const De = {
  context: void 0,
  registry: void 0,
  effects: void 0,
  done: !1,
  getContextId() {
    return Jp(this.context.count);
  },
  getNextContextId() {
    return Jp(this.context.count++);
  }
};
function Jp(e) {
  const t = String(e), r = t.length - 1;
  return De.context.id + (r ? String.fromCharCode(96 + r) : "") + t;
}
function Iy(e) {
  De.context = e;
}
const Py = !1, Dy = (e, t) => e === t, mr = Symbol("solid-proxy"), jv = typeof Proxy == "function", Ml = Symbol("solid-track"), Pu = {
  equals: Dy
};
let Vv = Wv;
const Ci = 1, Du = 2, Uv = {
  owned: null,
  cleanups: null,
  context: null,
  owner: null
}, S0 = {};
var St = null;
let E0 = null, My = null, Pt = null, Sr = null, yi = null, Ec = 0;
function Vo(e, t) {
  const r = Pt, n = St, i = e.length === 0, a = t === void 0 ? n : t, o = i ? Uv : {
    owned: null,
    cleanups: null,
    context: a ? a.context : null,
    owner: a
  }, s = i ? e : () => e(() => Re(() => Nl(o)));
  St = o, Pt = null;
  try {
    return bi(s, !0);
  } finally {
    Pt = r, St = n;
  }
}
function H(e, t) {
  t = t ? Object.assign({}, Pu, t) : Pu;
  const r = {
    value: e,
    observers: null,
    observerSlots: null,
    comparator: t.equals || void 0
  }, n = (i) => (typeof i == "function" && (i = i(r.value)), Hv(r, i));
  return [Bv.bind(r), n];
}
function Kh(e, t, r) {
  const n = Tc(e, t, !0, Ci);
  ws(n);
}
function J(e, t, r) {
  const n = Tc(e, t, !1, Ci);
  ws(n);
}
function me(e, t, r) {
  Vv = Uy;
  const n = Tc(e, t, !1, Ci);
  n.user = !0, yi ? yi.push(n) : ws(n);
}
function L(e, t, r) {
  r = r ? Object.assign({}, Pu, r) : Pu;
  const n = Tc(e, t, !0, 0);
  return n.observers = null, n.observerSlots = null, n.comparator = r.equals || void 0, ws(n), Bv.bind(n);
}
function Ny(e) {
  return e && typeof e == "object" && "then" in e;
}
function qv(e, t, r) {
  let n, i, a;
  typeof t == "function" ? (n = e, i = t, a = {}) : (n = !0, i = e, a = t || {});
  let o = null, s = S0, l = null, d = !1, u = "initialValue" in a, c = typeof n == "function" && L(n);
  const h = /* @__PURE__ */ new Set(), [f, p] = (a.storage || H)(a.initialValue), [g, v] = H(void 0), [m, $] = H(void 0, {
    equals: !1
  }), [w, k] = H(u ? "ready" : "unresolved");
  De.context && (l = De.getNextContextId(), a.ssrLoadFrom === "initial" ? s = a.initialValue : De.load && De.has(l) && (s = De.load(l)));
  function C(V, q, I, P) {
    return o === V && (o = null, P !== void 0 && (u = !0), (V === s || q === s) && a.onHydrated && queueMicrotask(
      () => a.onHydrated(P, {
        value: q
      })
    ), s = S0, E(q, I)), q;
  }
  function E(V, q) {
    bi(() => {
      q === void 0 && p(() => V), k(q !== void 0 ? "errored" : u ? "ready" : "unresolved"), v(q);
      for (const I of h.keys()) I.decrement();
      h.clear();
    }, !1);
  }
  function N() {
    const V = zy, q = f(), I = g();
    if (I !== void 0 && !o) throw I;
    return Pt && Pt.user, q;
  }
  function M(V = !0) {
    if (V !== !1 && d) return;
    d = !1;
    const q = c ? c() : n;
    if (q == null || q === !1) {
      C(o, Re(f));
      return;
    }
    const I = s !== S0 ? s : Re(
      () => i(q, {
        value: f(),
        refetching: V
      })
    );
    return Ny(I) ? (o = I, "value" in I ? (I.status === "success" ? C(o, I.value, void 0, q) : C(o, void 0, U1(I.value), q), I) : (d = !0, queueMicrotask(() => d = !1), bi(() => {
      k(u ? "refreshing" : "pending"), $();
    }, !1), I.then(
      (P) => C(I, P, void 0, q),
      (P) => C(I, void 0, U1(P), q)
    ))) : (C(o, I, void 0, q), I);
  }
  return Object.defineProperties(N, {
    state: {
      get: () => w()
    },
    error: {
      get: () => g()
    },
    loading: {
      get() {
        const V = w();
        return V === "pending" || V === "refreshing";
      }
    },
    latest: {
      get() {
        if (!u) return N();
        const V = g();
        if (V && !o) throw V;
        return f();
      }
    }
  }), c ? Kh(() => M(!1)) : M(!1), [
    N,
    {
      refetch: M,
      mutate: p
    }
  ];
}
function Mu(e) {
  return bi(e, !1);
}
function Re(e) {
  if (Pt === null) return e();
  const t = Pt;
  Pt = null;
  try {
    return e();
  } finally {
    Pt = t;
  }
}
function Et(e) {
  me(() => Re(e));
}
function xr(e) {
  return St === null || (St.cleanups === null ? St.cleanups = [e] : St.cleanups.push(e)), e;
}
function ns() {
  return Pt;
}
function fe() {
  return St;
}
function Ly(e) {
  const t = Pt, r = St;
  return Promise.resolve().then(() => {
    Pt = t, St = r;
    let n;
    return bi(e, !1), Pt = St = null, n ? n.done : void 0;
  });
}
const [Fy, Aae] = /* @__PURE__ */ H(!1);
function Ry() {
  return [Fy, Ly];
}
function Tr(e, t) {
  const r = Symbol("context");
  return {
    id: r,
    Provider: qy(r),
    defaultValue: e
  };
}
function cr(e) {
  let t;
  return St && St.context && (t = St.context[e.id]) !== void 0 ? t : e.defaultValue;
}
function Zh(e) {
  const t = L(e), r = L(() => q1(t()));
  return r.toArray = () => {
    const n = r();
    return Array.isArray(n) ? n : n != null ? [n] : [];
  }, r;
}
let zy;
function Bv() {
  if (this.sources && this.state)
    if (this.state === Ci) ws(this);
    else {
      const e = Sr;
      Sr = null, bi(() => Lu(this), !1), Sr = e;
    }
  if (Pt) {
    const e = this.observers ? this.observers.length : 0;
    Pt.sources ? (Pt.sources.push(this), Pt.sourceSlots.push(e)) : (Pt.sources = [this], Pt.sourceSlots = [e]), this.observers ? (this.observers.push(Pt), this.observerSlots.push(Pt.sources.length - 1)) : (this.observers = [Pt], this.observerSlots = [Pt.sources.length - 1]);
  }
  return this.value;
}
function Hv(e, t, r) {
  let n = e.value;
  return (!e.comparator || !e.comparator(n, t)) && (e.value = t, e.observers && e.observers.length && bi(() => {
    for (let i = 0; i < e.observers.length; i += 1) {
      const a = e.observers[i], o = E0 && E0.running;
      o && E0.disposed.has(a), (o ? !a.tState : !a.state) && (a.pure ? Sr.push(a) : yi.push(a), a.observers && Qv(a)), o || (a.state = Ci);
    }
    if (Sr.length > 1e6)
      throw Sr = [], new Error();
  }, !1)), t;
}
function ws(e) {
  if (!e.fn) return;
  Nl(e);
  const t = Ec;
  jy(
    e,
    e.value,
    t
  );
}
function jy(e, t, r) {
  let n;
  const i = St, a = Pt;
  Pt = St = e;
  try {
    n = e.fn(t);
  } catch (o) {
    return e.pure && (e.state = Ci, e.owned && e.owned.forEach(Nl), e.owned = null), e.updatedAt = r + 1, Gv(o);
  } finally {
    Pt = a, St = i;
  }
  (!e.updatedAt || e.updatedAt <= r) && (e.updatedAt != null && "observers" in e ? Hv(e, n) : e.value = n, e.updatedAt = r);
}
function Tc(e, t, r, n = Ci, i) {
  const a = {
    fn: e,
    state: n,
    updatedAt: null,
    owned: null,
    sources: null,
    sourceSlots: null,
    cleanups: null,
    value: t,
    owner: St,
    context: St ? St.context : null,
    pure: r
  };
  return St === null || St !== Uv && (St.owned ? St.owned.push(a) : St.owned = [a]), a;
}
function Nu(e) {
  if (e.state === 0) return;
  if (e.state === Du) return Lu(e);
  if (e.suspense && Re(e.suspense.inFallback)) return e.suspense.effects.push(e);
  const t = [e];
  for (; (e = e.owner) && (!e.updatedAt || e.updatedAt < Ec); )
    e.state && t.push(e);
  for (let r = t.length - 1; r >= 0; r--)
    if (e = t[r], e.state === Ci)
      ws(e);
    else if (e.state === Du) {
      const n = Sr;
      Sr = null, bi(() => Lu(e, t[0]), !1), Sr = n;
    }
}
function bi(e, t) {
  if (Sr) return e();
  let r = !1;
  t || (Sr = []), yi ? r = !0 : yi = [], Ec++;
  try {
    const n = e();
    return Vy(r), n;
  } catch (n) {
    r || (yi = null), Sr = null, Gv(n);
  }
}
function Vy(e) {
  if (Sr && (Wv(Sr), Sr = null), e) return;
  const t = yi;
  yi = null, t.length && bi(() => Vv(t), !1);
}
function Wv(e) {
  for (let t = 0; t < e.length; t++) Nu(e[t]);
}
function Uy(e) {
  let t, r = 0;
  for (t = 0; t < e.length; t++) {
    const n = e[t];
    n.user ? e[r++] = n : Nu(n);
  }
  if (De.context) {
    if (De.count) {
      De.effects || (De.effects = []), De.effects.push(...e.slice(0, r));
      return;
    }
    Iy();
  }
  for (De.effects && (De.done || !De.count) && (e = [...De.effects, ...e], r += De.effects.length, delete De.effects), t = 0; t < r; t++) Nu(e[t]);
}
function Lu(e, t) {
  e.state = 0;
  for (let r = 0; r < e.sources.length; r += 1) {
    const n = e.sources[r];
    if (n.sources) {
      const i = n.state;
      i === Ci ? n !== t && (!n.updatedAt || n.updatedAt < Ec) && Nu(n) : i === Du && Lu(n, t);
    }
  }
}
function Qv(e) {
  for (let t = 0; t < e.observers.length; t += 1) {
    const r = e.observers[t];
    r.state || (r.state = Du, r.pure ? Sr.push(r) : yi.push(r), r.observers && Qv(r));
  }
}
function Nl(e) {
  let t;
  if (e.sources)
    for (; e.sources.length; ) {
      const r = e.sources.pop(), n = e.sourceSlots.pop(), i = r.observers;
      if (i && i.length) {
        const a = i.pop(), o = r.observerSlots.pop();
        n < i.length && (a.sourceSlots[o] = n, i[n] = a, r.observerSlots[n] = o);
      }
    }
  if (e.tOwned) {
    for (t = e.tOwned.length - 1; t >= 0; t--) Nl(e.tOwned[t]);
    delete e.tOwned;
  }
  if (e.owned) {
    for (t = e.owned.length - 1; t >= 0; t--) Nl(e.owned[t]);
    e.owned = null;
  }
  if (e.cleanups) {
    for (t = e.cleanups.length - 1; t >= 0; t--) e.cleanups[t]();
    e.cleanups = null;
  }
  e.state = 0;
}
function U1(e) {
  return e instanceof Error ? e : new Error(typeof e == "string" ? e : "Unknown error", {
    cause: e
  });
}
function Gv(e, t = St) {
  throw U1(e);
}
function q1(e) {
  if (typeof e == "function" && !e.length) return q1(e());
  if (Array.isArray(e)) {
    const t = [];
    for (let r = 0; r < e.length; r++) {
      const n = q1(e[r]);
      Array.isArray(n) ? t.push.apply(t, n) : t.push(n);
    }
    return t;
  }
  return e;
}
function qy(e, t) {
  return function(n) {
    let i;
    return J(
      () => i = Re(() => (St.context = {
        ...St.context,
        [e]: n.value
      }, Zh(() => n.children))),
      void 0
    ), i;
  };
}
const By = Symbol("fallback");
function e5(e) {
  for (let t = 0; t < e.length; t++) e[t]();
}
function Hy(e, t, r = {}) {
  let n = [], i = [], a = [], o = 0, s = t.length > 1 ? [] : null;
  return xr(() => e5(a)), () => {
    let l = e() || [], d = l.length, u, c;
    return l[Ml], Re(() => {
      let f, p, g, v, m, $, w, k, C;
      if (d === 0)
        o !== 0 && (e5(a), a = [], n = [], i = [], o = 0, s && (s = [])), r.fallback && (n = [By], i[0] = Vo((E) => (a[0] = E, r.fallback())), o = 1);
      else if (o === 0) {
        for (i = new Array(d), c = 0; c < d; c++)
          n[c] = l[c], i[c] = Vo(h);
        o = d;
      } else {
        for (g = new Array(d), v = new Array(d), s && (m = new Array(d)), $ = 0, w = Math.min(o, d); $ < w && n[$] === l[$]; $++) ;
        for (w = o - 1, k = d - 1; w >= $ && k >= $ && n[w] === l[k]; w--, k--)
          g[k] = i[w], v[k] = a[w], s && (m[k] = s[w]);
        for (f = /* @__PURE__ */ new Map(), p = new Array(k + 1), c = k; c >= $; c--)
          C = l[c], u = f.get(C), p[c] = u === void 0 ? -1 : u, f.set(C, c);
        for (u = $; u <= w; u++)
          C = n[u], c = f.get(C), c !== void 0 && c !== -1 ? (g[c] = i[u], v[c] = a[u], s && (m[c] = s[u]), c = p[c], f.set(C, c)) : a[u]();
        for (c = $; c < d; c++)
          c in g ? (i[c] = g[c], a[c] = v[c], s && (s[c] = m[c], s[c](c))) : i[c] = Vo(h);
        i = i.slice(0, o = d), n = l.slice(0);
      }
      return i;
    });
    function h(f) {
      if (a[c] = f, s) {
        const [p, g] = H(c);
        return s[c] = g, t(l[c], p);
      }
      return t(l[c]);
    }
  };
}
function b(e, t) {
  return Re(() => e(t || {}));
}
function Od() {
  return !0;
}
const B1 = {
  get(e, t, r) {
    return t === mr ? r : e.get(t);
  },
  has(e, t) {
    return t === mr ? !0 : e.has(t);
  },
  set: Od,
  deleteProperty: Od,
  getOwnPropertyDescriptor(e, t) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(t);
      },
      set: Od,
      deleteProperty: Od
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function T0(e) {
  return (e = typeof e == "function" ? e() : e) ? e : {};
}
function Wy() {
  for (let e = 0, t = this.length; e < t; ++e) {
    const r = this[e]();
    if (r !== void 0) return r;
  }
}
function Be(...e) {
  let t = !1;
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    t = t || !!s && mr in s, e[o] = typeof s == "function" ? (t = !0, L(s)) : s;
  }
  if (jv && t)
    return new Proxy(
      {
        get(o) {
          for (let s = e.length - 1; s >= 0; s--) {
            const l = T0(e[s])[o];
            if (l !== void 0) return l;
          }
        },
        has(o) {
          for (let s = e.length - 1; s >= 0; s--)
            if (o in T0(e[s])) return !0;
          return !1;
        },
        keys() {
          const o = [];
          for (let s = 0; s < e.length; s++)
            o.push(...Object.keys(T0(e[s])));
          return [...new Set(o)];
        }
      },
      B1
    );
  const r = {}, n = /* @__PURE__ */ Object.create(null);
  for (let o = e.length - 1; o >= 0; o--) {
    const s = e[o];
    if (!s) continue;
    const l = Object.getOwnPropertyNames(s);
    for (let d = l.length - 1; d >= 0; d--) {
      const u = l[d];
      if (u === "__proto__" || u === "constructor") continue;
      const c = Object.getOwnPropertyDescriptor(s, u);
      if (!n[u])
        n[u] = c.get ? {
          enumerable: !0,
          configurable: !0,
          get: Wy.bind(r[u] = [c.get.bind(s)])
        } : c.value !== void 0 ? c : void 0;
      else {
        const h = r[u];
        h && (c.get ? h.push(c.get.bind(s)) : c.value !== void 0 && h.push(() => c.value));
      }
    }
  }
  const i = {}, a = Object.keys(n);
  for (let o = a.length - 1; o >= 0; o--) {
    const s = a[o], l = n[s];
    l && l.get ? Object.defineProperty(i, s, l) : i[s] = l ? l.value : void 0;
  }
  return i;
}
function Ua(e, ...t) {
  if (jv && mr in e) {
    const i = new Set(t.length > 1 ? t.flat() : t[0]), a = t.map((o) => new Proxy(
      {
        get(s) {
          return o.includes(s) ? e[s] : void 0;
        },
        has(s) {
          return o.includes(s) && s in e;
        },
        keys() {
          return o.filter((s) => s in e);
        }
      },
      B1
    ));
    return a.push(
      new Proxy(
        {
          get(o) {
            return i.has(o) ? void 0 : e[o];
          },
          has(o) {
            return i.has(o) ? !1 : o in e;
          },
          keys() {
            return Object.keys(e).filter((o) => !i.has(o));
          }
        },
        B1
      )
    ), a;
  }
  const r = {}, n = t.map(() => ({}));
  for (const i of Object.getOwnPropertyNames(e)) {
    const a = Object.getOwnPropertyDescriptor(e, i), o = !a.get && !a.set && a.enumerable && a.writable && a.configurable;
    let s = !1, l = 0;
    for (const d of t)
      d.includes(i) && (s = !0, o ? n[l][i] = a.value : Object.defineProperty(n[l], i, a)), ++l;
    s || (o ? r[i] = a.value : Object.defineProperty(r, i, a));
  }
  return [...n, r];
}
let Qy = 0;
function Da() {
  return De.context ? De.getNextContextId() : `cl-${Qy++}`;
}
const Yv = (e) => `Stale read from <${e}>.`;
function kt(e) {
  const t = "fallback" in e && {
    fallback: () => e.fallback
  };
  return L(Hy(() => e.each, e.children, t || void 0));
}
function X(e) {
  const t = e.keyed, r = L(() => e.when, void 0, void 0), n = t ? r : L(r, void 0, {
    equals: (i, a) => !i == !a
  });
  return L(
    () => {
      const i = n();
      if (i) {
        const a = e.children;
        return typeof a == "function" && a.length > 0 ? Re(
          () => a(
            t ? i : () => {
              if (!Re(n)) throw Yv("Show");
              return r();
            }
          )
        ) : a;
      }
      return e.fallback;
    },
    void 0,
    void 0
  );
}
function Ac(e) {
  const t = Zh(() => e.children), r = L(() => {
    const n = t(), i = Array.isArray(n) ? n : [n];
    let a = () => {
    };
    for (let o = 0; o < i.length; o++) {
      const s = o, l = i[o], d = a, u = L(
        () => d() ? void 0 : l.when,
        void 0,
        void 0
      ), c = l.keyed ? u : L(u, void 0, {
        equals: (h, f) => !h == !f
      });
      a = () => d() || (c() ? [s, u, l] : void 0);
    }
    return a;
  });
  return L(
    () => {
      const n = r()();
      if (!n) return e.fallback;
      const [i, a, o] = n, s = o.children;
      return typeof s == "function" && s.length > 0 ? Re(
        () => s(
          o.keyed ? a() : () => {
            if (Re(r)()?.[0] !== i) throw Yv("Match");
            return a();
          }
        )
      ) : s;
    },
    void 0,
    void 0
  );
}
function vn(e) {
  return e;
}
const Gy = [
  "allowfullscreen",
  "async",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "disabled",
  "formnovalidate",
  "hidden",
  "indeterminate",
  "inert",
  "ismap",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "seamless",
  "selected"
], Yy = /* @__PURE__ */ new Set([
  "className",
  "value",
  "readOnly",
  "formNoValidate",
  "isMap",
  "noModule",
  "playsInline",
  ...Gy
]), Ky = /* @__PURE__ */ new Set([
  "innerHTML",
  "textContent",
  "innerText",
  "children"
]), Zy = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  className: "class",
  htmlFor: "for"
}), Xy = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  class: "className",
  formnovalidate: {
    $: "formNoValidate",
    BUTTON: 1,
    INPUT: 1
  },
  ismap: {
    $: "isMap",
    IMG: 1
  },
  nomodule: {
    $: "noModule",
    SCRIPT: 1
  },
  playsinline: {
    $: "playsInline",
    VIDEO: 1
  },
  readonly: {
    $: "readOnly",
    INPUT: 1,
    TEXTAREA: 1
  }
});
function Jy(e, t) {
  const r = Xy[e];
  return typeof r == "object" ? r[t] ? r.$ : void 0 : r;
}
const eb = /* @__PURE__ */ new Set([
  "beforeinput",
  "click",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
]), tb = /* @__PURE__ */ new Set([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animate",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "circle",
  "clipPath",
  "color-profile",
  "cursor",
  "defs",
  "desc",
  "ellipse",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "filter",
  "font",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignObject",
  "g",
  "glyph",
  "glyphRef",
  "hkern",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "metadata",
  "missing-glyph",
  "mpath",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "set",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "textPath",
  "tref",
  "tspan",
  "use",
  "view",
  "vkern"
]), rb = {
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace"
};
function nb(e, t, r) {
  let n = r.length, i = t.length, a = n, o = 0, s = 0, l = t[i - 1].nextSibling, d = null;
  for (; o < i || s < a; ) {
    if (t[o] === r[s]) {
      o++, s++;
      continue;
    }
    for (; t[i - 1] === r[a - 1]; )
      i--, a--;
    if (i === o) {
      const u = a < n ? s ? r[s - 1].nextSibling : r[a - s] : l;
      for (; s < a; ) e.insertBefore(r[s++], u);
    } else if (a === s)
      for (; o < i; )
        (!d || !d.has(t[o])) && t[o].remove(), o++;
    else if (t[o] === r[a - 1] && r[s] === t[i - 1]) {
      const u = t[--i].nextSibling;
      e.insertBefore(r[s++], t[o++].nextSibling), e.insertBefore(r[--a], u), t[i] = r[a];
    } else {
      if (!d) {
        d = /* @__PURE__ */ new Map();
        let c = s;
        for (; c < a; ) d.set(r[c], c++);
      }
      const u = d.get(t[o]);
      if (u != null)
        if (s < u && u < a) {
          let c = o, h = 1, f;
          for (; ++c < i && c < a && !((f = d.get(t[c])) == null || f !== u + h); )
            h++;
          if (h > u - s) {
            const p = t[o];
            for (; s < u; ) e.insertBefore(r[s++], p);
          } else e.replaceChild(r[s++], t[o++]);
        } else o++;
      else t[o++].remove();
    }
  }
}
const t5 = "_$DX_DELEGATE";
function K(e, t, r, n) {
  let i;
  const a = () => {
    const s = n ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
    return s.innerHTML = e, r ? s.content.firstChild.firstChild : n ? s.firstChild : s.content.firstChild;
  }, o = t ? () => Re(() => document.importNode(i || (i = a()), !0)) : () => (i || (i = a())).cloneNode(!0);
  return o.cloneNode = o, o;
}
function da(e, t = window.document) {
  const r = t[t5] || (t[t5] = /* @__PURE__ */ new Set());
  for (let n = 0, i = e.length; n < i; n++) {
    const a = e[n];
    r.has(a) || (r.add(a), t.addEventListener(a, cb));
  }
}
function H1(e, t, r) {
  ro(e) || (r == null ? e.removeAttribute(t) : e.setAttribute(t, r));
}
function ib(e, t, r, n) {
  ro(e) || (n == null ? e.removeAttributeNS(t, r) : e.setAttributeNS(t, r, n));
}
function ab(e, t, r) {
  ro(e) || (r ? e.setAttribute(t, "") : e.removeAttribute(t));
}
function Wi(e, t) {
  ro(e) || (t == null ? e.removeAttribute("class") : e.className = t);
}
function ce(e, t, r, n) {
  if (n)
    Array.isArray(r) ? (e[`$$${t}`] = r[0], e[`$$${t}Data`] = r[1]) : e[`$$${t}`] = r;
  else if (Array.isArray(r)) {
    const i = r[0];
    e.addEventListener(t, r[0] = (a) => i.call(e, r[1], a));
  } else e.addEventListener(t, r, typeof r != "function" && r);
}
function ob(e, t, r = {}) {
  const n = Object.keys(t || {}), i = Object.keys(r);
  let a, o;
  for (a = 0, o = i.length; a < o; a++) {
    const s = i[a];
    !s || s === "undefined" || t[s] || (r5(e, s, !1), delete r[s]);
  }
  for (a = 0, o = n.length; a < o; a++) {
    const s = n[a], l = !!t[s];
    !s || s === "undefined" || r[s] === l || !l || (r5(e, s, !0), r[s] = l);
  }
  return r;
}
function Kv(e, t, r) {
  if (!t) return r ? H1(e, "style") : t;
  const n = e.style;
  if (typeof t == "string") return n.cssText = t;
  typeof r == "string" && (n.cssText = r = void 0), r || (r = {}), t || (t = {});
  let i, a;
  for (a in r)
    t[a] == null && n.removeProperty(a), delete r[a];
  for (a in t)
    i = t[a], i !== r[a] && (n.setProperty(a, i), r[a] = i);
  return r;
}
function sb(e, t = {}, r, n) {
  const i = {};
  return J(
    () => i.children = Ll(e, t.children, i.children)
  ), J(() => typeof t.ref == "function" && ze(t.ref, e)), J(() => lb(e, t, r, !0, i, !0)), i;
}
function ze(e, t, r) {
  return Re(() => e(t, r));
}
function A(e, t, r, n) {
  if (r !== void 0 && !n && (n = []), typeof t != "function") return Ll(e, t, n, r);
  J((i) => Ll(e, t(), i, r), n);
}
function lb(e, t, r, n, i = {}, a = !1) {
  t || (t = {});
  for (const o in i)
    if (!(o in t)) {
      if (o === "children") continue;
      i[o] = n5(e, o, null, i[o], r, a, t);
    }
  for (const o in t) {
    if (o === "children")
      continue;
    const s = t[o];
    i[o] = n5(e, o, s, i[o], r, a, t);
  }
}
function db(e) {
  let t, r;
  return !ro() || !(t = De.registry.get(r = hb())) ? e() : (De.completed && De.completed.add(t), De.registry.delete(r), t);
}
function ro(e) {
  return !!De.context && !De.done && (!e || e.isConnected);
}
function ub(e) {
  return e.toLowerCase().replace(/-([a-z])/g, (t, r) => r.toUpperCase());
}
function r5(e, t, r) {
  const n = t.trim().split(/\s+/);
  for (let i = 0, a = n.length; i < a; i++)
    e.classList.toggle(n[i], r);
}
function n5(e, t, r, n, i, a, o) {
  let s, l, d, u, c;
  if (t === "style") return Kv(e, r, n);
  if (t === "classList") return ob(e, r, n);
  if (r === n) return n;
  if (t === "ref")
    a || r(e);
  else if (t.slice(0, 3) === "on:") {
    const h = t.slice(3);
    n && e.removeEventListener(h, n, typeof n != "function" && n), r && e.addEventListener(h, r, typeof r != "function" && r);
  } else if (t.slice(0, 10) === "oncapture:") {
    const h = t.slice(10);
    n && e.removeEventListener(h, n, !0), r && e.addEventListener(h, r, !0);
  } else if (t.slice(0, 2) === "on") {
    const h = t.slice(2).toLowerCase(), f = eb.has(h);
    if (!f && n) {
      const p = Array.isArray(n) ? n[0] : n;
      e.removeEventListener(h, p);
    }
    (f || r) && (ce(e, h, r, f), f && da([h]));
  } else if (t.slice(0, 5) === "attr:")
    H1(e, t.slice(5), r);
  else if (t.slice(0, 5) === "bool:")
    ab(e, t.slice(5), r);
  else if ((c = t.slice(0, 5) === "prop:") || (d = Ky.has(t)) || !i && ((u = Jy(t, e.tagName)) || (l = Yy.has(t))) || (s = e.nodeName.includes("-") || "is" in o)) {
    if (c)
      t = t.slice(5), l = !0;
    else if (ro(e)) return r;
    t === "class" || t === "className" ? Wi(e, r) : s && !l && !d ? e[ub(t)] = r : e[u || t] = r;
  } else {
    const h = i && t.indexOf(":") > -1 && rb[t.split(":")[0]];
    h ? ib(e, h, t, r) : H1(e, Zy[t] || t, r);
  }
  return r;
}
function cb(e) {
  if (De.registry && De.events && De.events.find(([l, d]) => d === e))
    return;
  let t = e.target;
  const r = `$$${e.type}`, n = e.target, i = e.currentTarget, a = (l) => Object.defineProperty(e, "target", {
    configurable: !0,
    value: l
  }), o = () => {
    const l = t[r];
    if (l && !t.disabled) {
      const d = t[`${r}Data`];
      if (d !== void 0 ? l.call(t, d, e) : l.call(t, e), e.cancelBubble) return;
    }
    return t.host && typeof t.host != "string" && !t.host._$host && t.contains(e.target) && a(t.host), !0;
  }, s = () => {
    for (; o() && (t = t._$host || t.parentNode || t.host); ) ;
  };
  if (Object.defineProperty(e, "currentTarget", {
    configurable: !0,
    get() {
      return t || document;
    }
  }), De.registry && !De.done && (De.done = _$HY.done = !0), e.composedPath) {
    const l = e.composedPath();
    a(l[0]);
    for (let d = 0; d < l.length - 2 && (t = l[d], !!o()); d++) {
      if (t._$host) {
        t = t._$host, s();
        break;
      }
      if (t.parentNode === i)
        break;
    }
  } else s();
  a(n);
}
function Ll(e, t, r, n, i) {
  const a = ro(e);
  if (a) {
    !r && (r = [...e.childNodes]);
    let l = [];
    for (let d = 0; d < r.length; d++) {
      const u = r[d];
      u.nodeType === 8 && u.data.slice(0, 2) === "!$" ? u.remove() : l.push(u);
    }
    r = l;
  }
  for (; typeof r == "function"; ) r = r();
  if (t === r) return r;
  const o = typeof t, s = n !== void 0;
  if (e = s && r[0] && r[0].parentNode || e, o === "string" || o === "number") {
    if (a || o === "number" && (t = t.toString(), t === r))
      return r;
    if (s) {
      let l = r[0];
      l && l.nodeType === 3 ? l.data !== t && (l.data = t) : l = document.createTextNode(t), r = ho(e, r, n, l);
    } else
      r !== "" && typeof r == "string" ? r = e.firstChild.data = t : r = e.textContent = t;
  } else if (t == null || o === "boolean") {
    if (a) return r;
    r = ho(e, r, n);
  } else {
    if (o === "function")
      return J(() => {
        let l = t();
        for (; typeof l == "function"; ) l = l();
        r = Ll(e, l, r, n);
      }), () => r;
    if (Array.isArray(t)) {
      const l = [], d = r && Array.isArray(r);
      if (W1(l, t, r, i))
        return J(() => r = Ll(e, l, r, n, !0)), () => r;
      if (a) {
        if (!l.length) return r;
        if (n === void 0) return r = [...e.childNodes];
        let u = l[0];
        if (u.parentNode !== e) return r;
        const c = [u];
        for (; (u = u.nextSibling) !== n; ) c.push(u);
        return r = c;
      }
      if (l.length === 0) {
        if (r = ho(e, r, n), s) return r;
      } else d ? r.length === 0 ? i5(e, l, n) : nb(e, r, l) : (r && ho(e), i5(e, l));
      r = l;
    } else if (t.nodeType) {
      if (a && t.parentNode) return r = s ? [t] : t;
      if (Array.isArray(r)) {
        if (s) return r = ho(e, r, n, t);
        ho(e, r, null, t);
      } else r == null || r === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
      r = t;
    }
  }
  return r;
}
function W1(e, t, r, n) {
  let i = !1;
  for (let a = 0, o = t.length; a < o; a++) {
    let s = t[a], l = r && r[e.length], d;
    if (!(s == null || s === !0 || s === !1)) if ((d = typeof s) == "object" && s.nodeType)
      e.push(s);
    else if (Array.isArray(s))
      i = W1(e, s, l) || i;
    else if (d === "function")
      if (n) {
        for (; typeof s == "function"; ) s = s();
        i = W1(
          e,
          Array.isArray(s) ? s : [s],
          Array.isArray(l) ? l : [l]
        ) || i;
      } else
        e.push(s), i = !0;
    else {
      const u = String(s);
      l && l.nodeType === 3 && l.data === u ? e.push(l) : e.push(document.createTextNode(u));
    }
  }
  return i;
}
function i5(e, t, r = null) {
  for (let n = 0, i = t.length; n < i; n++) e.insertBefore(t[n], r);
}
function ho(e, t, r, n) {
  if (r === void 0) return e.textContent = "";
  const i = n || document.createTextNode("");
  if (t.length) {
    let a = !1;
    for (let o = t.length - 1; o >= 0; o--) {
      const s = t[o];
      if (i !== s) {
        const l = s.parentNode === e;
        !a && !o ? l ? e.replaceChild(i, s) : e.insertBefore(i, r) : l && s.remove();
      } else a = !0;
    }
  } else e.insertBefore(i, r);
  return [i];
}
function hb() {
  return De.getNextContextId();
}
const fb = "http://www.w3.org/2000/svg";
function pb(e, t = !1) {
  return t ? document.createElementNS(fb, e) : document.createElement(e);
}
function mb(e, t) {
  const r = L(e);
  return L(() => {
    const n = r();
    switch (typeof n) {
      case "function":
        return Re(() => n(t));
      case "string":
        const i = tb.has(n), a = De.context ? db() : pb(n, i);
        return sb(a, t, i), a;
    }
  });
}
function gb(e) {
  const [, t] = Ua(e, ["component"]);
  return mb(() => e.component, t);
}
function vb(e) {
  return Object.keys(e).reduce((r, n) => {
    const i = e[n];
    return r[n] = Object.assign({}, i), Xv(i.value) && !xb(i.value) && !Array.isArray(i.value) && (r[n].value = Object.assign({}, i.value)), Array.isArray(i.value) && (r[n].value = i.value.slice(0)), r;
  }, {});
}
function yb(e) {
  return e ? Object.keys(e).reduce((r, n) => {
    const i = e[n];
    return r[n] = Xv(i) && "value" in i ? i : {
      value: i
    }, r[n].attribute || (r[n].attribute = wb(n)), r[n].parse = "parse" in r[n] ? r[n].parse : typeof r[n].value != "string", r;
  }, {}) : {};
}
function bb(e) {
  return Object.keys(e).reduce((r, n) => (r[n] = e[n].value, r), {});
}
function $b(e, t) {
  const r = vb(t);
  return Object.keys(t).forEach((i) => {
    const a = r[i], o = e.getAttribute(a.attribute), s = e[i];
    o != null && (a.value = a.parse ? Zv(o) : o), s != null && (a.value = Array.isArray(s) ? s.slice(0) : s), a.reflect && a5(e, a.attribute, a.value, !!a.parse), Object.defineProperty(e, i, {
      get() {
        return a.value;
      },
      set(l) {
        const d = a.value;
        a.value = l, a.reflect && a5(this, a.attribute, a.value, !!a.parse);
        for (let u = 0, c = this.__propertyChangedCallbacks.length; u < c; u++)
          this.__propertyChangedCallbacks[u](i, l, d);
      },
      enumerable: !0,
      configurable: !0
    });
  }), r;
}
function Zv(e) {
  if (e)
    try {
      return JSON.parse(e);
    } catch {
      return e;
    }
}
function a5(e, t, r, n) {
  if (r == null || r === !1) return e.removeAttribute(t);
  let i = n ? JSON.stringify(r) : r;
  e.__updating[t] = !0, i === "true" && (i = ""), e.setAttribute(t, i), Promise.resolve().then(() => delete e.__updating[t]);
}
function wb(e) {
  return e.replace(/\.?([A-Z]+)/g, (t, r) => "-" + r.toLowerCase()).replace("_", "-").replace(/^-/, "");
}
function Xv(e) {
  return e != null && (typeof e == "object" || typeof e == "function");
}
function xb(e) {
  return Object.prototype.toString.call(e) === "[object Function]";
}
function kb(e) {
  return typeof e == "function" && e.toString().indexOf("class") === 0;
}
let A0;
function _b(e, t) {
  const r = Object.keys(t);
  return class extends e {
    static get observedAttributes() {
      return r.map((i) => t[i].attribute);
    }
    constructor() {
      super(), this.__initialized = !1, this.__released = !1, this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = {};
    }
    connectedCallback() {
      if (this.__initialized) return;
      this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = $b(this, t);
      const i = bb(this.props), a = this.Component, o = A0;
      try {
        A0 = this, this.__initialized = !0, kb(a) ? new a(i, {
          element: this
        }) : a(i, {
          element: this
        });
      } finally {
        A0 = o;
      }
    }
    async disconnectedCallback() {
      if (await Promise.resolve(), this.isConnected) return;
      this.__propertyChangedCallbacks.length = 0;
      let i = null;
      for (; i = this.__releaseCallbacks.pop(); ) i(this);
      delete this.__initialized, this.__released = !0;
    }
    attributeChangedCallback(i, a, o) {
      if (this.__initialized && !this.__updating[i] && (i = this.lookupProp(i), i in t)) {
        if (o == null && !this[i]) return;
        this[i] = t[i].parse ? Zv(o) : o;
      }
    }
    lookupProp(i) {
      if (t)
        return r.find((a) => i === a || i === t[a].attribute);
    }
    get renderRoot() {
      return this.shadowRoot || this.attachShadow({
        mode: "open"
      });
    }
    addReleaseCallback(i) {
      this.__releaseCallbacks.push(i);
    }
    addPropertyChangedCallback(i) {
      this.__propertyChangedCallbacks.push(i);
    }
  };
}
function Cb(e, t = {}, r = {}) {
  const {
    BaseElement: n = HTMLElement,
    extension: i,
    customElements: a = window.customElements
  } = r;
  return (o) => {
    if (!e) throw new Error("tag is required to register a Component");
    let s = a.get(e);
    return s ? (s.prototype.Component = o, s) : (s = _b(n, yb(t)), s.prototype.Component = o, s.prototype.registeredTag = e, a.define(e, s, i), s);
  };
}
function Sb(e) {
  const t = Object.keys(e), r = {};
  for (let n = 0; n < t.length; n++) {
    const [i, a] = H(e[t[n]]);
    Object.defineProperty(r, t[n], {
      get: i,
      set(o) {
        a(() => o);
      }
    });
  }
  return r;
}
function Eb(e) {
  if (e.assignedSlot && e.assignedSlot._$owner) return e.assignedSlot._$owner;
  let t = e.parentNode;
  for (; t && !t._$owner && !(t.assignedSlot && t.assignedSlot._$owner); )
    t = t.parentNode;
  return t && t.assignedSlot ? t.assignedSlot._$owner : e._$owner;
}
function Tb(e) {
  return (t, r) => {
    const { element: n } = r;
    return Vo((i) => {
      const a = Sb(t);
      n.addPropertyChangedCallback((s, l) => a[s] = l), n.addReleaseCallback(() => {
        n.renderRoot.textContent = "", i();
      });
      const o = e(a, r);
      return A(n.renderRoot, o);
    }, Eb(n));
  };
}
function Tt(e, t, r) {
  return arguments.length === 2 && (r = t, t = {}), Cb(e, t)(Tb(r));
}
var Q1 = function(e, t) {
  return Q1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Q1(e, t);
};
function ri(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Q1(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var j = function() {
  return j = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, j.apply(this, arguments);
};
function An(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function Ve(e, t, r, n) {
  function i(a) {
    return a instanceof r ? a : new r(function(o) {
      o(a);
    });
  }
  return new (r || (r = Promise))(function(a, o) {
    function s(u) {
      try {
        d(n.next(u));
      } catch (c) {
        o(c);
      }
    }
    function l(u) {
      try {
        d(n.throw(u));
      } catch (c) {
        o(c);
      }
    }
    function d(u) {
      u.done ? a(u.value) : i(u.value).then(s, l);
    }
    d((n = n.apply(e, t || [])).next());
  });
}
function Fi(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = s(0), o.throw = s(1), o.return = s(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(d) {
    return function(u) {
      return l([d, u]);
    };
  }
  function l(d) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, d[0] && (r = 0)), r; ) try {
      if (n = 1, i && (a = d[0] & 2 ? i.return : d[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, d[1])).done) return a;
      switch (i = 0, a && (d = [d[0] & 2, a.value]), d[0]) {
        case 0:
        case 1:
          a = d;
          break;
        case 4:
          return r.label++, { value: d[1], done: !1 };
        case 5:
          r.label++, i = d[1], d = [0];
          continue;
        case 7:
          d = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (d[0] === 6 || d[0] === 2)) {
            r = 0;
            continue;
          }
          if (d[0] === 3 && (!a || d[1] > a[0] && d[1] < a[3])) {
            r.label = d[1];
            break;
          }
          if (d[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = d;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(d);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      d = t.call(e, r);
    } catch (u) {
      d = [6, u], i = 0;
    } finally {
      n = a = 0;
    }
    if (d[0] & 5) throw d[1];
    return { value: d[0] ? d[1] : void 0, done: !0 };
  }
}
function Er(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, a; n < i; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function qn(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var i = 0;
    for (n = Object.getOwnPropertySymbols(e); i < n.length; i++) t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  }
  return r;
}
var Ta = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Jh(e, t) {
  return e(t = { exports: {} }, t.exports), t.exports;
}
var ya = Jh(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var r = function() {
    function n() {
      var i = this;
      this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(a, o) {
        var s = i.locked.get(a);
        s === void 0 ? o === void 0 ? i.locked.set(a, []) : i.locked.set(a, [o]) : o !== void 0 && (s.unshift(o), i.locked.set(a, s));
      }, this.isLocked = function(a) {
        return i.locked.has(a);
      }, this.lock = function(a) {
        return new Promise(function(o, s) {
          i.isLocked(a) ? i.addToLocked(a, o) : (i.addToLocked(a), o());
        });
      }, this.unlock = function(a) {
        var o = i.locked.get(a);
        if (o !== void 0 && o.length !== 0) {
          var s = o.pop();
          i.locked.set(a, o), s !== void 0 && setTimeout(s, 0);
        } else i.locked.delete(a);
      };
    }
    return n.getInstance = function() {
      return n.instance === void 0 && (n.instance = new n()), n.instance;
    }, n;
  }();
  t.default = function() {
    return r.getInstance();
  };
});
Xh(ya);
var Ab = Xh(Jh(function(e, t) {
  var r = Ta && Ta.__awaiter || function(u, c, h, f) {
    return new (h || (h = Promise))(function(p, g) {
      function v(w) {
        try {
          $(f.next(w));
        } catch (k) {
          g(k);
        }
      }
      function m(w) {
        try {
          $(f.throw(w));
        } catch (k) {
          g(k);
        }
      }
      function $(w) {
        w.done ? p(w.value) : new h(function(k) {
          k(w.value);
        }).then(v, m);
      }
      $((f = f.apply(u, c || [])).next());
    });
  }, n = Ta && Ta.__generator || function(u, c) {
    var h, f, p, g, v = { label: 0, sent: function() {
      if (1 & p[0]) throw p[1];
      return p[1];
    }, trys: [], ops: [] };
    return g = { next: m(0), throw: m(1), return: m(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
      return this;
    }), g;
    function m($) {
      return function(w) {
        return function(k) {
          if (h) throw new TypeError("Generator is already executing.");
          for (; v; ) try {
            if (h = 1, f && (p = 2 & k[0] ? f.return : k[0] ? f.throw || ((p = f.return) && p.call(f), 0) : f.next) && !(p = p.call(f, k[1])).done) return p;
            switch (f = 0, p && (k = [2 & k[0], p.value]), k[0]) {
              case 0:
              case 1:
                p = k;
                break;
              case 4:
                return v.label++, { value: k[1], done: !1 };
              case 5:
                v.label++, f = k[1], k = [0];
                continue;
              case 7:
                k = v.ops.pop(), v.trys.pop();
                continue;
              default:
                if (p = v.trys, !((p = p.length > 0 && p[p.length - 1]) || k[0] !== 6 && k[0] !== 2)) {
                  v = 0;
                  continue;
                }
                if (k[0] === 3 && (!p || k[1] > p[0] && k[1] < p[3])) {
                  v.label = k[1];
                  break;
                }
                if (k[0] === 6 && v.label < p[1]) {
                  v.label = p[1], p = k;
                  break;
                }
                if (p && v.label < p[2]) {
                  v.label = p[2], v.ops.push(k);
                  break;
                }
                p[2] && v.ops.pop(), v.trys.pop();
                continue;
            }
            k = c.call(u, v);
          } catch (C) {
            k = [6, C], f = 0;
          } finally {
            h = p = 0;
          }
          if (5 & k[0]) throw k[1];
          return { value: k[0] ? k[1] : void 0, done: !0 };
        }([$, w]);
      };
    }
  }, i = Ta;
  Object.defineProperty(t, "__esModule", { value: !0 });
  var a = "browser-tabs-lock-key", o = { key: function(u) {
    return r(i, void 0, void 0, function() {
      return n(this, function(c) {
        throw new Error("Unsupported");
      });
    });
  }, getItem: function(u) {
    return r(i, void 0, void 0, function() {
      return n(this, function(c) {
        throw new Error("Unsupported");
      });
    });
  }, clear: function() {
    return r(i, void 0, void 0, function() {
      return n(this, function(u) {
        return [2, window.localStorage.clear()];
      });
    });
  }, removeItem: function(u) {
    return r(i, void 0, void 0, function() {
      return n(this, function(c) {
        throw new Error("Unsupported");
      });
    });
  }, setItem: function(u, c) {
    return r(i, void 0, void 0, function() {
      return n(this, function(h) {
        throw new Error("Unsupported");
      });
    });
  }, keySync: function(u) {
    return window.localStorage.key(u);
  }, getItemSync: function(u) {
    return window.localStorage.getItem(u);
  }, clearSync: function() {
    return window.localStorage.clear();
  }, removeItemSync: function(u) {
    return window.localStorage.removeItem(u);
  }, setItemSync: function(u, c) {
    return window.localStorage.setItem(u, c);
  } };
  function s(u) {
    return new Promise(function(c) {
      return setTimeout(c, u);
    });
  }
  function l(u) {
    for (var c = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", h = "", f = 0; f < u; f++)
      h += c[Math.floor(Math.random() * c.length)];
    return h;
  }
  var d = function() {
    function u(c) {
      this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + l(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = c, u.waiters === void 0 && (u.waiters = []);
    }
    return u.prototype.acquireLock = function(c, h) {
      return h === void 0 && (h = 5e3), r(this, void 0, void 0, function() {
        var f, p, g, v, m, $, w;
        return n(this, function(k) {
          switch (k.label) {
            case 0:
              f = Date.now() + l(4), p = Date.now() + h, g = a + "-" + c, v = this.storageHandler === void 0 ? o : this.storageHandler, k.label = 1;
            case 1:
              return Date.now() < p ? [4, s(30)] : [3, 8];
            case 2:
              return k.sent(), v.getItemSync(g) !== null ? [3, 5] : (m = this.id + "-" + c + "-" + f, [4, s(Math.floor(25 * Math.random()))]);
            case 3:
              return k.sent(), v.setItemSync(g, JSON.stringify({ id: this.id, iat: f, timeoutKey: m, timeAcquired: Date.now(), timeRefreshed: Date.now() })), [4, s(30)];
            case 4:
              return k.sent(), ($ = v.getItemSync(g)) !== null && (w = JSON.parse($)).id === this.id && w.iat === f ? (this.acquiredIatSet.add(f), this.refreshLockWhileAcquired(g, f), [2, !0]) : [3, 7];
            case 5:
              return u.lockCorrector(this.storageHandler === void 0 ? o : this.storageHandler), [4, this.waitForSomethingToChange(p)];
            case 6:
              k.sent(), k.label = 7;
            case 7:
              return f = Date.now() + l(4), [3, 1];
            case 8:
              return [2, !1];
          }
        });
      });
    }, u.prototype.refreshLockWhileAcquired = function(c, h) {
      return r(this, void 0, void 0, function() {
        var f = this;
        return n(this, function(p) {
          return setTimeout(function() {
            return r(f, void 0, void 0, function() {
              var g, v, m;
              return n(this, function($) {
                switch ($.label) {
                  case 0:
                    return [4, ya.default().lock(h)];
                  case 1:
                    return $.sent(), this.acquiredIatSet.has(h) ? (g = this.storageHandler === void 0 ? o : this.storageHandler, (v = g.getItemSync(c)) === null ? (ya.default().unlock(h), [2]) : ((m = JSON.parse(v)).timeRefreshed = Date.now(), g.setItemSync(c, JSON.stringify(m)), ya.default().unlock(h), this.refreshLockWhileAcquired(c, h), [2])) : (ya.default().unlock(h), [2]);
                }
              });
            });
          }, 1e3), [2];
        });
      });
    }, u.prototype.waitForSomethingToChange = function(c) {
      return r(this, void 0, void 0, function() {
        return n(this, function(h) {
          switch (h.label) {
            case 0:
              return [4, new Promise(function(f) {
                var p = !1, g = Date.now(), v = !1;
                function m() {
                  if (v || (window.removeEventListener("storage", m), u.removeFromWaiting(m), clearTimeout($), v = !0), !p) {
                    p = !0;
                    var w = 50 - (Date.now() - g);
                    w > 0 ? setTimeout(f, w) : f(null);
                  }
                }
                window.addEventListener("storage", m), u.addToWaiting(m);
                var $ = setTimeout(m, Math.max(0, c - Date.now()));
              })];
            case 1:
              return h.sent(), [2];
          }
        });
      });
    }, u.addToWaiting = function(c) {
      this.removeFromWaiting(c), u.waiters !== void 0 && u.waiters.push(c);
    }, u.removeFromWaiting = function(c) {
      u.waiters !== void 0 && (u.waiters = u.waiters.filter(function(h) {
        return h !== c;
      }));
    }, u.notifyWaiters = function() {
      u.waiters !== void 0 && u.waiters.slice().forEach(function(c) {
        return c();
      });
    }, u.prototype.releaseLock = function(c) {
      return r(this, void 0, void 0, function() {
        return n(this, function(h) {
          switch (h.label) {
            case 0:
              return [4, this.releaseLock__private__(c)];
            case 1:
              return [2, h.sent()];
          }
        });
      });
    }, u.prototype.releaseLock__private__ = function(c) {
      return r(this, void 0, void 0, function() {
        var h, f, p, g;
        return n(this, function(v) {
          switch (v.label) {
            case 0:
              return h = this.storageHandler === void 0 ? o : this.storageHandler, f = a + "-" + c, (p = h.getItemSync(f)) === null ? [2] : (g = JSON.parse(p)).id !== this.id ? [3, 2] : [4, ya.default().lock(g.iat)];
            case 1:
              v.sent(), this.acquiredIatSet.delete(g.iat), h.removeItemSync(f), ya.default().unlock(g.iat), u.notifyWaiters(), v.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, u.lockCorrector = function(c) {
      for (var h = Date.now() - 5e3, f = c, p = [], g = 0; ; ) {
        var v = f.keySync(g);
        if (v === null) break;
        p.push(v), g++;
      }
      for (var m = !1, $ = 0; $ < p.length; $++) {
        var w = p[$];
        if (w.includes(a)) {
          var k = f.getItemSync(w);
          if (k !== null) {
            var C = JSON.parse(k);
            (C.timeRefreshed === void 0 && C.timeAcquired < h || C.timeRefreshed !== void 0 && C.timeRefreshed < h) && (f.removeItemSync(w), m = !0);
          }
        }
      }
      m && u.notifyWaiters();
    }, u.waiters = void 0, u;
  }();
  t.default = d;
}));
const Ob = { timeoutInSeconds: 60 }, Jv = { name: "auth0-spa-js", version: "2.1.3" }, e4 = () => Date.now();
let an = class G1 extends Error {
  constructor(t, r) {
    super(r), this.error = t, this.error_description = r, Object.setPrototypeOf(this, G1.prototype);
  }
  static fromPayload({ error: t, error_description: r }) {
    return new G1(t, r);
  }
}, Ib = class t4 extends an {
  constructor(t, r, n, i = null) {
    super(t, r), this.state = n, this.appState = i, Object.setPrototypeOf(this, t4.prototype);
  }
}, Y1 = class r4 extends an {
  constructor() {
    super("timeout", "Timeout"), Object.setPrototypeOf(this, r4.prototype);
  }
}, Pb = class n4 extends Y1 {
  constructor(t) {
    super(), this.popup = t, Object.setPrototypeOf(this, n4.prototype);
  }
}, Db = class i4 extends an {
  constructor(t) {
    super("cancelled", "Popup closed"), this.popup = t, Object.setPrototypeOf(this, i4.prototype);
  }
}, Mb = class a4 extends an {
  constructor(t, r, n) {
    super(t, r), this.mfa_token = n, Object.setPrototypeOf(this, a4.prototype);
  }
}, o4 = class s4 extends an {
  constructor(t, r) {
    super("missing_refresh_token", `Missing Refresh Token (audience: '${o5(t, ["default"])}', scope: '${o5(r)}')`), this.audience = t, this.scope = r, Object.setPrototypeOf(this, s4.prototype);
  }
};
function o5(e, t = []) {
  return e && !t.includes(e) ? e : "";
}
const du = () => window.crypto, O0 = () => {
  const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
  let t = "";
  return Array.from(du().getRandomValues(new Uint8Array(43))).forEach((r) => t += e[r % e.length]), t;
}, s5 = (e) => btoa(e), K1 = (e) => {
  var { clientId: t } = e, r = qn(e, ["clientId"]);
  return new URLSearchParams(((n) => Object.keys(n).filter((i) => n[i] !== void 0).reduce((i, a) => Object.assign(Object.assign({}, i), { [a]: n[a] }), {}))(Object.assign({ client_id: t }, r))).toString();
}, l5 = (e) => ((t) => decodeURIComponent(atob(t).split("").map((r) => "%" + ("00" + r.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), Nb = async (e, t) => {
  const r = await fetch(e, t);
  return { ok: r.ok, json: await r.json() };
}, Lb = async (e, t, r) => {
  const n = new AbortController();
  let i;
  return t.signal = n.signal, Promise.race([Nb(e, t), new Promise((a, o) => {
    i = setTimeout(() => {
      n.abort(), o(new Error("Timeout when executing 'fetch'"));
    }, r);
  })]).finally(() => {
    clearTimeout(i);
  });
}, Fb = async (e, t, r, n, i, a, o) => {
  return s = { auth: { audience: t, scope: r }, timeout: i, fetchUrl: e, fetchOptions: n, useFormData: o }, l = a, new Promise(function(d, u) {
    const c = new MessageChannel();
    c.port1.onmessage = function(h) {
      h.data.error ? u(new Error(h.data.error)) : d(h.data), c.port1.close();
    }, l.postMessage(s, [c.port2]);
  });
  var s, l;
}, Rb = async (e, t, r, n, i, a, o = 1e4) => i ? Fb(e, t, r, n, o, i, a) : Lb(e, n, o);
async function zb(e, t) {
  var { baseUrl: r, timeout: n, audience: i, scope: a, auth0Client: o, useFormData: s } = e, l = qn(e, ["baseUrl", "timeout", "audience", "scope", "auth0Client", "useFormData"]);
  const d = s ? K1(l) : JSON.stringify(l);
  return await async function(u, c, h, f, p, g, v) {
    let m, $ = null;
    for (let M = 0; M < 3; M++) try {
      m = await Rb(u, h, f, p, g, v, c), $ = null;
      break;
    } catch (V) {
      $ = V;
    }
    if ($) throw $;
    const w = m.json, { error: k, error_description: C } = w, E = qn(w, ["error", "error_description"]), { ok: N } = m;
    if (!N) {
      const M = C || `HTTP error. Unable to fetch ${u}`;
      throw k === "mfa_required" ? new Mb(k, M, E.mfa_token) : k === "missing_refresh_token" ? new o4(h, f) : new an(k || "request_error", M);
    }
    return E;
  }(`${r}/oauth/token`, n, i || "default", a, { method: "POST", body: d, headers: { "Content-Type": s ? "application/x-www-form-urlencoded" : "application/json", "Auth0-Client": btoa(JSON.stringify(o || Jv)) } }, t, s);
}
const Id = (...e) => {
  return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
  var t;
};
let Ma = class Z1 {
  constructor(t, r = "@@auth0spajs@@", n) {
    this.prefix = r, this.suffix = n, this.clientId = t.clientId, this.scope = t.scope, this.audience = t.audience;
  }
  toKey() {
    return [this.prefix, this.clientId, this.audience, this.scope, this.suffix].filter(Boolean).join("::");
  }
  static fromKey(t) {
    const [r, n, i, a] = t.split("::");
    return new Z1({ clientId: n, scope: a, audience: i }, r);
  }
  static fromCacheEntry(t) {
    const { scope: r, audience: n, client_id: i } = t;
    return new Z1({ scope: r, audience: n, clientId: i });
  }
}, jb = class {
  set(t, r) {
    localStorage.setItem(t, JSON.stringify(r));
  }
  get(t) {
    const r = window.localStorage.getItem(t);
    if (r) try {
      return JSON.parse(r);
    } catch {
      return;
    }
  }
  remove(t) {
    localStorage.removeItem(t);
  }
  allKeys() {
    return Object.keys(window.localStorage).filter((t) => t.startsWith("@@auth0spajs@@"));
  }
}, l4 = class {
  constructor() {
    this.enclosedCache = /* @__PURE__ */ function() {
      let t = {};
      return { set(r, n) {
        t[r] = n;
      }, get(r) {
        const n = t[r];
        if (n) return n;
      }, remove(r) {
        delete t[r];
      }, allKeys: () => Object.keys(t) };
    }();
  }
}, Vb = class {
  constructor(t, r, n) {
    this.cache = t, this.keyManifest = r, this.nowProvider = n || e4;
  }
  async setIdToken(t, r, n) {
    var i;
    const a = this.getIdTokenCacheKey(t);
    await this.cache.set(a, { id_token: r, decodedToken: n }), await ((i = this.keyManifest) === null || i === void 0 ? void 0 : i.add(a));
  }
  async getIdToken(t) {
    const r = await this.cache.get(this.getIdTokenCacheKey(t.clientId));
    if (!r && t.scope && t.audience) {
      const n = await this.get(t);
      return !n || !n.id_token || !n.decodedToken ? void 0 : { id_token: n.id_token, decodedToken: n.decodedToken };
    }
    if (r) return { id_token: r.id_token, decodedToken: r.decodedToken };
  }
  async get(t, r = 0) {
    var n;
    let i = await this.cache.get(t.toKey());
    if (!i) {
      const s = await this.getCacheKeys();
      if (!s) return;
      const l = this.matchExistingCacheKey(t, s);
      l && (i = await this.cache.get(l));
    }
    if (!i) return;
    const a = await this.nowProvider(), o = Math.floor(a / 1e3);
    return i.expiresAt - r < o ? i.body.refresh_token ? (i.body = { refresh_token: i.body.refresh_token }, await this.cache.set(t.toKey(), i), i.body) : (await this.cache.remove(t.toKey()), void await ((n = this.keyManifest) === null || n === void 0 ? void 0 : n.remove(t.toKey()))) : i.body;
  }
  async set(t) {
    var r;
    const n = new Ma({ clientId: t.client_id, scope: t.scope, audience: t.audience }), i = await this.wrapCacheEntry(t);
    await this.cache.set(n.toKey(), i), await ((r = this.keyManifest) === null || r === void 0 ? void 0 : r.add(n.toKey()));
  }
  async clear(t) {
    var r;
    const n = await this.getCacheKeys();
    n && (await n.filter((i) => !t || i.includes(t)).reduce(async (i, a) => {
      await i, await this.cache.remove(a);
    }, Promise.resolve()), await ((r = this.keyManifest) === null || r === void 0 ? void 0 : r.clear()));
  }
  async wrapCacheEntry(t) {
    const r = await this.nowProvider();
    return { body: t, expiresAt: Math.floor(r / 1e3) + t.expires_in };
  }
  async getCacheKeys() {
    var t;
    return this.keyManifest ? (t = await this.keyManifest.get()) === null || t === void 0 ? void 0 : t.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
  }
  getIdTokenCacheKey(t) {
    return new Ma({ clientId: t }, "@@auth0spajs@@", "@@user@@").toKey();
  }
  matchExistingCacheKey(t, r) {
    return r.filter((n) => {
      var i;
      const a = Ma.fromKey(n), o = new Set(a.scope && a.scope.split(" ")), s = ((i = t.scope) === null || i === void 0 ? void 0 : i.split(" ")) || [], l = a.scope && s.reduce((d, u) => d && o.has(u), !0);
      return a.prefix === "@@auth0spajs@@" && a.clientId === t.clientId && a.audience === t.audience && l;
    })[0];
  }
}, Ub = class {
  constructor(t, r, n) {
    this.storage = t, this.clientId = r, this.cookieDomain = n, this.storageKey = `a0.spajs.txs.${this.clientId}`;
  }
  create(t) {
    this.storage.save(this.storageKey, t, { daysUntilExpire: 1, cookieDomain: this.cookieDomain });
  }
  get() {
    return this.storage.get(this.storageKey);
  }
  remove() {
    this.storage.remove(this.storageKey, { cookieDomain: this.cookieDomain });
  }
};
const Us = (e) => typeof e == "number", qb = ["iss", "aud", "exp", "nbf", "iat", "jti", "azp", "nonce", "auth_time", "at_hash", "c_hash", "acr", "amr", "sub_jwk", "cnf", "sip_from_tag", "sip_date", "sip_callid", "sip_cseq_num", "sip_via_branch", "orig", "dest", "mky", "events", "toe", "txn", "rph", "sid", "vot", "vtm"], Bb = (e) => {
  if (!e.id_token) throw new Error("ID token is required but missing");
  const t = ((a) => {
    const o = a.split("."), [s, l, d] = o;
    if (o.length !== 3 || !s || !l || !d) throw new Error("ID token could not be decoded");
    const u = JSON.parse(l5(l)), c = { __raw: a }, h = {};
    return Object.keys(u).forEach((f) => {
      c[f] = u[f], qb.includes(f) || (h[f] = u[f]);
    }), { encoded: { header: s, payload: l, signature: d }, header: JSON.parse(l5(s)), claims: c, user: h };
  })(e.id_token);
  if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
  if (t.claims.iss !== e.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
  if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
  if (t.header.alg !== "RS256") throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
  if (!t.claims.aud || typeof t.claims.aud != "string" && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
  if (Array.isArray(t.claims.aud)) {
    if (!t.claims.aud.includes(e.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
    if (t.claims.aud.length > 1) {
      if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
      if (t.claims.azp !== e.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
    }
  } else if (t.claims.aud !== e.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
  if (e.nonce) {
    if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
    if (t.claims.nonce !== e.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
  }
  if (e.max_age && !Us(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
  if (t.claims.exp == null || !Us(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
  if (!Us(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
  const r = e.leeway || 60, n = new Date(e.now || Date.now()), i = /* @__PURE__ */ new Date(0);
  if (i.setUTCSeconds(t.claims.exp + r), n > i) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${n}) is after expiration time (${i})`);
  if (t.claims.nbf != null && Us(t.claims.nbf)) {
    const a = /* @__PURE__ */ new Date(0);
    if (a.setUTCSeconds(t.claims.nbf - r), n < a) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${n}) is before ${a}`);
  }
  if (t.claims.auth_time != null && Us(t.claims.auth_time)) {
    const a = /* @__PURE__ */ new Date(0);
    if (a.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + r), n > a) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${n}) is after last auth at ${a}`);
  }
  if (e.organization) {
    const a = e.organization.trim();
    if (a.startsWith("org_")) {
      const o = a;
      if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
      if (o !== t.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${o}", found "${t.claims.org_id}"`);
    } else {
      const o = a.toLowerCase();
      if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
      if (o !== t.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${o}", found "${t.claims.org_name}"`);
    }
  }
  return t;
};
var Na = Jh(function(e, t) {
  var r = Ta && Ta.__assign || function() {
    return r = Object.assign || function(l) {
      for (var d, u = 1, c = arguments.length; u < c; u++) for (var h in d = arguments[u]) Object.prototype.hasOwnProperty.call(d, h) && (l[h] = d[h]);
      return l;
    }, r.apply(this, arguments);
  };
  function n(l, d) {
    if (!d) return "";
    var u = "; " + l;
    return d === !0 ? u : u + "=" + d;
  }
  function i(l, d, u) {
    return encodeURIComponent(l).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(d).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(c) {
      if (typeof c.expires == "number") {
        var h = /* @__PURE__ */ new Date();
        h.setMilliseconds(h.getMilliseconds() + 864e5 * c.expires), c.expires = h;
      }
      return n("Expires", c.expires ? c.expires.toUTCString() : "") + n("Domain", c.domain) + n("Path", c.path) + n("Secure", c.secure) + n("SameSite", c.sameSite);
    }(u);
  }
  function a(l) {
    for (var d = {}, u = l ? l.split("; ") : [], c = /(%[\dA-F]{2})+/gi, h = 0; h < u.length; h++) {
      var f = u[h].split("="), p = f.slice(1).join("=");
      p.charAt(0) === '"' && (p = p.slice(1, -1));
      try {
        d[f[0].replace(c, decodeURIComponent)] = p.replace(c, decodeURIComponent);
      } catch {
      }
    }
    return d;
  }
  function o() {
    return a(document.cookie);
  }
  function s(l, d, u) {
    document.cookie = i(l, d, r({ path: "/" }, u));
  }
  t.__esModule = !0, t.encode = i, t.parse = a, t.getAll = o, t.get = function(l) {
    return o()[l];
  }, t.set = s, t.remove = function(l, d) {
    s(l, "", r(r({}, d), { expires: -1 }));
  };
});
Xh(Na), Na.encode, Na.parse, Na.getAll;
var Hb = Na.get, d4 = Na.set, u4 = Na.remove;
const bo = { get(e) {
  const t = Hb(e);
  if (t !== void 0) return JSON.parse(t);
}, save(e, t, r) {
  let n = {};
  window.location.protocol === "https:" && (n = { secure: !0, sameSite: "none" }), r?.daysUntilExpire && (n.expires = r.daysUntilExpire), r?.cookieDomain && (n.domain = r.cookieDomain), d4(e, JSON.stringify(t), n);
}, remove(e, t) {
  let r = {};
  t?.cookieDomain && (r.domain = t.cookieDomain), u4(e, r);
} }, Wb = { get(e) {
  return bo.get(e) || bo.get(`_legacy_${e}`);
}, save(e, t, r) {
  let n = {};
  window.location.protocol === "https:" && (n = { secure: !0 }), r?.daysUntilExpire && (n.expires = r.daysUntilExpire), r?.cookieDomain && (n.domain = r.cookieDomain), d4(`_legacy_${e}`, JSON.stringify(t), n), bo.save(e, t, r);
}, remove(e, t) {
  let r = {};
  t?.cookieDomain && (r.domain = t.cookieDomain), u4(e, r), bo.remove(e, t), bo.remove(`_legacy_${e}`, t);
} }, Qb = { get(e) {
  if (typeof sessionStorage > "u") return;
  const t = sessionStorage.getItem(e);
  return t != null ? JSON.parse(t) : void 0;
}, save(e, t) {
  sessionStorage.setItem(e, JSON.stringify(t));
}, remove(e) {
  sessionStorage.removeItem(e);
} };
function Gb(e, t, r) {
  var n = t === void 0 ? null : t, i = function(l, d) {
    var u = atob(l);
    if (d) {
      for (var c = new Uint8Array(u.length), h = 0, f = u.length; h < f; ++h) c[h] = u.charCodeAt(h);
      return String.fromCharCode.apply(null, new Uint16Array(c.buffer));
    }
    return u;
  }(e, r !== void 0 && r), a = i.indexOf(`
`, 10) + 1, o = i.substring(a) + (n ? "//# sourceMappingURL=" + n : ""), s = new Blob([o], { type: "application/javascript" });
  return URL.createObjectURL(s);
}
var d5, u5, c5, I0, Yb = (d5 = "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", u5 = null, c5 = !1, function(e) {
  return I0 = I0 || Gb(d5, u5, c5), new Worker(I0, e);
});
const P0 = {};
let Kb = class {
  constructor(t, r) {
    this.cache = t, this.clientId = r, this.manifestKey = this.createManifestKeyFrom(this.clientId);
  }
  async add(t) {
    var r;
    const n = new Set(((r = await this.cache.get(this.manifestKey)) === null || r === void 0 ? void 0 : r.keys) || []);
    n.add(t), await this.cache.set(this.manifestKey, { keys: [...n] });
  }
  async remove(t) {
    const r = await this.cache.get(this.manifestKey);
    if (r) {
      const n = new Set(r.keys);
      return n.delete(t), n.size > 0 ? await this.cache.set(this.manifestKey, { keys: [...n] }) : await this.cache.remove(this.manifestKey);
    }
  }
  get() {
    return this.cache.get(this.manifestKey);
  }
  clear() {
    return this.cache.remove(this.manifestKey);
  }
  createManifestKeyFrom(t) {
    return `@@auth0spajs@@::${t}`;
  }
};
const Zb = { memory: () => new l4().enclosedCache, localstorage: () => new jb() }, h5 = (e) => Zb[e], f5 = (e) => {
  const { openUrl: t, onRedirect: r } = e, n = qn(e, ["openUrl", "onRedirect"]);
  return Object.assign(Object.assign({}, n), { openUrl: t === !1 || t ? t : r });
}, D0 = new Ab();
class Xb {
  constructor(t) {
    let r, n;
    if (this.userCache = new l4().enclosedCache, this.defaultOptions = { authorizationParams: { scope: "openid profile email" }, useRefreshTokensFallback: !1, useFormData: !0 }, this._releaseLockOnPageHide = async () => {
      await D0.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
    }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), t), { authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), t.authorizationParams) }), typeof window < "u" && (() => {
      if (!du()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
      if (du().subtle === void 0) throw new Error(`
      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.
    `);
    })(), t.cache && t.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), t.cache) n = t.cache;
    else {
      if (r = t.cacheLocation || "memory", !h5(r)) throw new Error(`Invalid cache location "${r}"`);
      n = h5(r)();
    }
    this.httpTimeoutMs = t.httpTimeoutInSeconds ? 1e3 * t.httpTimeoutInSeconds : 1e4, this.cookieStorage = t.legacySameSiteCookie === !1 ? bo : Wb, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((o) => `auth0.${o}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = t.sessionCheckExpiryDays || 1;
    const i = t.useCookiesForTransactions ? this.cookieStorage : Qb;
    var a;
    this.scope = Id("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new Ub(i, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || e4, this.cacheManager = new Vb(n, n.allKeys ? void 0 : new Kb(n, this.options.clientId), this.nowProvider), this.domainUrl = (a = this.options.domain, /^https?:\/\//.test(a) ? a : `https://${a}`), this.tokenIssuer = ((o, s) => o ? o.startsWith("https://") ? o : `https://${o}/` : `${s}/`)(this.options.issuer, this.domainUrl), typeof window < "u" && window.Worker && this.options.useRefreshTokens && r === "memory" && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new Yb());
  }
  _url(t) {
    const r = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || Jv)));
    return `${this.domainUrl}${t}&auth0Client=${r}`;
  }
  _authorizeUrl(t) {
    return this._url(`/authorize?${K1(t)}`);
  }
  async _verifyIdToken(t, r, n) {
    const i = await this.nowProvider();
    return Bb({ iss: this.tokenIssuer, aud: this.options.clientId, id_token: t, nonce: r, organization: n, leeway: this.options.leeway, max_age: (a = this.options.authorizationParams.max_age, typeof a != "string" ? a : parseInt(a, 10) || void 0), now: i });
    var a;
  }
  _processOrgHint(t) {
    t ? this.cookieStorage.save(this.orgHintCookieName, t, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }) : this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain });
  }
  async _prepareAuthorizeUrl(t, r, n) {
    const i = s5(O0()), a = s5(O0()), o = O0(), s = ((u) => {
      const c = new Uint8Array(u);
      return ((h) => {
        const f = { "+": "-", "/": "_", "=": "" };
        return h.replace(/[+/=]/g, (p) => f[p]);
      })(window.btoa(String.fromCharCode(...Array.from(c))));
    })(await (async (u) => await du().subtle.digest({ name: "SHA-256" }, new TextEncoder().encode(u)))(o)), l = ((u, c, h, f, p, g, v, m) => Object.assign(Object.assign(Object.assign({ client_id: u.clientId }, u.authorizationParams), h), { scope: Id(c, h.scope), response_type: "code", response_mode: m || "query", state: f, nonce: p, redirect_uri: v || u.authorizationParams.redirect_uri, code_challenge: g, code_challenge_method: "S256" }))(this.options, this.scope, t, i, a, s, t.redirect_uri || this.options.authorizationParams.redirect_uri || n, r?.response_mode), d = this._authorizeUrl(l);
    return { nonce: a, code_verifier: o, scope: l.scope, audience: l.audience || "default", redirect_uri: l.redirect_uri, state: i, url: d };
  }
  async loginWithPopup(t, r) {
    var n;
    if (t = t || {}, !(r = r || {}).popup && (r.popup = ((s) => {
      const l = window.screenX + (window.innerWidth - 400) / 2, d = window.screenY + (window.innerHeight - 600) / 2;
      return window.open(s, "auth0:authorize:popup", `left=${l},top=${d},width=400,height=600,resizable,scrollbars=yes,status=1`);
    })(""), !r.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
    const i = await this._prepareAuthorizeUrl(t.authorizationParams || {}, { response_mode: "web_message" }, window.location.origin);
    r.popup.location.href = i.url;
    const a = await ((s) => new Promise((l, d) => {
      let u;
      const c = setInterval(() => {
        s.popup && s.popup.closed && (clearInterval(c), clearTimeout(h), window.removeEventListener("message", u, !1), d(new Db(s.popup)));
      }, 1e3), h = setTimeout(() => {
        clearInterval(c), d(new Pb(s.popup)), window.removeEventListener("message", u, !1);
      }, 1e3 * (s.timeoutInSeconds || 60));
      u = function(f) {
        if (f.data && f.data.type === "authorization_response") {
          if (clearTimeout(h), clearInterval(c), window.removeEventListener("message", u, !1), s.popup.close(), f.data.response.error) return d(an.fromPayload(f.data.response));
          l(f.data.response);
        }
      }, window.addEventListener("message", u);
    }))(Object.assign(Object.assign({}, r), { timeoutInSeconds: r.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60 }));
    if (i.state !== a.state) throw new an("state_mismatch", "Invalid state");
    const o = ((n = t.authorizationParams) === null || n === void 0 ? void 0 : n.organization) || this.options.authorizationParams.organization;
    await this._requestToken({ audience: i.audience, scope: i.scope, code_verifier: i.code_verifier, grant_type: "authorization_code", code: a.code, redirect_uri: i.redirect_uri }, { nonceIn: i.nonce, organization: o });
  }
  async getUser() {
    var t;
    const r = await this._getIdTokenFromCache();
    return (t = r?.decodedToken) === null || t === void 0 ? void 0 : t.user;
  }
  async getIdTokenClaims() {
    var t;
    const r = await this._getIdTokenFromCache();
    return (t = r?.decodedToken) === null || t === void 0 ? void 0 : t.claims;
  }
  async loginWithRedirect(t = {}) {
    var r;
    const n = f5(t), { openUrl: i, fragment: a, appState: o } = n, s = qn(n, ["openUrl", "fragment", "appState"]), l = ((r = s.authorizationParams) === null || r === void 0 ? void 0 : r.organization) || this.options.authorizationParams.organization, d = await this._prepareAuthorizeUrl(s.authorizationParams || {}), { url: u } = d, c = qn(d, ["url"]);
    this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, c), { appState: o }), l && { organization: l }));
    const h = a ? `${u}#${a}` : u;
    i ? await i(h) : window.location.assign(h);
  }
  async handleRedirectCallback(t = window.location.href) {
    const r = t.split("?").slice(1);
    if (r.length === 0) throw new Error("There are no query params available for parsing.");
    const { state: n, code: i, error: a, error_description: o } = ((c) => {
      c.indexOf("#") > -1 && (c = c.substring(0, c.indexOf("#")));
      const h = new URLSearchParams(c);
      return { state: h.get("state"), code: h.get("code") || void 0, error: h.get("error") || void 0, error_description: h.get("error_description") || void 0 };
    })(r.join("")), s = this.transactionManager.get();
    if (!s) throw new an("missing_transaction", "Invalid state");
    if (this.transactionManager.remove(), a) throw new Ib(a, o || a, n, s.appState);
    if (!s.code_verifier || s.state && s.state !== n) throw new an("state_mismatch", "Invalid state");
    const l = s.organization, d = s.nonce, u = s.redirect_uri;
    return await this._requestToken(Object.assign({ audience: s.audience, scope: s.scope, code_verifier: s.code_verifier, grant_type: "authorization_code", code: i }, u ? { redirect_uri: u } : {}), { nonceIn: d, organization: l }), { appState: s.appState };
  }
  async checkSession(t) {
    if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
      if (!this.cookieStorage.get("auth0.is.authenticated")) return;
      this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove("auth0.is.authenticated");
    }
    try {
      await this.getTokenSilently(t);
    } catch {
    }
  }
  async getTokenSilently(t = {}) {
    var r;
    const n = Object.assign(Object.assign({ cacheMode: "on" }, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: Id(this.scope, (r = t.authorizationParams) === null || r === void 0 ? void 0 : r.scope) }) }), i = await ((a, o) => {
      let s = P0[o];
      return s || (s = a().finally(() => {
        delete P0[o], s = null;
      }), P0[o] = s), s;
    })(() => this._getTokenSilently(n), `${this.options.clientId}::${n.authorizationParams.audience}::${n.authorizationParams.scope}`);
    return t.detailedResponse ? i : i?.access_token;
  }
  async _getTokenSilently(t) {
    const { cacheMode: r } = t, n = qn(t, ["cacheMode"]);
    if (r !== "off") {
      const i = await this._getEntryFromCache({ scope: n.authorizationParams.scope, audience: n.authorizationParams.audience || "default", clientId: this.options.clientId });
      if (i) return i;
    }
    if (r !== "cache-only") {
      if (!await (async (i, a = 3) => {
        for (let o = 0; o < a; o++) if (await i()) return !0;
        return !1;
      })(() => D0.acquireLock("auth0.lock.getTokenSilently", 5e3), 10)) throw new Y1();
      try {
        if (window.addEventListener("pagehide", this._releaseLockOnPageHide), r !== "off") {
          const d = await this._getEntryFromCache({ scope: n.authorizationParams.scope, audience: n.authorizationParams.audience || "default", clientId: this.options.clientId });
          if (d) return d;
        }
        const i = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(n) : await this._getTokenFromIFrame(n), { id_token: a, access_token: o, oauthTokenScope: s, expires_in: l } = i;
        return Object.assign(Object.assign({ id_token: a, access_token: o }, s ? { scope: s } : null), { expires_in: l });
      } finally {
        await D0.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
      }
    }
  }
  async getTokenWithPopup(t = {}, r = {}) {
    var n;
    const i = Object.assign(Object.assign({}, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: Id(this.scope, (n = t.authorizationParams) === null || n === void 0 ? void 0 : n.scope) }) });
    return r = Object.assign(Object.assign({}, Ob), r), await this.loginWithPopup(i, r), (await this.cacheManager.get(new Ma({ scope: i.authorizationParams.scope, audience: i.authorizationParams.audience || "default", clientId: this.options.clientId }))).access_token;
  }
  async isAuthenticated() {
    return !!await this.getUser();
  }
  _buildLogoutUrl(t) {
    t.clientId !== null ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
    const r = t.logoutParams || {}, { federated: n } = r, i = qn(r, ["federated"]), a = n ? "&federated" : "";
    return this._url(`/v2/logout?${K1(Object.assign({ clientId: t.clientId }, i))}`) + a;
  }
  async logout(t = {}) {
    const r = f5(t), { openUrl: n } = r, i = qn(r, ["openUrl"]);
    t.clientId === null ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove(this.isAuthenticatedCookieName, { cookieDomain: this.options.cookieDomain }), this.userCache.remove("@@user@@");
    const a = this._buildLogoutUrl(i);
    n ? await n(a) : n !== !1 && window.location.assign(a);
  }
  async _getTokenFromIFrame(t) {
    const r = Object.assign(Object.assign({}, t.authorizationParams), { prompt: "none" }), n = this.cookieStorage.get(this.orgHintCookieName);
    n && !r.organization && (r.organization = n);
    const { url: i, state: a, nonce: o, code_verifier: s, redirect_uri: l, scope: d, audience: u } = await this._prepareAuthorizeUrl(r, { response_mode: "web_message" }, window.location.origin);
    try {
      if (window.crossOriginIsolated) throw new an("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
      const c = t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, h = await ((p, g, v = 60) => new Promise((m, $) => {
        const w = window.document.createElement("iframe");
        w.setAttribute("width", "0"), w.setAttribute("height", "0"), w.style.display = "none";
        const k = () => {
          window.document.body.contains(w) && (window.document.body.removeChild(w), window.removeEventListener("message", C, !1));
        };
        let C;
        const E = setTimeout(() => {
          $(new Y1()), k();
        }, 1e3 * v);
        C = function(N) {
          if (N.origin != g || !N.data || N.data.type !== "authorization_response") return;
          const M = N.source;
          M && M.close(), N.data.response.error ? $(an.fromPayload(N.data.response)) : m(N.data.response), clearTimeout(E), window.removeEventListener("message", C, !1), setTimeout(k, 2e3);
        }, window.addEventListener("message", C, !1), window.document.body.appendChild(w), w.setAttribute("src", p);
      }))(i, this.domainUrl, c);
      if (a !== h.state) throw new an("state_mismatch", "Invalid state");
      const f = await this._requestToken(Object.assign(Object.assign({}, t.authorizationParams), { code_verifier: s, code: h.code, grant_type: "authorization_code", redirect_uri: l, timeout: t.authorizationParams.timeout || this.httpTimeoutMs }), { nonceIn: o, organization: r.organization });
      return Object.assign(Object.assign({}, f), { scope: d, oauthTokenScope: f.scope, audience: u });
    } catch (c) {
      throw c.error === "login_required" && this.logout({ openUrl: !1 }), c;
    }
  }
  async _getTokenUsingRefreshToken(t) {
    const r = await this.cacheManager.get(new Ma({ scope: t.authorizationParams.scope, audience: t.authorizationParams.audience || "default", clientId: this.options.clientId }));
    if (!(r && r.refresh_token || this.worker)) {
      if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(t);
      throw new o4(t.authorizationParams.audience || "default", t.authorizationParams.scope);
    }
    const n = t.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, i = typeof t.timeoutInSeconds == "number" ? 1e3 * t.timeoutInSeconds : null;
    try {
      const a = await this._requestToken(Object.assign(Object.assign(Object.assign({}, t.authorizationParams), { grant_type: "refresh_token", refresh_token: r && r.refresh_token, redirect_uri: n }), i && { timeout: i }));
      return Object.assign(Object.assign({}, a), { scope: t.authorizationParams.scope, oauthTokenScope: a.scope, audience: t.authorizationParams.audience || "default" });
    } catch (a) {
      if ((a.message.indexOf("Missing Refresh Token") > -1 || a.message && a.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(t);
      throw a;
    }
  }
  async _saveEntryInCache(t) {
    const { id_token: r, decodedToken: n } = t, i = qn(t, ["id_token", "decodedToken"]);
    this.userCache.set("@@user@@", { id_token: r, decodedToken: n }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(i);
  }
  async _getIdTokenFromCache() {
    const t = this.options.authorizationParams.audience || "default", r = await this.cacheManager.getIdToken(new Ma({ clientId: this.options.clientId, audience: t, scope: this.scope })), n = this.userCache.get("@@user@@");
    return r && r.id_token === n?.id_token ? n : (this.userCache.set("@@user@@", r), r);
  }
  async _getEntryFromCache({ scope: t, audience: r, clientId: n }) {
    const i = await this.cacheManager.get(new Ma({ scope: t, audience: r, clientId: n }), 60);
    if (i && i.access_token) {
      const { access_token: a, oauthTokenScope: o, expires_in: s } = i, l = await this._getIdTokenFromCache();
      return l && Object.assign(Object.assign({ id_token: l.id_token, access_token: a }, o ? { scope: o } : null), { expires_in: s });
    }
  }
  async _requestToken(t, r) {
    const { nonceIn: n, organization: i } = r || {}, a = await zb(Object.assign({ baseUrl: this.domainUrl, client_id: this.options.clientId, auth0Client: this.options.auth0Client, useFormData: this.options.useFormData, timeout: this.httpTimeoutMs }, t), this.worker), o = await this._verifyIdToken(a.id_token, n, i);
    return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, a), { decodedToken: o, scope: t.scope, audience: t.audience || "default" }), a.scope ? { oauthTokenScope: a.scope } : null), { client_id: this.options.clientId })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this._processOrgHint(i || o.claims.org_id), Object.assign(Object.assign({}, a), { decodedToken: o });
  }
}
var M0 = "Invariant Violation", p5 = Object.setPrototypeOf, Jb = p5 === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : p5, c4 = (
  /** @class */
  function(e) {
    ri(t, e);
    function t(r) {
      r === void 0 && (r = M0);
      var n = e.call(this, typeof r == "number" ? M0 + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = M0, Jb(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function Aa(e, t) {
  if (!e)
    throw new c4(t);
}
var h4 = ["debug", "log", "warn", "error", "silent"], e$ = h4.indexOf("log");
function Pd(e) {
  return function() {
    if (h4.indexOf(e) >= e$) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = Pd("debug"), e.log = Pd("log"), e.warn = Pd("warn"), e.error = Pd("error");
})(Aa || (Aa = {}));
var ef = "3.13.5";
function _n(e) {
  try {
    return e();
  } catch {
  }
}
const X1 = _n(function() {
  return globalThis;
}) || _n(function() {
  return window;
}) || _n(function() {
  return self;
}) || _n(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
_n(function() {
  return _n.constructor("return this")();
});
var m5 = /* @__PURE__ */ new Map();
function J1(e) {
  var t = m5.get(e) || 1;
  return m5.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function f4(e, t) {
  t === void 0 && (t = 0);
  var r = J1("stringifyForDisplay");
  return JSON.stringify(e, function(n, i) {
    return i === void 0 ? r : i;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function Dd(e) {
  return function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (typeof t == "number") {
      var i = t;
      t = tf(i), t || (t = rf(i, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var Oe = Object.assign(function(t, r) {
  for (var n = [], i = 2; i < arguments.length; i++)
    n[i - 2] = arguments[i];
  t || Aa(t, tf(r, n) || rf(r, n));
}, {
  debug: Dd(Aa.debug),
  log: Dd(Aa.log),
  warn: Dd(Aa.warn),
  error: Dd(Aa.error)
});
function Rr(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new c4(tf(e, t) || rf(e, t));
}
var g5 = Symbol.for("ApolloErrorMessageHandler_" + ef);
function p4(e) {
  if (typeof e == "string")
    return e;
  try {
    return f4(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function tf(e, t) {
  if (t === void 0 && (t = []), !!e)
    return X1[g5] && X1[g5](e, t.map(p4));
}
function rf(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: ef,
      message: e,
      args: t.map(p4)
    })));
}
function uu(e, t) {
  if (!!!e)
    throw new Error(t);
}
function t$(e) {
  return typeof e == "object" && e !== null;
}
function r$(e, t) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const n$ = /\r\n|[\n\r]/g;
function e2(e, t) {
  let r = 0, n = 1;
  for (const i of e.body.matchAll(n$)) {
    if (typeof i.index == "number" || r$(!1), i.index >= t)
      break;
    r = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: t + 1 - r
  };
}
function i$(e) {
  return m4(
    e.source,
    e2(e.source, e.start)
  );
}
function m4(e, t) {
  const r = e.locationOffset.column - 1, n = "".padStart(r) + e.body, i = t.line - 1, a = e.locationOffset.line - 1, o = t.line + a, s = t.line === 1 ? r : 0, l = t.column + s, d = `${e.name}:${o}:${l}
`, u = n.split(/\r\n|[\n\r]/g), c = u[i];
  if (c.length > 120) {
    const h = Math.floor(l / 80), f = l % 80, p = [];
    for (let g = 0; g < c.length; g += 80)
      p.push(c.slice(g, g + 80));
    return d + v5([
      [`${o} |`, p[0]],
      ...p.slice(1, h + 1).map((g) => ["|", g]),
      ["|", "^".padStart(f)],
      ["|", p[h + 1]]
    ]);
  }
  return d + v5([
    // Lines specified like this: ["prefix", "string"],
    [`${o - 1} |`, u[i - 1]],
    [`${o} |`, c],
    ["|", "^".padStart(l)],
    [`${o + 1} |`, u[i + 1]]
  ]);
}
function v5(e) {
  const t = e.filter(([n, i]) => i !== void 0), r = Math.max(...t.map(([n]) => n.length));
  return t.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
}
function a$(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class nf extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...r) {
    var n, i, a;
    const { nodes: o, source: s, positions: l, path: d, originalError: u, extensions: c } = a$(r);
    super(t), this.name = "GraphQLError", this.path = d ?? void 0, this.originalError = u ?? void 0, this.nodes = y5(
      Array.isArray(o) ? o : o ? [o] : void 0
    );
    const h = y5(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((p) => p.loc).filter((p) => p != null)
    );
    this.source = s ?? (h == null || (i = h[0]) === null || i === void 0 ? void 0 : i.source), this.positions = l ?? h?.map((p) => p.start), this.locations = l && s ? l.map((p) => e2(s, p)) : h?.map((p) => e2(p.source, p.start));
    const f = t$(
      u?.extensions
    ) ? u?.extensions : void 0;
    this.extensions = (a = c ?? f) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), u != null && u.stack ? Object.defineProperty(this, "stack", {
      value: u.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, nf) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (t += `

` + i$(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        t += `

` + m4(this.source, r);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function y5(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function fr(e, t, r) {
  return new nf(`Syntax Error: ${r}`, {
    source: e,
    positions: [t]
  });
}
class o$ {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, r, n) {
    this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class g4 {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, r, n, i, a, o) {
    this.kind = t, this.start = r, this.end = n, this.line = i, this.column = a, this.value = o, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const v4 = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, s$ = new Set(Object.keys(v4));
function b5(e) {
  const t = e?.kind;
  return typeof t == "string" && s$.has(t);
}
var Io;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(Io || (Io = {}));
var t2;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(t2 || (t2 = {}));
var ye;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(ye || (ye = {}));
function r2(e) {
  return e === 9 || e === 32;
}
function Fl(e) {
  return e >= 48 && e <= 57;
}
function y4(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function b4(e) {
  return y4(e) || e === 95;
}
function l$(e) {
  return y4(e) || Fl(e) || e === 95;
}
function d$(e) {
  var t;
  let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let o = 0; o < e.length; ++o) {
    var a;
    const s = e[o], l = u$(s);
    l !== s.length && (n = (a = n) !== null && a !== void 0 ? a : o, i = o, o !== 0 && l < r && (r = l));
  }
  return e.map((o, s) => s === 0 ? o : o.slice(r)).slice(
    (t = n) !== null && t !== void 0 ? t : 0,
    i + 1
  );
}
function u$(e) {
  let t = 0;
  for (; t < e.length && r2(e.charCodeAt(t)); )
    ++t;
  return t;
}
function c$(e, t) {
  const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, a = n.length > 1 && n.slice(1).every((f) => f.length === 0 || r2(f.charCodeAt(0))), o = r.endsWith('\\"""'), s = e.endsWith('"') && !o, l = e.endsWith("\\"), d = s || l, u = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || d || a || o
  );
  let c = "";
  const h = i && r2(e.charCodeAt(0));
  return (u && !h || a) && (c += `
`), c += r, (u || d) && (c += `
`), '"""' + c + '"""';
}
var ne;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(ne || (ne = {}));
class h$ {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const r = new g4(ne.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== ne.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const r = p$(this, t.end);
          t.next = r, r.prev = t, t = r;
        }
      while (t.kind === ne.COMMENT);
    return t;
  }
}
function f$(e) {
  return e === ne.BANG || e === ne.DOLLAR || e === ne.AMP || e === ne.PAREN_L || e === ne.PAREN_R || e === ne.SPREAD || e === ne.COLON || e === ne.EQUALS || e === ne.AT || e === ne.BRACKET_L || e === ne.BRACKET_R || e === ne.BRACE_L || e === ne.PIPE || e === ne.BRACE_R;
}
function xs(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function Oc(e, t) {
  return $4(e.charCodeAt(t)) && w4(e.charCodeAt(t + 1));
}
function $4(e) {
  return e >= 55296 && e <= 56319;
}
function w4(e) {
  return e >= 56320 && e <= 57343;
}
function qa(e, t) {
  const r = e.source.body.codePointAt(t);
  if (r === void 0)
    return ne.EOF;
  if (r >= 32 && r <= 126) {
    const n = String.fromCodePoint(r);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function er(e, t, r, n, i) {
  const a = e.line, o = 1 + r - e.lineStart;
  return new g4(t, r, n, a, o, i);
}
function p$(e, t) {
  const r = e.source.body, n = r.length;
  let i = t;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    switch (a) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      case 35:
        return m$(e, i);
      case 33:
        return er(e, ne.BANG, i, i + 1);
      case 36:
        return er(e, ne.DOLLAR, i, i + 1);
      case 38:
        return er(e, ne.AMP, i, i + 1);
      case 40:
        return er(e, ne.PAREN_L, i, i + 1);
      case 41:
        return er(e, ne.PAREN_R, i, i + 1);
      case 46:
        if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
          return er(e, ne.SPREAD, i, i + 3);
        break;
      case 58:
        return er(e, ne.COLON, i, i + 1);
      case 61:
        return er(e, ne.EQUALS, i, i + 1);
      case 64:
        return er(e, ne.AT, i, i + 1);
      case 91:
        return er(e, ne.BRACKET_L, i, i + 1);
      case 93:
        return er(e, ne.BRACKET_R, i, i + 1);
      case 123:
        return er(e, ne.BRACE_L, i, i + 1);
      case 124:
        return er(e, ne.PIPE, i, i + 1);
      case 125:
        return er(e, ne.BRACE_R, i, i + 1);
      case 34:
        return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? w$(e, i) : v$(e, i);
    }
    if (Fl(a) || a === 45)
      return g$(e, i, a);
    if (b4(a))
      return x$(e, i);
    throw fr(
      e.source,
      i,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : xs(a) || Oc(r, i) ? `Unexpected character: ${qa(e, i)}.` : `Invalid character: ${qa(e, i)}.`
    );
  }
  return er(e, ne.EOF, n, n);
}
function m$(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (a === 10 || a === 13)
      break;
    if (xs(a))
      ++i;
    else if (Oc(r, i))
      i += 2;
    else
      break;
  }
  return er(
    e,
    ne.COMMENT,
    t,
    i,
    r.slice(t + 1, i)
  );
}
function g$(e, t, r) {
  const n = e.source.body;
  let i = t, a = r, o = !1;
  if (a === 45 && (a = n.charCodeAt(++i)), a === 48) {
    if (a = n.charCodeAt(++i), Fl(a))
      throw fr(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${qa(
          e,
          i
        )}.`
      );
  } else
    i = N0(e, i, a), a = n.charCodeAt(i);
  if (a === 46 && (o = !0, a = n.charCodeAt(++i), i = N0(e, i, a), a = n.charCodeAt(i)), (a === 69 || a === 101) && (o = !0, a = n.charCodeAt(++i), (a === 43 || a === 45) && (a = n.charCodeAt(++i)), i = N0(e, i, a), a = n.charCodeAt(i)), a === 46 || b4(a))
    throw fr(
      e.source,
      i,
      `Invalid number, expected digit but got: ${qa(
        e,
        i
      )}.`
    );
  return er(
    e,
    o ? ne.FLOAT : ne.INT,
    t,
    i,
    n.slice(t, i)
  );
}
function N0(e, t, r) {
  if (!Fl(r))
    throw fr(
      e.source,
      t,
      `Invalid number, expected digit but got: ${qa(
        e,
        t
      )}.`
    );
  const n = e.source.body;
  let i = t + 1;
  for (; Fl(n.charCodeAt(i)); )
    ++i;
  return i;
}
function v$(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1, a = i, o = "";
  for (; i < n; ) {
    const s = r.charCodeAt(i);
    if (s === 34)
      return o += r.slice(a, i), er(e, ne.STRING, t, i + 1, o);
    if (s === 92) {
      o += r.slice(a, i);
      const l = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? y$(e, i) : b$(e, i) : $$(e, i);
      o += l.value, i += l.size, a = i;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (xs(s))
      ++i;
    else if (Oc(r, i))
      i += 2;
    else
      throw fr(
        e.source,
        i,
        `Invalid character within String: ${qa(
          e,
          i
        )}.`
      );
  }
  throw fr(e.source, i, "Unterminated string.");
}
function y$(e, t) {
  const r = e.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const a = r.charCodeAt(t + i++);
    if (a === 125) {
      if (i < 5 || !xs(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | fl(a), n < 0)
      break;
  }
  throw fr(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(
      t,
      t + i
    )}".`
  );
}
function b$(e, t) {
  const r = e.source.body, n = $5(r, t + 2);
  if (xs(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if ($4(n) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
    const i = $5(r, t + 8);
    if (w4(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw fr(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
  );
}
function $5(e, t) {
  return fl(e.charCodeAt(t)) << 12 | fl(e.charCodeAt(t + 1)) << 8 | fl(e.charCodeAt(t + 2)) << 4 | fl(e.charCodeAt(t + 3));
}
function fl(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function $$(e, t) {
  const r = e.source.body;
  switch (r.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw fr(
    e.source,
    t,
    `Invalid character escape sequence: "${r.slice(
      t,
      t + 2
    )}".`
  );
}
function w$(e, t) {
  const r = e.source.body, n = r.length;
  let i = e.lineStart, a = t + 3, o = a, s = "";
  const l = [];
  for (; a < n; ) {
    const d = r.charCodeAt(a);
    if (d === 34 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34) {
      s += r.slice(o, a), l.push(s);
      const u = er(
        e,
        ne.BLOCK_STRING,
        t,
        a + 3,
        // Return a string of the lines joined with U+000A.
        d$(l).join(`
`)
      );
      return e.line += l.length - 1, e.lineStart = i, u;
    }
    if (d === 92 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34 && r.charCodeAt(a + 3) === 34) {
      s += r.slice(o, a), o = a + 1, a += 4;
      continue;
    }
    if (d === 10 || d === 13) {
      s += r.slice(o, a), l.push(s), d === 13 && r.charCodeAt(a + 1) === 10 ? a += 2 : ++a, s = "", o = a, i = a;
      continue;
    }
    if (xs(d))
      ++a;
    else if (Oc(r, a))
      a += 2;
    else
      throw fr(
        e.source,
        a,
        `Invalid character within String: ${qa(
          e,
          a
        )}.`
      );
  }
  throw fr(e.source, a, "Unterminated string.");
}
function x$(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (l$(a))
      ++i;
    else
      break;
  }
  return er(
    e,
    ne.NAME,
    t,
    i,
    r.slice(t, i)
  );
}
const k$ = 10, x4 = 2;
function k4(e) {
  return Ic(e, []);
}
function Ic(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return _$(e, t);
    default:
      return String(e);
  }
}
function _$(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const r = [...t, e];
  if (C$(e)) {
    const n = e.toJSON();
    if (n !== e)
      return typeof n == "string" ? n : Ic(n, r);
  } else if (Array.isArray(e))
    return E$(e, r);
  return S$(e, r);
}
function C$(e) {
  return typeof e.toJSON == "function";
}
function S$(e, t) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : t.length > x4 ? "[" + T$(e) + "]" : "{ " + r.map(
    ([i, a]) => i + ": " + Ic(a, t)
  ).join(", ") + " }";
}
function E$(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > x4)
    return "[Array]";
  const r = Math.min(k$, e.length), n = e.length - r, i = [];
  for (let a = 0; a < r; ++a)
    i.push(Ic(e[a], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function T$(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
const A$ = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  // eslint-disable-next-line no-undef
  function(t, r) {
    return t instanceof r;
  }
);
class _4 {
  constructor(t, r = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || uu(!1, `Body must be a string. Received: ${k4(t)}.`), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || uu(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || uu(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function O$(e) {
  return A$(e, _4);
}
function I$(e, t) {
  return new P$(e, t).parseDocument();
}
let P$ = class {
  constructor(t, r = {}) {
    const n = O$(t) ? t : new _4(t);
    this._lexer = new h$(n), this._options = r, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(ne.NAME);
    return this.node(t, {
      kind: ye.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: ye.DOCUMENT,
      definitions: this.many(
        ne.SOF,
        this.parseDefinition,
        ne.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(ne.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
    if (r.kind === ne.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (t)
        throw fr(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(ne.BRACE_L))
      return this.node(t, {
        kind: ye.OPERATION_DEFINITION,
        operation: Io.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseOperationType();
    let n;
    return this.peek(ne.NAME) && (n = this.parseName()), this.node(t, {
      kind: ye.OPERATION_DEFINITION,
      operation: r,
      name: n,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(ne.NAME);
    switch (t.value) {
      case "query":
        return Io.QUERY;
      case "mutation":
        return Io.MUTATION;
      case "subscription":
        return Io.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      ne.PAREN_L,
      this.parseVariableDefinition,
      ne.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: ye.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(ne.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(ne.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(ne.DOLLAR), this.node(t, {
      kind: ye.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: ye.SELECTION_SET,
      selections: this.many(
        ne.BRACE_L,
        this.parseSelection,
        ne.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(ne.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, r = this.parseName();
    let n, i;
    return this.expectOptionalToken(ne.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(t, {
      kind: ye.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(ne.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const r = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(ne.PAREN_L, r, ne.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(ne.COLON), this.node(r, {
      kind: ye.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(ne.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(ne.NAME) ? this.node(t, {
      kind: ye.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: ye.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: ye.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: ye.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const r = this._lexer.token;
    switch (r.kind) {
      case ne.BRACKET_L:
        return this.parseList(t);
      case ne.BRACE_L:
        return this.parseObject(t);
      case ne.INT:
        return this.advanceLexer(), this.node(r, {
          kind: ye.INT,
          value: r.value
        });
      case ne.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: ye.FLOAT,
          value: r.value
        });
      case ne.STRING:
      case ne.BLOCK_STRING:
        return this.parseStringLiteral();
      case ne.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: ye.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: ye.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: ye.NULL
            });
          default:
            return this.node(r, {
              kind: ye.ENUM,
              value: r.value
            });
        }
      case ne.DOLLAR:
        if (t)
          if (this.expectToken(ne.DOLLAR), this._lexer.token.kind === ne.NAME) {
            const n = this._lexer.token.value;
            throw fr(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: ye.STRING,
      value: t.value,
      block: t.kind === ne.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const r = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: ye.LIST,
      values: this.any(ne.BRACKET_L, r, ne.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const r = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: ye.OBJECT,
      fields: this.any(ne.BRACE_L, r, ne.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(ne.COLON), this.node(r, {
      kind: ye.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const r = [];
    for (; this.peek(ne.AT); )
      r.push(this.parseDirective(t));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const r = this._lexer.token;
    return this.expectToken(ne.AT), this.node(r, {
      kind: ye.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let r;
    if (this.expectOptionalToken(ne.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(ne.BRACKET_R), r = this.node(t, {
        kind: ye.LIST_TYPE,
        type: n
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(ne.BANG) ? this.node(t, {
      kind: ye.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: ye.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(ne.STRING) || this.peek(ne.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      ne.BRACE_L,
      this.parseOperationTypeDefinition,
      ne.BRACE_R
    );
    return this.node(t, {
      kind: ye.SCHEMA_DEFINITION,
      description: r,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, r = this.parseOperationType();
    this.expectToken(ne.COLON);
    const n = this.parseNamedType();
    return this.node(t, {
      kind: ye.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: ye.SCALAR_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: ye.OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(ne.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      ne.BRACE_L,
      this.parseFieldDefinition,
      ne.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(ne.COLON);
    const a = this.parseTypeReference(), o = this.parseConstDirectives();
    return this.node(t, {
      kind: ye.FIELD_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      type: a,
      directives: o
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      ne.PAREN_L,
      this.parseInputValueDef,
      ne.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName();
    this.expectToken(ne.COLON);
    const i = this.parseTypeReference();
    let a;
    this.expectOptionalToken(ne.EQUALS) && (a = this.parseConstValueLiteral());
    const o = this.parseConstDirectives();
    return this.node(t, {
      kind: ye.INPUT_VALUE_DEFINITION,
      description: r,
      name: n,
      type: i,
      defaultValue: a,
      directives: o
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: ye.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: ye.UNION_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(ne.EQUALS) ? this.delimitedMany(ne.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: ye.ENUM_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      ne.BRACE_L,
      this.parseEnumValueDefinition,
      ne.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: ye.ENUM_VALUE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw fr(
        this._lexer.source,
        this._lexer.token.start,
        `${Md(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: ye.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      ne.BRACE_L,
      this.parseInputValueDef,
      ne.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === ne.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), n = this.optionalMany(
      ne.BRACE_L,
      this.parseOperationTypeDefinition,
      ne.BRACE_R
    );
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.UNION_TYPE_EXTENSION,
      name: r,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.ENUM_TYPE_EXTENSION,
      name: r,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: n,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(ne.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), a = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(t, {
      kind: ye.DIRECTIVE_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      repeatable: a,
      locations: o
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(ne.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(t2, r.value))
      return r;
    throw this.unexpected(t);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, r) {
    return this._options.noLocation !== !0 && (r.loc = new o$(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const r = this._lexer.token;
    if (r.kind === t)
      return this.advanceLexer(), r;
    throw fr(
      this._lexer.source,
      r.start,
      `Expected ${C4(t)}, found ${Md(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const r = this._lexer.token;
    if (r.kind === ne.NAME && r.value === t)
      this.advanceLexer();
    else
      throw fr(
        this._lexer.source,
        r.start,
        `Expected "${t}", found ${Md(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const r = this._lexer.token;
    return r.kind === ne.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const r = t ?? this._lexer.token;
    return fr(
      this._lexer.source,
      r.start,
      `Unexpected ${Md(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, r, n) {
    this.expectToken(t);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(r.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, r, n) {
    if (this.expectOptionalToken(t)) {
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, r, n) {
    this.expectToken(t);
    const i = [];
    do
      i.push(r.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, r) {
    this.expectOptionalToken(t);
    const n = [];
    do
      n.push(r.call(this));
    while (this.expectOptionalToken(t));
    return n;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, r = this._lexer.advance();
    if (t !== void 0 && r.kind !== ne.EOF && (++this._tokenCounter, this._tokenCounter > t))
      throw fr(
        this._lexer.source,
        r.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
};
function Md(e) {
  const t = e.value;
  return C4(e.kind) + (t != null ? ` "${t}"` : "");
}
function C4(e) {
  return f$(e) ? `"${e}"` : e;
}
function D$(e) {
  return `"${e.replace(M$, N$)}"`;
}
const M$ = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function N$(e) {
  return L$[e.charCodeAt(0)];
}
const L$ = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], Pc = Object.freeze({});
function In(e, t, r = v4) {
  const n = /* @__PURE__ */ new Map();
  for (const m of Object.values(ye))
    n.set(m, F$(t, m));
  let i, a = Array.isArray(e), o = [e], s = -1, l = [], d = e, u, c;
  const h = [], f = [];
  do {
    s++;
    const m = s === o.length, $ = m && l.length !== 0;
    if (m) {
      if (u = f.length === 0 ? void 0 : h[h.length - 1], d = c, c = f.pop(), $)
        if (a) {
          d = d.slice();
          let k = 0;
          for (const [C, E] of l) {
            const N = C - k;
            E === null ? (d.splice(N, 1), k++) : d[N] = E;
          }
        } else {
          d = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(d)
          );
          for (const [k, C] of l)
            d[k] = C;
        }
      s = i.index, o = i.keys, l = i.edits, a = i.inArray, i = i.prev;
    } else if (c) {
      if (u = a ? s : o[s], d = c[u], d == null)
        continue;
      h.push(u);
    }
    let w;
    if (!Array.isArray(d)) {
      var p, g;
      b5(d) || uu(!1, `Invalid AST Node: ${k4(d)}.`);
      const k = m ? (p = n.get(d.kind)) === null || p === void 0 ? void 0 : p.leave : (g = n.get(d.kind)) === null || g === void 0 ? void 0 : g.enter;
      if (w = k?.call(t, d, u, c, h, f), w === Pc)
        break;
      if (w === !1) {
        if (!m) {
          h.pop();
          continue;
        }
      } else if (w !== void 0 && (l.push([u, w]), !m))
        if (b5(w))
          d = w;
        else {
          h.pop();
          continue;
        }
    }
    if (w === void 0 && $ && l.push([u, d]), m)
      h.pop();
    else {
      var v;
      i = {
        inArray: a,
        index: s,
        keys: o,
        edits: l,
        prev: i
      }, a = Array.isArray(d), o = a ? d : (v = r[d.kind]) !== null && v !== void 0 ? v : [], s = -1, l = [], c && f.push(c), c = d;
    }
  } while (i !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : e;
}
function F$(e, t) {
  const r = e[t];
  return typeof r == "object" ? r : typeof r == "function" ? {
    enter: r,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function R$(e) {
  return In(e, j$);
}
const z$ = 80, j$ = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => Se(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = et("(", Se(e.variableDefinitions, ", "), ")"), r = Se(
        [
          e.operation,
          Se([e.name, t]),
          Se(e.directives, " ")
        ],
        " "
      );
      return (r === "query" ? "" : r + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: r, directives: n }) => e + ": " + t + et(" = ", r) + et(" ", Se(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => wn(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: r, directives: n, selectionSet: i }) {
      const a = et("", e, ": ") + t;
      let o = a + et("(", Se(r, ", "), ")");
      return o.length > z$ && (o = a + et(`(
`, cu(Se(r, `
`)), `
)`)), Se([o, Se(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + et(" ", Se(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: r }) => Se(
      [
        "...",
        et("on ", e),
        Se(t, " "),
        r
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: e, typeCondition: t, variableDefinitions: r, directives: n, selectionSet: i }) => (
      // or removed in the future.
      `fragment ${e}${et("(", Se(r, ", "), ")")} on ${t} ${et("", Se(n, " "), " ")}` + i
    )
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? c$(e) : D$(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + Se(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + Se(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + et("(", Se(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: r }) => et("", e, `
`) + Se(["schema", Se(t, " "), wn(r)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: r }) => et("", e, `
`) + Se(["scalar", t, Se(r, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => et("", e, `
`) + Se(
      [
        "type",
        t,
        et("implements ", Se(r, " & ")),
        Se(n, " "),
        wn(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: r, type: n, directives: i }) => et("", e, `
`) + t + (w5(r) ? et(`(
`, cu(Se(r, `
`)), `
)`) : et("(", Se(r, ", "), ")")) + ": " + n + et(" ", Se(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: r, defaultValue: n, directives: i }) => et("", e, `
`) + Se(
      [t + ": " + r, et("= ", n), Se(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => et("", e, `
`) + Se(
      [
        "interface",
        t,
        et("implements ", Se(r, " & ")),
        Se(n, " "),
        wn(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, types: n }) => et("", e, `
`) + Se(
      ["union", t, Se(r, " "), et("= ", Se(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, values: n }) => et("", e, `
`) + Se(["enum", t, Se(r, " "), wn(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: r }) => et("", e, `
`) + Se([t, Se(r, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, fields: n }) => et("", e, `
`) + Se(["input", t, Se(r, " "), wn(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: r, repeatable: n, locations: i }) => et("", e, `
`) + "directive @" + t + (w5(r) ? et(`(
`, cu(Se(r, `
`)), `
)`) : et("(", Se(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + Se(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => Se(
      ["extend schema", Se(e, " "), wn(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => Se(["extend scalar", e, Se(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => Se(
      [
        "extend type",
        e,
        et("implements ", Se(t, " & ")),
        Se(r, " "),
        wn(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => Se(
      [
        "extend interface",
        e,
        et("implements ", Se(t, " & ")),
        Se(r, " "),
        wn(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: r }) => Se(
      [
        "extend union",
        e,
        Se(t, " "),
        et("= ", Se(r, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: r }) => Se(["extend enum", e, Se(t, " "), wn(r)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: r }) => Se(["extend input", e, Se(t, " "), wn(r)], " ")
  }
};
function Se(e, t = "") {
  var r;
  return (r = e?.filter((n) => n).join(t)) !== null && r !== void 0 ? r : "";
}
function wn(e) {
  return et(`{
`, cu(Se(e, `
`)), `
}`);
}
function et(e, t, r = "") {
  return t != null && t !== "" ? e + t + r : "";
}
function cu(e) {
  return et("  ", e.replace(/\n/g, `
  `));
}
function w5(e) {
  var t;
  return (t = e?.some((r) => r.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
function x5(e) {
  return e.kind === ye.FIELD || e.kind === ye.FRAGMENT_SPREAD || e.kind === ye.INLINE_FRAGMENT;
}
function od(e, t) {
  var r = e.directives;
  return !r || !r.length ? !0 : q$(r).every(function(n) {
    var i = n.directive, a = n.ifArgument, o = !1;
    return a.value.kind === "Variable" ? (o = t && t[a.value.name.value], Oe(o !== void 0, 78, i.name.value)) : o = a.value.value, i.name.value === "skip" ? !o : o;
  });
}
function Rl(e, t, r) {
  var n = new Set(e), i = n.size;
  return In(t, {
    Directive: function(a) {
      if (n.delete(a.name.value) && (!r || !n.size))
        return Pc;
    }
  }), r ? !n.size : n.size < i;
}
function V$(e) {
  return e && Rl(["client", "export"], e, !0);
}
function U$(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function q$(e) {
  var t = [];
  return e && e.length && e.forEach(function(r) {
    if (U$(r)) {
      var n = r.arguments, i = r.name.value;
      Oe(n && n.length === 1, 79, i);
      var a = n[0];
      Oe(a.name && a.name.value === "if", 80, i);
      var o = a.value;
      Oe(o && (o.kind === "Variable" || o.kind === "BooleanValue"), 81, i), t.push({ directive: r, ifArgument: a });
    }
  }), t;
}
function B$(e) {
  var t, r, n = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(a) {
    var o = a.name;
    return o.value === "unmask";
  });
  if (!n)
    return "mask";
  var i = (r = n.arguments) === null || r === void 0 ? void 0 : r.find(function(a) {
    var o = a.name;
    return o.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === ye.VARIABLE ? globalThis.__DEV__ !== !1 && Oe.warn(82) : i.value.kind !== ye.STRING ? globalThis.__DEV__ !== !1 && Oe.warn(83) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && Oe.warn(84, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const H$ = () => /* @__PURE__ */ Object.create(null), { forEach: W$, slice: k5 } = Array.prototype, { hasOwnProperty: Q$ } = Object.prototype;
class Si {
  constructor(t = !0, r = H$) {
    this.weakness = t, this.makeData = r;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let r = this;
    return W$.call(t, (n) => r = r.getChildTrie(n)), Q$.call(r, "data") ? r.data : r.data = this.makeData(k5.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let r = this;
    for (let n = 0, i = t.length; r && n < i; ++n) {
      const a = r.mapFor(t[n], !1);
      r = a && a.get(t[n]);
    }
    return r && r.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let r;
    if (t.length) {
      const n = t[0], i = this.mapFor(n, !1), a = i && i.get(n);
      a && (r = a.removeArray(k5.call(t, 1)), !a.data && !a.weak && !(a.strong && a.strong.size) && i.delete(n));
    } else
      r = this.data, delete this.data;
    return r;
  }
  getChildTrie(t) {
    const r = this.mapFor(t, !0);
    let n = r.get(t);
    return n || r.set(t, n = new Si(this.weakness, this.makeData)), n;
  }
  mapFor(t, r) {
    return this.weakness && G$(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function G$(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
var Y$ = _n(function() {
  return navigator.product;
}) == "ReactNative", no = typeof WeakMap == "function" && !(Y$ && !global.HermesInternal), af = typeof WeakSet == "function", S4 = typeof Symbol == "function" && typeof Symbol.for == "function", Dc = S4 && Symbol.asyncIterator;
_n(function() {
  return window.document.createElement;
});
_n(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function Ht(e) {
  return e !== null && typeof e == "object";
}
function K$(e, t) {
  var r = t, n = [];
  e.definitions.forEach(function(a) {
    if (a.kind === "OperationDefinition")
      throw Rr(
        85,
        a.operation,
        a.name ? " named '".concat(a.name.value, "'") : ""
      );
    a.kind === "FragmentDefinition" && n.push(a);
  }), typeof r > "u" && (Oe(n.length === 1, 86, n.length), r = n[0].name.value);
  var i = j(j({}, e), { definitions: Er([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: r
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return i;
}
function ks(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(r) {
    t[r.name.value] = r;
  }), t;
}
function Mc(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var r = e.name.value;
      if (typeof t == "function")
        return t(r);
      var n = t && t[r];
      return Oe(n, 87, r), n || null;
    }
    default:
      return null;
  }
}
function Z$(e) {
  var t = !0;
  return In(e, {
    FragmentSpread: function(r) {
      if (t = !!r.directives && r.directives.some(function(n) {
        return n.name.value === "unmask";
      }), !t)
        return Pc;
    }
  }), t;
}
function X$() {
}
class n2 {
  constructor(t = 1 / 0, r = X$) {
    this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
  }
}
function i2() {
}
const J$ = i2, ew = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, tw = typeof WeakMap < "u" ? WeakMap : Map, rw = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: i2,
    unregister: i2
  };
}, nw = 10024;
class Fu {
  constructor(t = 1 / 0, r = J$) {
    this.max = t, this.dispose = r, this.map = new tw(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let i = 0; i < nw; i++) {
        const a = n.next().value;
        if (!a)
          break;
        this.unfinalizedNodes.delete(a);
        const o = a.key;
        delete a.key, a.keyRef = new ew(o), this.registry.register(o, a, a);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new rw(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const r = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (this.deleteNode(r), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var L0 = /* @__PURE__ */ new WeakSet();
function E4(e) {
  e.size <= (e.max || -1) || L0.has(e) || (L0.add(e), setTimeout(function() {
    e.clean(), L0.delete(e);
  }, 100));
}
var T4 = function(e, t) {
  var r = new Fu(e, t);
  return r.set = function(n, i) {
    var a = Fu.prototype.set.call(this, n, i);
    return E4(this), a;
  }, r;
}, iw = function(e, t) {
  var r = new n2(e, t);
  return r.set = function(n, i) {
    var a = n2.prototype.set.call(this, n, i);
    return E4(this), a;
  }, r;
}, aw = Symbol.for("apollo.cacheSize"), $i = j({}, X1[aw]), ba = {};
function A4(e, t) {
  ba[e] = t;
}
var ow = globalThis.__DEV__ !== !1 ? uw : void 0, sw = globalThis.__DEV__ !== !1 ? cw : void 0, lw = globalThis.__DEV__ !== !1 ? O4 : void 0;
function dw() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var r = t[0], n = t[1];
    return [
      r,
      $i[r] || n
    ];
  }));
}
function uw() {
  var e, t, r, n, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: dw(),
    sizes: j({ print: (e = ba.print) === null || e === void 0 ? void 0 : e.call(ba), parser: (t = ba.parser) === null || t === void 0 ? void 0 : t.call(ba), canonicalStringify: (r = ba.canonicalStringify) === null || r === void 0 ? void 0 : r.call(ba), links: o2(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: P4(this.queryManager.documentTransform)
    } }, (i = (n = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(n))
  };
}
function O4() {
  return {
    cache: {
      fragmentQueryDocuments: Ri(this.getFragmentDoc)
    }
  };
}
function cw() {
  var e = this.config.fragments;
  return j(j({}, O4.apply(this)), { addTypenameDocumentTransform: P4(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: Ri(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: Ri(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: Ri(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: Ri(e?.findFragmentSpreads),
    lookup: Ri(e?.lookup),
    transform: Ri(e?.transform)
  } });
}
function hw(e) {
  return !!e && "dirtyKey" in e;
}
function Ri(e) {
  return hw(e) ? e.size : void 0;
}
function I4(e) {
  return e != null;
}
function P4(e) {
  return a2(e).map(function(t) {
    return { cache: t };
  });
}
function a2(e) {
  return e ? Er(Er([
    Ri(e?.performWork)
  ], a2(e?.left), !0), a2(e?.right), !0).filter(I4) : [];
}
function o2(e) {
  var t;
  return e ? Er(Er([
    (t = e?.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], o2(e?.left), !0), o2(e?.right), !0).filter(I4) : [];
}
var Qi = Object.assign(function(t) {
  return JSON.stringify(t, fw);
}, {
  reset: function() {
    Po = new iw(
      $i.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && A4("canonicalStringify", function() {
  return Po.size;
});
var Po;
Qi.reset();
function fw(e, t) {
  if (t && typeof t == "object") {
    var r = Object.getPrototypeOf(t);
    if (r === Object.prototype || r === null) {
      var n = Object.keys(t);
      if (n.every(pw))
        return t;
      var i = JSON.stringify(n), a = Po.get(i);
      if (!a) {
        n.sort();
        var o = JSON.stringify(n);
        a = Po.get(o) || n, Po.set(i, a), Po.set(o, a);
      }
      var s = Object.create(r);
      return a.forEach(function(l) {
        s[l] = t[l];
      }), s;
    }
  }
  return t;
}
function pw(e, t, r) {
  return t === 0 || r[t - 1] <= e;
}
function Uo(e) {
  return { __ref: String(e) };
}
function yt(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function mw(e) {
  return Ht(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function gw(e) {
  return e.kind === "StringValue";
}
function vw(e) {
  return e.kind === "BooleanValue";
}
function yw(e) {
  return e.kind === "IntValue";
}
function bw(e) {
  return e.kind === "FloatValue";
}
function $w(e) {
  return e.kind === "Variable";
}
function ww(e) {
  return e.kind === "ObjectValue";
}
function xw(e) {
  return e.kind === "ListValue";
}
function kw(e) {
  return e.kind === "EnumValue";
}
function _w(e) {
  return e.kind === "NullValue";
}
function is(e, t, r, n) {
  if (yw(r) || bw(r))
    e[t.value] = Number(r.value);
  else if (vw(r) || gw(r))
    e[t.value] = r.value;
  else if (ww(r)) {
    var i = {};
    r.fields.map(function(o) {
      return is(i, o.name, o.value, n);
    }), e[t.value] = i;
  } else if ($w(r)) {
    var a = (n || {})[r.name.value];
    e[t.value] = a;
  } else if (xw(r))
    e[t.value] = r.values.map(function(o) {
      var s = {};
      return is(s, t, o, n), s[t.value];
    });
  else if (kw(r))
    e[t.value] = r.value;
  else if (_w(r))
    e[t.value] = null;
  else
    throw Rr(96, t.value, r.kind);
}
function Cw(e, t) {
  var r = null;
  e.directives && (r = {}, e.directives.forEach(function(i) {
    r[i.name.value] = {}, i.arguments && i.arguments.forEach(function(a) {
      var o = a.name, s = a.value;
      return is(r[i.name.value], o, s, t);
    });
  }));
  var n = null;
  return e.arguments && e.arguments.length && (n = {}, e.arguments.forEach(function(i) {
    var a = i.name, o = i.value;
    return is(n, a, o, t);
  })), D4(e.name.value, n, r);
}
var Sw = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], qs = Qi, D4 = Object.assign(function(e, t, r) {
  if (t && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var n = r.connection.filter ? r.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(r.connection.key, "(").concat(qs(i), ")");
    } else
      return r.connection.key;
  var a = e;
  if (t) {
    var o = qs(t);
    a += "(".concat(o, ")");
  }
  return r && Object.keys(r).forEach(function(s) {
    Sw.indexOf(s) === -1 && (r[s] && Object.keys(r[s]).length ? a += "@".concat(s, "(").concat(qs(r[s]), ")") : a += "@".concat(s));
  }), a;
}, {
  setStringify: function(e) {
    var t = qs;
    return qs = e, t;
  }
});
function Nc(e, t) {
  if (e.arguments && e.arguments.length) {
    var r = {};
    return e.arguments.forEach(function(n) {
      var i = n.name, a = n.value;
      return is(r, i, a, t);
    }), r;
  }
  return null;
}
function wi(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function s2(e, t, r) {
  for (var n, i = 0, a = t.selections; i < a.length; i++) {
    var o = a[i];
    if (Ki(o)) {
      if (o.name.value === "__typename")
        return e[wi(o)];
    } else n ? n.push(o) : n = [o];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (n)
    for (var s = 0, l = n; s < l.length; s++) {
      var o = l[s], d = s2(e, Mc(o, r).selectionSet, r);
      if (typeof d == "string")
        return d;
    }
}
function Ki(e) {
  return e.kind === "Field";
}
function Ew(e) {
  return e.kind === "InlineFragment";
}
function _s(e) {
  Oe(e && e.kind === "Document", 88);
  var t = e.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw Rr(89, r.kind);
    return r;
  });
  return Oe(t.length <= 1, 90, t.length), e;
}
function Ba(e) {
  return _s(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function pl(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function Cs(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function M4(e) {
  var t = Ba(e);
  return Oe(t && t.operation === "query", 91), t;
}
function N4(e) {
  Oe(e.kind === "Document", 92), Oe(e.definitions.length <= 1, 93);
  var t = e.definitions[0];
  return Oe(t.kind === "FragmentDefinition", 94), t;
}
function sd(e) {
  _s(e);
  for (var t, r = 0, n = e.definitions; r < n.length; r++) {
    var i = n[r];
    if (i.kind === "OperationDefinition") {
      var a = i.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw Rr(95);
}
function of(e) {
  var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
  return r && r.length && r.forEach(function(n) {
    n.defaultValue && is(t, n.variable.name, n.defaultValue);
  }), t;
}
let yr = null;
const _5 = {};
let Tw = 1;
const Aw = () => class {
  constructor() {
    this.id = [
      "slot",
      Tw++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let t = yr; t; t = t.parent)
      if (this.id in t.slots) {
        const r = t.slots[this.id];
        if (r === _5)
          break;
        return t !== yr && (yr.slots[this.id] = r), !0;
      }
    return yr && (yr.slots[this.id] = _5), !1;
  }
  getValue() {
    if (this.hasValue())
      return yr.slots[this.id];
  }
  withValue(t, r, n, i) {
    const a = {
      __proto__: null,
      [this.id]: t
    }, o = yr;
    yr = { parent: o, slots: a };
    try {
      return r.apply(i, n);
    } finally {
      yr = o;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(t) {
    const r = yr;
    return function() {
      const n = yr;
      try {
        return yr = r, t.apply(this, arguments);
      } finally {
        yr = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(t, r, n) {
    if (yr) {
      const i = yr;
      try {
        return yr = null, t.apply(n, r);
      } finally {
        yr = i;
      }
    } else
      return t.apply(n, r);
  }
};
function C5(e) {
  try {
    return e();
  } catch {
  }
}
const F0 = "@wry/context:Slot", Ow = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  C5(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  C5(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), S5 = Ow, Lc = S5[F0] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[F0] || function(e) {
  try {
    Object.defineProperty(S5, F0, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
}(Aw()), { bind: Rae, noContext: zae } = Lc, Fc = new Lc(), { hasOwnProperty: Iw } = Object.prototype, sf = Array.from || function(e) {
  const t = [];
  return e.forEach((r) => t.push(r)), t;
};
function lf(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const zl = [], Pw = 100;
function as(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function L4(e, t) {
  const r = e.length;
  return (
    // Unknown values are not equal to each other.
    r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    r === t.length && // The underlying value or exception must be the same.
    e[r - 1] === t[r - 1]
  );
}
function F4(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function R4(e) {
  return e.slice(0);
}
class Rc {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Rc.count;
  }
  peek() {
    if (this.value.length === 1 && !Zi(this))
      return E5(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return as(!this.recomputing, "already recomputing"), E5(this), Zi(this) ? Dw(this, t) : F4(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, z4(this), lf(this));
  }
  dispose() {
    this.setDirty(), B4(this), df(this, (t, r) => {
      t.setDirty(), H4(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = zl.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (sf(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), zl.push(this.deps), this.deps = null);
  }
}
Rc.count = 0;
function E5(e) {
  const t = Fc.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), Zi(e) ? V4(t, e) : U4(t, e), t;
}
function Dw(e, t) {
  return B4(e), Fc.withValue(e, Mw, [e, t]), Lw(e, t) && Nw(e), F4(e.value);
}
function Mw(e, t) {
  e.recomputing = !0;
  const { normalizeResult: r } = e;
  let n;
  r && e.value.length === 1 && (n = R4(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), r && n && !L4(n, e.value))
      try {
        e.value[0] = r(e.value[0], n[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function Zi(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function Nw(e) {
  e.dirty = !1, !Zi(e) && j4(e);
}
function z4(e) {
  df(e, V4);
}
function j4(e) {
  df(e, U4);
}
function df(e, t) {
  const r = e.parents.size;
  if (r) {
    const n = sf(e.parents);
    for (let i = 0; i < r; ++i)
      t(n[i], e);
  }
}
function V4(e, t) {
  as(e.childValues.has(t)), as(Zi(t));
  const r = !Zi(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = zl.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), r && z4(e);
}
function U4(e, t) {
  as(e.childValues.has(t)), as(!Zi(t));
  const r = e.childValues.get(t);
  r.length === 0 ? e.childValues.set(t, R4(t.value)) : L4(r, t.value) || e.setDirty(), q4(e, t), !Zi(e) && j4(e);
}
function q4(e, t) {
  const r = e.dirtyChildren;
  r && (r.delete(t), r.size === 0 && (zl.length < Pw && zl.push(r), e.dirtyChildren = null));
}
function B4(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, r) => {
    H4(e, r);
  }), e.forgetDeps(), as(e.dirtyChildren === null);
}
function H4(e, t) {
  t.parents.delete(e), e.childValues.delete(t), q4(e, t);
}
function Lw(e, t) {
  if (typeof e.subscribe == "function")
    try {
      lf(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
const Fw = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function W4(e) {
  const t = /* @__PURE__ */ new Map();
  function r(n) {
    const i = Fc.getValue();
    if (i) {
      let a = t.get(n);
      a || t.set(n, a = /* @__PURE__ */ new Set()), i.dependOn(a);
    }
  }
  return r.dirty = function(i, a) {
    const o = t.get(i);
    if (o) {
      const s = a && Iw.call(Fw, a) ? a : "setDirty";
      sf(o).forEach((l) => l[s]()), t.delete(i), lf(o);
    }
  }, r;
}
let T5;
function Rw(...e) {
  return (T5 || (T5 = new Si(typeof WeakMap == "function"))).lookupArray(e);
}
const R0 = /* @__PURE__ */ new Set();
function jl(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: n = Rw, normalizeResult: i, subscribe: a, cache: o = n2 } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof o == "function" ? new o(t, (h) => h.dispose()) : o, l = function() {
    const h = n.apply(null, r ? r.apply(null, arguments) : arguments);
    if (h === void 0)
      return e.apply(null, arguments);
    let f = s.get(h);
    f || (s.set(h, f = new Rc(e)), f.normalizeResult = i, f.subscribe = a, f.forget = () => s.delete(h));
    const p = f.recompute(Array.prototype.slice.call(arguments));
    return s.set(h, f), R0.add(s), Fc.hasValue() || (R0.forEach((g) => g.clean()), R0.clear()), p;
  };
  Object.defineProperty(l, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: t,
    keyArgs: r,
    makeCacheKey: n,
    normalizeResult: i,
    subscribe: a,
    cache: s
  });
  function d(h) {
    const f = h && s.get(h);
    f && f.setDirty();
  }
  l.dirtyKey = d, l.dirty = function() {
    d(n.apply(null, arguments));
  };
  function u(h) {
    const f = h && s.get(h);
    if (f)
      return f.peek();
  }
  l.peekKey = u, l.peek = function() {
    return u(n.apply(null, arguments));
  };
  function c(h) {
    return h ? s.delete(h) : !1;
  }
  return l.forgetKey = c, l.forget = function() {
    return c(n.apply(null, arguments));
  }, l.makeCacheKey = n, l.getKey = r ? function() {
    return n.apply(null, r.apply(null, arguments));
  } : n, Object.freeze(l);
}
function zw(e) {
  return e;
}
var Q4 = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = af ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(zw, { cache: !1 });
    }, e.split = function(t, r, n) {
      return n === void 0 && (n = e.identity()), Object.assign(new e(
        function(i) {
          var a = t(i) ? r : n;
          return a.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: r, right: n });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var r = new Si(no);
        this.performWork = jl(e.prototype.performWork.bind(this), {
          makeCacheKey: function(n) {
            var i = t.getCacheKey(n);
            if (i)
              return Oe(Array.isArray(i), 77), r.lookupArray(i);
          },
          max: $i["documentTransform.cache"],
          cache: Fu
        });
      }
    }, e.prototype.performWork = function(t) {
      return _s(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var r = this.performWork(t);
      return this.resultCache.add(r), r;
    }, e.prototype.concat = function(t) {
      var r = this;
      return Object.assign(new e(
        function(n) {
          return t.transformDocument(r.transformDocument(n));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  }()
), _l, La = Object.assign(function(e) {
  var t = _l.get(e);
  return t || (t = R$(e), _l.set(e, t)), t;
}, {
  reset: function() {
    _l = new T4(
      $i.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
La.reset();
globalThis.__DEV__ !== !1 && A4("print", function() {
  return _l ? _l.size : 0;
});
var Wt = Array.isArray;
function Xn(e) {
  return Array.isArray(e) && e.length > 0;
}
var A5 = {
  kind: ye.FIELD,
  name: {
    kind: ye.NAME,
    value: "__typename"
  }
};
function G4(e, t) {
  return !e || e.selectionSet.selections.every(function(r) {
    return r.kind === ye.FRAGMENT_SPREAD && G4(t[r.name.value], t);
  });
}
function jw(e) {
  return G4(Ba(e) || N4(e), ks(Cs(e))) ? null : e;
}
function Vw(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    n && (n.name ? t.set(n.name, n) : n.test && r.set(n.test, n));
  }), function(n) {
    var i = t.get(n.name.value);
    return !i && r.size && r.forEach(function(a, o) {
      o(n) && (i = a);
    }), i;
  };
}
function O5(e) {
  var t = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = e);
    var i = t.get(n);
    return i || t.set(n, i = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), i;
  };
}
function Y4(e, t) {
  _s(t);
  for (var r = O5(""), n = O5(""), i = function(m) {
    for (var $ = 0, w = void 0; $ < m.length && (w = m[$]); ++$)
      if (!Wt(w)) {
        if (w.kind === ye.OPERATION_DEFINITION)
          return r(w.name && w.name.value);
        if (w.kind === ye.FRAGMENT_DEFINITION)
          return n(w.name.value);
      }
    return globalThis.__DEV__ !== !1 && Oe.error(97), null;
  }, a = 0, o = t.definitions.length - 1; o >= 0; --o)
    t.definitions[o].kind === ye.OPERATION_DEFINITION && ++a;
  var s = Vw(e), l = function(m) {
    return Xn(m) && m.map(s).some(function($) {
      return $ && $.remove;
    });
  }, d = /* @__PURE__ */ new Map(), u = !1, c = {
    enter: function(m) {
      if (l(m.directives))
        return u = !0, null;
    }
  }, h = In(t, {
    // These two AST node types share the same implementation, defined above.
    Field: c,
    InlineFragment: c,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(m, $, w, k, C) {
        var E = i(C);
        E && E.variables.add(m.name.value);
      }
    },
    FragmentSpread: {
      enter: function(m, $, w, k, C) {
        if (l(m.directives))
          return u = !0, null;
        var E = i(C);
        E && E.fragmentSpreads.add(m.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(m, $, w, k) {
        d.set(JSON.stringify(k), m);
      },
      leave: function(m, $, w, k) {
        var C = d.get(JSON.stringify(k));
        if (m === C)
          return m;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          a > 0 && m.selectionSet.selections.every(function(E) {
            return E.kind === ye.FIELD && E.name.value === "__typename";
          })
        )
          return n(m.name.value).removed = !0, u = !0, null;
      }
    },
    Directive: {
      leave: function(m) {
        if (s(m))
          return u = !0, null;
      }
    }
  });
  if (!u)
    return t;
  var f = function(m) {
    return m.transitiveVars || (m.transitiveVars = new Set(m.variables), m.removed || m.fragmentSpreads.forEach(function($) {
      f(n($)).transitiveVars.forEach(function(w) {
        m.transitiveVars.add(w);
      });
    })), m;
  }, p = /* @__PURE__ */ new Set();
  h.definitions.forEach(function(m) {
    m.kind === ye.OPERATION_DEFINITION ? f(r(m.name && m.name.value)).fragmentSpreads.forEach(function($) {
      p.add($);
    }) : m.kind === ye.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    a === 0 && !n(m.name.value).removed && p.add(m.name.value);
  }), p.forEach(function(m) {
    f(n(m)).fragmentSpreads.forEach(function($) {
      p.add($);
    });
  });
  var g = function(m) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!p.has(m) || n(m).removed);
  }, v = {
    enter: function(m) {
      if (g(m.name.value))
        return null;
    }
  };
  return jw(In(h, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: v,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: v,
    OperationDefinition: {
      leave: function(m) {
        if (m.variableDefinitions) {
          var $ = f(
            // If an operation is anonymous, we use the empty string as its key.
            r(m.name && m.name.value)
          ).transitiveVars;
          if ($.size < m.variableDefinitions.length)
            return j(j({}, m), { variableDefinitions: m.variableDefinitions.filter(function(w) {
              return $.has(w.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var uf = Object.assign(function(e) {
  return In(e, {
    SelectionSet: {
      enter: function(t, r, n) {
        if (!(n && n.kind === ye.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var a = i.some(function(s) {
              return Ki(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var o = n;
              if (!(Ki(o) && o.directives && o.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return j(j({}, t), { selections: Er(Er([], i, !0), [A5], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === A5;
  }
});
function Uw(e) {
  var t = sd(e), r = t.operation;
  if (r === "query")
    return e;
  var n = In(e, {
    OperationDefinition: {
      enter: function(i) {
        return j(j({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function K4(e) {
  _s(e);
  var t = Y4([
    {
      test: function(r) {
        return r.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function qw(e) {
  return _s(e), In(e, {
    FragmentSpread: function(t) {
      var r;
      if (!(!((r = t.directives) === null || r === void 0) && r.some(function(n) {
        return n.name.value === "unmask";
      })))
        return j(j({}, t), { directives: Er(Er([], t.directives || [], !0), [
          {
            kind: ye.DIRECTIVE,
            name: { kind: ye.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var Bw = Object.prototype.hasOwnProperty;
function I5() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return zc(e);
}
function zc(e) {
  var t = e[0] || {}, r = e.length;
  if (r > 1)
    for (var n = new Xi(), i = 1; i < r; ++i)
      t = n.merge(t, e[i]);
  return t;
}
var Hw = function(e, t, r) {
  return this.merge(e[r], t[r]);
}, Xi = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = Hw), this.reconciler = t, this.isObject = Ht, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, r) {
      for (var n = this, i = [], a = 2; a < arguments.length; a++)
        i[a - 2] = arguments[a];
      return Ht(r) && Ht(t) ? (Object.keys(r).forEach(function(o) {
        if (Bw.call(t, o)) {
          var s = t[o];
          if (r[o] !== s) {
            var l = n.reconciler.apply(n, Er([
              t,
              r,
              o
            ], i, !1));
            l !== s && (t = n.shallowCopyForMerge(t), t[o] = l);
          }
        } else
          t = n.shallowCopyForMerge(t), t[o] = r[o];
      }), t) : r;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return Ht(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = j({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  }()
);
function Ww(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Qw(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Qw(e, t) {
  if (e) {
    if (typeof e == "string") return P5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return P5(e, t);
  }
}
function P5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function D5(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function cf(e, t, r) {
  return t && D5(e.prototype, t), r && D5(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var hf = function() {
  return typeof Symbol == "function";
}, ff = function(e) {
  return hf() && !!Symbol[e];
}, pf = function(e) {
  return ff(e) ? Symbol[e] : "@@" + e;
};
hf() && !ff("observable") && (Symbol.observable = Symbol("observable"));
var Gw = pf("iterator"), l2 = pf("observable"), Z4 = pf("species");
function Ru(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    return r;
  }
}
function Bs(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[Z4], t === null && (t = void 0)), t !== void 0 ? t : Ot;
}
function Yw(e) {
  return e instanceof Ot;
}
function os(e) {
  os.log ? os.log(e) : setTimeout(function() {
    throw e;
  });
}
function hu(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      os(t);
    }
  });
}
function X4(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = Ru(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (n) {
      os(n);
    }
}
function d2(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function Kw(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (J4(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function J4(e, t, r) {
  e._state = "running";
  var n = e._observer;
  try {
    var i = Ru(n, t);
    switch (t) {
      case "next":
        i && i.call(n, r);
        break;
      case "error":
        if (d2(e), i) i.call(n, r);
        else throw r;
        break;
      case "complete":
        d2(e), i && i.call(n);
        break;
    }
  } catch (a) {
    os(a);
  }
  e._state === "closed" ? X4(e) : e._state === "running" && (e._state = "ready");
}
function z0(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], hu(function() {
        return Kw(e);
      });
      return;
    }
    J4(e, t, r);
  }
}
var Zw = /* @__PURE__ */ function() {
  function e(r, n) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var i = new Xw(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (a) {
      i.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (d2(this), X4(this));
  }, cf(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
}(), Xw = /* @__PURE__ */ function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(n) {
    z0(this._subscription, "next", n);
  }, t.error = function(n) {
    z0(this._subscription, "error", n);
  }, t.complete = function() {
    z0(this._subscription, "complete");
  }, cf(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
}(), Ot = /* @__PURE__ */ function() {
  function e(r) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new Zw(n, this._subscriber);
  }, t.forEach = function(n) {
    var i = this;
    return new Promise(function(a, o) {
      if (typeof n != "function") {
        o(new TypeError(n + " is not a function"));
        return;
      }
      function s() {
        l.unsubscribe(), a();
      }
      var l = i.subscribe({
        next: function(d) {
          try {
            n(d, s);
          } catch (u) {
            o(u), l.unsubscribe();
          }
        },
        error: o,
        complete: a
      });
    });
  }, t.map = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Bs(this);
    return new a(function(o) {
      return i.subscribe({
        next: function(s) {
          try {
            s = n(s);
          } catch (l) {
            return o.error(l);
          }
          o.next(s);
        },
        error: function(s) {
          o.error(s);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Bs(this);
    return new a(function(o) {
      return i.subscribe({
        next: function(s) {
          try {
            if (!n(s)) return;
          } catch (l) {
            return o.error(l);
          }
          o.next(s);
        },
        error: function(s) {
          o.error(s);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Bs(this), o = arguments.length > 1, s = !1, l = arguments[1], d = l;
    return new a(function(u) {
      return i.subscribe({
        next: function(c) {
          var h = !s;
          if (s = !0, !h || o)
            try {
              d = n(d, c);
            } catch (f) {
              return u.error(f);
            }
          else
            d = c;
        },
        error: function(c) {
          u.error(c);
        },
        complete: function() {
          if (!s && !o) return u.error(new TypeError("Cannot reduce an empty sequence"));
          u.next(d), u.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    var s = Bs(this);
    return new s(function(l) {
      var d, u = 0;
      function c(h) {
        d = h.subscribe({
          next: function(f) {
            l.next(f);
          },
          error: function(f) {
            l.error(f);
          },
          complete: function() {
            u === a.length ? (d = void 0, l.complete()) : c(s.from(a[u++]));
          }
        });
      }
      return c(n), function() {
        d && (d.unsubscribe(), d = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Bs(this);
    return new a(function(o) {
      var s = [], l = i.subscribe({
        next: function(u) {
          if (n)
            try {
              u = n(u);
            } catch (h) {
              return o.error(h);
            }
          var c = a.from(u).subscribe({
            next: function(h) {
              o.next(h);
            },
            error: function(h) {
              o.error(h);
            },
            complete: function() {
              var h = s.indexOf(c);
              h >= 0 && s.splice(h, 1), d();
            }
          });
          s.push(c);
        },
        error: function(u) {
          o.error(u);
        },
        complete: function() {
          d();
        }
      });
      function d() {
        l.closed && s.length === 0 && o.complete();
      }
      return function() {
        s.forEach(function(u) {
          return u.unsubscribe();
        }), l.unsubscribe();
      };
    });
  }, t[l2] = function() {
    return this;
  }, e.from = function(n) {
    var i = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var a = Ru(n, l2);
    if (a) {
      var o = a.call(n);
      if (Object(o) !== o) throw new TypeError(o + " is not an object");
      return Yw(o) && o.constructor === i ? o : new i(function(s) {
        return o.subscribe(s);
      });
    }
    if (ff("iterator") && (a = Ru(n, Gw), a))
      return new i(function(s) {
        hu(function() {
          if (!s.closed) {
            for (var l = Ww(a.call(n)), d; !(d = l()).done; ) {
              var u = d.value;
              if (s.next(u), s.closed) return;
            }
            s.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new i(function(s) {
        hu(function() {
          if (!s.closed) {
            for (var l = 0; l < n.length; ++l)
              if (s.next(n[l]), s.closed) return;
            s.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var o = typeof this == "function" ? this : e;
    return new o(function(s) {
      hu(function() {
        if (!s.closed) {
          for (var l = 0; l < i.length; ++l)
            if (s.next(i[l]), s.closed) return;
          s.complete();
        }
      });
    });
  }, cf(e, null, [{
    key: Z4,
    get: function() {
      return this;
    }
  }]), e;
}();
hf() && Object.defineProperty(Ot, Symbol("extensions"), {
  value: {
    symbol: l2,
    hostReportError: os
  },
  configurable: !0
});
function Jw(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var $o;
typeof self < "u" ? $o = self : typeof window < "u" ? $o = window : typeof global < "u" ? $o = global : typeof module < "u" ? $o = module : $o = Function("return this")();
Jw($o);
var M5 = Ot.prototype, N5 = "@@observable";
M5[N5] || (M5[N5] = function() {
  return this;
});
function ex(e) {
  return e.catch(function() {
  }), e;
}
var tx = Object.prototype.toString;
function e9(e) {
  return u2(e);
}
function u2(e, t) {
  switch (tx.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = e.slice(0);
      return t.set(e, r), r.forEach(function(i, a) {
        r[a] = u2(i, t);
      }), r;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = Object.create(Object.getPrototypeOf(e));
      return t.set(e, n), Object.keys(e).forEach(function(i) {
        n[i] = u2(e[i], t);
      }), n;
    }
    default:
      return e;
  }
}
function rx(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(r) {
    Ht(r) && nx(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
      Ht(r[n]) && t.add(r[n]);
    });
  }), e;
}
function nx(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function zu(e) {
  return globalThis.__DEV__ !== !1 && rx(e), e;
}
function Cl(e, t, r) {
  var n = [];
  e.forEach(function(i) {
    return i[t] && n.push(i);
  }), n.forEach(function(i) {
    return i[t](r);
  });
}
function j0(e, t, r) {
  return new Ot(function(n) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(d) {
          return d(l());
        });
      }
    };
    function a(l, d) {
      return function(u) {
        if (l) {
          var c = function() {
            return n.closed ? (
              /* will be swallowed */
              0
            ) : l(u);
          };
          i = i.then(c, c).then(function(h) {
            return n.next(h);
          }, function(h) {
            return n.error(h);
          });
        } else
          n[d](u);
      };
    }
    var o = {
      next: a(t, "next"),
      error: a(r, "error"),
      complete: function() {
        i.then(function() {
          return n.complete();
        });
      }
    }, s = e.subscribe(o);
    return function() {
      return s.unsubscribe();
    };
  });
}
function t9(e) {
  function t(r) {
    Object.defineProperty(e, r, { value: Ot });
  }
  return S4 && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function L5(e) {
  return e && typeof e.then == "function";
}
var wo = (
  /** @class */
  function(e) {
    ri(t, e);
    function t(r) {
      var n = e.call(this, function(i) {
        return n.addObserver(i), function() {
          return n.removeObserver(i);
        };
      }) || this;
      return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, a) {
        n.resolve = i, n.reject = a;
      }), n.handlers = {
        next: function(i) {
          n.sub !== null && (n.latest = ["next", i], n.notify("next", i), Cl(n.observers, "next", i));
        },
        error: function(i) {
          var a = n.sub;
          a !== null && (a && setTimeout(function() {
            return a.unsubscribe();
          }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), Cl(n.observers, "error", i));
        },
        complete: function() {
          var i = n, a = i.sub, o = i.sources, s = o === void 0 ? [] : o;
          if (a !== null) {
            var l = s.shift();
            l ? L5(l) ? l.then(function(d) {
              return n.sub = d.subscribe(n.handlers);
            }, n.handlers.error) : n.sub = l.subscribe(n.handlers) : (a && setTimeout(function() {
              return a.unsubscribe();
            }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), Cl(n.observers, "complete"));
          }
        }
      }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
        n.reject(i), n.sources = [], n.handlers.error(i);
      }, n.promise.catch(function(i) {
      }), typeof r == "function" && (r = [new Ot(r)]), L5(r) ? r.then(function(i) {
        return n.start(i);
      }, n.handlers.error) : n.start(r), n;
    }
    return t.prototype.start = function(r) {
      this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(r) {
      if (this.latest) {
        var n = this.latest[0], i = r[n];
        i && i.call(r, this.latest[1]), this.sub === null && n === "next" && r.complete && r.complete();
      }
    }, t.prototype.addObserver = function(r) {
      this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
    }, t.prototype.removeObserver = function(r) {
      this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(r, n) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(a) {
        return a(r, n);
      }));
    }, t.prototype.beforeNext = function(r) {
      var n = !1;
      this.nextResultListeners.add(function(i, a) {
        n || (n = !0, r(i, a));
      });
    }, t;
  }(Ot)
);
t9(wo);
function qo(e) {
  return "incremental" in e;
}
function ix(e) {
  return "hasNext" in e && "data" in e;
}
function ax(e) {
  return qo(e) || ix(e);
}
function ox(e) {
  return Ht(e) && "payload" in e;
}
function r9(e, t) {
  var r = e, n = new Xi();
  return qo(t) && Xn(t.incremental) && t.incremental.forEach(function(i) {
    for (var a = i.data, o = i.path, s = o.length - 1; s >= 0; --s) {
      var l = o[s], d = !isNaN(+l), u = d ? [] : {};
      u[l] = a, a = u;
    }
    r = n.merge(r, a);
  }), r;
}
function fu(e) {
  var t = c2(e);
  return Xn(t);
}
function c2(e) {
  var t = Xn(e.errors) ? e.errors.slice(0) : [];
  return qo(e) && Xn(e.incremental) && e.incremental.forEach(function(r) {
    r.errors && t.push.apply(t, r.errors);
  }), t;
}
function ss() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var a = n[i];
      a !== void 0 && (r[i] = a);
    });
  }), r;
}
function V0(e, t) {
  return ss(e, t, t.variables && {
    variables: ss(j(j({}, e && e.variables), t.variables))
  });
}
function U0(e) {
  return new Ot(function(t) {
    t.error(e);
  });
}
var n9 = function(e, t, r) {
  var n = new Error(r);
  throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
};
function sx(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, n = Object.keys(e); r < n.length; r++) {
    var i = n[r];
    if (t.indexOf(i) < 0)
      throw Rr(46, i);
  }
  return e;
}
function lx(e, t) {
  var r = j({}, e), n = function(a) {
    typeof a == "function" ? r = j(j({}, r), a(r)) : r = j(j({}, r), a);
  }, i = function() {
    return j({}, r);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function dx(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? pl(t.query) || void 0 : ""), t;
}
function ux(e, t) {
  var r = j({}, e), n = new Set(Object.keys(e));
  return In(t, {
    Variable: function(i, a, o) {
      o && o.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete r[i];
  }), r;
}
function F5(e, t) {
  return t ? t(e) : Ot.of();
}
function Hs(e) {
  return typeof e == "function" ? new Ss(e) : e;
}
function Nd(e) {
  return e.request.length <= 1;
}
var Ss = (
  /** @class */
  function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return Ot.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(Hs).reduce(function(r, n) {
        return r.concat(n);
      });
    }, e.split = function(t, r, n) {
      var i = Hs(r), a = Hs(n || new e(F5)), o;
      return Nd(i) && Nd(a) ? o = new e(function(s) {
        return t(s) ? i.request(s) || Ot.of() : a.request(s) || Ot.of();
      }) : o = new e(function(s, l) {
        return t(s) ? i.request(s, l) || Ot.of() : a.request(s, l) || Ot.of();
      }), Object.assign(o, { left: i, right: a });
    }, e.execute = function(t, r) {
      return t.request(lx(r.context, dx(sx(r)))) || Ot.of();
    }, e.concat = function(t, r) {
      var n = Hs(t);
      if (Nd(n))
        return globalThis.__DEV__ !== !1 && Oe.warn(38, n), n;
      var i = Hs(r), a;
      return Nd(i) ? a = new e(function(o) {
        return n.request(o, function(s) {
          return i.request(s) || Ot.of();
        }) || Ot.of();
      }) : a = new e(function(o, s) {
        return n.request(o, function(l) {
          return i.request(l, s) || Ot.of();
        }) || Ot.of();
      }), Object.assign(a, { left: n, right: i });
    }, e.prototype.split = function(t, r, n) {
      return this.concat(e.split(t, r, n || new e(F5)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, r) {
      throw Rr(39);
    }, e.prototype.onError = function(t, r) {
      if (r && r.error)
        return r.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return this.onError = t, this;
    }, e;
  }()
), h2 = Ss.execute;
function cx(e) {
  var t, r = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return r.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function hx(e) {
  var t = null, r = null, n = !1, i = [], a = [];
  function o(c) {
    if (!r) {
      if (a.length) {
        var h = a.shift();
        if (Array.isArray(h) && h[0])
          return h[0]({ value: c, done: !1 });
      }
      i.push(c);
    }
  }
  function s(c) {
    r = c;
    var h = a.slice();
    h.forEach(function(f) {
      f[1](c);
    }), !t || t();
  }
  function l() {
    n = !0;
    var c = a.slice();
    c.forEach(function(h) {
      h[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", o), e.removeListener("error", s), e.removeListener("end", l), e.removeListener("finish", l), e.removeListener("close", l);
  }, e.on("data", o), e.on("error", s), e.on("end", l), e.on("finish", l), e.on("close", l);
  function d() {
    return new Promise(function(c, h) {
      if (r)
        return h(r);
      if (i.length)
        return c({ value: i.shift(), done: !1 });
      if (n)
        return c({ value: void 0, done: !0 });
      a.push([c, h]);
    });
  }
  var u = {
    next: function() {
      return d();
    }
  };
  return Dc && (u[Symbol.asyncIterator] = function() {
    return this;
  }), u;
}
function fx(e) {
  var t = !1, r = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(n, i) {
        e.then(function(a) {
          n({ value: a, done: !1 });
        }).catch(i);
      }));
    }
  };
  return Dc && (r[Symbol.asyncIterator] = function() {
    return this;
  }), r;
}
function R5(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return Dc && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function px(e) {
  return !!e.body;
}
function mx(e) {
  return !!e.getReader;
}
function gx(e) {
  return !!(Dc && e[Symbol.asyncIterator]);
}
function vx(e) {
  return !!e.stream;
}
function yx(e) {
  return !!e.arrayBuffer;
}
function bx(e) {
  return !!e.pipe;
}
function $x(e) {
  var t = e;
  if (px(e) && (t = e.body), gx(t))
    return cx(t);
  if (mx(t))
    return R5(t.getReader());
  if (vx(t))
    return R5(t.stream().getReader());
  if (yx(t))
    return fx(t.arrayBuffer());
  if (bx(t))
    return hx(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var mf = Symbol();
function wx(e) {
  return e.extensions ? Array.isArray(e.extensions[mf]) : !1;
}
function i9(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var xx = function(e) {
  var t = Er(Er(Er([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return Ht(r) && r.message || "Error message not found.";
  }).join(`
`);
}, $a = (
  /** @class */
  function(e) {
    ri(t, e);
    function t(r) {
      var n = r.graphQLErrors, i = r.protocolErrors, a = r.clientErrors, o = r.networkError, s = r.errorMessage, l = r.extraInfo, d = e.call(this, s) || this;
      return d.name = "ApolloError", d.graphQLErrors = n || [], d.protocolErrors = i || [], d.clientErrors = a || [], d.networkError = o || null, d.message = s || xx(d), d.extraInfo = l, d.cause = Er(Er(Er([
        o
      ], n || [], !0), i || [], !0), a || [], !0).find(function(u) {
        return !!u;
      }) || null, d.__proto__ = t.prototype, d;
    }
    return t;
  }(Error)
), z5 = Object.prototype.hasOwnProperty;
function kx(e, t) {
  return Ve(this, void 0, void 0, function() {
    var r, n, i, a, o, s, l, d, u, c, h, f, p, g, v, m, $, w, k, C, E, N, M, V;
    return Fi(this, function(q) {
      switch (q.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          r = new TextDecoder("utf-8"), n = (V = e.headers) === null || V === void 0 ? void 0 : V.get("content-type"), i = "boundary=", a = n?.includes(i) ? n?.substring(n?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", o = `\r
--`.concat(a), s = "", l = $x(e), d = !0, q.label = 1;
        case 1:
          return d ? [4, l.next()] : [3, 3];
        case 2:
          for (u = q.sent(), c = u.value, h = u.done, f = typeof c == "string" ? c : r.decode(c), p = s.length - o.length + 1, d = !h, s += f, g = s.indexOf(o, p); g > -1; ) {
            if (v = void 0, N = [
              s.slice(0, g),
              s.slice(g + o.length)
            ], v = N[0], s = N[1], m = v.indexOf(`\r
\r
`), $ = _x(v.slice(0, m)), w = $["content-type"], w && w.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (k = v.slice(m), k) {
              if (C = a9(e, k), Object.keys(C).length > 1 || "data" in C || "incremental" in C || "errors" in C || "payload" in C)
                if (ox(C)) {
                  if (E = {}, "payload" in C) {
                    if (Object.keys(C).length === 1 && C.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    E = j({}, C.payload);
                  }
                  "errors" in C && (E = j(j({}, E), { extensions: j(j({}, "extensions" in E ? E.extensions : null), (M = {}, M[mf] = C.errors, M)) })), t(E);
                } else
                  t(C);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(C).length === 1 && "hasNext" in C && !C.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            g = s.indexOf(o);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function _x(e) {
  var t = {};
  return e.split(`
`).forEach(function(r) {
    var n = r.indexOf(":");
    if (n > -1) {
      var i = r.slice(0, n).trim().toLowerCase(), a = r.slice(n + 1).trim();
      t[i] = a;
    }
  }), t;
}
function a9(e, t) {
  if (e.status >= 300) {
    var r = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    n9(e, r(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = e, n.statusCode = e.status, n.bodyText = t, n;
  }
}
function Cx(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function Sx(e) {
  return function(t) {
    return t.text().then(function(r) {
      return a9(t, r);
    }).then(function(r) {
      return !Array.isArray(r) && !z5.call(r, "data") && !z5.call(r, "errors") && n9(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(n) {
        return n.operationName;
      }) : e.operationName, "'.")), r;
    });
  };
}
var f2 = function(e, t) {
  var r;
  try {
    r = JSON.stringify(e);
  } catch (i) {
    var n = Rr(42, t, i.message);
    throw n.parseError = i, n;
  }
  return r;
}, Ex = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, Tx = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, Ax = {
  method: "POST"
}, Ox = {
  http: Ex,
  headers: Tx,
  options: Ax
}, Ix = function(e, t) {
  return t(e);
};
function Px(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var i = {}, a = {};
  r.forEach(function(c) {
    i = j(j(j({}, i), c.options), { headers: j(j({}, i.headers), c.headers) }), c.credentials && (i.credentials = c.credentials), a = j(j({}, a), c.http);
  }), i.headers && (i.headers = Dx(i.headers, a.preserveHeaderCase));
  var o = e.operationName, s = e.extensions, l = e.variables, d = e.query, u = { operationName: o, variables: l };
  return a.includeExtensions && (u.extensions = s), a.includeQuery && (u.query = t(d, La)), {
    options: i,
    body: u
  };
}
function Dx(e, t) {
  if (!t) {
    var r = {};
    return Object.keys(Object(e)).forEach(function(a) {
      r[a.toLowerCase()] = e[a];
    }), r;
  }
  var n = {};
  Object.keys(Object(e)).forEach(function(a) {
    n[a.toLowerCase()] = {
      originalName: a,
      value: e[a]
    };
  });
  var i = {};
  return Object.keys(n).forEach(function(a) {
    i[n[a].originalName] = n[a].value;
  }), i;
}
var Mx = function(e) {
  if (!e && typeof fetch > "u")
    throw Rr(40);
}, Nx = function(e, t) {
  var r = e.getContext(), n = r.uri;
  return n || (typeof t == "function" ? t(e) : t || "/graphql");
};
function Lx(e, t) {
  var r = [], n = function(c, h) {
    r.push("".concat(c, "=").concat(encodeURIComponent(h)));
  };
  if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = f2(t.variables, "Variables map");
    } catch (c) {
      return { parseError: c };
    }
    n("variables", i);
  }
  if (t.extensions) {
    var a = void 0;
    try {
      a = f2(t.extensions, "Extensions map");
    } catch (c) {
      return { parseError: c };
    }
    n("extensions", a);
  }
  var o = "", s = e, l = e.indexOf("#");
  l !== -1 && (o = e.substr(l), s = e.substr(0, l));
  var d = s.indexOf("?") === -1 ? "?" : "&", u = s + d + r.join("&") + o;
  return { newURI: u };
}
var j5 = _n(function() {
  return fetch;
}), Fx = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, r = t === void 0 ? "/graphql" : t, n = e.fetch, i = e.print, a = i === void 0 ? Ix : i, o = e.includeExtensions, s = e.preserveHeaderCase, l = e.useGETForQueries, d = e.includeUnusedVariables, u = d === void 0 ? !1 : d, c = An(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && Mx(n || j5);
  var h = {
    http: { includeExtensions: o, preserveHeaderCase: s },
    options: c.fetchOptions,
    credentials: c.credentials,
    headers: c.headers
  };
  return new Ss(function(f) {
    var p = Nx(f, r), g = f.getContext(), v = {};
    if (g.clientAwareness) {
      var m = g.clientAwareness, $ = m.name, w = m.version;
      $ && (v["apollographql-client-name"] = $), w && (v["apollographql-client-version"] = w);
    }
    var k = j(j({}, v), g.headers), C = {
      http: g.http,
      options: g.fetchOptions,
      credentials: g.credentials,
      headers: k
    };
    if (Rl(["client"], f.query)) {
      var E = K4(f.query);
      if (!E)
        return U0(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      f.query = E;
    }
    var N = Px(f, a, Ox, h, C), M = N.options, V = N.body;
    V.variables && !u && (V.variables = ux(V.variables, f.query));
    var q;
    !M.signal && typeof AbortController < "u" && (q = new AbortController(), M.signal = q.signal);
    var I = function(R) {
      return R.kind === "OperationDefinition" && R.operation === "mutation";
    }, P = function(R) {
      return R.kind === "OperationDefinition" && R.operation === "subscription";
    }, z = P(sd(f.query)), G = Rl(["defer"], f.query);
    if (l && !f.query.definitions.some(I) && (M.method = "GET"), G || z) {
      M.headers = M.headers || {};
      var se = "multipart/mixed;";
      z && G && globalThis.__DEV__ !== !1 && Oe.warn(41), z ? se += "boundary=graphql;subscriptionSpec=1.0,application/json" : G && (se += "deferSpec=20220824,application/json"), M.headers.accept = se;
    }
    if (M.method === "GET") {
      var ue = Lx(p, V), de = ue.newURI, D = ue.parseError;
      if (D)
        return U0(D);
      p = de;
    } else
      try {
        M.body = f2(V, "Payload");
      } catch (R) {
        return U0(R);
      }
    return new Ot(function(R) {
      var Q = n || _n(function() {
        return fetch;
      }) || j5, Z = R.next.bind(R);
      return Q(p, M).then(function(F) {
        var oe;
        f.setContext({ response: F });
        var pe = (oe = F.headers) === null || oe === void 0 ? void 0 : oe.get("content-type");
        return pe !== null && /^multipart\/mixed/i.test(pe) ? kx(F, Z) : Sx(f)(F).then(Z);
      }).then(function() {
        q = void 0, R.complete();
      }).catch(function(F) {
        q = void 0, Cx(F, R);
      }), function() {
        q && q.abort();
      };
    });
  });
}, o9 = (
  /** @class */
  function(e) {
    ri(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, Fx(r).request) || this;
      return n.options = r, n;
    }
    return t;
  }(Ss)
);
const { toString: V5, hasOwnProperty: Rx } = Object.prototype, U5 = Function.prototype.toString, p2 = /* @__PURE__ */ new Map();
function Dt(e, t) {
  try {
    return m2(e, t);
  } finally {
    p2.clear();
  }
}
function m2(e, t) {
  if (e === t)
    return !0;
  const r = V5.call(e), n = V5.call(t);
  if (r !== n)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    case "[object Object]": {
      if (B5(e, t))
        return !0;
      const i = q5(e), a = q5(t), o = i.length;
      if (o !== a.length)
        return !1;
      for (let s = 0; s < o; ++s)
        if (!Rx.call(t, i[s]))
          return !1;
      for (let s = 0; s < o; ++s) {
        const l = i[s];
        if (!m2(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (B5(e, t))
        return !0;
      const i = e.entries(), a = r === "[object Map]";
      for (; ; ) {
        const o = i.next();
        if (o.done)
          break;
        const [s, l] = o.value;
        if (!t.has(s) || a && !m2(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = U5.call(e);
      return i !== U5.call(t) ? !1 : !Vx(i, jx);
    }
  }
  return !1;
}
function q5(e) {
  return Object.keys(e).filter(zx, e);
}
function zx(e) {
  return this[e] !== void 0;
}
const jx = "{ [native code] }";
function Vx(e, t) {
  const r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function B5(e, t) {
  let r = p2.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    p2.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
function s9(e, t, r, n) {
  var i = t.data, a = An(t, ["data"]), o = r.data, s = An(r, ["data"]);
  return Dt(a, s) && pu(sd(e).selectionSet, i, o, {
    fragmentMap: ks(Cs(e)),
    variables: n
  });
}
function pu(e, t, r, n) {
  if (t === r)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(a) {
    if (i.has(a) || (i.add(a), !od(a, n.variables)) || H5(a))
      return !0;
    if (Ki(a)) {
      var o = wi(a), s = t && t[o], l = r && r[o], d = a.selectionSet;
      if (!d)
        return Dt(s, l);
      var u = Array.isArray(s), c = Array.isArray(l);
      if (u !== c)
        return !1;
      if (u && c) {
        var h = s.length;
        if (l.length !== h)
          return !1;
        for (var f = 0; f < h; ++f)
          if (!pu(d, s[f], l[f], n))
            return !1;
        return !0;
      }
      return pu(d, s, l, n);
    } else {
      var p = Mc(a, n.fragmentMap);
      if (p)
        return H5(p) ? !0 : pu(
          p.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          r,
          n
        );
    }
  });
}
function H5(e) {
  return !!e.directives && e.directives.some(Ux);
}
function Ux(e) {
  return e.name.value === "nonreactive";
}
var l9 = no ? WeakMap : Map, d9 = af ? WeakSet : Set, gf = new Lc(), W5 = !1;
function u9() {
  W5 || (W5 = !0, globalThis.__DEV__ !== !1 && Oe.warn(52));
}
function c9(e, t, r) {
  return gf.withValue(!0, function() {
    var n = ml(e, t, r, !1);
    return Object.isFrozen(e) && zu(n), n;
  });
}
function qx(e, t) {
  if (t.has(e))
    return t.get(e);
  var r = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, r), r;
}
function ml(e, t, r, n, i) {
  var a, o = r.knownChanged, s = qx(e, r.mutableTargets);
  if (Array.isArray(e)) {
    for (var l = 0, d = Array.from(e.entries()); l < d.length; l++) {
      var u = d[l], c = u[0], h = u[1];
      if (h === null) {
        s[c] = null;
        continue;
      }
      var f = ml(h, t, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(c, "]") : void 0);
      o.has(f) && o.add(s), s[c] = f;
    }
    return o.has(s) ? s : e;
  }
  for (var p = 0, g = t.selections; p < g.length; p++) {
    var v = g[p], m = void 0;
    if (n && o.add(s), v.kind === ye.FIELD) {
      var $ = wi(v), w = v.selectionSet;
      if (m = s[$] || e[$], m === void 0)
        continue;
      if (w && m !== null) {
        var f = ml(e[$], w, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat($) : void 0);
        o.has(f) && (m = f);
      }
      globalThis.__DEV__ === !1 && (s[$] = m), globalThis.__DEV__ !== !1 && (n && $ !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((a = Object.getOwnPropertyDescriptor(s, $)) === null || a === void 0) && a.value) ? Object.defineProperty(s, $, Bx($, m, i || "", r.operationName, r.operationType)) : (delete s[$], s[$] = m));
    }
    if (v.kind === ye.INLINE_FRAGMENT && (!v.typeCondition || r.cache.fragmentMatches(v, e.__typename)) && (m = ml(e, v.selectionSet, r, n, i)), v.kind === ye.FRAGMENT_SPREAD) {
      var k = v.name.value, C = r.fragmentMap[k] || (r.fragmentMap[k] = r.cache.lookupFragment(k));
      Oe(C, 47, k);
      var E = B$(v);
      E !== "mask" && (m = ml(e, C.selectionSet, r, E === "migrate", i));
    }
    o.has(m) && o.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && o.add(s), o.has(s) ? s : e;
}
function Bx(e, t, r, n, i) {
  var a = function() {
    return gf.getValue() || (globalThis.__DEV__ !== !1 && Oe.warn(48, n ? "".concat(i, " '").concat(n, "'") : "anonymous ".concat(i), "".concat(r, ".").concat(e).replace(/^\./, "")), a = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return a();
    },
    set: function(o) {
      a = function() {
        return o;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function h9(e, t, r, n) {
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && u9(), e;
  var i = t.definitions.filter(function(o) {
    return o.kind === ye.FRAGMENT_DEFINITION;
  });
  typeof n > "u" && (Oe(i.length === 1, 49, i.length), n = i[0].name.value);
  var a = i.find(function(o) {
    return o.name.value === n;
  });
  return Oe(!!a, 50, n), e == null || Dt(e, {}) ? e : c9(e, a.selectionSet, {
    operationType: "fragment",
    operationName: a.name.value,
    fragmentMap: ks(Cs(t)),
    cache: r,
    mutableTargets: new l9(),
    knownChanged: new d9()
  });
}
function Hx(e, t, r) {
  var n;
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && u9(), e;
  var i = Ba(t);
  return Oe(i, 51), e == null ? e : c9(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
    fragmentMap: ks(Cs(t)),
    cache: r,
    mutableTargets: new l9(),
    knownChanged: new d9()
  });
}
var f9 = (
  /** @class */
  function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = jl(K$, {
        max: $i["cache.fragmentQueryDocuments"] || 1e3,
        cache: Fu
      });
    }
    return e.prototype.lookupFragment = function(t) {
      return null;
    }, e.prototype.batch = function(t) {
      var r = this, n = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = t.update(r);
      }, n), i;
    }, e.prototype.recordOptimisticTransaction = function(t, r) {
      this.performTransaction(t, r);
    }, e.prototype.transformDocument = function(t) {
      return t;
    }, e.prototype.transformForLink = function(t) {
      return t;
    }, e.prototype.identify = function(t) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(t) {
      return !1;
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !!t.optimistic), this.read(j(j({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: r }));
    }, e.prototype.watchFragment = function(t) {
      var r = this, n = t.fragment, i = t.fragmentName, a = t.from, o = t.optimistic, s = o === void 0 ? !0 : o, l = An(t, ["fragment", "fragmentName", "from", "optimistic"]), d = this.getFragmentDoc(n, i), u = typeof a > "u" || typeof a == "string" ? a : this.identify(a), c = !!t[Symbol.for("apollo.dataMasking")];
      if (globalThis.__DEV__ !== !1) {
        var h = i || N4(n).name.value;
        u || globalThis.__DEV__ !== !1 && Oe.warn(1, h);
      }
      var f = j(j({}, l), { returnPartialData: !0, id: u, query: d, optimistic: s }), p;
      return new Ot(function(g) {
        return r.watch(j(j({}, f), { immediate: !0, callback: function(v) {
          var m = c ? h9(v.result, n, r, i) : v.result;
          if (
            // Always ensure we deliver the first result
            !(p && s9(
              d,
              { data: p.result },
              { data: m },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              t.variables
            ))
          ) {
            var $ = {
              data: m,
              complete: !!v.complete
            };
            v.missing && ($.missing = zc(v.missing.map(function(w) {
              return w.missing;
            }))), p = j(j({}, v), { result: m }), g.next($);
          }
        } }));
      });
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !!t.optimistic), this.read(j(j({}, t), { query: this.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: r }));
    }, e.prototype.writeQuery = function(t) {
      var r = t.id, n = t.data, i = An(t, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: r || "ROOT_QUERY",
        result: n
      }));
    }, e.prototype.writeFragment = function(t) {
      var r = t.id, n = t.data, i = t.fragment, a = t.fragmentName, o = An(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(o, {
        query: this.getFragmentDoc(i, a),
        dataId: r,
        result: n
      }));
    }, e.prototype.updateQuery = function(t, r) {
      return this.batch({
        update: function(n) {
          var i = n.readQuery(t), a = r(i);
          return a == null ? i : (n.writeQuery(j(j({}, t), { data: a })), a);
        }
      });
    }, e.prototype.updateFragment = function(t, r) {
      return this.batch({
        update: function(n) {
          var i = n.readFragment(t), a = r(i);
          return a == null ? i : (n.writeFragment(j(j({}, t), { data: a })), a);
        }
      });
    }, e;
  }()
);
globalThis.__DEV__ !== !1 && (f9.prototype.getMemoryInternals = lw);
var p9 = (
  /** @class */
  function(e) {
    ri(t, e);
    function t(r, n, i, a) {
      var o, s = e.call(this, r) || this;
      if (s.message = r, s.path = n, s.query = i, s.variables = a, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var l = s.path.length - 1; l >= 0; --l)
          s.missing = (o = {}, o[s.path[l]] = s.missing, o);
      } else
        s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  }(Error)
), hr = Object.prototype.hasOwnProperty;
function Ws(e) {
  return e == null;
}
function m9(e, t) {
  var r = e.__typename, n = e.id, i = e._id;
  if (typeof r == "string" && (t && (t.keyObject = Ws(n) ? Ws(i) ? void 0 : { _id: i } : { id: n }), Ws(n) && !Ws(i) && (n = i), !Ws(n)))
    return "".concat(r, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var g9 = {
  dataIdFromObject: m9,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function Wx(e) {
  return ss(g9, e);
}
function v9(e) {
  var t = e.canonizeResults;
  return t === void 0 ? g9.canonizeResults : t;
}
function Qx(e, t) {
  return yt(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
}
var y9 = /^[_a-z][_0-9a-z]*/i;
function Ji(e) {
  var t = e.match(y9);
  return t ? t[0] : e;
}
function g2(e, t, r) {
  return Ht(t) ? Wt(t) ? t.every(function(n) {
    return g2(e, n, r);
  }) : e.selections.every(function(n) {
    if (Ki(n) && od(n, r)) {
      var i = wi(n);
      return hr.call(t, i) && (!n.selectionSet || g2(n.selectionSet, t[i], r));
    }
    return !0;
  }) : !1;
}
function Do(e) {
  return Ht(e) && !yt(e) && !Wt(e);
}
function Gx() {
  return new Xi();
}
function b9(e, t) {
  var r = ks(Cs(e));
  return {
    fragmentMap: r,
    lookupFragment: function(n) {
      var i = r[n];
      return !i && t && (i = t.lookup(n)), i || null;
    }
  };
}
var mu = /* @__PURE__ */ Object.create(null), q0 = function() {
  return mu;
}, Q5 = /* @__PURE__ */ Object.create(null), Vl = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this;
      this.policies = t, this.group = r, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, a) {
        return zu(yt(i) ? n.get(i.__ref, a) : i && i[a]);
      }, this.canRead = function(i) {
        return yt(i) ? n.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, a) {
        if (typeof i == "string")
          return Uo(i);
        if (yt(i))
          return i;
        var o = n.policies.identify(i)[0];
        if (o) {
          var s = Uo(o);
          return a && n.merge(o, i), s;
        }
      };
    }
    return e.prototype.toObject = function() {
      return j({}, this.data);
    }, e.prototype.has = function(t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function(t, r) {
      if (this.group.depend(t, r), hr.call(this.data, t)) {
        var n = this.data[t];
        if (n && hr.call(n, r))
          return n[r];
      }
      if (r === "__typename" && hr.call(this.policies.rootTypenamesById, t))
        return this.policies.rootTypenamesById[t];
      if (this instanceof Li)
        return this.parent.get(t, r);
    }, e.prototype.lookup = function(t, r) {
      if (r && this.group.depend(t, "__exists"), hr.call(this.data, t))
        return this.data[t];
      if (this instanceof Li)
        return this.parent.lookup(t, r);
      if (this.policies.rootTypenamesById[t])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(t, r) {
      var n = this, i;
      yt(t) && (t = t.__ref), yt(r) && (r = r.__ref);
      var a = typeof t == "string" ? this.lookup(i = t) : t, o = typeof r == "string" ? this.lookup(i = r) : r;
      if (o) {
        Oe(typeof i == "string", 2);
        var s = new Xi(Kx).merge(a, o);
        if (this.data[i] = s, s !== a && (delete this.refs[i], this.group.caching)) {
          var l = /* @__PURE__ */ Object.create(null);
          a || (l.__exists = 1), Object.keys(o).forEach(function(d) {
            if (!a || a[d] !== s[d]) {
              l[d] = 1;
              var u = Ji(d);
              u !== d && !n.policies.hasKeyArgs(s.__typename, u) && (l[u] = 1), s[d] === void 0 && !(n instanceof Li) && delete s[d];
            }
          }), l.__typename && !(a && a.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === s.__typename && delete l.__typename, Object.keys(l).forEach(function(d) {
            return n.group.dirty(i, d);
          });
        }
      }
    }, e.prototype.modify = function(t, r) {
      var n = this, i = this.lookup(t);
      if (i) {
        var a = /* @__PURE__ */ Object.create(null), o = !1, s = !0, l = {
          DELETE: mu,
          INVALIDATE: Q5,
          isReference: yt,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(d, u) {
            return n.policies.readField(typeof d == "string" ? {
              fieldName: d,
              from: u || Uo(t)
            } : d, { store: n });
          }
        };
        if (Object.keys(i).forEach(function(d) {
          var u = Ji(d), c = i[d];
          if (c !== void 0) {
            var h = typeof r == "function" ? r : r[d] || r[u];
            if (h) {
              var f = h === q0 ? mu : h(zu(c), j(j({}, l), { fieldName: u, storeFieldName: d, storage: n.getStorage(t, d) }));
              if (f === Q5)
                n.group.dirty(t, d);
              else if (f === mu && (f = void 0), f !== c && (a[d] = f, o = !0, c = f, globalThis.__DEV__ !== !1)) {
                var p = function(C) {
                  if (n.lookup(C.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && Oe.warn(3, C), !0;
                };
                if (yt(f))
                  p(f);
                else if (Array.isArray(f))
                  for (var g = !1, v = void 0, m = 0, $ = f; m < $.length; m++) {
                    var w = $[m];
                    if (yt(w)) {
                      if (g = !0, p(w))
                        break;
                    } else if (typeof w == "object" && w) {
                      var k = n.policies.identify(w)[0];
                      k && (v = w);
                    }
                    if (g && v !== void 0) {
                      globalThis.__DEV__ !== !1 && Oe.warn(4, v);
                      break;
                    }
                  }
              }
            }
            c !== void 0 && (s = !1);
          }
        }), o)
          return this.merge(t, a), s && (this instanceof Li ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(t, r, n) {
      var i, a = this.lookup(t);
      if (a) {
        var o = this.getFieldValue(a, "__typename"), s = r && n ? this.policies.getStoreFieldName({ typename: o, fieldName: r, args: n }) : r;
        return this.modify(t, s ? (i = {}, i[s] = q0, i) : q0);
      }
      return !1;
    }, e.prototype.evict = function(t, r) {
      var n = !1;
      return t.id && (hr.call(this.data, t.id) && (n = this.delete(t.id, t.fieldName, t.args)), this instanceof Li && this !== r && (n = this.parent.evict(t, r) || n), (t.fieldName || n) && this.group.dirty(t.id, t.fieldName || "__exists")), n;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var t = this, r = this.toObject(), n = [];
      return this.getRootIdSet().forEach(function(i) {
        hr.call(t.policies.rootTypenamesById, i) || n.push(i);
      }), n.length && (r.__META = { extraRootIds: n.sort() }), r;
    }, e.prototype.replace = function(t) {
      var r = this;
      if (Object.keys(this.data).forEach(function(a) {
        t && hr.call(t, a) || r.delete(a);
      }), t) {
        var n = t.__META, i = An(t, ["__META"]);
        Object.keys(i).forEach(function(a) {
          r.merge(a, i[a]);
        }), n && n.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function(t) {
      if (this.rootIds[t] > 0) {
        var r = --this.rootIds[t];
        return r || delete this.rootIds[t], r;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(t) {
      return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof Li ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function() {
      var t = this, r = this.getRootIdSet(), n = this.toObject();
      r.forEach(function(o) {
        hr.call(n, o) && (Object.keys(t.findChildRefIds(o)).forEach(r.add, r), delete n[o]);
      });
      var i = Object.keys(n);
      if (i.length) {
        for (var a = this; a instanceof Li; )
          a = a.parent;
        i.forEach(function(o) {
          return a.delete(o);
        });
      }
      return i;
    }, e.prototype.findChildRefIds = function(t) {
      if (!hr.call(this.refs, t)) {
        var r = this.refs[t] = /* @__PURE__ */ Object.create(null), n = this.data[t];
        if (!n)
          return r;
        var i = /* @__PURE__ */ new Set([n]);
        i.forEach(function(a) {
          yt(a) && (r[a.__ref] = !0), Ht(a) && Object.keys(a).forEach(function(o) {
            var s = a[o];
            Ht(s) && i.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  }()
), $9 = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = null), this.caching = t, this.parent = r, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? W4() : null, this.keyMaker = new Si(no);
    }, e.prototype.depend = function(t, r) {
      if (this.d) {
        this.d(B0(t, r));
        var n = Ji(r);
        n !== r && this.d(B0(t, n)), this.parent && this.parent.depend(t, r);
      }
    }, e.prototype.dirty = function(t, r) {
      this.d && this.d.dirty(
        B0(t, r),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        r === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  }()
);
function B0(e, t) {
  return t + "#" + e;
}
function G5(e, t) {
  Sl(e) && e.group.depend(t, "__exists");
}
(function(e) {
  var t = (
    /** @class */
    function(r) {
      ri(n, r);
      function n(i) {
        var a = i.policies, o = i.resultCaching, s = o === void 0 ? !0 : o, l = i.seed, d = r.call(this, a, new $9(s)) || this;
        return d.stump = new Yx(d), d.storageTrie = new Si(no), l && d.replace(l), d;
      }
      return n.prototype.addLayer = function(i, a) {
        return this.stump.addLayer(i, a);
      }, n.prototype.removeLayer = function() {
        return this;
      }, n.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, n;
    }(e)
  );
  e.Root = t;
})(Vl || (Vl = {}));
var Li = (
  /** @class */
  function(e) {
    ri(t, e);
    function t(r, n, i, a) {
      var o = e.call(this, n.policies, a) || this;
      return o.id = r, o.parent = n, o.replay = i, o.group = a, i(o), o;
    }
    return t.prototype.addLayer = function(r, n) {
      return new t(r, this, n, this.group);
    }, t.prototype.removeLayer = function(r) {
      var n = this, i = this.parent.removeLayer(r);
      return r === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(a) {
        var o = n.data[a], s = i.lookup(a);
        s ? o ? o !== s && Object.keys(o).forEach(function(l) {
          Dt(o[l], s[l]) || n.group.dirty(a, l);
        }) : (n.group.dirty(a, "__exists"), Object.keys(s).forEach(function(l) {
          n.group.dirty(a, l);
        })) : n.delete(a);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function() {
      return j(j({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function(r) {
      var n = this.parent.findChildRefIds(r);
      return hr.call(this.data, r) ? j(j({}, n), e.prototype.findChildRefIds.call(this, r)) : n;
    }, t.prototype.getStorage = function() {
      for (var r = this.parent; r.parent; )
        r = r.parent;
      return r.getStorage.apply(
        r,
        // @ts-expect-error
        arguments
      );
    }, t;
  }(Vl)
), Yx = (
  /** @class */
  function(e) {
    ri(t, e);
    function t(r) {
      return e.call(this, "EntityStore.Stump", r, function() {
      }, new $9(r.group.caching, r.group)) || this;
    }
    return t.prototype.removeLayer = function() {
      return this;
    }, t.prototype.merge = function(r, n) {
      return this.parent.merge(r, n);
    }, t;
  }(Li)
);
function Kx(e, t, r) {
  var n = e[r], i = t[r];
  return Dt(n, i) ? n : i;
}
function Sl(e) {
  return !!(e instanceof Vl && e.group.caching);
}
function Zx(e) {
  return Ht(e) ? Wt(e) ? e.slice(0) : j({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var Y5 = (
  /** @class */
  function() {
    function e() {
      this.known = new (af ? WeakSet : Set)(), this.pool = new Si(no), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(t) {
      return Ht(t) && this.known.has(t);
    }, e.prototype.pass = function(t) {
      if (Ht(t)) {
        var r = Zx(t);
        return this.passes.set(r, t), r;
      }
      return t;
    }, e.prototype.admit = function(t) {
      var r = this;
      if (Ht(t)) {
        var n = this.passes.get(t);
        if (n)
          return n;
        var i = Object.getPrototypeOf(t);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(t))
              return t;
            var a = t.map(this.admit, this), o = this.pool.lookupArray(a);
            return o.array || (this.known.add(o.array = a), globalThis.__DEV__ !== !1 && Object.freeze(a)), o.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(t))
              return t;
            var s = Object.getPrototypeOf(t), l = [s], d = this.sortedKeys(t);
            l.push(d.json);
            var u = l.length;
            d.sorted.forEach(function(f) {
              l.push(r.admit(t[f]));
            });
            var o = this.pool.lookupArray(l);
            if (!o.object) {
              var c = o.object = Object.create(s);
              this.known.add(c), d.sorted.forEach(function(f, p) {
                c[f] = l[u + p];
              }), globalThis.__DEV__ !== !1 && Object.freeze(c);
            }
            return o.object;
          }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function(t) {
      var r = Object.keys(t), n = this.pool.lookupArray(r);
      if (!n.keys) {
        r.sort();
        var i = JSON.stringify(r);
        (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: r, json: i });
      }
      return n.keys;
    }, e;
  }()
);
function K5(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var Xx = (
  /** @class */
  function() {
    function e(t) {
      var r = this;
      this.knownResults = new (no ? WeakMap : Map)(), this.config = ss(t, {
        addTypename: t.addTypename !== !1,
        canonizeResults: v9(t)
      }), this.canon = t.canon || new Y5(), this.executeSelectionSet = jl(function(n) {
        var i, a = n.context.canonizeResults, o = K5(n);
        o[3] = !a;
        var s = (i = r.executeSelectionSet).peek.apply(i, o);
        return s ? a ? j(j({}, s), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: r.canon.admit(s.result)
        }) : s : (G5(n.context.store, n.enclosingRef.__ref), r.execSelectionSetImpl(n));
      }, {
        max: this.config.resultCacheMaxSize || $i["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: K5,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(n, i, a, o) {
          if (Sl(a.store))
            return a.store.makeCacheKey(n, yt(i) ? i.__ref : i, a.varString, o);
        }
      }), this.executeSubSelectedArray = jl(function(n) {
        return G5(n.context.store, n.enclosingRef.__ref), r.execSubSelectedArrayImpl(n);
      }, {
        max: this.config.resultCacheMaxSize || $i["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(n) {
          var i = n.field, a = n.array, o = n.context;
          if (Sl(o.store))
            return o.store.makeCacheKey(i, a, o.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new Y5();
    }, e.prototype.diffQueryAgainstStore = function(t) {
      var r = t.store, n = t.query, i = t.rootId, a = i === void 0 ? "ROOT_QUERY" : i, o = t.variables, s = t.returnPartialData, l = s === void 0 ? !0 : s, d = t.canonizeResults, u = d === void 0 ? this.config.canonizeResults : d, c = this.config.cache.policies;
      o = j(j({}, of(M4(n))), o);
      var h = Uo(a), f = this.executeSelectionSet({
        selectionSet: sd(n).selectionSet,
        objectOrReference: h,
        enclosingRef: h,
        context: j({ store: r, query: n, policies: c, variables: o, varString: Qi(o), canonizeResults: u }, b9(n, this.config.fragments))
      }), p;
      if (f.missing && (p = [
        new p9(Jx(f.missing), f.missing, n, o)
      ], !l))
        throw p[0];
      return {
        result: f.result,
        complete: !p,
        missing: p
      };
    }, e.prototype.isFresh = function(t, r, n, i) {
      if (Sl(i.store) && this.knownResults.get(t) === n) {
        var a = this.executeSelectionSet.peek(
          n,
          r,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(t)
        );
        if (a && t === a.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(t) {
      var r = this, n = t.selectionSet, i = t.objectOrReference, a = t.enclosingRef, o = t.context;
      if (yt(i) && !o.policies.rootTypenamesById[i.__ref] && !o.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var s = o.variables, l = o.policies, d = o.store, u = d.getFieldValue(i, "__typename"), c = [], h, f = new Xi();
      this.config.addTypename && typeof u == "string" && !l.rootIdsByTypename[u] && c.push({ __typename: u });
      function p(w, k) {
        var C;
        return w.missing && (h = f.merge(h, (C = {}, C[k] = w.missing, C))), w.result;
      }
      var g = new Set(n.selections);
      g.forEach(function(w) {
        var k, C;
        if (od(w, s))
          if (Ki(w)) {
            var E = l.readField({
              fieldName: w.name.value,
              field: w,
              variables: o.variables,
              from: i
            }, o), N = wi(w);
            E === void 0 ? uf.added(w) || (h = f.merge(h, (k = {}, k[N] = "Can't find field '".concat(w.name.value, "' on ").concat(yt(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), k))) : Wt(E) ? E.length > 0 && (E = p(r.executeSubSelectedArray({
              field: w,
              array: E,
              enclosingRef: a,
              context: o
            }), N)) : w.selectionSet ? E != null && (E = p(r.executeSelectionSet({
              selectionSet: w.selectionSet,
              objectOrReference: E,
              enclosingRef: yt(E) ? E : a,
              context: o
            }), N)) : o.canonizeResults && (E = r.canon.pass(E)), E !== void 0 && c.push((C = {}, C[N] = E, C));
          } else {
            var M = Mc(w, o.lookupFragment);
            if (!M && w.kind === ye.FRAGMENT_SPREAD)
              throw Rr(10, w.name.value);
            M && l.fragmentMatches(M, u) && M.selectionSet.selections.forEach(g.add, g);
          }
      });
      var v = zc(c), m = { result: v, missing: h }, $ = o.canonizeResults ? this.canon.admit(m) : zu(m);
      return $.result && this.knownResults.set($.result, n), $;
    }, e.prototype.execSubSelectedArrayImpl = function(t) {
      var r = this, n = t.field, i = t.array, a = t.enclosingRef, o = t.context, s, l = new Xi();
      function d(u, c) {
        var h;
        return u.missing && (s = l.merge(s, (h = {}, h[c] = u.missing, h))), u.result;
      }
      return n.selectionSet && (i = i.filter(o.store.canRead)), i = i.map(function(u, c) {
        return u === null ? null : Wt(u) ? d(r.executeSubSelectedArray({
          field: n,
          array: u,
          enclosingRef: a,
          context: o
        }), c) : n.selectionSet ? d(r.executeSelectionSet({
          selectionSet: n.selectionSet,
          objectOrReference: u,
          enclosingRef: yt(u) ? u : a,
          context: o
        }), c) : (globalThis.__DEV__ !== !1 && ek(o.store, n, u), u);
      }), {
        result: o.canonizeResults ? this.canon.admit(i) : i,
        missing: s
      };
    }, e;
  }()
);
function Jx(e) {
  try {
    JSON.stringify(e, function(t, r) {
      if (typeof r == "string")
        throw r;
      return r;
    });
  } catch (t) {
    return t;
  }
}
function ek(e, t, r) {
  if (!t.selectionSet) {
    var n = /* @__PURE__ */ new Set([r]);
    n.forEach(function(i) {
      Ht(i) && (Oe(
        !yt(i),
        11,
        Qx(e, i),
        t.name.value
      ), Object.values(i).forEach(n.add, n));
    });
  }
}
var vf = new Lc(), Z5 = /* @__PURE__ */ new WeakMap();
function El(e) {
  var t = Z5.get(e);
  return t || Z5.set(e, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: W4()
  }), t;
}
function X5(e) {
  El(e).vars.forEach(function(t) {
    return t.forgetCache(e);
  });
}
function tk(e) {
  El(e).vars.forEach(function(t) {
    return t.attachCache(e);
  });
}
function rk(e) {
  var t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), n = function(a) {
    if (arguments.length > 0) {
      if (e !== a) {
        e = a, t.forEach(function(l) {
          El(l).dep.dirty(n), nk(l);
        });
        var o = Array.from(r);
        r.clear(), o.forEach(function(l) {
          return l(e);
        });
      }
    } else {
      var s = vf.getValue();
      s && (i(s), El(s).dep(n));
    }
    return e;
  };
  n.onNextChange = function(a) {
    return r.add(a), function() {
      r.delete(a);
    };
  };
  var i = n.attachCache = function(a) {
    return t.add(a), El(a).vars.add(n), n;
  };
  return n.forgetCache = function(a) {
    return t.delete(a);
  }, n;
}
function nk(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var J5 = /* @__PURE__ */ Object.create(null);
function yf(e) {
  var t = JSON.stringify(e);
  return J5[t] || (J5[t] = /* @__PURE__ */ Object.create(null));
}
function e3(e) {
  var t = yf(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function(r, n) {
    var i = function(o, s) {
      return n.readField(s, o);
    }, a = n.keyObject = bf(e, function(o) {
      var s = Bo(
        n.storeObject,
        o,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return s === void 0 && r !== n.storeObject && hr.call(r, o[0]) && (s = Bo(r, o, x9)), Oe(s !== void 0, 5, o.join("."), r), s;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(a));
  });
}
function t3(e) {
  var t = yf(e);
  return t.keyArgsFn || (t.keyArgsFn = function(r, n) {
    var i = n.field, a = n.variables, o = n.fieldName, s = bf(e, function(d) {
      var u = d[0], c = u.charAt(0);
      if (c === "@") {
        if (i && Xn(i.directives)) {
          var h = u.slice(1), f = i.directives.find(function(m) {
            return m.name.value === h;
          }), p = f && Nc(f, a);
          return p && Bo(
            p,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            d.slice(1)
          );
        }
        return;
      }
      if (c === "$") {
        var g = u.slice(1);
        if (a && hr.call(a, g)) {
          var v = d.slice(0);
          return v[0] = g, Bo(a, v);
        }
        return;
      }
      if (r)
        return Bo(r, d);
    }), l = JSON.stringify(s);
    return (r || l !== "{}") && (o += ":" + l), o;
  });
}
function bf(e, t) {
  var r = new Xi();
  return w9(e).reduce(function(n, i) {
    var a, o = t(i);
    if (o !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        o = (a = {}, a[i[s]] = o, a);
      n = r.merge(n, o);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function w9(e) {
  var t = yf(e);
  if (!t.paths) {
    var r = t.paths = [], n = [];
    e.forEach(function(i, a) {
      Wt(i) ? (w9(i).forEach(function(o) {
        return r.push(n.concat(o));
      }), n.length = 0) : (n.push(i), Wt(e[a + 1]) || (r.push(n.slice(0)), n.length = 0));
    });
  }
  return t.paths;
}
function x9(e, t) {
  return e[t];
}
function Bo(e, t, r) {
  return r = r || x9, k9(t.reduce(function n(i, a) {
    return Wt(i) ? i.map(function(o) {
      return n(o, a);
    }) : i && r(i, a);
  }, e));
}
function k9(e) {
  return Ht(e) ? Wt(e) ? e.map(k9) : bf(Object.keys(e).sort(), function(t) {
    return Bo(e, t);
  }) : e;
}
function v2(e) {
  return e.args !== void 0 ? e.args : e.field ? Nc(e.field, e.variables) : null;
}
var ik = function() {
}, r3 = function(e, t) {
  return t.fieldName;
}, n3 = function(e, t, r) {
  var n = r.mergeObjects;
  return n(e, t);
}, i3 = function(e, t) {
  return t;
}, ak = (
  /** @class */
  function() {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = j({ dataIdFromObject: m9 }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function(t, r) {
      var n, i = this, a = r && (r.typename || ((n = r.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || t.__typename;
      if (a === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var o = r && r.storeObject || t, s = j(j({}, r), { typename: a, storeObject: o, readField: r && r.readField || function() {
        var c = $f(arguments, o);
        return i.readField(c, {
          store: i.cache.data,
          variables: c.variables
        });
      } }), l, d = a && this.getTypePolicy(a), u = d && d.keyFn || this.config.dataIdFromObject;
      return gf.withValue(!0, function() {
        for (; u; ) {
          var c = u(j(j({}, t), o), s);
          if (Wt(c))
            u = e3(c);
          else {
            l = c;
            break;
          }
        }
      }), l = l ? String(l) : void 0, s.keyObject ? [l, s.keyObject] : [l];
    }, e.prototype.addTypePolicies = function(t) {
      var r = this;
      Object.keys(t).forEach(function(n) {
        var i = t[n], a = i.queryType, o = i.mutationType, s = i.subscriptionType, l = An(i, ["queryType", "mutationType", "subscriptionType"]);
        a && r.setRootTypename("Query", n), o && r.setRootTypename("Mutation", n), s && r.setRootTypename("Subscription", n), hr.call(r.toBeAdded, n) ? r.toBeAdded[n].push(l) : r.toBeAdded[n] = [l];
      });
    }, e.prototype.updateTypePolicy = function(t, r) {
      var n = this, i = this.getTypePolicy(t), a = r.keyFields, o = r.fields;
      function s(l, d) {
        l.merge = typeof d == "function" ? d : d === !0 ? n3 : d === !1 ? i3 : l.merge;
      }
      s(i, r.merge), i.keyFn = // Pass false to disable normalization for this typename.
      a === !1 ? ik : Wt(a) ? e3(a) : typeof a == "function" ? a : i.keyFn, o && Object.keys(o).forEach(function(l) {
        var d = n.getFieldPolicy(t, l, !0), u = o[l];
        if (typeof u == "function")
          d.read = u;
        else {
          var c = u.keyArgs, h = u.read, f = u.merge;
          d.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          c === !1 ? r3 : Wt(c) ? t3(c) : typeof c == "function" ? c : d.keyFn, typeof h == "function" && (d.read = h), s(d, f);
        }
        d.read && d.merge && (d.keyFn = d.keyFn || r3);
      });
    }, e.prototype.setRootTypename = function(t, r) {
      r === void 0 && (r = t);
      var n = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[n];
      r !== i && (Oe(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[r] = n, this.rootTypenamesById[n] = r);
    }, e.prototype.addPossibleTypes = function(t) {
      var r = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function(n) {
        r.getSupertypeSet(n, !0), t[n].forEach(function(i) {
          r.getSupertypeSet(i, !0).add(n);
          var a = i.match(y9);
          (!a || a[0] !== i) && r.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, e.prototype.getTypePolicy = function(t) {
      var r = this;
      if (!hr.call(this.typePolicies, t)) {
        var n = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
        n.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(t);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(o, s) {
          if (o.test(t)) {
            var l = r.supertypeMap.get(s);
            l && l.forEach(function(d) {
              return i.add(d);
            });
          }
        })), i && i.size && i.forEach(function(o) {
          var s = r.getTypePolicy(o), l = s.fields, d = An(s, ["fields"]);
          Object.assign(n, d), Object.assign(n.fields, l);
        });
      }
      var a = this.toBeAdded[t];
      return a && a.length && a.splice(0).forEach(function(o) {
        r.updateTypePolicy(t, o);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function(t, r, n) {
      if (t) {
        var i = this.getTypePolicy(t).fields;
        return i[r] || n && (i[r] = /* @__PURE__ */ Object.create(null));
      }
    }, e.prototype.getSupertypeSet = function(t, r) {
      var n = this.supertypeMap.get(t);
      return !n && r && this.supertypeMap.set(t, n = /* @__PURE__ */ new Set()), n;
    }, e.prototype.fragmentMatches = function(t, r, n, i) {
      var a = this;
      if (!t.typeCondition)
        return !0;
      if (!r)
        return !1;
      var o = t.typeCondition.name.value;
      if (r === o)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(o))
        for (var s = this.getSupertypeSet(r, !0), l = [s], d = function(p) {
          var g = a.getSupertypeSet(p, !1);
          g && g.size && l.indexOf(g) < 0 && l.push(g);
        }, u = !!(n && this.fuzzySubtypes.size), c = !1, h = 0; h < l.length; ++h) {
          var f = l[h];
          if (f.has(o))
            return s.has(o) || (c && globalThis.__DEV__ !== !1 && Oe.warn(7, r, o), s.add(o)), !0;
          f.forEach(d), u && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          h === l.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          g2(t.selectionSet, n, i) && (u = !1, c = !0, this.fuzzySubtypes.forEach(function(p, g) {
            var v = r.match(p);
            v && v[0] === r && d(g);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(t, r) {
      var n = this.getFieldPolicy(t, r, !1);
      return !!(n && n.keyFn);
    }, e.prototype.getStoreFieldName = function(t) {
      var r = t.typename, n = t.fieldName, i = this.getFieldPolicy(r, n, !1), a, o = i && i.keyFn;
      if (o && r)
        for (var s = {
          typename: r,
          fieldName: n,
          field: t.field || null,
          variables: t.variables
        }, l = v2(t); o; ) {
          var d = o(l, s);
          if (Wt(d))
            o = t3(d);
          else {
            a = d || n;
            break;
          }
        }
      return a === void 0 && (a = t.field ? Cw(t.field, t.variables) : D4(n, v2(t))), a === !1 ? n : n === Ji(a) ? a : n + ":" + a;
    }, e.prototype.readField = function(t, r) {
      var n = t.from;
      if (n) {
        var i = t.field || t.fieldName;
        if (i) {
          if (t.typename === void 0) {
            var a = r.store.getFieldValue(n, "__typename");
            a && (t.typename = a);
          }
          var o = this.getStoreFieldName(t), s = Ji(o), l = r.store.getFieldValue(n, o), d = this.getFieldPolicy(t.typename, s, !1), u = d && d.read;
          if (u) {
            var c = a3(this, n, t, r, r.store.getStorage(yt(n) ? n.__ref : n, o));
            return vf.withValue(this.cache, u, [
              l,
              c
            ]);
          }
          return l;
        }
      }
    }, e.prototype.getReadFunction = function(t, r) {
      var n = this.getFieldPolicy(t, r, !1);
      return n && n.read;
    }, e.prototype.getMergeFunction = function(t, r, n) {
      var i = this.getFieldPolicy(t, r, !1), a = i && i.merge;
      return !a && n && (i = this.getTypePolicy(n), a = i && i.merge), a;
    }, e.prototype.runMergeFunction = function(t, r, n, i, a) {
      var o = n.field, s = n.typename, l = n.merge;
      return l === n3 ? _9(i.store)(t, r) : l === i3 ? r : (i.overwrite && (t = void 0), l(t, r, a3(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: s,
          fieldName: o.name.value,
          field: o,
          variables: i.variables
        },
        i,
        a || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  }()
);
function a3(e, t, r, n, i) {
  var a = e.getStoreFieldName(r), o = Ji(a), s = r.variables || n.variables, l = n.store, d = l.toReference, u = l.canRead;
  return {
    args: v2(r),
    field: r.field || null,
    fieldName: o,
    storeFieldName: a,
    variables: s,
    isReference: yt,
    toReference: d,
    storage: i,
    cache: e.cache,
    canRead: u,
    readField: function() {
      return e.readField($f(arguments, t, s), n);
    },
    mergeObjects: _9(n.store)
  };
}
function $f(e, t, r) {
  var n = e[0], i = e[1], a = e.length, o;
  return typeof n == "string" ? o = {
    fieldName: n,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: a > 1 ? i : t
  } : (o = j({}, n), hr.call(o, "from") || (o.from = t)), globalThis.__DEV__ !== !1 && o.from === void 0 && globalThis.__DEV__ !== !1 && Oe.warn(8, f4(Array.from(e))), o.variables === void 0 && (o.variables = r), o;
}
function _9(e) {
  return function(r, n) {
    if (Wt(r) || Wt(n))
      throw Rr(9);
    if (Ht(r) && Ht(n)) {
      var i = e.getFieldValue(r, "__typename"), a = e.getFieldValue(n, "__typename"), o = i && a && i !== a;
      if (o)
        return n;
      if (yt(r) && Do(n))
        return e.merge(r.__ref, n), r;
      if (Do(r) && yt(n))
        return e.merge(r, n.__ref), n;
      if (Do(r) && Do(n))
        return j(j({}, r), n);
    }
    return n;
  };
}
function H0(e, t, r) {
  var n = "".concat(t).concat(r), i = e.flavors.get(n);
  return i || e.flavors.set(n, i = e.clientOnly === t && e.deferred === r ? e : j(j({}, e), { clientOnly: t, deferred: r })), i;
}
var ok = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.cache = t, this.reader = r, this.fragments = n;
    }
    return e.prototype.writeToStore = function(t, r) {
      var n = this, i = r.query, a = r.result, o = r.dataId, s = r.variables, l = r.overwrite, d = Ba(i), u = Gx();
      s = j(j({}, of(d)), s);
      var c = j(j({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(f, p) {
        return u.merge(f, p);
      }, variables: s, varString: Qi(s) }, b9(i, this.fragments)), { overwrite: !!l, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), h = this.processSelectionSet({
        result: a || /* @__PURE__ */ Object.create(null),
        dataId: o,
        selectionSet: d.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: c
      });
      if (!yt(h))
        throw Rr(12, a);
      return c.incomingById.forEach(function(f, p) {
        var g = f.storeObject, v = f.mergeTree, m = f.fieldNodeSet, $ = Uo(p);
        if (v && v.map.size) {
          var w = n.applyMerges(v, $, g, c);
          if (yt(w))
            return;
          g = w;
        }
        if (globalThis.__DEV__ !== !1 && !c.overwrite) {
          var k = /* @__PURE__ */ Object.create(null);
          m.forEach(function(N) {
            N.selectionSet && (k[N.name.value] = !0);
          });
          var C = function(N) {
            return k[Ji(N)] === !0;
          }, E = function(N) {
            var M = v && v.map.get(N);
            return !!(M && M.info && M.info.merge);
          };
          Object.keys(g).forEach(function(N) {
            C(N) && !E(N) && sk($, g, N, c.store);
          });
        }
        t.merge(p, g);
      }), t.retain(h.__ref), h;
    }, e.prototype.processSelectionSet = function(t) {
      var r = this, n = t.dataId, i = t.result, a = t.selectionSet, o = t.context, s = t.mergeTree, l = this.cache.policies, d = /* @__PURE__ */ Object.create(null), u = n && l.rootTypenamesById[n] || s2(i, a, o.fragmentMap) || n && o.store.get(n, "__typename");
      typeof u == "string" && (d.__typename = u);
      var c = function() {
        var w = $f(arguments, d, o.variables);
        if (yt(w.from)) {
          var k = o.incomingById.get(w.from.__ref);
          if (k) {
            var C = l.readField(j(j({}, w), { from: k.storeObject }), o);
            if (C !== void 0)
              return C;
          }
        }
        return l.readField(w, o);
      }, h = /* @__PURE__ */ new Set();
      this.flattenFields(
        a,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        o,
        u
      ).forEach(function(w, k) {
        var C, E = wi(k), N = i[E];
        if (h.add(k), N !== void 0) {
          var M = l.getStoreFieldName({
            typename: u,
            fieldName: k.name.value,
            field: k,
            variables: w.variables
          }), V = o3(s, M), q = r.processFieldValue(
            N,
            k,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            k.selectionSet ? H0(w, !1, !1) : w,
            V
          ), I = void 0;
          k.selectionSet && (yt(q) || Do(q)) && (I = c("__typename", q));
          var P = l.getMergeFunction(u, k.name.value, I);
          P ? V.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: k,
            typename: u,
            merge: P
          } : s3(s, M), d = w.merge(d, (C = {}, C[M] = q, C));
        } else globalThis.__DEV__ !== !1 && !w.clientOnly && !w.deferred && !uf.added(k) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !l.getReadFunction(u, k.name.value) && globalThis.__DEV__ !== !1 && Oe.error(13, wi(k), i);
      });
      try {
        var f = l.identify(i, {
          typename: u,
          selectionSet: a,
          fragmentMap: o.fragmentMap,
          storeObject: d,
          readField: c
        }), p = f[0], g = f[1];
        n = n || p, g && (d = o.merge(d, g));
      } catch (w) {
        if (!n)
          throw w;
      }
      if (typeof n == "string") {
        var v = Uo(n), m = o.written[n] || (o.written[n] = []);
        if (m.indexOf(a) >= 0 || (m.push(a), this.reader && this.reader.isFresh(i, v, a, o)))
          return v;
        var $ = o.incomingById.get(n);
        return $ ? ($.storeObject = o.merge($.storeObject, d), $.mergeTree = y2($.mergeTree, s), h.forEach(function(w) {
          return $.fieldNodeSet.add(w);
        })) : o.incomingById.set(n, {
          storeObject: d,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: ju(s) ? void 0 : s,
          fieldNodeSet: h
        }), v;
      }
      return d;
    }, e.prototype.processFieldValue = function(t, r, n, i) {
      var a = this;
      return !r.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? e9(t) : t : Wt(t) ? t.map(function(o, s) {
        var l = a.processFieldValue(o, r, n, o3(i, s));
        return s3(i, s), l;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: r.selectionSet,
        context: n,
        mergeTree: i
      });
    }, e.prototype.flattenFields = function(t, r, n, i) {
      i === void 0 && (i = s2(r, t, n.fragmentMap));
      var a = /* @__PURE__ */ new Map(), o = this.cache.policies, s = new Si(!1);
      return function l(d, u) {
        var c = s.lookup(
          d,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          u.clientOnly,
          u.deferred
        );
        c.visited || (c.visited = !0, d.selections.forEach(function(h) {
          if (od(h, n.variables)) {
            var f = u.clientOnly, p = u.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(f && p) && Xn(h.directives) && h.directives.forEach(function(m) {
                var $ = m.name.value;
                if ($ === "client" && (f = !0), $ === "defer") {
                  var w = Nc(m, n.variables);
                  (!w || w.if !== !1) && (p = !0);
                }
              }), Ki(h)
            ) {
              var g = a.get(h);
              g && (f = f && g.clientOnly, p = p && g.deferred), a.set(h, H0(n, f, p));
            } else {
              var v = Mc(h, n.lookupFragment);
              if (!v && h.kind === ye.FRAGMENT_SPREAD)
                throw Rr(14, h.name.value);
              v && o.fragmentMatches(v, i, r, n.variables) && l(v.selectionSet, H0(n, f, p));
            }
          }
        }));
      }(t, n), a;
    }, e.prototype.applyMerges = function(t, r, n, i, a) {
      var o, s = this;
      if (t.map.size && !yt(n)) {
        var l = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !Wt(n) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (yt(r) || Do(r)) ? r : void 0
        ), d = n;
        l && !a && (a = [yt(l) ? l.__ref : l]);
        var u, c = function(h, f) {
          return Wt(h) ? typeof f == "number" ? h[f] : void 0 : i.store.getFieldValue(h, String(f));
        };
        t.map.forEach(function(h, f) {
          var p = c(l, f), g = c(d, f);
          if (g !== void 0) {
            a && a.push(f);
            var v = s.applyMerges(h, p, g, i, a);
            v !== g && (u = u || /* @__PURE__ */ new Map(), u.set(f, v)), a && Oe(a.pop() === f);
          }
        }), u && (n = Wt(d) ? d.slice(0) : j({}, d), u.forEach(function(h, f) {
          n[f] = h;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(r, n, t.info, i, a && (o = i.store).getStorage.apply(o, a)) : n;
    }, e;
  }()
), C9 = [];
function o3(e, t) {
  var r = e.map;
  return r.has(t) || r.set(t, C9.pop() || { map: /* @__PURE__ */ new Map() }), r.get(t);
}
function y2(e, t) {
  if (e === t || !t || ju(t))
    return e;
  if (!e || ju(e))
    return t;
  var r = e.info && t.info ? j(j({}, e.info), t.info) : e.info || t.info, n = e.map.size && t.map.size, i = n ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, a = { info: r, map: i };
  if (n) {
    var o = new Set(t.map.keys());
    e.map.forEach(function(s, l) {
      a.map.set(l, y2(s, t.map.get(l))), o.delete(l);
    }), o.forEach(function(s) {
      a.map.set(s, y2(t.map.get(s), e.map.get(s)));
    });
  }
  return a;
}
function ju(e) {
  return !e || !(e.info || e.map.size);
}
function s3(e, t) {
  var r = e.map, n = r.get(t);
  n && ju(n) && (C9.push(n), r.delete(t));
}
var l3 = /* @__PURE__ */ new Set();
function sk(e, t, r, n) {
  var i = function(c) {
    var h = n.getFieldValue(c, r);
    return typeof h == "object" && h;
  }, a = i(e);
  if (a) {
    var o = i(t);
    if (o && !yt(a) && !Dt(a, o) && !Object.keys(a).every(function(c) {
      return n.getFieldValue(o, c) !== void 0;
    })) {
      var s = n.getFieldValue(e, "__typename") || n.getFieldValue(t, "__typename"), l = Ji(r), d = "".concat(s, ".").concat(l);
      if (!l3.has(d)) {
        l3.add(d);
        var u = [];
        !Wt(a) && !Wt(o) && [a, o].forEach(function(c) {
          var h = n.getFieldValue(c, "__typename");
          typeof h == "string" && !u.includes(h) && u.push(h);
        }), globalThis.__DEV__ !== !1 && Oe.warn(15, l, s, u.length ? "either ensure all objects of type " + u.join(" and ") + " have an ID or a custom merge function, or " : "", d, j({}, a), j({}, o));
      }
    }
  }
}
var S9 = (
  /** @class */
  function(e) {
    ri(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this) || this;
      return n.watches = /* @__PURE__ */ new Set(), n.addTypenameTransform = new Q4(uf), n.assumeImmutableResults = !0, n.makeVar = rk, n.txCount = 0, n.config = Wx(r), n.addTypename = !!n.config.addTypename, n.policies = new ak({
        cache: n,
        dataIdFromObject: n.config.dataIdFromObject,
        possibleTypes: n.config.possibleTypes,
        typePolicies: n.config.typePolicies
      }), n.init(), n;
    }
    return t.prototype.init = function() {
      var r = this.data = new Vl.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = r.stump, this.resetResultCache();
    }, t.prototype.resetResultCache = function(r) {
      var n = this, i = this.storeReader, a = this.config.fragments;
      this.storeWriter = new ok(this, this.storeReader = new Xx({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: v9(this.config),
        canon: r ? void 0 : i && i.canon,
        fragments: a
      }), a), this.maybeBroadcastWatch = jl(function(o, s) {
        return n.broadcastWatch(o, s);
      }, {
        max: this.config.resultCacheMaxSize || $i["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(o) {
          var s = o.optimistic ? n.optimisticData : n.data;
          if (Sl(s)) {
            var l = o.optimistic, d = o.id, u = o.variables;
            return s.makeCacheKey(
              o.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              o.callback,
              Qi({ optimistic: l, id: d, variables: u })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(o) {
        return o.resetCaching();
      });
    }, t.prototype.restore = function(r) {
      return this.init(), r && this.data.replace(r), this;
    }, t.prototype.extract = function(r) {
      return r === void 0 && (r = !1), (r ? this.optimisticData : this.data).extract();
    }, t.prototype.read = function(r) {
      var n = r.returnPartialData, i = n === void 0 ? !1 : n;
      try {
        return this.storeReader.diffQueryAgainstStore(j(j({}, r), { store: r.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (a) {
        if (a instanceof p9)
          return null;
        throw a;
      }
    }, t.prototype.write = function(r) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, r);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.modify = function(r) {
      if (hr.call(r, "id") && !r.id)
        return !1;
      var n = r.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, n.modify(r.id || "ROOT_QUERY", r.fields);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.diff = function(r) {
      return this.storeReader.diffQueryAgainstStore(j(j({}, r), { store: r.optimistic ? this.optimisticData : this.data, rootId: r.id || "ROOT_QUERY", config: this.config }));
    }, t.prototype.watch = function(r) {
      var n = this;
      return this.watches.size || tk(this), this.watches.add(r), r.immediate && this.maybeBroadcastWatch(r), function() {
        n.watches.delete(r) && !n.watches.size && X5(n), n.maybeBroadcastWatch.forget(r);
      };
    }, t.prototype.gc = function(r) {
      var n;
      Qi.reset(), La.reset(), this.addTypenameTransform.resetCache(), (n = this.config.fragments) === null || n === void 0 || n.resetCaches();
      var i = this.optimisticData.gc();
      return r && !this.txCount && (r.resetResultCache ? this.resetResultCache(r.resetResultIdentities) : r.resetResultIdentities && this.storeReader.resetCanon()), i;
    }, t.prototype.retain = function(r, n) {
      return (n ? this.optimisticData : this.data).retain(r);
    }, t.prototype.release = function(r, n) {
      return (n ? this.optimisticData : this.data).release(r);
    }, t.prototype.identify = function(r) {
      if (yt(r))
        return r.__ref;
      try {
        return this.policies.identify(r)[0];
      } catch (n) {
        globalThis.__DEV__ !== !1 && Oe.warn(n);
      }
    }, t.prototype.evict = function(r) {
      if (!r.id) {
        if (hr.call(r, "id"))
          return !1;
        r = j(j({}, r), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(r, this.data);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.reset = function(r) {
      var n = this;
      return this.init(), Qi.reset(), r && r.discardWatches ? (this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), X5(this)) : this.broadcastWatches(), Promise.resolve();
    }, t.prototype.removeOptimistic = function(r) {
      var n = this.optimisticData.removeLayer(r);
      n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
    }, t.prototype.batch = function(r) {
      var n = this, i = r.update, a = r.optimistic, o = a === void 0 ? !0 : a, s = r.removeOptimistic, l = r.onWatchUpdated, d, u = function(h) {
        var f = n, p = f.data, g = f.optimisticData;
        ++n.txCount, h && (n.data = n.optimisticData = h);
        try {
          return d = i(n);
        } finally {
          --n.txCount, n.data = p, n.optimisticData = g;
        }
      }, c = /* @__PURE__ */ new Set();
      return l && !this.txCount && this.broadcastWatches(j(j({}, r), { onWatchUpdated: function(h) {
        return c.add(h), !1;
      } })), typeof o == "string" ? this.optimisticData = this.optimisticData.addLayer(o, u) : o === !1 ? u(this.data) : u(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), l && c.size ? (this.broadcastWatches(j(j({}, r), { onWatchUpdated: function(h, f) {
        var p = l.call(this, h, f);
        return p !== !1 && c.delete(h), p;
      } })), c.size && c.forEach(function(h) {
        return n.maybeBroadcastWatch.dirty(h);
      })) : this.broadcastWatches(r), d;
    }, t.prototype.performTransaction = function(r, n) {
      return this.batch({
        update: r,
        optimistic: n || n !== null
      });
    }, t.prototype.transformDocument = function(r) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(r));
    }, t.prototype.fragmentMatches = function(r, n) {
      return this.policies.fragmentMatches(r, n);
    }, t.prototype.lookupFragment = function(r) {
      var n;
      return ((n = this.config.fragments) === null || n === void 0 ? void 0 : n.lookup(r)) || null;
    }, t.prototype.broadcastWatches = function(r) {
      var n = this;
      this.txCount || this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch(i, r);
      });
    }, t.prototype.addFragmentsToDocument = function(r) {
      var n = this.config.fragments;
      return n ? n.transform(r) : r;
    }, t.prototype.addTypenameToDocument = function(r) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(r) : r;
    }, t.prototype.broadcastWatch = function(r, n) {
      var i = r.lastDiff, a = this.diff(r);
      n && (r.optimistic && typeof n.optimistic == "string" && (a.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, r, a, i) === !1) || (!i || !Dt(i.result, a.result)) && r.callback(r.lastDiff = a, i);
    }, t;
  }(f9)
);
globalThis.__DEV__ !== !1 && (S9.prototype.getMemoryInternals = sw);
var gt;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(gt || (gt = {}));
function Ho(e) {
  return e ? e < 7 : !1;
}
var d3 = Object.assign, lk = Object.hasOwnProperty, b2 = (
  /** @class */
  function(e) {
    ri(t, e);
    function t(r) {
      var n = r.queryManager, i = r.queryInfo, a = r.options, o = e.call(this, function(v) {
        try {
          var m = v._subscription._observer;
          m && !m.error && (m.error = dk);
        } catch {
        }
        var $ = !o.observers.size;
        o.observers.add(v);
        var w = o.last;
        return w && w.error ? v.error && v.error(w.error) : w && w.result && v.next && v.next(o.maskResult(w.result)), $ && o.reobserve().catch(function() {
        }), function() {
          o.observers.delete(v) && !o.observers.size && o.tearDownQuery();
        };
      }) || this;
      o.observers = /* @__PURE__ */ new Set(), o.subscriptions = /* @__PURE__ */ new Set(), o.queryInfo = i, o.queryManager = n, o.waitForOwnResult = W0(a.fetchPolicy), o.isTornDown = !1, o.subscribeToMore = o.subscribeToMore.bind(o), o.maskResult = o.maskResult.bind(o);
      var s = n.defaultOptions.watchQuery, l = s === void 0 ? {} : s, d = l.fetchPolicy, u = d === void 0 ? "cache-first" : d, c = a.fetchPolicy, h = c === void 0 ? u : c, f = a.initialFetchPolicy, p = f === void 0 ? h === "standby" ? u : h : f;
      o.options = j(j({}, a), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: p,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: h
      }), o.queryId = i.queryId || n.generateQueryId();
      var g = Ba(o.query);
      return o.queryName = g && g.name && g.name.value, o;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var r = this;
      return new Promise(function(n, i) {
        var a = {
          next: function(s) {
            n(s), r.observers.delete(a), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              o.unsubscribe();
            }, 0);
          },
          error: i
        }, o = r.subscribe(a);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(r) {
      r === void 0 && (r = !0);
      var n = this.getLastResult(!0), i = this.queryInfo.networkStatus || n && n.networkStatus || gt.ready, a = j(j({}, n), { loading: Ho(i), networkStatus: i }), o = this.options.fetchPolicy, s = o === void 0 ? "cache-first" : o;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(W0(s) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var l = this.queryInfo.getDiff();
        (l.complete || this.options.returnPartialData) && (a.data = l.result), Dt(a.data, {}) && (a.data = void 0), l.complete ? (delete a.partial, l.complete && a.networkStatus === gt.loading && (s === "cache-first" || s === "cache-only") && (a.networkStatus = gt.ready, a.loading = !1)) : a.partial = !0, a.networkStatus === gt.ready && (a.error || a.errors) && (a.networkStatus = gt.error), globalThis.__DEV__ !== !1 && !l.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && T9(l.missing);
      }
      return r && this.updateLastResult(a), a;
    }, t.prototype.getCurrentResult = function(r) {
      return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
    }, t.prototype.isDifferentFromLastResult = function(r, n) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), a = this.queryManager.dataMasking, o = a ? i.nonReactiveQuery : this.query, s = a || i.hasNonreactiveDirective ? !s9(o, this.last.result, r, this.variables) : !Dt(this.last.result, r);
      return s || n && !Dt(this.last.variables, n);
    }, t.prototype.getLast = function(r, n) {
      var i = this.last;
      if (i && i[r] && (!n || Dt(i.variables, this.variables)))
        return i[r];
    }, t.prototype.getLastResult = function(r) {
      return this.getLast("result", r);
    }, t.prototype.getLastError = function(r) {
      return this.getLast("error", r);
    }, t.prototype.resetLastResults = function() {
      delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(r) {
      var n, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, a = this.options.fetchPolicy;
      if (a === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && lk.call(r, "variables")) {
        var o = M4(this.query), s = o.variableDefinitions;
        (!s || !s.some(function(l) {
          return l.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && Oe.warn(
          21,
          r,
          ((n = o.name) === null || n === void 0 ? void 0 : n.value) || o
        );
      }
      return r && !Dt(this.options.variables, r) && (i.variables = this.options.variables = j(j({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, gt.refetch);
    }, t.prototype.fetchMore = function(r) {
      var n = this, i = j(j({}, r.query ? r : j(j(j(j({}, this.options), { query: this.options.query }), r), { variables: j(j({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var a = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : i.query;
      var o = this.queryInfo, s = o.networkStatus;
      o.networkStatus = gt.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), d = r?.updateQuery, u = this.options.fetchPolicy !== "no-cache";
      return u || Oe(d, 22), this.queryManager.fetchQuery(a, i, gt.fetchMore).then(function(c) {
        if (n.queryManager.removeQuery(a), o.networkStatus === gt.fetchMore && (o.networkStatus = s), u)
          n.queryManager.cache.batch({
            update: function(p) {
              var g = r.updateQuery;
              g ? p.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(v) {
                return g(v, {
                  fetchMoreResult: c.data,
                  variables: i.variables
                });
              }) : p.writeQuery({
                query: i.query,
                variables: i.variables,
                data: c.data
              });
            },
            onWatchUpdated: function(p) {
              l.add(p.query);
            }
          });
        else {
          var h = n.getLast("result"), f = d(h.data, {
            fetchMoreResult: c.data,
            variables: i.variables
          });
          n.reportResult(j(j({}, h), { networkStatus: s, loading: Ho(s), data: f }), n.variables);
        }
        return n.maskResult(c);
      }).finally(function() {
        u && !l.has(n.query) && E9(n);
      });
    }, t.prototype.subscribeToMore = function(r) {
      var n = this, i = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(a) {
          var o = r.updateQuery;
          o && n.updateQuery(function(s, l) {
            return o(s, j({ subscriptionData: a }, l));
          });
        },
        error: function(a) {
          if (r.onError) {
            r.onError(a);
            return;
          }
          globalThis.__DEV__ !== !1 && Oe.error(23, a);
        }
      });
      return this.subscriptions.add(i), function() {
        n.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(r) {
      return this.reobserve(r);
    }, t.prototype.silentSetOptions = function(r) {
      var n = ss(this.options, r || {});
      d3(this.options, n);
    }, t.prototype.setVariables = function(r) {
      return Dt(this.variables, r) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, gt.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(r) {
      var n = this.queryManager, i = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), a = i.result, o = i.complete, s = r(a, {
        variables: this.variables,
        complete: !!o,
        previousData: a
      });
      s && (n.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), n.broadcastQueries());
    }, t.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(r, n) {
      if (n.nextFetchPolicy) {
        var i = n.fetchPolicy, a = i === void 0 ? "cache-first" : i, o = n.initialFetchPolicy, s = o === void 0 ? a : o;
        a === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(a, {
          reason: r,
          options: n,
          observable: this,
          initialFetchPolicy: s
        }) : r === "variables-changed" ? n.fetchPolicy = s : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, t.prototype.fetch = function(r, n, i) {
      return this.queryManager.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(this.queryId, r, n, i);
    }, t.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var n = this, i = n.pollingInfo, a = n.options.pollInterval;
        if (!a || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === a)) {
          Oe(a, 24);
          var o = i || (this.pollingInfo = {});
          o.interval = a;
          var s = function() {
            var d, u;
            r.pollingInfo && (!Ho(r.queryInfo.networkStatus) && !(!((u = (d = r.options).skipPollAttempt) === null || u === void 0) && u.call(d)) ? r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, gt.poll).then(l, l) : l());
          }, l = function() {
            var d = r.pollingInfo;
            d && (clearTimeout(d.timeout), d.timeout = setTimeout(s, d.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(r, n) {
      n === void 0 && (n = this.variables);
      var i = this.getLastError();
      return i && this.last && !Dt(n, this.last.variables) && (i = void 0), this.last = j({ result: this.queryManager.assumeImmutableResults ? r : e9(r), variables: n }, i ? { error: i } : null);
    }, t.prototype.reobserveAsConcast = function(r, n) {
      var i = this;
      this.isTornDown = !1;
      var a = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === gt.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === gt.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === gt.poll
      ), o = this.options.variables, s = this.options.fetchPolicy, l = ss(this.options, r || {}), d = a ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : d3(this.options, l), u = this.transformDocument(d.query);
      this.lastQuery = u, a || (this.updatePolling(), r && r.variables && !Dt(r.variables, o) && // Don't mess with the fetchPolicy if it's currently "standby".
      d.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (d.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof d.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", d), n === void 0 && (n = gt.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = W0(d.fetchPolicy));
      var c = function() {
        i.concast === p && (i.waitForOwnResult = !1);
      }, h = d.variables && j({}, d.variables), f = this.fetch(d, n, u), p = f.concast, g = f.fromLink, v = {
        next: function(m) {
          Dt(i.variables, h) && (c(), i.reportResult(m, h));
        },
        error: function(m) {
          Dt(i.variables, h) && (i9(m) || (m = new $a({ networkError: m })), c(), i.reportError(m, h));
        }
      };
      return !a && (g || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = p, this.observer = v), p.addObserver(v), p;
    }, t.prototype.reobserve = function(r, n) {
      return ex(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      var i = this.last;
      this.resetLastResults();
      var a = this.subscribe.apply(this, r);
      return this.last = i, a;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(r, n) {
      var i = this.getLastError(), a = this.isDifferentFromLastResult(r, n);
      (i || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (i || a) && Cl(this.observers, "next", this.maskResult(r));
    }, t.prototype.reportError = function(r, n) {
      var i = j(j({}, this.getLastResult()), { error: r, errors: r.graphQLErrors, networkStatus: gt.error, loading: !1 });
      this.updateLastResult(i, n), Cl(this.observers, "error", this.last.error = r);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, t.prototype.maskResult = function(r) {
      return r && "data" in r ? j(j({}, r), { data: this.queryManager.maskOperation({
        document: this.query,
        data: r.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : r;
    }, t;
  }(Ot)
);
t9(b2);
function E9(e) {
  var t = e.options, r = t.fetchPolicy, n = t.nextFetchPolicy;
  return r === "cache-and-network" || r === "network-only" ? e.reobserve({
    fetchPolicy: "cache-first",
    // Use a temporary nextFetchPolicy function that replaces itself with the
    // previous nextFetchPolicy value and returns the original fetchPolicy.
    nextFetchPolicy: function(i, a) {
      return this.nextFetchPolicy = n, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(i, a) : r;
    }
  }) : e.reobserve();
}
function dk(e) {
  globalThis.__DEV__ !== !1 && Oe.error(25, e.message, e.stack);
}
function T9(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && Oe.debug(26, e);
}
function W0(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var Mo = new (no ? WeakMap : Map)();
function Q0(e, t) {
  var r = e[t];
  typeof r == "function" && (e[t] = function() {
    return Mo.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (Mo.get(e) + 1) % 1e15
    ), r.apply(this, arguments);
  });
}
function u3(e) {
  e.notifyTimeout && (clearTimeout(e.notifyTimeout), e.notifyTimeout = void 0);
}
var G0 = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.listeners = /* @__PURE__ */ new Set(), this.document = null, this.lastRequestId = 1, this.stopped = !1, this.dirty = !1, this.observableQuery = null;
      var n = this.cache = t.cache;
      Mo.has(n) || (Mo.set(n, 0), Q0(n, "evict"), Q0(n, "modify"), Q0(n, "reset"));
    }
    return e.prototype.init = function(t) {
      var r = t.networkStatus || gt.loading;
      return this.variables && this.networkStatus !== gt.loading && !Dt(this.variables, t.variables) && (r = gt.setVariables), Dt(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: r
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.reset = function() {
      u3(this), this.dirty = !1;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this.getDiffOptions();
      if (this.lastDiff && Dt(t, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var r = this.observableQuery;
      if (r && r.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var n = this.cache.diff(t);
      return this.updateLastDiff(n, t), n;
    }, e.prototype.updateLastDiff = function(t, r) {
      this.lastDiff = t ? {
        diff: t,
        options: r || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var r;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var r = this, n, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && (!((n = this.observableQuery) === null || n === void 0) && n.getLastError()) || (this.updateLastDiff(t), !this.dirty && !Dt(i && i.result, t && t.result) && (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0))));
    }, e.prototype.setObservableQuery = function(t) {
      var r = this;
      t !== this.observableQuery && (this.oqListener && this.listeners.delete(this.oqListener), this.observableQuery = t, t ? (t.queryInfo = this, this.listeners.add(this.oqListener = function() {
        var n = r.getDiff();
        n.fromOptimisticTransaction ? t.observe() : E9(t);
      })) : delete this.oqListener);
    }, e.prototype.notify = function() {
      var t = this;
      u3(this), this.shouldNotify() && this.listeners.forEach(function(r) {
        return r(t);
      }), this.dirty = !1;
    }, e.prototype.shouldNotify = function() {
      if (!this.dirty || !this.listeners.size)
        return !1;
      if (Ho(this.networkStatus) && this.observableQuery) {
        var t = this.observableQuery.options.fetchPolicy;
        if (t !== "cache-only" && t !== "cache-and-network")
          return !1;
      }
      return !0;
    }, e.prototype.stop = function() {
      if (!this.stopped) {
        this.stopped = !0, this.reset(), this.cancel();
        var t = this.observableQuery;
        t && t.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var r = this;
      t === void 0 && (t = this.variables);
      var n = this.observableQuery;
      if (!(n && n.options.fetchPolicy === "no-cache")) {
        var i = j(j({}, this.getDiffOptions(t)), { watcher: this, callback: function(a) {
          return r.setDiff(a);
        } });
        (!this.lastWatch || !Dt(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, r) {
      var n = this.lastWrite;
      return !(n && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      n.dmCount === Mo.get(this.cache) && Dt(r, n.variables) && Dt(t.data, n.result.data));
    }, e.prototype.markResult = function(t, r, n, i) {
      var a = this, o = new Xi(), s = Xn(t.errors) ? t.errors.slice(0) : [];
      if (this.reset(), "incremental" in t && Xn(t.incremental)) {
        var l = r9(this.getDiff().result, t);
        t.data = l;
      } else if ("hasNext" in t && t.hasNext) {
        var d = this.getDiff();
        t.data = o.merge(d.result, t.data);
      }
      this.graphQLErrors = s, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && ($2(t, n.errorPolicy) ? this.cache.performTransaction(function(u) {
        if (a.shouldWrite(t, n.variables))
          u.writeQuery({
            query: r,
            data: t.data,
            variables: n.variables,
            overwrite: i === 1
          }), a.lastWrite = {
            result: t,
            variables: n.variables,
            dmCount: Mo.get(a.cache)
          };
        else if (a.lastDiff && a.lastDiff.diff.complete) {
          t.data = a.lastDiff.diff.result;
          return;
        }
        var c = a.getDiffOptions(n.variables), h = u.diff(c);
        !a.stopped && Dt(a.variables, n.variables) && a.updateWatch(n.variables), a.updateLastDiff(h, c), h.complete && (t.data = h.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = gt.ready;
    }, e.prototype.markError = function(t) {
      return this.networkStatus = gt.error, this.lastWrite = void 0, this.reset(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  }()
);
function $2(e, t) {
  t === void 0 && (t = "none");
  var r = t === "ignore" || t === "all", n = !fu(e);
  return !n && r && e.data && (n = !0), n;
}
var uk = Object.prototype.hasOwnProperty, c3 = /* @__PURE__ */ Object.create(null), ck = (
  /** @class */
  function() {
    function e(t) {
      var r = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new T4(
        $i["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new Si(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var n = new Q4(
        function(a) {
          return r.cache.transformDocument(a);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(r, n) {
        t.stopQueryNoBroadcast(n);
      }), this.cancelPendingFetches(Rr(27));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(r) {
        return r(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return Ve(this, arguments, void 0, function(r) {
        var n, i, a, o, s, l, d, u = r.mutation, c = r.variables, h = r.optimisticResponse, f = r.updateQueries, p = r.refetchQueries, g = p === void 0 ? [] : p, v = r.awaitRefetchQueries, m = v === void 0 ? !1 : v, $ = r.update, w = r.onQueryUpdated, k = r.fetchPolicy, C = k === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : k, E = r.errorPolicy, N = E === void 0 ? ((d = this.defaultOptions.mutate) === null || d === void 0 ? void 0 : d.errorPolicy) || "none" : E, M = r.keepRootFields, V = r.context;
        return Fi(this, function(q) {
          switch (q.label) {
            case 0:
              return Oe(u, 28), Oe(C === "network-only" || C === "no-cache", 29), n = this.generateMutationId(), u = this.cache.transformForLink(this.transform(u)), i = this.getDocumentInfo(u).hasClientExports, c = this.getVariables(u, c), i ? [4, this.localState.addExportedVariables(u, c, V)] : [3, 2];
            case 1:
              c = q.sent(), q.label = 2;
            case 2:
              return a = this.mutationStore && (this.mutationStore[n] = {
                mutation: u,
                variables: c,
                loading: !0,
                error: null
              }), o = h && this.markMutationOptimistic(h, {
                mutationId: n,
                document: u,
                variables: c,
                fetchPolicy: C,
                errorPolicy: N,
                context: V,
                updateQueries: f,
                update: $,
                keepRootFields: M
              }), this.broadcastQueries(), s = this, [2, new Promise(function(I, P) {
                return j0(s.getObservableFromLink(u, j(j({}, V), { optimisticResponse: o ? h : void 0 }), c, {}, !1), function(z) {
                  if (fu(z) && N === "none")
                    throw new $a({
                      graphQLErrors: c2(z)
                    });
                  a && (a.loading = !1, a.error = null);
                  var G = j({}, z);
                  return typeof g == "function" && (g = g(G)), N === "ignore" && fu(G) && delete G.errors, s.markMutationResult({
                    mutationId: n,
                    result: G,
                    document: u,
                    variables: c,
                    fetchPolicy: C,
                    errorPolicy: N,
                    context: V,
                    update: $,
                    updateQueries: f,
                    awaitRefetchQueries: m,
                    refetchQueries: g,
                    removeOptimistic: o ? n : void 0,
                    onQueryUpdated: w,
                    keepRootFields: M
                  });
                }).subscribe({
                  next: function(z) {
                    s.broadcastQueries(), (!("hasNext" in z) || z.hasNext === !1) && I(j(j({}, z), { data: s.maskOperation({
                      document: u,
                      data: z.data,
                      fetchPolicy: C,
                      id: n
                    }) }));
                  },
                  error: function(z) {
                    a && (a.loading = !1, a.error = z), o && s.cache.removeOptimistic(n), s.broadcastQueries(), P(z instanceof $a ? z : new $a({
                      networkError: z
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, r) {
      var n = this;
      r === void 0 && (r = this.cache);
      var i = t.result, a = [], o = t.fetchPolicy === "no-cache";
      if (!o && $2(i, t.errorPolicy)) {
        if (qo(i) || a.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), qo(i) && Xn(i.incremental)) {
          var s = r.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          s.result && (l = r9(s.result, i)), typeof l < "u" && (i.data = l, a.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var d = t.updateQueries;
        d && this.queries.forEach(function(c, h) {
          var f = c.observableQuery, p = f && f.queryName;
          if (!(!p || !uk.call(d, p))) {
            var g = d[p], v = n.queries.get(h), m = v.document, $ = v.variables, w = r.diff({
              query: m,
              variables: $,
              returnPartialData: !0,
              optimistic: !1
            }), k = w.result, C = w.complete;
            if (C && k) {
              var E = g(k, {
                mutationResult: i,
                queryName: m && pl(m) || void 0,
                queryVariables: $
              });
              E && a.push({
                result: E,
                dataId: "ROOT_QUERY",
                query: m,
                variables: $
              });
            }
          }
        });
      }
      if (a.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var u = [];
        if (this.refetchQueries({
          updateCache: function(c) {
            o || a.forEach(function(g) {
              return c.write(g);
            });
            var h = t.update, f = !ax(i) || qo(i) && !i.hasNext;
            if (h) {
              if (!o) {
                var p = c.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: n.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                p.complete && (i = j(j({}, i), { data: p.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              f && h(c, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !o && !t.keepRootFields && f && c.modify({
              id: "ROOT_MUTATION",
              fields: function(g, v) {
                var m = v.fieldName, $ = v.DELETE;
                return m === "__typename" ? g : $;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(c) {
          return u.push(c);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(u).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, r) {
      var n = this, i = typeof t == "function" ? t(r.variables, { IGNORE: c3 }) : t;
      return i === c3 ? !1 : (this.cache.recordOptimisticTransaction(function(a) {
        try {
          n.markMutationResult(j(j({}, r), { result: { data: i } }), a);
        } catch (o) {
          globalThis.__DEV__ !== !1 && Oe.error(o);
        }
      }, r.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, r, n) {
      return this.fetchConcastWithInfo(t, r, n).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(r, n) {
        t[n] = {
          variables: r.variables,
          networkStatus: r.networkStatus,
          networkError: r.networkError,
          graphQLErrors: r.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var r = this.queries.get(t);
      r && (r.networkError = void 0, r.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var r = this.transformCache;
      if (!r.has(t)) {
        var n = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: V$(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: Rl(["nonreactive"], t),
          nonReactiveQuery: qw(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: Y4([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: of(Ba(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: j(j({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? j(j({}, i), { operation: "query" }) : i;
          }) })
        };
        r.set(t, n);
      }
      return r.get(t);
    }, e.prototype.getVariables = function(t, r) {
      return j(j({}, this.getDocumentInfo(t).defaultVars), r);
    }, e.prototype.watchQuery = function(t) {
      var r = this.transform(t.query);
      t = j(j({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var n = new G0(this), i = new b2({
        queryManager: this,
        queryInfo: n,
        options: t
      });
      return i.lastQuery = r, this.queries.set(i.queryId, n), n.init({
        document: r,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, r) {
      var n = this;
      r === void 0 && (r = this.generateQueryId()), Oe(t.query, 30), Oe(t.query.kind === "Document", 31), Oe(!t.returnPartialData, 32), Oe(!t.pollInterval, 33);
      var i = this.transform(t.query);
      return this.fetchQuery(r, j(j({}, t), { query: i })).then(function(a) {
        return a && j(j({}, a), { data: n.maskOperation({
          document: i,
          data: a.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      }).finally(function() {
        return n.stopQuery(r);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var r = this.queries.get(t);
      r && r.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(Rr(34)), this.queries.forEach(function(r) {
        r.observableQuery ? r.networkStatus = gt.loading : r.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = "active");
      var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), a.set(s, !1);
        else if (mw(s)) {
          var l = La(r.transform(s));
          i.set(l, pl(s)), a.set(l, !1);
        } else Ht(s) && s.query && o.add(s);
      }), this.queries.forEach(function(s, l) {
        var d = s.observableQuery, u = s.document;
        if (d) {
          if (t === "all") {
            n.set(l, d);
            return;
          }
          var c = d.queryName, h = d.options.fetchPolicy;
          if (h === "standby" || t === "active" && !d.hasObservers())
            return;
          (t === "active" || c && a.has(c) || u && a.has(La(u))) && (n.set(l, d), c && a.set(c, !0), u && a.set(La(u), !0));
        }
      }), o.size && o.forEach(function(s) {
        var l = J1("legacyOneTimeQuery"), d = r.getQuery(l).init({
          document: s.query,
          variables: s.variables
        }), u = new b2({
          queryManager: r,
          queryInfo: d,
          options: j(j({}, s), { fetchPolicy: "network-only" })
        });
        Oe(u.queryId === l), d.setObservableQuery(u), n.set(l, u);
      }), globalThis.__DEV__ !== !1 && a.size && a.forEach(function(s, l) {
        if (!s) {
          var d = i.get(l);
          d ? globalThis.__DEV__ !== !1 && Oe.warn(35, d) : globalThis.__DEV__ !== !1 && Oe.warn(36);
        }
      }), n;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = !1);
      var n = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, a) {
        var o = i.options.fetchPolicy;
        i.resetLastResults(), (t || o !== "standby" && o !== "cache-only") && n.push(i.refetch()), r.getQuery(a).setDiff(null);
      }), this.broadcastQueries(), Promise.all(n);
    }, e.prototype.setObservableQuery = function(t) {
      this.getQuery(t.queryId).setObservableQuery(t);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var r = this, n = t.query, i = t.variables, a = t.fetchPolicy, o = t.errorPolicy, s = o === void 0 ? "none" : o, l = t.context, d = l === void 0 ? {} : l, u = t.extensions, c = u === void 0 ? {} : u;
      n = this.transform(n), i = this.getVariables(n, i);
      var h = function(p) {
        return r.getObservableFromLink(n, d, p, c).map(function(g) {
          a !== "no-cache" && ($2(g, s) && r.cache.write({
            query: n,
            result: g.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: p
          }), r.broadcastQueries());
          var v = fu(g), m = wx(g);
          if (v || m) {
            var $ = {};
            if (v && ($.graphQLErrors = g.errors), m && ($.protocolErrors = g.extensions[mf]), s === "none" || m)
              throw new $a($);
          }
          return s === "ignore" && delete g.errors, g;
        });
      };
      if (this.getDocumentInfo(n).hasClientExports) {
        var f = this.localState.addExportedVariables(n, i, d).then(h);
        return new Ot(function(p) {
          var g = null;
          return f.then(function(v) {
            return g = v.subscribe(p);
          }, p.error), function() {
            return g && g.unsubscribe();
          };
        });
      }
      return h(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      this.fetchCancelFns.delete(t), this.queries.has(t) && (this.getQuery(t).stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        return t.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, r, n, i, a) {
      var o = this, s;
      a === void 0 && (a = (s = r?.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var l, d = this.getDocumentInfo(t), u = d.serverQuery, c = d.clientQuery;
      if (u) {
        var h = this, f = h.inFlightLinkObservables, p = h.link, g = {
          query: u,
          variables: n,
          operationName: pl(u) || void 0,
          context: this.prepareContext(j(j({}, r), { forceFetch: !a })),
          extensions: i
        };
        if (r = g.context, a) {
          var v = La(u), m = Qi(n), $ = f.lookup(v, m);
          if (l = $.observable, !l) {
            var w = new wo([
              h2(p, g)
            ]);
            l = $.observable = w, w.beforeNext(function k(C, E) {
              C === "next" && "hasNext" in E && E.hasNext ? w.beforeNext(k) : f.remove(v, m);
            });
          }
        } else
          l = new wo([
            h2(p, g)
          ]);
      } else
        l = new wo([Ot.of({ data: {} })]), r = this.prepareContext(r);
      return c && (l = j0(l, function(k) {
        return o.localState.runResolvers({
          document: c,
          remoteResult: k,
          context: r,
          variables: n
        });
      })), l;
    }, e.prototype.getResultsFromLink = function(t, r, n) {
      var i = t.lastRequestId = this.generateRequestId(), a = this.cache.transformForLink(n.query);
      return j0(this.getObservableFromLink(a, n.context, n.variables), function(o) {
        var s = c2(o), l = s.length > 0, d = n.errorPolicy;
        if (i >= t.lastRequestId) {
          if (l && d === "none")
            throw t.markError(new $a({
              graphQLErrors: s
            }));
          t.markResult(o, a, n, r), t.markReady();
        }
        var u = {
          data: o.data,
          loading: !1,
          networkStatus: gt.ready
        };
        return l && d === "none" && (u.data = void 0), l && d !== "ignore" && (u.errors = s, u.networkStatus = gt.error), u;
      }, function(o) {
        var s = i9(o) ? o : new $a({ networkError: o });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, r, n, i) {
      var a = this;
      n === void 0 && (n = gt.loading), i === void 0 && (i = r.query);
      var o = this.getVariables(i, r.variables), s = this.getQuery(t), l = this.defaultOptions.watchQuery, d = r.fetchPolicy, u = d === void 0 ? l && l.fetchPolicy || "cache-first" : d, c = r.errorPolicy, h = c === void 0 ? l && l.errorPolicy || "none" : c, f = r.returnPartialData, p = f === void 0 ? !1 : f, g = r.notifyOnNetworkStatusChange, v = g === void 0 ? !1 : g, m = r.context, $ = m === void 0 ? {} : m, w = Object.assign({}, r, {
        query: i,
        variables: o,
        fetchPolicy: u,
        errorPolicy: h,
        returnPartialData: p,
        notifyOnNetworkStatusChange: v,
        context: $
      }), k = function(V) {
        w.variables = V;
        var q = a.fetchQueryByPolicy(s, w, n);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          w.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          q.sources.length > 0 && s.observableQuery && s.observableQuery.applyNextFetchPolicy("after-fetch", r), q
        );
      }, C = function() {
        return a.fetchCancelFns.delete(t);
      };
      this.fetchCancelFns.set(t, function(V) {
        C(), setTimeout(function() {
          return E.cancel(V);
        });
      });
      var E, N;
      if (this.getDocumentInfo(w.query).hasClientExports)
        E = new wo(this.localState.addExportedVariables(w.query, w.variables, w.context).then(k).then(function(V) {
          return V.sources;
        })), N = !0;
      else {
        var M = k(w.variables);
        N = M.fromLink, E = new wo(M.sources);
      }
      return E.promise.then(C, C), {
        concast: E,
        fromLink: N
      };
    }, e.prototype.refetchQueries = function(t) {
      var r = this, n = t.updateCache, i = t.include, a = t.optimistic, o = a === void 0 ? !1 : a, s = t.removeOptimistic, l = s === void 0 ? o ? J1("refetchQueries") : void 0 : s, d = t.onQueryUpdated, u = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(h, f) {
        u.set(f, {
          oq: h,
          lastDiff: r.getQuery(f).getDiff()
        });
      });
      var c = /* @__PURE__ */ new Map();
      return n && this.cache.batch({
        update: n,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: o && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(h, f, p) {
          var g = h.watcher instanceof G0 && h.watcher.observableQuery;
          if (g) {
            if (d) {
              u.delete(g.queryId);
              var v = d(g, f, p);
              return v === !0 && (v = g.refetch()), v !== !1 && c.set(g, v), v;
            }
            d !== null && u.set(g.queryId, { oq: g, lastDiff: p, diff: f });
          }
        }
      }), u.size && u.forEach(function(h, f) {
        var p = h.oq, g = h.lastDiff, v = h.diff, m;
        if (d) {
          if (!v) {
            var $ = p.queryInfo;
            $.reset(), v = $.getDiff();
          }
          m = d(p, v, g);
        }
        (!d || m === !0) && (m = p.refetch()), m !== !1 && c.set(p, m), f.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(f);
      }), l && this.cache.removeOptimistic(l), c;
    }, e.prototype.maskOperation = function(t) {
      var r, n, i, a = t.document, o = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, l = t.id, d = (r = Ba(a)) === null || r === void 0 ? void 0 : r.operation, u = ((n = d?.[0]) !== null && n !== void 0 ? n : "o") + l;
        this.dataMasking && s === "no-cache" && !Z$(a) && !this.noCacheWarningsByQueryId.has(u) && (this.noCacheWarningsByQueryId.add(u), globalThis.__DEV__ !== !1 && Oe.warn(
          37,
          (i = pl(a)) !== null && i !== void 0 ? i : "Unnamed ".concat(d ?? "operation")
        ));
      }
      return this.dataMasking ? Hx(o, a, this.cache) : o;
    }, e.prototype.maskFragment = function(t) {
      var r = t.data, n = t.fragment, i = t.fragmentName;
      return this.dataMasking ? h9(r, n, this.cache, i) : r;
    }, e.prototype.fetchQueryByPolicy = function(t, r, n) {
      var i = this, a = r.query, o = r.variables, s = r.fetchPolicy, l = r.refetchWritePolicy, d = r.errorPolicy, u = r.returnPartialData, c = r.context, h = r.notifyOnNetworkStatusChange, f = t.networkStatus;
      t.init({
        document: a,
        variables: o,
        networkStatus: n
      });
      var p = function() {
        return t.getDiff();
      }, g = function(k, C) {
        C === void 0 && (C = t.networkStatus || gt.loading);
        var E = k.result;
        globalThis.__DEV__ !== !1 && !u && !Dt(E, {}) && T9(k.missing);
        var N = function(M) {
          return Ot.of(j({ data: M, loading: Ho(C), networkStatus: C }, k.complete ? null : { partial: !0 }));
        };
        return E && i.getDocumentInfo(a).hasForcedResolvers ? i.localState.runResolvers({
          document: a,
          remoteResult: { data: E },
          context: c,
          variables: o,
          onlyRunForcedResolvers: !0
        }).then(function(M) {
          return N(M.data || void 0);
        }) : d === "none" && C === gt.refetch && Array.isArray(k.missing) ? N(void 0) : N(E);
      }, v = s === "no-cache" ? 0 : n === gt.refetch && l !== "merge" ? 1 : 2, m = function() {
        return i.getResultsFromLink(t, v, {
          query: a,
          variables: o,
          context: c,
          fetchPolicy: s,
          errorPolicy: d
        });
      }, $ = h && typeof f == "number" && f !== n && Ho(n);
      switch (s) {
        default:
        case "cache-first": {
          var w = p();
          return w.complete ? {
            fromLink: !1,
            sources: [g(w, t.markReady())]
          } : u || $ ? {
            fromLink: !0,
            sources: [g(w), m()]
          } : { fromLink: !0, sources: [m()] };
        }
        case "cache-and-network": {
          var w = p();
          return w.complete || u || $ ? {
            fromLink: !0,
            sources: [g(w), m()]
          } : { fromLink: !0, sources: [m()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [g(p(), t.markReady())]
          };
        case "network-only":
          return $ ? {
            fromLink: !0,
            sources: [g(p()), m()]
          } : { fromLink: !0, sources: [m()] };
        case "no-cache":
          return $ ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [g(t.getDiff()), m()]
          } : { fromLink: !0, sources: [m()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new G0(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var r = this.localState.prepareContext(t);
      return j(j(j({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
    }, e;
  }()
), hk = (
  /** @class */
  function() {
    function e(t) {
      var r = t.cache, n = t.client, i = t.resolvers, a = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, n && (this.client = n), i && this.addResolvers(i), a && this.setFragmentMatcher(a);
    }
    return e.prototype.addResolvers = function(t) {
      var r = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
        r.resolvers = I5(r.resolvers, n);
      }) : this.resolvers = I5(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return Ve(this, arguments, void 0, function(r) {
        var n = r.document, i = r.remoteResult, a = r.context, o = r.variables, s = r.onlyRunForcedResolvers, l = s === void 0 ? !1 : s;
        return Fi(this, function(d) {
          return n ? [2, this.resolveDocument(n, i.data, a, o, this.fragmentMatcher, l).then(function(u) {
            return j(j({}, i), { data: u.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return Rl(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return K4(t);
    }, e.prototype.prepareContext = function(t) {
      var r = this.cache;
      return j(j({}, t), {
        cache: r,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(n) {
          return r.identify(n);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return Ve(this, arguments, void 0, function(r, n, i) {
        return n === void 0 && (n = {}), i === void 0 && (i = {}), Fi(this, function(a) {
          return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, n) || {}, this.prepareContext(i), n).then(function(o) {
            return j(j({}, n), o.exportedVariables);
          })] : [2, j({}, n)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var r = !1;
      return In(t, {
        Directive: {
          enter: function(n) {
            if (n.name.value === "client" && n.arguments && (r = n.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), r))
              return Pc;
          }
        }
      }), r;
    }, e.prototype.buildRootValueFromCache = function(t, r) {
      return this.cache.diff({
        query: Uw(t),
        variables: r,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, r) {
      return Ve(this, arguments, void 0, function(n, i, a, o, s, l) {
        var d, u, c, h, f, p, g, v, m, $, w;
        return a === void 0 && (a = {}), o === void 0 && (o = {}), s === void 0 && (s = function() {
          return !0;
        }), l === void 0 && (l = !1), Fi(this, function(k) {
          return d = sd(n), u = Cs(n), c = ks(u), h = this.collectSelectionsToResolve(d, c), f = d.operation, p = f ? f.charAt(0).toUpperCase() + f.slice(1) : "Query", g = this, v = g.cache, m = g.client, $ = {
            fragmentMap: c,
            context: j(j({}, a), { cache: v, client: m }),
            variables: o,
            fragmentMatcher: s,
            defaultOperationType: p,
            exportedVariables: {},
            selectionsToResolve: h,
            onlyRunForcedResolvers: l
          }, w = !1, [2, this.resolveSelectionSet(d.selectionSet, w, i, $).then(function(C) {
            return {
              result: C,
              exportedVariables: $.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, r, n, i) {
      return Ve(this, void 0, void 0, function() {
        var a, o, s, l, d, u = this;
        return Fi(this, function(c) {
          return a = i.fragmentMap, o = i.context, s = i.variables, l = [n], d = function(h) {
            return Ve(u, void 0, void 0, function() {
              var f, p;
              return Fi(this, function(g) {
                return !r && !i.selectionsToResolve.has(h) ? [
                  2
                  /*return*/
                ] : od(h, s) ? Ki(h) ? [2, this.resolveField(h, r, n, i).then(function(v) {
                  var m;
                  typeof v < "u" && l.push((m = {}, m[wi(h)] = v, m));
                })] : (Ew(h) ? f = h : (f = a[h.name.value], Oe(f, 19, h.name.value)), f && f.typeCondition && (p = f.typeCondition.name.value, i.fragmentMatcher(n, p, o)) ? [2, this.resolveSelectionSet(f.selectionSet, r, n, i).then(function(v) {
                  l.push(v);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(d)).then(function() {
            return zc(l);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, r, n, i) {
      return Ve(this, void 0, void 0, function() {
        var a, o, s, l, d, u, c, h, f, p = this;
        return Fi(this, function(g) {
          return n ? (a = i.variables, o = t.name.value, s = wi(t), l = o !== s, d = n[s] || n[o], u = Promise.resolve(d), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (c = n.__typename || i.defaultOperationType, h = this.resolvers && this.resolvers[c], h && (f = h[l ? o : s], f && (u = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            vf.withValue(this.cache, f, [
              n,
              Nc(t, a),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, u.then(function(v) {
            var m, $;
            if (v === void 0 && (v = d), t.directives && t.directives.forEach(function(k) {
              k.name.value === "export" && k.arguments && k.arguments.forEach(function(C) {
                C.name.value === "as" && C.value.kind === "StringValue" && (i.exportedVariables[C.value.value] = v);
              });
            }), !t.selectionSet || v == null)
              return v;
            var w = ($ = (m = t.directives) === null || m === void 0 ? void 0 : m.some(function(k) {
              return k.name.value === "client";
            })) !== null && $ !== void 0 ? $ : !1;
            if (Array.isArray(v))
              return p.resolveSubSelectedArray(t, r || w, v, i);
            if (t.selectionSet)
              return p.resolveSelectionSet(t.selectionSet, r || w, v, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, r, n, i) {
      var a = this;
      return Promise.all(n.map(function(o) {
        if (o === null)
          return null;
        if (Array.isArray(o))
          return a.resolveSubSelectedArray(t, r, o, i);
        if (t.selectionSet)
          return a.resolveSelectionSet(t.selectionSet, r, o, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, r) {
      var n = function(o) {
        return !Array.isArray(o);
      }, i = this.selectionsToResolveCache;
      function a(o) {
        if (!i.has(o)) {
          var s = /* @__PURE__ */ new Set();
          i.set(o, s), In(o, {
            Directive: function(l, d, u, c, h) {
              l.name.value === "client" && h.forEach(function(f) {
                n(f) && x5(f) && s.add(f);
              });
            },
            FragmentSpread: function(l, d, u, c, h) {
              var f = r[l.name.value];
              Oe(f, 20, l.name.value);
              var p = a(f);
              p.size > 0 && (h.forEach(function(g) {
                n(g) && x5(g) && s.add(g);
              }), s.add(l), p.forEach(function(g) {
                s.add(g);
              }));
            }
          });
        }
        return i.get(o);
      }
      return a(t);
    }, e;
  }()
), h3 = !1, A9 = (
  /** @class */
  function() {
    function e(t) {
      var r = this, n;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw Rr(16);
      var i = t.uri, a = t.credentials, o = t.headers, s = t.cache, l = t.documentTransform, d = t.ssrMode, u = d === void 0 ? !1 : d, c = t.ssrForceFetchDelay, h = c === void 0 ? 0 : c, f = t.connectToDevTools, p = t.queryDeduplication, g = p === void 0 ? !0 : p, v = t.defaultOptions, m = t.defaultContext, $ = t.assumeImmutableResults, w = $ === void 0 ? s.assumeImmutableResults : $, k = t.resolvers, C = t.typeDefs, E = t.fragmentMatcher, N = t.name, M = t.version, V = t.devtools, q = t.dataMasking, I = t.link;
      I || (I = i ? new o9({ uri: i, credentials: a, headers: o }) : Ss.empty()), this.link = I, this.cache = s, this.disableNetworkFetches = u || h > 0, this.queryDeduplication = g, this.defaultOptions = v || /* @__PURE__ */ Object.create(null), this.typeDefs = C, this.devtoolsConfig = j(j({}, V), { enabled: (n = V?.enabled) !== null && n !== void 0 ? n : f }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), h && setTimeout(function() {
        return r.disableNetworkFetches = !1;
      }, h), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = ef, this.localState = new hk({
        cache: s,
        client: this,
        resolvers: k,
        fragmentMatcher: E
      }), this.queryManager = new ck({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: m,
        documentTransform: l,
        queryDeduplication: g,
        ssrMode: u,
        dataMasking: !!q,
        clientAwareness: {
          name: N,
          version: M
        },
        localState: this.localState,
        assumeImmutableResults: w,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          r.devToolsHookCb && r.devToolsHookCb({
            action: {},
            state: {
              queries: r.queryManager.getQueryStore(),
              mutations: r.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: r.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, r = Symbol.for("apollo.devtools");
        (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this, !h3 && globalThis.__DEV__ !== !1 && (h3 = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var n = window.navigator, i = n && n.userAgent, a = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? a = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (a = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), a && globalThis.__DEV__ !== !1 && Oe.log("Download the Apollo DevTools for a better development experience: %s", a);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = V0(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = j(j({}, t), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = V0(this.defaultOptions.query, t)), Oe(t.fetchPolicy !== "cache-and-network", 17), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = j(j({}, t), { fetchPolicy: "cache-first" })), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = V0(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var r = this, n = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return j(j({}, i), { data: r.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      });
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readQuery(t, r);
    }, e.prototype.watchFragment = function(t) {
      var r;
      return this.cache.watchFragment(j(j({}, t), (r = {}, r[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, r)));
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readFragment(t, r);
    }, e.prototype.writeQuery = function(t) {
      var r = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.writeFragment = function(t) {
      var r = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return h2(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(r) {
          return r();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(r) {
          return r();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var r = this;
      return this.resetStoreCallbacks.push(t), function() {
        r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var r = this;
      return this.clearStoreCallbacks.push(t), function() {
        r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var r = this.queryManager.refetchQueries(t), n = [], i = [];
      r.forEach(function(o, s) {
        n.push(s), i.push(o);
      });
      var a = Promise.all(i);
      return a.queries = n, a.results = i, a.catch(function(o) {
        globalThis.__DEV__ !== !1 && Oe.debug(18, o);
      }), a;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
globalThis.__DEV__ !== !1 && (A9.prototype.getMemoryInternals = ow);
var gu = /* @__PURE__ */ new Map(), w2 = /* @__PURE__ */ new Map(), O9 = !0, Vu = !1;
function I9(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function fk(e) {
  return I9(e.source.body.substring(e.start, e.end));
}
function pk(e) {
  var t = /* @__PURE__ */ new Set(), r = [];
  return e.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var i = n.name.value, a = fk(n.loc), o = w2.get(i);
      o && !o.has(a) ? O9 && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || w2.set(i, o = /* @__PURE__ */ new Set()), o.add(a), t.has(a) || (t.add(a), r.push(n));
    } else
      r.push(n);
  }), j(j({}, e), { definitions: r });
}
function mk(e) {
  var t = new Set(e.definitions);
  t.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
      var a = n[i];
      a && typeof a == "object" && t.add(a);
    });
  });
  var r = e.loc;
  return r && (delete r.startToken, delete r.endToken), e;
}
function gk(e) {
  var t = I9(e);
  if (!gu.has(t)) {
    var r = I$(e, {
      experimentalFragmentVariables: Vu,
      allowLegacyFragmentVariables: Vu
    });
    if (!r || r.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    gu.set(t, mk(pk(r)));
  }
  return gu.get(t);
}
function Ce(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  typeof e == "string" && (e = [e]);
  var n = e[0];
  return t.forEach(function(i, a) {
    i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += e[a + 1];
  }), gk(n);
}
function vk() {
  gu.clear(), w2.clear();
}
function yk() {
  O9 = !1;
}
function bk() {
  Vu = !0;
}
function $k() {
  Vu = !1;
}
var Qs = {
  gql: Ce,
  resetCaches: vk,
  disableFragmentWarnings: yk,
  enableExperimentalFragmentVariables: bk,
  disableExperimentalFragmentVariables: $k
};
(function(e) {
  e.gql = Qs.gql, e.resetCaches = Qs.resetCaches, e.disableFragmentWarnings = Qs.disableFragmentWarnings, e.enableExperimentalFragmentVariables = Qs.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = Qs.disableExperimentalFragmentVariables;
})(Ce || (Ce = {}));
Ce.default = Ce;
function wk(e) {
  return new Ss(function(t, r) {
    var n = An(t, []);
    return new Ot(function(i) {
      var a, o = !1;
      return Promise.resolve(n).then(function(s) {
        return e(s, t.getContext());
      }).then(t.setContext).then(function() {
        o || (a = r(t).subscribe({
          next: i.next.bind(i),
          error: i.error.bind(i),
          complete: i.complete.bind(i)
        }));
      }).catch(i.error.bind(i)), function() {
        o = !0, a && a.unsubscribe();
      };
    });
  });
}
const xk = /[?&]code=[^&]+/, kk = /[?&]state=[^&]+/, _k = /[?&]error=[^&]+/;
class Y0 {
  /**
   * @param config - Photon AuthManager configuration options
   * @remarks - Note, that organization is optional for scenarios in which a provider supports more than themselves.
   */
  constructor({ authentication: t, organization: r, audience: n = "https://api.photon.health", connection: i }) {
    this._getAccessToken = (...a) => Ve(this, [...a], void 0, function* ({ audience: o } = {
      audience: this.audience
    }, s = !1) {
      const l = {
        authorizationParams: Object.assign({ audience: o || this.audience || void 0 }, this.organization ? { organization: this.organization } : {})
      };
      let d;
      try {
        d = yield this.authentication.getTokenSilently(l);
      } catch (u) {
        u.message.includes("Consent required") && (d = yield this.authentication.getTokenWithPopup(l));
      }
      if (!d) {
        const u = Object.assign(Object.assign({}, l), { appState: {
          returnTo: `${window.location.pathname}${window.location.search}`
        } });
        if (yield this.authentication.loginWithRedirect(u), s)
          throw new Error();
        return yield this._getAccessToken({ audience: o }, !0);
      }
      return d;
    }), this.authentication = t, this.organization = r, this.audience = n, this.connection = i;
  }
  /**
   * Performs a login against the specified Auth0 domain
   * @param config - Login configuration
   * @returns
   */
  login(t) {
    return Ve(this, arguments, void 0, function* ({ organizationId: r, invitation: n, connection: i, appState: a }) {
      const o = Object.assign({ authorizationParams: Object.assign(Object.assign(Object.assign(Object.assign({}, this.audience ? { audience: this.audience } : {}), i || this.connection ? { connection: i || this.connection } : {}), r || this.organization ? { organization: r || this.organization } : {}), n ? { invitation: n } : {}) }, a ? { appState: a } : {});
      return this.authentication.loginWithRedirect(o);
    });
  }
  /**
   * Performs a logout against the specified Auth0 domain
   * @param config - Logout configuration
   * @returns
   */
  logout(t) {
    return Ve(this, arguments, void 0, function* ({ returnTo: r, federated: n = !1 }) {
      const i = {
        logoutParams: Object.assign(Object.assign({}, r ? { returnTo: r } : {}), n ? { federated: n } : {})
      };
      return this.authentication.logout(i);
    });
  }
  /**
   * Determines if URL has Auth0 parameters
   * @returns boolean
   */
  hasAuthParams(t = window.location.search) {
    return (xk.test(t) || _k.test(t)) && kk.test(t);
  }
  /**
   * Retrieves a valid access token
   * @param config - getAccessToken configuration
   * @returns
   */
  getAccessToken() {
    return Ve(this, arguments, void 0, function* ({ audience: t } = {
      audience: this.audience
    }) {
      return yield this._getAccessToken({ audience: t ?? this.audience });
    });
  }
  /**
   * Retrieves a valid access token
   * @param config - getAccessToken configuration
   * @returns
   */
  getAccessTokenWithConsent() {
    return Ve(this, arguments, void 0, function* ({ audience: t } = {
      audience: this.audience
    }) {
      const r = {
        authorizationParams: Object.assign({ audience: t || this.audience || void 0 }, this.organization ? { organization: this.organization } : {})
      };
      return this.authentication.getTokenWithPopup(r);
    });
  }
  /**
   * Silently performs a getAccessToken and pre-populates the token and user information caches
   * @returns
   */
  checkSession() {
    return Ve(this, void 0, void 0, function* () {
      const t = {
        authorizationParams: Object.assign({ audience: this.audience || void 0 }, this.organization ? { organization: this.organization } : {})
      };
      return this.authentication.checkSession(t);
    });
  }
  /**
   * Handes Auth0 redirect after login
   * @param url - The url which contains the code and state parameters (defaults to window.location.href)
   * @returns
   */
  handleRedirect(t) {
    return Ve(this, void 0, void 0, function* () {
      try {
        return this.authentication.handleRedirectCallback(t);
      } catch (r) {
        console.error(r);
      }
    });
  }
  /**
   * Retrieves information about the currently authenticated user
   * @returns
   */
  getUser() {
    return Ve(this, void 0, void 0, function* () {
      return this.authentication.getUser();
    });
  }
  /**
   * Determines whether or not a user is currently logged in
   * @returns
   */
  isAuthenticated() {
    return Ve(this, void 0, void 0, function* () {
      try {
        return yield this.authentication.checkSession(), yield this.authentication.isAuthenticated();
      } catch {
        return !1;
      }
    });
  }
}
const Ld = Ce`
  fragment OrganizationFields on Organization {
    id
    name
  }
`, ui = Ce`
  fragment PatientFields on Patient {
    id
    externalId
    name {
      full
    }
    dateOfBirth
    sex
    gender
    email
    phone
    address {
      name {
        full
      }
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`, f3 = Ce`
  fragment AllergenFields on Allergen {
    id
    name
    rxcui
  }
`, Fd = Ce`
  fragment CatalogFields on Catalog {
    id
    name
  }
`, za = Ce`
  fragment MedicationFields on Medication {
    id
    name
    form
    schedule
    controlled
  }
`, K0 = Ce`
  fragment SearchMedicationFields on SearchMedication {
    id
    name
  }
`, p3 = Ce`
  fragment MedicalEquipmentFields on MedicalEquipment {
    id
    name
  }
`;
Ce`
  fragment CatalogTreatmentFields on Catalog {
    treatments {
      id
      name
    }
  }
`;
const m3 = Ce`
  fragment DispenseUnitFields on DispenseUnit {
    name
  }
`, Ck = Ce`
  fragment FillPrescriptionFields on Fill {
    id
    state
    requestedAt
    filledAt
    order {
      id
      createdAt
      state
      fulfillment {
        state
      }
      pharmacy {
        id
        name
        address {
          street1
          street2
          city
          state
          postalCode
        }
      }
    }
  }
`, Gs = Ce`
  ${Ck}
  fragment PrescriptionFields on Prescription {
    id
    externalId
    fills {
      ...FillPrescriptionFields
    }
    prescriber {
      id
      name {
        full
      }
    }
    patient {
      id
      name {
        full
      }
    }
    state
    treatment {
      id
      name
    }
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    fillsAllowed
    fillsRemaining
    daysSupply
    instructions
    notes
    effectiveDate
    expirationDate
    writtenAt
  }
`, Sk = Ce`
  fragment FillFields on Fill {
    id
    prescription {
      id
    }
    treatment {
      name
    }
    state
    requestedAt
    filledAt
  }
`, Ys = Ce`
  ${ui}
  ${Sk}
  fragment OrderFields on Order {
    id
    externalId
    state
    fills {
      ...FillFields
    }
    patient {
      ...PatientFields
    }
    pharmacy {
      id
      name
      phone
      address {
        city
        country
        postalCode
        state
        street1
        street2
      }
    }
    fulfillment {
      type
      state
      carrier
      trackingNumber
    }
    createdAt
  }
`, Z0 = Ce`
  fragment WebhookFields on WebhookConfig {
    id
    name
    filters
    url
  }
`, g3 = Ce`
  fragment ClientFields on Client {
    id
    name
    secret
    appType
  }
`, Rd = Ce`
  fragment PharmacyFields on Pharmacy {
    id
    NPI
    NCPDP
    name
    fulfillmentTypes
    address {
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`, X0 = Ce`
  fragment PrescriptionTemplateFields on PrescriptionTemplate {
    id
    daysSupply
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    instructions
    notes
    fillsAllowed
    treatment {
      id
      name
    }
    isPrivate
  }
`;
function Ft(e, t) {
  return Ve(this, arguments, void 0, function* (r, n, i = {}, a = "network-only") {
    const o = yield r.query({
      query: n,
      variables: i,
      fetchPolicy: a
    });
    return Object.assign(Object.assign({}, o), { refetch: (s) => r.query({ query: n, variables: Object.assign(i, s) }), fetchMore: ({ after: s, first: l }) => r.query({
      query: n,
      variables: Object.assign(i, { after: s, first: l })
    }) });
  });
}
function Yr(e, t) {
  return ({ variables: r, refetchQueries: n, awaitRefetchQueries: i = !1 }) => e.mutate({
    mutation: t,
    refetchQueries: n,
    awaitRefetchQueries: i,
    variables: r
  });
}
const x2 = {
  tau: "https://app.boson.health",
  boson: "https://app.boson.health",
  neutron: "https://app.neutron.health",
  photon: "https://app.photon.health"
}, zd = {
  tau: "https://api.boson.health",
  boson: "https://api.boson.health",
  neutron: "https://api.neutron.health",
  photon: "https://api.photon.health"
}, v3 = {
  tau: "http://clinical-api.tau.health:8080",
  boson: "https://clinical-api.boson.health",
  neutron: "https://clinical-api.neutron.health",
  photon: "https://clinical-api.photon.health"
};
function Ek(e) {
  const t = Object.keys(x2).find((r) => e.toLowerCase().includes(r));
  return x2[t || "photon"];
}
class Tk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all catalogs based on currently authenticated organization
   * @param options - Query options
   * @returns
   */
  getCatalogs() {
    return Ve(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { CatalogFields: Fd }
    }) {
      t || (t = { CatalogFields: Fd });
      const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      query catalogs {
        catalogs {
          ...${r}
        }
      }
    `;
      return Ft(this.apollo, i);
    });
  }
  /**
   * Retrieves catalog by id
   * @param options - Query options
   * @returns
   */
  getCatalog() {
    return Ve(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { CatalogFields: Fd }
    }) {
      r || (r = { CatalogFields: Fd });
      const [n, i] = Object.entries(r)[0], a = Ce`
      ${i}
      query catalog($id: ID) {
        catalog(id: $id) {
          ...${n}
        }
      }
    `;
      return Ft(this.apollo, a, { id: t });
    });
  }
  /**
   * Adds a treatment to a catalog
   * @param options - Query options
   * @returns
   */
  addToCatalog({ fragment: t }) {
    t || (t = { MedicationFields: za });
    const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      mutation addToCatalog(
        $catalogId: ID!
        $treatmentId: ID!
      ) {
        addToCatalog(
          catalogId: $catalogId
          treatmentId: $treatmentId
        ) {
          ...${r}
        }
      }
    `;
    return Yr(this.apollo, i);
  }
  /**
   * Removes a treatment from a catalog
   * @param options - Query options
   * @returns
   */
  removeFromCatalog({ fragment: t }) {
    t || (t = { MedicationFields: za });
    const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      mutation removeFromCatalog(
        $catalogId: ID!
        $treatmentId: ID!
      ) {
        removeFromCatalog(
          catalogId: $catalogId
          treatmentId: $treatmentId
        ) {
          ...${r}
        }
      }
    `;
    return Yr(this.apollo, i);
  }
}
class Ak {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all medications, optionally filtered by name, type, and code
   * @param options - Query options
   * @returns
   */
  getMedications() {
    return Ve(this, arguments, void 0, function* ({ filter: t, after: r, first: n, fragment: i } = {
      fragment: { MedicationFields: za }
    }) {
      i || (i = { MedicationFields: za });
      const [a, o] = Object.entries(i)[0], s = Ce`
      ${o}
      query medications($filter: MedicationFilter, $after: ID, $first: Int) {
        medications(filter: $filter, after: $after, first: $first) {
          ...${a}
    }
  }
    `;
      return Ft(this.apollo, s, {
        filter: t,
        after: r,
        first: n
      });
    });
  }
}
class Ok {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all medical equipment, optionally filtered by name, type, and code
   * @param options - Query options
   * @returns
   */
  getMedicalEquipment() {
    return Ve(this, arguments, void 0, function* ({ name: t, after: r, first: n, fragment: i } = {
      fragment: { MedicalEquipmentFields: p3 }
    }) {
      i || (i = { MedicalEquipmentFields: p3 });
      const [a, o] = Object.entries(i)[0], s = Ce`
      ${o}
      query medicalEquipment($name: String, $after: ID, $first: Int) {
        medicalEquipment(name: $name, after: $after, first: $first) {
          ...${a}
    }
  }
    `;
      return Ft(this.apollo, s, {
        name: t,
        after: r,
        first: n
      });
    });
  }
}
class Ik {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all orders in a paginated fashion, optionally filtered by patientId, patientName
   * @param options - Query options
   * @returns
   */
  getOrders() {
    return Ve(this, arguments, void 0, function* ({ patientId: t, patientName: r, after: n, first: i, fragment: a } = {
      first: 25,
      fragment: { OrderFields: Ys }
    }) {
      i || (i = 25), a || (a = { OrderFields: Ys });
      const [o, s] = Object.entries(a)[0], l = Ce`
        ${s}
        query orders(
          $patientId: ID
          $patientName: String
          $after: ID
          $first: Int
      ) {
          orders(
              filter: {
                  patientId: $patientId
                  patientName: $patientName
              }
              after: $after
              first: $first
          ) {
              ...${o}
          }
        }
      `;
      return Ft(this.apollo, l, {
        patientId: t,
        patientName: r,
        after: n,
        first: i
      });
    });
  }
  /**
   * Retrieves order by id
   * @param options - Query options
   * @returns
   */
  getOrder() {
    return Ve(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { OrderFields: Ys }
    }) {
      r || (r = { OrderFields: Ys });
      const [n, i] = Object.entries(r)[0], a = Ce`
        ${i}
        query order($id: ID!) {
          order(id: $id) {
            ...${n}
          }
        }
      `;
      return Ft(this.apollo, a, { id: t });
    });
  }
  /**
   * Creates a new order
   * @param options - Query options
   * @returns
   */
  createOrder({ fragment: t }) {
    t || (t = { OrderFields: Ys });
    const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      mutation createOrder(
        $externalId: ID
        $patientId: ID!
        $fills: [FillInput!]!
        $address: AddressInput!
        $pharmacyId: ID!
        $groupId: ID
      ) {
        createOrder(
          externalId: $externalId
          patientId: $patientId
          fills: $fills
          address: $address
          pharmacyId: $pharmacyId
          groupId: $groupId
        ) {
          ...${r}
        }
      }
    `;
    return Yr(this.apollo, i);
  }
}
class Pk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves patient by id
   * @param options - Query options
   * @returns
   */
  getPatient() {
    return Ve(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { PatientFields: ui }
    }) {
      r || (r = { PatientFields: ui });
      const [n, i] = Object.entries(r)[0], a = Ce`
      ${i}
      query patient($id: ID!) {
        patient(id: $id) {
          ...${n}
        }
      }
    `;
      return Ft(this.apollo, a, { id: t });
    });
  }
  /**
   * Retrieves all patients in a paginated fashion, optionally filtered by name
   * @param options - Query options
   * @returns
   */
  getPatients() {
    return Ve(this, arguments, void 0, function* ({ after: t, first: r, name: n, fragment: i } = {
      first: 25,
      fragment: { PatientFields: ui }
    }) {
      i || (i = { PatientFields: ui }), r || (r = 25);
      const [a, o] = Object.entries(i)[0], s = Ce`
      ${o}
      query patients($after: ID, $name: String, $first: Int) {
        patients(after: $after, first: $first, filter: { name: $name }) {
          ...${a}
        }
      }
    `;
      return Ft(this.apollo, s, {
        after: t,
        name: n,
        first: r
      });
    });
  }
  /**
   * Creates a new patient
   * @param options - Query options
   * @returns
   */
  createPatient({ fragment: t }) {
    t || (t = { PatientFields: ui });
    const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      mutation createPatient(
        $externalId: ID
        $name: NameInput!
        $dateOfBirth: AWSDate!
        $sex: SexType!
        $gender: String
        $email: AWSEmail
        $phone: AWSPhone!
        $address: AddressInput
        $allergies: [AllergenInput]
        $medicationHistory: [MedHistoryInput]
        $preferredPharmacies: [ID]
      ) {
        createPatient(
          externalId: $externalId
          name: $name
          dateOfBirth: $dateOfBirth
          sex: $sex
          gender: $gender
          address: $address
          email: $email
          phone: $phone
          allergies: $allergies
          medicationHistory: $medicationHistory
          preferredPharmacies: $preferredPharmacies
        ) {
          ...${r}
        }
      }`;
    return Yr(this.apollo, i);
  }
  /**
   * Updates an existing patient
   * @param options - Query options
   * @returns
   */
  updatePatient({ fragment: t }) {
    t || (t = { PatientFields: ui });
    const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      mutation updatePatient(
        $id: ID!
        $externalId: ID
        $name: NameInput
        $dateOfBirth: AWSDate
        $sex: SexType
        $gender: String
        $email: AWSEmail
        $phone: AWSPhone
        $allergies: [AllergenInput]
        $medicationHistory: [MedHistoryInput]
        $address: AddressInput
        $preferredPharmacies: [ID]
      ) {
        updatePatient(
          id: $id
          externalId: $externalId
          name: $name
          dateOfBirth: $dateOfBirth
          sex: $sex
          gender: $gender
          email: $email
          phone: $phone
          allergies: $allergies
          medicationHistory: $medicationHistory
          address: $address,
          preferredPharmacies: $preferredPharmacies
        ) {
          ...${r}
        }
      }`;
    return Yr(this.apollo, i);
  }
  /**
   * Adds a preferred pharmcy to a patient
   * @param options - Query options
   * @returns
   */
  removePatientPreferredPharmacy({ fragment: t }) {
    t || (t = { PatientFields: ui });
    const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      mutation removePatientPreferredPharmacy(
        $patientId: ID!
        $pharmacyId: ID!
      ) {
        removePatientPreferredPharmacy(
          patientId: $patientId
          pharmacyId: $pharmacyId
        ) {
          ...${r}
        }
      }`;
    return Yr(this.apollo, i);
  }
  /**
   * Removes an allergen from a patient
   * @param options - Query options
   * @returns
   */
  removePatientAllergy({ fragment: t }) {
    t || (t = { PatientFields: ui });
    const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      mutation removePatientAllergy(
        $id: ID!
        $allergenId: ID!
      ) {
        updatePatient(
          id: $id
          allergenId: $allergenId
        ) {
          ...${r}
        }
      }`;
    return Yr(this.apollo, i);
  }
}
class Dk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all pharmacies, optionally filtered by pharmacy name, in a given latitude/longitude/radius
   * @param options - Query options
   * @returns
   */
  getPharmacies() {
    return Ve(this, arguments, void 0, function* ({ name: t, location: r, type: n, after: i, first: a, fragment: o } = {
      first: 100,
      fragment: { PharmacyFields: Rd }
    }) {
      a || (a = 100), o || (o = { PharmacyFields: Rd });
      const [s, l] = Object.entries(o)[0], d = Ce`
      ${l}
      query pharmacies($name: String, $location: LatLongSearch, $type: FulfillmentType, $after: Int, $first: Int) {
        pharmacies(name: $name, location: $location, type: $type, after: $after, first: $first) {
          ...${s}
        }
      }
    `;
      return Ft(this.apollo, d, {
        name: t,
        location: r,
        type: n,
        after: i,
        first: a
      });
    });
  }
  /**
   * Retrieves pharmacy by id
   * @param options - Query options
   * @returns
   */
  getPharmacy() {
    return Ve(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { PharmacyFields: Rd }
    }) {
      r || (r = { PharmacyFields: Rd });
      const [n, i] = Object.entries(r)[0], a = Ce`
          ${i}
          query pharmacy($id: ID!) {
            pharmacy(id: $id) {
              ...${n}
            }
          }
        `;
      return Ft(this.apollo, a, { id: t });
    });
  }
}
class Mk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  getPrescriptions() {
    return Ve(this, arguments, void 0, function* ({ patientId: t, patientName: r, prescriberId: n, state: i, after: a, first: o, fragment: s } = {
      first: 25,
      fragment: { PrescriptionFields: Gs }
    }) {
      s || (s = { PrescriptionFields: Gs }), o || (o = 25);
      const [l, d] = Object.entries(s)[0], u = Ce`
      ${d}
      query prescriptions(
        $patientId: ID
        $patientName: String
        $prescriberId: ID
        $state: PrescriptionState
        $after: ID
        $first: Int
      ) {
        prescriptions(
          filter: {
            patientId: $patientId
            patientName: $patientName
            prescriberId: $prescriberId
            state: $state
          }
          after: $after
          first: $first
        ) {
          ...${l}
        }
      }
    `;
      return Ft(this.apollo, u, {
        patientId: t,
        patientName: r,
        prescriberId: n,
        state: i,
        after: a,
        first: o
      });
    });
  }
  getPrescription() {
    return Ve(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { PrescriptionFields: Gs }
    }) {
      r || (r = { PrescriptionFields: Gs });
      const [n, i] = Object.entries(r)[0], a = Ce`
      ${i}
      query prescription($id: ID!) {
        prescription(id: $id) {
          ...${n}
        }
      }
    `;
      return Ft(this.apollo, a, {
        id: t
      });
    });
  }
  getDispenseUnits() {
    return Ve(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { DispenseUnitFields: m3 }
    }) {
      t || (t = { DispenseUnitFields: m3 });
      const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      query dispenseUnits {
        dispenseUnits {
          ...${r}
        }
      }
    `;
      return Ft(this.apollo, i, {});
    });
  }
  createPrescription({ fragment: t }) {
    t || (t = { PrescriptionFields: Gs });
    const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      mutation createPrescription(
        $externalId: ID
        $patientId: ID!
        $treatmentId: ID!
        $dispenseAsWritten: Boolean
        $dispenseQuantity: Float!
        $dispenseUnit: String!
        $fillsAllowed: Int!
        $daysSupply: Int
        $instructions: String!
        $notes: String
        $effectiveDate: AWSDate
        $diagnoses: [ID]
      ) {
        createPrescription(
          externalId: $externalId
          patientId: $patientId
          treatmentId: $treatmentId
          dispenseAsWritten: $dispenseAsWritten
          dispenseQuantity: $dispenseQuantity
          dispenseUnit: $dispenseUnit
          fillsAllowed: $fillsAllowed
          daysSupply: $daysSupply
          instructions: $instructions
          notes: $notes
          effectiveDate: $effectiveDate
          diagnoses: $diagnoses
        ) {
          ...${r}
        }
      }`;
    return Yr(this.apollo, i);
  }
}
class Nk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all allergens, optionally filtered by name (fuzzy)
   * @param options - Query options
   * @returns
   */
  getAllergens() {
    return Ve(this, arguments, void 0, function* ({ fragment: t, filter: r } = {
      fragment: { AllergenFields: f3 }
    }) {
      t || (t = { AllergenFields: f3 });
      const [n, i] = Object.entries(t)[0], a = Ce`
        ${i}
        query allergens($filter: AllergenFilter) {
            allergens(filter: $filter) {
                ...${n}
            }
        }
      `;
      return Ft(this.apollo, a, {
        filter: r
      });
    });
  }
}
class Lk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Creates a new prescription template
   * @param options - Query options
   * @returns
   */
  createPrescriptionTemplate({ fragment: t }) {
    t || (t = { PrescriptionTemplateFields: X0 });
    const [r, n] = Object.entries(t)[0], i = Ce`
        ${n}
        mutation createPrescriptionTemplate(
          $catalogId: ID!,
          $treatmentId: ID!,
          $dispenseAsWritten: Boolean,
          $dispenseQuantity: Float,
          $dispenseUnit: String,
          $fillsAllowed: Int,
          $daysSupply: Int,
          $instructions: String,
          $notes: String,
          $name: String,
          $isPrivate: Boolean
        ) {
          createPrescriptionTemplate(
            catalogId: $catalogId
            treatmentId: $treatmentId
            dispenseAsWritten: $dispenseAsWritten
            dispenseQuantity: $dispenseQuantity
            dispenseUnit: $dispenseUnit
            fillsAllowed: $fillsAllowed
            daysSupply: $daysSupply
            instructions: $instructions
            notes: $notes
            name: $name
            isPrivate: $isPrivate
        ) {
            ...${r}
        }
      }
      `;
    return Yr(this.apollo, i);
  }
  /**
   * Updates a prescription template
   * @param options - Query options
   * @returns
   */
  updatePrescriptionTemplate({ fragment: t }) {
    t || (t = { PrescriptionTemplateFields: X0 });
    const [r, n] = Object.entries(t)[0], i = Ce`
        ${n}
        mutation updatePrescriptionTemplate(
          $catalogId: ID!,
          $templateId: ID!,
          $dispenseAsWritten: Boolean,
          $dispenseQuantity: Float,
          $dispenseUnit: String,
          $fillsAllowed: Int,
          $daysSupply: Int,
          $instructions: String,
          $notes: String,
          $name: String
        ) {
          updatePrescriptionTemplate(
            catalogId: $catalogId
            templateId: $templateId
            dispenseAsWritten: $dispenseAsWritten
            dispenseQuantity: $dispenseQuantity
            dispenseUnit: $dispenseUnit
            fillsAllowed: $fillsAllowed
            daysSupply: $daysSupply
            instructions: $instructions
            notes: $notes
            name: $name
        ) {
            ...${r}
        }
      }
      `;
    return Yr(this.apollo, i);
  }
  /**
   * Deletes an existing prescription template
   * @param options - Query options
   * @returns
   */
  deletePrescriptionTemplate({ fragment: t }) {
    t || (t = { PrescriptionTemplateFields: X0 });
    const [r, n] = Object.entries(t)[0], i = Ce`
        ${n}
        mutation deletePrescriptionTemplate(
          $catalogId: ID!,
          $templateId: ID!
        ) {
          deletePrescriptionTemplate(
            catalogId: $catalogId
            templateId: $templateId
        ) {
            ...${r}
        }
      }
      `;
    return Yr(this.apollo, i);
  }
}
class Fk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all medication concepts, filtered by name
   * @param options - Query options
   * @returns
   */
  getConcepts(t) {
    return Ve(this, arguments, void 0, function* ({ name: r, fragment: n }) {
      n || (n = { SearchMedicationFields: K0 });
      const [i, a] = Object.entries(n)[0], o = Ce`
        ${a}
        query medicationConcepts($name: String!) {
          medicationConcepts(name: $name) {
            ...${i}
      }
    }
      `;
      return Ft(this.apollo, o, {
        name: r
      });
    });
  }
  /**
   * Retrieves all strengths for a SearchMedication CONCEPT
   * @param options - Query options
   * @returns
   */
  getStrengths(t) {
    return Ve(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { SearchMedicationFields: K0 });
      const [i, a] = Object.entries(n)[0], o = Ce`
          ${a}
          query medicationStrengths($id: String!) {
            medicationStrengths(id: $id) {
              ...${i}
        }
      }
        `;
      return Ft(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all routes for a SearchMedication STRENGTH
   * @param options - Query options
   * @returns
   */
  getRoutes(t) {
    return Ve(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { SearchMedicationFields: K0 });
      const [i, a] = Object.entries(n)[0], o = Ce`
              ${a}
              query medicationRoutes($id: String!) {
                medicationRoutes(id: $id) {
                  ...${i}
            }
          }
            `;
      return Ft(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all forms for a SearchMedication ROUTE
   * @param options - Query options
   * @returns
   */
  getForms(t) {
    return Ve(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { MedicationFields: za });
      const [i, a] = Object.entries(n)[0], o = Ce`
              ${a}
              query medicationForms($id: String!) {
                medicationForms(id: $id) {
                  ...${i}
            }
          }
            `;
      return Ft(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all products for a SearchMedication FORM/Medication DRUG
   * @param options - Query options
   * @returns
   */
  getProducts(t) {
    return Ve(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { MedicationFields: za });
      const [i, a] = Object.entries(n)[0], o = Ce`
                  ${a}
                  query medicationProducts($id: String!) {
                    medicationProducts(id: $id) {
                      ...${i}
                }
              }
                `;
      return Ft(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all packages for a Medication PRODUCT
   * @param options - Query optiofns
   * @returns
   */
  getPackages(t) {
    return Ve(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { MedicationFields: za });
      const [i, a] = Object.entries(n)[0], o = Ce`
                  ${a}
                  query medicationPackages($id: String!) {
                    medicationPackages(id: $id) {
                      ...${i}
                }
              }
                `;
      return Ft(this.apollo, o, {
        id: r
      });
    });
  }
}
class Rk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.catalog = new Tk(t), this.medication = new Ak(t), this.medicalEquipment = new Ok(t), this.searchMedication = new Fk(t), this.order = new Ik(t), this.patient = new Pk(t), this.pharmacy = new Dk(t), this.prescription = new Mk(t), this.allergens = new Nk(t), this.prescriptionTemplate = new Lk(t);
  }
}
class zk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all Auth0 clients based on currently authenticated organization
   * @param options - Query options
   * @returns
   */
  getClients() {
    return Ve(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { ClientFields: g3 }
    }) {
      const [r, n] = Object.entries(t)[0], i = Ce`
          ${n}
          query clients {
            clients {
              ...${r}
            }
          }
        `;
      return Ft(this.apollo, i);
    });
  }
  /**
   * Rotates client_secret for the authenticated Auth0 organization
   * @param options - Query options
   * @returns
   */
  rotateSecret({ fragment: t }) {
    t || (t = { ClientFields: g3 });
    const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      mutation rotateSecret(
        $id: ID!
      ) {
        rotateSecret(id: $id) {
          ...${r}
        }
      }
    `;
    return Yr(this.apollo, i);
  }
}
class jk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves the organization associated with the authenticated user
   * @param options - Query options
   * @returns
   */
  getOrganization() {
    return Ve(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { OrganizationFields: Ld }
    }) {
      t || (t = { OrganizationFields: Ld });
      const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      query organization {
        organization {
          ...${r}
        }
      }
    `;
      return Ft(this.apollo, i);
    });
  }
  /**
   * Retrieves all organizations associated with the auhenticated user
   * @param options - Query options
   * @returns
   */
  getOrganizations() {
    return Ve(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { OrganizationFields: Ld }
    }) {
      t || (t = { OrganizationFields: Ld });
      const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      query organizations {
        organizations {
          ...${r}
        }
      }
    `;
      return Ft(this.apollo, i);
    });
  }
}
class Vk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves list of webhook associated with currently authenticated organization
   * @param options - Query options
   * @returns
   */
  getWebhooks() {
    return Ve(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { WebhookFields: Z0 }
    }) {
      t || (t = { WebhookFields: Z0 });
      const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      query webhooks {
        webhooks {
          ...${r}
        }
      }
    `;
      return Ft(this.apollo, i);
    });
  }
  /**
   * Creates a new webhook for the authenticated organization
   * @param options - Query options
   * @returns
   */
  createWebhook({ fragment: t }) {
    t || (t = { WebhookFields: Z0 });
    const [r, n] = Object.entries(t)[0], i = Ce`
      ${n}
      mutation createWebhook(
        $name: String
        $filters: [String]
        $sharedSecret: String
        $url: String!
      ) {
        createWebhookConfig(name: $name, filters: $filters, sharedSecret: $sharedSecret, url: $url) {
          ...${r}
        }
      }`;
    return Yr(this.apollo, i);
  }
  /**
   * Deletes a webhook, by id, inside the currently authenticated organization
   * @returns
   */
  deleteWebhook() {
    const t = Ce`
      mutation deleteWebhookConfig($id: String!) {
        deleteWebhookConfig(id: $id)
      }
    `;
    return Yr(this.apollo, t);
  }
}
class Uk {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.client = new zk(t), this.organization = new jk(t), this.webhook = new Vk(t);
  }
}
var y3;
(function(e) {
  e.Drug = "DRUG", e.Package = "PACKAGE", e.Product = "PRODUCT";
})(y3 || (y3 = {}));
var b3;
(function(e) {
  e.Icd10 = "ICD10";
})(b3 || (b3 = {}));
var $3;
(function(e) {
  e.Canceled = "CANCELED", e.New = "NEW", e.Scheduled = "SCHEDULED", e.Sent = "SENT";
})($3 || ($3 = {}));
var w3;
(function(e) {
  e.MailOrder = "MAIL_ORDER", e.PickUp = "PICK_UP";
})(w3 || (w3 = {}));
var x3;
(function(e) {
  e.Otc = "OTC", e.Rx = "RX";
})(x3 || (x3 = {}));
var k3;
(function(e) {
  e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED", e.Routing = "ROUTING";
})(k3 || (k3 = {}));
var _3;
(function(e) {
  e.Pharmacy = "PHARMACY", e.Prescriber = "PRESCRIBER";
})(_3 || (_3 = {}));
var C3;
(function(e) {
  e.Draft = "DRAFT", e.Active = "ACTIVE", e.Depleted = "DEPLETED", e.Expired = "EXPIRED", e.Canceled = "CANCELED";
})(C3 || (C3 = {}));
var S3;
(function(e) {
  e.I = "I", e.Ii = "II", e.Iii = "III", e.Iv = "IV", e.V = "V";
})(S3 || (S3 = {}));
var E3;
(function(e) {
  e.Concept = "CONCEPT", e.Form = "FORM", e.Route = "ROUTE", e.Strength = "STRENGTH";
})(E3 || (E3 = {}));
var T3;
(function(e) {
  e.Female = "FEMALE", e.Male = "MALE", e.Unknown = "UNKNOWN";
})(T3 || (T3 = {}));
const qk = "1.3.4", J0 = {
  version: qk
};
var e1;
const Bk = (e1 = J0?.version) !== null && e1 !== void 0 ? e1 : "unknown";
class Hk {
  /**
   * Constructs a new PhotonSDK instance
   * @param config - Photon SDK configuration options
   * @remarks - Note, that organization is optional for scenarios in which a provider supports more than themselves.
   */
  constructor({ domain: t, clientId: r, redirectURI: n, organization: i, env: a = "photon", audience: o, connection: s, uri: l, developmentMode: d = !1 }, u) {
    this.audience = o || zd[a], this.uri = l || `${zd[a]}/graphql`, this.clinicalUrl = l ? Ek(l) : x2[a], this.clinicalApiUri = `${v3[a]}/graphql`, d && (this.audience = zd.neutron, this.uri = `${zd.neutron}/graphql`, this.clinicalApiUri = `${v3.neutron}/graphql`);
    const c = {
      domain: t || (d ? "auth.neutron.health" : "auth.photon.health"),
      clientId: r,
      cacheLocation: "localstorage",
      useRefreshTokens: !0,
      useRefreshTokensFallback: !0,
      authorizationParams: Object.assign({ redirect_uri: n, audience: this.audience }, s ? { connection: s } : {})
    };
    this.auth0Client = new Xb(c), this.organization = i, this.authentication = new Y0(Object.assign({ authentication: this.auth0Client, organization: this.organization, audience: this.audience }, s ? { connection: s } : {})), this.apollo = this.constructApolloClient({ elementsVersion: u, isServices: !1 }), this.apolloClinical = this.constructApolloClient({ elementsVersion: u, isServices: !0 }), this.clinical = new Rk(this.apollo), this.management = new Uk(this.apollo);
  }
  constructApolloClient({ elementsVersion: t, isServices: r } = {
    isServices: !1
  }) {
    return new A9({
      link: wk((i, a) => Ve(this, void 0, void 0, function* () {
        var { headers: o } = a, s = An(a, ["headers"]);
        const l = yield this.authentication.getAccessToken(), d = Object.assign(Object.assign(Object.assign({}, o), { "x-photon-sdk-version": Bk }), t ? { "x-photon-elements-version": t } : {});
        return l ? Object.assign(Object.assign({}, s), { headers: r ? Object.assign(Object.assign({}, d), { "x-photon-auth-token": l, "x-photon-auth-token-type": "auth0" }) : Object.assign(Object.assign({}, d), { authorization: l }) }) : Object.assign({ headers: d }, s);
      })).concat(new o9({
        uri: r ? this.clinicalApiUri : this.uri
      })),
      defaultOptions: {
        query: {
          fetchPolicy: "cache-first",
          errorPolicy: "all"
        },
        mutate: {
          // Because of the way we do lambdas, we have a _slight_ delay between reads and writes
          // This forces a delay of 1s which isn't the greatest, but also isn't the worst
          // https://github.com/apollographql/apollo-feature-requests/issues/207
          onQueryUpdated: Qk
        }
      },
      cache: new S9({
        // Addresses and names don't have unique ids. So we just allow for merging these
        typePolicies: {
          Patient: {
            fields: {
              name: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              },
              address: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              }
            }
          },
          User: {
            fields: {
              name: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              },
              address: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              }
            }
          }
        }
      })
    });
  }
  /**
   * Sets the organization ID to use
   * @returns PhotonSDK
   */
  setOrganization(t) {
    return this.organization = t, this.authentication = new Y0({
      authentication: this.auth0Client,
      organization: t,
      audience: this.audience
    }), this;
  }
  /**
   * Clears the organization ID
   * @returns PhotonSDK
   */
  clearOrganization() {
    return this.organization = void 0, this.authentication = new Y0({
      authentication: this.auth0Client,
      organization: void 0,
      audience: this.audience
    }), this.authentication.login({}), this;
  }
}
const Wk = (e) => new Promise((t) => setTimeout(t, e)), Qk = (e) => Ve(void 0, void 0, void 0, function* () {
  yield Wk(1e3), e.refetch();
}), Gk = [
  "allowfullscreen",
  "async",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "disabled",
  "formnovalidate",
  "hidden",
  "indeterminate",
  "inert",
  "ismap",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "seamless",
  "selected"
], Yk = /* @__PURE__ */ new Set([
  "className",
  "value",
  "readOnly",
  "formNoValidate",
  "isMap",
  "noModule",
  "playsInline",
  ...Gk
]), Kk = /* @__PURE__ */ new Set([
  "innerHTML",
  "textContent",
  "innerText",
  "children"
]), Zk = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  className: "class",
  htmlFor: "for"
}), Xk = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  class: "className",
  formnovalidate: {
    $: "formNoValidate",
    BUTTON: 1,
    INPUT: 1
  },
  ismap: {
    $: "isMap",
    IMG: 1
  },
  nomodule: {
    $: "noModule",
    SCRIPT: 1
  },
  playsinline: {
    $: "playsInline",
    VIDEO: 1
  },
  readonly: {
    $: "readOnly",
    INPUT: 1,
    TEXTAREA: 1
  }
});
function Jk(e, t) {
  const r = Xk[e];
  return typeof r == "object" ? r[t] ? r.$ : void 0 : r;
}
const e_ = /* @__PURE__ */ new Set([
  "beforeinput",
  "click",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
]), t_ = /* @__PURE__ */ new Set([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animate",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "circle",
  "clipPath",
  "color-profile",
  "cursor",
  "defs",
  "desc",
  "ellipse",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "filter",
  "font",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignObject",
  "g",
  "glyph",
  "glyphRef",
  "hkern",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "metadata",
  "missing-glyph",
  "mpath",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "set",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "textPath",
  "tref",
  "tspan",
  "use",
  "view",
  "vkern"
]), r_ = {
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace"
};
function n_(e, t, r) {
  let n = r.length, i = t.length, a = n, o = 0, s = 0, l = t[i - 1].nextSibling, d = null;
  for (; o < i || s < a; ) {
    if (t[o] === r[s]) {
      o++, s++;
      continue;
    }
    for (; t[i - 1] === r[a - 1]; )
      i--, a--;
    if (i === o) {
      const u = a < n ? s ? r[s - 1].nextSibling : r[a - s] : l;
      for (; s < a; ) e.insertBefore(r[s++], u);
    } else if (a === s)
      for (; o < i; )
        (!d || !d.has(t[o])) && t[o].remove(), o++;
    else if (t[o] === r[a - 1] && r[s] === t[i - 1]) {
      const u = t[--i].nextSibling;
      e.insertBefore(r[s++], t[o++].nextSibling), e.insertBefore(r[--a], u), t[i] = r[a];
    } else {
      if (!d) {
        d = /* @__PURE__ */ new Map();
        let c = s;
        for (; c < a; ) d.set(r[c], c++);
      }
      const u = d.get(t[o]);
      if (u != null)
        if (s < u && u < a) {
          let c = o, h = 1, f;
          for (; ++c < i && c < a && !((f = d.get(t[c])) == null || f !== u + h); )
            h++;
          if (h > u - s) {
            const p = t[o];
            for (; s < u; ) e.insertBefore(r[s++], p);
          } else e.replaceChild(r[s++], t[o++]);
        } else o++;
      else t[o++].remove();
    }
  }
}
const A3 = "_$DX_DELEGATE";
function x(e, t, r, n) {
  let i;
  const a = () => {
    const s = n ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
    return s.innerHTML = e, r ? s.content.firstChild.firstChild : n ? s.firstChild : s.content.firstChild;
  }, o = t ? () => Re(() => document.importNode(i || (i = a()), !0)) : () => (i || (i = a())).cloneNode(!0);
  return o.cloneNode = o, o;
}
function cn(e, t = window.document) {
  const r = t[A3] || (t[A3] = /* @__PURE__ */ new Set());
  for (let n = 0, i = e.length; n < i; n++) {
    const a = e[n];
    r.has(a) || (r.add(a), t.addEventListener(a, u_));
  }
}
function pt(e, t, r) {
  io(e) || (r == null ? e.removeAttribute(t) : e.setAttribute(t, r));
}
function i_(e, t, r, n) {
  io(e) || (n == null ? e.removeAttributeNS(t, r) : e.setAttributeNS(t, r, n));
}
function a_(e, t, r) {
  io(e) || (r ? e.setAttribute(t, "") : e.removeAttribute(t));
}
function ot(e, t) {
  io(e) || (t == null ? e.removeAttribute("class") : e.className = t);
}
function P9(e, t, r, n) {
  if (n)
    Array.isArray(r) ? (e[`$$${t}`] = r[0], e[`$$${t}Data`] = r[1]) : e[`$$${t}`] = r;
  else if (Array.isArray(r)) {
    const i = r[0];
    e.addEventListener(t, r[0] = (a) => i.call(e, r[1], a));
  } else e.addEventListener(t, r, typeof r != "function" && r);
}
function o_(e, t, r = {}) {
  const n = Object.keys(t || {}), i = Object.keys(r);
  let a, o;
  for (a = 0, o = i.length; a < o; a++) {
    const s = i[a];
    !s || s === "undefined" || t[s] || (O3(e, s, !1), delete r[s]);
  }
  for (a = 0, o = n.length; a < o; a++) {
    const s = n[a], l = !!t[s];
    !s || s === "undefined" || r[s] === l || !l || (O3(e, s, !0), r[s] = l);
  }
  return r;
}
function ci(e, t, r) {
  if (!t) return r ? pt(e, "style") : t;
  const n = e.style;
  if (typeof t == "string") return n.cssText = t;
  typeof r == "string" && (n.cssText = r = void 0), r || (r = {}), t || (t = {});
  let i, a;
  for (a in r)
    t[a] == null && n.removeProperty(a), delete r[a];
  for (a in t)
    i = t[a], i !== r[a] && (n.setProperty(a, i), r[a] = i);
  return r;
}
function yn(e, t = {}, r, n) {
  const i = {};
  return n || J(
    () => i.children = Ul(e, t.children, i.children)
  ), J(() => typeof t.ref == "function" && bn(t.ref, e)), J(() => s_(e, t, r, !0, i, !0)), i;
}
function bn(e, t, r) {
  return Re(() => e(t, r));
}
function S(e, t, r, n) {
  if (r !== void 0 && !n && (n = []), typeof t != "function") return Ul(e, t, n, r);
  J((i) => Ul(e, t(), i, r), n);
}
function s_(e, t, r, n, i = {}, a = !1) {
  t || (t = {});
  for (const o in i)
    if (!(o in t)) {
      if (o === "children") continue;
      i[o] = I3(e, o, null, i[o], r, a, t);
    }
  for (const o in t) {
    if (o === "children")
      continue;
    const s = t[o];
    i[o] = I3(e, o, s, i[o], r, a, t);
  }
}
function l_(e) {
  let t, r;
  return !io() || !(t = De.registry.get(r = c_())) ? e() : (De.completed && De.completed.add(t), De.registry.delete(r), t);
}
function io(e) {
  return !!De.context && !De.done && (!e || e.isConnected);
}
function d_(e) {
  return e.toLowerCase().replace(/-([a-z])/g, (t, r) => r.toUpperCase());
}
function O3(e, t, r) {
  const n = t.trim().split(/\s+/);
  for (let i = 0, a = n.length; i < a; i++)
    e.classList.toggle(n[i], r);
}
function I3(e, t, r, n, i, a, o) {
  let s, l, d, u, c;
  if (t === "style") return ci(e, r, n);
  if (t === "classList") return o_(e, r, n);
  if (r === n) return n;
  if (t === "ref")
    a || r(e);
  else if (t.slice(0, 3) === "on:") {
    const h = t.slice(3);
    n && e.removeEventListener(h, n, typeof n != "function" && n), r && e.addEventListener(h, r, typeof r != "function" && r);
  } else if (t.slice(0, 10) === "oncapture:") {
    const h = t.slice(10);
    n && e.removeEventListener(h, n, !0), r && e.addEventListener(h, r, !0);
  } else if (t.slice(0, 2) === "on") {
    const h = t.slice(2).toLowerCase(), f = e_.has(h);
    if (!f && n) {
      const p = Array.isArray(n) ? n[0] : n;
      e.removeEventListener(h, p);
    }
    (f || r) && (P9(e, h, r, f), f && cn([h]));
  } else if (t.slice(0, 5) === "attr:")
    pt(e, t.slice(5), r);
  else if (t.slice(0, 5) === "bool:")
    a_(e, t.slice(5), r);
  else if ((c = t.slice(0, 5) === "prop:") || (d = Kk.has(t)) || !i && ((u = Jk(t, e.tagName)) || (l = Yk.has(t))) || (s = e.nodeName.includes("-") || "is" in o)) {
    if (c)
      t = t.slice(5), l = !0;
    else if (io(e)) return r;
    t === "class" || t === "className" ? ot(e, r) : s && !l && !d ? e[d_(t)] = r : e[u || t] = r;
  } else {
    const h = i && t.indexOf(":") > -1 && r_[t.split(":")[0]];
    h ? i_(e, h, t, r) : pt(e, Zk[t] || t, r);
  }
  return r;
}
function u_(e) {
  if (De.registry && De.events && De.events.find(([l, d]) => d === e))
    return;
  let t = e.target;
  const r = `$$${e.type}`, n = e.target, i = e.currentTarget, a = (l) => Object.defineProperty(e, "target", {
    configurable: !0,
    value: l
  }), o = () => {
    const l = t[r];
    if (l && !t.disabled) {
      const d = t[`${r}Data`];
      if (d !== void 0 ? l.call(t, d, e) : l.call(t, e), e.cancelBubble) return;
    }
    return t.host && typeof t.host != "string" && !t.host._$host && t.contains(e.target) && a(t.host), !0;
  }, s = () => {
    for (; o() && (t = t._$host || t.parentNode || t.host); ) ;
  };
  if (Object.defineProperty(e, "currentTarget", {
    configurable: !0,
    get() {
      return t || document;
    }
  }), De.registry && !De.done && (De.done = _$HY.done = !0), e.composedPath) {
    const l = e.composedPath();
    a(l[0]);
    for (let d = 0; d < l.length - 2 && (t = l[d], !!o()); d++) {
      if (t._$host) {
        t = t._$host, s();
        break;
      }
      if (t.parentNode === i)
        break;
    }
  } else s();
  a(n);
}
function Ul(e, t, r, n, i) {
  const a = io(e);
  if (a) {
    !r && (r = [...e.childNodes]);
    let l = [];
    for (let d = 0; d < r.length; d++) {
      const u = r[d];
      u.nodeType === 8 && u.data.slice(0, 2) === "!$" ? u.remove() : l.push(u);
    }
    r = l;
  }
  for (; typeof r == "function"; ) r = r();
  if (t === r) return r;
  const o = typeof t, s = n !== void 0;
  if (e = s && r[0] && r[0].parentNode || e, o === "string" || o === "number") {
    if (a || o === "number" && (t = t.toString(), t === r))
      return r;
    if (s) {
      let l = r[0];
      l && l.nodeType === 3 ? l.data !== t && (l.data = t) : l = document.createTextNode(t), r = fo(e, r, n, l);
    } else
      r !== "" && typeof r == "string" ? r = e.firstChild.data = t : r = e.textContent = t;
  } else if (t == null || o === "boolean") {
    if (a) return r;
    r = fo(e, r, n);
  } else {
    if (o === "function")
      return J(() => {
        let l = t();
        for (; typeof l == "function"; ) l = l();
        r = Ul(e, l, r, n);
      }), () => r;
    if (Array.isArray(t)) {
      const l = [], d = r && Array.isArray(r);
      if (k2(l, t, r, i))
        return J(() => r = Ul(e, l, r, n, !0)), () => r;
      if (a) {
        if (!l.length) return r;
        if (n === void 0) return r = [...e.childNodes];
        let u = l[0];
        if (u.parentNode !== e) return r;
        const c = [u];
        for (; (u = u.nextSibling) !== n; ) c.push(u);
        return r = c;
      }
      if (l.length === 0) {
        if (r = fo(e, r, n), s) return r;
      } else d ? r.length === 0 ? P3(e, l, n) : n_(e, r, l) : (r && fo(e), P3(e, l));
      r = l;
    } else if (t.nodeType) {
      if (a && t.parentNode) return r = s ? [t] : t;
      if (Array.isArray(r)) {
        if (s) return r = fo(e, r, n, t);
        fo(e, r, null, t);
      } else r == null || r === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
      r = t;
    }
  }
  return r;
}
function k2(e, t, r, n) {
  let i = !1;
  for (let a = 0, o = t.length; a < o; a++) {
    let s = t[a], l = r && r[e.length], d;
    if (!(s == null || s === !0 || s === !1)) if ((d = typeof s) == "object" && s.nodeType)
      e.push(s);
    else if (Array.isArray(s))
      i = k2(e, s, l) || i;
    else if (d === "function")
      if (n) {
        for (; typeof s == "function"; ) s = s();
        i = k2(
          e,
          Array.isArray(s) ? s : [s],
          Array.isArray(l) ? l : [l]
        ) || i;
      } else
        e.push(s), i = !0;
    else {
      const u = String(s);
      l && l.nodeType === 3 && l.data === u ? e.push(l) : e.push(document.createTextNode(u));
    }
  }
  return i;
}
function P3(e, t, r = null) {
  for (let n = 0, i = t.length; n < i; n++) e.insertBefore(t[n], r);
}
function fo(e, t, r, n) {
  if (r === void 0) return e.textContent = "";
  const i = n || document.createTextNode("");
  if (t.length) {
    let a = !1;
    for (let o = t.length - 1; o >= 0; o--) {
      const s = t[o];
      if (i !== s) {
        const l = s.parentNode === e;
        !a && !o ? l ? e.replaceChild(i, s) : e.insertBefore(i, r) : l && s.remove();
      } else a = !0;
    }
  } else e.insertBefore(i, r);
  return [i];
}
function c_() {
  return De.getNextContextId();
}
const h_ = "http://www.w3.org/2000/svg";
function f_(e, t = !1) {
  return t ? document.createElementNS(h_, e) : document.createElement(e);
}
function p_(e, t) {
  const r = L(e);
  return L(() => {
    const n = r();
    switch (typeof n) {
      case "function":
        return Re(() => n(t));
      case "string":
        const i = t_.has(n), a = De.context ? l_() : f_(n, i);
        return yn(a, t, i), a;
    }
  });
}
function m_(e) {
  const [, t] = Ua(e, ["component"]);
  return p_(() => e.component, t);
}
function g_(e, ...t) {
  const r = e.subscribe(...t);
  return r.unsubscribe ? () => r.unsubscribe() : r;
}
function hi(e) {
  let t;
  return g_(e, (r) => t = r)(), t;
}
class v_ extends Error {
  constructor(t, r) {
    super(t), this.name = "FelteSubmitError", this.response = r;
  }
}
function y_(e, t) {
  return Object.keys(e).some((r) => t(e[r]));
}
function jc(e, t) {
  return Object.keys(e || {}).reduce((r, n) => Object.assign(Object.assign({}, r), { [n]: t(e[n]) }), {});
}
function Ye(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Qr(e) {
  return Object.keys(e || {}).reduce((t, r) => Object.assign(Object.assign({}, t), { [r]: Ye(e[r]) ? Qr(e[r]) : Array.isArray(e[r]) ? [...e[r]] : e[r] }), {});
}
function b_(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function $_(e) {
  return function(t) {
    if (Ye(t)) {
      const r = Gr(t, e);
      return b_(r, ["key"]);
    }
    return e;
  };
}
function Gr(e, t) {
  return jc(e, (r) => Ye(r) ? Gr(r, t) : Array.isArray(r) ? r.map($_(t)) : t);
}
function Gi(...e) {
  const t = e.pop(), r = e.shift();
  if (typeof r == "string")
    return r;
  const n = Qr(r);
  if (e.length === 0)
    return n;
  for (const i of e) {
    if (!i)
      continue;
    if (typeof i == "string")
      return i;
    let a = t(n, i);
    if (typeof a < "u")
      return a;
    const o = Array.from(new Set(Object.keys(n).concat(Object.keys(i))));
    for (const s of o)
      if (a = t(n[s], i[s]), typeof a < "u")
        n[s] = a;
      else if (Ye(i[s]) && Ye(n[s]))
        n[s] = Gi(n[s], i[s], t);
      else if (Array.isArray(i[s]))
        n[s] = i[s].map((l, d) => {
          if (!Ye(l))
            return l;
          const u = Array.isArray(n[s]) ? n[s][d] : n[s];
          return Gi(u, l, t);
        });
      else if (Ye(i[s])) {
        const l = Gr(Qr(i[s]), void 0);
        n[s] = Gi(l, i[s], t);
      } else typeof i[s] < "u" && (n[s] = i[s]);
  }
  return n;
}
function w_(e, t) {
  if (!(Ye(e) && Ye(t))) {
    if (Array.isArray(t)) {
      if (t.some(Ye))
        return;
      const r = Array.isArray(e) ? e : [];
      return t.map((n, i) => {
        var a;
        return (a = r[i]) !== null && a !== void 0 ? a : n;
      });
    }
    if (typeof e < "u")
      return e;
  }
}
function D3(...e) {
  return Gi(...e, w_);
}
function D9(...e) {
  return Gi(...e, () => {
  });
}
function Yn(e, t, r) {
  const n = (a) => String.prototype.split.call(t, a).filter(Boolean).reduce((o, s) => o != null ? o[s] : o, e), i = n(/[,[\]]+?/) || n(/[,[\].]+?/);
  return i === void 0 || i === e ? r : i;
}
function Es(e, t, r) {
  e && (e = Qr(e)), Ye(e) || (e = {});
  const n = Array.isArray(t) ? t : t.match(/[^.[\]]+/g) || [], i = n[n.length - 1];
  if (!i)
    return e;
  let a = e;
  for (let o = 0; o < n.length - 1; o++) {
    const s = n[o];
    if (!a[s] || !Ye(a[s]) && !Array.isArray(a[s])) {
      const l = n[o + 1];
      isNaN(Number(l)) ? a[s] = {} : a[s] = [];
    }
    a = a[s];
  }
  return a[i] = r(a[i]), e;
}
function It(e, t, r) {
  return Es(e, t, () => r);
}
function gl(e, t) {
  if (!e || Object(e) !== e)
    return;
  typeof e < "u" && (e = Qr(e));
  const r = Array.isArray(t) ? t : t.toString().match(/[^.[\]]+/g) || [], n = r.length === 1 ? e : Yn(e, r.slice(0, -1).join("."));
  return Array.isArray(n) ? n.splice(Number(r[r.length - 1]), 1) : n == null || delete n[r[r.length - 1]], e;
}
function ql(e, t) {
  return y_(e, (r) => Ye(r) ? ql(r, t) : Array.isArray(r) ? r.length === 0 || r.every((n) => typeof n == "string") ? t(r) : r.some((n) => Ye(n) ? ql(n, t) : t(n)) : t(r));
}
function Wo(e) {
  return e?.nodeName === "INPUT";
}
function x_(e) {
  return e?.nodeName === "TEXTAREA";
}
function Qo(e) {
  return e?.nodeName === "SELECT";
}
function Vc(e) {
  return e?.nodeName === "FIELDSET";
}
function lr(e) {
  return Wo(e) || x_(e) || Qo(e);
}
function _2(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}
function $r(e, t) {
  return lr(e) ? e.name : "";
}
function t1(e) {
  let t = e;
  for (; t && t.nodeName !== "FORM"; ) {
    if (t.hasAttribute("data-felte-ignore"))
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function M3(e, t) {
  return !Ye(e) || !t ? e : typeof t == "string" ? Yn(e, t) : t(e);
}
function k_(e, t) {
  if (!(Ye(e) || Ye(t))) {
    if (e === null || e === "")
      return t;
    if (t === null || t === "" || !t)
      return e;
    if (!(!e || !t)) {
      if (Array.isArray(e)) {
        if (!Array.isArray(t))
          return [...e, t];
        const r = [], n = Math.max(t.length, e.length);
        for (let i = 0; i < n; i++) {
          let a = e[i], o = t[i];
          !Ye(a) && !Ye(o) ? (Array.isArray(a) || (a = [a]), Array.isArray(o) || (o = [o]), r.push(...a, ...o)) : r.push(xo([a ?? {}, o ?? {}]));
        }
        return r.filter(Boolean);
      }
      return Array.isArray(t) || (t = [t]), [e, ...t].reduce((r, n) => r.concat(n), []).filter(Boolean);
    }
  }
}
function xo(e) {
  return Gi(...e, k_);
}
function __(e, t) {
  return t ? (Array.isArray(t) ? t : [t]).map((r) => r(e)) : [];
}
function C2(e, t) {
  return t ? Array.isArray(t) ? t.reduce((r, n) => n(r), e) : t(e) : e;
}
function M9(e = 8) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let r = "";
  for (let n = 0; n < e; n++)
    r += t.charAt(Math.floor(Math.random() * t.length));
  return r;
}
function S2(e, t) {
  if (e === t)
    return !0;
  if (Array.isArray(e) && Array.isArray(t))
    return e.length !== t.length ? !1 : e.every((r, n) => S2(r, t[n]));
  if (Ye(e) && Ye(t)) {
    const r = Object.keys(e), n = Object.keys(t);
    return r.length !== n.length ? !1 : r.every((i) => S2(e[i], t[i]));
  }
  return !1;
}
function Uu(e, t, { onInit: r, onEnd: n } = {}) {
  let i;
  return (...a) => {
    i || r?.(), i && clearTimeout(i), i = setTimeout(() => {
      e.apply(this, a), i = void 0, n?.();
    }, t);
  };
}
function E2(e) {
  if (lr(e))
    return [e];
  if (e.childElementCount === 0)
    return [];
  const t = /* @__PURE__ */ new Set();
  for (const r of e.children) {
    if (lr(r) && t.add(r), Vc(r))
      for (const n of r.elements)
        lr(n) && t.add(n);
    r.childElementCount > 0 && E2(r).forEach((n) => t.add(n));
  }
  return Array.from(t);
}
function N9(e) {
  for (const t of e.elements)
    !lr(t) && !Vc(t) || e.hasAttribute("data-felte-keep-on-remove") && !t.hasAttribute("data-felte-keep-on-remove") && (t.dataset.felteKeepOnRemove = e.dataset.felteKeepOnRemove);
}
function L9(e) {
  return e.type.match(/^(number|range)$/) ? e.value ? +e.value : null : e.value;
}
function N3(e) {
  var t;
  let r = {}, n = {};
  for (const i of e.elements) {
    if (Vc(i) && N9(i), !lr(i) || !i.name)
      continue;
    const a = $r(i);
    if (Wo(i)) {
      if (i.type === "checkbox") {
        if (typeof Yn(r, a) > "u") {
          if (Array.from(e.querySelectorAll(`[name="${i.name}"]`)).filter((s) => lr(s) ? a === $r(s) : !1).length === 1) {
            r = It(r, a, i.checked), n = It(n, a, !1);
            continue;
          }
          r = It(r, a, i.checked ? [i.value] : []), n = It(n, a, !1);
          continue;
        }
        Array.isArray(Yn(r, a)) && i.checked && (r = Es(r, a, (s) => [
          ...s,
          i.value
        ]));
        continue;
      }
      if (i.type === "radio") {
        if (Yn(r, a))
          continue;
        r = It(r, a, i.checked ? i.value : void 0), n = It(n, a, !1);
        continue;
      }
      if (i.type === "file") {
        r = It(r, a, i.multiple ? Array.from(i.files || []) : (t = i.files) === null || t === void 0 ? void 0 : t[0]), n = It(n, a, !1);
        continue;
      }
    } else if (Qo(i)) {
      if (!i.multiple)
        r = It(r, a, i.value);
      else {
        const s = Array.from(i.selectedOptions).map((l) => l.value);
        r = It(r, a, s);
      }
      n = It(n, a, !1);
      continue;
    }
    const o = L9(i);
    r = It(r, a, o), n = It(n, a, !1);
  }
  return { defaultData: r, defaultTouched: n };
}
function vu(e, t) {
  var r;
  if (!lr(e))
    return;
  const n = t;
  if (Wo(e)) {
    if (e.type === "checkbox") {
      const i = n;
      if (typeof i > "u" || typeof i == "boolean") {
        e.checked = !!i;
        return;
      }
      Array.isArray(i) && (i.includes(e.value) ? e.checked = !0 : e.checked = !1);
      return;
    }
    if (e.type === "radio") {
      const i = n;
      e.value === i ? e.checked = !0 : e.checked = !1;
      return;
    }
    if (e.type === "file") {
      if (t instanceof FileList)
        e.files = t;
      else if (t instanceof File && typeof DataTransfer < "u") {
        const i = new DataTransfer();
        i.items.add(t), e.files = i.files;
      } else if (typeof DataTransfer < "u" && Array.isArray(t) && t.some((i) => i instanceof File)) {
        const i = new DataTransfer();
        for (const a of t)
          a instanceof File && i.items.add(a);
        e.files = i.files;
      } else (!t || Array.isArray(t) && !t.length) && (e.files = null, e.value = "");
      return;
    }
  } else if (Qo(e)) {
    if (e.multiple) {
      if (Array.isArray(n)) {
        e.value = String((r = n[0]) !== null && r !== void 0 ? r : "");
        const i = n.map((a) => String(a));
        for (const a of e.options)
          i.includes(a.value) ? a.selected = !0 : a.selected = !1;
      }
    } else {
      e.value = String(n ?? "");
      for (const i of e.options)
        i.value === String(n) ? i.selected = !0 : i.selected = !1;
    }
    return;
  }
  e.value = String(n ?? "");
}
function jd(e, t) {
  for (const r of e.elements) {
    if (Vc(r) && N9(r), !lr(r) || !r.name)
      continue;
    const n = $r(r);
    vu(r, Yn(t, n));
  }
}
const C_ = {
  attributes: !0,
  attributeFilter: ["data-felte-validation-message", "aria-invalid"]
};
function S_(e, t) {
  var r, n;
  let i, a, o, s, l, d;
  typeof e == "string" ? (i = e, a = void 0, o = (r = void 0) !== null && r !== void 0 ? r : !1, d = void 0) : (i = e.name, a = e.defaultValue, o = (n = e.touchOnChange) !== null && n !== void 0 ? n : !1, d = e?.onFormReset);
  function u(v, m) {
    if (!l)
      return;
    v !== "focusout" && vu(l, m);
    const $ = new Event(v, {
      bubbles: !0,
      composed: !0
    });
    l.dispatchEvent($);
  }
  function c(v) {
    v.forEach(() => {
      const m = l.getAttribute("aria-invalid");
      m ? s.setAttribute("aria-invalid", m) : s.removeAttribute("aria-invalid");
      const $ = l.getAttribute("data-felte-validation-message");
      $ ? s.setAttribute("data-felte-validation-message", $) : s.removeAttribute("data-felte-validation-message");
    });
  }
  function h(v) {
    d && (vu(l, a), d(v));
  }
  function f(v) {
    s = v;
    let m, $;
    if (lr(v))
      return l = v, l.name = i, {};
    {
      let w = !1, k = !1;
      return setTimeout(() => {
        if (k)
          return;
        const C = s.parentNode;
        if (!C || !_2(C))
          return;
        const E = C.querySelector(`[name="${i}"]`);
        if (!E || !lr(E)) {
          const N = document.createElement("input");
          N.type = "hidden", N.name = i, C.insertBefore(N, v.nextSibling), l = N, w = !0;
        } else
          l = E;
        vu(l, a), m = new MutationObserver(c), m.observe(l, C_), $ = l.closest("form"), $?.addEventListener("reset", h);
      }), {
        destroy() {
          var C;
          w && ((C = l.parentNode) === null || C === void 0 || C.removeChild(l)), k = !0, m?.disconnect(), $?.removeEventListener("reset", h);
        }
      };
    }
  }
  function p(v) {
    u(o ? "change" : "input", v);
  }
  function g() {
    u("focusout");
  }
  return {
    field: f,
    onInput: p,
    onChange: p,
    onBlur: g
  };
}
function F9(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function fi(e, t) {
  return jc(e, (r) => Ye(r) ? fi(r, t) : Array.isArray(r) ? r.length === 0 || r.every((n) => typeof n == "string") ? t : r.map((n) => {
    const i = fi(n, t);
    return F9(i, ["key"]);
  }) : t);
}
function Ha(e) {
  return e ? jc(e, (t) => Ye(t) ? Ha(t) : Array.isArray(t) ? t.length === 0 || t.every((r) => typeof r == "string") ? t : t.map((r) => {
    if (!Ye(r))
      return r;
    const n = Ha(r);
    return n.key || (n.key = M9()), n;
  }) : t) : {};
}
function Go(e) {
  return e ? jc(e, (t) => Ye(t) ? Go(t) : Array.isArray(t) ? t.length === 0 || t.every((r) => typeof r == "string") ? t : t.map((r) => {
    if (!Ye(r))
      return r;
    const n = Go(r);
    return F9(n, ["key"]);
  }) : t) : {};
}
function E_() {
  class e extends CustomEvent {
    constructor(i) {
      super("feltesuccess", { detail: i });
    }
  }
  class t extends CustomEvent {
    constructor(i) {
      super("felteerror", { detail: i, cancelable: !0 });
    }
    setErrors(i) {
      this.preventDefault(), this.errors = i;
    }
  }
  class r extends Event {
    constructor() {
      super("feltesubmit", { cancelable: !0 });
    }
    handleSubmit(i) {
      this.onSubmit = i;
    }
    handleError(i) {
      this.onError = i;
    }
    handleSuccess(i) {
      this.onSuccess = i;
    }
  }
  return {
    createErrorEvent: (n) => new t(n),
    createSubmitEvent: () => new r(),
    createSuccessEvent: (n) => new e(n)
  };
}
function T_(e) {
  if (e)
    return async function() {
      let t = new FormData(e);
      const r = new URL(e.action), n = e.method.toLowerCase() === "get" ? "get" : r.searchParams.get("_method") || e.method;
      let i = e.enctype;
      e.querySelector('input[type="file"]') && (i = "multipart/form-data"), (n === "get" || i === "application/x-www-form-urlencoded") && (t = new URLSearchParams(t));
      let a;
      n === "get" ? (t.forEach((s, l) => {
        r.searchParams.append(l, s);
      }), a = { method: n, headers: { Accept: "application/json" } }) : a = {
        method: n,
        body: t,
        headers: Object.assign(Object.assign({}, i !== "multipart/form-data" && {
          "Content-Type": i
        }), { Accept: "application/json" })
      };
      const o = await window.fetch(r.toString(), a);
      if (o.ok)
        return o;
      throw new v_("An error occurred while submitting the form", o);
    };
}
function Vd(e, t, r, n) {
  return Es(e, t, (i) => (typeof i < "u" && !Array.isArray(i) || (i || (i = []), typeof n > "u" ? i.push(r) : i.splice(n, 0, r)), i));
}
function A_(e, t, r, n) {
  return Es(e, t, (i) => (!i || !Array.isArray(i) || ([i[r], i[n]] = [i[n], i[r]]), i));
}
function O_(e, t, r, n) {
  return Es(e, t, (i) => (!i || !Array.isArray(i) || i.splice(n, 0, i.splice(r, 1)[0]), i));
}
function L3(e) {
  return typeof e == "function";
}
function Ii(e) {
  return (t, r) => {
    if (typeof t == "string") {
      const n = t;
      e((i) => {
        const a = L3(r) ? r(Yn(i, n)) : r;
        return It(i, n, a);
      });
    } else
      e((n) => L3(t) ? t(n) : t);
  };
}
function I_({ stores: e, config: t, validateErrors: r, validateWarnings: n, _getCurrentExtenders: i }) {
  var a;
  let o, s = Ha((a = t.initialValues) !== null && a !== void 0 ? a : {});
  const { data: l, touched: d, errors: u, warnings: c, isDirty: h, isSubmitting: f, interacted: p } = e, g = Ii(l.update), v = Ii(d.update), m = Ii(u.update), $ = Ii(c.update);
  function w(D) {
    g((R) => {
      const Q = D(R);
      return o && jd(o, Q), Q;
    });
  }
  const k = (D, R, Q) => {
    Ii(w)(D, R), typeof D == "string" && Q && v(D, !0);
  };
  function C(D, R, Q) {
    const Z = Ye(R) ? fi(R, !1) : !1, F = Ye(Z) ? Gr(Z, []) : [];
    R = Ye(R) ? Object.assign(Object.assign({}, R), { key: M9() }) : R, u.update((oe) => Vd(oe, D, F, Q)), c.update((oe) => Vd(oe, D, F, Q)), d.update((oe) => Vd(oe, D, Z, Q)), l.update((oe) => {
      const pe = Vd(oe, D, R, Q);
      return setTimeout(() => o && jd(o, pe)), pe;
    });
  }
  function E(D) {
    u.update(D), c.update(D), d.update(D), l.update((R) => {
      const Q = D(R);
      return setTimeout(() => o && jd(o, Q)), Q;
    });
  }
  function N(D) {
    E((R) => gl(R, D));
  }
  function M(D, R, Q) {
    E((Z) => A_(Z, D, R, Q));
  }
  function V(D, R, Q) {
    E((Z) => O_(Z, D, R, Q));
  }
  function q(D) {
    const R = Yn(s, D), Q = Ye(R) ? fi(R, !1) : !1, Z = Ye(Q) ? Gr(Q, []) : [];
    l.update((F) => {
      const oe = It(F, D, R);
      return o && jd(o, oe), oe;
    }), d.update((F) => It(F, D, Q)), u.update((F) => It(F, D, Z)), c.update((F) => It(F, D, Z));
  }
  const I = Ii(f.update), P = Ii(h.update), z = Ii(p.update);
  async function G() {
    const D = hi(l);
    d.set(fi(D, !0)), p.set(null);
    const R = await r(D);
    return await n(D), R;
  }
  function se() {
    k(Qr(s)), v((D) => Gr(D, !1)), p.set(null), h.set(!1);
  }
  function ue(D) {
    return async function(R) {
      var Q, Z, F, oe, pe, ee, re;
      const { createErrorEvent: Ie, createSubmitEvent: Pe, createSuccessEvent: at } = E_(), Xe = Pe();
      o?.dispatchEvent(Xe);
      const ft = (Z = (Q = Xe.onError) !== null && Q !== void 0 ? Q : D?.onError) !== null && Z !== void 0 ? Z : t.onError, bt = (oe = (F = Xe.onSuccess) !== null && F !== void 0 ? F : D?.onSuccess) !== null && oe !== void 0 ? oe : t.onSuccess, le = (re = (ee = (pe = Xe.onSubmit) !== null && pe !== void 0 ? pe : D?.onSubmit) !== null && ee !== void 0 ? ee : t.onSubmit) !== null && re !== void 0 ? re : T_(o);
      if (!le || (R?.preventDefault(), Xe.defaultPrevented))
        return;
      f.set(!0), p.set(null);
      const Y = Go(hi(l)), ve = await r(Y, D?.validate), xe = await n(Y, D?.warn);
      if (xe && c.set(D9(Gr(Y, []), xe)), d.set(fi(Y, !0)), ve && (d.set(fi(ve, !0)), ql(ve, (Fe) => Array.isArray(Fe) ? Fe.length >= 1 : !!Fe))) {
        await new Promise((Fe) => setTimeout(Fe)), i().forEach((Fe) => {
          var He;
          return (He = Fe.onSubmitError) === null || He === void 0 ? void 0 : He.call(Fe, {
            data: Y,
            errors: ve
          });
        }), f.set(!1);
        return;
      }
      const Qe = {
        event: R,
        setFields: k,
        setData: g,
        setTouched: v,
        setErrors: m,
        setWarnings: $,
        unsetField: N,
        addField: C,
        resetField: q,
        reset: se,
        setInitialValues: de.setInitialValues,
        moveField: V,
        swapFields: M,
        form: o,
        controls: o && Array.from(o.elements).filter(lr),
        config: Object.assign(Object.assign({}, t), D)
      };
      try {
        const Fe = await le(Y, Qe);
        o?.dispatchEvent(at(Object.assign({ response: Fe }, Qe))), await bt?.(Fe, Qe);
      } catch (Fe) {
        const He = Ie(Object.assign({ error: Fe }, Qe));
        if (o?.dispatchEvent(He), !ft && !He.defaultPrevented)
          throw Fe;
        if (!ft && !He.errors)
          return;
        const Ge = He.errors || await ft?.(Fe, Qe);
        Ge && (d.set(fi(Ge, !0)), u.set(Ge), await new Promise((Gt) => setTimeout(Gt)), i().forEach((Gt) => {
          var Ze;
          return (Ze = Gt.onSubmitError) === null || Ze === void 0 ? void 0 : Ze.call(Gt, {
            data: Y,
            errors: hi(u)
          });
        }));
      } finally {
        f.set(!1);
      }
    };
  }
  const de = {
    setData: g,
    setFields: k,
    setTouched: v,
    setErrors: m,
    setWarnings: $,
    setIsSubmitting: I,
    setIsDirty: P,
    setInteracted: z,
    validate: G,
    reset: se,
    unsetField: N,
    resetField: q,
    addField: C,
    swapFields: M,
    moveField: V,
    createSubmitHandler: ue,
    handleSubmit: ue(),
    setInitialValues: (D) => {
      s = Ha(D);
    }
  };
  return {
    public: de,
    private: {
      _setFormNode(D) {
        o = D;
      },
      _getInitialValues: () => s
    }
  };
}
function P_({ helpers: e, stores: t, config: r, extender: n, createSubmitHandler: i, handleSubmit: a, _setFormNode: o, _getInitialValues: s, _setCurrentExtenders: l, _getCurrentExtenders: d }) {
  const { setFields: u, setTouched: c, reset: h, setInitialValues: f } = e, { addValidator: p, addTransformer: g, validate: v } = e, { data: m, errors: $, warnings: w, touched: k, isSubmitting: C, isDirty: E, interacted: N, isValid: M, isValidating: V } = t;
  function q(I) {
    I.requestSubmit || (I.requestSubmit = a);
    function P(le) {
      return function(Y) {
        return Y({
          form: I,
          stage: le,
          controls: Array.from(I.elements).filter(lr),
          data: m,
          errors: $,
          warnings: w,
          touched: k,
          isValid: M,
          isValidating: V,
          isSubmitting: C,
          isDirty: E,
          interacted: N,
          config: r,
          addValidator: p,
          addTransformer: g,
          setFields: u,
          validate: v,
          reset: h,
          createSubmitHandler: i,
          handleSubmit: a
        });
      };
    }
    l(n.map(P("MOUNT"))), I.noValidate = !!r.validate;
    const { defaultData: z, defaultTouched: G } = N3(I);
    o(I), f(D9(Qr(z), s())), u(s()), k.set(G);
    function se(le) {
      const Y = $r(le), ve = Array.from(I.querySelectorAll(`[name="${le.name}"]`)).filter((xe) => lr(xe) ? Y === $r(xe) : !1);
      if (ve.length !== 0)
        return ve.length === 1 ? m.update((xe) => It(xe, $r(le), le.checked)) : m.update((xe) => It(xe, $r(le), ve.filter(Wo).filter((Qe) => Qe.checked).map((Qe) => Qe.value)));
    }
    function ue(le) {
      const Y = I.querySelectorAll(`[name="${le.name}"]`), ve = Array.from(Y).find((xe) => Wo(xe) && xe.checked);
      m.update((xe) => It(xe, $r(le), ve?.value));
    }
    function de(le) {
      var Y;
      const ve = Array.from((Y = le.files) !== null && Y !== void 0 ? Y : []);
      m.update((xe) => It(xe, $r(le), le.multiple ? ve : ve[0]));
    }
    function D(le) {
      if (!le.multiple)
        m.update((Y) => It(Y, $r(le), le.value));
      else {
        const Y = Array.from(le.selectedOptions).map((ve) => ve.value);
        m.update((ve) => It(ve, $r(le), Y));
      }
    }
    function R(le) {
      const Y = le.target;
      if (!Y || !lr(Y) || Qo(Y) || t1(Y) || ["checkbox", "radio", "file"].includes(Y.type) || !Y.name)
        return;
      E.set(!0);
      const ve = L9(Y);
      N.set(Y.name), m.update((xe) => It(xe, $r(Y), ve));
    }
    function Q(le) {
      const Y = le.target;
      if (!(!Y || !lr(Y) || t1(Y)) && Y.name)
        if (c($r(Y), !0), N.set(Y.name), (Qo(Y) || ["checkbox", "radio", "file", "hidden"].includes(Y.type)) && E.set(!0), Y.type === "hidden" && m.update((ve) => It(ve, $r(Y), Y.value)), Qo(Y))
          D(Y);
        else if (Wo(Y))
          Y.type === "checkbox" ? se(Y) : Y.type === "radio" ? ue(Y) : Y.type === "file" && de(Y);
        else return;
    }
    function Z(le) {
      const Y = le.target;
      !Y || !lr(Y) || t1(Y) || Y.name && (c($r(Y), !0), N.set(Y.name));
    }
    function F(le) {
      le.preventDefault(), h();
    }
    const oe = { childList: !0, subtree: !0 };
    function pe(le) {
      let Y = hi(m), ve = hi(k), xe = hi($), Qe = hi(w);
      for (const Fe of le.reverse()) {
        if (Fe.hasAttribute("data-felte-keep-on-remove") && Fe.dataset.felteKeepOnRemove !== "false")
          continue;
        const He = /.*(\[[0-9]+\]|\.[0-9]+)\.[^.]+$/;
        let Ge = $r(Fe);
        const Gt = hi(k);
        if (He.test(Ge)) {
          const Ze = Ge.split(".").slice(0, -1).join("."), Pr = Yn(Gt, Ze);
          Ye(Pr) && Object.keys(Pr).length <= 1 && (Ge = Ze);
        }
        Y = gl(Y, Ge), ve = gl(ve, Ge), xe = gl(xe, Ge), Qe = gl(Qe, Ge);
      }
      m.set(Y), k.set(ve), $.set(xe), w.set(Qe);
    }
    const ee = Uu(() => {
      d().forEach((ve) => {
        var xe;
        return (xe = ve.destroy) === null || xe === void 0 ? void 0 : xe.call(ve);
      }), l(n.map(P("UPDATE")));
      const { defaultData: le, defaultTouched: Y } = N3(I);
      m.update((ve) => D3(ve, le)), k.update((ve) => D3(ve, Y)), e.setFields(hi(m));
    }, 0);
    let re = [];
    const Ie = Uu(() => {
      d().forEach((le) => {
        var Y;
        return (Y = le.destroy) === null || Y === void 0 ? void 0 : Y.call(le);
      }), l(n.map(P("UPDATE"))), pe(re), re = [];
    }, 0);
    function Pe(le) {
      Array.from(le.addedNodes).some((Y) => _2(Y) ? lr(Y) ? !0 : E2(Y).length > 0 : !1) && ee();
    }
    function at(le) {
      for (const Y of le.removedNodes) {
        if (!_2(Y))
          continue;
        const ve = E2(Y);
        ve.length !== 0 && (re.push(...ve), Ie());
      }
    }
    function Xe(le) {
      for (const Y of le)
        Y.type === "childList" && (Y.addedNodes.length > 0 && Pe(Y), Y.removedNodes.length > 0 && at(Y));
    }
    const ft = new MutationObserver(Xe);
    ft.observe(I, oe), I.addEventListener("input", R), I.addEventListener("change", Q), I.addEventListener("focusout", Z), I.addEventListener("submit", a), I.addEventListener("reset", F);
    const bt = $.subscribe((le) => {
      for (const Y of I.elements) {
        if (!lr(Y) || !Y.name)
          continue;
        const ve = Yn(le, $r(Y)), xe = Array.isArray(ve) ? ve.join(`
`) : typeof ve == "string" ? ve : void 0;
        xe !== Y.dataset.felteValidationMessage && (xe ? (Y.dataset.felteValidationMessage = xe, Y.setAttribute("aria-invalid", "true")) : (delete Y.dataset.felteValidationMessage, Y.removeAttribute("aria-invalid")));
      }
    });
    return {
      destroy() {
        ft.disconnect(), I.removeEventListener("input", R), I.removeEventListener("change", Q), I.removeEventListener("focusout", Z), I.removeEventListener("submit", a), I.removeEventListener("reset", F), bt(), d().forEach((le) => {
          var Y;
          return (Y = le.destroy) === null || Y === void 0 ? void 0 : Y.call(le);
        });
      }
    };
  }
  return { form: q };
}
function D_(e) {
  const t = { aborted: !1, priority: e };
  return {
    signal: t,
    abort() {
      t.aborted = !0;
    }
  };
}
function M_(e, t) {
  if (Ye(e))
    return !t || Ye(t) && Object.keys(t).length === 0 ? Gr(e, null) : void 0;
  if (Array.isArray(e)) {
    if (e.some(Ye))
      return;
    const r = Array.isArray(t) ? t : [];
    return e.map((n, i) => {
      const a = r[i];
      return Array.isArray(a) && a.length === 0 ? null : n && a || null;
    });
  }
  return Array.isArray(t) && t.length === 0 ? null : Array.isArray(t) ? e ? t : null : e && t ? [t] : null;
}
function N_(e, t) {
  if (Ye(e))
    return !t || Ye(t) && Object.keys(t).length === 0 ? Gr(e, null) : void 0;
  if (Array.isArray(e)) {
    if (e.some(Ye))
      return;
    const r = Array.isArray(t) ? t : [];
    return e.map((n, i) => {
      const a = r[i];
      return Array.isArray(a) && a.length === 0 ? null : a || null;
    });
  }
  return Array.isArray(t) && t.length === 0 ? null : Array.isArray(t) ? t : t ? [t] : null;
}
function L_([e, t]) {
  return Gi(t, e, M_);
}
function F_([e, t]) {
  return Gi(t, e, N_);
}
function R_(e) {
  return function(t, r, n) {
    const i = Array.isArray(t) ? t : [t], a = new Array(i.length), o = e(n), s = o.set, l = o.subscribe;
    let d;
    function u() {
      d = i.map((h, f) => h.subscribe((p) => {
        a[f] = p, s(r(a));
      }));
    }
    function c() {
      d?.forEach((h) => h());
    }
    return o.subscribe = function(h) {
      const f = l(h);
      return () => {
        f();
      };
    }, [o, u, c];
  };
}
function z_(e, t) {
  var r, n, i, a, o, s, l, d, u;
  const c = R_(e), h = t.initialValues = t.initialValues ? Ha(C2(Qr(t.initialValues), t.transform)) : {}, f = fi(Go(h), !1), p = e(f), g = e(0), [v, m, $] = c([p, g], ([Ct, Vt]) => ql(Ct, (Ut) => !!Ut) && Vt >= 1, !1);
  delete v.set, delete v.update;
  function w(Ct) {
    let Vt;
    return async function(Ut, Jr, zn, en = !1) {
      if (!zn || !Ut)
        return;
      let tn = Jr && Object.keys(Jr).length > 0 ? Jr : Gr(Ut, []);
      const di = D_(en);
      if ((!Vt?.signal.priority || en) && (Vt?.abort(), Vt = di), Vt.signal.priority && !en)
        return;
      g.update((rn) => rn + 1);
      const Hr = __(Go(Ut), zn);
      return Hr.forEach(async (rn) => {
        const Ti = await rn;
        di.signal.aborted || (tn = xo([tn, Ti]), Ct.set(tn));
      }), await Promise.all(Hr), Vt = void 0, g.update((rn) => rn - 1), tn;
    };
  }
  let k = Gr(f, []);
  const C = e(h), E = Gr(f, []), N = e(E), M = e(Qr(E)), [V, q, I] = c([
    N,
    M
  ], xo, Qr(E)), P = Gr(f, []), z = e(P), G = e(Qr(P)), [se, ue, de] = c([
    z,
    G
  ], xo, Qr(P)), [D, R, Q] = c([V, p], L_, Qr(E)), [Z, F, oe] = c([se, p], F_, Qr(P));
  let pe = !1;
  const [ee, re, Ie] = c(V, ([Ct]) => {
    var Vt;
    return pe ? !ql(Ct, (Ut) => Array.isArray(Ut) ? Ut.length >= 1 : !!Ut) : (pe = !0, !t.validate && !(!((Vt = t.debounced) === null || Vt === void 0) && Vt.validate));
  }, !t.validate && !(!((r = t.debounced) === null || r === void 0) && r.validate));
  delete ee.set, delete ee.update;
  const Pe = e(!1), at = e(!1), Xe = e(null), ft = w(N), bt = w(z), le = w(M), Y = w(G), ve = Uu(le, (o = (i = (n = t.debounced) === null || n === void 0 ? void 0 : n.validateTimeout) !== null && i !== void 0 ? i : (a = t.debounced) === null || a === void 0 ? void 0 : a.timeout) !== null && o !== void 0 ? o : 300, {
    onInit: () => {
      g.update((Ct) => Ct + 1);
    },
    onEnd: () => {
      g.update((Ct) => Ct - 1);
    }
  }), xe = Uu(Y, (u = (l = (s = t.debounced) === null || s === void 0 ? void 0 : s.warnTimeout) !== null && l !== void 0 ? l : (d = t.debounced) === null || d === void 0 ? void 0 : d.timeout) !== null && u !== void 0 ? u : 300);
  async function Qe(Ct, Vt) {
    var Ut;
    const Jr = ft(Ct, k, Vt ?? t.validate, !0);
    if (Vt)
      return Jr;
    const zn = le(Ct, k, (Ut = t.debounced) === null || Ut === void 0 ? void 0 : Ut.validate, !0);
    return xo(await Promise.all([Jr, zn]));
  }
  async function Fe(Ct, Vt) {
    var Ut;
    const Jr = bt(Ct, k, Vt ?? t.warn, !0);
    if (Vt)
      return Jr;
    const zn = Y(Ct, k, (Ut = t.debounced) === null || Ut === void 0 ? void 0 : Ut.warn, !0);
    return xo(await Promise.all([Jr, zn]));
  }
  let He = E, Ge = P;
  function Gt() {
    const Ct = C.subscribe((en) => {
      var tn, di;
      const Hr = Go(en);
      ft(Hr, k, t.validate), bt(Hr, k, t.warn), ve(Hr, k, (tn = t.debounced) === null || tn === void 0 ? void 0 : tn.validate), xe(Hr, k, (di = t.debounced) === null || di === void 0 ? void 0 : di.warn);
    }), Vt = p.subscribe((en) => {
      k = Gr(en, []);
    }), Ut = V.subscribe((en) => {
      He = en;
    }), Jr = se.subscribe((en) => {
      Ge = en;
    });
    q(), re(), ue(), R(), F(), m();
    function zn() {
      Ct(), Q(), I(), de(), oe(), Ie(), $(), Vt(), Ut(), Jr();
    }
    return zn;
  }
  function Ze(Ct) {
    N.set(Ct(He)), M.set({});
  }
  function Pr(Ct) {
    z.set(Ct(Ge)), G.set({});
  }
  function zs(Ct) {
    Ze(() => Ct);
  }
  function v0(Ct) {
    Pr(() => Ct);
  }
  return D.set = zs, D.update = Ze, Z.set = v0, Z.update = Pr, {
    data: C,
    errors: D,
    warnings: Z,
    touched: p,
    isValid: ee,
    isSubmitting: Pe,
    isDirty: at,
    isValidating: v,
    interacted: Xe,
    validateErrors: Qe,
    validateWarnings: Fe,
    cleanup: t.preventStoreStart ? () => {
    } : Gt(),
    start: Gt
  };
}
function j_(e, t) {
  var r, n;
  (r = e.extend) !== null && r !== void 0 || (e.extend = []), (n = e.debounced) !== null && n !== void 0 || (e.debounced = {}), e.validate && !Array.isArray(e.validate) && (e.validate = [e.validate]), e.debounced.validate && !Array.isArray(e.debounced.validate) && (e.debounced.validate = [e.debounced.validate]), e.transform && !Array.isArray(e.transform) && (e.transform = [e.transform]), e.warn && !Array.isArray(e.warn) && (e.warn = [e.warn]), e.debounced.warn && !Array.isArray(e.debounced.warn) && (e.debounced.warn = [e.debounced.warn]);
  function i(ue, { debounced: de, level: D } = {
    debounced: !1,
    level: "error"
  }) {
    var R;
    const Q = D === "error" ? "validate" : "warn";
    (R = e.debounced) !== null && R !== void 0 || (e.debounced = {});
    const Z = de ? e.debounced : e;
    Z[Q] ? Z[Q] = [
      ...Z[Q],
      ue
    ] : Z[Q] = [ue];
  }
  function a(ue) {
    e.transform ? e.transform = [
      ...e.transform,
      ue
    ] : e.transform = [ue];
  }
  const o = Array.isArray(e.extend) ? e.extend : [e.extend];
  let s = [];
  const l = () => s, d = (ue) => {
    s = ue;
  }, { isSubmitting: u, isValidating: c, data: h, errors: f, warnings: p, touched: g, isValid: v, isDirty: m, cleanup: $, start: w, validateErrors: k, validateWarnings: C, interacted: E } = z_(t.storeFactory, e), N = h.update, M = h.set, V = (ue) => N((de) => Ha(C2(ue(de), e.transform))), q = (ue) => M(Ha(C2(ue, e.transform)));
  h.update = V, h.set = q;
  const I = I_({
    config: e,
    validateErrors: k,
    validateWarnings: C,
    _getCurrentExtenders: l,
    stores: {
      data: h,
      errors: f,
      warnings: p,
      touched: g,
      isSubmitting: u,
      isDirty: m,
      interacted: E
    }
  }), { createSubmitHandler: P, handleSubmit: z } = I.public;
  s = o.map((ue) => ue({
    stage: "SETUP",
    errors: f,
    warnings: p,
    touched: g,
    data: h,
    isDirty: m,
    isValid: v,
    isValidating: c,
    isSubmitting: u,
    interacted: E,
    config: e,
    addValidator: i,
    addTransformer: a,
    setFields: I.public.setFields,
    reset: I.public.reset,
    validate: I.public.validate,
    handleSubmit: z,
    createSubmitHandler: P
  }));
  const G = Object.assign({
    config: e,
    stores: {
      data: h,
      touched: g,
      errors: f,
      warnings: p,
      isSubmitting: u,
      isValidating: c,
      isValid: v,
      isDirty: m,
      interacted: E
    },
    createSubmitHandler: P,
    handleSubmit: z,
    helpers: Object.assign(Object.assign({}, I.public), {
      addTransformer: a,
      addValidator: i
    }),
    extender: o,
    _getCurrentExtenders: l,
    _setCurrentExtenders: d
  }, I.private), { form: se } = P_(G);
  return Object.assign({
    data: h,
    errors: f,
    warnings: p,
    touched: g,
    isValid: v,
    isSubmitting: u,
    isValidating: c,
    isDirty: m,
    interacted: E,
    form: se,
    cleanup: $,
    startStores: w
  }, I.public);
}
function V_(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function U_(e) {
  const t = {}, r = {};
  function n(i) {
    if (!i)
      return e();
    if (!t[i.toString()]) {
      const o = H(M3(Re(e), i));
      r[i.toString()] = o, t[i.toString()] = i;
    }
    const [a] = r[i.toString()];
    return a();
  }
  return me(() => {
    const i = e(), a = Object.keys(t);
    for (const o of a) {
      const s = t[o], l = M3(i, s), [d, u] = r[s.toString()];
      S2(l, Re(d)) || u(l);
    }
  }), n;
}
function q_(e) {
  return function(t) {
    return Vo((r) => (me(() => t(e())), r));
  };
}
const B_ = (e) => {
  const [t, r] = H(e);
  function n(s) {
    r(() => s);
  }
  function i(s) {
    r(s);
  }
  const a = U_(t), o = q_(t);
  return a.subscribe = o, a.set = n, a.update = i, a;
};
function R9(e) {
  const t = j_(e ?? {}, {
    storeFactory: B_
  }), { form: r, cleanup: n, startStores: i, data: a, errors: o, warnings: s, touched: l } = t, d = V_(t, ["form", "cleanup", "startStores", "data", "errors", "warnings", "touched"]);
  let u = null;
  const c = () => u?.(), [h, f] = H(null);
  me(() => {
    const g = h();
    g && (c(), u = r(g).destroy);
  });
  const p = (g) => (f(g), {
    destroy: c
  });
  return xr(c), xr(n), Object.assign(Object.assign({}, d), { data: a, errors: o, warnings: s, touched: l, form: p });
}
function H_(e, t) {
  const { field: r, onChange: n, onInput: i, onBlur: a } = S_(e);
  function o(s) {
    const { destroy: l } = r(s);
    return xr(() => l?.()), { destroy: l };
  }
  return {
    field: o,
    onChange: n,
    onInput: i,
    onBlur: a
  };
}
function W_(e) {
  function t(r) {
    return r.issues.reduce((n, i) => i.path ? Es(n, i.path.join("."), (a) => !a || !Array.isArray(a) ? [i.message] : [...a, i.message]) : n, {});
  }
  return async function(r) {
    try {
      await e.parseAsync(r);
    } catch (n) {
      return t(n);
    }
  };
}
function z9({ schema: e, level: t = "error" }) {
  return function(r) {
    if (r.stage !== "SETUP")
      return {};
    const n = W_(e);
    return r.addValidator(n, { level: t }), {};
  };
}
var ct;
(function(e) {
  e.assertEqual = (i) => i;
  function t(i) {
  }
  e.assertIs = t;
  function r(i) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (i) => {
    const a = {};
    for (const o of i)
      a[o] = o;
    return a;
  }, e.getValidEnumValues = (i) => {
    const a = e.objectKeys(i).filter((s) => typeof i[i[s]] != "number"), o = {};
    for (const s of a)
      o[s] = i[s];
    return e.objectValues(o);
  }, e.objectValues = (i) => e.objectKeys(i).map(function(a) {
    return i[a];
  }), e.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const a = [];
    for (const o in i)
      Object.prototype.hasOwnProperty.call(i, o) && a.push(o);
    return a;
  }, e.find = (i, a) => {
    for (const o of i)
      if (a(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function n(i, a = " | ") {
    return i.map((o) => typeof o == "string" ? `'${o}'` : o).join(a);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (i, a) => typeof a == "bigint" ? a.toString() : a;
})(ct || (ct = {}));
var F3;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(F3 || (F3 = {}));
const Te = ct.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), zi = (e) => {
  switch (typeof e) {
    case "undefined":
      return Te.undefined;
    case "string":
      return Te.string;
    case "number":
      return isNaN(e) ? Te.nan : Te.number;
    case "boolean":
      return Te.boolean;
    case "function":
      return Te.function;
    case "bigint":
      return Te.bigint;
    case "symbol":
      return Te.symbol;
    case "object":
      return Array.isArray(e) ? Te.array : e === null ? Te.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Te.promise : typeof Map < "u" && e instanceof Map ? Te.map : typeof Set < "u" && e instanceof Set ? Te.set : typeof Date < "u" && e instanceof Date ? Te.date : Te.object;
    default:
      return Te.unknown;
  }
}, he = ct.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class xi extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(a) {
      return a.message;
    }, n = { _errors: [] }, i = (a) => {
      for (const o of a.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(i);
        else if (o.code === "invalid_return_type")
          i(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          i(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const d = o.path[l];
            l === o.path.length - 1 ? (s[d] = s[d] || { _errors: [] }, s[d]._errors.push(r(o))) : s[d] = s[d] || { _errors: [] }, s = s[d], l++;
          }
        }
    };
    return i(this), n;
  }
  static assert(t) {
    if (!(t instanceof xi))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ct.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const i of this.issues)
      i.path.length > 0 ? (r[i.path[0]] = r[i.path[0]] || [], r[i.path[0]].push(t(i))) : n.push(t(i));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
xi.create = (e) => new xi(e);
const T2 = (e, t) => {
  let r;
  switch (e.code) {
    case he.invalid_type:
      e.received === Te.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case he.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, ct.jsonStringifyReplacer)}`;
      break;
    case he.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${ct.joinValues(e.keys, ", ")}`;
      break;
    case he.invalid_union:
      r = "Invalid input";
      break;
    case he.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${ct.joinValues(e.options)}`;
      break;
    case he.invalid_enum_value:
      r = `Invalid enum value. Expected ${ct.joinValues(e.options)}, received '${e.received}'`;
      break;
    case he.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case he.invalid_return_type:
      r = "Invalid function return type";
      break;
    case he.invalid_date:
      r = "Invalid date";
      break;
    case he.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : ct.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case he.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case he.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case he.custom:
      r = "Invalid input";
      break;
    case he.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case he.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case he.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, ct.assertNever(e);
  }
  return { message: r };
};
let Q_ = T2;
function G_() {
  return Q_;
}
const Y_ = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: i } = e, a = [...r, ...i.path || []], o = {
    ...i,
    path: a
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: a,
      message: i.message
    };
  let s = "";
  const l = n.filter((d) => !!d).slice().reverse();
  for (const d of l)
    s = d(o, { data: t, defaultError: s }).message;
  return {
    ...i,
    path: a,
    message: s
  };
};
function we(e, t) {
  const r = G_(), n = Y_({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === T2 ? void 0 : T2
      // then global default map
    ].filter((i) => !!i)
  });
  e.common.issues.push(n);
}
class un {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const i of r) {
      if (i.status === "aborted")
        return qe;
      i.status === "dirty" && t.dirty(), n.push(i.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const i of r) {
      const a = await i.key, o = await i.value;
      n.push({
        key: a,
        value: o
      });
    }
    return un.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const i of r) {
      const { key: a, value: o } = i;
      if (a.status === "aborted" || o.status === "aborted")
        return qe;
      a.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), a.value !== "__proto__" && (typeof o.value < "u" || i.alwaysSet) && (n[a.value] = o.value);
    }
    return { status: t.value, value: n };
  }
}
const qe = Object.freeze({
  status: "aborted"
}), A2 = (e) => ({ status: "dirty", value: e }), $n = (e) => ({ status: "valid", value: e }), R3 = (e) => e.status === "aborted", z3 = (e) => e.status === "dirty", ls = (e) => e.status === "valid", qu = (e) => typeof Promise < "u" && e instanceof Promise;
function Bu(e, t, r, n) {
  if (typeof t == "function" ? e !== t || !0 : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function j9(e, t, r, n, i) {
  if (typeof t == "function" ? e !== t || !0 : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, r), r;
}
var Ae;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t?.message;
})(Ae || (Ae = {}));
var vl, yl;
class ea {
  constructor(t, r, n, i) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const j3 = (e, t) => {
  if (ls(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new xi(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function Ke(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: i } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: i } : { errorMap: (a, o) => {
    var s, l;
    const { message: d } = e;
    return a.code === "invalid_enum_value" ? { message: d ?? o.defaultError } : typeof o.data > "u" ? { message: (s = d ?? n) !== null && s !== void 0 ? s : o.defaultError } : a.code !== "invalid_type" ? { message: o.defaultError } : { message: (l = d ?? r) !== null && l !== void 0 ? l : o.defaultError };
  }, description: i };
}
class lt {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return zi(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: zi(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new un(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: zi(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (qu(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    var n;
    const i = {
      common: {
        issues: [],
        async: (n = r?.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r?.errorMap
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: zi(t)
    }, a = this._parseSync({ data: t, path: i.path, parent: i });
    return j3(i, a);
  }
  "~validate"(t) {
    var r, n;
    const i = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: zi(t)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: t, path: [], parent: i });
        return ls(a) ? {
          value: a.value
        } : {
          issues: i.common.issues
        };
      } catch (a) {
        !((n = (r = a?.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), i.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: i }).then((a) => ls(a) ? {
      value: a.value
    } : {
      issues: i.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r?.errorMap,
        async: !0
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: zi(t)
    }, i = this._parse({ data: t, path: n.path, parent: n }), a = await (qu(i) ? i : Promise.resolve(i));
    return j3(n, a);
  }
  refine(t, r) {
    const n = (i) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(i) : r;
    return this._refinement((i, a) => {
      const o = t(i), s = () => a.addIssue({
        code: he.custom,
        ...n(i)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, i) => t(n) ? !0 : (i.addIssue(typeof r == "function" ? r(n, i) : r), !1));
  }
  _refinement(t) {
    return new us({
      schema: this,
      typeName: Ue.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return Yi.create(this, this._def);
  }
  nullable() {
    return cs.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Kn.create(this);
  }
  promise() {
    return Gu.create(this, this._def);
  }
  or(t) {
    return Wu.create([this, t], this._def);
  }
  and(t) {
    return Qu.create(this, t, this._def);
  }
  transform(t) {
    return new us({
      ...Ke(this._def),
      schema: this,
      typeName: Ue.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new I2({
      ...Ke(this._def),
      innerType: this,
      defaultValue: r,
      typeName: Ue.ZodDefault
    });
  }
  brand() {
    return new yC({
      typeName: Ue.ZodBranded,
      type: this,
      ...Ke(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new P2({
      ...Ke(this._def),
      innerType: this,
      catchValue: r,
      typeName: Ue.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return wf.create(this, t);
  }
  readonly() {
    return D2.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const K_ = /^c[^\s-]{8,}$/i, Z_ = /^[0-9a-z]+$/, X_ = /^[0-9A-HJKMNP-TV-Z]{26}$/i, J_ = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, eC = /^[a-z0-9_-]{21}$/i, tC = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, rC = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, nC = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, iC = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let r1;
const aC = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, oC = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, sC = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, lC = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, dC = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, uC = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, V9 = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", cC = new RegExp(`^${V9}$`);
function U9(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function hC(e) {
  return new RegExp(`^${U9(e)}$`);
}
function fC(e) {
  let t = `${V9}T${U9(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function pC(e, t) {
  return !!((t === "v4" || !t) && aC.test(e) || (t === "v6" || !t) && sC.test(e));
}
function mC(e, t) {
  if (!tC.test(e))
    return !1;
  try {
    const [r] = e.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), i = JSON.parse(atob(n));
    return !(typeof i != "object" || i === null || !i.typ || !i.alg || t && i.alg !== t);
  } catch {
    return !1;
  }
}
function gC(e, t) {
  return !!((t === "v4" || !t) && oC.test(e) || (t === "v6" || !t) && lC.test(e));
}
class Hi extends lt {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Te.string) {
      const i = this._getOrReturnCtx(t);
      return we(i, {
        code: he.invalid_type,
        expected: Te.string,
        received: i.parsedType
      }), qe;
    }
    const r = new un();
    let n;
    for (const i of this._def.checks)
      if (i.kind === "min")
        t.data.length < i.value && (n = this._getOrReturnCtx(t, n), we(n, {
          code: he.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "max")
        t.data.length > i.value && (n = this._getOrReturnCtx(t, n), we(n, {
          code: he.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "length") {
        const a = t.data.length > i.value, o = t.data.length < i.value;
        (a || o) && (n = this._getOrReturnCtx(t, n), a ? we(n, {
          code: he.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && we(n, {
          code: he.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), r.dirty());
      } else if (i.kind === "email")
        nC.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
          validation: "email",
          code: he.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "emoji")
        r1 || (r1 = new RegExp(iC, "u")), r1.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
          validation: "emoji",
          code: he.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "uuid")
        J_.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
          validation: "uuid",
          code: he.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "nanoid")
        eC.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
          validation: "nanoid",
          code: he.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid")
        K_.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
          validation: "cuid",
          code: he.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid2")
        Z_.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
          validation: "cuid2",
          code: he.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "ulid")
        X_.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
          validation: "ulid",
          code: he.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "url")
        try {
          new URL(t.data);
        } catch {
          n = this._getOrReturnCtx(t, n), we(n, {
            validation: "url",
            code: he.invalid_string,
            message: i.message
          }), r.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
        validation: "regex",
        code: he.invalid_string,
        message: i.message
      }), r.dirty())) : i.kind === "trim" ? t.data = t.data.trim() : i.kind === "includes" ? t.data.includes(i.value, i.position) || (n = this._getOrReturnCtx(t, n), we(n, {
        code: he.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), r.dirty()) : i.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : i.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : i.kind === "startsWith" ? t.data.startsWith(i.value) || (n = this._getOrReturnCtx(t, n), we(n, {
        code: he.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), r.dirty()) : i.kind === "endsWith" ? t.data.endsWith(i.value) || (n = this._getOrReturnCtx(t, n), we(n, {
        code: he.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), r.dirty()) : i.kind === "datetime" ? fC(i).test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
        code: he.invalid_string,
        validation: "datetime",
        message: i.message
      }), r.dirty()) : i.kind === "date" ? cC.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
        code: he.invalid_string,
        validation: "date",
        message: i.message
      }), r.dirty()) : i.kind === "time" ? hC(i).test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
        code: he.invalid_string,
        validation: "time",
        message: i.message
      }), r.dirty()) : i.kind === "duration" ? rC.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
        validation: "duration",
        code: he.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "ip" ? pC(t.data, i.version) || (n = this._getOrReturnCtx(t, n), we(n, {
        validation: "ip",
        code: he.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "jwt" ? mC(t.data, i.alg) || (n = this._getOrReturnCtx(t, n), we(n, {
        validation: "jwt",
        code: he.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "cidr" ? gC(t.data, i.version) || (n = this._getOrReturnCtx(t, n), we(n, {
        validation: "cidr",
        code: he.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "base64" ? dC.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
        validation: "base64",
        code: he.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "base64url" ? uC.test(t.data) || (n = this._getOrReturnCtx(t, n), we(n, {
        validation: "base64url",
        code: he.invalid_string,
        message: i.message
      }), r.dirty()) : ct.assertNever(i);
    return { status: r.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((i) => t.test(i), {
      validation: r,
      code: he.invalid_string,
      ...Ae.errToObj(n)
    });
  }
  _addCheck(t) {
    return new Hi({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Ae.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Ae.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Ae.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Ae.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...Ae.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Ae.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Ae.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Ae.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...Ae.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...Ae.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...Ae.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Ae.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...Ae.errToObj(t) });
  }
  datetime(t) {
    var r, n;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      offset: (r = t?.offset) !== null && r !== void 0 ? r : !1,
      local: (n = t?.local) !== null && n !== void 0 ? n : !1,
      ...Ae.errToObj(t?.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      ...Ae.errToObj(t?.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...Ae.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Ae.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r?.position,
      ...Ae.errToObj(r?.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Ae.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Ae.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Ae.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Ae.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Ae.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, Ae.errToObj(t));
  }
  trim() {
    return new Hi({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Hi({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Hi({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Hi.create = (e) => {
  var t;
  return new Hi({
    checks: [],
    typeName: Ue.ZodString,
    coerce: (t = e?.coerce) !== null && t !== void 0 ? t : !1,
    ...Ke(e)
  });
};
function vC(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, i = r > n ? r : n, a = parseInt(e.toFixed(i).replace(".", "")), o = parseInt(t.toFixed(i).replace(".", ""));
  return a % o / Math.pow(10, i);
}
class Bl extends lt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Te.number) {
      const i = this._getOrReturnCtx(t);
      return we(i, {
        code: he.invalid_type,
        expected: Te.number,
        received: i.parsedType
      }), qe;
    }
    let r;
    const n = new un();
    for (const i of this._def.checks)
      i.kind === "int" ? ct.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), we(r, {
        code: he.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), n.dirty()) : i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (r = this._getOrReturnCtx(t, r), we(r, {
        code: he.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (r = this._getOrReturnCtx(t, r), we(r, {
        code: he.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "multipleOf" ? vC(t.data, i.value) !== 0 && (r = this._getOrReturnCtx(t, r), we(r, {
        code: he.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), n.dirty()) : i.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), we(r, {
        code: he.not_finite,
        message: i.message
      }), n.dirty()) : ct.assertNever(i);
    return { status: n.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Ae.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Ae.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Ae.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Ae.toString(r));
  }
  setLimit(t, r, n, i) {
    return new Bl({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Ae.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Bl({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Ae.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Ae.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Ae.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Ae.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Ae.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Ae.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Ae.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Ae.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Ae.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && ct.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
Bl.create = (e) => new Bl({
  checks: [],
  typeName: Ue.ZodNumber,
  coerce: e?.coerce || !1,
  ...Ke(e)
});
class Hl extends lt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== Te.bigint)
      return this._getInvalidInput(t);
    let r;
    const n = new un();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (r = this._getOrReturnCtx(t, r), we(r, {
        code: he.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), n.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (r = this._getOrReturnCtx(t, r), we(r, {
        code: he.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), n.dirty()) : i.kind === "multipleOf" ? t.data % i.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), we(r, {
        code: he.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), n.dirty()) : ct.assertNever(i);
    return { status: n.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return we(r, {
      code: he.invalid_type,
      expected: Te.bigint,
      received: r.parsedType
    }), qe;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Ae.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Ae.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Ae.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Ae.toString(r));
  }
  setLimit(t, r, n, i) {
    return new Hl({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Ae.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Hl({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Ae.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Ae.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Ae.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Ae.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Ae.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Hl.create = (e) => {
  var t;
  return new Hl({
    checks: [],
    typeName: Ue.ZodBigInt,
    coerce: (t = e?.coerce) !== null && t !== void 0 ? t : !1,
    ...Ke(e)
  });
};
class V3 extends lt {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Te.boolean) {
      const r = this._getOrReturnCtx(t);
      return we(r, {
        code: he.invalid_type,
        expected: Te.boolean,
        received: r.parsedType
      }), qe;
    }
    return $n(t.data);
  }
}
V3.create = (e) => new V3({
  typeName: Ue.ZodBoolean,
  coerce: e?.coerce || !1,
  ...Ke(e)
});
class Hu extends lt {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Te.date) {
      const i = this._getOrReturnCtx(t);
      return we(i, {
        code: he.invalid_type,
        expected: Te.date,
        received: i.parsedType
      }), qe;
    }
    if (isNaN(t.data.getTime())) {
      const i = this._getOrReturnCtx(t);
      return we(i, {
        code: he.invalid_date
      }), qe;
    }
    const r = new un();
    let n;
    for (const i of this._def.checks)
      i.kind === "min" ? t.data.getTime() < i.value && (n = this._getOrReturnCtx(t, n), we(n, {
        code: he.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), r.dirty()) : i.kind === "max" ? t.data.getTime() > i.value && (n = this._getOrReturnCtx(t, n), we(n, {
        code: he.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), r.dirty()) : ct.assertNever(i);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Hu({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Ae.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Ae.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
Hu.create = (e) => new Hu({
  checks: [],
  coerce: e?.coerce || !1,
  typeName: Ue.ZodDate,
  ...Ke(e)
});
class U3 extends lt {
  _parse(t) {
    if (this._getType(t) !== Te.symbol) {
      const r = this._getOrReturnCtx(t);
      return we(r, {
        code: he.invalid_type,
        expected: Te.symbol,
        received: r.parsedType
      }), qe;
    }
    return $n(t.data);
  }
}
U3.create = (e) => new U3({
  typeName: Ue.ZodSymbol,
  ...Ke(e)
});
class q3 extends lt {
  _parse(t) {
    if (this._getType(t) !== Te.undefined) {
      const r = this._getOrReturnCtx(t);
      return we(r, {
        code: he.invalid_type,
        expected: Te.undefined,
        received: r.parsedType
      }), qe;
    }
    return $n(t.data);
  }
}
q3.create = (e) => new q3({
  typeName: Ue.ZodUndefined,
  ...Ke(e)
});
class B3 extends lt {
  _parse(t) {
    if (this._getType(t) !== Te.null) {
      const r = this._getOrReturnCtx(t);
      return we(r, {
        code: he.invalid_type,
        expected: Te.null,
        received: r.parsedType
      }), qe;
    }
    return $n(t.data);
  }
}
B3.create = (e) => new B3({
  typeName: Ue.ZodNull,
  ...Ke(e)
});
class H3 extends lt {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return $n(t.data);
  }
}
H3.create = (e) => new H3({
  typeName: Ue.ZodAny,
  ...Ke(e)
});
class W3 extends lt {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return $n(t.data);
  }
}
W3.create = (e) => new W3({
  typeName: Ue.ZodUnknown,
  ...Ke(e)
});
class ta extends lt {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return we(r, {
      code: he.invalid_type,
      expected: Te.never,
      received: r.parsedType
    }), qe;
  }
}
ta.create = (e) => new ta({
  typeName: Ue.ZodNever,
  ...Ke(e)
});
class Q3 extends lt {
  _parse(t) {
    if (this._getType(t) !== Te.undefined) {
      const r = this._getOrReturnCtx(t);
      return we(r, {
        code: he.invalid_type,
        expected: Te.void,
        received: r.parsedType
      }), qe;
    }
    return $n(t.data);
  }
}
Q3.create = (e) => new Q3({
  typeName: Ue.ZodVoid,
  ...Ke(e)
});
class Kn extends lt {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), i = this._def;
    if (r.parsedType !== Te.array)
      return we(r, {
        code: he.invalid_type,
        expected: Te.array,
        received: r.parsedType
      }), qe;
    if (i.exactLength !== null) {
      const o = r.data.length > i.exactLength.value, s = r.data.length < i.exactLength.value;
      (o || s) && (we(r, {
        code: o ? he.too_big : he.too_small,
        minimum: s ? i.exactLength.value : void 0,
        maximum: o ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), n.dirty());
    }
    if (i.minLength !== null && r.data.length < i.minLength.value && (we(r, {
      code: he.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), n.dirty()), i.maxLength !== null && r.data.length > i.maxLength.value && (we(r, {
      code: he.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => i.type._parseAsync(new ea(r, o, r.path, s)))).then((o) => un.mergeArray(n, o));
    const a = [...r.data].map((o, s) => i.type._parseSync(new ea(r, o, r.path, s)));
    return un.mergeArray(n, a);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new Kn({
      ...this._def,
      minLength: { value: t, message: Ae.toString(r) }
    });
  }
  max(t, r) {
    return new Kn({
      ...this._def,
      maxLength: { value: t, message: Ae.toString(r) }
    });
  }
  length(t, r) {
    return new Kn({
      ...this._def,
      exactLength: { value: t, message: Ae.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Kn.create = (e, t) => new Kn({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Ue.ZodArray,
  ...Ke(t)
});
function ko(e) {
  if (e instanceof rr) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = Yi.create(ko(n));
    }
    return new rr({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof Kn ? new Kn({
    ...e._def,
    type: ko(e.element)
  }) : e instanceof Yi ? Yi.create(ko(e.unwrap())) : e instanceof cs ? cs.create(ko(e.unwrap())) : e instanceof Wa ? Wa.create(e.items.map((t) => ko(t))) : e;
}
class rr extends lt {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = ct.objectKeys(t);
    return this._cached = { shape: t, keys: r };
  }
  _parse(t) {
    if (this._getType(t) !== Te.object) {
      const l = this._getOrReturnCtx(t);
      return we(l, {
        code: he.invalid_type,
        expected: Te.object,
        received: l.parsedType
      }), qe;
    }
    const { status: r, ctx: n } = this._processInputParams(t), { shape: i, keys: a } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof ta && this._def.unknownKeys === "strip"))
      for (const l in n.data)
        a.includes(l) || o.push(l);
    const s = [];
    for (const l of a) {
      const d = i[l], u = n.data[l];
      s.push({
        key: { status: "valid", value: l },
        value: d._parse(new ea(n, u, n.path, l)),
        alwaysSet: l in n.data
      });
    }
    if (this._def.catchall instanceof ta) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const d of o)
          s.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: n.data[d] }
          });
      else if (l === "strict")
        o.length > 0 && (we(n, {
          code: he.unrecognized_keys,
          keys: o
        }), r.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const d of o) {
        const u = n.data[d];
        s.push({
          key: { status: "valid", value: d },
          value: l._parse(
            new ea(n, u, n.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const d of s) {
        const u = await d.key, c = await d.value;
        l.push({
          key: u,
          value: c,
          alwaysSet: d.alwaysSet
        });
      }
      return l;
    }).then((l) => un.mergeObjectSync(r, l)) : un.mergeObjectSync(r, s);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Ae.errToObj, new rr({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var i, a, o, s;
          const l = (o = (a = (i = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(i, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (s = Ae.errToObj(t).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new rr({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new rr({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new rr({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new rr({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Ue.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new rr({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    return ct.objectKeys(t).forEach((n) => {
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new rr({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    return ct.objectKeys(this.shape).forEach((n) => {
      t[n] || (r[n] = this.shape[n]);
    }), new rr({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ko(this);
  }
  partial(t) {
    const r = {};
    return ct.objectKeys(this.shape).forEach((n) => {
      const i = this.shape[n];
      t && !t[n] ? r[n] = i : r[n] = i.optional();
    }), new rr({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    return ct.objectKeys(this.shape).forEach((n) => {
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof Yi; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new rr({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return q9(ct.objectKeys(this.shape));
  }
}
rr.create = (e, t) => new rr({
  shape: () => e,
  unknownKeys: "strip",
  catchall: ta.create(),
  typeName: Ue.ZodObject,
  ...Ke(t)
});
rr.strictCreate = (e, t) => new rr({
  shape: () => e,
  unknownKeys: "strict",
  catchall: ta.create(),
  typeName: Ue.ZodObject,
  ...Ke(t)
});
rr.lazycreate = (e, t) => new rr({
  shape: e,
  unknownKeys: "strip",
  catchall: ta.create(),
  typeName: Ue.ZodObject,
  ...Ke(t)
});
class Wu extends lt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function i(a) {
      for (const s of a)
        if (s.result.status === "valid")
          return s.result;
      for (const s of a)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = a.map((s) => new xi(s.ctx.common.issues));
      return we(r, {
        code: he.invalid_union,
        unionErrors: o
      }), qe;
    }
    if (r.common.async)
      return Promise.all(n.map(async (a) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(i);
    {
      let a;
      const o = [];
      for (const l of n) {
        const d = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: d
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !a && (a = { result: u, ctx: d }), d.common.issues.length && o.push(d.common.issues);
      }
      if (a)
        return r.common.issues.push(...a.ctx.common.issues), a.result;
      const s = o.map((l) => new xi(l));
      return we(r, {
        code: he.invalid_union,
        unionErrors: s
      }), qe;
    }
  }
  get options() {
    return this._def.options;
  }
}
Wu.create = (e, t) => new Wu({
  options: e,
  typeName: Ue.ZodUnion,
  ...Ke(t)
});
function O2(e, t) {
  const r = zi(e), n = zi(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === Te.object && n === Te.object) {
    const i = ct.objectKeys(t), a = ct.objectKeys(e).filter((s) => i.indexOf(s) !== -1), o = { ...e, ...t };
    for (const s of a) {
      const l = O2(e[s], t[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === Te.array && n === Te.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const i = [];
    for (let a = 0; a < e.length; a++) {
      const o = e[a], s = t[a], l = O2(o, s);
      if (!l.valid)
        return { valid: !1 };
      i.push(l.data);
    }
    return { valid: !0, data: i };
  } else return r === Te.date && n === Te.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Qu extends lt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), i = (a, o) => {
      if (R3(a) || R3(o))
        return qe;
      const s = O2(a.value, o.value);
      return s.valid ? ((z3(a) || z3(o)) && r.dirty(), { status: r.value, value: s.data }) : (we(n, {
        code: he.invalid_intersection_types
      }), qe);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([a, o]) => i(a, o)) : i(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Qu.create = (e, t, r) => new Qu({
  left: e,
  right: t,
  typeName: Ue.ZodIntersection,
  ...Ke(r)
});
class Wa extends lt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Te.array)
      return we(n, {
        code: he.invalid_type,
        expected: Te.array,
        received: n.parsedType
      }), qe;
    if (n.data.length < this._def.items.length)
      return we(n, {
        code: he.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), qe;
    !this._def.rest && n.data.length > this._def.items.length && (we(n, {
      code: he.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((a, o) => {
      const s = this._def.items[o] || this._def.rest;
      return s ? s._parse(new ea(n, a, n.path, o)) : null;
    }).filter((a) => !!a);
    return n.common.async ? Promise.all(i).then((a) => un.mergeArray(r, a)) : un.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Wa({
      ...this._def,
      rest: t
    });
  }
}
Wa.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Wa({
    items: e,
    typeName: Ue.ZodTuple,
    rest: null,
    ...Ke(t)
  });
};
class G3 extends lt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Te.map)
      return we(n, {
        code: he.invalid_type,
        expected: Te.map,
        received: n.parsedType
      }), qe;
    const i = this._def.keyType, a = this._def.valueType, o = [...n.data.entries()].map(([s, l], d) => ({
      key: i._parse(new ea(n, s, n.path, [d, "key"])),
      value: a._parse(new ea(n, l, n.path, [d, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const d = await l.key, u = await l.value;
          if (d.status === "aborted" || u.status === "aborted")
            return qe;
          (d.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(d.value, u.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const d = l.key, u = l.value;
        if (d.status === "aborted" || u.status === "aborted")
          return qe;
        (d.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(d.value, u.value);
      }
      return { status: r.value, value: s };
    }
  }
}
G3.create = (e, t, r) => new G3({
  valueType: t,
  keyType: e,
  typeName: Ue.ZodMap,
  ...Ke(r)
});
class Wl extends lt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Te.set)
      return we(n, {
        code: he.invalid_type,
        expected: Te.set,
        received: n.parsedType
      }), qe;
    const i = this._def;
    i.minSize !== null && n.data.size < i.minSize.value && (we(n, {
      code: he.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), r.dirty()), i.maxSize !== null && n.data.size > i.maxSize.value && (we(n, {
      code: he.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), r.dirty());
    const a = this._def.valueType;
    function o(l) {
      const d = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return qe;
        u.status === "dirty" && r.dirty(), d.add(u.value);
      }
      return { status: r.value, value: d };
    }
    const s = [...n.data.values()].map((l, d) => a._parse(new ea(n, l, n.path, d)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(t, r) {
    return new Wl({
      ...this._def,
      minSize: { value: t, message: Ae.toString(r) }
    });
  }
  max(t, r) {
    return new Wl({
      ...this._def,
      maxSize: { value: t, message: Ae.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Wl.create = (e, t) => new Wl({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Ue.ZodSet,
  ...Ke(t)
});
class Y3 extends lt {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Y3.create = (e, t) => new Y3({
  getter: e,
  typeName: Ue.ZodLazy,
  ...Ke(t)
});
class K3 extends lt {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return we(r, {
        received: r.data,
        code: he.invalid_literal,
        expected: this._def.value
      }), qe;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
K3.create = (e, t) => new K3({
  value: e,
  typeName: Ue.ZodLiteral,
  ...Ke(t)
});
function q9(e, t) {
  return new ds({
    values: e,
    typeName: Ue.ZodEnum,
    ...Ke(t)
  });
}
class ds extends lt {
  constructor() {
    super(...arguments), vl.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return we(r, {
        expected: ct.joinValues(n),
        received: r.parsedType,
        code: he.invalid_type
      }), qe;
    }
    if (Bu(this, vl) || j9(this, vl, new Set(this._def.values)), !Bu(this, vl).has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return we(r, {
        received: r.data,
        code: he.invalid_enum_value,
        options: n
      }), qe;
    }
    return $n(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return ds.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return ds.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
vl = /* @__PURE__ */ new WeakMap();
ds.create = q9;
class Z3 extends lt {
  constructor() {
    super(...arguments), yl.set(this, void 0);
  }
  _parse(t) {
    const r = ct.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== Te.string && n.parsedType !== Te.number) {
      const i = ct.objectValues(r);
      return we(n, {
        expected: ct.joinValues(i),
        received: n.parsedType,
        code: he.invalid_type
      }), qe;
    }
    if (Bu(this, yl) || j9(this, yl, new Set(ct.getValidEnumValues(this._def.values))), !Bu(this, yl).has(t.data)) {
      const i = ct.objectValues(r);
      return we(n, {
        received: n.data,
        code: he.invalid_enum_value,
        options: i
      }), qe;
    }
    return $n(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
yl = /* @__PURE__ */ new WeakMap();
Z3.create = (e, t) => new Z3({
  values: e,
  typeName: Ue.ZodNativeEnum,
  ...Ke(t)
});
class Gu extends lt {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Te.promise && r.common.async === !1)
      return we(r, {
        code: he.invalid_type,
        expected: Te.promise,
        received: r.parsedType
      }), qe;
    const n = r.parsedType === Te.promise ? r.data : Promise.resolve(r.data);
    return $n(n.then((i) => this._def.type.parseAsync(i, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
Gu.create = (e, t) => new Gu({
  type: e,
  typeName: Ue.ZodPromise,
  ...Ke(t)
});
class us extends lt {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Ue.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), i = this._def.effect || null, a = {
      addIssue: (o) => {
        we(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), i.type === "preprocess") {
      const o = i.transform(n.data, a);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return qe;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? qe : l.status === "dirty" || r.value === "dirty" ? A2(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return qe;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? qe : s.status === "dirty" || r.value === "dirty" ? A2(s.value) : s;
      }
    }
    if (i.type === "refinement") {
      const o = (s) => {
        const l = i.refinement(s, a);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? qe : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? qe : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (i.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!ls(o))
          return o;
        const s = i.transform(o.value, a);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => ls(o) ? Promise.resolve(i.transform(o.value, a)).then((s) => ({ status: r.value, value: s })) : o);
    ct.assertNever(i);
  }
}
us.create = (e, t, r) => new us({
  schema: e,
  typeName: Ue.ZodEffects,
  effect: t,
  ...Ke(r)
});
us.createWithPreprocess = (e, t, r) => new us({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Ue.ZodEffects,
  ...Ke(r)
});
class Yi extends lt {
  _parse(t) {
    return this._getType(t) === Te.undefined ? $n(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Yi.create = (e, t) => new Yi({
  innerType: e,
  typeName: Ue.ZodOptional,
  ...Ke(t)
});
class cs extends lt {
  _parse(t) {
    return this._getType(t) === Te.null ? $n(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
cs.create = (e, t) => new cs({
  innerType: e,
  typeName: Ue.ZodNullable,
  ...Ke(t)
});
class I2 extends lt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === Te.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
I2.create = (e, t) => new I2({
  innerType: e,
  typeName: Ue.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...Ke(t)
});
class P2 extends lt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return qu(i) ? i.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new xi(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new xi(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
P2.create = (e, t) => new P2({
  innerType: e,
  typeName: Ue.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...Ke(t)
});
class X3 extends lt {
  _parse(t) {
    if (this._getType(t) !== Te.nan) {
      const r = this._getOrReturnCtx(t);
      return we(r, {
        code: he.invalid_type,
        expected: Te.nan,
        received: r.parsedType
      }), qe;
    }
    return { status: "valid", value: t.data };
  }
}
X3.create = (e) => new X3({
  typeName: Ue.ZodNaN,
  ...Ke(e)
});
class yC extends lt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class wf extends lt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? qe : i.status === "dirty" ? (r.dirty(), A2(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return i.status === "aborted" ? qe : i.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new wf({
      in: t,
      out: r,
      typeName: Ue.ZodPipeline
    });
  }
}
class D2 extends lt {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (i) => (ls(i) && (i.value = Object.freeze(i.value)), i);
    return qu(r) ? r.then((i) => n(i)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
D2.create = (e, t) => new D2({
  innerType: e,
  typeName: Ue.ZodReadonly,
  ...Ke(t)
});
var Ue;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Ue || (Ue = {}));
const _o = Hi.create;
ta.create;
Kn.create;
const B9 = rr.create;
Wu.create;
Qu.create;
Wa.create;
ds.create;
Gu.create;
Yi.create;
cs.create;
var M2 = function(e, t) {
  return M2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, M2(e, t);
};
function ld(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  M2(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var ae = function() {
  return ae = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ae.apply(this, arguments);
};
function N2(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function ji(e, t, r, n) {
  function i(a) {
    return a instanceof r ? a : new r(function(o) {
      o(a);
    });
  }
  return new (r || (r = Promise))(function(a, o) {
    function s(u) {
      try {
        d(n.next(u));
      } catch (c) {
        o(c);
      }
    }
    function l(u) {
      try {
        d(n.throw(u));
      } catch (c) {
        o(c);
      }
    }
    function d(u) {
      u.done ? a(u.value) : i(u.value).then(s, l);
    }
    d((n = n.apply(e, t || [])).next());
  });
}
function Vi(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = s(0), o.throw = s(1), o.return = s(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(d) {
    return function(u) {
      return l([d, u]);
    };
  }
  function l(d) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, d[0] && (r = 0)), r; ) try {
      if (n = 1, i && (a = d[0] & 2 ? i.return : d[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, d[1])).done) return a;
      switch (i = 0, a && (d = [d[0] & 2, a.value]), d[0]) {
        case 0:
        case 1:
          a = d;
          break;
        case 4:
          return r.label++, { value: d[1], done: !1 };
        case 5:
          r.label++, i = d[1], d = [0];
          continue;
        case 7:
          d = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (d[0] === 6 || d[0] === 2)) {
            r = 0;
            continue;
          }
          if (d[0] === 3 && (!a || d[1] > a[0] && d[1] < a[3])) {
            r.label = d[1];
            break;
          }
          if (d[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = d;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(d);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      d = t.call(e, r);
    } catch (u) {
      d = [6, u], i = 0;
    } finally {
      n = a = 0;
    }
    if (d[0] & 5) throw d[1];
    return { value: d[0] ? d[1] : void 0, done: !0 };
  }
}
function Fr(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, a; n < i; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function yu(e, t) {
  throw new Error(t);
}
function bC(e) {
  return typeof e == "object" && e !== null;
}
function $C(e, t) {
  throw new Error(
    "Unexpected invariant triggered."
  );
}
const wC = /\r\n|[\n\r]/g;
function L2(e, t) {
  let r = 0, n = 1;
  for (const i of e.body.matchAll(wC)) {
    if (typeof i.index == "number" || $C(), i.index >= t)
      break;
    r = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: t + 1 - r
  };
}
function xC(e) {
  return H9(
    e.source,
    L2(e.source, e.start)
  );
}
function H9(e, t) {
  const r = e.locationOffset.column - 1, n = "".padStart(r) + e.body, i = t.line - 1, a = e.locationOffset.line - 1, o = t.line + a, s = t.line === 1 ? r : 0, l = t.column + s, d = `${e.name}:${o}:${l}
`, u = n.split(/\r\n|[\n\r]/g), c = u[i];
  if (c.length > 120) {
    const h = Math.floor(l / 80), f = l % 80, p = [];
    for (let g = 0; g < c.length; g += 80)
      p.push(c.slice(g, g + 80));
    return d + J3([
      [`${o} |`, p[0]],
      ...p.slice(1, h + 1).map((g) => ["|", g]),
      ["|", "^".padStart(f)],
      ["|", p[h + 1]]
    ]);
  }
  return d + J3([
    // Lines specified like this: ["prefix", "string"],
    [`${o - 1} |`, u[i - 1]],
    [`${o} |`, c],
    ["|", "^".padStart(l)],
    [`${o + 1} |`, u[i + 1]]
  ]);
}
function J3(e) {
  const t = e.filter(([n, i]) => i !== void 0), r = Math.max(...t.map(([n]) => n.length));
  return t.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
}
function kC(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class xf extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...r) {
    var n, i, a;
    const { nodes: o, source: s, positions: l, path: d, originalError: u, extensions: c } = kC(r);
    super(t), this.name = "GraphQLError", this.path = d ?? void 0, this.originalError = u ?? void 0, this.nodes = em(
      Array.isArray(o) ? o : o ? [o] : void 0
    );
    const h = em(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((p) => p.loc).filter((p) => p != null)
    );
    this.source = s ?? (h == null || (i = h[0]) === null || i === void 0 ? void 0 : i.source), this.positions = l ?? h?.map((p) => p.start), this.locations = l && s ? l.map((p) => L2(s, p)) : h?.map((p) => L2(p.source, p.start));
    const f = bC(
      u?.extensions
    ) ? u?.extensions : void 0;
    this.extensions = (a = c ?? f) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), u != null && u.stack ? Object.defineProperty(this, "stack", {
      value: u.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, xf) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (t += `

` + xC(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        t += `

` + H9(this.source, r);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function em(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function pr(e, t, r) {
  return new xf(`Syntax Error: ${r}`, {
    source: e,
    positions: [t]
  });
}
class _C {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, r, n) {
    this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class W9 {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, r, n, i, a, o) {
    this.kind = t, this.start = r, this.end = n, this.line = i, this.column = a, this.value = o, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Q9 = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, CC = new Set(Object.keys(Q9));
function tm(e) {
  const t = e?.kind;
  return typeof t == "string" && CC.has(t);
}
var No;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(No || (No = {}));
var F2;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(F2 || (F2 = {}));
var $e;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})($e || ($e = {}));
function R2(e) {
  return e === 9 || e === 32;
}
function Ql(e) {
  return e >= 48 && e <= 57;
}
function G9(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function Y9(e) {
  return G9(e) || e === 95;
}
function SC(e) {
  return G9(e) || Ql(e) || e === 95;
}
function EC(e) {
  var t;
  let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let o = 0; o < e.length; ++o) {
    var a;
    const s = e[o], l = TC(s);
    l !== s.length && (n = (a = n) !== null && a !== void 0 ? a : o, i = o, o !== 0 && l < r && (r = l));
  }
  return e.map((o, s) => s === 0 ? o : o.slice(r)).slice(
    (t = n) !== null && t !== void 0 ? t : 0,
    i + 1
  );
}
function TC(e) {
  let t = 0;
  for (; t < e.length && R2(e.charCodeAt(t)); )
    ++t;
  return t;
}
function AC(e, t) {
  const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, a = n.length > 1 && n.slice(1).every((f) => f.length === 0 || R2(f.charCodeAt(0))), o = r.endsWith('\\"""'), s = e.endsWith('"') && !o, l = e.endsWith("\\"), d = s || l, u = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || d || a || o
  );
  let c = "";
  const h = i && R2(e.charCodeAt(0));
  return (u && !h || a) && (c += `
`), c += r, (u || d) && (c += `
`), '"""' + c + '"""';
}
var ie;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(ie || (ie = {}));
class OC {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const r = new W9(ie.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== ie.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const r = PC(this, t.end);
          t.next = r, r.prev = t, t = r;
        }
      while (t.kind === ie.COMMENT);
    return t;
  }
}
function IC(e) {
  return e === ie.BANG || e === ie.DOLLAR || e === ie.AMP || e === ie.PAREN_L || e === ie.PAREN_R || e === ie.SPREAD || e === ie.COLON || e === ie.EQUALS || e === ie.AT || e === ie.BRACKET_L || e === ie.BRACKET_R || e === ie.BRACE_L || e === ie.PIPE || e === ie.BRACE_R;
}
function Ts(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function Uc(e, t) {
  return K9(e.charCodeAt(t)) && Z9(e.charCodeAt(t + 1));
}
function K9(e) {
  return e >= 55296 && e <= 56319;
}
function Z9(e) {
  return e >= 56320 && e <= 57343;
}
function Qa(e, t) {
  const r = e.source.body.codePointAt(t);
  if (r === void 0)
    return ie.EOF;
  if (r >= 32 && r <= 126) {
    const n = String.fromCodePoint(r);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function tr(e, t, r, n, i) {
  const a = e.line, o = 1 + r - e.lineStart;
  return new W9(t, r, n, a, o, i);
}
function PC(e, t) {
  const r = e.source.body, n = r.length;
  let i = t;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    switch (a) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      case 35:
        return DC(e, i);
      case 33:
        return tr(e, ie.BANG, i, i + 1);
      case 36:
        return tr(e, ie.DOLLAR, i, i + 1);
      case 38:
        return tr(e, ie.AMP, i, i + 1);
      case 40:
        return tr(e, ie.PAREN_L, i, i + 1);
      case 41:
        return tr(e, ie.PAREN_R, i, i + 1);
      case 46:
        if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
          return tr(e, ie.SPREAD, i, i + 3);
        break;
      case 58:
        return tr(e, ie.COLON, i, i + 1);
      case 61:
        return tr(e, ie.EQUALS, i, i + 1);
      case 64:
        return tr(e, ie.AT, i, i + 1);
      case 91:
        return tr(e, ie.BRACKET_L, i, i + 1);
      case 93:
        return tr(e, ie.BRACKET_R, i, i + 1);
      case 123:
        return tr(e, ie.BRACE_L, i, i + 1);
      case 124:
        return tr(e, ie.PIPE, i, i + 1);
      case 125:
        return tr(e, ie.BRACE_R, i, i + 1);
      case 34:
        return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? zC(e, i) : NC(e, i);
    }
    if (Ql(a) || a === 45)
      return MC(e, i, a);
    if (Y9(a))
      return jC(e, i);
    throw pr(
      e.source,
      i,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Ts(a) || Uc(r, i) ? `Unexpected character: ${Qa(e, i)}.` : `Invalid character: ${Qa(e, i)}.`
    );
  }
  return tr(e, ie.EOF, n, n);
}
function DC(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (a === 10 || a === 13)
      break;
    if (Ts(a))
      ++i;
    else if (Uc(r, i))
      i += 2;
    else
      break;
  }
  return tr(
    e,
    ie.COMMENT,
    t,
    i,
    r.slice(t + 1, i)
  );
}
function MC(e, t, r) {
  const n = e.source.body;
  let i = t, a = r, o = !1;
  if (a === 45 && (a = n.charCodeAt(++i)), a === 48) {
    if (a = n.charCodeAt(++i), Ql(a))
      throw pr(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${Qa(
          e,
          i
        )}.`
      );
  } else
    i = n1(e, i, a), a = n.charCodeAt(i);
  if (a === 46 && (o = !0, a = n.charCodeAt(++i), i = n1(e, i, a), a = n.charCodeAt(i)), (a === 69 || a === 101) && (o = !0, a = n.charCodeAt(++i), (a === 43 || a === 45) && (a = n.charCodeAt(++i)), i = n1(e, i, a), a = n.charCodeAt(i)), a === 46 || Y9(a))
    throw pr(
      e.source,
      i,
      `Invalid number, expected digit but got: ${Qa(
        e,
        i
      )}.`
    );
  return tr(
    e,
    o ? ie.FLOAT : ie.INT,
    t,
    i,
    n.slice(t, i)
  );
}
function n1(e, t, r) {
  if (!Ql(r))
    throw pr(
      e.source,
      t,
      `Invalid number, expected digit but got: ${Qa(
        e,
        t
      )}.`
    );
  const n = e.source.body;
  let i = t + 1;
  for (; Ql(n.charCodeAt(i)); )
    ++i;
  return i;
}
function NC(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1, a = i, o = "";
  for (; i < n; ) {
    const s = r.charCodeAt(i);
    if (s === 34)
      return o += r.slice(a, i), tr(e, ie.STRING, t, i + 1, o);
    if (s === 92) {
      o += r.slice(a, i);
      const l = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? LC(e, i) : FC(e, i) : RC(e, i);
      o += l.value, i += l.size, a = i;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (Ts(s))
      ++i;
    else if (Uc(r, i))
      i += 2;
    else
      throw pr(
        e.source,
        i,
        `Invalid character within String: ${Qa(
          e,
          i
        )}.`
      );
  }
  throw pr(e.source, i, "Unterminated string.");
}
function LC(e, t) {
  const r = e.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const a = r.charCodeAt(t + i++);
    if (a === 125) {
      if (i < 5 || !Ts(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | bl(a), n < 0)
      break;
  }
  throw pr(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(
      t,
      t + i
    )}".`
  );
}
function FC(e, t) {
  const r = e.source.body, n = rm(r, t + 2);
  if (Ts(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (K9(n) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
    const i = rm(r, t + 8);
    if (Z9(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw pr(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
  );
}
function rm(e, t) {
  return bl(e.charCodeAt(t)) << 12 | bl(e.charCodeAt(t + 1)) << 8 | bl(e.charCodeAt(t + 2)) << 4 | bl(e.charCodeAt(t + 3));
}
function bl(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function RC(e, t) {
  const r = e.source.body;
  switch (r.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw pr(
    e.source,
    t,
    `Invalid character escape sequence: "${r.slice(
      t,
      t + 2
    )}".`
  );
}
function zC(e, t) {
  const r = e.source.body, n = r.length;
  let i = e.lineStart, a = t + 3, o = a, s = "";
  const l = [];
  for (; a < n; ) {
    const d = r.charCodeAt(a);
    if (d === 34 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34) {
      s += r.slice(o, a), l.push(s);
      const u = tr(
        e,
        ie.BLOCK_STRING,
        t,
        a + 3,
        // Return a string of the lines joined with U+000A.
        EC(l).join(`
`)
      );
      return e.line += l.length - 1, e.lineStart = i, u;
    }
    if (d === 92 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34 && r.charCodeAt(a + 3) === 34) {
      s += r.slice(o, a), o = a + 1, a += 4;
      continue;
    }
    if (d === 10 || d === 13) {
      s += r.slice(o, a), l.push(s), d === 13 && r.charCodeAt(a + 1) === 10 ? a += 2 : ++a, s = "", o = a, i = a;
      continue;
    }
    if (Ts(d))
      ++a;
    else if (Uc(r, a))
      a += 2;
    else
      throw pr(
        e.source,
        a,
        `Invalid character within String: ${Qa(
          e,
          a
        )}.`
      );
  }
  throw pr(e.source, a, "Unterminated string.");
}
function jC(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (SC(a))
      ++i;
    else
      break;
  }
  return tr(
    e,
    ie.NAME,
    t,
    i,
    r.slice(t, i)
  );
}
const VC = 10, X9 = 2;
function J9(e) {
  return qc(e, []);
}
function qc(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return UC(e, t);
    default:
      return String(e);
  }
}
function UC(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const r = [...t, e];
  if (qC(e)) {
    const n = e.toJSON();
    if (n !== e)
      return typeof n == "string" ? n : qc(n, r);
  } else if (Array.isArray(e))
    return HC(e, r);
  return BC(e, r);
}
function qC(e) {
  return typeof e.toJSON == "function";
}
function BC(e, t) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : t.length > X9 ? "[" + WC(e) + "]" : "{ " + r.map(
    ([n, i]) => n + ": " + qc(i, t)
  ).join(", ") + " }";
}
function HC(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > X9)
    return "[Array]";
  const r = Math.min(VC, e.length), n = e.length - r, i = [];
  for (let a = 0; a < r; ++a)
    i.push(qc(e[a], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function WC(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
const QC = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  // eslint-disable-next-line no-undef
  function(e, t) {
    return e instanceof t;
  }
);
class e7 {
  constructor(t, r = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || yu(!1, `Body must be a string. Received: ${J9(t)}.`), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || yu(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || yu(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function GC(e) {
  return QC(e, e7);
}
function YC(e, t) {
  return new KC(e, t).parseDocument();
}
class KC {
  constructor(t, r = {}) {
    const n = GC(t) ? t : new e7(t);
    this._lexer = new OC(n), this._options = r, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(ie.NAME);
    return this.node(t, {
      kind: $e.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: $e.DOCUMENT,
      definitions: this.many(
        ie.SOF,
        this.parseDefinition,
        ie.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(ie.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
    if (r.kind === ie.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (t)
        throw pr(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(ie.BRACE_L))
      return this.node(t, {
        kind: $e.OPERATION_DEFINITION,
        operation: No.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseOperationType();
    let n;
    return this.peek(ie.NAME) && (n = this.parseName()), this.node(t, {
      kind: $e.OPERATION_DEFINITION,
      operation: r,
      name: n,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(ie.NAME);
    switch (t.value) {
      case "query":
        return No.QUERY;
      case "mutation":
        return No.MUTATION;
      case "subscription":
        return No.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      ie.PAREN_L,
      this.parseVariableDefinition,
      ie.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: $e.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(ie.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(ie.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(ie.DOLLAR), this.node(t, {
      kind: $e.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: $e.SELECTION_SET,
      selections: this.many(
        ie.BRACE_L,
        this.parseSelection,
        ie.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(ie.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, r = this.parseName();
    let n, i;
    return this.expectOptionalToken(ie.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(t, {
      kind: $e.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(ie.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const r = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(ie.PAREN_L, r, ie.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(ie.COLON), this.node(r, {
      kind: $e.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(ie.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(ie.NAME) ? this.node(t, {
      kind: $e.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: $e.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: $e.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: $e.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const r = this._lexer.token;
    switch (r.kind) {
      case ie.BRACKET_L:
        return this.parseList(t);
      case ie.BRACE_L:
        return this.parseObject(t);
      case ie.INT:
        return this.advanceLexer(), this.node(r, {
          kind: $e.INT,
          value: r.value
        });
      case ie.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: $e.FLOAT,
          value: r.value
        });
      case ie.STRING:
      case ie.BLOCK_STRING:
        return this.parseStringLiteral();
      case ie.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: $e.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: $e.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: $e.NULL
            });
          default:
            return this.node(r, {
              kind: $e.ENUM,
              value: r.value
            });
        }
      case ie.DOLLAR:
        if (t)
          if (this.expectToken(ie.DOLLAR), this._lexer.token.kind === ie.NAME) {
            const n = this._lexer.token.value;
            throw pr(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: $e.STRING,
      value: t.value,
      block: t.kind === ie.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const r = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: $e.LIST,
      values: this.any(ie.BRACKET_L, r, ie.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const r = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: $e.OBJECT,
      fields: this.any(ie.BRACE_L, r, ie.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(ie.COLON), this.node(r, {
      kind: $e.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const r = [];
    for (; this.peek(ie.AT); )
      r.push(this.parseDirective(t));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const r = this._lexer.token;
    return this.expectToken(ie.AT), this.node(r, {
      kind: $e.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let r;
    if (this.expectOptionalToken(ie.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(ie.BRACKET_R), r = this.node(t, {
        kind: $e.LIST_TYPE,
        type: n
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(ie.BANG) ? this.node(t, {
      kind: $e.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: $e.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(ie.STRING) || this.peek(ie.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      ie.BRACE_L,
      this.parseOperationTypeDefinition,
      ie.BRACE_R
    );
    return this.node(t, {
      kind: $e.SCHEMA_DEFINITION,
      description: r,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, r = this.parseOperationType();
    this.expectToken(ie.COLON);
    const n = this.parseNamedType();
    return this.node(t, {
      kind: $e.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: $e.SCALAR_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: $e.OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(ie.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      ie.BRACE_L,
      this.parseFieldDefinition,
      ie.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(ie.COLON);
    const a = this.parseTypeReference(), o = this.parseConstDirectives();
    return this.node(t, {
      kind: $e.FIELD_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      type: a,
      directives: o
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      ie.PAREN_L,
      this.parseInputValueDef,
      ie.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName();
    this.expectToken(ie.COLON);
    const i = this.parseTypeReference();
    let a;
    this.expectOptionalToken(ie.EQUALS) && (a = this.parseConstValueLiteral());
    const o = this.parseConstDirectives();
    return this.node(t, {
      kind: $e.INPUT_VALUE_DEFINITION,
      description: r,
      name: n,
      type: i,
      defaultValue: a,
      directives: o
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: $e.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: $e.UNION_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(ie.EQUALS) ? this.delimitedMany(ie.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: $e.ENUM_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      ie.BRACE_L,
      this.parseEnumValueDefinition,
      ie.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: $e.ENUM_VALUE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw pr(
        this._lexer.source,
        this._lexer.token.start,
        `${Ud(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: $e.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      ie.BRACE_L,
      this.parseInputValueDef,
      ie.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === ie.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), n = this.optionalMany(
      ie.BRACE_L,
      this.parseOperationTypeDefinition,
      ie.BRACE_R
    );
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: $e.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: $e.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: $e.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: $e.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: $e.UNION_TYPE_EXTENSION,
      name: r,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: $e.ENUM_TYPE_EXTENSION,
      name: r,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: $e.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: n,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(ie.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), a = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(t, {
      kind: $e.DIRECTIVE_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      repeatable: a,
      locations: o
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(ie.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(F2, r.value))
      return r;
    throw this.unexpected(t);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, r) {
    return this._options.noLocation !== !0 && (r.loc = new _C(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const r = this._lexer.token;
    if (r.kind === t)
      return this.advanceLexer(), r;
    throw pr(
      this._lexer.source,
      r.start,
      `Expected ${t7(t)}, found ${Ud(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const r = this._lexer.token;
    if (r.kind === ie.NAME && r.value === t)
      this.advanceLexer();
    else
      throw pr(
        this._lexer.source,
        r.start,
        `Expected "${t}", found ${Ud(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const r = this._lexer.token;
    return r.kind === ie.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const r = t ?? this._lexer.token;
    return pr(
      this._lexer.source,
      r.start,
      `Unexpected ${Ud(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, r, n) {
    this.expectToken(t);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(r.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, r, n) {
    if (this.expectOptionalToken(t)) {
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, r, n) {
    this.expectToken(t);
    const i = [];
    do
      i.push(r.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, r) {
    this.expectOptionalToken(t);
    const n = [];
    do
      n.push(r.call(this));
    while (this.expectOptionalToken(t));
    return n;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, r = this._lexer.advance();
    if (t !== void 0 && r.kind !== ie.EOF && (++this._tokenCounter, this._tokenCounter > t))
      throw pr(
        this._lexer.source,
        r.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
}
function Ud(e) {
  const t = e.value;
  return t7(e.kind) + (t != null ? ` "${t}"` : "");
}
function t7(e) {
  return IC(e) ? `"${e}"` : e;
}
function ZC(e) {
  return `"${e.replace(XC, JC)}"`;
}
const XC = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function JC(e) {
  return eS[e.charCodeAt(0)];
}
const eS = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], Bc = Object.freeze({});
function Pn(e, t, r = Q9) {
  const n = /* @__PURE__ */ new Map();
  for (const m of Object.values($e))
    n.set(m, tS(t, m));
  let i, a = Array.isArray(e), o = [e], s = -1, l = [], d = e, u, c;
  const h = [], f = [];
  do {
    s++;
    const m = s === o.length, $ = m && l.length !== 0;
    if (m) {
      if (u = f.length === 0 ? void 0 : h[h.length - 1], d = c, c = f.pop(), $)
        if (a) {
          d = d.slice();
          let k = 0;
          for (const [C, E] of l) {
            const N = C - k;
            E === null ? (d.splice(N, 1), k++) : d[N] = E;
          }
        } else {
          d = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(d)
          );
          for (const [k, C] of l)
            d[k] = C;
        }
      s = i.index, o = i.keys, l = i.edits, a = i.inArray, i = i.prev;
    } else if (c) {
      if (u = a ? s : o[s], d = c[u], d == null)
        continue;
      h.push(u);
    }
    let w;
    if (!Array.isArray(d)) {
      var p, g;
      if (tm(d) || yu(!1, `Invalid AST Node: ${J9(d)}.`), w = (m ? (p = n.get(d.kind)) === null || p === void 0 ? void 0 : p.leave : (g = n.get(d.kind)) === null || g === void 0 ? void 0 : g.enter)?.call(t, d, u, c, h, f), w === Bc)
        break;
      if (w === !1) {
        if (!m) {
          h.pop();
          continue;
        }
      } else if (w !== void 0 && (l.push([u, w]), !m))
        if (tm(w))
          d = w;
        else {
          h.pop();
          continue;
        }
    }
    if (w === void 0 && $ && l.push([u, d]), m)
      h.pop();
    else {
      var v;
      i = {
        inArray: a,
        index: s,
        keys: o,
        edits: l,
        prev: i
      }, a = Array.isArray(d), o = a ? d : (v = r[d.kind]) !== null && v !== void 0 ? v : [], s = -1, l = [], c && f.push(c), c = d;
    }
  } while (i !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : e;
}
function tS(e, t) {
  const r = e[t];
  return typeof r == "object" ? r : typeof r == "function" ? {
    enter: r,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function rS(e) {
  return Pn(e, iS);
}
const nS = 80, iS = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => Ee(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = tt("(", Ee(e.variableDefinitions, ", "), ")"), r = Ee(
        [
          e.operation,
          Ee([e.name, t]),
          Ee(e.directives, " ")
        ],
        " "
      );
      return (r === "query" ? "" : r + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: r, directives: n }) => e + ": " + t + tt(" = ", r) + tt(" ", Ee(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => xn(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: r, directives: n, selectionSet: i }) {
      const a = tt("", e, ": ") + t;
      let o = a + tt("(", Ee(r, ", "), ")");
      return o.length > nS && (o = a + tt(`(
`, bu(Ee(r, `
`)), `
)`)), Ee([o, Ee(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + tt(" ", Ee(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: r }) => Ee(
      [
        "...",
        tt("on ", e),
        Ee(t, " "),
        r
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: e, typeCondition: t, variableDefinitions: r, directives: n, selectionSet: i }) => (
      // or removed in the future.
      `fragment ${e}${tt("(", Ee(r, ", "), ")")} on ${t} ${tt("", Ee(n, " "), " ")}` + i
    )
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? AC(e) : ZC(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + Ee(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + Ee(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + tt("(", Ee(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: r }) => tt("", e, `
`) + Ee(["schema", Ee(t, " "), xn(r)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: r }) => tt("", e, `
`) + Ee(["scalar", t, Ee(r, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => tt("", e, `
`) + Ee(
      [
        "type",
        t,
        tt("implements ", Ee(r, " & ")),
        Ee(n, " "),
        xn(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: r, type: n, directives: i }) => tt("", e, `
`) + t + (nm(r) ? tt(`(
`, bu(Ee(r, `
`)), `
)`) : tt("(", Ee(r, ", "), ")")) + ": " + n + tt(" ", Ee(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: r, defaultValue: n, directives: i }) => tt("", e, `
`) + Ee(
      [t + ": " + r, tt("= ", n), Ee(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => tt("", e, `
`) + Ee(
      [
        "interface",
        t,
        tt("implements ", Ee(r, " & ")),
        Ee(n, " "),
        xn(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, types: n }) => tt("", e, `
`) + Ee(
      ["union", t, Ee(r, " "), tt("= ", Ee(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, values: n }) => tt("", e, `
`) + Ee(["enum", t, Ee(r, " "), xn(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: r }) => tt("", e, `
`) + Ee([t, Ee(r, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, fields: n }) => tt("", e, `
`) + Ee(["input", t, Ee(r, " "), xn(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: r, repeatable: n, locations: i }) => tt("", e, `
`) + "directive @" + t + (nm(r) ? tt(`(
`, bu(Ee(r, `
`)), `
)`) : tt("(", Ee(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + Ee(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => Ee(
      ["extend schema", Ee(e, " "), xn(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => Ee(["extend scalar", e, Ee(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => Ee(
      [
        "extend type",
        e,
        tt("implements ", Ee(t, " & ")),
        Ee(r, " "),
        xn(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => Ee(
      [
        "extend interface",
        e,
        tt("implements ", Ee(t, " & ")),
        Ee(r, " "),
        xn(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: r }) => Ee(
      [
        "extend union",
        e,
        Ee(t, " "),
        tt("= ", Ee(r, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: r }) => Ee(["extend enum", e, Ee(t, " "), xn(r)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: r }) => Ee(["extend input", e, Ee(t, " "), xn(r)], " ")
  }
};
function Ee(e, t = "") {
  var r;
  return (r = e?.filter((n) => n).join(t)) !== null && r !== void 0 ? r : "";
}
function xn(e) {
  return tt(`{
`, bu(Ee(e, `
`)), `
}`);
}
function tt(e, t, r = "") {
  return t != null && t !== "" ? e + t + r : "";
}
function bu(e) {
  return tt("  ", e.replace(/\n/g, `
  `));
}
function nm(e) {
  var t;
  return (t = e?.some((r) => r.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
function im(e) {
  return e.kind === $e.FIELD || e.kind === $e.FRAGMENT_SPREAD || e.kind === $e.INLINE_FRAGMENT;
}
var $u = /* @__PURE__ */ new Map(), z2 = /* @__PURE__ */ new Map(), r7 = !0, Yu = !1;
function n7(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function aS(e) {
  return n7(e.source.body.substring(e.start, e.end));
}
function oS(e) {
  var t = /* @__PURE__ */ new Set(), r = [];
  return e.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var i = n.name.value, a = aS(n.loc), o = z2.get(i);
      o && !o.has(a) ? r7 && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || z2.set(i, o = /* @__PURE__ */ new Set()), o.add(a), t.has(a) || (t.add(a), r.push(n));
    } else
      r.push(n);
  }), ae(ae({}, e), { definitions: r });
}
function sS(e) {
  var t = new Set(e.definitions);
  t.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
      var a = n[i];
      a && typeof a == "object" && t.add(a);
    });
  });
  var r = e.loc;
  return r && (delete r.startToken, delete r.endToken), e;
}
function lS(e) {
  var t = n7(e);
  if (!$u.has(t)) {
    var r = YC(e, {
      experimentalFragmentVariables: Yu,
      allowLegacyFragmentVariables: Yu
    });
    if (!r || r.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    $u.set(t, sS(oS(r)));
  }
  return $u.get(t);
}
function Le(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  typeof e == "string" && (e = [e]);
  var n = e[0];
  return t.forEach(function(i, a) {
    i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += e[a + 1];
  }), lS(n);
}
function dS() {
  $u.clear(), z2.clear();
}
function uS() {
  r7 = !1;
}
function cS() {
  Yu = !0;
}
function hS() {
  Yu = !1;
}
var Ks = {
  gql: Le,
  resetCaches: dS,
  disableFragmentWarnings: uS,
  enableExperimentalFragmentVariables: cS,
  disableExperimentalFragmentVariables: hS
};
(function(e) {
  e.gql = Ks.gql, e.resetCaches = Ks.resetCaches, e.disableFragmentWarnings = Ks.disableFragmentWarnings, e.enableExperimentalFragmentVariables = Ks.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = Ks.disableExperimentalFragmentVariables;
})(Le || (Le = {}));
Le.default = Le;
function i7(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (r = i7(e[t])) && (n && (n += " "), n += r);
  else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function Zt() {
  for (var e, t, r = 0, n = ""; r < arguments.length; ) (e = arguments[r++]) && (t = i7(e)) && (n && (n += " "), n += t);
  return n;
}
var fS = /* @__PURE__ */ x("<svg>");
const pS = (e) => {
  const [t, r] = Ua(e, ["path"]);
  return (() => {
    var n = fS();
    return yn(n, Be({
      get viewBox() {
        return t.path.mini ? "0 0 20 20" : "0 0 24 24";
      },
      get fill() {
        return t.path.outline ? "none" : "currentColor";
      },
      get stroke() {
        return t.path.outline ? "currentColor" : "none";
      },
      get "stroke-width"() {
        return t.path.outline ? 1.5 : void 0;
      }
    }, r), !0, !0), S(n, () => t.path.path), n;
  })();
};
var mS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5"></svg>', !1, !0, !1), gS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"></svg>', !1, !0, !1), vS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5"></svg>', !1, !0, !1), yS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), bS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), $S = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), wS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), xS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 4.5l-15 15m0 0h11.25m-11.25 0V8.25"></svg>', !1, !0, !1), kS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m-6 3.75l3 3m0 0l3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75"></svg>', !1, !0, !1), _S = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15M9 12l3 3m0 0l3-3m-3 3V2.25"></svg>', !1, !0, !1), CS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 4.5l15 15m0 0V8.25m0 11.25H8.25"></svg>', !1, !0, !1), SS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"></svg>', !1, !0, !1), ES = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"></svg>', !1, !0, !1), TS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), AS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"></svg>', !1, !0, !1), OS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"></svg>', !1, !0, !1), IS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 17.25L12 21m0 0l-3.75-3.75M12 21V3"></svg>', !1, !0, !1), PS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"></svg>', !1, !0, !1), DS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"></svg>', !1, !0, !1), MS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 6.75L12 3m0 0l3.75 3.75M12 3v18"></svg>', !1, !0, !1), NS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3"></svg>', !1, !0, !1), LS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"></svg>', !1, !0, !1), FS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), RS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"></svg>', !1, !0, !1), zS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"></svg>', !1, !0, !1), jS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75"></svg>', !1, !0, !1), VS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"></svg>', !1, !0, !1), US = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></svg>', !1, !0, !1), qS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"></svg>', !1, !0, !1), BS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"></svg>', !1, !0, !1), HS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 6L9 12.75l4.286-4.286a11.948 11.948 0 014.306 6.43l.776 2.898m0 0l3.182-5.511m-3.182 5.51l-5.511-3.181"></svg>', !1, !0, !1), WS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"></svg>', !1, !0, !1), QS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), GS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 19.5l-15-15m0 0v11.25m0-11.25h11.25"></svg>', !1, !0, !1), YS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m0-3l-3-3m0 0l-3 3m3-3v11.25m6-2.25h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75"></svg>', !1, !0, !1), KS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15"></svg>', !1, !0, !1), ZS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"></svg>', !1, !0, !1), XS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"></svg>', !1, !0, !1), JS = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"></svg>', !1, !0, !1), eE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 15l-6 6m0 0l-6-6m6 6V9a6 6 0 0112 0v3"></svg>', !1, !0, !1), tE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"></svg>', !1, !0, !1), rE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 15l6-6m0 0l-6-6m6 6H9a6 6 0 000 12h3"></svg>', !1, !0, !1), nE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9l6-6m0 0l6 6m-6-6v12a6 6 0 01-12 0v-3"></svg>', !1, !0, !1), iE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5l5.25 5.25"></svg>', !1, !0, !1), aE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"></svg>', !1, !0, !1), oE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"></svg>', !1, !0, !1), sE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"></svg>', !1, !0, !1), lE = /* @__PURE__ */ x('<svg><path stroke-linecap=round d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25"></svg>', !1, !0, !1), dE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9.75L14.25 12m0 0l2.25 2.25M14.25 12l2.25-2.25M14.25 12L12 14.25m-2.58 4.92l-6.375-6.375a1.125 1.125 0 010-1.59L9.42 4.83c.211-.211.498-.33.796-.33H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-9.284c-.298 0-.585-.119-.796-.33z"></svg>', !1, !0, !1), uE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 16.811c0 .864-.933 1.405-1.683.977l-7.108-4.062a1.125 1.125 0 010-1.953l7.108-4.062A1.125 1.125 0 0121 8.688v8.123zM11.25 16.811c0 .864-.933 1.405-1.683.977l-7.108-4.062a1.125 1.125 0 010-1.953L9.567 7.71a1.125 1.125 0 011.683.977v8.123z"></svg>', !1, !0, !1), cE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"></svg>', !1, !0, !1), hE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 9h16.5m-16.5 6.75h16.5"></svg>', !1, !0, !1), fE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"></svg>', !1, !0, !1), pE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25"></svg>', !1, !0, !1), mE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"></svg>', !1, !0, !1), gE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"></svg>', !1, !0, !1), vE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"></svg>', !1, !0, !1), yE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0l-3.75-3.75M17.25 21L21 17.25"></svg>', !1, !0, !1), bE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12"></svg>', !1, !0, !1), $E = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"></svg>', !1, !0, !1), wE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5H18V15H4.5v-4.5zM3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"></svg>', !1, !0, !1), xE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5h6.75V15H4.5v-4.5zM3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"></svg>', !1, !0, !1), kE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"></svg>', !1, !0, !1), _E = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5"></svg>', !1, !0, !1), CE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.143 17.082a24.248 24.248 0 003.844.148m-3.844-.148a23.856 23.856 0 01-5.455-1.31 8.964 8.964 0 002.3-5.542m3.155 6.852a3 3 0 005.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 003.536-1.003A8.967 8.967 0 0118 9.75V9A6 6 0 006.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"></svg>', !1, !0, !1), SE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M10.5 8.25h3l-3 4.5h3"></svg>', !1, !0, !1), EE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"></svg>', !1, !0, !1), TE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.412 15.655L9.75 21.75l3.745-4.012M9.257 13.5H3.75l2.659-2.849m2.048-2.194L14.25 2.25 12 10.5h8.25l-4.707 5.043M8.457 8.457L3 3m5.457 5.457l7.086 7.086m0 0L21 21"></svg>', !1, !0, !1), AE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"></svg>', !1, !0, !1), OE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"></svg>', !1, !0, !1), IE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 3l1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17.25 4.5 21V8.742m.164-4.078a2.15 2.15 0 011.743-1.342 48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185V19.5M4.664 4.664L19.5 19.5"></svg>', !1, !0, !1), PE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h1.5m9 0h-9"></svg>', !1, !0, !1), DE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z"></svg>', !1, !0, !1), ME = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"></svg>', !1, !0, !1), NE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0112 12.75zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 01-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 002.248-2.354M12 12.75a2.25 2.25 0 01-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 00-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 01.4-2.253M12 8.25a2.25 2.25 0 00-2.248 2.146M12 8.25a2.25 2.25 0 012.248 2.146M8.683 5a6.032 6.032 0 01-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0115.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 00-.575-1.752M4.921 6a24.048 24.048 0 00-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 01-5.223 1.082"></svg>', !1, !0, !1), LE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z"></svg>', !1, !0, !1), FE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), RE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"></svg>', !1, !0, !1), zE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 21v-7.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349m-16.5 11.65V9.35m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72L4.318 3.44A1.5 1.5 0 015.378 3h13.243a1.5 1.5 0 011.06.44l1.19 1.189a3 3 0 01-.621 4.72m-13.5 8.65h3.75a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v3.75c0 .415.336.75.75.75z"></svg>', !1, !0, !1), jE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.87c1.355 0 2.697.055 4.024.165C17.155 8.51 18 9.473 18 10.608v2.513m-3-4.87v-1.5m-6 1.5v-1.5m12 9.75l-1.5.75a3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0L3 16.5m15-3.38a48.474 48.474 0 00-6-.37c-2.032 0-4.034.125-6 .37m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.17c0 .62-.504 1.124-1.125 1.124H4.125A1.125 1.125 0 013 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 016 13.12M12.265 3.11a.375.375 0 11-.53 0L12 2.845l.265.265zm-3 0a.375.375 0 11-.53 0L9 2.845l.265.265zm6 0a.375.375 0 11-.53 0L15 2.845l.265.265z"></svg>', !1, !0, !1), VE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"></svg>', !1, !0, !1), UE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"></svg>', !1, !0, !1), qE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"></svg>', !1, !0, !1), BE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z"></svg>', !1, !0, !1), HE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z"></svg>', !1, !0, !1), WE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"></svg>', !1, !0, !1), QE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"></svg>', !1, !0, !1), GE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z"></svg>', !1, !0, !1), YE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z"></svg>', !1, !0, !1), KE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), ZE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 21l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), XE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), JE = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"></svg>', !1, !0, !1), eT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), tT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"></svg>', !1, !0, !1), rT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 01-.923 1.785A5.969 5.969 0 006 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337z"></svg>', !1, !0, !1), nT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"></svg>', !1, !0, !1), iT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), aT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12.75l6 6 9-13.5"></svg>', !1, !0, !1), oT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 5.25l-7.5 7.5-7.5-7.5m15 6l-7.5 7.5-7.5-7.5"></svg>', !1, !0, !1), sT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"></svg>', !1, !0, !1), lT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5"></svg>', !1, !0, !1), dT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12.75l7.5-7.5 7.5 7.5m-15 6l7.5-7.5 7.5 7.5"></svg>', !1, !0, !1), uT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 8.25l-7.5 7.5-7.5-7.5"></svg>', !1, !0, !1), cT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 19.5L8.25 12l7.5-7.5"></svg>', !1, !0, !1), hT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 4.5l7.5 7.5-7.5 7.5"></svg>', !1, !0, !1), fT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></svg>', !1, !0, !1), pT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 15.75l7.5-7.5 7.5 7.5"></svg>', !1, !0, !1), mT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"></svg>', !1, !0, !1), gT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75"></svg>', !1, !0, !1), vT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"></svg>', !1, !0, !1), yT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z"></svg>', !1, !0, !1), bT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184"></svg>', !1, !0, !1), $T = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), wT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9.75v6.75m0 0l-3-3m3 3l3-3m-8.25 6a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"></svg>', !1, !0, !1), xT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"></svg>', !1, !0, !1), kT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z"></svg>', !1, !0, !1), _T = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 9.75L16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"></svg>', !1, !0, !1), CT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"></svg>', !1, !0, !1), ST = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"></svg>', !1, !0, !1), kf = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), ET = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z"></svg>', !1, !0, !1), TT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 1115 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3m7.5-12.99l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205L12 12m6.894 5.785l-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864l-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"></svg>', !1, !0, !1), AT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), OT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25"></svg>', !1, !0, !1), IT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z"></svg>', !1, !0, !1), PT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"></svg>', !1, !0, !1), DT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 7.5l-2.25-1.313M21 7.5v2.25m0-2.25l-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3l2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75l2.25-1.313M12 21.75V19.5m0 2.25l-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"></svg>', !1, !0, !1), MT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"></svg>', !1, !0, !1), NT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 7.5l.415-.207a.75.75 0 011.085.67V10.5m0 0h6m-6 0h-1.5m1.5 0v5.438c0 .354.161.697.473.865a3.751 3.751 0 005.452-2.553c.083-.409-.263-.75-.68-.75h-.745M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), LT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), FT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), RT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.121 7.629A3 3 0 009.017 9.43c-.023.212-.002.425.028.636l.506 3.541a4.5 4.5 0 01-.43 2.65L9 16.5l1.539-.513a2.25 2.25 0 011.422 0l.655.218a2.25 2.25 0 001.718-.122L15 15.75M8.25 12H12m9 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), zT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 8.25H9m6 3H9m3 6l-3-3h1.5a3 3 0 100-6M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), jT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 7.5l3 4.5m0 0l3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), VT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zM12 2.25V4.5m5.834.166l-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243l-1.59-1.59"></svg>', !1, !0, !1), UT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zm-7.518-.267A8.25 8.25 0 1120.25 10.5M8.288 14.212A5.25 5.25 0 1117.25 10.5"></svg>', !1, !0, !1), qT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"></svg>', !1, !0, !1), BT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 002.25-2.25v-15a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 4.5v15a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), HT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), WT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), QT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), GT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 019 9v.375M10.125 2.25A3.375 3.375 0 0113.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 013.375 3.375M9 15l2.25 2.25L15 12"></svg>', !1, !0, !1), YT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"></svg>', !1, !0, !1), KT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"></svg>', !1, !0, !1), ZT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), XT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), JT = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), eA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), tA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), rA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"></svg>', !1, !0, !1), nA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"></svg>', !1, !0, !1), iA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 9v.906a2.25 2.25 0 01-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 001.183 1.981l6.478 3.488m8.839 2.51l-4.66-2.51m0 0l-1.023-.55a2.25 2.25 0 00-2.134 0l-1.022.55m0 0l-4.661 2.51m16.5 1.615a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V8.844a2.25 2.25 0 011.183-1.98l7.5-4.04a2.25 2.25 0 012.134 0l7.5 4.04a2.25 2.25 0 011.183 1.98V19.5z"></svg>', !1, !0, !1), aA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"></svg>', !1, !0, !1), oA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"></svg>', !1, !0, !1), sA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"></svg>', !1, !0, !1), lA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 11.25l1.5 1.5.75-.75V8.758l2.276-.61a3 3 0 10-3.675-3.675l-.61 2.277H12l-.75.75 1.5 1.5M15 11.25l-8.47 8.47c-.34.34-.8.53-1.28.53s-.94.19-1.28.53l-.97.97-.75-.75.97-.97c.34-.34.53-.8.53-1.28s.19-.94.53-1.28L12.75 9M15 11.25L12.75 9"></svg>', !1, !0, !1), dA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"></svg>', !1, !0, !1), uA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"></svg>', !1, !0, !1), cA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.182 16.318A4.486 4.486 0 0012.016 15a4.486 4.486 0 00-3.198 1.318M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"></svg>', !1, !0, !1), hA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.182 15.182a4.5 4.5 0 01-6.364 0M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"></svg>', !1, !0, !1), fA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0118 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0118 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 016 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5"></svg>', !1, !0, !1), pA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.864 4.243A7.5 7.5 0 0119.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 004.5 10.5a7.464 7.464 0 01-1.15 3.993m1.989 3.559A11.209 11.209 0 008.25 10.5a3.75 3.75 0 117.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 01-3.6 9.75m6.633-4.596a18.666 18.666 0 01-2.485 5.33"></svg>', !1, !0, !1), mA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z"></svg>', !1, !0, !1), gA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1A3.75 3.75 0 0012 18z"></svg>', !1, !0, !1), vA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 3v1.5M3 21v-6m0 0l2.77-.693a9 9 0 016.208.682l.108.054a9 9 0 006.086.71l3.114-.732a48.524 48.524 0 01-.005-10.499l-3.11.732a9 9 0 01-6.085-.711l-.108-.054a9 9 0 00-6.208-.682L3 4.5M3 15V4.5"></svg>', !1, !0, !1), yA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 13.5l3 3m0 0l3-3m-3 3v-6m1.06-4.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), bA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 13.5H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), $A = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 00-1.883 2.542l.857 6a2.25 2.25 0 002.227 1.932H19.05a2.25 2.25 0 002.227-1.932l.857-6a2.25 2.25 0 00-1.883-2.542m-16.5 0V6A2.25 2.25 0 016 3.75h3.879a1.5 1.5 0 011.06.44l2.122 2.12a1.5 1.5 0 001.06.44H18A2.25 2.25 0 0120.25 9v.776"></svg>', !1, !0, !1), wA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 10.5v6m3-3H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), xA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), kA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062A1.125 1.125 0 013 16.81V8.688zM12.75 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062a1.125 1.125 0 01-1.683-.977V8.688z"></svg>', !1, !0, !1), _A = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"></svg>', !1, !0, !1), CA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 8.25v7.5m6-7.5h-3V12m0 0v3.75m0-3.75H18M9.75 9.348c-1.03-1.464-2.698-1.464-3.728 0-1.03 1.465-1.03 3.84 0 5.304 1.03 1.464 2.699 1.464 3.728 0V12h-1.5M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"></svg>', !1, !0, !1), SA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3.75v16.5M2.25 12h19.5M6.375 17.25a4.875 4.875 0 004.875-4.875V12m6.375 5.25a4.875 4.875 0 01-4.875-4.875V12m-9 8.25h16.5a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5H3.75a1.5 1.5 0 00-1.5 1.5v13.5a1.5 1.5 0 001.5 1.5zm12.621-9.44c-1.409 1.41-4.242 1.061-4.242 1.061s-.349-2.833 1.06-4.242a2.25 2.25 0 013.182 3.182zM10.773 7.63c1.409 1.409 1.06 4.242 1.06 4.242S9 12.22 7.592 10.811a2.25 2.25 0 113.182-3.182z"></svg>', !1, !0, !1), EA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), TA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"></svg>', !1, !0, !1), AA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.115 5.19l.319 1.913A6 6 0 008.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 002.288-4.042 1.087 1.087 0 00-.358-1.099l-1.33-1.108c-.251-.21-.582-.299-.905-.245l-1.17.195a1.125 1.125 0 01-.98-.314l-.295-.295a1.125 1.125 0 010-1.591l.13-.132a1.125 1.125 0 011.3-.21l.603.302a.809.809 0 001.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 001.528-1.732l.146-.292M6.115 5.19A9 9 0 1017.18 4.64M6.115 5.19A8.965 8.965 0 0112 3c1.929 0 3.716.607 5.18 1.64"></svg>', !1, !0, !1), OA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 01-1.161.886l-.143.048a1.107 1.107 0 00-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 01-1.652.928l-.679-.906a1.125 1.125 0 00-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 00-8.862 12.872M12.75 3.031a9 9 0 016.69 14.036m0 0l-.177-.529A2.25 2.25 0 0017.128 15H16.5l-.324-.324a1.453 1.453 0 00-2.328.377l-.036.073a1.586 1.586 0 01-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 01-5.276 3.67m0 0a9 9 0 01-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25"></svg>', !1, !0, !1), IA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.893 13.393l-1.135-1.135a2.252 2.252 0 01-.421-.585l-1.08-2.16a.414.414 0 00-.663-.107.827.827 0 01-.812.21l-1.273-.363a.89.89 0 00-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 01-1.81 1.025 1.055 1.055 0 01-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 01-1.383-2.46l.007-.042a2.25 2.25 0 01.29-.787l.09-.15a2.25 2.25 0 012.37-1.048l1.178.236a1.125 1.125 0 001.302-.795l.208-.73a1.125 1.125 0 00-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 01-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 01-1.458-1.137l1.411-2.353a2.25 2.25 0 00.286-.76m11.928 9.869A9 9 0 008.965 3.525m11.928 9.868A9 9 0 118.965 3.525"></svg>', !1, !0, !1), PA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.05 4.575a1.575 1.575 0 10-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 013.15 0v1.5m-3.15 0l.075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 013.15 0V15M6.9 7.575a1.575 1.575 0 10-3.15 0v8.175a6.75 6.75 0 006.75 6.75h2.018a5.25 5.25 0 003.712-1.538l1.732-1.732a5.25 5.25 0 001.538-3.712l.003-2.024a.668.668 0 01.198-.471 1.575 1.575 0 10-2.228-2.228 3.818 3.818 0 00-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0116.35 15m.002 0h-.002"></svg>', !1, !0, !1), DA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 15h2.25m8.024-9.75c.011.05.028.1.052.148.591 1.2.924 2.55.924 3.977a8.96 8.96 0 01-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398C20.613 14.547 19.833 15 19 15h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 00.303-.54m.023-8.25H16.48a4.5 4.5 0 01-1.423-.23l-3.114-1.04a4.5 4.5 0 00-1.423-.23H6.504c-.618 0-1.217.247-1.605.729A11.95 11.95 0 002.25 12c0 .434.023.863.068 1.285C2.427 14.306 3.346 15 4.372 15h3.126c.618 0 .991.724.725 1.282A7.471 7.471 0 007.5 19.5a2.25 2.25 0 002.25 2.25.75.75 0 00.75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 002.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384"></svg>', !1, !0, !1), MA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z"></svg>', !1, !0, !1), NA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5l-3.9 19.5m-2.1-19.5l-3.9 19.5"></svg>', !1, !0, !1), LA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"></svg>', !1, !0, !1), FA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205l3 1m1.5.5l-1.5-.5M6.75 7.364V3h-3v18m3-13.636l10.5-3.819"></svg>', !1, !0, !1), RA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"></svg>', !1, !0, !1), zA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z"></svg>', !1, !0, !1), jA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 3.75H6.912a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859M12 3v8.25m0 0l-3-3m3 3l3-3"></svg>', !1, !0, !1), VA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.875 14.25l1.214 1.942a2.25 2.25 0 001.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 011.872 1.002l.164.246a2.25 2.25 0 001.872 1.002h2.092a2.25 2.25 0 001.872-1.002l.164-.246A2.25 2.25 0 0116.954 9h4.636M2.41 9a2.25 2.25 0 00-.16.832V12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 01.382-.632l3.285-3.832a2.25 2.25 0 011.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0021.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), UA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H6.911a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661z"></svg>', !1, !0, !1), qA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></svg>', !1, !0, !1), BA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z"></svg>', !1, !0, !1), HA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802"></svg>', !1, !0, !1), WA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.712 4.33a9.027 9.027 0 011.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 00-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 010 9.424m-4.138-5.976a3.736 3.736 0 00-.88-1.388 3.737 3.737 0 00-1.388-.88m2.268 2.268a3.765 3.765 0 010 2.528m-2.268-4.796a3.765 3.765 0 00-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 01-1.388.88m2.268-2.268l4.138 3.448m0 0a9.027 9.027 0 01-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0l-3.448-4.138m3.448 4.138a9.014 9.014 0 01-9.424 0m5.976-4.138a3.765 3.765 0 01-2.528 0m0 0a3.736 3.736 0 01-1.388-.88 3.737 3.737 0 01-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 01-1.652-1.306 9.027 9.027 0 01-1.306-1.652m0 0l4.138-3.448M4.33 16.712a9.014 9.014 0 010-9.424m4.138 5.976a3.765 3.765 0 010-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 011.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 00-1.652 1.306A9.025 9.025 0 004.33 7.288"></svg>', !1, !0, !1), QA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"></svg>', !1, !0, !1), GA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"></svg>', !1, !0, !1), YA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), KA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), ZA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), XA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 15.75l-2.489-2.489m0 0a3.375 3.375 0 10-4.773-4.773 3.375 3.375 0 004.774 4.774zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), JA = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM13.5 10.5h-6"></svg>', !1, !0, !1), eO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6"></svg>', !1, !0, !1), tO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"></svg>', !1, !0, !1), rO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), nO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"></svg>', !1, !0, !1), iO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"></svg>', !1, !0, !1), aO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46"></svg>', !1, !0, !1), oO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z"></svg>', !1, !0, !1), sO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), lO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M18 12H6"></svg>', !1, !0, !1), dO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 12h-15"></svg>', !1, !0, !1), uO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"></svg>', !1, !0, !1), cO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z"></svg>', !1, !0, !1), hO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z"></svg>', !1, !0, !1), fO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"></svg>', !1, !0, !1), pO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42"></svg>', !1, !0, !1), mO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"></svg>', !1, !0, !1), gO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13"></svg>', !1, !0, !1), vO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 9v6m-4.5 0V9M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), yO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 5.25v13.5m-7.5-13.5v13.5"></svg>', !1, !0, !1), bO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"></svg>', !1, !0, !1), $O = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"></svg>', !1, !0, !1), wO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0l6-6m-3 18c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"></svg>', !1, !0, !1), xO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 3.75v4.5m0-4.5h-4.5m4.5 0l-6 6m3 12c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"></svg>', !1, !0, !1), kO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 3.75L18 6m0 0l2.25 2.25M18 6l2.25-2.25M18 6l-2.25 2.25m1.5 13.5c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"></svg>', !1, !0, !1), _O = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"></svg>', !1, !0, !1), CO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), a7 = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), SO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"></svg>', !1, !0, !1), EO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 7.5V18M15 7.5V18M3 16.811V8.69c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 010 1.954l-7.108 4.061A1.125 1.125 0 013 16.811z"></svg>', !1, !0, !1), TO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"></svg>', !1, !0, !1), AO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), OO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6v12m6-6H6"></svg>', !1, !0, !1), IO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 4.5v15m7.5-7.5h-15"></svg>', !1, !0, !1), PO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.636 5.636a9 9 0 1012.728 0M12 3v9"></svg>', !1, !0, !1), DO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6"></svg>', !1, !0, !1), MO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605"></svg>', !1, !0, !1), NO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z"></svg>', !1, !0, !1), LO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 01-.657.643 48.39 48.39 0 01-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 01-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 00-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 01-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 00.657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 01-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 005.427-.63 48.05 48.05 0 00.582-4.717.532.532 0 00-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 00.658-.663 48.422 48.422 0 00-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 01-.61-.58v0z"></svg>', !1, !0, !1), FO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z"></svg>', !1, !0, !1), RO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z"></svg>', !1, !0, !1), zO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"></svg>', !1, !0, !1), jO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z"></svg>', !1, !0, !1), VO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 7.5l16.5-4.125M12 6.75c-2.708 0-5.363.224-7.948.655C2.999 7.58 2.25 8.507 2.25 9.574v9.176A2.25 2.25 0 004.5 21h15a2.25 2.25 0 002.25-2.25V9.574c0-1.067-.75-1.994-1.802-2.169A48.329 48.329 0 0012 6.75zm-1.683 6.443l-.005.005-.006-.005.006-.005.005.005zm-.005 2.127l-.005-.006.005-.005.005.005-.005.005zm-2.116-.006l-.005.006-.006-.006.005-.005.006.005zm-.005-2.116l-.006-.005.006-.005.005.005-.005.005zM9.255 10.5v.008h-.008V10.5h.008zm3.249 1.88l-.007.004-.003-.007.006-.003.004.006zm-1.38 5.126l-.003-.006.006-.004.004.007-.006.003zm.007-6.501l-.003.006-.007-.003.004-.007.006.004zm1.37 5.129l-.007-.004.004-.006.006.003-.004.007zm.504-1.877h-.008v-.007h.008v.007zM9.255 18v.008h-.008V18h.008zm-3.246-1.87l-.007.004L6 16.127l.006-.003.004.006zm1.366-5.119l-.004-.006.006-.004.004.007-.006.003zM7.38 17.5l-.003.006-.007-.003.004-.007.006.004zm-1.376-5.116L6 12.38l.003-.007.007.004-.004.007zm-.5 1.873h-.008v-.007h.008v.007zM17.25 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zm0 4.5a.75.75 0 110-1.5.75.75 0 010 1.5z"></svg>', !1, !0, !1), UO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 14.25l6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185zM9.75 9h.008v.008H9.75V9zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm4.125 4.5h.008v.008h-.008V13.5zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), qO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 9.75h4.875a2.625 2.625 0 010 5.25H12M8.25 9.75L10.5 7.5M8.25 9.75L10.5 12m9-7.243V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185z"></svg>', !1, !0, !1), BO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z"></svg>', !1, !0, !1), HO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122"></svg>', !1, !0, !1), WO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></svg>', !1, !0, !1), QO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 19.5v-.75a7.5 7.5 0 00-7.5-7.5H4.5m0-6.75h.75c7.87 0 14.25 6.38 14.25 14.25v.75M6 18.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"></svg>', !1, !0, !1), GO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0012 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 01-2.031.352 5.988 5.988 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 01-2.031.352 5.989 5.989 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971z"></svg>', !1, !0, !1), YO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.848 8.25l1.536.887M7.848 8.25a3 3 0 11-5.196-3 3 3 0 015.196 3zm1.536.887a2.165 2.165 0 011.083 1.839c.005.351.054.695.14 1.024M9.384 9.137l2.077 1.199M7.848 15.75l1.536-.887m-1.536.887a3 3 0 11-5.196 3 3 3 0 015.196-3zm1.536-.887a2.165 2.165 0 001.083-1.838c.005-.352.054-.695.14-1.025m-1.223 2.863l2.077-1.199m0-3.328a4.323 4.323 0 012.068-1.379l5.325-1.628a4.5 4.5 0 012.48-.044l.803.215-7.794 4.5m-2.882-1.664A4.331 4.331 0 0010.607 12m3.736 0l7.794 4.5-.802.215a4.5 4.5 0 01-2.48-.043l-5.326-1.629a4.324 4.324 0 01-2.068-1.379M14.343 12l-2.882 1.664"></svg>', !1, !0, !1), KO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), ZO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 17.25v-.228a4.5 4.5 0 00-.12-1.03l-2.268-9.64a3.375 3.375 0 00-3.285-2.602H7.923a3.375 3.375 0 00-3.285 2.602l-2.268 9.64a4.5 4.5 0 00-.12 1.03v.228m19.5 0a3 3 0 01-3 3H5.25a3 3 0 01-3-3m19.5 0a3 3 0 00-3-3H5.25a3 3 0 00-3 3m16.5 0h.008v.008h-.008v-.008zm-3 0h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), XO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"></svg>', !1, !0, !1), JO = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"></svg>', !1, !0, !1), eI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v3.75m0-10.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.249-8.25-3.286zm0 13.036h.008v.008H12v-.008z"></svg>', !1, !0, !1), tI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), rI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"></svg>', !1, !0, !1), nI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 3l8.735 8.735m0 0a.374.374 0 11.53.53m-.53-.53l.53.53m0 0L21 21M14.652 9.348a3.75 3.75 0 010 5.304m2.121-7.425a6.75 6.75 0 010 9.546m2.121-11.667c3.808 3.807 3.808 9.98 0 13.788m-9.546-4.242a3.733 3.733 0 01-1.06-2.122m-1.061 4.243a6.75 6.75 0 01-1.625-6.929m-.496 9.05c-3.068-3.067-3.664-7.67-1.79-11.334M12 12h.008v.008H12V12z"></svg>', !1, !0, !1), iI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.348 14.651a3.75 3.75 0 010-5.303m5.304 0a3.75 3.75 0 010 5.303m-7.425 2.122a6.75 6.75 0 010-9.546m9.546 0a6.75 6.75 0 010 9.546M5.106 18.894c-3.808-3.808-3.808-9.98 0-13.789m13.788 0c3.808 3.808 3.808 9.981 0 13.79M12 12h.008v.007H12V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), aI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"></svg>', !1, !0, !1), oI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z"></svg>', !1, !0, !1), sI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.25 9.75L19.5 12m0 0l2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6l4.72-4.72a.75.75 0 011.28.531V19.94a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.506-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.395C2.806 8.757 3.63 8.25 4.51 8.25H6.75z"></svg>', !1, !0, !1), lI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 8.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v8.25A2.25 2.25 0 006 16.5h2.25m8.25-8.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-7.5A2.25 2.25 0 018.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 00-2.25 2.25v6"></svg>', !1, !0, !1), dI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0l4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0l-5.571 3-5.571-3"></svg>', !1, !0, !1), uI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"></svg>', !1, !0, !1), cI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v2.25A2.25 2.25 0 006 10.5zm0 9.75h2.25A2.25 2.25 0 0010.5 18v-2.25a2.25 2.25 0 00-2.25-2.25H6a2.25 2.25 0 00-2.25 2.25V18A2.25 2.25 0 006 20.25zm9.75-9.75H18a2.25 2.25 0 002.25-2.25V6A2.25 2.25 0 0018 3.75h-2.25A2.25 2.25 0 0013.5 6v2.25a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), hI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"></svg>', !1, !0, !1), fI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9.563C9 9.252 9.252 9 9.563 9h4.874c.311 0 .563.252.563.563v4.874c0 .311-.252.563-.563.563H9.564A.562.562 0 019 14.437V9.564z"></svg>', !1, !0, !1), pI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 7.5A2.25 2.25 0 017.5 5.25h9a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25v-9z"></svg>', !1, !0, !1), mI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"></svg>', !1, !0, !1), gI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.098 19.902a3.75 3.75 0 005.304 0l6.401-6.402M6.75 21A3.75 3.75 0 013 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 003.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008z"></svg>', !1, !0, !1), vI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0112 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"></svg>', !1, !0, !1), yI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z"></svg>', !1, !0, !1), bI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 6h.008v.008H6V6z"></svg>', !1, !0, !1), $I = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"></svg>', !1, !0, !1), wI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"></svg>', !1, !0, !1), xI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0"></svg>', !1, !0, !1), kI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"></svg>', !1, !0, !1), _I = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), CI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), SI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"></svg>', !1, !0, !1), EI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M22 10.5h-6m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"></svg>', !1, !0, !1), TI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"></svg>', !1, !0, !1), AI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"></svg>', !1, !0, !1), OI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"></svg>', !1, !0, !1), II = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.745 3A23.933 23.933 0 003 12c0 3.183.62 6.22 1.745 9M19.5 3c.967 2.78 1.5 5.817 1.5 9s-.533 6.22-1.5 9M8.25 8.885l1.444-.89a.75.75 0 011.105.402l2.402 7.206a.75.75 0 001.104.401l1.445-.889m-8.25.75l.213.09a1.687 1.687 0 002.062-.617l4.45-6.676a1.688 1.688 0 012.062-.618l.213.09"></svg>', !1, !0, !1), PI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 00-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409"></svg>', !1, !0, !1), DI = /* @__PURE__ */ x('<svg><path stroke-linecap=round d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), MI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), NI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 3.75H6A2.25 2.25 0 003.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0120.25 6v1.5m0 9V18A2.25 2.25 0 0118 20.25h-1.5m-9 0H6A2.25 2.25 0 013.75 18v-1.5M15 12a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), LI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3"></svg>', !1, !0, !1), FI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 011.06 0z"></svg>', !1, !0, !1), RI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V8.25m-18 0V6a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6zM7.5 6h.008v.008H7.5V6zm2.25 0h.008v.008H9.75V6z"></svg>', !1, !0, !1), zI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), jI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 6.75a4.5 4.5 0 01-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 11-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 016.336-4.486l-3.276 3.276a3.004 3.004 0 002.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852z"></svg>', !1, !0, !1), VI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.867 19.125h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), UI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), qI = /* @__PURE__ */ x('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 18L18 6M6 6l12 12"></svg>', !1, !0, !1);
const BI = {
  path: () => mS(),
  outline: !0,
  mini: !1
}, HI = {
  path: () => gS(),
  outline: !0,
  mini: !1
}, WI = {
  path: () => vS(),
  outline: !0,
  mini: !1
}, QI = {
  path: () => yS(),
  outline: !0,
  mini: !1
}, GI = {
  path: () => bS(),
  outline: !0,
  mini: !1
}, YI = {
  path: () => $S(),
  outline: !0,
  mini: !1
}, KI = {
  path: () => wS(),
  outline: !0,
  mini: !1
}, ZI = {
  path: () => xS(),
  outline: !0,
  mini: !1
}, XI = {
  path: () => kS(),
  outline: !0,
  mini: !1
}, JI = {
  path: () => _S(),
  outline: !0,
  mini: !1
}, eP = {
  path: () => CS(),
  outline: !0,
  mini: !1
}, tP = {
  path: () => SS(),
  outline: !0,
  mini: !1
}, rP = {
  path: () => ES(),
  outline: !0,
  mini: !1
}, nP = {
  path: () => TS(),
  outline: !0,
  mini: !1
}, iP = {
  path: () => AS(),
  outline: !0,
  mini: !1
}, aP = {
  path: () => OS(),
  outline: !0,
  mini: !1
}, oP = {
  path: () => IS(),
  outline: !0,
  mini: !1
}, sP = {
  path: () => PS(),
  outline: !0,
  mini: !1
}, lP = {
  path: () => DS(),
  outline: !0,
  mini: !1
}, dP = {
  path: () => MS(),
  outline: !0,
  mini: !1
}, uP = {
  path: () => NS(),
  outline: !0,
  mini: !1
}, cP = {
  path: () => LS(),
  outline: !0,
  mini: !1
}, hP = {
  path: () => FS(),
  outline: !0,
  mini: !1
}, fP = {
  path: () => RS(),
  outline: !0,
  mini: !1
}, pP = {
  path: () => zS(),
  outline: !0,
  mini: !1
}, mP = {
  path: () => jS(),
  outline: !0,
  mini: !1
}, gP = {
  path: () => VS(),
  outline: !0,
  mini: !1
}, vP = {
  path: () => US(),
  outline: !0,
  mini: !1
}, yP = {
  path: () => qS(),
  outline: !0,
  mini: !1
}, bP = {
  path: () => BS(),
  outline: !0,
  mini: !1
}, $P = {
  path: () => HS(),
  outline: !0,
  mini: !1
}, wP = {
  path: () => WS(),
  outline: !0,
  mini: !1
}, xP = {
  path: () => QS(),
  outline: !0,
  mini: !1
}, kP = {
  path: () => GS(),
  outline: !0,
  mini: !1
}, _P = {
  path: () => YS(),
  outline: !0,
  mini: !1
}, CP = {
  path: () => KS(),
  outline: !0,
  mini: !1
}, SP = {
  path: () => ZS(),
  outline: !0,
  mini: !1
}, EP = {
  path: () => XS(),
  outline: !0,
  mini: !1
}, TP = {
  path: () => JS(),
  outline: !0,
  mini: !1
}, AP = {
  path: () => eE(),
  outline: !0,
  mini: !1
}, OP = {
  path: () => tE(),
  outline: !0,
  mini: !1
}, IP = {
  path: () => rE(),
  outline: !0,
  mini: !1
}, PP = {
  path: () => nE(),
  outline: !0,
  mini: !1
}, DP = {
  path: () => iE(),
  outline: !0,
  mini: !1
}, MP = {
  path: () => aE(),
  outline: !0,
  mini: !1
}, NP = {
  path: () => oE(),
  outline: !0,
  mini: !1
}, LP = {
  path: () => sE(),
  outline: !0,
  mini: !1
}, FP = {
  path: () => lE(),
  outline: !0,
  mini: !1
}, RP = {
  path: () => dE(),
  outline: !0,
  mini: !1
}, zP = {
  path: () => uE(),
  outline: !0,
  mini: !1
}, jP = {
  path: () => cE(),
  outline: !0,
  mini: !1
}, VP = {
  path: () => hE(),
  outline: !0,
  mini: !1
}, UP = {
  path: () => fE(),
  outline: !0,
  mini: !1
}, qP = {
  path: () => pE(),
  outline: !0,
  mini: !1
}, BP = {
  path: () => mE(),
  outline: !0,
  mini: !1
}, HP = {
  path: () => gE(),
  outline: !0,
  mini: !1
}, WP = {
  path: () => vE(),
  outline: !0,
  mini: !1
}, QP = {
  path: () => yE(),
  outline: !0,
  mini: !1
}, GP = {
  path: () => bE(),
  outline: !0,
  mini: !1
}, YP = {
  path: () => $E(),
  outline: !0,
  mini: !1
}, KP = {
  path: () => wE(),
  outline: !0,
  mini: !1
}, ZP = {
  path: () => xE(),
  outline: !0,
  mini: !1
}, XP = {
  path: () => kE(),
  outline: !0,
  mini: !1
}, JP = {
  path: () => _E(),
  outline: !0,
  mini: !1
}, eD = {
  path: () => CE(),
  outline: !0,
  mini: !1
}, tD = {
  path: () => SE(),
  outline: !0,
  mini: !1
}, rD = {
  path: () => EE(),
  outline: !0,
  mini: !1
}, nD = {
  path: () => TE(),
  outline: !0,
  mini: !1
}, iD = {
  path: () => AE(),
  outline: !0,
  mini: !1
}, aD = {
  path: () => OE(),
  outline: !0,
  mini: !1
}, oD = {
  path: () => IE(),
  outline: !0,
  mini: !1
}, sD = {
  path: () => PE(),
  outline: !0,
  mini: !1
}, lD = {
  path: () => DE(),
  outline: !0,
  mini: !1
}, dD = {
  path: () => ME(),
  outline: !0,
  mini: !1
}, uD = {
  path: () => NE(),
  outline: !0,
  mini: !1
}, cD = {
  path: () => LE(),
  outline: !0,
  mini: !1
}, hD = {
  path: () => FE(),
  outline: !0,
  mini: !1
}, fD = {
  path: () => RE(),
  outline: !0,
  mini: !1
}, pD = {
  path: () => zE(),
  outline: !0,
  mini: !1
}, mD = {
  path: () => jE(),
  outline: !0,
  mini: !1
}, gD = {
  path: () => VE(),
  outline: !0,
  mini: !1
}, vD = {
  path: () => UE(),
  outline: !0,
  mini: !1
}, yD = {
  path: () => qE(),
  outline: !0,
  mini: !1
}, bD = {
  path: () => [BE(), HE()],
  outline: !0,
  mini: !1
}, $D = {
  path: () => WE(),
  outline: !0,
  mini: !1
}, wD = {
  path: () => QE(),
  outline: !0,
  mini: !1
}, xD = {
  path: () => [GE(), YE()],
  outline: !0,
  mini: !1
}, kD = {
  path: () => KE(),
  outline: !0,
  mini: !1
}, _D = {
  path: () => ZE(),
  outline: !0,
  mini: !1
}, CD = {
  path: () => XE(),
  outline: !0,
  mini: !1
}, SD = {
  path: () => JE(),
  outline: !0,
  mini: !1
}, ED = {
  path: () => eT(),
  outline: !0,
  mini: !1
}, TD = {
  path: () => tT(),
  outline: !0,
  mini: !1
}, AD = {
  path: () => rT(),
  outline: !0,
  mini: !1
}, OD = {
  path: () => nT(),
  outline: !0,
  mini: !1
}, ID = {
  path: () => iT(),
  outline: !0,
  mini: !1
}, PD = {
  path: () => aT(),
  outline: !0,
  mini: !1
}, DD = {
  path: () => oT(),
  outline: !0,
  mini: !1
}, MD = {
  path: () => sT(),
  outline: !0,
  mini: !1
}, ND = {
  path: () => lT(),
  outline: !0,
  mini: !1
}, LD = {
  path: () => dT(),
  outline: !0,
  mini: !1
}, FD = {
  path: () => uT(),
  outline: !0,
  mini: !1
}, RD = {
  path: () => cT(),
  outline: !0,
  mini: !1
}, zD = {
  path: () => hT(),
  outline: !0,
  mini: !1
}, jD = {
  path: () => fT(),
  outline: !0,
  mini: !1
}, VD = {
  path: () => pT(),
  outline: !0,
  mini: !1
}, UD = {
  path: () => mT(),
  outline: !0,
  mini: !1
}, qD = {
  path: () => gT(),
  outline: !0,
  mini: !1
}, BD = {
  path: () => vT(),
  outline: !0,
  mini: !1
}, HD = {
  path: () => yT(),
  outline: !0,
  mini: !1
}, WD = {
  path: () => bT(),
  outline: !0,
  mini: !1
}, QD = {
  path: () => $T(),
  outline: !0,
  mini: !1
}, GD = {
  path: () => wT(),
  outline: !0,
  mini: !1
}, YD = {
  path: () => xT(),
  outline: !0,
  mini: !1
}, KD = {
  path: () => kT(),
  outline: !0,
  mini: !1
}, ZD = {
  path: () => _T(),
  outline: !0,
  mini: !1
}, XD = {
  path: () => CT(),
  outline: !0,
  mini: !1
}, JD = {
  path: () => [ST(), kf()],
  outline: !0,
  mini: !1
}, eM = {
  path: () => [ET(), kf()],
  outline: !0,
  mini: !1
}, tM = {
  path: () => TT(),
  outline: !0,
  mini: !1
}, rM = {
  path: () => AT(),
  outline: !0,
  mini: !1
}, nM = {
  path: () => OT(),
  outline: !0,
  mini: !1
}, iM = {
  path: () => IT(),
  outline: !0,
  mini: !1
}, aM = {
  path: () => PT(),
  outline: !0,
  mini: !1
}, oM = {
  path: () => DT(),
  outline: !0,
  mini: !1
}, sM = {
  path: () => MT(),
  outline: !0,
  mini: !1
}, lM = {
  path: () => NT(),
  outline: !0,
  mini: !1
}, dM = {
  path: () => LT(),
  outline: !0,
  mini: !1
}, uM = {
  path: () => FT(),
  outline: !0,
  mini: !1
}, cM = {
  path: () => RT(),
  outline: !0,
  mini: !1
}, hM = {
  path: () => zT(),
  outline: !0,
  mini: !1
}, fM = {
  path: () => jT(),
  outline: !0,
  mini: !1
}, pM = {
  path: () => VT(),
  outline: !0,
  mini: !1
}, mM = {
  path: () => UT(),
  outline: !0,
  mini: !1
}, gM = {
  path: () => qT(),
  outline: !0,
  mini: !1
}, vM = {
  path: () => BT(),
  outline: !0,
  mini: !1
}, yM = {
  path: () => HT(),
  outline: !0,
  mini: !1
}, bM = {
  path: () => WT(),
  outline: !0,
  mini: !1
}, $M = {
  path: () => QT(),
  outline: !0,
  mini: !1
}, wM = {
  path: () => GT(),
  outline: !0,
  mini: !1
}, xM = {
  path: () => YT(),
  outline: !0,
  mini: !1
}, kM = {
  path: () => KT(),
  outline: !0,
  mini: !1
}, _M = {
  path: () => ZT(),
  outline: !0,
  mini: !1
}, CM = {
  path: () => XT(),
  outline: !0,
  mini: !1
}, SM = {
  path: () => JT(),
  outline: !0,
  mini: !1
}, EM = {
  path: () => eA(),
  outline: !0,
  mini: !1
}, TM = {
  path: () => tA(),
  outline: !0,
  mini: !1
}, AM = {
  path: () => rA(),
  outline: !0,
  mini: !1
}, OM = {
  path: () => nA(),
  outline: !0,
  mini: !1
}, IM = {
  path: () => iA(),
  outline: !0,
  mini: !1
}, PM = {
  path: () => aA(),
  outline: !0,
  mini: !1
}, DM = {
  path: () => oA(),
  outline: !0,
  mini: !1
}, MM = {
  path: () => sA(),
  outline: !0,
  mini: !1
}, NM = {
  path: () => lA(),
  outline: !0,
  mini: !1
}, LM = {
  path: () => dA(),
  outline: !0,
  mini: !1
}, FM = {
  path: () => [uA(), kf()],
  outline: !0,
  mini: !1
}, RM = {
  path: () => cA(),
  outline: !0,
  mini: !1
}, zM = {
  path: () => hA(),
  outline: !0,
  mini: !1
}, jM = {
  path: () => fA(),
  outline: !0,
  mini: !1
}, VM = {
  path: () => pA(),
  outline: !0,
  mini: !1
}, UM = {
  path: () => [mA(), gA()],
  outline: !0,
  mini: !1
}, qM = {
  path: () => vA(),
  outline: !0,
  mini: !1
}, BM = {
  path: () => yA(),
  outline: !0,
  mini: !1
}, HM = {
  path: () => bA(),
  outline: !0,
  mini: !1
}, WM = {
  path: () => $A(),
  outline: !0,
  mini: !1
}, QM = {
  path: () => wA(),
  outline: !0,
  mini: !1
}, GM = {
  path: () => xA(),
  outline: !0,
  mini: !1
}, YM = {
  path: () => kA(),
  outline: !0,
  mini: !1
}, KM = {
  path: () => _A(),
  outline: !0,
  mini: !1
}, ZM = {
  path: () => CA(),
  outline: !0,
  mini: !1
}, XM = {
  path: () => SA(),
  outline: !0,
  mini: !1
}, JM = {
  path: () => EA(),
  outline: !0,
  mini: !1
}, eN = {
  path: () => TA(),
  outline: !0,
  mini: !1
}, tN = {
  path: () => AA(),
  outline: !0,
  mini: !1
}, rN = {
  path: () => OA(),
  outline: !0,
  mini: !1
}, nN = {
  path: () => IA(),
  outline: !0,
  mini: !1
}, iN = {
  path: () => PA(),
  outline: !0,
  mini: !1
}, aN = {
  path: () => DA(),
  outline: !0,
  mini: !1
}, oN = {
  path: () => MA(),
  outline: !0,
  mini: !1
}, sN = {
  path: () => NA(),
  outline: !0,
  mini: !1
}, lN = {
  path: () => LA(),
  outline: !0,
  mini: !1
}, dN = {
  path: () => FA(),
  outline: !0,
  mini: !1
}, uN = {
  path: () => RA(),
  outline: !0,
  mini: !1
}, cN = {
  path: () => zA(),
  outline: !0,
  mini: !1
}, hN = {
  path: () => jA(),
  outline: !0,
  mini: !1
}, fN = {
  path: () => VA(),
  outline: !0,
  mini: !1
}, pN = {
  path: () => UA(),
  outline: !0,
  mini: !1
}, mN = {
  path: () => qA(),
  outline: !0,
  mini: !1
}, gN = {
  path: () => BA(),
  outline: !0,
  mini: !1
}, vN = {
  path: () => HA(),
  outline: !0,
  mini: !1
}, yN = {
  path: () => WA(),
  outline: !0,
  mini: !1
}, bN = {
  path: () => QA(),
  outline: !0,
  mini: !1
}, $N = {
  path: () => GA(),
  outline: !0,
  mini: !1
}, wN = {
  path: () => YA(),
  outline: !0,
  mini: !1
}, xN = {
  path: () => KA(),
  outline: !0,
  mini: !1
}, kN = {
  path: () => ZA(),
  outline: !0,
  mini: !1
}, _N = {
  path: () => XA(),
  outline: !0,
  mini: !1
}, CN = {
  path: () => JA(),
  outline: !0,
  mini: !1
}, SN = {
  path: () => eO(),
  outline: !0,
  mini: !1
}, EN = {
  path: () => tO(),
  outline: !0,
  mini: !1
}, TN = {
  path: () => [rO(), nO()],
  outline: !0,
  mini: !1
}, AN = {
  path: () => iO(),
  outline: !0,
  mini: !1
}, ON = {
  path: () => aO(),
  outline: !0,
  mini: !1
}, IN = {
  path: () => oO(),
  outline: !0,
  mini: !1
}, PN = {
  path: () => sO(),
  outline: !0,
  mini: !1
}, DN = {
  path: () => lO(),
  outline: !0,
  mini: !1
}, MN = {
  path: () => dO(),
  outline: !0,
  mini: !1
}, NN = {
  path: () => uO(),
  outline: !0,
  mini: !1
}, LN = {
  path: () => cO(),
  outline: !0,
  mini: !1
}, FN = {
  path: () => hO(),
  outline: !0,
  mini: !1
}, RN = {
  path: () => fO(),
  outline: !0,
  mini: !1
}, zN = {
  path: () => pO(),
  outline: !0,
  mini: !1
}, jN = {
  path: () => mO(),
  outline: !0,
  mini: !1
}, VN = {
  path: () => gO(),
  outline: !0,
  mini: !1
}, UN = {
  path: () => vO(),
  outline: !0,
  mini: !1
}, qN = {
  path: () => yO(),
  outline: !0,
  mini: !1
}, BN = {
  path: () => bO(),
  outline: !0,
  mini: !1
}, HN = {
  path: () => $O(),
  outline: !0,
  mini: !1
}, WN = {
  path: () => wO(),
  outline: !0,
  mini: !1
}, QN = {
  path: () => xO(),
  outline: !0,
  mini: !1
}, GN = {
  path: () => kO(),
  outline: !0,
  mini: !1
}, YN = {
  path: () => _O(),
  outline: !0,
  mini: !1
}, KN = {
  path: () => CO(),
  outline: !0,
  mini: !1
}, ZN = {
  path: () => [a7(), SO()],
  outline: !0,
  mini: !1
}, XN = {
  path: () => EO(),
  outline: !0,
  mini: !1
}, JN = {
  path: () => TO(),
  outline: !0,
  mini: !1
}, eL = {
  path: () => AO(),
  outline: !0,
  mini: !1
}, tL = {
  path: () => OO(),
  outline: !0,
  mini: !1
}, rL = {
  path: () => IO(),
  outline: !0,
  mini: !1
}, nL = {
  path: () => PO(),
  outline: !0,
  mini: !1
}, iL = {
  path: () => DO(),
  outline: !0,
  mini: !1
}, aL = {
  path: () => MO(),
  outline: !0,
  mini: !1
}, oL = {
  path: () => NO(),
  outline: !0,
  mini: !1
}, sL = {
  path: () => LO(),
  outline: !0,
  mini: !1
}, lL = {
  path: () => [FO(), RO()],
  outline: !0,
  mini: !1
}, dL = {
  path: () => zO(),
  outline: !0,
  mini: !1
}, uL = {
  path: () => jO(),
  outline: !0,
  mini: !1
}, cL = {
  path: () => VO(),
  outline: !0,
  mini: !1
}, hL = {
  path: () => UO(),
  outline: !0,
  mini: !1
}, fL = {
  path: () => qO(),
  outline: !0,
  mini: !1
}, pL = {
  path: () => BO(),
  outline: !0,
  mini: !1
}, mL = {
  path: () => HO(),
  outline: !0,
  mini: !1
}, gL = {
  path: () => WO(),
  outline: !0,
  mini: !1
}, vL = {
  path: () => QO(),
  outline: !0,
  mini: !1
}, yL = {
  path: () => GO(),
  outline: !0,
  mini: !1
}, bL = {
  path: () => YO(),
  outline: !0,
  mini: !1
}, $L = {
  path: () => KO(),
  outline: !0,
  mini: !1
}, wL = {
  path: () => ZO(),
  outline: !0,
  mini: !1
}, xL = {
  path: () => XO(),
  outline: !0,
  mini: !1
}, kL = {
  path: () => JO(),
  outline: !0,
  mini: !1
}, _L = {
  path: () => eI(),
  outline: !0,
  mini: !1
}, CL = {
  path: () => tI(),
  outline: !0,
  mini: !1
}, SL = {
  path: () => rI(),
  outline: !0,
  mini: !1
}, EL = {
  path: () => nI(),
  outline: !0,
  mini: !1
}, TL = {
  path: () => iI(),
  outline: !0,
  mini: !1
}, AL = {
  path: () => aI(),
  outline: !0,
  mini: !1
}, OL = {
  path: () => oI(),
  outline: !0,
  mini: !1
}, IL = {
  path: () => sI(),
  outline: !0,
  mini: !1
}, PL = {
  path: () => lI(),
  outline: !0,
  mini: !1
}, DL = {
  path: () => dI(),
  outline: !0,
  mini: !1
}, ML = {
  path: () => uI(),
  outline: !0,
  mini: !1
}, NL = {
  path: () => cI(),
  outline: !0,
  mini: !1
}, LL = {
  path: () => hI(),
  outline: !0,
  mini: !1
}, FL = {
  path: () => [a7(), fI()],
  outline: !0,
  mini: !1
}, RL = {
  path: () => pI(),
  outline: !0,
  mini: !1
}, zL = {
  path: () => mI(),
  outline: !0,
  mini: !1
}, jL = {
  path: () => gI(),
  outline: !0,
  mini: !1
}, VL = {
  path: () => vI(),
  outline: !0,
  mini: !1
}, UL = {
  path: () => [yI(), bI()],
  outline: !0,
  mini: !1
}, qL = {
  path: () => $I(),
  outline: !0,
  mini: !1
}, BL = {
  path: () => wI(),
  outline: !0,
  mini: !1
}, HL = {
  path: () => xI(),
  outline: !0,
  mini: !1
}, WL = {
  path: () => kI(),
  outline: !0,
  mini: !1
}, QL = {
  path: () => _I(),
  outline: !0,
  mini: !1
}, GL = {
  path: () => CI(),
  outline: !0,
  mini: !1
}, YL = {
  path: () => SI(),
  outline: !0,
  mini: !1
}, KL = {
  path: () => EI(),
  outline: !0,
  mini: !1
}, ZL = {
  path: () => TI(),
  outline: !0,
  mini: !1
}, XL = {
  path: () => AI(),
  outline: !0,
  mini: !1
}, JL = {
  path: () => OI(),
  outline: !0,
  mini: !1
}, eF = {
  path: () => II(),
  outline: !0,
  mini: !1
}, tF = {
  path: () => PI(),
  outline: !0,
  mini: !1
}, rF = {
  path: () => DI(),
  outline: !0,
  mini: !1
}, nF = {
  path: () => MI(),
  outline: !0,
  mini: !1
}, iF = {
  path: () => NI(),
  outline: !0,
  mini: !1
}, aF = {
  path: () => LI(),
  outline: !0,
  mini: !1
}, oF = {
  path: () => FI(),
  outline: !0,
  mini: !1
}, sF = {
  path: () => RI(),
  outline: !0,
  mini: !1
}, lF = {
  path: () => zI(),
  outline: !0,
  mini: !1
}, dF = {
  path: () => [jI(), VI()],
  outline: !0,
  mini: !1
}, uF = {
  path: () => UI(),
  outline: !0,
  mini: !1
}, cF = {
  path: () => qI(),
  outline: !0,
  mini: !1
}, hF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  academicCap: BI,
  adjustmentsHorizontal: HI,
  adjustmentsVertical: WI,
  archiveBox: YI,
  archiveBoxArrowDown: QI,
  archiveBoxXMark: GI,
  arrowDown: rP,
  arrowDownCircle: KI,
  arrowDownLeft: ZI,
  arrowDownOnSquare: JI,
  arrowDownOnSquareStack: XI,
  arrowDownRight: eP,
  arrowDownTray: tP,
  arrowLeft: aP,
  arrowLeftCircle: nP,
  arrowLeftOnRectangle: iP,
  arrowLongDown: oP,
  arrowLongLeft: sP,
  arrowLongRight: lP,
  arrowLongUp: dP,
  arrowPath: cP,
  arrowPathRoundedSquare: uP,
  arrowRight: pP,
  arrowRightCircle: hP,
  arrowRightOnRectangle: fP,
  arrowSmallDown: mP,
  arrowSmallLeft: gP,
  arrowSmallRight: vP,
  arrowSmallUp: yP,
  arrowTopRightOnSquare: bP,
  arrowTrendingDown: $P,
  arrowTrendingUp: wP,
  arrowUp: TP,
  arrowUpCircle: xP,
  arrowUpLeft: kP,
  arrowUpOnSquare: CP,
  arrowUpOnSquareStack: _P,
  arrowUpRight: SP,
  arrowUpTray: EP,
  arrowUturnDown: AP,
  arrowUturnLeft: OP,
  arrowUturnRight: IP,
  arrowUturnUp: PP,
  arrowsPointingIn: DP,
  arrowsPointingOut: MP,
  arrowsRightLeft: NP,
  arrowsUpDown: LP,
  atSymbol: FP,
  backspace: RP,
  backward: zP,
  banknotes: jP,
  barsArrowDown: QP,
  barsArrowUp: GP,
  bars_2: VP,
  bars_3: HP,
  bars_3BottomLeft: UP,
  bars_3BottomRight: qP,
  bars_3CenterLeft: BP,
  bars_4: WP,
  battery_0: YP,
  battery_100: KP,
  battery_50: ZP,
  beaker: XP,
  bell: rD,
  bellAlert: JP,
  bellSlash: eD,
  bellSnooze: tD,
  bolt: iD,
  boltSlash: nD,
  bookOpen: aD,
  bookmark: lD,
  bookmarkSlash: oD,
  bookmarkSquare: sD,
  briefcase: dD,
  bugAnt: uD,
  buildingLibrary: cD,
  buildingOffice: fD,
  buildingOffice_2: hD,
  buildingStorefront: pD,
  cake: mD,
  calculator: gD,
  calendar: yD,
  calendarDays: vD,
  camera: bD,
  chartBar: wD,
  chartBarSquare: $D,
  chartPie: xD,
  chatBubbleBottomCenter: _D,
  chatBubbleBottomCenterText: kD,
  chatBubbleLeft: ED,
  chatBubbleLeftEllipsis: CD,
  chatBubbleLeftRight: SD,
  chatBubbleOvalLeft: AD,
  chatBubbleOvalLeftEllipsis: TD,
  check: PD,
  checkBadge: OD,
  checkCircle: ID,
  chevronDoubleDown: DD,
  chevronDoubleLeft: MD,
  chevronDoubleRight: ND,
  chevronDoubleUp: LD,
  chevronDown: FD,
  chevronLeft: RD,
  chevronRight: zD,
  chevronUp: VD,
  chevronUpDown: jD,
  circleStack: UD,
  clipboard: WD,
  clipboardDocument: HD,
  clipboardDocumentCheck: qD,
  clipboardDocumentList: BD,
  clock: QD,
  cloud: KD,
  cloudArrowDown: GD,
  cloudArrowUp: YD,
  codeBracket: XD,
  codeBracketSquare: ZD,
  cog: tM,
  cog_6Tooth: JD,
  cog_8Tooth: eM,
  commandLine: rM,
  computerDesktop: nM,
  cpuChip: iM,
  creditCard: aM,
  cube: sM,
  cubeTransparent: oM,
  currencyBangladeshi: lM,
  currencyDollar: dM,
  currencyEuro: uM,
  currencyPound: cM,
  currencyRupee: hM,
  currencyYen: fM,
  cursorArrowRays: pM,
  cursorArrowRipple: mM,
  devicePhoneMobile: gM,
  deviceTablet: vM,
  document: EM,
  documentArrowDown: yM,
  documentArrowUp: bM,
  documentChartBar: $M,
  documentCheck: wM,
  documentDuplicate: xM,
  documentMagnifyingGlass: kM,
  documentMinus: _M,
  documentPlus: CM,
  documentText: SM,
  ellipsisHorizontal: AM,
  ellipsisHorizontalCircle: TM,
  ellipsisVertical: OM,
  envelope: PM,
  envelopeOpen: IM,
  exclamationCircle: DM,
  exclamationTriangle: MM,
  eye: FM,
  eyeDropper: NM,
  eyeSlash: LM,
  faceFrown: RM,
  faceSmile: zM,
  film: jM,
  fingerPrint: VM,
  fire: UM,
  flag: qM,
  folder: GM,
  folderArrowDown: BM,
  folderMinus: HM,
  folderOpen: WM,
  folderPlus: QM,
  forward: YM,
  funnel: KM,
  gif: ZM,
  gift: JM,
  giftTop: XM,
  globeAlt: eN,
  globeAmericas: tN,
  globeAsiaAustralia: rN,
  globeEuropeAfrica: nN,
  handRaised: iN,
  handThumbDown: aN,
  handThumbUp: oN,
  hashtag: sN,
  heart: lN,
  home: uN,
  homeModern: dN,
  identification: cN,
  inbox: pN,
  inboxArrowDown: hN,
  inboxStack: fN,
  informationCircle: mN,
  key: gN,
  language: vN,
  lifebuoy: yN,
  lightBulb: bN,
  link: $N,
  listBullet: wN,
  lockClosed: xN,
  lockOpen: kN,
  magnifyingGlass: EN,
  magnifyingGlassCircle: _N,
  magnifyingGlassMinus: CN,
  magnifyingGlassPlus: SN,
  map: AN,
  mapPin: TN,
  megaphone: ON,
  microphone: IN,
  minus: MN,
  minusCircle: PN,
  minusSmall: DN,
  moon: NN,
  musicalNote: LN,
  newspaper: FN,
  noSymbol: RN,
  paintBrush: zN,
  paperAirplane: jN,
  paperClip: VN,
  pause: qN,
  pauseCircle: UN,
  pencil: HN,
  pencilSquare: BN,
  phone: YN,
  phoneArrowDownLeft: WN,
  phoneArrowUpRight: QN,
  phoneXMark: GN,
  photo: KN,
  play: JN,
  playCircle: ZN,
  playPause: XN,
  plus: rL,
  plusCircle: eL,
  plusSmall: tL,
  power: nL,
  presentationChartBar: iL,
  presentationChartLine: aL,
  printer: oL,
  puzzlePiece: sL,
  qrCode: lL,
  questionMarkCircle: dL,
  queueList: uL,
  radio: cL,
  receiptPercent: hL,
  receiptRefund: fL,
  rectangleGroup: pL,
  rectangleStack: mL,
  rocketLaunch: gL,
  rss: vL,
  scale: yL,
  scissors: bL,
  server: wL,
  serverStack: $L,
  share: xL,
  shieldCheck: kL,
  shieldExclamation: _L,
  shoppingBag: CL,
  shoppingCart: SL,
  signal: TL,
  signalSlash: EL,
  sparkles: AL,
  speakerWave: OL,
  speakerXMark: IL,
  square_2Stack: PL,
  square_3Stack_3d: DL,
  squaresPlus: NL,
  squares_2x2: ML,
  star: LL,
  stop: RL,
  stopCircle: FL,
  sun: zL,
  swatch: jL,
  tableCells: VL,
  tag: UL,
  ticket: qL,
  trash: BL,
  trophy: HL,
  truck: WL,
  tv: QL,
  user: XL,
  userCircle: GL,
  userGroup: YL,
  userMinus: KL,
  userPlus: ZL,
  users: JL,
  variable: eF,
  videoCamera: rF,
  videoCameraSlash: tF,
  viewColumns: nF,
  viewfinderCircle: iF,
  wallet: aF,
  wifi: oF,
  window: sF,
  wrench: dF,
  wrenchScrewdriver: lF,
  xCircle: uF,
  xMark: cF
}, Symbol.toStringTag, { value: "Module" }));
function rt(e) {
  const t = Be({
    size: "md",
    name: "exclamationMark"
  }, e), r = L(() => Zt(e.class, {
    "h-4 w-4": t.size === "sm",
    "h-6 w-6": t.size === "md",
    "h-8 w-8": t.size === "lg",
    "h-10 w-10": t.size === "xl"
  }));
  return b(X, {
    get when() {
      return e.name;
    },
    get children() {
      return b(pS, {
        get path() {
          return hF[t.name];
        },
        get class() {
          return r();
        },
        "aria-hidden": "true"
      });
    }
  });
}
const Ku = Symbol("store-raw"), Yo = Symbol("store-node"), pi = Symbol("store-has"), o7 = Symbol("store-self");
function s7(e) {
  let t = e[mr];
  if (!t && (Object.defineProperty(e, mr, {
    value: t = new Proxy(e, mF)
  }), !Array.isArray(e))) {
    const r = Object.keys(e), n = Object.getOwnPropertyDescriptors(e);
    for (let i = 0, a = r.length; i < a; i++) {
      const o = r[i];
      n[o].get && Object.defineProperty(e, o, {
        enumerable: n[o].enumerable,
        get: n[o].get.bind(t)
      });
    }
  }
  return t;
}
function Jn(e) {
  let t;
  return e != null && typeof e == "object" && (e[mr] || !(t = Object.getPrototypeOf(e)) || t === Object.prototype || Array.isArray(e));
}
function Ga(e, t = /* @__PURE__ */ new Set()) {
  let r, n, i, a;
  if (r = e != null && e[Ku]) return r;
  if (!Jn(e) || t.has(e)) return e;
  if (Array.isArray(e)) {
    Object.isFrozen(e) ? e = e.slice(0) : t.add(e);
    for (let o = 0, s = e.length; o < s; o++)
      i = e[o], (n = Ga(i, t)) !== i && (e[o] = n);
  } else {
    Object.isFrozen(e) ? e = Object.assign({}, e) : t.add(e);
    const o = Object.keys(e), s = Object.getOwnPropertyDescriptors(e);
    for (let l = 0, d = o.length; l < d; l++)
      a = o[l], !s[a].get && (i = e[a], (n = Ga(i, t)) !== i && (e[a] = n));
  }
  return e;
}
function Zu(e, t) {
  let r = e[t];
  return r || Object.defineProperty(e, t, {
    value: r = /* @__PURE__ */ Object.create(null)
  }), r;
}
function Gl(e, t, r) {
  if (e[t]) return e[t];
  const [n, i] = H(r, {
    equals: !1,
    internal: !0
  });
  return n.$ = i, e[t] = n;
}
function fF(e, t) {
  const r = Reflect.getOwnPropertyDescriptor(e, t);
  return !r || r.get || !r.configurable || t === mr || t === Yo || (delete r.value, delete r.writable, r.get = () => e[mr][t]), r;
}
function l7(e) {
  ns() && Gl(Zu(e, Yo), o7)();
}
function pF(e) {
  return l7(e), Reflect.ownKeys(e);
}
const mF = {
  get(e, t, r) {
    if (t === Ku) return e;
    if (t === mr) return r;
    if (t === Ml)
      return l7(e), r;
    const n = Zu(e, Yo), i = n[t];
    let a = i ? i() : e[t];
    if (t === Yo || t === pi || t === "__proto__") return a;
    if (!i) {
      const o = Object.getOwnPropertyDescriptor(e, t);
      ns() && (typeof a != "function" || e.hasOwnProperty(t)) && !(o && o.get) && (a = Gl(n, t, a)());
    }
    return Jn(a) ? s7(a) : a;
  },
  has(e, t) {
    return t === Ku || t === mr || t === Ml || t === Yo || t === pi || t === "__proto__" ? !0 : (ns() && Gl(Zu(e, pi), t)(), t in e);
  },
  set() {
    return !0;
  },
  deleteProperty() {
    return !0;
  },
  ownKeys: pF,
  getOwnPropertyDescriptor: fF
};
function Wr(e, t, r, n = !1) {
  if (!n && e[t] === r) return;
  const i = e[t], a = e.length;
  r === void 0 ? (delete e[t], e[pi] && e[pi][t] && i !== void 0 && e[pi][t].$()) : (e[t] = r, e[pi] && e[pi][t] && i === void 0 && e[pi][t].$());
  let o = Zu(e, Yo), s;
  if ((s = Gl(o, t, i)) && s.$(() => r), Array.isArray(e) && e.length !== a) {
    for (let l = e.length; l < a; l++) (s = o[l]) && s.$();
    (s = Gl(o, "length", a)) && s.$(e.length);
  }
  (s = o[o7]) && s.$();
}
function d7(e, t) {
  const r = Object.keys(t);
  for (let n = 0; n < r.length; n += 1) {
    const i = r[n];
    Wr(e, i, t[i]);
  }
}
function gF(e, t) {
  if (typeof t == "function" && (t = t(e)), t = Ga(t), Array.isArray(t)) {
    if (e === t) return;
    let r = 0, n = t.length;
    for (; r < n; r++) {
      const i = t[r];
      e[r] !== i && Wr(e, r, i);
    }
    Wr(e, "length", n);
  } else d7(e, t);
}
function $l(e, t, r = []) {
  let n, i = e;
  if (t.length > 1) {
    n = t.shift();
    const o = typeof n, s = Array.isArray(e);
    if (Array.isArray(n)) {
      for (let l = 0; l < n.length; l++)
        $l(e, [n[l]].concat(t), r);
      return;
    } else if (s && o === "function") {
      for (let l = 0; l < e.length; l++)
        n(e[l], l) && $l(e, [l].concat(t), r);
      return;
    } else if (s && o === "object") {
      const { from: l = 0, to: d = e.length - 1, by: u = 1 } = n;
      for (let c = l; c <= d; c += u)
        $l(e, [c].concat(t), r);
      return;
    } else if (t.length > 1) {
      $l(e[n], t, [n].concat(r));
      return;
    }
    i = e[n], r = [n].concat(r);
  }
  let a = t[0];
  typeof a == "function" && (a = a(i, r), a === i) || n === void 0 && a == null || (a = Ga(a), n === void 0 || Jn(i) && Jn(a) && !Array.isArray(a) ? d7(i, a) : Wr(e, n, a));
}
function ua(...[e, t]) {
  const r = Ga(e || {}), n = Array.isArray(r), i = s7(r);
  function a(...o) {
    Mu(() => {
      n && o.length === 1 ? gF(r, o[0]) : $l(r, o);
    });
  }
  return [i, a];
}
const j2 = Symbol("store-root");
function Co(e, t, r, n, i) {
  const a = t[r];
  if (e === a) return;
  const o = Array.isArray(e);
  if (r !== j2 && (!Jn(e) || !Jn(a) || o !== Array.isArray(a) || i && e[i] !== a[i])) {
    Wr(t, r, e);
    return;
  }
  if (o) {
    if (e.length && a.length && (!n || i && e[0] && e[0][i] != null)) {
      let d, u, c, h, f, p, g, v;
      for (c = 0, h = Math.min(a.length, e.length); c < h && (a[c] === e[c] || i && a[c] && e[c] && a[c][i] === e[c][i]); c++)
        Co(e[c], a, c, n, i);
      const m = new Array(e.length), $ = /* @__PURE__ */ new Map();
      for (h = a.length - 1, f = e.length - 1; h >= c && f >= c && (a[h] === e[f] || i && a[h] && e[f] && a[h][i] === e[f][i]); h--, f--)
        m[f] = a[h];
      if (c > f || c > h) {
        for (u = c; u <= f; u++) Wr(a, u, e[u]);
        for (; u < e.length; u++)
          Wr(a, u, m[u]), Co(e[u], a, u, n, i);
        a.length > e.length && Wr(a, "length", e.length);
        return;
      }
      for (g = new Array(f + 1), u = f; u >= c; u--)
        p = e[u], v = i && p ? p[i] : p, d = $.get(v), g[u] = d === void 0 ? -1 : d, $.set(v, u);
      for (d = c; d <= h; d++)
        p = a[d], v = i && p ? p[i] : p, u = $.get(v), u !== void 0 && u !== -1 && (m[u] = a[d], u = g[u], $.set(v, u));
      for (u = c; u < e.length; u++)
        u in m ? (Wr(a, u, m[u]), Co(e[u], a, u, n, i)) : Wr(a, u, e[u]);
    } else
      for (let d = 0, u = e.length; d < u; d++)
        Co(e[d], a, d, n, i);
    a.length > e.length && Wr(a, "length", e.length);
    return;
  }
  const s = Object.keys(e);
  for (let d = 0, u = s.length; d < u; d++)
    Co(e[s[d]], a, s[d], n, i);
  const l = Object.keys(a);
  for (let d = 0, u = l.length; d < u; d++)
    e[l[d]] === void 0 && Wr(a, l[d], void 0);
}
function vF(e, t = {}) {
  const { merge: r, key: n = "id" } = t, i = Ga(e);
  return (a) => {
    if (!Jn(a) || !Jn(i)) return i;
    const o = Co(
      i,
      {
        [j2]: a
      },
      j2,
      r,
      n
    );
    return o === void 0 ? a : o;
  };
}
const Xu = /* @__PURE__ */ new WeakMap(), u7 = {
  get(e, t) {
    if (t === Ku) return e;
    const r = e[t];
    let n;
    return Jn(r) ? Xu.get(r) || (Xu.set(r, n = new Proxy(r, u7)), n) : r;
  },
  set(e, t, r) {
    return Wr(e, t, Ga(r)), !0;
  },
  deleteProperty(e, t) {
    return Wr(e, t, void 0, !0), !0;
  }
};
function qd(e) {
  return (t) => {
    if (Jn(t)) {
      let r;
      (r = Xu.get(t)) || Xu.set(t, r = new Proxy(t, u7)), e(r);
    }
    return t;
  };
}
var yF = /* @__PURE__ */ x("<label>"), bF = /* @__PURE__ */ x('<div class="text-xs leading-6 text-gray-500">'), $F = /* @__PURE__ */ x('<span class="text-xs leading-6 text-gray-500"id=email-optional>'), wF = /* @__PURE__ */ x('<div><div class="flex justify-between items-center"><div>'), xF = /* @__PURE__ */ x("<div class=h-6><p>");
const _f = Tr([{
  id: "",
  error: "",
  loading: !1,
  disabled: !1
}, {
  setError: () => {
  },
  setLoading: () => {
  },
  setDisabled: () => {
  }
}]);
function kF(e) {
  const [t, r] = ua({
    id: `input-${Da()}`,
    error: e.error || "",
    loading: !1,
    disabled: !1
  }), n = [t, {
    setError(i) {
      r("error", i);
    },
    setLoading(i) {
      r("loading", i);
    },
    setDisabled(i) {
      r("disabled", i);
    }
  }];
  return b(_f.Provider, {
    value: n,
    get children() {
      return e.children;
    }
  });
}
function Cf() {
  return cr(_f);
}
function _F(e) {
  const [t, {
    setError: r,
    setLoading: n,
    setDisabled: i
  }] = cr(_f), a = e.error ? `${t.id}-error` : e.helpText ? `${t.id}-help` : void 0;
  me(() => {
    r(e.error || "");
  }), me(() => {
    n(e.loading || !1);
  }), me(() => {
    i(e.disabled || !1);
  });
  const o = L(() => typeof e.label == "string"), s = L(() => typeof e?.contextText == "string");
  return (() => {
    var l = wF(), d = l.firstChild, u = d.firstChild;
    return S(u, b(X, {
      get when() {
        return o();
      },
      get children() {
        var c = yF();
        return S(c, () => e.label), J((h) => {
          var f = `block text-base font-light leading-6 text-gray-900 ${e?.subLabel ? "mb-0" : ""}`, p = t.id;
          return f !== h.e && ot(c, h.e = f), p !== h.t && pt(c, "for", h.t = p), h;
        }, {
          e: void 0,
          t: void 0
        }), c;
      }
    }), null), S(u, b(X, {
      get when() {
        return !o();
      },
      get children() {
        return e.label;
      }
    }), null), S(u, b(X, {
      get when() {
        return e?.subLabel;
      },
      get children() {
        var c = bF();
        return S(c, () => e.subLabel), c;
      }
    }), null), S(d, b(X, {
      get when() {
        return !!e.contextText;
      },
      get children() {
        return [b(X, {
          when: s,
          get children() {
            var c = $F();
            return S(c, () => e.contextText), c;
          }
        }), b(X, {
          when: !s,
          get children() {
            return e.contextText;
          }
        })];
      }
    }), null), S(l, () => e.children, null), S(l, (() => {
      var c = L(() => !!(e.error || e.helpText));
      return () => c() && (() => {
        var h = xF(), f = h.firstChild;
        return pt(f, "id", a), S(f, () => e.error || e.helpText), J(() => ot(f, `mt-1 text-sm ${e.error ? "text-red-600" : "text-gray-500"}`)), h;
      })();
    })(), null), l;
  })();
}
function wr(e) {
  return b(kF, {
    get error() {
      return e.error;
    },
    get children() {
      return b(_F, Be(e, {
        get children() {
          return e.children;
        }
      }));
    }
  });
}
var CF = /* @__PURE__ */ x('<div role=status><svg aria-hidden=true viewBox="0 0 100 100"fill=none xmlns=http://www.w3.org/2000/svg><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"fill=currentColor></path><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"fill=currentFill></path></svg><span class=sr-only>Loading...');
function ni(e) {
  const t = Be({
    size: "lg",
    color: "blue"
  }, e), r = Zt("text-gray-200 animate-spin dark:text-gray-600", {
    "fill-blue-500": t.color === "blue",
    "fill-green-500": t.color === "green",
    "w-4 h-4": t.size === "sm",
    "w-6 h-6": t.size === "md",
    "w-8 h-8": t.size === "lg",
    "w-12 h-12": t.size === "xl"
  });
  return (() => {
    var n = CF(), i = n.firstChild;
    return pt(i, "class", r), n;
  })();
}
var SF = /* @__PURE__ */ x('<div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">'), EF = /* @__PURE__ */ x('<div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-1">'), TF = /* @__PURE__ */ x('<div class="absolute inset-y-0 right-0 flex items-center pr-3"><button aria-label="Drop Down for more options">'), AF = /* @__PURE__ */ x('<div class="relative rounded-lg shadow-sm"><input>');
function OF(e) {
  return typeof e == "string" ? e : typeof e == "number" ? e.toString() : Array.isArray(e) ? e.join(", ") : "";
}
function Mr(e) {
  const [t, r] = Ua(e, ["error", "copy"]), [n, i] = Ua(r, ["onInput"]), [a, o] = H(!1), [s] = Cf(), l = L(() => {
    const u = s.disabled || i.disabled, c = t.error || s.error, h = i.readonly || i.readOnly;
    return Zt("block w-full rounded-lg border-0 py-3 px-4 shadow-sm ring-1 ring-inset text-sm sm:text-base sm:leading-6 focus:outline-none", {
      "pl-10": i.type === "email",
      "ring-red-300 placeholder:text-red-300 focus:ring-inset focus:ring-red-500": !!c && !u,
      "text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-inset focus:ring-blue-600": !c && !u,
      "focus:ring-2": !h,
      "cursor-not-allowed bg-gray-50 text-gray-500 ring-gray-200": i.disabled,
      "focus:ring-1 focus:ring-1  focus:outline-0 focus:ring-gray-300 bg-gray-50 text-gray-500 ring-gray-200": h,
      "cursor-pointer": e.pointer
    });
  }), d = (u) => {
    const c = u.currentTarget;
    !isNaN(c.valueAsNumber) && typeof n.onInput == "function" && n.onInput(u);
  };
  return me(() => {
    a() && setTimeout(() => {
      o(!1);
    }, 1e3);
  }), (() => {
    var u = AF(), c = u.firstChild;
    return S(u, b(X, {
      get when() {
        return i.type === "email";
      },
      get children() {
        var h = SF();
        return S(h, b(rt, {
          name: "envelope",
          class: "h-5 w-5 text-gray-400",
          size: "sm"
        })), h;
      }
    }), c), yn(c, Be({
      get id() {
        return s?.id;
      },
      get onInput() {
        return i.type === "number" ? d : n.onInput;
      }
    }, i, {
      get class() {
        return l();
      },
      autocomplete: "off"
    }), !1, !1), S(u, b(X, {
      get when() {
        return s.loading || i.loading;
      },
      get children() {
        var h = EF();
        return S(h, b(ni, {
          size: "sm"
        })), h;
      }
    }), null), S(u, b(X, {
      get when() {
        return t.copy;
      },
      get children() {
        var h = TF(), f = h.firstChild;
        return f.$$click = () => {
          navigator.clipboard.writeText(OF(i?.value)), o(!0);
        }, S(f, b(X, {
          get when() {
            return a();
          },
          get children() {
            return b(rt, {
              name: "check",
              class: "h-5 w-5 text-gray-400",
              size: "sm"
            });
          }
        }), null), S(f, b(X, {
          get when() {
            return !a();
          },
          get children() {
            return b(rt, {
              name: "clipboard",
              class: "h-5 w-5 text-gray-400",
              size: "sm"
            });
          }
        }), null), h;
      }
    }), null), u;
  })();
}
cn(["click"]);
const IF = [
  { id: "AL", name: "Alabama" },
  { id: "AK", name: "Alaska" },
  { id: "AZ", name: "Arizona" },
  { id: "AR", name: "Arkansas" },
  { id: "CA", name: "California" },
  { id: "CO", name: "Colorado" },
  { id: "CT", name: "Connecticut" },
  { id: "DE", name: "Delaware" },
  { id: "DC", name: "District Of Columbia" },
  { id: "FL", name: "Florida" },
  { id: "GA", name: "Georgia" },
  { id: "HI", name: "Hawaii" },
  { id: "ID", name: "Idaho" },
  { id: "IL", name: "Illinois" },
  { id: "IN", name: "Indiana" },
  { id: "IA", name: "Iowa" },
  { id: "KS", name: "Kansas" },
  { id: "KY", name: "Kentucky" },
  { id: "LA", name: "Louisiana" },
  { id: "ME", name: "Maine" },
  { id: "MD", name: "Maryland" },
  { id: "MA", name: "Massachusetts" },
  { id: "MI", name: "Michigan" },
  { id: "MN", name: "Minnesota" },
  { id: "MS", name: "Mississippi" },
  { id: "MO", name: "Missouri" },
  { id: "MT", name: "Montana" },
  { id: "NE", name: "Nebraska" },
  { id: "NV", name: "Nevada" },
  { id: "NH", name: "New Hampshire" },
  { id: "NJ", name: "New Jersey" },
  { id: "NM", name: "New Mexico" },
  { id: "NY", name: "New York" },
  { id: "NC", name: "North Carolina" },
  { id: "ND", name: "North Dakota" },
  { id: "OH", name: "Ohio" },
  { id: "OK", name: "Oklahoma" },
  { id: "OR", name: "Oregon" },
  { id: "PA", name: "Pennsylvania" },
  { id: "PR", name: "Puerto Rico" },
  { id: "RI", name: "Rhode Island" },
  { id: "SC", name: "South Carolina" },
  { id: "SD", name: "South Dakota" },
  { id: "TN", name: "Tennessee" },
  { id: "TX", name: "Texas" },
  { id: "UT", name: "Utah" },
  { id: "VT", name: "Vermont" },
  { id: "VA", name: "Virginia" },
  { id: "WA", name: "Washington" },
  { id: "WV", name: "West Virginia" },
  { id: "WI", name: "Wisconsin" },
  { id: "WY", name: "Wyoming" }
];
function Wn(e, t) {
  let r = {}, n = Object.keys(e);
  for (let i = 0, a = n.length; i < a; i += 1) {
    let o = n[i];
    t.includes(o) || Object.defineProperty(r, o, { get() {
      return e[o];
    }, configurable: !0, enumerable: !0 });
  }
  return r;
}
function Ya(e, t) {
  if (!e) throw t;
}
function V2(e, t) {
  return e === t || e !== e && t !== t;
}
function PF(e) {
  let [t, r] = H(), n, i, a = e.by || V2;
  if ("defaultValue" in e) {
    let [s, l] = H(e.defaultValue);
    n = s, i = (d) => {
      l(() => d), e.onChange && e.onChange(d);
    };
  } else n = L(() => e.value), i = (s) => {
    e.onChange && e.onChange(s);
  };
  let o = L(() => !!e.disabled);
  return { isSelected(s) {
    return V2(s, n());
  }, select(s) {
    Re(o) || (e.toggleable && a(Re(n), s) ? i(void 0) : i(s));
  }, hasSelected() {
    return n() != null;
  }, disabled: o, hasActive() {
    return !!t();
  }, isActive(s) {
    let l = t();
    return l ? a(s, l.value) : !1;
  }, focus(s) {
    Re(o) || r({ value: s });
  }, blur() {
    Re(o) || r(void 0);
  } };
}
function DF(e) {
  let [t, r] = H(), n, i, a = e.by || V2;
  if ("defaultValue" in e) {
    let [s, l] = H(e.defaultValue);
    n = s, i = (d) => {
      l(() => d), e.onChange && e.onChange(d);
    };
  } else n = L(() => e.value), i = (s) => {
    e.onChange && e.onChange(s);
  };
  let o = L(() => !!e.disabled);
  return { isSelected(s) {
    let l = n();
    for (let d = 0, u = l.length; d < u; d += 1) if (a(s, l[d])) return !0;
    return !1;
  }, select(s) {
    if (!Re(o)) {
      let l = [], d = Re(n), u = !1;
      for (let c = 0, h = d.length; c < h; c += 1) {
        let f = d[c], p = a(f, s);
        p && (u = !0), e.toggleable && p || l.push(f);
      }
      u || l.push(s), i(l);
    }
  }, hasSelected: L(() => n().length > 0), disabled: o, hasActive: L(() => !!t()), isActive(s) {
    let l = t();
    return l ? a(s, l.value) : !1;
  }, focus(s) {
    Re(o) || r({ value: s });
  }, blur() {
    Re(o) || r(void 0);
  } };
}
var c7 = Tr();
function h7(e) {
  return b(c7.Provider, { value: e.state, get children() {
    let t = e.children;
    return typeof t == "function" ? t(e.state) : t;
  } });
}
function Sf() {
  let e = cr(c7);
  return Ya(e, new Error("Missing <SelectStateProvider>")), e;
}
function Hc(e, t) {
  return b(m_, Be({ get component() {
    return e();
  } }, t));
}
function MF(e) {
  return typeof e == "function";
}
function dd(e) {
  let [t, r] = H();
  return me(() => {
    let n = t();
    n && "ref" in e && MF(e.ref) && e.ref(n);
  }), [t, r];
}
function As(e) {
  return e ? "" : void 0;
}
function ud(e) {
  return { get disabled() {
    return e();
  }, get "aria-disabled"() {
    return e();
  } };
}
function NF(e) {
  return { get "aria-expanded"() {
    return e();
  } };
}
function LF(e) {
  return { get "aria-selected"() {
    return e();
  } };
}
function cd(e) {
  return { get "tc-disabled"() {
    return As(e());
  } };
}
function Ef(e) {
  return { get "tc-expanded"() {
    return As(e());
  } };
}
function FF(e) {
  return { get "tc-selected"() {
    return As(e());
  } };
}
function RF(e) {
  return { get "tc-active"() {
    return As(e());
  } };
}
function Tf(e) {
  return { get "tc-has-selected"() {
    return As(e());
  } };
}
function Af(e) {
  return { get "tc-has-active"() {
    return As(e());
  } };
}
function zF(e, t, r, n) {
  e.addEventListener(t, r, n), xr(() => {
    e.removeEventListener(t, r, n);
  });
}
var Nr = zF, Wc = "tc", jF = `${Wc}-type`, f7 = `[${Wc}-disabled]`, VF = `[${Wc}-selected]`;
function hd(e) {
  return { [jF]: e };
}
var UF = /* @__PURE__ */ new Set();
function qF(e) {
  for (let t of UF.keys()) t(e);
}
function am(e) {
  return !e.matches(f7);
}
function Qc(e, t, r, n) {
  let i = t + r;
  if (n) {
    for (r === 1 && i === e.length && (i = 0), r === -1 && i === -1 && (i = e.length - 1); t !== i; ) {
      if (am(e[i])) return e[i];
      i += r, r === 1 && i >= e.length && (i = 0), r === -1 && i < 0 && (i = e.length - 1);
    }
    return;
  }
  for (; i >= 0 && i < e.length; ) {
    if (am(e[i])) return e[i];
    i += r;
  }
}
function Os(e, t) {
  return e && (t ? qF(e) : e.focus()), e;
}
function BF(e, t, r, n) {
  for (let i = 0, a = e.length; i < a; i += 1) if (t === e[i] || e[i].contains(t)) return Os(Qc(e, i, 1, r), n);
}
function HF(e, t, r, n) {
  for (let i = 0, a = e.length; i < a; i += 1) if (e[i].contains(t)) return Os(Qc(e, i, -1, r), n);
}
function WF(e, t) {
  if (e.length) return Os(Qc(e, -1, 1, !1), t);
}
function QF(e, t) {
  if (e.length) return Os(Qc(e, e.length, -1, !1), t);
}
function GF(e, t, r) {
  let n = t.toLowerCase();
  for (let i = 0, a = e.length; i < a; i += 1) {
    let o = e[i].textContent;
    if (o != null && o.toLowerCase().startsWith(n)) return Os(e[i], r);
  }
}
var p7 = `${Wc}-owner`;
function YF(e, t, r = "") {
  let n = `[${p7}="${t}"]:not(${f7})${r}`;
  return e.querySelectorAll(n);
}
function KF(e) {
  return { [p7]: e };
}
var ZF = class {
  constructor(e, t = {}) {
    var r, n;
    this.ownerID = e, this.options = { virtual: (r = t.virtual) != null ? r : !1, base: (n = t.base) != null ? n : "" };
  }
  setRef(e) {
    this.internalRef = e;
  }
  clearRef() {
    this.internalRef = void 0;
  }
  query(e, t = "") {
    return YF(e, this.ownerID, `${this.options.base}${t}`);
  }
  setCurrent(e) {
    this.current = e;
  }
  setChecked(e) {
    this.current = Os(e, this.options.virtual);
  }
  setNextChecked(e) {
    if (this.internalRef instanceof HTMLElement) {
      Ya(this.current, new Error("missing current ref"));
      let t = BF(this.query(this.internalRef), this.current, e, this.options.virtual);
      t && (this.current = t);
    }
  }
  setPrevChecked(e) {
    if (this.internalRef instanceof HTMLElement) {
      Ya(this.current, new Error("missing current ref"));
      let t = HF(this.query(this.internalRef), this.current, e, this.options.virtual);
      t && (this.current = t);
    }
  }
  setFirstChecked(e = "") {
    if (this.internalRef instanceof HTMLElement) {
      let t = WF(this.query(this.internalRef, e), this.options.virtual);
      t && (this.current = t);
    }
  }
  setLastChecked(e = "") {
    if (this.internalRef instanceof HTMLElement) {
      let t = QF(this.query(this.internalRef, e), this.options.virtual);
      t && (this.current = t);
    }
  }
  setFirstMatch(e) {
    if (this.internalRef instanceof HTMLElement) {
      let t = GF(this.query(this.internalRef), e, this.options.virtual);
      t && (this.current = t);
    }
  }
  getId() {
    return this.ownerID;
  }
};
function XF(e) {
  let t = Sf(), r = L(() => e.disabled || t.disabled());
  return { isSelected: L(() => t.isSelected(e.value)), isActive: L(() => t.isActive(e.value)), select() {
    Re(r) || t.select(e.value);
  }, focus() {
    Re(r) || t.focus(e.value);
  }, blur() {
    !Re(r) && this.isActive() && t.blur();
  }, disabled: r };
}
var JF = Tr();
function eR(e) {
  return b(JF.Provider, { value: e.state, get children() {
    let t = e.children;
    return typeof t == "function" ? t(e.state) : t;
  } });
}
var tR = hd("button");
function m7(e) {
  let [t, r] = dd(e);
  return me(() => {
    let n = t();
    n instanceof HTMLElement && n.tagName !== "BUTTON" && Nr(n, "keydown", (i) => {
      switch (i.key) {
        case "Enter":
        case " ": {
          n.click();
          break;
        }
      }
    });
  }), Hc(() => e.as || "button", Be({ get tabindex() {
    return e.disabled ? -1 : 0;
  }, role: "button" }, cd(() => e.disabled), ud(() => e.disabled), Wn(e, ["as", "ref"]), tR, { ref: r }));
}
function g7(e, t, r) {
  let n = L(() => e.unmount == null ? !0 : e.unmount);
  return L(() => {
    let i = n();
    if (i === "offscreen") {
      let a = L(() => t()), o = Zh(() => r());
      return L(() => a() && o);
    }
    if (i) {
      let a = L(() => t());
      return L(() => a() && r);
    }
    return r;
  });
}
function rR(e) {
  let t, r;
  if ("defaultOpen" in e) {
    let [i, a] = H(e.defaultOpen);
    t = i, r = (o) => {
      a(o), o && e.onOpen && e.onOpen(), e.onChange && e.onChange(o), !o && e.onClose && e.onClose();
    };
  } else t = L(() => e.isOpen), r = (i) => {
    i && e.onOpen && e.onOpen(), e.onChange && e.onChange(i), !i && e.onClose && e.onClose();
  };
  let n = L(() => !!e.disabled);
  return { isOpen() {
    return t();
  }, setState(i) {
    Re(n) || r(i);
  }, disabled: n, open() {
    Re(n) || r(!0);
  }, close() {
    Re(n) || r(!1);
  }, toggle() {
    Re(n) || r(!Re(t));
  } };
}
var v7 = Tr();
function nR(e) {
  return b(v7.Provider, { value: e.state, get children() {
    let t = e.children;
    return typeof t == "function" ? t(e.state) : t;
  } });
}
function Gc() {
  let e = cr(v7);
  return Ya(e, new Error("Missing <DisclosureStateProvider>")), e;
}
function y7(e) {
  let t = Gc();
  return L(() => {
    let r = e.children;
    return typeof r == "function" && r.length === 1 ? L(() => r(t)) : r;
  });
}
function om() {
  let e = window.getSelection();
  if (e) {
    let t = e.focusNode;
    if (t) return t.parentElement;
  }
}
function iR(e) {
  if (e) {
    let t = e.getAttribute("tabindex");
    e.setAttribute("tabindex", "-1"), e.focus(), e.blur(), t ? e.setAttribute("tabindex", t) : e.removeAttribute("tabindex");
  }
}
var aR = class {
  constructor() {
    this.returnElement = document.activeElement, this.fsp = om(), xr(() => {
      this.load();
    });
  }
  load() {
    this.returnElement instanceof HTMLElement ? this.returnElement.focus() : iR(this.fsp);
  }
  save() {
    this.returnElement = document.activeElement, this.fsp = om();
  }
};
function oR() {
  return new aR();
}
var b7 = Tr();
function Of(e) {
  let t = cr(b7);
  return Ya(t, new Error(`<${e}> must be used inside a <Listbox>`)), t;
}
var sR = hd("listbox"), lR = hd("listbox-button"), dR = hd("listbox-options"), uR = hd("listbox-option");
function cR(e) {
  return !!e.multiple;
}
function hR(e) {
  return "defaultValue" in e;
}
function sm(e) {
  return "defaultOpen" in e;
}
function fR(e) {
  return hR(e) ? sm(e) ? Wn(e, ["as", "by", "children", "defaultOpen", "defaultValue", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]) : Wn(e, ["as", "by", "children", "isOpen", "defaultValue", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]) : sm(e) ? Wn(e, ["as", "by", "children", "defaultOpen", "value", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]) : Wn(e, ["as", "by", "children", "isOpen", "value", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]);
}
function pR(e) {
  return L(() => {
    let t = Da(), r = Da(), n = Da(), i = Da(), a = rR(Be(e, { onChange(l) {
      e.onDisclosureChange && e.onDisclosureChange(l);
    } })), o = cR(e) ? DF(Be(e, { onChange(l) {
      e.onSelectChange && e.onSelectChange(l);
    } })) : PF(Be(e, { onChange(l) {
      e.onSelectChange && e.onSelectChange(l);
    } })), s = oR();
    return me(() => {
      a.isOpen() ? s.save() : s.load();
    }), b(b7.Provider, { value: { get multiple() {
      return e.multiple;
    }, ownerID: t, labelID: r, buttonID: n, optionsID: i, get horizontal() {
      return e.horizontal;
    }, buttonHovering: !1, optionsHovering: !1 }, get children() {
      return b(h7, { state: o, get children() {
        return b(nR, { state: a, get children() {
          return Hc(() => e.as || "div", Be(fR(e), sR, { id: t, "aria-labelledby": r }, cd(() => o.disabled()), ud(() => o.disabled()), Tf(() => o.hasSelected()), Af(() => o.hasActive()), Ef(() => a.isOpen()), { get children() {
            return e.children;
          } }));
        } });
      } });
    } });
  });
}
function mR(e) {
  let t = Of("ListboxButton"), r = Gc(), n = Sf(), [i, a] = dd(e), o = () => r.disabled() || e.disabled;
  return me(() => {
    let s = i();
    s instanceof HTMLElement && (t.anchor = s, Nr(s, "click", () => {
      o() || r.toggle();
    }), Nr(s, "keydown", (l) => {
      if (!o()) switch (l.key) {
        case "ArrowUp":
        case "ArrowDown": {
          l.preventDefault(), r.toggle();
          break;
        }
      }
    }), Nr(s, "mouseenter", () => {
      t.buttonHovering = !0;
    }), Nr(s, "mouseleave", () => {
      t.buttonHovering = !1;
    }));
  }), b(m7, Be(Wn(e, ["children", "ref"]), lR, { id: t.buttonID, "aria-haspopup": "listbox", "aria-controls": t.optionsID, ref: a }, cd(o), ud(o), Ef(() => r.isOpen()), NF(() => r.isOpen()), Tf(() => n.hasSelected()), Af(() => n.hasActive()), { get children() {
    return b(y7, { get children() {
      return e.children;
    } });
  } }));
}
var $7 = Tr();
function gR(e) {
  let t = cr($7);
  return Ya(t, new Error(`<${e}> must be used inside a <ListboxOptions>`)), t;
}
function vR(e) {
  return new ZF(e);
}
function yR(e) {
  let t = Of("ListboxOptions"), r = gR("ListboxOptions"), n = Gc(), i = XF(e), [a, o] = dd(e);
  return J(() => {
    let s = a();
    s instanceof HTMLElement && (Nr(s, "click", () => {
      i.disabled() || (i.select(), t.multiple || n.close());
    }), Nr(s, "focus", () => {
      i.focus();
    }), Nr(s, "blur", () => {
      i.blur();
    }), Nr(s, "mouseenter", () => {
      i.disabled() || s.focus({ preventScroll: !0 });
    }), Nr(s, "mouseleave", () => {
      i.disabled() || i.blur();
    }));
  }), b(m7, Be(Wn(e, ["as", "children", "disabled", "value", "ref"]), uR, KF(r.getId()), { get as() {
    return e.as || "li";
  }, role: "option", tabindex: -1, ref: o }, cd(() => i.disabled()), ud(() => i.disabled()), FF(() => i.isSelected()), LF(() => i.isSelected()), RF(() => i.isActive()), { get children() {
    return b(eR, { state: i, get children() {
      return e.children;
    } });
  } }));
}
var bR = 250;
function $R(e, t = bR) {
  let r = "", n;
  return xr(() => {
    n && clearTimeout(n);
  }), (i) => {
    r += i, n && clearTimeout(n), n = setTimeout(() => {
      e(r), r = "";
    }, t);
  };
}
function wR(e) {
  let t = Of("ListboxOptions"), r = Sf(), n = Gc(), [i, a] = dd(e), o = vR(t.optionsID), s = $R((l) => {
    o.setFirstMatch(l);
  });
  return Et(() => {
    me(() => {
      let l = i();
      l instanceof HTMLElement && n.isOpen() && (o.setRef(l), xr(() => {
        o.clearRef();
      }), Re(() => r.hasSelected()) ? o.setFirstChecked(VF) : o.setFirstChecked(), Nr(l, "keydown", (d) => {
        if (!r.disabled()) switch (d.key) {
          case "Escape": {
            n.close();
            break;
          }
          case "ArrowLeft": {
            t.horizontal && (d.preventDefault(), o.setPrevChecked(!0));
            break;
          }
          case "ArrowUp": {
            t.horizontal || (d.preventDefault(), o.setPrevChecked(!0));
            break;
          }
          case "ArrowRight": {
            t.horizontal && (d.preventDefault(), o.setNextChecked(!0));
            break;
          }
          case "ArrowDown": {
            t.horizontal || (d.preventDefault(), o.setNextChecked(!0));
            break;
          }
          case "Home": {
            d.preventDefault(), o.setFirstChecked();
            break;
          }
          case "End": {
            d.preventDefault(), o.setLastChecked();
            break;
          }
          case " ":
          case "Enter": {
            d.preventDefault();
            break;
          }
          default: {
            d.key.length === 1 && s(d.key);
            break;
          }
        }
      }), Nr(l, "focusout", (d) => {
        t.buttonHovering || t.optionsHovering || d.relatedTarget && l.contains(d.relatedTarget) || n.close();
      }), Nr(l, "focusin", (d) => {
        d.target && d.target !== l && o.setCurrent(d.target);
      }), Nr(l, "mouseenter", () => {
        t.optionsHovering = !0;
      }), Nr(l, "mouseleave", () => {
        t.optionsHovering = !1;
      }));
    });
  }), g7(e, () => n.isOpen(), () => b($7.Provider, { value: o, get children() {
    return Hc(() => e.as || "ul", Be(Wn(e, ["as", "children", "ref"]), dR, { id: t.optionsID, role: "listbox", "aria-multiselectable": t.multiple, "aria-labelledby": t.buttonID, ref: a, get "aria-orientation"() {
      return t.horizontal ? "horizontal" : "vertical";
    }, get tabindex() {
      return r.disabled() ? -1 : 0;
    } }, cd(() => r.disabled()), ud(() => r.disabled()), Ef(() => n.isOpen()), Tf(() => r.hasSelected()), Af(() => r.hasActive()), { get children() {
      return b(h7, { state: r, get children() {
        return e.children;
      } });
    } }));
  } }));
}
var w7 = Tr(), lm = Tr();
function xR(e) {
  let t = cr(w7);
  return Ya(t, new Error(`<${e}> must be used inside a <Transition>`)), t;
}
function kR() {
  let [e, t] = H(0);
  return { register() {
    t((r) => r + 1);
  }, unregister() {
    t((r) => r - 1);
  }, done() {
    return e() === 0;
  } };
}
function Pi(e) {
  return e ? e.split(" ") : [];
}
function pa(e, t) {
  let r = t.filter((n) => n);
  r.length && e.classList.add(...r);
}
function ma(e, t) {
  let r = t.filter((n) => n);
  r.length && e.classList.remove(...r);
}
function _R(e) {
  let t = xR("TransitionChild"), r = cr(lm), n = kR(), [i, a] = H(), [o, s] = H(t.show), [l, d] = dd(e), u = !0;
  function c(h, f) {
    if (f) {
      if (u) {
        let p = Pi(e.enter), g = Pi(e.enterFrom), v = Pi(e.enterTo), m = Pi(e.entered), $ = () => {
          ma(h, p), ma(h, v), a("entered"), pa(h, m), e.afterEnter && e.afterEnter();
        };
        e.beforeEnter && e.beforeEnter(), a("enter-from"), pa(h, p), pa(h, g), requestAnimationFrame(() => {
          ma(h, g), a("enter-to"), pa(h, v), h.addEventListener("transitionend", $, { once: !0 }), h.addEventListener("animationend", $, { once: !0 });
        });
      }
    } else {
      let p = Pi(e.leave), g = Pi(e.leaveFrom), v = Pi(e.leaveTo), m = Pi(e.entered);
      e.beforeLeave && e.beforeLeave(), r && r.register(), ma(h, m), a("leave-from"), pa(h, p), pa(h, g), requestAnimationFrame(() => {
        ma(h, g), a("leave-to"), pa(h, v);
      });
      let $ = () => {
        ma(h, p), ma(h, v), s(!1), r && r.unregister(), e.afterLeave && e.afterLeave();
      };
      h.addEventListener("transitionend", $, { once: !0 }), h.addEventListener("animationend", $, { once: !0 });
    }
  }
  return me(() => {
    let h = t.show;
    h && s(!0);
    let f = l();
    f instanceof HTMLElement ? h ? c(f, !0) : n.done() && c(f, !1) : u = !0;
  }), b(lm.Provider, { value: n, get children() {
    return g7(e, o, () => Hc(() => e.as || "div", Be(Wn(e, ["as", "enter", "enterFrom", "enterTo", "leave", "leaveFrom", "leaveTo", "unmount", "afterEnter", "afterLeave", "appear", "beforeEnter", "beforeLeave", "entered", "ref"]), { ref: d, get "tc-transition"() {
      return i();
    } })));
  } });
}
function CR(e) {
  return b(w7.Provider, { value: e, get children() {
    return b(_R, Wn(e, ["show"]));
  } });
}
var SR = /* @__PURE__ */ x('<span class="block truncate">'), ER = /* @__PURE__ */ x('<span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">'), TR = /* @__PURE__ */ x("<div><span>"), AR = /* @__PURE__ */ x("<span>");
function OR(e) {
  const [t, r] = H({
    name: e.selectMessage
  }), {
    field: n,
    onInput: i
  } = H_(e.name), [a] = Cf();
  return b(pR, {
    ref: n,
    defaultOpen: !1,
    get value() {
      return t();
    },
    onSelectChange: (o) => {
      r(o ?? {
        name: e.selectMessage
      }), i(o?.name ?? "");
    },
    class: "relative shadow-sm rounded-lg",
    get children() {
      return [b(mR, {
        type: "button",
        get class() {
          return `block text-left w-full rounded-lg border-0 py-3 px-4 shadow-sm ring-1 ring-inset text-sm sm:text-base sm:leading-6 focus:outline-none text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-inset focus:ring-blue-600 focus:ring-2
          ${a.error ? "ring-red-300 placeholder:text-red-300 focus:ring-inset focus:ring-red-500" : ""}
          `;
        },
        get children() {
          return [(() => {
            var o = SR();
            return S(o, () => t()?.name ?? ""), o;
          })(), (() => {
            var o = ER();
            return S(o, b(rt, {
              name: "chevronDown",
              class: "w-5 h-5 text-gray-400",
              size: "sm"
            })), o;
          })()];
        }
      }), b(y7, {
        children: ({
          isOpen: o
        }) => b(CR, {
          get show() {
            return o();
          },
          enter: "transition ease-in duration-100",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition ease-out duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          get children() {
            return b(wR, {
              unmount: !1,
              class: "absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10",
              get children() {
                return b(kt, {
                  get each() {
                    return e.list;
                  },
                  children: (s) => b(yR, {
                    class: "focus:outline-none group",
                    value: s,
                    children: ({
                      isActive: l,
                      isSelected: d
                    }) => (() => {
                      var u = TR(), c = u.firstChild;
                      return S(c, () => s.name), S(u, (() => {
                        var h = L(() => !!d());
                        return () => h() ? (() => {
                          var f = AR();
                          return S(f, b(rt, {
                            name: "checkCircle"
                          })), J(() => ot(f, Zt((l(), "text-blue-600"), "group-hover:text-blue-600", "absolute inset-y-0 left-0 flex items-center pl-3"))), f;
                        })() : null;
                      })(), null), J((h) => {
                        var f = Zt(l() ? "text-blue-900 bg-blue-100" : "text-gray-900", "group-hover:text-blue-900 group-hover:bg-blue-100", "cursor-default select-none relative py-2 pl-10 pr-4"), p = Zt(d() ? "font-medium" : "font-normal", "block truncate");
                        return f !== h.e && ot(u, h.e = f), p !== h.t && ot(c, h.t = p), h;
                      }, {
                        e: void 0,
                        t: void 0
                      }), u;
                    })()
                  })
                });
              }
            });
          }
        })
      })];
    }
  });
}
var dm = /* @__PURE__ */ x("<div>");
function hn(e) {
  const t = Be({
    variant: "white",
    autoPadding: !0
  }, e), r = L(() => Zt("border rounded-lg ", {
    "divide-y divide-gray-300": t?.addChildrenDivider,
    "border-blue-600 bg-blue-50": t?.selected,
    "border-gray-300": !t?.selected,
    "bg-white": t?.variant === "white",
    "bg-gray-50": t?.variant === "gray",
    "opacity-35": t?.disabled
  }));
  return (() => {
    var n = dm();
    return S(n, b(kt, {
      get each() {
        return Array.isArray(t.children) ? t.children : [t.children];
      },
      children: (i) => (() => {
        var a = dm();
        return S(a, i), J(() => ot(a, Zt({
          "px-4 py-3 sm:px-6 sm:py-4": t.autoPadding
        }))), a;
      })()
    })), J(() => ot(n, r())), n;
  })();
}
var IR = /* @__PURE__ */ x("<span>");
function ke(e) {
  const t = Be({
    size: "md",
    color: "black"
  }, e), r = L(() => (
    // [overflow-wrap:anywhere] is here to prevent long text from overflowing, should be in tailwind soon
    // https://github.com/tailwindlabs/tailwindcss/discussions/2213#discussioncomment-5316024
    Zt(e.class, "inline-flex my-px [overflow-wrap:anywhere] leading-snug", {
      "text-xs": t.size === "xs",
      "text-sm": t.size === "sm",
      "text-base": t.size === "md",
      "text-lg": t.size === "lg",
      "text-xl": t.size === "xl",
      "text-black": !e.loading && t.color === "black",
      "text-slate-500": !e.loading && t.color === "gray",
      "text-red-500": !e.loading && t.color === "red",
      "text-transparent box-border rounded-md": e.loading,
      "bg-gray-100": !e.selected && e.loading,
      "bg-blue-100": e.selected && e.loading,
      "font-semibold": e.bold,
      italic: e.italic
    })
  ));
  return (() => {
    var n = IR();
    return S(n, b(X, {
      get when() {
        return !e.loading;
      },
      get children() {
        return e.children;
      }
    }), null), S(n, b(X, {
      get when() {
        return e.loading;
      },
      get children() {
        return e.sampleLoadingText;
      }
    }), null), J((i) => {
      var a = r(), o = e.loading, s = e.loading;
      return a !== i.e && ot(n, i.e = a), o !== i.t && pt(n, "aria-hidden", i.t = o), s !== i.a && pt(n, "aria-busy", i.a = s), i;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), n;
  })();
}
var PR = /* @__PURE__ */ x("<button>");
function st(e) {
  const t = Be({
    variant: "primary",
    size: "lg"
  }, e), [r, n] = Ua(t, ["variant", "size", "color", "children", "iconLeft", "loading"]), i = L(() => {
    const a = r.color || "gray", o = r.variant === "secondary" && r.color ? `rounded bg-white text-${a}-600 shadow-sm ring-1 ring-inset ring-${a}-500 hover:bg-${a}-50` : "";
    return Zt("font-semibold flex justify-center inline-flex items-center gap-x-1", {
      "shadow-sm": r.variant !== "naked",
      "rounded-md": ["xl", "lg", "md"].includes(r.size),
      rounded: !["xl", "lg", "md"].includes(r.size),
      "text-xs": r.size === "xs",
      "text-sm": r.size !== "xs",
      "px-3.5 py-2.5": r.size === "xl" && r.variant !== "naked",
      "px-3 py-2": r.size === "lg" && r.variant !== "naked",
      "px-2.5 py-1.5": r.size === "md" && r.variant !== "naked",
      "px-2 py-1": (r.size === "sm" || r.size === "xs") && r.variant !== "naked",
      "text-white bg-blue-500 hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2": r.variant === "primary",
      "rounded bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50": r.variant === "secondary" && !r.color,
      "text-white bg-red-500 hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2": r.variant === "danger",
      "bg-blue-50 text-blue-600 hover:bg-blue-100": r.variant === "tertiary",
      "text-blue-600 hover:text-blue-500 bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-300": r.variant === "naked",
      "opacity-50 cursor-not-allowed": n.disabled || r.loading
    }, o, e?.class);
  });
  return (() => {
    var a = PR();
    return yn(a, Be(n, {
      get class() {
        return i();
      },
      get disabled() {
        return n.disabled || r.loading;
      },
      get type() {
        return e?.type;
      }
    }), !1, !0), S(a, b(X, {
      get when() {
        return r?.loading;
      },
      get children() {
        return b(ni, {
          size: "sm"
        });
      }
    }), null), S(a, b(X, {
      get when() {
        return r?.iconLeft;
      },
      get children() {
        return r?.iconLeft;
      }
    }), null), S(a, () => t.children, null), a;
  })();
}
const x7 = Tr();
function DR(e) {
  return b(x7.Provider, {
    get value() {
      return e.client;
    },
    get children() {
      return e.children;
    }
  });
}
function Ln() {
  const e = cr(x7);
  if (!e)
    throw new Error("SDKContext must be defined");
  return e;
}
const MR = (e) => typeof e == "function", Ju = (e, t) => MR(e) ? e(t) : e;
var nr;
(function(e) {
  e[e.ADD_TOAST = 0] = "ADD_TOAST", e[e.UPDATE_TOAST = 1] = "UPDATE_TOAST", e[e.UPSERT_TOAST = 2] = "UPSERT_TOAST", e[e.DISMISS_TOAST = 3] = "DISMISS_TOAST", e[e.REMOVE_TOAST = 4] = "REMOVE_TOAST", e[e.START_PAUSE = 5] = "START_PAUSE", e[e.END_PAUSE = 6] = "END_PAUSE";
})(nr || (nr = {}));
const [ja, Di] = ua({
  toasts: [],
  pausedAt: void 0
}), NR = () => {
  const { pausedAt: e, toasts: t } = ja;
  if (e)
    return;
  const r = Date.now();
  return t.map((n) => {
    if (n.duration === 1 / 0)
      return;
    const i = (n.duration || 0) + n.pauseDuration - (r - n.createdAt);
    if (i <= 0) {
      n.visible && Dn({
        type: nr.DISMISS_TOAST,
        toastId: n.id
      });
      return;
    }
    return setTimeout(() => {
      Dn({
        type: nr.DISMISS_TOAST,
        toastId: n.id
      });
    }, i);
  });
}, Tl = /* @__PURE__ */ new Map(), um = (e, t) => {
  if (Tl.has(e))
    return;
  const r = setTimeout(() => {
    Tl.delete(e), Dn({
      type: nr.REMOVE_TOAST,
      toastId: e
    });
  }, t);
  Tl.set(e, r);
}, LR = (e) => {
  const t = Tl.get(e);
  Tl.delete(e), t && clearTimeout(t);
}, Dn = (e) => {
  switch (e.type) {
    case nr.ADD_TOAST:
      Di("toasts", (i) => {
        const a = i;
        return [e.toast, ...a];
      });
      break;
    case nr.DISMISS_TOAST:
      const { toastId: t } = e, r = ja.toasts;
      if (t) {
        const i = r.find((a) => a.id === t);
        i && um(t, i.unmountDelay), Di("toasts", (a) => a.id === t, qd((a) => a.visible = !1));
      } else
        r.forEach((i) => {
          um(i.id, i.unmountDelay);
        }), Di("toasts", (i) => i.id !== void 0, qd((i) => i.visible = !1));
      break;
    case nr.REMOVE_TOAST:
      if (!e.toastId) {
        Di("toasts", []);
        break;
      }
      Di("toasts", (i) => i.filter((a) => a.id !== e.toastId));
      break;
    case nr.UPDATE_TOAST:
      e.toast.id && LR(e.toast.id), Di("toasts", (i) => i.id === e.toast.id, (i) => ({
        ...i,
        ...e.toast
      }));
      break;
    case nr.UPSERT_TOAST:
      ja.toasts.find((i) => i.id === e.toast.id) ? Dn({ type: nr.UPDATE_TOAST, toast: e.toast }) : Dn({ type: nr.ADD_TOAST, toast: e.toast });
      break;
    case nr.START_PAUSE:
      Di(qd((i) => {
        i.pausedAt = Date.now(), i.toasts.forEach((a) => {
          a.paused = !0;
        });
      }));
      break;
    case nr.END_PAUSE:
      const n = e.time - (ja.pausedAt || 0);
      Di(qd((i) => {
        i.pausedAt = void 0, i.toasts.forEach((a) => {
          a.pauseDuration += n, a.paused = !1;
        });
      }));
      break;
  }
}, FR = {
  blank: 4e3,
  error: 4e3,
  success: 2e3,
  loading: 1 / 0,
  custom: 4e3
}, Ko = {
  id: "",
  icon: "",
  unmountDelay: 500,
  duration: 3e3,
  ariaProps: {
    role: "status",
    "aria-live": "polite"
  },
  className: "",
  style: {},
  position: "top-right",
  iconTheme: {}
}, k7 = {
  position: "top-right",
  toastOptions: Ko,
  gutter: 8,
  containerStyle: {},
  containerClassName: ""
}, Bd = "16px", RR = {
  position: "fixed",
  "z-index": 9999,
  top: Bd,
  bottom: Bd,
  left: Bd,
  right: Bd,
  "pointer-events": "none"
}, zR = /* @__PURE__ */ (() => {
  let e = 0;
  return () => String(++e);
})(), jR = (e) => {
  QR((t) => ({
    containerClassName: e.containerClassName ?? t.containerClassName,
    containerStyle: e.containerStyle ?? t.containerStyle,
    gutter: e.gutter ?? t.gutter,
    position: e.position ?? t.position,
    toastOptions: {
      ...e.toastOptions
    }
  }));
}, VR = (e, t) => {
  const r = e.includes("top") ? { top: 0, "margin-top": `${t}px` } : { bottom: 0, "margin-bottom": `${t}px` }, n = e.includes("center") ? { "justify-content": "center" } : e.includes("right") ? { "justify-content": "flex-end" } : {};
  return {
    left: 0,
    right: 0,
    display: "flex",
    position: "absolute",
    transition: "all 230ms cubic-bezier(.21,1.02,.73,1)",
    ...r,
    ...n
  };
}, UR = (e, t) => {
  const r = e.getBoundingClientRect();
  r.height !== t.height && Dn({
    type: nr.UPDATE_TOAST,
    toast: { id: t.id, height: r.height }
  });
}, qR = (e, t) => {
  const { toasts: r } = ja, n = So().gutter || k7.gutter || 8, i = r.filter((s) => (s.position || t) === t && s.height), a = i.findIndex((s) => s.id === e.id), o = i.filter((s, l) => l < a && s.visible).length;
  return i.slice(0, o).reduce((s, l) => s + n + (l.height || 0), 0);
}, BR = (e, t) => (e.position || t).includes("top") ? 1 : -1, HR = {
  display: "flex",
  "align-items": "center",
  color: "#363636",
  background: "white",
  "box-shadow": "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
  "max-width": "350px",
  "pointer-events": "auto",
  padding: "8px 10px",
  "border-radius": "4px",
  "line-height": "1.3",
  "will-change": "transform"
}, WR = {
  display: "flex",
  "align-items": "center",
  flex: "1 1 auto",
  margin: "4px 10px",
  "white-space": "pre-line"
}, Hd = {
  "flex-shrink": 0,
  "min-width": "20px",
  "min-height": "20px",
  display: "flex",
  "align-items": "center",
  "justify-content": "center",
  "text-align": "center"
}, ec = (e) => ({
  calcMode: "spline",
  keyTimes: "0; 1",
  keySplines: e
}), [So, QR] = H(k7), GR = (e, t = "blank", r) => ({
  ...Ko,
  ...So().toastOptions,
  ...r,
  type: t,
  message: e,
  pauseDuration: 0,
  createdAt: Date.now(),
  visible: !0,
  id: r.id || zR(),
  paused: !1,
  style: {
    ...Ko.style,
    ...So().toastOptions?.style,
    ...r.style
  },
  duration: r.duration || So().toastOptions?.duration || FR[t],
  position: r.position || So().toastOptions?.position || So().position || Ko.position
}), fd = (e) => (t, r = {}) => Vo(() => {
  const n = ja.toasts.find((a) => a.id === r.id), i = GR(t, e, { ...n, duration: void 0, ...r });
  return Dn({ type: nr.UPSERT_TOAST, toast: i }), i.id;
}), ln = (e, t) => fd("blank")(e, t);
Re(() => ln);
ln.error = fd("error");
ln.success = fd("success");
ln.loading = fd("loading");
ln.custom = fd("custom");
ln.dismiss = (e) => {
  Dn({
    type: nr.DISMISS_TOAST,
    toastId: e
  });
};
ln.promise = (e, t, r) => {
  const n = ln.loading(t.loading, { ...r });
  return e.then((i) => (ln.success(Ju(t.success, i), {
    id: n,
    ...r
  }), i)).catch((i) => {
    ln.error(Ju(t.error, i), {
      id: n,
      ...r
    });
  }), e;
};
ln.remove = (e) => {
  Dn({
    type: nr.REMOVE_TOAST,
    toastId: e
  });
};
var YR = /* @__PURE__ */ x("<div><style>.sldt-active{z-index:9999;}.sldt-active>*{pointer-events:auto;}");
const KR = (e) => (me(() => {
  jR(e);
}), me(() => {
  const t = NR();
  xr(() => {
    t && t.forEach((r) => r && clearTimeout(r));
  });
}), (() => {
  var t = YR();
  return t.firstChild, S(t, b(kt, {
    get each() {
      return ja.toasts;
    },
    children: (r) => b(ez, {
      toast: r
    })
  }), null), J((r) => {
    var n = {
      ...RR,
      ...e.containerStyle
    }, i = e.containerClassName;
    return r.e = ci(t, n, r.e), i !== r.t && ot(t, r.t = i), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})());
var Wd = /* @__PURE__ */ x("<div>"), ZR = /* @__PURE__ */ x("<div><div>");
const XR = (e) => {
  let t;
  return me(() => {
    if (!t) return;
    const r = BR(e.toast, e.position);
    e.toast.visible ? t.animate([{
      transform: `translate3d(0,${r * -200}%,0) scale(.6)`,
      opacity: 0.5
    }, {
      transform: "translate3d(0,0,0) scale(1)",
      opacity: 1
    }], {
      duration: 350,
      fill: "forwards",
      easing: "cubic-bezier(.21,1.02,.73,1)"
    }) : t.animate([{
      transform: "translate3d(0,0,-1px) scale(1)",
      opacity: 1
    }, {
      transform: `translate3d(0,${r * -150}%,-1px) scale(.4)`,
      opacity: 0
    }], {
      duration: 400,
      fill: "forwards",
      easing: "cubic-bezier(.06,.71,.55,1)"
    });
  }), (() => {
    var r = ZR(), n = r.firstChild, i = t;
    return typeof i == "function" ? bn(i, r) : t = r, S(r, b(Ac, {
      get children() {
        return [b(vn, {
          get when() {
            return e.toast.icon;
          },
          get children() {
            var a = Wd();
            return S(a, () => e.toast.icon), J((o) => ci(a, Hd, o)), a;
          }
        }), b(vn, {
          get when() {
            return e.toast.type === "loading";
          },
          get children() {
            var a = Wd();
            return S(a, b(lz, Be(() => e.toast.iconTheme))), J((o) => ci(a, Hd, o)), a;
          }
        }), b(vn, {
          get when() {
            return e.toast.type === "success";
          },
          get children() {
            var a = Wd();
            return S(a, b(iz, Be(() => e.toast.iconTheme))), J((o) => ci(a, Hd, o)), a;
          }
        }), b(vn, {
          get when() {
            return e.toast.type === "error";
          },
          get children() {
            var a = Wd();
            return S(a, b(oz, Be(() => e.toast.iconTheme))), J((o) => ci(a, Hd, o)), a;
          }
        })];
      }
    }), n), yn(n, Be(() => e.toast.ariaProps), !1, !0), S(n, () => Ju(e.toast.message, e.toast)), J((a) => {
      var o = e.toast.className, s = {
        ...HR,
        ...e.toast.style
      }, l = WR;
      return o !== a.e && ot(r, a.e = o), a.t = ci(r, s, a.t), a.a = ci(n, l, a.a), a;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), r;
  })();
};
var JR = /* @__PURE__ */ x("<div>");
const ez = (e) => {
  const t = () => {
    const i = e.toast.position || Ko.position, a = qR(e.toast, i);
    return VR(i, a);
  }, r = L(() => t());
  let n;
  return Et(() => {
    n && UR(n, e.toast);
  }), (() => {
    var i = JR();
    i.addEventListener("mouseleave", () => Dn({
      type: nr.END_PAUSE,
      time: Date.now()
    })), i.addEventListener("mouseenter", () => Dn({
      type: nr.START_PAUSE,
      time: Date.now()
    }));
    var a = n;
    return typeof a == "function" ? bn(a, i) : n = i, S(i, (() => {
      var o = L(() => e.toast.type === "custom");
      return () => o() ? Ju(e.toast.message, e.toast) : b(XR, {
        get toast() {
          return e.toast;
        },
        get position() {
          return e.toast.position || Ko.position;
        }
      });
    })()), J((o) => {
      var s = r(), l = e.toast.visible ? "sldt-active" : "";
      return o.e = ci(i, s, o.e), l !== o.t && ot(i, o.t = l), o;
    }, {
      e: void 0,
      t: void 0
    }), i;
  })();
};
var tz = /* @__PURE__ */ x('<svg><circle cx=16 cy=16 r=0><animate attributeName=opacity values="0; 1; 1"></animate><animate attributeName=r values="0; 17.5; 16"></svg>', !1, !0, !1), rz = /* @__PURE__ */ x('<svg><circle cx=16 cy=16 r=12 opacity=0><animate attributeName=opacity values="1; 0"></animate><animate attributeName=r values="12; 26"></svg>', !1, !0, !1);
const _7 = (e) => {
  const t = {
    dur: "0.35s",
    begin: "100ms",
    fill: "freeze",
    calcMode: "spline",
    keyTimes: "0; 0.6; 1",
    keySplines: "0.25 0.71 0.4 0.88; .59 .22 .87 .63"
  };
  return (() => {
    var r = tz(), n = r.firstChild, i = n.nextSibling;
    return yn(n, t, !0, !1), yn(i, t, !0, !1), J(() => pt(r, "fill", e.fill)), r;
  })();
}, C7 = (e) => {
  const t = {
    dur: "1s",
    begin: e.begin || "320ms",
    fill: "freeze",
    ...ec("0.0 0.0 0.2 1")
  };
  return (() => {
    var r = rz(), n = r.firstChild, i = n.nextSibling;
    return yn(n, t, !0, !1), yn(i, t, !0, !1), J(() => pt(r, "fill", e.fill)), r;
  })();
};
var nz = /* @__PURE__ */ x('<svg viewBox="0 0 32 32"width=1.25rem height=1.25rem><path fill=none stroke-width=4 stroke-dasharray=22 stroke-dashoffset=22 stroke-linecap=round stroke-miterlimit=10 d=M9.8,17.2l3.8,3.6c0.1,0.1,0.3,0.1,0.4,0l9.6-9.7><animate attributeName=stroke-dashoffset values=22;0 dur=0.25s begin=250ms fill=freeze>');
const iz = (e) => {
  const t = e.primary || "#34C759";
  return (() => {
    var r = nz(), n = r.firstChild, i = n.firstChild;
    return r.style.setProperty("overflow", "visible"), S(r, b(_7, {
      fill: t
    }), n), S(r, b(C7, {
      fill: t,
      begin: "350ms"
    }), n), yn(i, Be(() => ec("0.0, 0.0, 0.58, 1.0")), !0, !1), J(() => pt(n, "stroke", e.secondary || "#FCFCFC")), r;
  })();
};
var az = /* @__PURE__ */ x('<svg viewBox="0 0 32 32"width=1.25rem height=1.25rem><path fill=none stroke-width=4 stroke-dasharray=9 stroke-dashoffset=9 stroke-linecap=round d=M16,7l0,9><animate attributeName=stroke-dashoffset values=9;0 dur=0.2s begin=250ms fill=freeze></animate></path><circle cx=16 cy=23 r=2.5 opacity=0><animate attributeName=opacity values=0;1 dur=0.25s begin=350ms fill=freeze>');
const oz = (e) => {
  const t = e.primary || "#FF3B30";
  return (() => {
    var r = az(), n = r.firstChild, i = n.firstChild, a = n.nextSibling, o = a.firstChild;
    return r.style.setProperty("overflow", "visible"), S(r, b(_7, {
      fill: t
    }), n), S(r, b(C7, {
      fill: t
    }), n), yn(i, Be(() => ec("0.0, 0.0, 0.58, 1.0")), !0, !1), yn(o, Be(() => ec("0.0, 0.0, 0.58, 1.0")), !0, !1), J((s) => {
      var l = e.secondary || "#FFFFFF", d = e.secondary || "#FFFFFF";
      return l !== s.e && pt(n, "stroke", s.e = l), d !== s.t && pt(a, "fill", s.t = d), s;
    }, {
      e: void 0,
      t: void 0
    }), r;
  })();
};
var sz = /* @__PURE__ */ x('<svg viewBox="0 0 32 32"width=1.25rem height=1.25rem><path fill=none stroke-width=4 stroke-miterlimit=10 d=M16,6c3,0,5.7,1.3,7.5,3.4c1.5,1.8,2.5,4,2.5,6.6c0,5.5-4.5,10-10,10S6,21.6,6,16S10.5,6,16,6z></path><path fill=none stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=M16,6c3,0,5.7,1.3,7.5,3.4c0.6,0.7,1.1,1.4,1.5,2.2><animateTransform attributeName=transform type=rotate from="0 16 16"to="360 16 16"dur=0.75s repeatCount=indefinite>');
const lz = (e) => (() => {
  var t = sz(), r = t.firstChild, n = r.nextSibling;
  return t.style.setProperty("overflow", "visible"), J((i) => {
    var a = e.primary || "#E5E7EB", o = e.secondary || "#4b5563";
    return a !== i.e && pt(r, "stroke", i.e = a), o !== i.t && pt(n, "stroke", i.t = o), i;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
var dz = /* @__PURE__ */ x("<div>"), uz = /* @__PURE__ */ x('<div><div></div><div></div><button type=button class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"><span class=sr-only>Close');
const ir = (e) => {
  ln.custom((t) => (() => {
    var r = uz(), n = r.firstChild, i = n.nextSibling, a = i.nextSibling;
    return a.firstChild, S(n, b(rt, {
      get name() {
        return e.status === "success" ? "checkCircle" : e.status === "error" ? "exclamationCircle" : "informationCircle";
      },
      class: "mr-2"
    })), S(i, b(X, {
      get when() {
        return e?.header;
      },
      get children() {
        return b(ke, {
          bold: !0,
          get children() {
            return e.header;
          }
        });
      }
    }), null), S(i, b(X, {
      get when() {
        return e.body;
      },
      get children() {
        var o = dz();
        return S(o, b(ke, {
          get children() {
            return e.body;
          }
        })), o;
      }
    }), null), a.$$click = () => ln.dismiss(t.id), S(a, b(rt, {
      name: "xMark",
      class: "h-6 w-6",
      "aria-hidden": "true"
    }), null), J((o) => {
      var s = `${t.visible ? "animate-enter" : "animate-leave"} flex gap-1 items-start border ${e.status === "success" ? "border-green-400" : e.status === "error" ? "border-red-400" : "border-blue-400"} border-2 rounded-lg p-4 bg-white w-full sm:max-w-md sm:w-auto`, l = e.status === "success" ? "text-green-500" : e.status === "error" ? "text-red-400" : "text-blue-500";
      return s !== o.e && ot(r, o.e = s), l !== o.t && ot(n, o.t = l), o;
    }, {
      e: void 0,
      t: void 0
    }), r;
  })(), {
    position: "top-right",
    unmountDelay: 3e3,
    ariaProps: {
      role: "status",
      "aria-live": "polite"
    }
  });
};
cn(["click"]);
var cz = /* @__PURE__ */ x('<div class="flex-shrink-0 mr-2">'), hz = /* @__PURE__ */ x("<button type=button title=Close>"), fz = /* @__PURE__ */ x('<div><div class="flex w-full">');
function ca(e) {
  const [t, r] = H(!0);
  Et(() => {
    sessionStorage.getItem(`banner-${e.id}`) === "closed" && r(!1);
  });
  const n = () => {
    r(!1), e.id && sessionStorage.setItem(`banner-${e.id}`, "closed");
  }, i = () => Zt("flex place-items-start justify-between gap-2 py-3 px-3 sm:px-4 rounded-lg", {
    "border-2 rounded border-solid": e.withBorder,
    "text-blue-600 bg-blue-50": e.status === "info",
    "border-blue-600": e.status === "info" && e.withBorder,
    "text-red-600 bg-red-50": e.status === "error",
    "border-red-600": e.status === "error" && e.withBorder,
    "text-green-600 bg-green-50": e.status === "success",
    "border-green-600": e.status === "success" && e.withBorder,
    "text-yellow-600 bg-yellow-50": e.status === "warning",
    "border-yellow-600": e.status === "warning" && e.withBorder,
    "text-slate-600 bg-slate-50": e.status === "suggestion",
    "border-slate-600": e.status === "suggestion" && e.withBorder
  }), a = () => Zt("", {
    "text-blue-600": e.status === "info",
    "text-red-600": e.status === "error",
    "text-green-600": e.status === "success",
    "text-yellow-600": e.status === "warning",
    "text-slate-600": e.status === "suggestion"
  });
  return b(X, {
    get when() {
      return t();
    },
    get children() {
      var o = fz(), s = o.firstChild;
      return S(s, b(X, {
        get when() {
          return !e.withoutIcon;
        },
        get children() {
          var l = cz();
          return S(l, b(rt, {
            get name() {
              return e.iconName ? e.iconName : "informationCircle";
            },
            get class() {
              return a();
            }
          })), l;
        }
      }), null), S(s, () => e.children, null), S(o, b(X, {
        get when() {
          return e.closable;
        },
        get children() {
          var l = hz();
          return l.$$click = n, S(l, b(rt, {
            name: "xMark",
            size: "sm"
          })), J(() => ot(l, "ml-auto " + a())), l;
        }
      }), null), J(() => ot(o, i())), o;
    }
  });
}
cn(["click"]);
var pz = /* @__PURE__ */ x('<div class="flex items-center justify-between">'), mz = /* @__PURE__ */ x('<div><form id=patient-address class=mt-4><div class="grid grid-cols-1 sm:gap-4 sm:grid-cols-2">');
const gz = B9({
  street1: _o().min(1, {
    message: "Street 1 is required"
  }),
  street2: _o().optional(),
  city: _o().min(1, {
    message: "City is required"
  }),
  state: _o().min(1, {
    message: "State is required"
  }),
  postalCode: _o().min(5, {
    message: "Postal code must be 5 digits"
  })
}), vz = Le`
  mutation UpdateAddress($id: ID!, $address: AddressInput) {
    updatePatient(id: $id, address: $address) {
      id
    }
  }
`;
function yz(e) {
  const [t, r] = H(!1), n = Ln(), i = async (s) => {
    await n.apollo.mutate({
      mutation: vz,
      variables: {
        id: e.patientId,
        address: s
      },
      update: () => {
        r(!1), ir({
          header: "Address Updated",
          body: "The patient address has been updated.",
          status: "success"
        }), e?.setAddress && e.setAddress(s);
      }
    });
  }, {
    form: a,
    errors: o
  } = R9({
    onSubmit: async (s) => {
      r(!0);
      try {
        i({
          country: "US",
          ...s
        });
      } catch {
        ir({
          header: "Error Updating Patient",
          body: "The patient address has not been updated.",
          status: "info"
        });
      }
    },
    extend: z9({
      schema: gz
    })
  });
  return b(hn, {
    addChildrenDivider: !0,
    get children() {
      return [(() => {
        var s = pz();
        return S(s, b(ke, {
          color: "gray",
          children: "Patient Address"
        }), null), S(s, b(st, {
          type: "submit",
          form: "patient-address",
          get disabled() {
            return t();
          },
          get loading() {
            return t();
          },
          children: "Save address"
        }), null), s;
      })(), (() => {
        var s = mz(), l = s.firstChild, d = l.firstChild;
        return S(s, b(ca, {
          status: "info",
          children: "Patient address is required to write a prescription"
        }), l), bn(a, l), S(l, b(wr, {
          label: "Address Line 1 *",
          subLabel: "Enter Street Number and Name",
          get error() {
            return o().street1;
          },
          get children() {
            return b(Mr, {
              type: "text",
              name: "street1"
            });
          }
        }), d), S(l, b(wr, {
          label: "Address Line 2",
          subLabel: "Enter Apt, Unit, or Suite",
          get children() {
            return b(Mr, {
              type: "text",
              name: "street2"
            });
          }
        }), d), S(l, b(wr, {
          label: "City *",
          get error() {
            return o().city;
          },
          get children() {
            return b(Mr, {
              type: "text",
              name: "city"
            });
          }
        }), d), S(d, b(wr, {
          label: "State *",
          get error() {
            return o().state;
          },
          get children() {
            return b(OR, {
              list: IF,
              selectMessage: "Select a State",
              name: "state"
            });
          }
        }), null), S(d, b(wr, {
          label: "Zip Code *",
          get error() {
            return o().postalCode;
          },
          get children() {
            return b(Mr, {
              type: "text",
              name: "postalCode"
            });
          }
        }), null), s;
      })()];
    }
  });
}
var bz = /* @__PURE__ */ x('<div><div class=flex><div class=flex-shrink-0></div><div class=ml-3><h3></h3><div><p class="text-sm mb-0">');
const U2 = (e) => {
  const t = L(() => {
    switch (e.type) {
      case "success":
        return "checkCircle";
      case "info":
        return "informationCircle";
      case "warning":
        return "exclamationTriangle";
      case "error":
        return "xCircle";
    }
  }), r = L(() => {
    switch (e.type) {
      case "success":
        return "text-green-800";
      case "info":
        return "text-blue-800";
      case "warning":
        return "text-yellow-800";
      case "error":
        return "text-red-800";
    }
  }), n = L(() => {
    switch (e.type) {
      case "success":
        return "bg-green-50";
      case "info":
        return "bg-blue-50";
      case "warning":
        return "bg-yellow-50";
      case "error":
        return "bg-red-50";
    }
  }), i = L(() => {
    switch (e.type) {
      case "success":
        return "border-green-200";
      case "info":
        return "border-blue-200";
      case "warning":
        return "border-yellow-200";
      case "error":
        return "border-red-200";
    }
  });
  return (() => {
    var a = bz(), o = a.firstChild, s = o.firstChild, l = s.nextSibling, d = l.firstChild, u = d.nextSibling, c = u.firstChild;
    return S(s, b(rt, {
      get name() {
        return t();
      },
      get class() {
        return r();
      }
    })), S(d, () => e.header), S(c, () => e.message), J((h) => {
      var f = `rounded-md ${n()} border-2 ${i()} p-4`, p = `text-base font-medium mt-0 ${r()}`, g = `mt-2 ${r()}`;
      return f !== h.e && ot(a, h.e = f), p !== h.t && ot(d, h.t = p), g !== h.a && ot(u, h.a = g), h;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), a;
  })();
}, $z = () => {
}, cm = (e, t) => t();
function wz(e, t) {
  const r = Re(e), n = r ? [r] : [], { onEnter: i = cm, onExit: a = cm } = t, [o, s] = H(t.appear ? [] : n), [l] = Ry();
  let d, u = !1;
  function c(p, g) {
    if (!p)
      return g && g();
    u = !0, a(p, () => {
      Mu(() => {
        u = !1, s((v) => v.filter((m) => m !== p)), g && g();
      });
    });
  }
  function h(p) {
    const g = d;
    if (!g)
      return p && p();
    d = void 0, s((v) => [g, ...v]), i(g, p ?? $z);
  }
  const f = t.mode === "out-in" ? (
    // exit -> enter
    // exit -> enter
    (p) => u || c(p, h)
  ) : t.mode === "in-out" ? (
    // enter -> exit
    // enter -> exit
    (p) => h(() => c(p))
  ) : (
    // exit & enter
    // exit & enter
    (p) => {
      c(p), h();
    }
  );
  return Kh((p) => {
    const g = e();
    return Re(l) ? (l(), p) : (g !== p && (d = g, Mu(() => Re(() => f(p)))), g);
  }, t.appear ? void 0 : r), o;
}
const hm = (e) => e instanceof Element;
function q2(e, t) {
  if (t(e))
    return e;
  if (typeof e == "function" && !e.length)
    return q2(e(), t);
  if (Array.isArray(e))
    for (const r of e) {
      const n = q2(r, t);
      if (n)
        return n;
    }
  return null;
}
function xz(e, t = hm, r = hm) {
  const n = L(e);
  return L(() => q2(n(), t));
}
function kz(e) {
  return L(() => {
    const t = e.name || "s";
    return {
      enterActive: (e.enterActiveClass || t + "-enter-active").split(" "),
      enter: (e.enterClass || t + "-enter").split(" "),
      enterTo: (e.enterToClass || t + "-enter-to").split(" "),
      exitActive: (e.exitActiveClass || t + "-exit-active").split(" "),
      exit: (e.exitClass || t + "-exit").split(" "),
      exitTo: (e.exitToClass || t + "-exit-to").split(" "),
      move: (e.moveClass || t + "-move").split(" ")
    };
  });
}
function S7(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
function _z(e, t, r, n) {
  const { onBeforeEnter: i, onEnter: a, onAfterEnter: o } = t;
  i?.(r), r.classList.add(...e.enter), r.classList.add(...e.enterActive), queueMicrotask(() => {
    if (!r.parentNode)
      return n?.();
    a?.(r, () => s());
  }), S7(() => {
    r.classList.remove(...e.enter), r.classList.add(...e.enterTo), (!a || a.length < 2) && (r.addEventListener("transitionend", s), r.addEventListener("animationend", s));
  });
  function s(l) {
    (!l || l.target === r) && (n?.(), r.removeEventListener("transitionend", s), r.removeEventListener("animationend", s), r.classList.remove(...e.enterActive), r.classList.remove(...e.enterTo), o?.(r));
  }
}
function Cz(e, t, r, n) {
  const { onBeforeExit: i, onExit: a, onAfterExit: o } = t;
  if (!r.parentNode)
    return n?.();
  i?.(r), r.classList.add(...e.exit), r.classList.add(...e.exitActive), a?.(r, () => s()), S7(() => {
    r.classList.remove(...e.exit), r.classList.add(...e.exitTo), (!a || a.length < 2) && (r.addEventListener("transitionend", s), r.addEventListener("animationend", s));
  });
  function s(l) {
    (!l || l.target === r) && (n?.(), r.removeEventListener("transitionend", s), r.removeEventListener("animationend", s), r.classList.remove(...e.exitActive), r.classList.remove(...e.exitTo), o?.(r));
  }
}
const Sz = {
  inout: "in-out",
  outin: "out-in"
}, fm = (e) => {
  const t = kz(e);
  return wz(xz(() => e.children), {
    mode: Sz[e.mode],
    appear: e.appear,
    onEnter(r, n) {
      _z(t(), e, r, n);
    },
    onExit(r, n) {
      Cz(t(), e, r, n);
    }
  });
}, Qd = (e, t) => (r, n) => {
  r.animate(e, t).finished.then(n);
};
var Ez = /* @__PURE__ */ x('<div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">'), Tz = /* @__PURE__ */ x('<div class="relative z-100">'), Az = /* @__PURE__ */ x('<div class="absolute right-0 top-0 pr-4 pt-4 sm:pr-6 sm:pt-6 sm:block"><button type=button class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"><span class=sr-only>Close'), Oz = /* @__PURE__ */ x('<div class="fixed inset-0 z-20 overflow-y-auto"><div><div>');
const Gd = 100;
function ao(e) {
  const t = Be({
    size: "md",
    open: !1,
    position: "center"
  }, e), r = L(() => Zt("relative transform rounded-lg bg-white p-4 text-left shadow-xl transition-all sm:my-8 w-full sm:p-6", {
    "sm:max-w-lg": t.size === "lg",
    "sm:max-w-sm": t.size === "md"
  }));
  return me(() => {
    const n = window?.zE;
    n && (t.open ? n("messenger", "hide") : n("messenger", "show"));
  }), (() => {
    var n = Tz();
    return S(n, b(fm, {
      get onEnter() {
        return Qd([{
          opacity: 0
        }, {
          opacity: 1
        }], {
          duration: Gd,
          easing: "ease-in"
        });
      },
      get onExit() {
        return Qd([{
          opacity: 1
        }, {
          opacity: 0
        }], {
          duration: Gd,
          easing: "ease-out"
        });
      },
      get children() {
        return b(X, {
          get when() {
            return t.open;
          },
          get children() {
            return Ez();
          }
        });
      }
    }), null), S(n, b(fm, {
      get onEnter() {
        return Qd([{
          opacity: 0,
          transform: "scale(0.95)"
        }, {
          opacity: 1,
          transform: "scale(1)"
        }], {
          duration: Gd,
          easing: "ease-in"
        });
      },
      get onExit() {
        return Qd([{
          opacity: 1,
          transform: "scale(1)"
        }, {
          opacity: 0,
          transform: "scale(0.95)"
        }], {
          duration: Gd,
          easing: "ease-out"
        });
      },
      get children() {
        return L(() => !!t.open)() && (() => {
          var i = Oz(), a = i.firstChild, o = a.firstChild;
          return S(o, b(X, {
            get when() {
              return t?.onClose;
            },
            get children() {
              var s = Az(), l = s.firstChild;
              return l.firstChild, P9(l, "click", t.onClose, !0), S(l, b(rt, {
                name: "xMark",
                class: "h-6 w-6",
                "aria-hidden": "true"
              }), null), s;
            }
          }), null), S(o, () => t.children, null), J((s) => {
            var l = Zt("flex min-h-full justify-center p-4 text-center sm:p-0", {
              "items-end": t.position === "bottom",
              "items-center": t.position === "center"
            }), d = r();
            return l !== s.e && ot(a, s.e = l), d !== s.t && ot(o, s.t = d), s;
          }, {
            e: void 0,
            t: void 0
          }), i;
        })();
      }
    }), null), n;
  })();
}
cn(["click"]);
const pm = ["mcg", "mg", "g"], mm = ["mL", "L"], gm = ["mcg/kg", "mg/kg", "g/kg"], B2 = (e) => 0.453592 * e, H2 = (e) => 2.20462 * e, E7 = (e) => e / 16, T7 = (e) => e / 1e3, vm = (e) => B2(E7(e)), ym = (e) => H2(T7(e)), bm = (e) => 1e3 * e, $m = (e) => 16 * e, Iz = {
  lb: {
    lb: (e) => e,
    kg: B2,
    oz: (e) => 16 * e,
    g: (e) => bm(B2(e))
  },
  kg: {
    lb: H2,
    kg: (e) => e,
    oz: (e) => $m(H2(e)),
    g: (e) => 1e3 * e
  },
  oz: {
    lb: E7,
    kg: vm,
    oz: (e) => e,
    g: (e) => bm(vm(e))
  },
  g: {
    lb: ym,
    kg: T7,
    oz: (e) => $m(ym(e)),
    g: (e) => e
  }
}, Pz = (e, t) => Iz[t.unit][e](t.value), Dz = {
  g: {
    g: (e) => e,
    mcg: (e) => e * 1e3 * 1e3,
    mg: (e) => e * 1e3
  },
  mg: {
    g: (e) => e / 1e3,
    mg: (e) => e,
    mcg: (e) => e * 1e3
  },
  mcg: {
    g: (e) => e / (1e3 * 1e3),
    mg: (e) => e / 1e3,
    mcg: (e) => e
  }
}, Mz = (e) => e.split("/")[0], Nz = (e, t) => Dz[t.unit][Mz(e)](t.value), Lz = (e) => {
  switch (e) {
    case "g/kg":
    case "mg/kg":
    case "mcg/kg":
      return "kg";
  }
}, Fz = (e, t) => e.value * Pz(Lz(e.unit), t), Rz = (e, t, r) => {
  const n = r.unit === "L" ? r.value * 1e3 : r.value;
  return e.value * n / Nz(e.unit, t);
};
function zz(e, t) {
  const r = (n) => {
    e?.contains(n.target) || t();
  };
  document.body.addEventListener("click", r), xr(() => document.body.removeEventListener("click", r));
}
var jz = /* @__PURE__ */ x("<div class=relative>"), Vz = /* @__PURE__ */ x("<ul role=listbox tabindex=-1>"), A7 = /* @__PURE__ */ x("<div>"), Uz = /* @__PURE__ */ x('<span class="absolute inset-y-0 right-0 flex items-center pr-4">'), qz = /* @__PURE__ */ x('<li role=option tabindex=-1><span class="block truncate">'), Bz = /* @__PURE__ */ x('<button class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"title="Input dropdown">');
const Yc = Tr([{
  open: !1,
  selected: {},
  active: "",
  typing: !1
}, {
  setOpen: () => {
  },
  setSelected: () => {
  },
  setActive: () => {
  },
  setTyping: () => {
  }
}]);
function Hz() {
  return cr(Yc);
}
function Lr(e) {
  const [t, r] = ua({
    open: !1,
    selected: {},
    active: "",
    typing: !1
  }), n = [t, {
    setOpen(i) {
      r("open", i);
    },
    setSelected(i) {
      (e.value?.id !== i?.id || e.value?.id === void 0) && e.setSelected(i);
    },
    setActive(i) {
      r("active", i);
    },
    setTyping(i) {
      r("typing", i);
    }
  }];
  return me(() => {
    e.value?.id !== t.selected?.id && r("selected", e.value);
  }), b(Yc.Provider, {
    value: n,
    get children() {
      var i = jz();
      return S(i, () => e.children), i;
    }
  });
}
function Wz(e) {
  const [t] = cr(Yc);
  let r;
  const n = L(() => {
    if (t.open && r?.getBoundingClientRect) {
      const a = r.getBoundingClientRect(), o = window.innerHeight - a.bottom, s = a.top;
      return o > s ? "bottom" : "top";
    }
    return "bottom";
  }), i = L(() => Zt("absolute z-10 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm", {
    "bottom-full mb-1": n() === "top",
    "top-full mt-1": n() === "bottom"
  }));
  return (() => {
    var a = A7(), o = r;
    return typeof o == "function" ? bn(o, a) : r = a, S(a, b(X, {
      get when() {
        return t.open;
      },
      get children() {
        var s = Vz();
        return S(s, () => e.children), J(() => ot(s, i())), s;
      }
    })), a;
  })();
}
function Qz(e) {
  const [t, {
    setSelected: r,
    setActive: n
  }] = cr(Yc), i = L(() => Zt("relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 cursor-pointer", {
    "bg-blue-600 text-white": t.active === e.key
  })), a = L(() => Zt(t.active === e.key ? "text-white" : "text-blue-600"));
  return (() => {
    var o = qz(), s = o.firstChild;
    return o.addEventListener("mouseenter", () => n(e.key)), o.$$click = () => r(e.value), S(s, () => e.children), S(o, b(X, {
      get when() {
        return t.selected?.id === e.key;
      },
      get children() {
        var l = Uz();
        return S(l, b(rt, {
          name: "checkCircle",
          get class() {
            return a();
          }
        })), l;
      }
    }), null), J(() => ot(o, i())), o;
  })();
}
function Gz(e) {
  const [t, {
    setOpen: r
  }] = Hz(), [n] = Cf(), [i, a] = Ua(e, ["onInput", "value"]), [o, s] = H("");
  let l;
  return Et(() => {
    zz(l, () => {
      r(!1);
    });
  }), me(() => {
    t.selected && s(e.displayValue(t.selected)), t.selected === void 0 && s("");
  }), me(() => {
    t.open || s(e.displayValue(t.selected) || "");
  }), [(() => {
    var d = A7(), u = l;
    return typeof u == "function" ? bn(u, d) : l = d, S(d, b(Mr, Be(a, {
      get "aria-label"() {
        return e.label;
      },
      get value() {
        return o() || "";
      },
      onClick: () => r(!t.open),
      onInput: (c) => {
        i?.onInput && i?.onInput(c), s(c.currentTarget.value), r(!0);
      },
      type: "text"
    }))), d;
  })(), (() => {
    var d = Bz();
    return d.$$click = () => r(!t.open), S(d, b(X, {
      get when() {
        return !n.loading && !e.loading;
      },
      get children() {
        return b(rt, {
          name: "chevronUpDown",
          class: "text-gray-400"
        });
      }
    })), d;
  })()];
}
Lr.Input = Gz;
Lr.Options = Wz;
Lr.Option = Qz;
cn(["click"]);
const Yz = (e) => e.map((t, r) => ({
  id: r.toString(),
  name: t
}));
function Zs(e) {
  const t = L(() => Yz(e.options)), r = L(() => e.selected ? e.options.indexOf(e.selected) : 0);
  return b(Lr, {
    get value() {
      return t()[r()];
    },
    setSelected: (n) => e.setSelected(n.name),
    get children() {
      return [b(Lr.Input, {
        displayValue: (n) => n.name
      }), b(Lr.Options, {
        get children() {
          return b(kt, {
            get each() {
              return t();
            },
            children: (n) => b(Lr.Option, {
              get key() {
                return n.id;
              },
              value: n,
              get children() {
                return n.name;
              }
            })
          });
        }
      })];
    }
  });
}
var Kz = /* @__PURE__ */ x('<div class="flex items-center"><h2>Calculate Dose Quantity'), Zz = /* @__PURE__ */ x("<p>Enter desired dosage and patient weight to calculate total and dose quantity."), Xz = /* @__PURE__ */ x('<div class=my-8><div class="flex items-center"><h3>Selected Medication</h3></div><p>'), Jz = /* @__PURE__ */ x('<div class="grid grid-cols-1 sm:grid-cols-2 gap-4"><div class="grid grid-cols-2 gap-4 sm:gap-2"></div><div class="flex gap-4 items-center"><div>per</div><div class=grow>'), ej = /* @__PURE__ */ x('<div class="grid grid-cols-1 sm:grid-cols-2 gap-4"><div class="grid grid-cols-2 gap-4 sm:gap-2">'), wm = /* @__PURE__ */ x('<div class="flex gap-4 sm:gap-2">'), tj = /* @__PURE__ */ x('<section class=mt-8><div class="flex items-center"><h3>Dosage Inputs</h3></div><div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">'), rj = /* @__PURE__ */ x('<section class=mt-8><div class="flex items-center"><h3>Frequency</h3></div><div class="grid grid-cols-2 gap-4">'), nj = /* @__PURE__ */ x('<section class=mt-8><div class="flex items-center"><h3>Dosage</h3></div><div class="grid grid-cols-2 gap-4"></div><hr class="h-px mb-4 bg-gray-200 border-0 dark:bg-gray-700 w-full"><div class="grid grid-cols-2 gap-4">'), ij = /* @__PURE__ */ x('<div class="mt-8 flex gap-4 justify-end">');
const po = (e) => parseFloat(e.toFixed(1)), xm = ["day", "dose"], km = ["lb", "kg"], aj = (e) => {
  switch (e?.toLowerCase()) {
    case "kg":
    case "kgs":
      return "kg";
    case "lb":
    case "lbs":
      return "lb";
    default:
      return;
  }
}, Yd = (e) => isNaN(e) || !isFinite(e) ? 0 : e;
function oj(e) {
  const [t, r] = H(0), [n, i] = H(gm[1]), [a, o] = H(xm[0]), [s, l] = H(0), [d, u] = H(km[0]), [c, h] = H(0), [f, p] = H(pm[1]), [g, v] = H(0), [m, $] = H(mm[0]), [w, k] = H(1), [C, E] = H(1);
  Et(() => {
    const G = aj(e.weightUnit);
    G ? (e.weight && l(e.weight), e.weightUnit && u(G)) : (l(0), u("lb"));
  });
  const N = L(() => d() ? Fz({
    unit: n(),
    value: t()
  }, {
    unit: d(),
    value: s()
  }) : 0), M = L(() => Rz({
    unit: n(),
    value: N()
  }, {
    unit: f(),
    value: c()
  }, {
    unit: m(),
    value: g()
  })), V = L(() => Yd(a() === "day" ? N() / C() : N())), q = L(() => Yd(V() * w() * C())), I = L(() => n().split("/")[0]), P = L(() => Yd(a() === "day" ? M() / C() : M())), z = L(() => Yd(P() * w() * C()));
  return b(ao, {
    get open() {
      return e.open;
    },
    get onClose() {
      return e.onClose;
    },
    size: "lg",
    get children() {
      return [(() => {
        var G = Kz(), se = G.firstChild;
        return S(G, b(rt, {
          name: "calculator",
          class: "mr-2"
        }), se), G;
      })(), Zz(), (() => {
        var G = Xz(), se = G.firstChild, ue = se.firstChild, de = se.nextSibling;
        return S(se, b(rt, {
          name: "pencilSquare",
          class: "mr-2"
        }), ue), S(de, () => e?.medicationName || "None Selected"), J(() => ot(de, e?.medicationName ? "" : "@apply text-gray-400")), G;
      })(), (() => {
        var G = tj(), se = G.firstChild, ue = se.firstChild, de = se.nextSibling;
        return S(se, b(rt, {
          name: "beaker",
          class: "mr-2"
        }), ue), S(G, b(wr, {
          label: "Dose",
          get children() {
            var D = Jz(), R = D.firstChild, Q = R.nextSibling, Z = Q.firstChild, F = Z.nextSibling;
            return S(R, b(Mr, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return t();
              },
              onInput: (oe) => r(oe.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (oe) => r(Math.max(oe.currentTarget?.valueAsNumber || 0, 0))
            }), null), S(R, b(Zs, {
              get selected() {
                return n();
              },
              setSelected: i,
              options: gm
            }), null), S(F, b(Zs, {
              get selected() {
                return a();
              },
              setSelected: o,
              options: xm
            })), D;
          }
        }), de), S(G, b(wr, {
          label: "Patient Weight",
          get children() {
            var D = ej(), R = D.firstChild;
            return S(R, b(Mr, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return s();
              },
              onInput: (Q) => l(Q.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (Q) => l(Math.max(Q.currentTarget?.valueAsNumber || 0, 0))
            }), null), S(R, b(Zs, {
              setSelected: u,
              options: km,
              get selected() {
                return d();
              }
            }), null), D;
          }
        }), de), S(de, b(wr, {
          label: "Liquid Concentration",
          get children() {
            var D = wm();
            return S(D, b(Mr, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return c();
              },
              onInput: (R) => h(R.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (R) => h(Math.max(R.currentTarget?.valueAsNumber || 0, 0))
            }), null), S(D, b(Zs, {
              get selected() {
                return f();
              },
              setSelected: p,
              options: pm
            }), null), D;
          }
        }), null), S(de, b(wr, {
          label: "Per Volume",
          get children() {
            var D = wm();
            return S(D, b(Mr, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return g();
              },
              onInput: (R) => v(R.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (R) => v(Math.max(R.currentTarget?.valueAsNumber || 0, 0))
            }), null), S(D, b(Zs, {
              get selected() {
                return m();
              },
              setSelected: $,
              options: mm
            }), null), D;
          }
        }), null), G;
      })(), (() => {
        var G = rj(), se = G.firstChild, ue = se.firstChild, de = se.nextSibling;
        return S(se, b(rt, {
          name: "clock",
          class: "mr-2"
        }), ue), S(de, b(wr, {
          label: "Duration in Days",
          get children() {
            return b(Mr, {
              type: "number",
              inputmode: "decimal",
              min: "1",
              get value() {
                return w();
              },
              onInput: (D) => k(D.currentTarget?.valueAsNumber),
              onFocusOut: (D) => k(Math.max(D.currentTarget?.valueAsNumber || 1, 1))
            });
          }
        }), null), S(de, b(wr, {
          label: "Doses per Day",
          get children() {
            return b(Mr, {
              type: "number",
              inputmode: "decimal",
              min: "1",
              get value() {
                return C();
              },
              onInput: (D) => E(D.currentTarget?.valueAsNumber),
              onFocusOut: (D) => E(Math.max(D.currentTarget?.valueAsNumber || 1, 1))
            });
          }
        }), null), G;
      })(), (() => {
        var G = nj(), se = G.firstChild, ue = se.firstChild, de = se.nextSibling, D = de.nextSibling, R = D.nextSibling;
        return S(se, b(rt, {
          name: "chartPie",
          class: "mr-2"
        }), ue), S(de, b(wr, {
          label: "Single Dose",
          get children() {
            return b(Mr, {
              type: "text",
              get value() {
                return `${po(V())} ${I()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), S(de, b(wr, {
          label: "Total Quantity",
          get children() {
            return b(Mr, {
              type: "text",
              get value() {
                return `${po(q())} ${I()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), S(R, b(wr, {
          label: "Single Liquid Dose",
          get children() {
            return b(Mr, {
              type: "text",
              get value() {
                return `${po(P())} ${m()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), S(R, b(wr, {
          label: "Total Liquid Quantity",
          get children() {
            return b(Mr, {
              type: "text",
              get value() {
                return `${po(z())} ${m()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), G;
      })(), (() => {
        var G = ij();
        return S(G, b(st, {
          variant: "secondary",
          get onClick() {
            return e.onClose;
          },
          children: "Cancel"
        }), null), S(G, b(st, {
          onClick: () => {
            e.setAutocompleteValues({
              days: w(),
              liquidDose: po(P()),
              totalLiquid: po(z()),
              unit: m()
            }), e.onClose();
          },
          get disabled() {
            return z() === 0;
          },
          children: "Autofill"
        }), null), G;
      })()];
    }
  });
}
function sj(e) {
  const t = ["00002015204", "00002024304", "00002121404", "00002134004", "00002200204", "00002142304"], r = ["000021423", "000021214", "000022002", "000020152", "000021340", "000020243"], n = ["00002246001", "00002246080", "00002250601", "00002250661", "00002250680", "00002247101", "00002247180", "00002245701", "00002245780", "00002249501", "00002249580", "00002248401", "00002248480"], i = ["000022457", "000022460", "000022484", "000022495", "000022506", "000022471"], a = e.treatment?.codes?.packageNDC?.replaceAll("-", ""), o = e.treatment?.codes?.productNDC?.replaceAll("-", "") || a?.substring(0, a?.length - 2);
  return !a || !o ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "no_advice"
  } : t.includes(a) ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "include",
    constraint_pharmacies: [{
      id: "phr_01J6APWHGNFJCE74SB031VYPHW",
      name: "LillyDirect Self Pay Pharmacy Solutions"
    }]
  } : r.includes(o) ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "no_routing"
  } : n.includes(a) || i.includes(o) ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "exclude",
    constraint_pharmacies: [{
      id: "phr_01J6APWHGNFJCE74SB031VYPHW",
      name: "LillyDirect Self Pay Pharmacy Solutions"
    }]
  } : {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "no_advice"
  };
}
function O7(e) {
  return !!(["include", "no_routing"].includes(e.routing_constraint_type) && e.prescriptions.length === 1);
}
function lj(e) {
  const t = /* @__PURE__ */ new Map();
  for (const r of e)
    O7(r) && t.set(r.prescriptions[0].id, r);
  return t;
}
const dj = {
  prescriptions: [],
  routing_constraint_type: "exclude",
  constraint_pharmacies: []
};
function _m(e) {
  return e.routing_constraint_type === "no_routing" ? {
    prescriptions: e.prescriptions,
    constraint_pharmacies: [],
    routing_constraint_type: "include"
  } : e.routing_constraint_type === "no_advice" ? {
    prescriptions: e.prescriptions,
    constraint_pharmacies: [],
    routing_constraint_type: "exclude"
  } : e;
}
function uj(e, t) {
  e = _m(e), t = _m(t);
  const r = (d) => {
    const u = d.constraint_pharmacies?.map((c) => c.id);
    return new Set(u);
  }, n = r(e), i = r(t), a = /* @__PURE__ */ new Map();
  for (const d of e?.constraint_pharmacies || [])
    a.set(d.id, d);
  for (const d of t?.constraint_pharmacies || [])
    a.set(d.id, d);
  const o = (d, u) => {
    const c = [];
    for (const h of Array.from(u))
      d.has(h) && c.push(a.get(h));
    return c;
  }, s = (d, u) => {
    const c = Array.from(d).map((h) => a.get(h));
    for (const h of Array.from(u))
      d.has(h) || c.push(a.get(h));
    return c;
  }, l = (d, u) => {
    const c = [];
    for (const h of Array.from(d))
      u.has(h) || c.push(a.get(h));
    return c;
  };
  return e.routing_constraint_type === "include" && t.routing_constraint_type === "include" ? {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: o(n, i),
    routing_constraint_type: "include"
  } : e.routing_constraint_type === "include" && t.routing_constraint_type === "exclude" ? {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: l(n, i),
    routing_constraint_type: "include"
  } : e.routing_constraint_type === "exclude" && t.routing_constraint_type === "include" ? {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: l(i, n),
    routing_constraint_type: "include"
  } : {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: s(n, i),
    routing_constraint_type: "exclude"
  };
}
function Cm(e, t = ["include", "exclude", "no_advice", "no_routing"]) {
  return e.reduce((r, n) => t.includes(n.routing_constraint_type) ? uj(r, n) : r, dj);
}
const cj = (e) => e <= 0 ? "error" : "warning", hj = (e, t) => {
  if (!e.constraint_pharmacies || t === 0)
    return "";
  const r = e.constraint_pharmacies.map((n) => n.name);
  return t === 1 ? r[0] : (r[t - 1] = `and ${r[t - 1]}`, t === 2 ? r.join(" ") : r.join(", "));
}, fj = (e, t, r) => r <= 0 ? `${e.treatment.name} cannot be filled at any pharmacies.` : `${e.treatment.name} can only be filled at ${hj(t, r)}.`, pj = (e) => {
  me(() => {
    if (!O7(e.routingConstraint))
      throw new Error("Cannot create a PrescriptionRoutingAlert for the given routing constraint.");
    if (e.routingConstraint.prescriptions[0].id !== e.prescription.id)
      throw new Error(`Prescription ID ${e.prescription.id} and the constraint's prescription ID ${e.routingConstraint.prescriptions[0].id} do not match.`);
  });
  const t = L(() => e.routingConstraint.routing_constraint_type === "no_routing" || !e.routingConstraint.constraint_pharmacies ? 0 : e.routingConstraint.constraint_pharmacies.length);
  return b(ca, {
    iconName: "exclamationTriangle",
    get status() {
      return cj(t());
    },
    withBorder: !0,
    get children() {
      return fj(e.prescription, e.routingConstraint, t());
    }
  });
}, mj = () => b(ca, {
  iconName: "exclamationTriangle",
  status: "warning",
  withBorder: !0,
  children: "One or more prescriptions in the order cannot be filled at this pharmacy."
}), I7 = Tr(), gj = (e) => {
  const [t, r] = H([]), n = {
    // values
    draftPrescriptions: t,
    // actions
    setDraftPrescriptions: r
  };
  return b(I7.Provider, {
    value: n,
    get children() {
      return e.children;
    }
  });
}, pd = () => {
  const e = cr(I7);
  if (!e)
    throw new Error("can't find DraftPrescriptionsContext");
  return e;
};
function tc(e) {
  "@babel/helpers - typeof";
  return tc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, tc(e);
}
function Ka(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function jr(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ii(e) {
  jr(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || tc(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function vj(e, t) {
  jr(2, arguments);
  var r = ii(e).getTime(), n = Ka(t);
  return new Date(r + n);
}
var yj = {};
function Kc() {
  return yj;
}
function bj(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function $j(e) {
  return jr(1, arguments), e instanceof Date || tc(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function wj(e) {
  if (jr(1, arguments), !$j(e) && typeof e != "number")
    return !1;
  var t = ii(e);
  return !isNaN(Number(t));
}
function xj(e, t) {
  jr(2, arguments);
  var r = Ka(t);
  return vj(e, -r);
}
var kj = 864e5;
function _j(e) {
  jr(1, arguments);
  var t = ii(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), i = r - n;
  return Math.floor(i / kj) + 1;
}
function rc(e) {
  jr(1, arguments);
  var t = 1, r = ii(e), n = r.getUTCDay(), i = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - i), r.setUTCHours(0, 0, 0, 0), r;
}
function P7(e) {
  jr(1, arguments);
  var t = ii(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var i = rc(n), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(r, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = rc(a);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function Cj(e) {
  jr(1, arguments);
  var t = P7(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = rc(r);
  return n;
}
var Sj = 6048e5;
function Ej(e) {
  jr(1, arguments);
  var t = ii(e), r = rc(t).getTime() - Cj(t).getTime();
  return Math.round(r / Sj) + 1;
}
function nc(e, t) {
  var r, n, i, a, o, s, l, d;
  jr(1, arguments);
  var u = Kc(), c = Ka((r = (n = (i = (a = t?.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : u.weekStartsOn) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(c >= 0 && c <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ii(e), f = h.getUTCDay(), p = (f < c ? 7 : 0) + f - c;
  return h.setUTCDate(h.getUTCDate() - p), h.setUTCHours(0, 0, 0, 0), h;
}
function D7(e, t) {
  var r, n, i, a, o, s, l, d;
  jr(1, arguments);
  var u = ii(e), c = u.getUTCFullYear(), h = Kc(), f = Ka((r = (n = (i = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : h.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = h.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(f >= 1 && f <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(c + 1, 0, f), p.setUTCHours(0, 0, 0, 0);
  var g = nc(p, t), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(c, 0, f), v.setUTCHours(0, 0, 0, 0);
  var m = nc(v, t);
  return u.getTime() >= g.getTime() ? c + 1 : u.getTime() >= m.getTime() ? c : c - 1;
}
function Tj(e, t) {
  var r, n, i, a, o, s, l, d;
  jr(1, arguments);
  var u = Kc(), c = Ka((r = (n = (i = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : u.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), h = D7(e, t), f = /* @__PURE__ */ new Date(0);
  f.setUTCFullYear(h, 0, c), f.setUTCHours(0, 0, 0, 0);
  var p = nc(f, t);
  return p;
}
var Aj = 6048e5;
function Oj(e, t) {
  jr(1, arguments);
  var r = ii(e), n = nc(r, t).getTime() - Tj(r, t).getTime();
  return Math.round(n / Aj) + 1;
}
function $t(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var Mi = {
  // Year
  y: function(e, t) {
    var r = e.getUTCFullYear(), n = r > 0 ? r : 1 - r;
    return $t(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M: function(e, t) {
    var r = e.getUTCMonth();
    return t === "M" ? String(r + 1) : $t(r + 1, 2);
  },
  // Day of the month
  d: function(e, t) {
    return $t(e.getUTCDate(), t.length);
  },
  // AM or PM
  a: function(e, t) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, t) {
    return $t(e.getUTCHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H: function(e, t) {
    return $t(e.getUTCHours(), t.length);
  },
  // Minute
  m: function(e, t) {
    return $t(e.getUTCMinutes(), t.length);
  },
  // Second
  s: function(e, t) {
    return $t(e.getUTCSeconds(), t.length);
  },
  // Fraction of second
  S: function(e, t) {
    var r = t.length, n = e.getUTCMilliseconds(), i = Math.floor(n * Math.pow(10, r - 3));
    return $t(i, t.length);
  }
}, mo = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ij = {
  // Era
  G: function(e, t, r) {
    var n = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(n, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(n, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      var n = e.getUTCFullYear(), i = n > 0 ? n : 1 - n;
      return r.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Mi.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    var i = D7(e, n), a = i > 0 ? i : 1 - i;
    if (t === "YY") {
      var o = a % 100;
      return $t(o, 2);
    }
    return t === "Yo" ? r.ordinalNumber(a, {
      unit: "year"
    }) : $t(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    var r = P7(e);
    return $t(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    var r = e.getUTCFullYear();
    return $t(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    var n = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return $t(n, 2);
      case "Qo":
        return r.ordinalNumber(n, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    var n = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return $t(n, 2);
      case "qo":
        return r.ordinalNumber(n, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    var n = e.getUTCMonth();
    switch (t) {
      case "M":
      case "MM":
        return Mi.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    var n = e.getUTCMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return $t(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    var i = Oj(e, n);
    return t === "wo" ? r.ordinalNumber(i, {
      unit: "week"
    }) : $t(i, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    var n = Ej(e);
    return t === "Io" ? r.ordinalNumber(n, {
      unit: "week"
    }) : $t(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Mi.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    var n = _j(e);
    return t === "Do" ? r.ordinalNumber(n, {
      unit: "dayOfYear"
    }) : $t(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    var n = e.getUTCDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    var i = e.getUTCDay(), a = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return $t(a, 2);
      case "eo":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    var i = e.getUTCDay(), a = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return $t(a, t.length);
      case "co":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    var n = e.getUTCDay(), i = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return $t(i, t.length);
      case "io":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    var n = e.getUTCHours(), i = n / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    var n = e.getUTCHours(), i;
    switch (n === 12 ? i = mo.noon : n === 0 ? i = mo.midnight : i = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    var n = e.getUTCHours(), i;
    switch (n >= 17 ? i = mo.evening : n >= 12 ? i = mo.afternoon : n >= 4 ? i = mo.morning : i = mo.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      var n = e.getUTCHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, {
        unit: "hour"
      });
    }
    return Mi.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Mi.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    var n = e.getUTCHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, {
      unit: "hour"
    }) : $t(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    var n = e.getUTCHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, {
      unit: "hour"
    }) : $t(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Mi.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Mi.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Mi.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r, n) {
    var i = n._originalDate || e, a = i.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (t) {
      case "X":
        return Em(a);
      case "XXXX":
      case "XX":
        return wa(a);
      case "XXXXX":
      case "XXX":
      default:
        return wa(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r, n) {
    var i = n._originalDate || e, a = i.getTimezoneOffset();
    switch (t) {
      case "x":
        return Em(a);
      case "xxxx":
      case "xx":
        return wa(a);
      case "xxxxx":
      case "xxx":
      default:
        return wa(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r, n) {
    var i = n._originalDate || e, a = i.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Sm(a, ":");
      case "OOOO":
      default:
        return "GMT" + wa(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r, n) {
    var i = n._originalDate || e, a = i.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Sm(a, ":");
      case "zzzz":
      default:
        return "GMT" + wa(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r, n) {
    var i = n._originalDate || e, a = Math.floor(i.getTime() / 1e3);
    return $t(a, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r, n) {
    var i = n._originalDate || e, a = i.getTime();
    return $t(a, t.length);
  }
};
function Sm(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.floor(n / 60), a = n % 60;
  if (a === 0)
    return r + String(i);
  var o = t;
  return r + String(i) + o + $t(a, 2);
}
function Em(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + $t(Math.abs(e) / 60, 2);
  }
  return wa(e, t);
}
function wa(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", i = Math.abs(e), a = $t(Math.floor(i / 60), 2), o = $t(i % 60, 2);
  return n + a + r + o;
}
var Tm = function(e, t) {
  switch (e) {
    case "P":
      return t.date({
        width: "short"
      });
    case "PP":
      return t.date({
        width: "medium"
      });
    case "PPP":
      return t.date({
        width: "long"
      });
    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}, M7 = function(e, t) {
  switch (e) {
    case "p":
      return t.time({
        width: "short"
      });
    case "pp":
      return t.time({
        width: "medium"
      });
    case "ppp":
      return t.time({
        width: "long"
      });
    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}, Pj = function(e, t) {
  var r = e.match(/(P+)(p+)?/) || [], n = r[1], i = r[2];
  if (!i)
    return Tm(e, t);
  var a;
  switch (n) {
    case "P":
      a = t.dateTime({
        width: "short"
      });
      break;
    case "PP":
      a = t.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      a = t.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      a = t.dateTime({
        width: "full"
      });
      break;
  }
  return a.replace("{{date}}", Tm(n, t)).replace("{{time}}", M7(i, t));
}, Dj = {
  p: M7,
  P: Pj
}, Mj = ["D", "DD"], Nj = ["YY", "YYYY"];
function Lj(e) {
  return Mj.indexOf(e) !== -1;
}
function Fj(e) {
  return Nj.indexOf(e) !== -1;
}
function Am(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Rj = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, zj = function(e, t, r) {
  var n, i = Rj[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function i1(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var jj = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Vj = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Uj = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, qj = {
  date: i1({
    formats: jj,
    defaultWidth: "full"
  }),
  time: i1({
    formats: Vj,
    defaultWidth: "full"
  }),
  dateTime: i1({
    formats: Uj,
    defaultWidth: "full"
  })
}, Bj = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Hj = function(e, t, r, n) {
  return Bj[e];
};
function Xs(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", i;
    if (n === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : a;
      i = e.formattingValues[o] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth, l = r != null && r.width ? String(r.width) : e.defaultWidth;
      i = e.values[l] || e.values[s];
    }
    var d = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[d];
  };
}
var Wj = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Qj = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Gj = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Yj = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Kj = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Zj = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Xj = function(e, t) {
  var r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Jj = {
  ordinalNumber: Xj,
  era: Xs({
    values: Wj,
    defaultWidth: "wide"
  }),
  quarter: Xs({
    values: Qj,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Xs({
    values: Gj,
    defaultWidth: "wide"
  }),
  day: Xs({
    values: Yj,
    defaultWidth: "wide"
  }),
  dayPeriod: Xs({
    values: Kj,
    defaultWidth: "wide",
    formattingValues: Zj,
    defaultFormattingWidth: "wide"
  })
};
function Js(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    var o = a[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? tV(s, function(c) {
      return c.test(o);
    }) : eV(s, function(c) {
      return c.test(o);
    }), d;
    d = e.valueCallback ? e.valueCallback(l) : l, d = r.valueCallback ? r.valueCallback(d) : d;
    var u = t.slice(o.length);
    return {
      value: d,
      rest: u
    };
  };
}
function eV(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function tV(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function rV(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n) return null;
    var i = n[0], a = t.match(e.parsePattern);
    if (!a) return null;
    var o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var s = t.slice(i.length);
    return {
      value: o,
      rest: s
    };
  };
}
var nV = /^(\d+)(th|st|nd|rd)?/i, iV = /\d+/i, aV = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, oV = {
  any: [/^b/i, /^(a|c)/i]
}, sV = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, lV = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, dV = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, uV = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, cV = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, hV = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, fV = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, pV = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, mV = {
  ordinalNumber: rV({
    matchPattern: nV,
    parsePattern: iV,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Js({
    matchPatterns: aV,
    defaultMatchWidth: "wide",
    parsePatterns: oV,
    defaultParseWidth: "any"
  }),
  quarter: Js({
    matchPatterns: sV,
    defaultMatchWidth: "wide",
    parsePatterns: lV,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Js({
    matchPatterns: dV,
    defaultMatchWidth: "wide",
    parsePatterns: uV,
    defaultParseWidth: "any"
  }),
  day: Js({
    matchPatterns: cV,
    defaultMatchWidth: "wide",
    parsePatterns: hV,
    defaultParseWidth: "any"
  }),
  dayPeriod: Js({
    matchPatterns: fV,
    defaultMatchWidth: "any",
    parsePatterns: pV,
    defaultParseWidth: "any"
  })
}, gV = {
  code: "en-US",
  formatDistance: zj,
  formatLong: qj,
  formatRelative: Hj,
  localize: Jj,
  match: mV,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, vV = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, yV = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, bV = /^'([^]*?)'?$/, $V = /''/g, wV = /[a-zA-Z]/;
function If(e, t, r) {
  var n, i, a, o, s, l, d, u, c, h, f, p, g, v;
  jr(2, arguments);
  var m = String(t), $ = Kc(), w = (n = (i = void 0) !== null && i !== void 0 ? i : $.locale) !== null && n !== void 0 ? n : gV, k = Ka((a = (o = (s = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && s !== void 0 ? s : $.firstWeekContainsDate) !== null && o !== void 0 ? o : (d = $.locale) === null || d === void 0 || (u = d.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(k >= 1 && k <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var C = Ka((c = (h = (f = (p = void 0) !== null && p !== void 0 ? p : void 0) !== null && f !== void 0 ? f : $.weekStartsOn) !== null && h !== void 0 ? h : (g = $.locale) === null || g === void 0 || (v = g.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && c !== void 0 ? c : 0);
  if (!(C >= 0 && C <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!w.localize)
    throw new RangeError("locale must contain localize property");
  if (!w.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var E = ii(e);
  if (!wj(E))
    throw new RangeError("Invalid time value");
  var N = bj(E), M = xj(E, N), V = {
    firstWeekContainsDate: k,
    weekStartsOn: C,
    locale: w,
    _originalDate: E
  }, q = m.match(yV).map(function(I) {
    var P = I[0];
    if (P === "p" || P === "P") {
      var z = Dj[P];
      return z(I, w.formatLong);
    }
    return I;
  }).join("").match(vV).map(function(I) {
    if (I === "''")
      return "'";
    var P = I[0];
    if (P === "'")
      return xV(I);
    var z = Ij[P];
    if (z)
      return Fj(I) && Am(I, t, String(e)), Lj(I) && Am(I, t, String(e)), z(M, I, w.localize, V);
    if (P.match(wV))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + P + "`");
    return I;
  }).join("");
  return q;
}
function xV(e) {
  var t = e.match(bV);
  return t ? t[1].replace($V, "'") : e;
}
const kV = Le`
  mutation CreatePrescriptionTemplate(
    $catalogId: ID!
    $name: String
    $treatmentId: ID!
    $dispenseAsWritten: Boolean
    $dispenseQuantity: Float
    $dispenseUnit: String
    $refillsAllowed: Int
    $fillsAllowed: Int
    $daysSupply: Int
    $instructions: String
    $notes: String
    $isPrivate: Boolean
  ) {
    createPrescriptionTemplate(
      catalogId: $catalogId
      name: $name
      treatmentId: $treatmentId
      dispenseAsWritten: $dispenseAsWritten
      dispenseQuantity: $dispenseQuantity
      dispenseUnit: $dispenseUnit
      refillsAllowed: $refillsAllowed
      fillsAllowed: $fillsAllowed
      daysSupply: $daysSupply
      instructions: $instructions
      notes: $notes
      isPrivate: $isPrivate
    ) {
      id
    }
  }
`, _V = Le`
  mutation CreatePrescription(
    $externalId: ID
    $patientId: ID!
    $treatmentId: ID!
    $dispenseAsWritten: Boolean
    $dispenseQuantity: Float!
    $dispenseUnit: String!
    $refillsAllowed: Int
    $fillsAllowed: Int
    $daysSupply: Int
    $instructions: String!
    $notes: String
    $effectiveDate: AWSDate
    $diagnoses: [ID]
  ) {
    createPrescription(
      externalId: $externalId
      patientId: $patientId
      treatmentId: $treatmentId
      dispenseAsWritten: $dispenseAsWritten
      dispenseQuantity: $dispenseQuantity
      dispenseUnit: $dispenseUnit
      refillsAllowed: $refillsAllowed #todo: remove this?
      fillsAllowed: $fillsAllowed
      daysSupply: $daysSupply
      instructions: $instructions
      notes: $notes
      effectiveDate: $effectiveDate
      diagnoses: $diagnoses
    ) {
      id
      externalId
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      fillsAllowed
      daysSupply
      instructions
      notes
      effectiveDate
      diagnoses {
        code
      }
      treatment {
        id
        name
        codes {
          packageNDC
          productNDC
        }
      }
    }
  }
`, CV = Le`
  mutation CreatePrescriptions($prescriptions: [PrescriptionInput]!) {
    createPrescriptions(prescriptions: $prescriptions) {
      id
      externalId
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      fillsAllowed
      daysSupply
      instructions
      notes
      effectiveDate
      diagnoses {
        code
      }
      treatment {
        id
        name
        codes {
          packageNDC
          productNDC
        }
      }
    }
  }
`, SV = Le`
  mutation UpdatePrescriptionStates($input: UpdatePrescriptionStatesInput!) {
    updatePrescriptionStates(input: $input)
  }
`, EV = Le`
  mutation GenerateCoverageOptions($pharmacyId: ID!, $prescriptions: [CoverageRxInput!]!) {
    generateCoverageOptions(pharmacyId: $pharmacyId, prescriptions: $prescriptions) {
      id
      prescriptionId
      isAlternative
      status
      statusMessage
      paRequired
      price
      daysSupply
      dispenseQuantity
      dispenseUnit
      treatment {
        id
        name
      }
      pharmacy {
        id
        name
      }
      alerts {
        label
        text
      }
    }
  }
`;
var a1 = "Invariant Violation", Om = Object.setPrototypeOf, TV = Om === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : Om, N7 = (
  /** @class */
  function(e) {
    ld(t, e);
    function t(r) {
      r === void 0 && (r = a1);
      var n = e.call(this, typeof r == "number" ? a1 + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = a1, TV(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function Oa(e, t) {
  if (!e)
    throw new N7(t);
}
var L7 = ["debug", "log", "warn", "error", "silent"], AV = L7.indexOf("log");
function Kd(e) {
  return function() {
    if (L7.indexOf(e) >= AV) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = Kd("debug"), e.log = Kd("log"), e.warn = Kd("warn"), e.error = Kd("error");
})(Oa || (Oa = {}));
var Pf = "3.13.5";
function Cn(e) {
  try {
    return e();
  } catch {
  }
}
const W2 = Cn(function() {
  return globalThis;
}) || Cn(function() {
  return window;
}) || Cn(function() {
  return self;
}) || Cn(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Cn(function() {
  return Cn.constructor("return this")();
});
var Im = /* @__PURE__ */ new Map();
function Q2(e) {
  var t = Im.get(e) || 1;
  return Im.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function OV(e, t) {
  var r = Q2("stringifyForDisplay");
  return JSON.stringify(e, function(n, i) {
    return i === void 0 ? r : i;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function Zd(e) {
  return function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (typeof t == "number") {
      var i = t;
      t = Df(i), t || (t = Mf(i, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var Ne = Object.assign(function(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  e || Oa(e, Df(t, r) || Mf(t, r));
}, {
  debug: Zd(Oa.debug),
  log: Zd(Oa.log),
  warn: Zd(Oa.warn),
  error: Zd(Oa.error)
});
function ei(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new N7(Df(e, t) || Mf(e, t));
}
var Pm = Symbol.for("ApolloErrorMessageHandler_" + Pf);
function F7(e) {
  if (typeof e == "string")
    return e;
  try {
    return OV(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function Df(e, t) {
  if (t === void 0 && (t = []), !!e)
    return W2[Pm] && W2[Pm](e, t.map(F7));
}
function Mf(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: Pf,
      message: e,
      args: t.map(F7)
    })));
}
function R7(e, t) {
  var r = e.directives;
  return !r || !r.length ? !0 : DV(r).every(function(n) {
    var i = n.directive, a = n.ifArgument, o = !1;
    return a.value.kind === "Variable" ? (o = t && t[a.value.name.value], Ne(o !== void 0, 78, i.name.value)) : o = a.value.value, i.name.value === "skip" ? !o : o;
  });
}
function Yl(e, t, r) {
  var n = new Set(e), i = n.size;
  return Pn(t, {
    Directive: function(a) {
      if (n.delete(a.name.value) && (!r || !n.size))
        return Bc;
    }
  }), r ? !n.size : n.size < i;
}
function IV(e) {
  return e && Yl(["client", "export"], e, !0);
}
function PV(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function DV(e) {
  var t = [];
  return e && e.length && e.forEach(function(r) {
    if (PV(r)) {
      var n = r.arguments, i = r.name.value;
      Ne(n && n.length === 1, 79, i);
      var a = n[0];
      Ne(a.name && a.name.value === "if", 80, i);
      var o = a.value;
      Ne(o && (o.kind === "Variable" || o.kind === "BooleanValue"), 81, i), t.push({ directive: r, ifArgument: a });
    }
  }), t;
}
function MV(e) {
  var t, r, n = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(a) {
    var o = a.name;
    return o.value === "unmask";
  });
  if (!n)
    return "mask";
  var i = (r = n.arguments) === null || r === void 0 ? void 0 : r.find(function(a) {
    var o = a.name;
    return o.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === $e.VARIABLE ? globalThis.__DEV__ !== !1 && Ne.warn(82) : i.value.kind !== $e.STRING ? globalThis.__DEV__ !== !1 && Ne.warn(83) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && Ne.warn(84, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const NV = () => /* @__PURE__ */ Object.create(null), { forEach: LV, slice: Dm } = Array.prototype, { hasOwnProperty: FV } = Object.prototype;
class md {
  constructor(t = !0, r = NV) {
    this.weakness = t, this.makeData = r;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let r = this;
    return LV.call(t, (n) => r = r.getChildTrie(n)), FV.call(r, "data") ? r.data : r.data = this.makeData(Dm.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let r = this;
    for (let n = 0, i = t.length; r && n < i; ++n) {
      const a = r.mapFor(t[n], !1);
      r = a && a.get(t[n]);
    }
    return r && r.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let r;
    if (t.length) {
      const n = t[0], i = this.mapFor(n, !1), a = i && i.get(n);
      a && (r = a.removeArray(Dm.call(t, 1)), !a.data && !a.weak && !(a.strong && a.strong.size) && i.delete(n));
    } else
      r = this.data, delete this.data;
    return r;
  }
  getChildTrie(t) {
    const r = this.mapFor(t, !0);
    let n = r.get(t);
    return n || r.set(t, n = new md(this.weakness, this.makeData)), n;
  }
  mapFor(t, r) {
    return this.weakness && RV(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function RV(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
var zV = Cn(function() {
  return navigator.product;
}) == "ReactNative", Nf = typeof WeakMap == "function" && !(zV && !global.HermesInternal), z7 = typeof WeakSet == "function", j7 = typeof Symbol == "function" && typeof Symbol.for == "function", Zc = j7 && Symbol.asyncIterator;
Cn(function() {
  return window.document.createElement;
});
Cn(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function Qn(e) {
  return e !== null && typeof e == "object";
}
function gd(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(r) {
    t[r.name.value] = r;
  }), t;
}
function jV(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var r = e.name.value;
      if (typeof t == "function")
        return t(r);
      var n = t && t[r];
      return Ne(n, 87, r), n || null;
    }
    default:
      return null;
  }
}
function VV(e) {
  var t = !0;
  return Pn(e, {
    FragmentSpread: function(r) {
      if (t = !!r.directives && r.directives.some(function(n) {
        return n.name.value === "unmask";
      }), !t)
        return Bc;
    }
  }), t;
}
function UV() {
}
class G2 {
  constructor(t = 1 / 0, r = UV) {
    this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
  }
}
function Y2() {
}
const qV = Y2, BV = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, HV = typeof WeakMap < "u" ? WeakMap : Map, WV = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: Y2,
    unregister: Y2
  };
}, QV = 10024;
class K2 {
  constructor(t = 1 / 0, r = qV) {
    this.max = t, this.dispose = r, this.map = new HV(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let i = 0; i < QV; i++) {
        const a = n.next().value;
        if (!a)
          break;
        this.unfinalizedNodes.delete(a);
        const o = a.key;
        delete a.key, a.keyRef = new BV(o), this.registry.register(o, a, a);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new WV(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const r = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (this.deleteNode(r), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var o1 = /* @__PURE__ */ new WeakSet();
function V7(e) {
  e.size <= (e.max || -1) || o1.has(e) || (o1.add(e), setTimeout(function() {
    e.clean(), o1.delete(e);
  }, 100));
}
var U7 = function(e, t) {
  var r = new K2(e, t);
  return r.set = function(n, i) {
    var a = K2.prototype.set.call(this, n, i);
    return V7(this), a;
  }, r;
}, GV = function(e, t) {
  var r = new G2(e, t);
  return r.set = function(n, i) {
    var a = G2.prototype.set.call(this, n, i);
    return V7(this), a;
  }, r;
}, YV = Symbol.for("apollo.cacheSize"), vd = ae({}, W2[YV]), xa = {};
function q7(e, t) {
  xa[e] = t;
}
var KV = globalThis.__DEV__ !== !1 ? XV : void 0;
function ZV() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var r = t[0], n = t[1];
    return [
      r,
      vd[r] || n
    ];
  }));
}
function XV() {
  var e, t, r, n, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: ZV(),
    sizes: ae({ print: (e = xa.print) === null || e === void 0 ? void 0 : e.call(xa), parser: (t = xa.parser) === null || t === void 0 ? void 0 : t.call(xa), canonicalStringify: (r = xa.canonicalStringify) === null || r === void 0 ? void 0 : r.call(xa), links: X2(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: tU(this.queryManager.documentTransform)
    } }, (i = (n = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(n))
  };
}
function JV(e) {
  return !!e && "dirtyKey" in e;
}
function eU(e) {
  return JV(e) ? e.size : void 0;
}
function B7(e) {
  return e != null;
}
function tU(e) {
  return Z2(e).map(function(t) {
    return { cache: t };
  });
}
function Z2(e) {
  return e ? Fr(Fr([
    eU(e?.performWork)
  ], Z2(e?.left), !0), Z2(e?.right), !0).filter(B7) : [];
}
function X2(e) {
  var t;
  return e ? Fr(Fr([
    (t = e?.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], X2(e?.left), !0), X2(e?.right), !0).filter(B7) : [];
}
var Lf = Object.assign(function(e) {
  return JSON.stringify(e, rU);
}, {
  reset: function() {
    Lo = new GV(
      vd.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && q7("canonicalStringify", function() {
  return Lo.size;
});
var Lo;
Lf.reset();
function rU(e, t) {
  if (t && typeof t == "object") {
    var r = Object.getPrototypeOf(t);
    if (r === Object.prototype || r === null) {
      var n = Object.keys(t);
      if (n.every(nU))
        return t;
      var i = JSON.stringify(n), a = Lo.get(i);
      if (!a) {
        n.sort();
        var o = JSON.stringify(n);
        a = Lo.get(o) || n, Lo.set(i, a), Lo.set(o, a);
      }
      var s = Object.create(r);
      return a.forEach(function(l) {
        s[l] = t[l];
      }), s;
    }
  }
  return t;
}
function nU(e, t, r) {
  return t === 0 || r[t - 1] <= e;
}
function iU(e) {
  return Qn(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function aU(e) {
  return e.kind === "StringValue";
}
function oU(e) {
  return e.kind === "BooleanValue";
}
function sU(e) {
  return e.kind === "IntValue";
}
function lU(e) {
  return e.kind === "FloatValue";
}
function dU(e) {
  return e.kind === "Variable";
}
function uU(e) {
  return e.kind === "ObjectValue";
}
function cU(e) {
  return e.kind === "ListValue";
}
function hU(e) {
  return e.kind === "EnumValue";
}
function fU(e) {
  return e.kind === "NullValue";
}
function ic(e, t, r, n) {
  if (sU(r) || lU(r))
    e[t.value] = Number(r.value);
  else if (oU(r) || aU(r))
    e[t.value] = r.value;
  else if (uU(r)) {
    var i = {};
    r.fields.map(function(o) {
      return ic(i, o.name, o.value, n);
    }), e[t.value] = i;
  } else if (dU(r)) {
    var a = (n || {})[r.name.value];
    e[t.value] = a;
  } else if (cU(r))
    e[t.value] = r.values.map(function(o) {
      var s = {};
      return ic(s, t, o, n), s[t.value];
    });
  else if (hU(r))
    e[t.value] = r.value;
  else if (fU(r))
    e[t.value] = null;
  else
    throw ei(96, t.value, r.kind);
}
var pU = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], el = Lf;
Object.assign(function(e, t, r) {
  if (t && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var n = r.connection.filter ? r.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(r.connection.key, "(").concat(el(i), ")");
    } else
      return r.connection.key;
  var a = e;
  if (t) {
    var o = el(t);
    a += "(".concat(o, ")");
  }
  return r && Object.keys(r).forEach(function(s) {
    pU.indexOf(s) === -1 && (r[s] && Object.keys(r[s]).length ? a += "@".concat(s, "(").concat(el(r[s]), ")") : a += "@".concat(s));
  }), a;
}, {
  setStringify: function(e) {
    var t = el;
    return el = e, t;
  }
});
function mU(e, t) {
  if (e.arguments && e.arguments.length) {
    var r = {};
    return e.arguments.forEach(function(n) {
      var i = n.name, a = n.value;
      return ic(r, i, a, t);
    }), r;
  }
  return null;
}
function ac(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function oc(e) {
  return e.kind === "Field";
}
function gU(e) {
  return e.kind === "InlineFragment";
}
function Is(e) {
  Ne(e && e.kind === "Document", 88);
  var t = e.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw ei(89, r.kind);
    return r;
  });
  return Ne(t.length <= 1, 90, t.length), e;
}
function hs(e) {
  return Is(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function wl(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function yd(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function vU(e) {
  var t = hs(e);
  return Ne(t && t.operation === "query", 91), t;
}
function yU(e) {
  Ne(e.kind === "Document", 92), Ne(e.definitions.length <= 1, 93);
  var t = e.definitions[0];
  return Ne(t.kind === "FragmentDefinition", 94), t;
}
function Xc(e) {
  Is(e);
  for (var t, r = 0, n = e.definitions; r < n.length; r++) {
    var i = n[r];
    if (i.kind === "OperationDefinition") {
      var a = i.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw ei(95);
}
function bU(e) {
  var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
  return r && r.length && r.forEach(function(n) {
    n.defaultValue && ic(t, n.variable.name, n.defaultValue);
  }), t;
}
let br = null;
const Mm = {};
let $U = 1;
const wU = () => class {
  constructor() {
    this.id = [
      "slot",
      $U++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = br; e; e = e.parent)
      if (this.id in e.slots) {
        const t = e.slots[this.id];
        if (t === Mm)
          break;
        return e !== br && (br.slots[this.id] = t), !0;
      }
    return br && (br.slots[this.id] = Mm), !1;
  }
  getValue() {
    if (this.hasValue())
      return br.slots[this.id];
  }
  withValue(e, t, r, n) {
    const i = {
      __proto__: null,
      [this.id]: e
    }, a = br;
    br = { parent: a, slots: i };
    try {
      return t.apply(n, r);
    } finally {
      br = a;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const t = br;
    return function() {
      const r = br;
      try {
        return br = t, e.apply(this, arguments);
      } finally {
        br = r;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, t, r) {
    if (br) {
      const n = br;
      try {
        return br = null, e.apply(r, t);
      } finally {
        br = n;
      }
    } else
      return e.apply(r, t);
  }
};
function Nm(e) {
  try {
    return e();
  } catch {
  }
}
const s1 = "@wry/context:Slot", xU = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  Nm(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  Nm(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), Lm = xU, Jc = Lm[s1] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[s1] || function(e) {
  try {
    Object.defineProperty(Lm, s1, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
}(wU()), { bind: jae, noContext: Vae } = Jc, Ff = new Jc(), H7 = Array.from || function(e) {
  const t = [];
  return e.forEach((r) => t.push(r)), t;
};
function W7(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const Kl = [], kU = 100;
function fs(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function Q7(e, t) {
  const r = e.length;
  return (
    // Unknown values are not equal to each other.
    r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    r === t.length && // The underlying value or exception must be the same.
    e[r - 1] === t[r - 1]
  );
}
function G7(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function Y7(e) {
  return e.slice(0);
}
class e0 {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++e0.count;
  }
  peek() {
    if (this.value.length === 1 && !ra(this))
      return Fm(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return fs(!this.recomputing, "already recomputing"), Fm(this), ra(this) ? _U(this, t) : G7(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, K7(this), W7(this));
  }
  dispose() {
    this.setDirty(), t6(this), Rf(this, (t, r) => {
      t.setDirty(), r6(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = Kl.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (H7(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), Kl.push(this.deps), this.deps = null);
  }
}
e0.count = 0;
function Fm(e) {
  const t = Ff.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), ra(e) ? X7(t, e) : J7(t, e), t;
}
function _U(e, t) {
  return t6(e), Ff.withValue(e, CU, [e, t]), EU(e, t) && SU(e), G7(e.value);
}
function CU(e, t) {
  e.recomputing = !0;
  const { normalizeResult: r } = e;
  let n;
  r && e.value.length === 1 && (n = Y7(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), r && n && !Q7(n, e.value))
      try {
        e.value[0] = r(e.value[0], n[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function ra(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function SU(e) {
  e.dirty = !1, !ra(e) && Z7(e);
}
function K7(e) {
  Rf(e, X7);
}
function Z7(e) {
  Rf(e, J7);
}
function Rf(e, t) {
  const r = e.parents.size;
  if (r) {
    const n = H7(e.parents);
    for (let i = 0; i < r; ++i)
      t(n[i], e);
  }
}
function X7(e, t) {
  fs(e.childValues.has(t)), fs(ra(t));
  const r = !ra(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = Kl.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), r && K7(e);
}
function J7(e, t) {
  fs(e.childValues.has(t)), fs(!ra(t));
  const r = e.childValues.get(t);
  r.length === 0 ? e.childValues.set(t, Y7(t.value)) : Q7(r, t.value) || e.setDirty(), e6(e, t), !ra(e) && Z7(e);
}
function e6(e, t) {
  const r = e.dirtyChildren;
  r && (r.delete(t), r.size === 0 && (Kl.length < kU && Kl.push(r), e.dirtyChildren = null));
}
function t6(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, r) => {
    r6(e, r);
  }), e.forgetDeps(), fs(e.dirtyChildren === null);
}
function r6(e, t) {
  t.parents.delete(e), e.childValues.delete(t), e6(e, t);
}
function EU(e, t) {
  if (typeof e.subscribe == "function")
    try {
      W7(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
let Rm;
function TU(...e) {
  return (Rm || (Rm = new md(typeof WeakMap == "function"))).lookupArray(e);
}
const l1 = /* @__PURE__ */ new Set();
function AU(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: n = TU, normalizeResult: i, subscribe: a, cache: o = G2 } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof o == "function" ? new o(t, (h) => h.dispose()) : o, l = function() {
    const h = n.apply(null, r ? r.apply(null, arguments) : arguments);
    if (h === void 0)
      return e.apply(null, arguments);
    let f = s.get(h);
    f || (s.set(h, f = new e0(e)), f.normalizeResult = i, f.subscribe = a, f.forget = () => s.delete(h));
    const p = f.recompute(Array.prototype.slice.call(arguments));
    return s.set(h, f), l1.add(s), Ff.hasValue() || (l1.forEach((g) => g.clean()), l1.clear()), p;
  };
  Object.defineProperty(l, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: t,
    keyArgs: r,
    makeCacheKey: n,
    normalizeResult: i,
    subscribe: a,
    cache: s
  });
  function d(h) {
    const f = h && s.get(h);
    f && f.setDirty();
  }
  l.dirtyKey = d, l.dirty = function() {
    d(n.apply(null, arguments));
  };
  function u(h) {
    const f = h && s.get(h);
    if (f)
      return f.peek();
  }
  l.peekKey = u, l.peek = function() {
    return u(n.apply(null, arguments));
  };
  function c(h) {
    return h ? s.delete(h) : !1;
  }
  return l.forgetKey = c, l.forget = function() {
    return c(n.apply(null, arguments));
  }, l.makeCacheKey = n, l.getKey = r ? function() {
    return n.apply(null, r.apply(null, arguments));
  } : n, Object.freeze(l);
}
function OU(e) {
  return e;
}
var IU = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = z7 ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(OU, { cache: !1 });
    }, e.split = function(t, r, n) {
      return n === void 0 && (n = e.identity()), Object.assign(new e(
        function(i) {
          var a = t(i) ? r : n;
          return a.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: r, right: n });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var r = new md(Nf);
        this.performWork = AU(e.prototype.performWork.bind(this), {
          makeCacheKey: function(n) {
            var i = t.getCacheKey(n);
            if (i)
              return Ne(Array.isArray(i), 77), r.lookupArray(i);
          },
          max: vd["documentTransform.cache"],
          cache: K2
        });
      }
    }, e.prototype.performWork = function(t) {
      return Is(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var r = this.performWork(t);
      return this.resultCache.add(r), r;
    }, e.prototype.concat = function(t) {
      var r = this;
      return Object.assign(new e(
        function(n) {
          return t.transformDocument(r.transformDocument(n));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  }()
), Al, Fo = Object.assign(function(e) {
  var t = Al.get(e);
  return t || (t = rS(e), Al.set(e, t)), t;
}, {
  reset: function() {
    Al = new U7(
      vd.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
Fo.reset();
globalThis.__DEV__ !== !1 && q7("print", function() {
  return Al ? Al.size : 0;
});
var PU = Array.isArray;
function na(e) {
  return Array.isArray(e) && e.length > 0;
}
var zm = {
  kind: $e.FIELD,
  name: {
    kind: $e.NAME,
    value: "__typename"
  }
};
function n6(e, t) {
  return !e || e.selectionSet.selections.every(function(r) {
    return r.kind === $e.FRAGMENT_SPREAD && n6(t[r.name.value], t);
  });
}
function DU(e) {
  return n6(hs(e) || yU(e), gd(yd(e))) ? null : e;
}
function MU(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    n && (n.name ? t.set(n.name, n) : n.test && r.set(n.test, n));
  }), function(n) {
    var i = t.get(n.name.value);
    return !i && r.size && r.forEach(function(a, o) {
      o(n) && (i = a);
    }), i;
  };
}
function jm(e) {
  var t = /* @__PURE__ */ new Map();
  return function(r) {
    r === void 0 && (r = e);
    var n = t.get(r);
    return n || t.set(r, n = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), n;
  };
}
function i6(e, t) {
  Is(t);
  for (var r = jm(""), n = jm(""), i = function(m) {
    for (var $ = 0, w = void 0; $ < m.length && (w = m[$]); ++$)
      if (!PU(w)) {
        if (w.kind === $e.OPERATION_DEFINITION)
          return r(w.name && w.name.value);
        if (w.kind === $e.FRAGMENT_DEFINITION)
          return n(w.name.value);
      }
    return globalThis.__DEV__ !== !1 && Ne.error(97), null;
  }, a = 0, o = t.definitions.length - 1; o >= 0; --o)
    t.definitions[o].kind === $e.OPERATION_DEFINITION && ++a;
  var s = MU(e), l = function(m) {
    return na(m) && m.map(s).some(function($) {
      return $ && $.remove;
    });
  }, d = /* @__PURE__ */ new Map(), u = !1, c = {
    enter: function(m) {
      if (l(m.directives))
        return u = !0, null;
    }
  }, h = Pn(t, {
    // These two AST node types share the same implementation, defined above.
    Field: c,
    InlineFragment: c,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(m, $, w, k, C) {
        var E = i(C);
        E && E.variables.add(m.name.value);
      }
    },
    FragmentSpread: {
      enter: function(m, $, w, k, C) {
        if (l(m.directives))
          return u = !0, null;
        var E = i(C);
        E && E.fragmentSpreads.add(m.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(m, $, w, k) {
        d.set(JSON.stringify(k), m);
      },
      leave: function(m, $, w, k) {
        var C = d.get(JSON.stringify(k));
        if (m === C)
          return m;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          a > 0 && m.selectionSet.selections.every(function(E) {
            return E.kind === $e.FIELD && E.name.value === "__typename";
          })
        )
          return n(m.name.value).removed = !0, u = !0, null;
      }
    },
    Directive: {
      leave: function(m) {
        if (s(m))
          return u = !0, null;
      }
    }
  });
  if (!u)
    return t;
  var f = function(m) {
    return m.transitiveVars || (m.transitiveVars = new Set(m.variables), m.removed || m.fragmentSpreads.forEach(function($) {
      f(n($)).transitiveVars.forEach(function(w) {
        m.transitiveVars.add(w);
      });
    })), m;
  }, p = /* @__PURE__ */ new Set();
  h.definitions.forEach(function(m) {
    m.kind === $e.OPERATION_DEFINITION ? f(r(m.name && m.name.value)).fragmentSpreads.forEach(function($) {
      p.add($);
    }) : m.kind === $e.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    a === 0 && !n(m.name.value).removed && p.add(m.name.value);
  }), p.forEach(function(m) {
    f(n(m)).fragmentSpreads.forEach(function($) {
      p.add($);
    });
  });
  var g = function(m) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!p.has(m) || n(m).removed);
  }, v = {
    enter: function(m) {
      if (g(m.name.value))
        return null;
    }
  };
  return DU(Pn(h, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: v,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: v,
    OperationDefinition: {
      leave: function(m) {
        if (m.variableDefinitions) {
          var $ = f(
            // If an operation is anonymous, we use the empty string as its key.
            r(m.name && m.name.value)
          ).transitiveVars;
          if ($.size < m.variableDefinitions.length)
            return ae(ae({}, m), { variableDefinitions: m.variableDefinitions.filter(function(w) {
              return $.has(w.variable.name.value);
            }) });
        }
      }
    }
  }));
}
Object.assign(function(e) {
  return Pn(e, {
    SelectionSet: {
      enter: function(t, r, n) {
        if (!(n && n.kind === $e.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var a = i.some(function(s) {
              return oc(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var o = n;
              if (!(oc(o) && o.directives && o.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return ae(ae({}, t), { selections: Fr(Fr([], i, !0), [zm], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === zm;
  }
});
function NU(e) {
  var t = Xc(e), r = t.operation;
  if (r === "query")
    return e;
  var n = Pn(e, {
    OperationDefinition: {
      enter: function(i) {
        return ae(ae({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function a6(e) {
  Is(e);
  var t = i6([
    {
      test: function(r) {
        return r.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function LU(e) {
  return Is(e), Pn(e, {
    FragmentSpread: function(t) {
      var r;
      if (!(!((r = t.directives) === null || r === void 0) && r.some(function(n) {
        return n.name.value === "unmask";
      })))
        return ae(ae({}, t), { directives: Fr(Fr([], t.directives || [], !0), [
          {
            kind: $e.DIRECTIVE,
            name: { kind: $e.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var FU = Object.prototype.hasOwnProperty;
function Vm() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return o6(e);
}
function o6(e) {
  var t = e[0] || {}, r = e.length;
  if (r > 1)
    for (var n = new zf(), i = 1; i < r; ++i)
      t = n.merge(t, e[i]);
  return t;
}
var RU = function(e, t, r) {
  return this.merge(e[r], t[r]);
}, zf = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = RU), this.reconciler = t, this.isObject = Qn, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, r) {
      for (var n = this, i = [], a = 2; a < arguments.length; a++)
        i[a - 2] = arguments[a];
      return Qn(r) && Qn(t) ? (Object.keys(r).forEach(function(o) {
        if (FU.call(t, o)) {
          var s = t[o];
          if (r[o] !== s) {
            var l = n.reconciler.apply(n, Fr([
              t,
              r,
              o
            ], i, !1));
            l !== s && (t = n.shallowCopyForMerge(t), t[o] = l);
          }
        } else
          t = n.shallowCopyForMerge(t), t[o] = r[o];
      }), t) : r;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return Qn(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = ae({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  }()
);
function zU(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = jU(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jU(e, t) {
  if (e) {
    if (typeof e == "string") return Um(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Um(e, t);
  }
}
function Um(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function qm(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function jf(e, t, r) {
  return t && qm(e.prototype, t), r && qm(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Vf = function() {
  return typeof Symbol == "function";
}, Uf = function(e) {
  return Vf() && !!Symbol[e];
}, qf = function(e) {
  return Uf(e) ? Symbol[e] : "@@" + e;
};
Vf() && !Uf("observable") && (Symbol.observable = Symbol("observable"));
var VU = qf("iterator"), J2 = qf("observable"), s6 = qf("species");
function sc(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    return r;
  }
}
function tl(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[s6], t === null && (t = void 0)), t !== void 0 ? t : Mt;
}
function UU(e) {
  return e instanceof Mt;
}
function ps(e) {
  ps.log ? ps.log(e) : setTimeout(function() {
    throw e;
  });
}
function wu(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      ps(t);
    }
  });
}
function l6(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = sc(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (n) {
      ps(n);
    }
}
function eh(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function qU(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (d6(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function d6(e, t, r) {
  e._state = "running";
  var n = e._observer;
  try {
    var i = sc(n, t);
    switch (t) {
      case "next":
        i && i.call(n, r);
        break;
      case "error":
        if (eh(e), i) i.call(n, r);
        else throw r;
        break;
      case "complete":
        eh(e), i && i.call(n);
        break;
    }
  } catch (a) {
    ps(a);
  }
  e._state === "closed" ? l6(e) : e._state === "running" && (e._state = "ready");
}
function d1(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], wu(function() {
        return qU(e);
      });
      return;
    }
    d6(e, t, r);
  }
}
var BU = /* @__PURE__ */ function() {
  function e(r, n) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var i = new HU(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (a) {
      i.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (eh(this), l6(this));
  }, jf(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
}(), HU = /* @__PURE__ */ function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(r) {
    d1(this._subscription, "next", r);
  }, t.error = function(r) {
    d1(this._subscription, "error", r);
  }, t.complete = function() {
    d1(this._subscription, "complete");
  }, jf(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
}(), Mt = /* @__PURE__ */ function() {
  function e(r) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(r) {
    return (typeof r != "object" || r === null) && (r = {
      next: r,
      error: arguments[1],
      complete: arguments[2]
    }), new BU(r, this._subscriber);
  }, t.forEach = function(r) {
    var n = this;
    return new Promise(function(i, a) {
      if (typeof r != "function") {
        a(new TypeError(r + " is not a function"));
        return;
      }
      function o() {
        s.unsubscribe(), i();
      }
      var s = n.subscribe({
        next: function(l) {
          try {
            r(l, o);
          } catch (d) {
            a(d), s.unsubscribe();
          }
        },
        error: a,
        complete: i
      });
    });
  }, t.map = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = tl(this);
    return new i(function(a) {
      return n.subscribe({
        next: function(o) {
          try {
            o = r(o);
          } catch (s) {
            return a.error(s);
          }
          a.next(o);
        },
        error: function(o) {
          a.error(o);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.filter = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = tl(this);
    return new i(function(a) {
      return n.subscribe({
        next: function(o) {
          try {
            if (!r(o)) return;
          } catch (s) {
            return a.error(s);
          }
          a.next(o);
        },
        error: function(o) {
          a.error(o);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.reduce = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = tl(this), a = arguments.length > 1, o = !1, s = arguments[1], l = s;
    return new i(function(d) {
      return n.subscribe({
        next: function(u) {
          var c = !o;
          if (o = !0, !c || a)
            try {
              l = r(l, u);
            } catch (h) {
              return d.error(h);
            }
          else
            l = u;
        },
        error: function(u) {
          d.error(u);
        },
        complete: function() {
          if (!o && !a) return d.error(new TypeError("Cannot reduce an empty sequence"));
          d.next(l), d.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var r = this, n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var o = tl(this);
    return new o(function(s) {
      var l, d = 0;
      function u(c) {
        l = c.subscribe({
          next: function(h) {
            s.next(h);
          },
          error: function(h) {
            s.error(h);
          },
          complete: function() {
            d === i.length ? (l = void 0, s.complete()) : u(o.from(i[d++]));
          }
        });
      }
      return u(r), function() {
        l && (l.unsubscribe(), l = void 0);
      };
    });
  }, t.flatMap = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = tl(this);
    return new i(function(a) {
      var o = [], s = n.subscribe({
        next: function(d) {
          if (r)
            try {
              d = r(d);
            } catch (c) {
              return a.error(c);
            }
          var u = i.from(d).subscribe({
            next: function(c) {
              a.next(c);
            },
            error: function(c) {
              a.error(c);
            },
            complete: function() {
              var c = o.indexOf(u);
              c >= 0 && o.splice(c, 1), l();
            }
          });
          o.push(u);
        },
        error: function(d) {
          a.error(d);
        },
        complete: function() {
          l();
        }
      });
      function l() {
        s.closed && o.length === 0 && a.complete();
      }
      return function() {
        o.forEach(function(d) {
          return d.unsubscribe();
        }), s.unsubscribe();
      };
    });
  }, t[J2] = function() {
    return this;
  }, e.from = function(r) {
    var n = typeof this == "function" ? this : e;
    if (r == null) throw new TypeError(r + " is not an object");
    var i = sc(r, J2);
    if (i) {
      var a = i.call(r);
      if (Object(a) !== a) throw new TypeError(a + " is not an object");
      return UU(a) && a.constructor === n ? a : new n(function(o) {
        return a.subscribe(o);
      });
    }
    if (Uf("iterator") && (i = sc(r, VU), i))
      return new n(function(o) {
        wu(function() {
          if (!o.closed) {
            for (var s = zU(i.call(r)), l; !(l = s()).done; ) {
              var d = l.value;
              if (o.next(d), o.closed) return;
            }
            o.complete();
          }
        });
      });
    if (Array.isArray(r))
      return new n(function(o) {
        wu(function() {
          if (!o.closed) {
            for (var s = 0; s < r.length; ++s)
              if (o.next(r[s]), o.closed) return;
            o.complete();
          }
        });
      });
    throw new TypeError(r + " is not observable");
  }, e.of = function() {
    for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
      n[i] = arguments[i];
    var a = typeof this == "function" ? this : e;
    return new a(function(o) {
      wu(function() {
        if (!o.closed) {
          for (var s = 0; s < n.length; ++s)
            if (o.next(n[s]), o.closed) return;
          o.complete();
        }
      });
    });
  }, jf(e, null, [{
    key: s6,
    get: function() {
      return this;
    }
  }]), e;
}();
Vf() && Object.defineProperty(Mt, Symbol("extensions"), {
  value: {
    symbol: J2,
    hostReportError: ps
  },
  configurable: !0
});
function WU(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var Eo;
typeof self < "u" ? Eo = self : typeof window < "u" ? Eo = window : typeof global < "u" ? Eo = global : typeof module < "u" ? Eo = module : Eo = Function("return this")();
WU(Eo);
var Bm = Mt.prototype, Hm = "@@observable";
Bm[Hm] || (Bm[Hm] = function() {
  return this;
});
function QU(e) {
  return e.catch(function() {
  }), e;
}
var GU = Object.prototype.toString;
function YU(e) {
  return th(e);
}
function th(e, t) {
  switch (GU.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = e.slice(0);
      return t.set(e, r), r.forEach(function(i, a) {
        r[a] = th(i, t);
      }), r;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = Object.create(Object.getPrototypeOf(e));
      return t.set(e, n), Object.keys(e).forEach(function(i) {
        n[i] = th(e[i], t);
      }), n;
    }
    default:
      return e;
  }
}
function KU(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(r) {
    Qn(r) && ZU(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
      Qn(r[n]) && t.add(r[n]);
    });
  }), e;
}
function ZU(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function XU(e) {
  return globalThis.__DEV__ !== !1 && KU(e), e;
}
function Ol(e, t, r) {
  var n = [];
  e.forEach(function(i) {
    return i[t] && n.push(i);
  }), n.forEach(function(i) {
    return i[t](r);
  });
}
function u1(e, t, r) {
  return new Mt(function(n) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(d) {
          return d(l());
        });
      }
    };
    function a(l, d) {
      return function(u) {
        if (l) {
          var c = function() {
            return n.closed ? (
              /* will be swallowed */
              0
            ) : l(u);
          };
          i = i.then(c, c).then(function(h) {
            return n.next(h);
          }, function(h) {
            return n.error(h);
          });
        } else
          n[d](u);
      };
    }
    var o = {
      next: a(t, "next"),
      error: a(r, "error"),
      complete: function() {
        i.then(function() {
          return n.complete();
        });
      }
    }, s = e.subscribe(o);
    return function() {
      return s.unsubscribe();
    };
  });
}
function u6(e) {
  function t(r) {
    Object.defineProperty(e, r, { value: Mt });
  }
  return j7 && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function Wm(e) {
  return e && typeof e.then == "function";
}
var To = (
  /** @class */
  function(e) {
    ld(t, e);
    function t(r) {
      var n = e.call(this, function(i) {
        return n.addObserver(i), function() {
          return n.removeObserver(i);
        };
      }) || this;
      return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, a) {
        n.resolve = i, n.reject = a;
      }), n.handlers = {
        next: function(i) {
          n.sub !== null && (n.latest = ["next", i], n.notify("next", i), Ol(n.observers, "next", i));
        },
        error: function(i) {
          var a = n.sub;
          a !== null && (a && setTimeout(function() {
            return a.unsubscribe();
          }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), Ol(n.observers, "error", i));
        },
        complete: function() {
          var i = n, a = i.sub, o = i.sources, s = o === void 0 ? [] : o;
          if (a !== null) {
            var l = s.shift();
            l ? Wm(l) ? l.then(function(d) {
              return n.sub = d.subscribe(n.handlers);
            }, n.handlers.error) : n.sub = l.subscribe(n.handlers) : (a && setTimeout(function() {
              return a.unsubscribe();
            }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), Ol(n.observers, "complete"));
          }
        }
      }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
        n.reject(i), n.sources = [], n.handlers.error(i);
      }, n.promise.catch(function(i) {
      }), typeof r == "function" && (r = [new Mt(r)]), Wm(r) ? r.then(function(i) {
        return n.start(i);
      }, n.handlers.error) : n.start(r), n;
    }
    return t.prototype.start = function(r) {
      this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(r) {
      if (this.latest) {
        var n = this.latest[0], i = r[n];
        i && i.call(r, this.latest[1]), this.sub === null && n === "next" && r.complete && r.complete();
      }
    }, t.prototype.addObserver = function(r) {
      this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
    }, t.prototype.removeObserver = function(r) {
      this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(r, n) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(a) {
        return a(r, n);
      }));
    }, t.prototype.beforeNext = function(r) {
      var n = !1;
      this.nextResultListeners.add(function(i, a) {
        n || (n = !0, r(i, a));
      });
    }, t;
  }(Mt)
);
u6(To);
function Zo(e) {
  return "incremental" in e;
}
function JU(e) {
  return "hasNext" in e && "data" in e;
}
function eq(e) {
  return Zo(e) || JU(e);
}
function tq(e) {
  return Qn(e) && "payload" in e;
}
function c6(e, t) {
  var r = e, n = new zf();
  return Zo(t) && na(t.incremental) && t.incremental.forEach(function(i) {
    for (var a = i.data, o = i.path, s = o.length - 1; s >= 0; --s) {
      var l = o[s], d = !isNaN(+l), u = d ? [] : {};
      u[l] = a, a = u;
    }
    r = n.merge(r, a);
  }), r;
}
function xu(e) {
  var t = rh(e);
  return na(t);
}
function rh(e) {
  var t = na(e.errors) ? e.errors.slice(0) : [];
  return Zo(e) && na(e.incremental) && e.incremental.forEach(function(r) {
    r.errors && t.push.apply(t, r.errors);
  }), t;
}
function lc() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var a = n[i];
      a !== void 0 && (r[i] = a);
    });
  }), r;
}
function ku(e, t) {
  return lc(e, t, t.variables && {
    variables: lc(ae(ae({}, e && e.variables), t.variables))
  });
}
function c1(e) {
  return new Mt(function(t) {
    t.error(e);
  });
}
var h6 = function(e, t, r) {
  var n = new Error(r);
  throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
};
function rq(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, n = Object.keys(e); r < n.length; r++) {
    var i = n[r];
    if (t.indexOf(i) < 0)
      throw ei(46, i);
  }
  return e;
}
function nq(e, t) {
  var r = ae({}, e), n = function(a) {
    typeof a == "function" ? r = ae(ae({}, r), a(r)) : r = ae(ae({}, r), a);
  }, i = function() {
    return ae({}, r);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function iq(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? wl(t.query) || void 0 : ""), t;
}
function aq(e, t) {
  var r = ae({}, e), n = new Set(Object.keys(e));
  return Pn(t, {
    Variable: function(i, a, o) {
      o && o.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete r[i];
  }), r;
}
function Qm(e, t) {
  return t ? t(e) : Mt.of();
}
function rl(e) {
  return typeof e == "function" ? new bd(e) : e;
}
function Xd(e) {
  return e.request.length <= 1;
}
var bd = (
  /** @class */
  function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return Mt.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(rl).reduce(function(r, n) {
        return r.concat(n);
      });
    }, e.split = function(t, r, n) {
      var i = rl(r), a = rl(n || new e(Qm)), o;
      return Xd(i) && Xd(a) ? o = new e(function(s) {
        return t(s) ? i.request(s) || Mt.of() : a.request(s) || Mt.of();
      }) : o = new e(function(s, l) {
        return t(s) ? i.request(s, l) || Mt.of() : a.request(s, l) || Mt.of();
      }), Object.assign(o, { left: i, right: a });
    }, e.execute = function(t, r) {
      return t.request(nq(r.context, iq(rq(r)))) || Mt.of();
    }, e.concat = function(t, r) {
      var n = rl(t);
      if (Xd(n))
        return globalThis.__DEV__ !== !1 && Ne.warn(38, n), n;
      var i = rl(r), a;
      return Xd(i) ? a = new e(function(o) {
        return n.request(o, function(s) {
          return i.request(s) || Mt.of();
        }) || Mt.of();
      }) : a = new e(function(o, s) {
        return n.request(o, function(l) {
          return i.request(l, s) || Mt.of();
        }) || Mt.of();
      }), Object.assign(a, { left: n, right: i });
    }, e.prototype.split = function(t, r, n) {
      return this.concat(e.split(t, r, n || new e(Qm)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, r) {
      throw ei(39);
    }, e.prototype.onError = function(t, r) {
      if (r && r.error)
        return r.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return this.onError = t, this;
    }, e;
  }()
), nh = bd.execute;
function oq(e) {
  var t, r = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return r.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function sq(e) {
  var t = null, r = null, n = !1, i = [], a = [];
  function o(c) {
    if (!r) {
      if (a.length) {
        var h = a.shift();
        if (Array.isArray(h) && h[0])
          return h[0]({ value: c, done: !1 });
      }
      i.push(c);
    }
  }
  function s(c) {
    r = c;
    var h = a.slice();
    h.forEach(function(f) {
      f[1](c);
    }), !t || t();
  }
  function l() {
    n = !0;
    var c = a.slice();
    c.forEach(function(h) {
      h[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", o), e.removeListener("error", s), e.removeListener("end", l), e.removeListener("finish", l), e.removeListener("close", l);
  }, e.on("data", o), e.on("error", s), e.on("end", l), e.on("finish", l), e.on("close", l);
  function d() {
    return new Promise(function(c, h) {
      if (r)
        return h(r);
      if (i.length)
        return c({ value: i.shift(), done: !1 });
      if (n)
        return c({ value: void 0, done: !0 });
      a.push([c, h]);
    });
  }
  var u = {
    next: function() {
      return d();
    }
  };
  return Zc && (u[Symbol.asyncIterator] = function() {
    return this;
  }), u;
}
function lq(e) {
  var t = !1, r = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(n, i) {
        e.then(function(a) {
          n({ value: a, done: !1 });
        }).catch(i);
      }));
    }
  };
  return Zc && (r[Symbol.asyncIterator] = function() {
    return this;
  }), r;
}
function Gm(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return Zc && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function dq(e) {
  return !!e.body;
}
function uq(e) {
  return !!e.getReader;
}
function cq(e) {
  return !!(Zc && e[Symbol.asyncIterator]);
}
function hq(e) {
  return !!e.stream;
}
function fq(e) {
  return !!e.arrayBuffer;
}
function pq(e) {
  return !!e.pipe;
}
function mq(e) {
  var t = e;
  if (dq(e) && (t = e.body), cq(t))
    return oq(t);
  if (uq(t))
    return Gm(t.getReader());
  if (hq(t))
    return Gm(t.stream().getReader());
  if (fq(t))
    return lq(t.arrayBuffer());
  if (pq(t))
    return sq(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var Bf = Symbol();
function gq(e) {
  return e.extensions ? Array.isArray(e.extensions[Bf]) : !1;
}
function f6(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var vq = function(e) {
  var t = Fr(Fr(Fr([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return Qn(r) && r.message || "Error message not found.";
  }).join(`
`);
}, ka = (
  /** @class */
  function(e) {
    ld(t, e);
    function t(r) {
      var n = r.graphQLErrors, i = r.protocolErrors, a = r.clientErrors, o = r.networkError, s = r.errorMessage, l = r.extraInfo, d = e.call(this, s) || this;
      return d.name = "ApolloError", d.graphQLErrors = n || [], d.protocolErrors = i || [], d.clientErrors = a || [], d.networkError = o || null, d.message = s || vq(d), d.extraInfo = l, d.cause = Fr(Fr(Fr([
        o
      ], n || [], !0), i || [], !0), a || [], !0).find(function(u) {
        return !!u;
      }) || null, d.__proto__ = t.prototype, d;
    }
    return t;
  }(Error)
), Ym = Object.prototype.hasOwnProperty;
function yq(e, t) {
  return ji(this, void 0, void 0, function() {
    var r, n, i, a, o, s, l, d, u, c, h, f, p, g, v, m, $, w, k, C, E, N, M, V;
    return Vi(this, function(q) {
      switch (q.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          r = new TextDecoder("utf-8"), n = (V = e.headers) === null || V === void 0 ? void 0 : V.get("content-type"), i = "boundary=", a = n?.includes(i) ? n?.substring(n?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", o = `\r
--`.concat(a), s = "", l = mq(e), d = !0, q.label = 1;
        case 1:
          return d ? [4, l.next()] : [3, 3];
        case 2:
          for (u = q.sent(), c = u.value, h = u.done, f = typeof c == "string" ? c : r.decode(c), p = s.length - o.length + 1, d = !h, s += f, g = s.indexOf(o, p); g > -1; ) {
            if (v = void 0, N = [
              s.slice(0, g),
              s.slice(g + o.length)
            ], v = N[0], s = N[1], m = v.indexOf(`\r
\r
`), $ = bq(v.slice(0, m)), w = $["content-type"], w && w.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (k = v.slice(m), k) {
              if (C = p6(e, k), Object.keys(C).length > 1 || "data" in C || "incremental" in C || "errors" in C || "payload" in C)
                if (tq(C)) {
                  if (E = {}, "payload" in C) {
                    if (Object.keys(C).length === 1 && C.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    E = ae({}, C.payload);
                  }
                  "errors" in C && (E = ae(ae({}, E), { extensions: ae(ae({}, "extensions" in E ? E.extensions : null), (M = {}, M[Bf] = C.errors, M)) })), t(E);
                } else
                  t(C);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(C).length === 1 && "hasNext" in C && !C.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            g = s.indexOf(o);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function bq(e) {
  var t = {};
  return e.split(`
`).forEach(function(r) {
    var n = r.indexOf(":");
    if (n > -1) {
      var i = r.slice(0, n).trim().toLowerCase(), a = r.slice(n + 1).trim();
      t[i] = a;
    }
  }), t;
}
function p6(e, t) {
  if (e.status >= 300) {
    var r = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    h6(e, r(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = e, n.statusCode = e.status, n.bodyText = t, n;
  }
}
function $q(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function wq(e) {
  return function(t) {
    return t.text().then(function(r) {
      return p6(t, r);
    }).then(function(r) {
      return !Array.isArray(r) && !Ym.call(r, "data") && !Ym.call(r, "errors") && h6(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(n) {
        return n.operationName;
      }) : e.operationName, "'.")), r;
    });
  };
}
var ih = function(e, t) {
  var r;
  try {
    r = JSON.stringify(e);
  } catch (i) {
    var n = ei(42, t, i.message);
    throw n.parseError = i, n;
  }
  return r;
}, xq = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, kq = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, _q = {
  method: "POST"
}, Cq = {
  http: xq,
  headers: kq,
  options: _q
}, Sq = function(e, t) {
  return t(e);
};
function Eq(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var i = {}, a = {};
  r.forEach(function(c) {
    i = ae(ae(ae({}, i), c.options), { headers: ae(ae({}, i.headers), c.headers) }), c.credentials && (i.credentials = c.credentials), a = ae(ae({}, a), c.http);
  }), i.headers && (i.headers = Tq(i.headers, a.preserveHeaderCase));
  var o = e.operationName, s = e.extensions, l = e.variables, d = e.query, u = { operationName: o, variables: l };
  return a.includeExtensions && (u.extensions = s), a.includeQuery && (u.query = t(d, Fo)), {
    options: i,
    body: u
  };
}
function Tq(e, t) {
  if (!t) {
    var r = {};
    return Object.keys(Object(e)).forEach(function(a) {
      r[a.toLowerCase()] = e[a];
    }), r;
  }
  var n = {};
  Object.keys(Object(e)).forEach(function(a) {
    n[a.toLowerCase()] = {
      originalName: a,
      value: e[a]
    };
  });
  var i = {};
  return Object.keys(n).forEach(function(a) {
    i[n[a].originalName] = n[a].value;
  }), i;
}
var Aq = function(e) {
  if (!e && typeof fetch > "u")
    throw ei(40);
}, Oq = function(e, t) {
  var r = e.getContext(), n = r.uri;
  return n || (typeof t == "function" ? t(e) : t || "/graphql");
};
function Iq(e, t) {
  var r = [], n = function(c, h) {
    r.push("".concat(c, "=").concat(encodeURIComponent(h)));
  };
  if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = ih(t.variables, "Variables map");
    } catch (c) {
      return { parseError: c };
    }
    n("variables", i);
  }
  if (t.extensions) {
    var a = void 0;
    try {
      a = ih(t.extensions, "Extensions map");
    } catch (c) {
      return { parseError: c };
    }
    n("extensions", a);
  }
  var o = "", s = e, l = e.indexOf("#");
  l !== -1 && (o = e.substr(l), s = e.substr(0, l));
  var d = s.indexOf("?") === -1 ? "?" : "&", u = s + d + r.join("&") + o;
  return { newURI: u };
}
var Km = Cn(function() {
  return fetch;
}), Pq = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, r = t === void 0 ? "/graphql" : t, n = e.fetch, i = e.print, a = i === void 0 ? Sq : i, o = e.includeExtensions, s = e.preserveHeaderCase, l = e.useGETForQueries, d = e.includeUnusedVariables, u = d === void 0 ? !1 : d, c = N2(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && Aq(n || Km);
  var h = {
    http: { includeExtensions: o, preserveHeaderCase: s },
    options: c.fetchOptions,
    credentials: c.credentials,
    headers: c.headers
  };
  return new bd(function(f) {
    var p = Oq(f, r), g = f.getContext(), v = {};
    if (g.clientAwareness) {
      var m = g.clientAwareness, $ = m.name, w = m.version;
      $ && (v["apollographql-client-name"] = $), w && (v["apollographql-client-version"] = w);
    }
    var k = ae(ae({}, v), g.headers), C = {
      http: g.http,
      options: g.fetchOptions,
      credentials: g.credentials,
      headers: k
    };
    if (Yl(["client"], f.query)) {
      var E = a6(f.query);
      if (!E)
        return c1(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      f.query = E;
    }
    var N = Eq(f, a, Cq, h, C), M = N.options, V = N.body;
    V.variables && !u && (V.variables = aq(V.variables, f.query));
    var q;
    !M.signal && typeof AbortController < "u" && (q = new AbortController(), M.signal = q.signal);
    var I = function(R) {
      return R.kind === "OperationDefinition" && R.operation === "mutation";
    }, P = function(R) {
      return R.kind === "OperationDefinition" && R.operation === "subscription";
    }, z = P(Xc(f.query)), G = Yl(["defer"], f.query);
    if (l && !f.query.definitions.some(I) && (M.method = "GET"), G || z) {
      M.headers = M.headers || {};
      var se = "multipart/mixed;";
      z && G && globalThis.__DEV__ !== !1 && Ne.warn(41), z ? se += "boundary=graphql;subscriptionSpec=1.0,application/json" : G && (se += "deferSpec=20220824,application/json"), M.headers.accept = se;
    }
    if (M.method === "GET") {
      var ue = Iq(p, V), de = ue.newURI, D = ue.parseError;
      if (D)
        return c1(D);
      p = de;
    } else
      try {
        M.body = ih(V, "Payload");
      } catch (R) {
        return c1(R);
      }
    return new Mt(function(R) {
      var Q = n || Cn(function() {
        return fetch;
      }) || Km, Z = R.next.bind(R);
      return Q(p, M).then(function(F) {
        var oe;
        f.setContext({ response: F });
        var pe = (oe = F.headers) === null || oe === void 0 ? void 0 : oe.get("content-type");
        return pe !== null && /^multipart\/mixed/i.test(pe) ? yq(F, Z) : wq(f)(F).then(Z);
      }).then(function() {
        q = void 0, R.complete();
      }).catch(function(F) {
        q = void 0, $q(F, R);
      }), function() {
        q && q.abort();
      };
    });
  });
}, Dq = (
  /** @class */
  function(e) {
    ld(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, Pq(r).request) || this;
      return n.options = r, n;
    }
    return t;
  }(bd)
);
const { toString: Zm, hasOwnProperty: Mq } = Object.prototype, Xm = Function.prototype.toString, ah = /* @__PURE__ */ new Map();
function qt(e, t) {
  try {
    return oh(e, t);
  } finally {
    ah.clear();
  }
}
function oh(e, t) {
  if (e === t)
    return !0;
  const r = Zm.call(e), n = Zm.call(t);
  if (r !== n)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    case "[object Object]": {
      if (eg(e, t))
        return !0;
      const i = Jm(e), a = Jm(t), o = i.length;
      if (o !== a.length)
        return !1;
      for (let s = 0; s < o; ++s)
        if (!Mq.call(t, i[s]))
          return !1;
      for (let s = 0; s < o; ++s) {
        const l = i[s];
        if (!oh(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (eg(e, t))
        return !0;
      const i = e.entries(), a = r === "[object Map]";
      for (; ; ) {
        const o = i.next();
        if (o.done)
          break;
        const [s, l] = o.value;
        if (!t.has(s) || a && !oh(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = Xm.call(e);
      return i !== Xm.call(t) ? !1 : !Fq(i, Lq);
    }
  }
  return !1;
}
function Jm(e) {
  return Object.keys(e).filter(Nq, e);
}
function Nq(e) {
  return this[e] !== void 0;
}
const Lq = "{ [native code] }";
function Fq(e, t) {
  const r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function eg(e, t) {
  let r = ah.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    ah.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
function Rq(e, t, r, n) {
  var i = t.data, a = N2(t, ["data"]), o = r.data, s = N2(r, ["data"]);
  return qt(a, s) && _u(Xc(e).selectionSet, i, o, {
    fragmentMap: gd(yd(e)),
    variables: n
  });
}
function _u(e, t, r, n) {
  if (t === r)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(a) {
    if (i.has(a) || (i.add(a), !R7(a, n.variables)) || tg(a))
      return !0;
    if (oc(a)) {
      var o = ac(a), s = t && t[o], l = r && r[o], d = a.selectionSet;
      if (!d)
        return qt(s, l);
      var u = Array.isArray(s), c = Array.isArray(l);
      if (u !== c)
        return !1;
      if (u && c) {
        var h = s.length;
        if (l.length !== h)
          return !1;
        for (var f = 0; f < h; ++f)
          if (!_u(d, s[f], l[f], n))
            return !1;
        return !0;
      }
      return _u(d, s, l, n);
    } else {
      var p = jV(a, n.fragmentMap);
      if (p)
        return tg(p) ? !0 : _u(
          p.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          r,
          n
        );
    }
  });
}
function tg(e) {
  return !!e.directives && e.directives.some(zq);
}
function zq(e) {
  return e.name.value === "nonreactive";
}
var m6 = Nf ? WeakMap : Map, g6 = z7 ? WeakSet : Set, v6 = new Jc(), rg = !1;
function y6() {
  rg || (rg = !0, globalThis.__DEV__ !== !1 && Ne.warn(52));
}
function b6(e, t, r) {
  return v6.withValue(!0, function() {
    var n = xl(e, t, r, !1);
    return Object.isFrozen(e) && XU(n), n;
  });
}
function jq(e, t) {
  if (t.has(e))
    return t.get(e);
  var r = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, r), r;
}
function xl(e, t, r, n, i) {
  var a, o = r.knownChanged, s = jq(e, r.mutableTargets);
  if (Array.isArray(e)) {
    for (var l = 0, d = Array.from(e.entries()); l < d.length; l++) {
      var u = d[l], c = u[0], h = u[1];
      if (h === null) {
        s[c] = null;
        continue;
      }
      var f = xl(h, t, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(c, "]") : void 0);
      o.has(f) && o.add(s), s[c] = f;
    }
    return o.has(s) ? s : e;
  }
  for (var p = 0, g = t.selections; p < g.length; p++) {
    var v = g[p], m = void 0;
    if (n && o.add(s), v.kind === $e.FIELD) {
      var $ = ac(v), w = v.selectionSet;
      if (m = s[$] || e[$], m === void 0)
        continue;
      if (w && m !== null) {
        var f = xl(e[$], w, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat($) : void 0);
        o.has(f) && (m = f);
      }
      globalThis.__DEV__ === !1 && (s[$] = m), globalThis.__DEV__ !== !1 && (n && $ !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((a = Object.getOwnPropertyDescriptor(s, $)) === null || a === void 0) && a.value) ? Object.defineProperty(s, $, Vq($, m, i || "", r.operationName, r.operationType)) : (delete s[$], s[$] = m));
    }
    if (v.kind === $e.INLINE_FRAGMENT && (!v.typeCondition || r.cache.fragmentMatches(v, e.__typename)) && (m = xl(e, v.selectionSet, r, n, i)), v.kind === $e.FRAGMENT_SPREAD) {
      var k = v.name.value, C = r.fragmentMap[k] || (r.fragmentMap[k] = r.cache.lookupFragment(k));
      Ne(C, 47, k);
      var E = MV(v);
      E !== "mask" && (m = xl(e, C.selectionSet, r, E === "migrate", i));
    }
    o.has(m) && o.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && o.add(s), o.has(s) ? s : e;
}
function Vq(e, t, r, n, i) {
  var a = function() {
    return v6.getValue() || (globalThis.__DEV__ !== !1 && Ne.warn(48, n ? "".concat(i, " '").concat(n, "'") : "anonymous ".concat(i), "".concat(r, ".").concat(e).replace(/^\./, "")), a = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return a();
    },
    set: function(o) {
      a = function() {
        return o;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function Uq(e, t, r, n) {
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && y6(), e;
  var i = t.definitions.filter(function(o) {
    return o.kind === $e.FRAGMENT_DEFINITION;
  });
  typeof n > "u" && (Ne(i.length === 1, 49, i.length), n = i[0].name.value);
  var a = i.find(function(o) {
    return o.name.value === n;
  });
  return Ne(!!a, 50, n), e == null || qt(e, {}) ? e : b6(e, a.selectionSet, {
    operationType: "fragment",
    operationName: a.name.value,
    fragmentMap: gd(yd(t)),
    cache: r,
    mutableTargets: new m6(),
    knownChanged: new g6()
  });
}
function qq(e, t, r) {
  var n;
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && y6(), e;
  var i = hs(t);
  return Ne(i, 51), e == null ? e : b6(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
    fragmentMap: gd(yd(t)),
    cache: r,
    mutableTargets: new m6(),
    knownChanged: new g6()
  });
}
var Bq = new Jc(), vt;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(vt || (vt = {}));
function Xo(e) {
  return e ? e < 7 : !1;
}
var ng = Object.assign, Hq = Object.hasOwnProperty, sh = (
  /** @class */
  function(e) {
    ld(t, e);
    function t(r) {
      var n = r.queryManager, i = r.queryInfo, a = r.options, o = e.call(this, function(v) {
        try {
          var m = v._subscription._observer;
          m && !m.error && (m.error = Wq);
        } catch {
        }
        var $ = !o.observers.size;
        o.observers.add(v);
        var w = o.last;
        return w && w.error ? v.error && v.error(w.error) : w && w.result && v.next && v.next(o.maskResult(w.result)), $ && o.reobserve().catch(function() {
        }), function() {
          o.observers.delete(v) && !o.observers.size && o.tearDownQuery();
        };
      }) || this;
      o.observers = /* @__PURE__ */ new Set(), o.subscriptions = /* @__PURE__ */ new Set(), o.queryInfo = i, o.queryManager = n, o.waitForOwnResult = h1(a.fetchPolicy), o.isTornDown = !1, o.subscribeToMore = o.subscribeToMore.bind(o), o.maskResult = o.maskResult.bind(o);
      var s = n.defaultOptions.watchQuery, l = s === void 0 ? {} : s, d = l.fetchPolicy, u = d === void 0 ? "cache-first" : d, c = a.fetchPolicy, h = c === void 0 ? u : c, f = a.initialFetchPolicy, p = f === void 0 ? h === "standby" ? u : h : f;
      o.options = ae(ae({}, a), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: p,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: h
      }), o.queryId = i.queryId || n.generateQueryId();
      var g = hs(o.query);
      return o.queryName = g && g.name && g.name.value, o;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var r = this;
      return new Promise(function(n, i) {
        var a = {
          next: function(s) {
            n(s), r.observers.delete(a), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              o.unsubscribe();
            }, 0);
          },
          error: i
        }, o = r.subscribe(a);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(r) {
      r === void 0 && (r = !0);
      var n = this.getLastResult(!0), i = this.queryInfo.networkStatus || n && n.networkStatus || vt.ready, a = ae(ae({}, n), { loading: Xo(i), networkStatus: i }), o = this.options.fetchPolicy, s = o === void 0 ? "cache-first" : o;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(h1(s) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var l = this.queryInfo.getDiff();
        (l.complete || this.options.returnPartialData) && (a.data = l.result), qt(a.data, {}) && (a.data = void 0), l.complete ? (delete a.partial, l.complete && a.networkStatus === vt.loading && (s === "cache-first" || s === "cache-only") && (a.networkStatus = vt.ready, a.loading = !1)) : a.partial = !0, a.networkStatus === vt.ready && (a.error || a.errors) && (a.networkStatus = vt.error), globalThis.__DEV__ !== !1 && !l.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && w6(l.missing);
      }
      return r && this.updateLastResult(a), a;
    }, t.prototype.getCurrentResult = function(r) {
      return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
    }, t.prototype.isDifferentFromLastResult = function(r, n) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), a = this.queryManager.dataMasking, o = a ? i.nonReactiveQuery : this.query, s = a || i.hasNonreactiveDirective ? !Rq(o, this.last.result, r, this.variables) : !qt(this.last.result, r);
      return s || n && !qt(this.last.variables, n);
    }, t.prototype.getLast = function(r, n) {
      var i = this.last;
      if (i && i[r] && (!n || qt(i.variables, this.variables)))
        return i[r];
    }, t.prototype.getLastResult = function(r) {
      return this.getLast("result", r);
    }, t.prototype.getLastError = function(r) {
      return this.getLast("error", r);
    }, t.prototype.resetLastResults = function() {
      delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(r) {
      var n, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, a = this.options.fetchPolicy;
      if (a === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && Hq.call(r, "variables")) {
        var o = vU(this.query), s = o.variableDefinitions;
        (!s || !s.some(function(l) {
          return l.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && Ne.warn(
          21,
          r,
          ((n = o.name) === null || n === void 0 ? void 0 : n.value) || o
        );
      }
      return r && !qt(this.options.variables, r) && (i.variables = this.options.variables = ae(ae({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, vt.refetch);
    }, t.prototype.fetchMore = function(r) {
      var n = this, i = ae(ae({}, r.query ? r : ae(ae(ae(ae({}, this.options), { query: this.options.query }), r), { variables: ae(ae({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var a = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : i.query;
      var o = this.queryInfo, s = o.networkStatus;
      o.networkStatus = vt.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), d = r?.updateQuery, u = this.options.fetchPolicy !== "no-cache";
      return u || Ne(d, 22), this.queryManager.fetchQuery(a, i, vt.fetchMore).then(function(c) {
        if (n.queryManager.removeQuery(a), o.networkStatus === vt.fetchMore && (o.networkStatus = s), u)
          n.queryManager.cache.batch({
            update: function(p) {
              var g = r.updateQuery;
              g ? p.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(v) {
                return g(v, {
                  fetchMoreResult: c.data,
                  variables: i.variables
                });
              }) : p.writeQuery({
                query: i.query,
                variables: i.variables,
                data: c.data
              });
            },
            onWatchUpdated: function(p) {
              l.add(p.query);
            }
          });
        else {
          var h = n.getLast("result"), f = d(h.data, {
            fetchMoreResult: c.data,
            variables: i.variables
          });
          n.reportResult(ae(ae({}, h), { networkStatus: s, loading: Xo(s), data: f }), n.variables);
        }
        return n.maskResult(c);
      }).finally(function() {
        u && !l.has(n.query) && $6(n);
      });
    }, t.prototype.subscribeToMore = function(r) {
      var n = this, i = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(a) {
          var o = r.updateQuery;
          o && n.updateQuery(function(s, l) {
            return o(s, ae({ subscriptionData: a }, l));
          });
        },
        error: function(a) {
          if (r.onError) {
            r.onError(a);
            return;
          }
          globalThis.__DEV__ !== !1 && Ne.error(23, a);
        }
      });
      return this.subscriptions.add(i), function() {
        n.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(r) {
      return this.reobserve(r);
    }, t.prototype.silentSetOptions = function(r) {
      var n = lc(this.options, r || {});
      ng(this.options, n);
    }, t.prototype.setVariables = function(r) {
      return qt(this.variables, r) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, vt.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(r) {
      var n = this.queryManager, i = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), a = i.result, o = i.complete, s = r(a, {
        variables: this.variables,
        complete: !!o,
        previousData: a
      });
      s && (n.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), n.broadcastQueries());
    }, t.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(r, n) {
      if (n.nextFetchPolicy) {
        var i = n.fetchPolicy, a = i === void 0 ? "cache-first" : i, o = n.initialFetchPolicy, s = o === void 0 ? a : o;
        a === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(a, {
          reason: r,
          options: n,
          observable: this,
          initialFetchPolicy: s
        }) : r === "variables-changed" ? n.fetchPolicy = s : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, t.prototype.fetch = function(r, n, i) {
      return this.queryManager.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(this.queryId, r, n, i);
    }, t.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var n = this, i = n.pollingInfo, a = n.options.pollInterval;
        if (!a || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === a)) {
          Ne(a, 24);
          var o = i || (this.pollingInfo = {});
          o.interval = a;
          var s = function() {
            var d, u;
            r.pollingInfo && (!Xo(r.queryInfo.networkStatus) && !(!((u = (d = r.options).skipPollAttempt) === null || u === void 0) && u.call(d)) ? r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, vt.poll).then(l, l) : l());
          }, l = function() {
            var d = r.pollingInfo;
            d && (clearTimeout(d.timeout), d.timeout = setTimeout(s, d.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(r, n) {
      n === void 0 && (n = this.variables);
      var i = this.getLastError();
      return i && this.last && !qt(n, this.last.variables) && (i = void 0), this.last = ae({ result: this.queryManager.assumeImmutableResults ? r : YU(r), variables: n }, i ? { error: i } : null);
    }, t.prototype.reobserveAsConcast = function(r, n) {
      var i = this;
      this.isTornDown = !1;
      var a = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === vt.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === vt.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === vt.poll
      ), o = this.options.variables, s = this.options.fetchPolicy, l = lc(this.options, r || {}), d = a ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : ng(this.options, l), u = this.transformDocument(d.query);
      this.lastQuery = u, a || (this.updatePolling(), r && r.variables && !qt(r.variables, o) && // Don't mess with the fetchPolicy if it's currently "standby".
      d.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (d.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof d.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", d), n === void 0 && (n = vt.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = h1(d.fetchPolicy));
      var c = function() {
        i.concast === p && (i.waitForOwnResult = !1);
      }, h = d.variables && ae({}, d.variables), f = this.fetch(d, n, u), p = f.concast, g = f.fromLink, v = {
        next: function(m) {
          qt(i.variables, h) && (c(), i.reportResult(m, h));
        },
        error: function(m) {
          qt(i.variables, h) && (f6(m) || (m = new ka({ networkError: m })), c(), i.reportError(m, h));
        }
      };
      return !a && (g || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = p, this.observer = v), p.addObserver(v), p;
    }, t.prototype.reobserve = function(r, n) {
      return QU(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      var i = this.last;
      this.resetLastResults();
      var a = this.subscribe.apply(this, r);
      return this.last = i, a;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(r, n) {
      var i = this.getLastError(), a = this.isDifferentFromLastResult(r, n);
      (i || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (i || a) && Ol(this.observers, "next", this.maskResult(r));
    }, t.prototype.reportError = function(r, n) {
      var i = ae(ae({}, this.getLastResult()), { error: r, errors: r.graphQLErrors, networkStatus: vt.error, loading: !1 });
      this.updateLastResult(i, n), Ol(this.observers, "error", this.last.error = r);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, t.prototype.maskResult = function(r) {
      return r && "data" in r ? ae(ae({}, r), { data: this.queryManager.maskOperation({
        document: this.query,
        data: r.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : r;
    }, t;
  }(Mt)
);
u6(sh);
function $6(e) {
  var t = e.options, r = t.fetchPolicy, n = t.nextFetchPolicy;
  return r === "cache-and-network" || r === "network-only" ? e.reobserve({
    fetchPolicy: "cache-first",
    // Use a temporary nextFetchPolicy function that replaces itself with the
    // previous nextFetchPolicy value and returns the original fetchPolicy.
    nextFetchPolicy: function(i, a) {
      return this.nextFetchPolicy = n, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(i, a) : r;
    }
  }) : e.reobserve();
}
function Wq(e) {
  globalThis.__DEV__ !== !1 && Ne.error(25, e.message, e.stack);
}
function w6(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && Ne.debug(26, e);
}
function h1(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var Ro = new (Nf ? WeakMap : Map)();
function f1(e, t) {
  var r = e[t];
  typeof r == "function" && (e[t] = function() {
    return Ro.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (Ro.get(e) + 1) % 1e15
    ), r.apply(this, arguments);
  });
}
function ig(e) {
  e.notifyTimeout && (clearTimeout(e.notifyTimeout), e.notifyTimeout = void 0);
}
var p1 = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.listeners = /* @__PURE__ */ new Set(), this.document = null, this.lastRequestId = 1, this.stopped = !1, this.dirty = !1, this.observableQuery = null;
      var n = this.cache = t.cache;
      Ro.has(n) || (Ro.set(n, 0), f1(n, "evict"), f1(n, "modify"), f1(n, "reset"));
    }
    return e.prototype.init = function(t) {
      var r = t.networkStatus || vt.loading;
      return this.variables && this.networkStatus !== vt.loading && !qt(this.variables, t.variables) && (r = vt.setVariables), qt(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: r
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.reset = function() {
      ig(this), this.dirty = !1;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this.getDiffOptions();
      if (this.lastDiff && qt(t, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var r = this.observableQuery;
      if (r && r.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var n = this.cache.diff(t);
      return this.updateLastDiff(n, t), n;
    }, e.prototype.updateLastDiff = function(t, r) {
      this.lastDiff = t ? {
        diff: t,
        options: r || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var r;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var r = this, n, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && !((n = this.observableQuery) === null || n === void 0) && n.getLastError() || (this.updateLastDiff(t), !this.dirty && !qt(i && i.result, t && t.result) && (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0))));
    }, e.prototype.setObservableQuery = function(t) {
      var r = this;
      t !== this.observableQuery && (this.oqListener && this.listeners.delete(this.oqListener), this.observableQuery = t, t ? (t.queryInfo = this, this.listeners.add(this.oqListener = function() {
        var n = r.getDiff();
        n.fromOptimisticTransaction ? t.observe() : $6(t);
      })) : delete this.oqListener);
    }, e.prototype.notify = function() {
      var t = this;
      ig(this), this.shouldNotify() && this.listeners.forEach(function(r) {
        return r(t);
      }), this.dirty = !1;
    }, e.prototype.shouldNotify = function() {
      if (!this.dirty || !this.listeners.size)
        return !1;
      if (Xo(this.networkStatus) && this.observableQuery) {
        var t = this.observableQuery.options.fetchPolicy;
        if (t !== "cache-only" && t !== "cache-and-network")
          return !1;
      }
      return !0;
    }, e.prototype.stop = function() {
      if (!this.stopped) {
        this.stopped = !0, this.reset(), this.cancel();
        var t = this.observableQuery;
        t && t.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var r = this;
      t === void 0 && (t = this.variables);
      var n = this.observableQuery;
      if (!(n && n.options.fetchPolicy === "no-cache")) {
        var i = ae(ae({}, this.getDiffOptions(t)), { watcher: this, callback: function(a) {
          return r.setDiff(a);
        } });
        (!this.lastWatch || !qt(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, r) {
      var n = this.lastWrite;
      return !(n && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      n.dmCount === Ro.get(this.cache) && qt(r, n.variables) && qt(t.data, n.result.data));
    }, e.prototype.markResult = function(t, r, n, i) {
      var a = this, o = new zf(), s = na(t.errors) ? t.errors.slice(0) : [];
      if (this.reset(), "incremental" in t && na(t.incremental)) {
        var l = c6(this.getDiff().result, t);
        t.data = l;
      } else if ("hasNext" in t && t.hasNext) {
        var d = this.getDiff();
        t.data = o.merge(d.result, t.data);
      }
      this.graphQLErrors = s, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (lh(t, n.errorPolicy) ? this.cache.performTransaction(function(u) {
        if (a.shouldWrite(t, n.variables))
          u.writeQuery({
            query: r,
            data: t.data,
            variables: n.variables,
            overwrite: i === 1
          }), a.lastWrite = {
            result: t,
            variables: n.variables,
            dmCount: Ro.get(a.cache)
          };
        else if (a.lastDiff && a.lastDiff.diff.complete) {
          t.data = a.lastDiff.diff.result;
          return;
        }
        var c = a.getDiffOptions(n.variables), h = u.diff(c);
        !a.stopped && qt(a.variables, n.variables) && a.updateWatch(n.variables), a.updateLastDiff(h, c), h.complete && (t.data = h.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = vt.ready;
    }, e.prototype.markError = function(t) {
      return this.networkStatus = vt.error, this.lastWrite = void 0, this.reset(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  }()
);
function lh(e, t) {
  t === void 0 && (t = "none");
  var r = t === "ignore" || t === "all", n = !xu(e);
  return !n && r && e.data && (n = !0), n;
}
var Qq = Object.prototype.hasOwnProperty, ag = /* @__PURE__ */ Object.create(null), Gq = (
  /** @class */
  function() {
    function e(t) {
      var r = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new U7(
        vd["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new md(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var n = new IU(
        function(a) {
          return r.cache.transformDocument(a);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(r, n) {
        t.stopQueryNoBroadcast(n);
      }), this.cancelPendingFetches(ei(27));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(r) {
        return r(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return ji(this, arguments, void 0, function(r) {
        var n, i, a, o, s, l, d, u = r.mutation, c = r.variables, h = r.optimisticResponse, f = r.updateQueries, p = r.refetchQueries, g = p === void 0 ? [] : p, v = r.awaitRefetchQueries, m = v === void 0 ? !1 : v, $ = r.update, w = r.onQueryUpdated, k = r.fetchPolicy, C = k === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : k, E = r.errorPolicy, N = E === void 0 ? ((d = this.defaultOptions.mutate) === null || d === void 0 ? void 0 : d.errorPolicy) || "none" : E, M = r.keepRootFields, V = r.context;
        return Vi(this, function(q) {
          switch (q.label) {
            case 0:
              return Ne(u, 28), Ne(C === "network-only" || C === "no-cache", 29), n = this.generateMutationId(), u = this.cache.transformForLink(this.transform(u)), i = this.getDocumentInfo(u).hasClientExports, c = this.getVariables(u, c), i ? [4, this.localState.addExportedVariables(u, c, V)] : [3, 2];
            case 1:
              c = q.sent(), q.label = 2;
            case 2:
              return a = this.mutationStore && (this.mutationStore[n] = {
                mutation: u,
                variables: c,
                loading: !0,
                error: null
              }), o = h && this.markMutationOptimistic(h, {
                mutationId: n,
                document: u,
                variables: c,
                fetchPolicy: C,
                errorPolicy: N,
                context: V,
                updateQueries: f,
                update: $,
                keepRootFields: M
              }), this.broadcastQueries(), s = this, [2, new Promise(function(I, P) {
                return u1(s.getObservableFromLink(u, ae(ae({}, V), { optimisticResponse: o ? h : void 0 }), c, {}, !1), function(z) {
                  if (xu(z) && N === "none")
                    throw new ka({
                      graphQLErrors: rh(z)
                    });
                  a && (a.loading = !1, a.error = null);
                  var G = ae({}, z);
                  return typeof g == "function" && (g = g(G)), N === "ignore" && xu(G) && delete G.errors, s.markMutationResult({
                    mutationId: n,
                    result: G,
                    document: u,
                    variables: c,
                    fetchPolicy: C,
                    errorPolicy: N,
                    context: V,
                    update: $,
                    updateQueries: f,
                    awaitRefetchQueries: m,
                    refetchQueries: g,
                    removeOptimistic: o ? n : void 0,
                    onQueryUpdated: w,
                    keepRootFields: M
                  });
                }).subscribe({
                  next: function(z) {
                    s.broadcastQueries(), (!("hasNext" in z) || z.hasNext === !1) && I(ae(ae({}, z), { data: s.maskOperation({
                      document: u,
                      data: z.data,
                      fetchPolicy: C,
                      id: n
                    }) }));
                  },
                  error: function(z) {
                    a && (a.loading = !1, a.error = z), o && s.cache.removeOptimistic(n), s.broadcastQueries(), P(z instanceof ka ? z : new ka({
                      networkError: z
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, r) {
      var n = this;
      r === void 0 && (r = this.cache);
      var i = t.result, a = [], o = t.fetchPolicy === "no-cache";
      if (!o && lh(i, t.errorPolicy)) {
        if (Zo(i) || a.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), Zo(i) && na(i.incremental)) {
          var s = r.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          s.result && (l = c6(s.result, i)), typeof l < "u" && (i.data = l, a.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var d = t.updateQueries;
        d && this.queries.forEach(function(c, h) {
          var f = c.observableQuery, p = f && f.queryName;
          if (!(!p || !Qq.call(d, p))) {
            var g = d[p], v = n.queries.get(h), m = v.document, $ = v.variables, w = r.diff({
              query: m,
              variables: $,
              returnPartialData: !0,
              optimistic: !1
            }), k = w.result, C = w.complete;
            if (C && k) {
              var E = g(k, {
                mutationResult: i,
                queryName: m && wl(m) || void 0,
                queryVariables: $
              });
              E && a.push({
                result: E,
                dataId: "ROOT_QUERY",
                query: m,
                variables: $
              });
            }
          }
        });
      }
      if (a.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var u = [];
        if (this.refetchQueries({
          updateCache: function(c) {
            o || a.forEach(function(g) {
              return c.write(g);
            });
            var h = t.update, f = !eq(i) || Zo(i) && !i.hasNext;
            if (h) {
              if (!o) {
                var p = c.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: n.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                p.complete && (i = ae(ae({}, i), { data: p.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              f && h(c, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !o && !t.keepRootFields && f && c.modify({
              id: "ROOT_MUTATION",
              fields: function(g, v) {
                var m = v.fieldName, $ = v.DELETE;
                return m === "__typename" ? g : $;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(c) {
          return u.push(c);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(u).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, r) {
      var n = this, i = typeof t == "function" ? t(r.variables, { IGNORE: ag }) : t;
      return i === ag ? !1 : (this.cache.recordOptimisticTransaction(function(a) {
        try {
          n.markMutationResult(ae(ae({}, r), { result: { data: i } }), a);
        } catch (o) {
          globalThis.__DEV__ !== !1 && Ne.error(o);
        }
      }, r.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, r, n) {
      return this.fetchConcastWithInfo(t, r, n).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(r, n) {
        t[n] = {
          variables: r.variables,
          networkStatus: r.networkStatus,
          networkError: r.networkError,
          graphQLErrors: r.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var r = this.queries.get(t);
      r && (r.networkError = void 0, r.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var r = this.transformCache;
      if (!r.has(t)) {
        var n = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: IV(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: Yl(["nonreactive"], t),
          nonReactiveQuery: LU(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: i6([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: bU(hs(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: ae(ae({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? ae(ae({}, i), { operation: "query" }) : i;
          }) })
        };
        r.set(t, n);
      }
      return r.get(t);
    }, e.prototype.getVariables = function(t, r) {
      return ae(ae({}, this.getDocumentInfo(t).defaultVars), r);
    }, e.prototype.watchQuery = function(t) {
      var r = this.transform(t.query);
      t = ae(ae({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var n = new p1(this), i = new sh({
        queryManager: this,
        queryInfo: n,
        options: t
      });
      return i.lastQuery = r, this.queries.set(i.queryId, n), n.init({
        document: r,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, r) {
      var n = this;
      r === void 0 && (r = this.generateQueryId()), Ne(t.query, 30), Ne(t.query.kind === "Document", 31), Ne(!t.returnPartialData, 32), Ne(!t.pollInterval, 33);
      var i = this.transform(t.query);
      return this.fetchQuery(r, ae(ae({}, t), { query: i })).then(function(a) {
        return a && ae(ae({}, a), { data: n.maskOperation({
          document: i,
          data: a.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      }).finally(function() {
        return n.stopQuery(r);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var r = this.queries.get(t);
      r && r.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(ei(34)), this.queries.forEach(function(r) {
        r.observableQuery ? r.networkStatus = vt.loading : r.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = "active");
      var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), a.set(s, !1);
        else if (iU(s)) {
          var l = Fo(r.transform(s));
          i.set(l, wl(s)), a.set(l, !1);
        } else Qn(s) && s.query && o.add(s);
      }), this.queries.forEach(function(s, l) {
        var d = s.observableQuery, u = s.document;
        if (d) {
          if (t === "all") {
            n.set(l, d);
            return;
          }
          var c = d.queryName, h = d.options.fetchPolicy;
          if (h === "standby" || t === "active" && !d.hasObservers())
            return;
          (t === "active" || c && a.has(c) || u && a.has(Fo(u))) && (n.set(l, d), c && a.set(c, !0), u && a.set(Fo(u), !0));
        }
      }), o.size && o.forEach(function(s) {
        var l = Q2("legacyOneTimeQuery"), d = r.getQuery(l).init({
          document: s.query,
          variables: s.variables
        }), u = new sh({
          queryManager: r,
          queryInfo: d,
          options: ae(ae({}, s), { fetchPolicy: "network-only" })
        });
        Ne(u.queryId === l), d.setObservableQuery(u), n.set(l, u);
      }), globalThis.__DEV__ !== !1 && a.size && a.forEach(function(s, l) {
        if (!s) {
          var d = i.get(l);
          d ? globalThis.__DEV__ !== !1 && Ne.warn(35, d) : globalThis.__DEV__ !== !1 && Ne.warn(36);
        }
      }), n;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = !1);
      var n = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, a) {
        var o = i.options.fetchPolicy;
        i.resetLastResults(), (t || o !== "standby" && o !== "cache-only") && n.push(i.refetch()), r.getQuery(a).setDiff(null);
      }), this.broadcastQueries(), Promise.all(n);
    }, e.prototype.setObservableQuery = function(t) {
      this.getQuery(t.queryId).setObservableQuery(t);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var r = this, n = t.query, i = t.variables, a = t.fetchPolicy, o = t.errorPolicy, s = o === void 0 ? "none" : o, l = t.context, d = l === void 0 ? {} : l, u = t.extensions, c = u === void 0 ? {} : u;
      n = this.transform(n), i = this.getVariables(n, i);
      var h = function(p) {
        return r.getObservableFromLink(n, d, p, c).map(function(g) {
          a !== "no-cache" && (lh(g, s) && r.cache.write({
            query: n,
            result: g.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: p
          }), r.broadcastQueries());
          var v = xu(g), m = gq(g);
          if (v || m) {
            var $ = {};
            if (v && ($.graphQLErrors = g.errors), m && ($.protocolErrors = g.extensions[Bf]), s === "none" || m)
              throw new ka($);
          }
          return s === "ignore" && delete g.errors, g;
        });
      };
      if (this.getDocumentInfo(n).hasClientExports) {
        var f = this.localState.addExportedVariables(n, i, d).then(h);
        return new Mt(function(p) {
          var g = null;
          return f.then(function(v) {
            return g = v.subscribe(p);
          }, p.error), function() {
            return g && g.unsubscribe();
          };
        });
      }
      return h(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      this.fetchCancelFns.delete(t), this.queries.has(t) && (this.getQuery(t).stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        return t.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, r, n, i, a) {
      var o = this, s;
      a === void 0 && (a = (s = r?.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var l, d = this.getDocumentInfo(t), u = d.serverQuery, c = d.clientQuery;
      if (u) {
        var h = this, f = h.inFlightLinkObservables, p = h.link, g = {
          query: u,
          variables: n,
          operationName: wl(u) || void 0,
          context: this.prepareContext(ae(ae({}, r), { forceFetch: !a })),
          extensions: i
        };
        if (r = g.context, a) {
          var v = Fo(u), m = Lf(n), $ = f.lookup(v, m);
          if (l = $.observable, !l) {
            var w = new To([
              nh(p, g)
            ]);
            l = $.observable = w, w.beforeNext(function k(C, E) {
              C === "next" && "hasNext" in E && E.hasNext ? w.beforeNext(k) : f.remove(v, m);
            });
          }
        } else
          l = new To([
            nh(p, g)
          ]);
      } else
        l = new To([Mt.of({ data: {} })]), r = this.prepareContext(r);
      return c && (l = u1(l, function(k) {
        return o.localState.runResolvers({
          document: c,
          remoteResult: k,
          context: r,
          variables: n
        });
      })), l;
    }, e.prototype.getResultsFromLink = function(t, r, n) {
      var i = t.lastRequestId = this.generateRequestId(), a = this.cache.transformForLink(n.query);
      return u1(this.getObservableFromLink(a, n.context, n.variables), function(o) {
        var s = rh(o), l = s.length > 0, d = n.errorPolicy;
        if (i >= t.lastRequestId) {
          if (l && d === "none")
            throw t.markError(new ka({
              graphQLErrors: s
            }));
          t.markResult(o, a, n, r), t.markReady();
        }
        var u = {
          data: o.data,
          loading: !1,
          networkStatus: vt.ready
        };
        return l && d === "none" && (u.data = void 0), l && d !== "ignore" && (u.errors = s, u.networkStatus = vt.error), u;
      }, function(o) {
        var s = f6(o) ? o : new ka({ networkError: o });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, r, n, i) {
      var a = this;
      n === void 0 && (n = vt.loading), i === void 0 && (i = r.query);
      var o = this.getVariables(i, r.variables), s = this.getQuery(t), l = this.defaultOptions.watchQuery, d = r.fetchPolicy, u = d === void 0 ? l && l.fetchPolicy || "cache-first" : d, c = r.errorPolicy, h = c === void 0 ? l && l.errorPolicy || "none" : c, f = r.returnPartialData, p = f === void 0 ? !1 : f, g = r.notifyOnNetworkStatusChange, v = g === void 0 ? !1 : g, m = r.context, $ = m === void 0 ? {} : m, w = Object.assign({}, r, {
        query: i,
        variables: o,
        fetchPolicy: u,
        errorPolicy: h,
        returnPartialData: p,
        notifyOnNetworkStatusChange: v,
        context: $
      }), k = function(V) {
        w.variables = V;
        var q = a.fetchQueryByPolicy(s, w, n);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          w.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          q.sources.length > 0 && s.observableQuery && s.observableQuery.applyNextFetchPolicy("after-fetch", r), q
        );
      }, C = function() {
        return a.fetchCancelFns.delete(t);
      };
      this.fetchCancelFns.set(t, function(V) {
        C(), setTimeout(function() {
          return E.cancel(V);
        });
      });
      var E, N;
      if (this.getDocumentInfo(w.query).hasClientExports)
        E = new To(this.localState.addExportedVariables(w.query, w.variables, w.context).then(k).then(function(V) {
          return V.sources;
        })), N = !0;
      else {
        var M = k(w.variables);
        N = M.fromLink, E = new To(M.sources);
      }
      return E.promise.then(C, C), {
        concast: E,
        fromLink: N
      };
    }, e.prototype.refetchQueries = function(t) {
      var r = this, n = t.updateCache, i = t.include, a = t.optimistic, o = a === void 0 ? !1 : a, s = t.removeOptimistic, l = s === void 0 ? o ? Q2("refetchQueries") : void 0 : s, d = t.onQueryUpdated, u = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(h, f) {
        u.set(f, {
          oq: h,
          lastDiff: r.getQuery(f).getDiff()
        });
      });
      var c = /* @__PURE__ */ new Map();
      return n && this.cache.batch({
        update: n,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: o && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(h, f, p) {
          var g = h.watcher instanceof p1 && h.watcher.observableQuery;
          if (g) {
            if (d) {
              u.delete(g.queryId);
              var v = d(g, f, p);
              return v === !0 && (v = g.refetch()), v !== !1 && c.set(g, v), v;
            }
            d !== null && u.set(g.queryId, { oq: g, lastDiff: p, diff: f });
          }
        }
      }), u.size && u.forEach(function(h, f) {
        var p = h.oq, g = h.lastDiff, v = h.diff, m;
        if (d) {
          if (!v) {
            var $ = p.queryInfo;
            $.reset(), v = $.getDiff();
          }
          m = d(p, v, g);
        }
        (!d || m === !0) && (m = p.refetch()), m !== !1 && c.set(p, m), f.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(f);
      }), l && this.cache.removeOptimistic(l), c;
    }, e.prototype.maskOperation = function(t) {
      var r, n, i, a = t.document, o = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, l = t.id, d = (r = hs(a)) === null || r === void 0 ? void 0 : r.operation, u = ((n = d?.[0]) !== null && n !== void 0 ? n : "o") + l;
        this.dataMasking && s === "no-cache" && !VV(a) && !this.noCacheWarningsByQueryId.has(u) && (this.noCacheWarningsByQueryId.add(u), globalThis.__DEV__ !== !1 && Ne.warn(
          37,
          (i = wl(a)) !== null && i !== void 0 ? i : "Unnamed ".concat(d ?? "operation")
        ));
      }
      return this.dataMasking ? qq(o, a, this.cache) : o;
    }, e.prototype.maskFragment = function(t) {
      var r = t.data, n = t.fragment, i = t.fragmentName;
      return this.dataMasking ? Uq(r, n, this.cache, i) : r;
    }, e.prototype.fetchQueryByPolicy = function(t, r, n) {
      var i = this, a = r.query, o = r.variables, s = r.fetchPolicy, l = r.refetchWritePolicy, d = r.errorPolicy, u = r.returnPartialData, c = r.context, h = r.notifyOnNetworkStatusChange, f = t.networkStatus;
      t.init({
        document: a,
        variables: o,
        networkStatus: n
      });
      var p = function() {
        return t.getDiff();
      }, g = function(k, C) {
        C === void 0 && (C = t.networkStatus || vt.loading);
        var E = k.result;
        globalThis.__DEV__ !== !1 && !u && !qt(E, {}) && w6(k.missing);
        var N = function(M) {
          return Mt.of(ae({ data: M, loading: Xo(C), networkStatus: C }, k.complete ? null : { partial: !0 }));
        };
        return E && i.getDocumentInfo(a).hasForcedResolvers ? i.localState.runResolvers({
          document: a,
          remoteResult: { data: E },
          context: c,
          variables: o,
          onlyRunForcedResolvers: !0
        }).then(function(M) {
          return N(M.data || void 0);
        }) : d === "none" && C === vt.refetch && Array.isArray(k.missing) ? N(void 0) : N(E);
      }, v = s === "no-cache" ? 0 : n === vt.refetch && l !== "merge" ? 1 : 2, m = function() {
        return i.getResultsFromLink(t, v, {
          query: a,
          variables: o,
          context: c,
          fetchPolicy: s,
          errorPolicy: d
        });
      }, $ = h && typeof f == "number" && f !== n && Xo(n);
      switch (s) {
        default:
        case "cache-first": {
          var w = p();
          return w.complete ? {
            fromLink: !1,
            sources: [g(w, t.markReady())]
          } : u || $ ? {
            fromLink: !0,
            sources: [g(w), m()]
          } : { fromLink: !0, sources: [m()] };
        }
        case "cache-and-network": {
          var w = p();
          return w.complete || u || $ ? {
            fromLink: !0,
            sources: [g(w), m()]
          } : { fromLink: !0, sources: [m()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [g(p(), t.markReady())]
          };
        case "network-only":
          return $ ? {
            fromLink: !0,
            sources: [g(p()), m()]
          } : { fromLink: !0, sources: [m()] };
        case "no-cache":
          return $ ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [g(t.getDiff()), m()]
          } : { fromLink: !0, sources: [m()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new p1(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var r = this.localState.prepareContext(t);
      return ae(ae(ae({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
    }, e;
  }()
), Yq = (
  /** @class */
  function() {
    function e(t) {
      var r = t.cache, n = t.client, i = t.resolvers, a = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, n && (this.client = n), i && this.addResolvers(i), a && this.setFragmentMatcher(a);
    }
    return e.prototype.addResolvers = function(t) {
      var r = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
        r.resolvers = Vm(r.resolvers, n);
      }) : this.resolvers = Vm(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return ji(this, arguments, void 0, function(r) {
        var n = r.document, i = r.remoteResult, a = r.context, o = r.variables, s = r.onlyRunForcedResolvers, l = s === void 0 ? !1 : s;
        return Vi(this, function(d) {
          return n ? [2, this.resolveDocument(n, i.data, a, o, this.fragmentMatcher, l).then(function(u) {
            return ae(ae({}, i), { data: u.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return Yl(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return a6(t);
    }, e.prototype.prepareContext = function(t) {
      var r = this.cache;
      return ae(ae({}, t), {
        cache: r,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(n) {
          return r.identify(n);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return ji(this, arguments, void 0, function(r, n, i) {
        return n === void 0 && (n = {}), i === void 0 && (i = {}), Vi(this, function(a) {
          return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, n) || {}, this.prepareContext(i), n).then(function(o) {
            return ae(ae({}, n), o.exportedVariables);
          })] : [2, ae({}, n)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var r = !1;
      return Pn(t, {
        Directive: {
          enter: function(n) {
            if (n.name.value === "client" && n.arguments && (r = n.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), r))
              return Bc;
          }
        }
      }), r;
    }, e.prototype.buildRootValueFromCache = function(t, r) {
      return this.cache.diff({
        query: NU(t),
        variables: r,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, r) {
      return ji(this, arguments, void 0, function(n, i, a, o, s, l) {
        var d, u, c, h, f, p, g, v, m, $, w;
        return a === void 0 && (a = {}), o === void 0 && (o = {}), s === void 0 && (s = function() {
          return !0;
        }), l === void 0 && (l = !1), Vi(this, function(k) {
          return d = Xc(n), u = yd(n), c = gd(u), h = this.collectSelectionsToResolve(d, c), f = d.operation, p = f ? f.charAt(0).toUpperCase() + f.slice(1) : "Query", g = this, v = g.cache, m = g.client, $ = {
            fragmentMap: c,
            context: ae(ae({}, a), { cache: v, client: m }),
            variables: o,
            fragmentMatcher: s,
            defaultOperationType: p,
            exportedVariables: {},
            selectionsToResolve: h,
            onlyRunForcedResolvers: l
          }, w = !1, [2, this.resolveSelectionSet(d.selectionSet, w, i, $).then(function(C) {
            return {
              result: C,
              exportedVariables: $.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, r, n, i) {
      return ji(this, void 0, void 0, function() {
        var a, o, s, l, d, u = this;
        return Vi(this, function(c) {
          return a = i.fragmentMap, o = i.context, s = i.variables, l = [n], d = function(h) {
            return ji(u, void 0, void 0, function() {
              var f, p;
              return Vi(this, function(g) {
                return !r && !i.selectionsToResolve.has(h) ? [
                  2
                  /*return*/
                ] : R7(h, s) ? oc(h) ? [2, this.resolveField(h, r, n, i).then(function(v) {
                  var m;
                  typeof v < "u" && l.push((m = {}, m[ac(h)] = v, m));
                })] : (gU(h) ? f = h : (f = a[h.name.value], Ne(f, 19, h.name.value)), f && f.typeCondition && (p = f.typeCondition.name.value, i.fragmentMatcher(n, p, o)) ? [2, this.resolveSelectionSet(f.selectionSet, r, n, i).then(function(v) {
                  l.push(v);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(d)).then(function() {
            return o6(l);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, r, n, i) {
      return ji(this, void 0, void 0, function() {
        var a, o, s, l, d, u, c, h, f, p = this;
        return Vi(this, function(g) {
          return n ? (a = i.variables, o = t.name.value, s = ac(t), l = o !== s, d = n[s] || n[o], u = Promise.resolve(d), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (c = n.__typename || i.defaultOperationType, h = this.resolvers && this.resolvers[c], h && (f = h[l ? o : s], f && (u = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            Bq.withValue(this.cache, f, [
              n,
              mU(t, a),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, u.then(function(v) {
            var m, $;
            if (v === void 0 && (v = d), t.directives && t.directives.forEach(function(k) {
              k.name.value === "export" && k.arguments && k.arguments.forEach(function(C) {
                C.name.value === "as" && C.value.kind === "StringValue" && (i.exportedVariables[C.value.value] = v);
              });
            }), !t.selectionSet || v == null)
              return v;
            var w = ($ = (m = t.directives) === null || m === void 0 ? void 0 : m.some(function(k) {
              return k.name.value === "client";
            })) !== null && $ !== void 0 ? $ : !1;
            if (Array.isArray(v))
              return p.resolveSubSelectedArray(t, r || w, v, i);
            if (t.selectionSet)
              return p.resolveSelectionSet(t.selectionSet, r || w, v, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, r, n, i) {
      var a = this;
      return Promise.all(n.map(function(o) {
        if (o === null)
          return null;
        if (Array.isArray(o))
          return a.resolveSubSelectedArray(t, r, o, i);
        if (t.selectionSet)
          return a.resolveSelectionSet(t.selectionSet, r, o, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, r) {
      var n = function(o) {
        return !Array.isArray(o);
      }, i = this.selectionsToResolveCache;
      function a(o) {
        if (!i.has(o)) {
          var s = /* @__PURE__ */ new Set();
          i.set(o, s), Pn(o, {
            Directive: function(l, d, u, c, h) {
              l.name.value === "client" && h.forEach(function(f) {
                n(f) && im(f) && s.add(f);
              });
            },
            FragmentSpread: function(l, d, u, c, h) {
              var f = r[l.name.value];
              Ne(f, 20, l.name.value);
              var p = a(f);
              p.size > 0 && (h.forEach(function(g) {
                n(g) && im(g) && s.add(g);
              }), s.add(l), p.forEach(function(g) {
                s.add(g);
              }));
            }
          });
        }
        return i.get(o);
      }
      return a(t);
    }, e;
  }()
), og = !1, Kq = (
  /** @class */
  function() {
    function e(t) {
      var r = this, n;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw ei(16);
      var i = t.uri, a = t.credentials, o = t.headers, s = t.cache, l = t.documentTransform, d = t.ssrMode, u = d === void 0 ? !1 : d, c = t.ssrForceFetchDelay, h = c === void 0 ? 0 : c, f = t.connectToDevTools, p = t.queryDeduplication, g = p === void 0 ? !0 : p, v = t.defaultOptions, m = t.defaultContext, $ = t.assumeImmutableResults, w = $ === void 0 ? s.assumeImmutableResults : $, k = t.resolvers, C = t.typeDefs, E = t.fragmentMatcher, N = t.name, M = t.version, V = t.devtools, q = t.dataMasking, I = t.link;
      I || (I = i ? new Dq({ uri: i, credentials: a, headers: o }) : bd.empty()), this.link = I, this.cache = s, this.disableNetworkFetches = u || h > 0, this.queryDeduplication = g, this.defaultOptions = v || /* @__PURE__ */ Object.create(null), this.typeDefs = C, this.devtoolsConfig = ae(ae({}, V), { enabled: (n = V?.enabled) !== null && n !== void 0 ? n : f }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), h && setTimeout(function() {
        return r.disableNetworkFetches = !1;
      }, h), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = Pf, this.localState = new Yq({
        cache: s,
        client: this,
        resolvers: k,
        fragmentMatcher: E
      }), this.queryManager = new Gq({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: m,
        documentTransform: l,
        queryDeduplication: g,
        ssrMode: u,
        dataMasking: !!q,
        clientAwareness: {
          name: N,
          version: M
        },
        localState: this.localState,
        assumeImmutableResults: w,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          r.devToolsHookCb && r.devToolsHookCb({
            action: {},
            state: {
              queries: r.queryManager.getQueryStore(),
              mutations: r.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: r.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, r = Symbol.for("apollo.devtools");
        (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this, !og && globalThis.__DEV__ !== !1 && (og = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var n = window.navigator, i = n && n.userAgent, a = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? a = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (a = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), a && globalThis.__DEV__ !== !1 && Ne.log("Download the Apollo DevTools for a better development experience: %s", a);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = ku(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = ae(ae({}, t), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = ku(this.defaultOptions.query, t)), Ne(t.fetchPolicy !== "cache-and-network", 17), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = ae(ae({}, t), { fetchPolicy: "cache-first" })), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = ku(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var r = this, n = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return ae(ae({}, i), { data: r.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      });
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readQuery(t, r);
    }, e.prototype.watchFragment = function(t) {
      var r;
      return this.cache.watchFragment(ae(ae({}, t), (r = {}, r[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, r)));
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readFragment(t, r);
    }, e.prototype.writeQuery = function(t) {
      var r = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.writeFragment = function(t) {
      var r = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return nh(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(r) {
          return r();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(r) {
          return r();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var r = this;
      return this.resetStoreCallbacks.push(t), function() {
        r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var r = this;
      return this.clearStoreCallbacks.push(t), function() {
        r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var r = this.queryManager.refetchQueries(t), n = [], i = [];
      r.forEach(function(o, s) {
        n.push(s), i.push(o);
      });
      var a = Promise.all(i);
      return a.queries = n, a.results = i, a.catch(function(o) {
        globalThis.__DEV__ !== !1 && Ne.debug(18, o);
      }), a;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
globalThis.__DEV__ !== !1 && (Kq.prototype.getMemoryInternals = KV);
const Zq = Le`
  query GetPrescription($id: ID!) {
    prescription(id: $id) {
      id
      daysSupply
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      instructions
      notes
      fillsAllowed
      treatment {
        id
        name
      }
    }
  }
`;
Le`
  query TemplatesFromCatalogs {
    catalogs {
      templates {
        id
        daysSupply
        dispenseAsWritten
        dispenseQuantity
        dispenseUnit
        instructions
        notes
        fillsAllowed
        treatment {
          id
          name
        }
      }
    }
  }
`;
Le`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      id
      preferredPharmacyId
      benefits {
        id
        bin
        groupId
        memberId
        pcn
      }
    }
  }
`;
const Hf = Le`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      preferredPharmacies {
        id
        name
        address {
          street1
          city
          state
        }
      }
      address {
        street1
        street2
        city
        state
        postalCode
      }
    }
  }
`, x6 = Le`
  query GetPharmacies($location: LatLongSearch!) {
    pharmacies(location: $location) {
      id
      name
      address {
        street1
        city
        state
      }
    }
  }
`, Xq = Le`
  query GetMailOrderPharmacies(
    $name: String
    $fulfillmentType: FulfillmentType
    $integrated: Boolean
    $limit: Int
    $offset: Int
  ) {
    pharmacies(
      name: $name
      fulfillmentType: $fulfillmentType
      integrated: $integrated
      limit: $limit
      offset: $offset
    ) {
      id
      name
      address {
        street1
        city
        state
      }
    }
  }
`, dc = async (e, t) => {
  if (typeof e != "string" && (!e.latitude || !e.longitude))
    return [];
  const r = await t.geocode({
    ...typeof e == "string" ? { address: e } : { location: { lat: e.latitude, lng: e.longitude } }
  });
  return r?.results?.length ? r.results.map(() => ({
    latitude: r.results[0].geometry.location.lat(),
    longitude: r.results[0].geometry.location.lng(),
    address: r.results[0].formatted_address
  })) : [];
};
let Jd = !1;
function Jq({ onLoad: e, onError: t }) {
  if (window?.google?.maps)
    e();
  else if (Jd) {
    const r = setInterval(() => {
      window?.google?.maps && (clearInterval(r), e());
    }, 100);
  } else {
    Jd = !0;
    const r = document.createElement("script");
    r.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAvuwwE6g2Bsmih66nu4dB7-H7U1_7KQ6g&callback=Function.prototype&libraries=places", document.head.appendChild(r), r.onload = () => {
      Jd = !1, e();
    }, r.onerror = (n) => {
      Jd = !1, t && t(n);
    };
  }
}
const k6 = Tr(), eB = (e) => {
  const [t, r] = H({
    geocoder: null,
    autocompleteService: null
  });
  return Et(() => {
    Jq({
      onLoad: () => {
        r({
          geocoder: new google.maps.Geocoder(),
          autocompleteService: new google.maps.places.AutocompleteService()
        });
      },
      onError: (n) => {
        console.error("Error loading Google Maps script:", n);
      }
    });
  }), b(k6.Provider, {
    value: {
      googleMapsServices: t
    },
    get children() {
      return e.children;
    }
  });
}, Wf = () => {
  const e = cr(k6);
  if (!e)
    throw new Error("useGoogleService must be used within the GoogleServiceProvider");
  return e;
}, Qf = Tr(), sg = (e, t) => ({
  externalId: e.externalId,
  patientId: t,
  treatmentId: e.treatment?.id,
  dispenseAsWritten: e.dispenseAsWritten,
  dispenseQuantity: e.dispenseQuantity,
  dispenseUnit: e.dispenseUnit,
  fillsAllowed: e.fillsAllowed,
  daysSupply: e.daysSupply,
  instructions: e.instructions,
  notes: e.notes,
  effectiveDate: If(/* @__PURE__ */ new Date(), "yyyy-MM-dd").toString(),
  diagnoses: e.diagnoseCodes
}), tB = (e) => {
  const {
    googleMapsServices: t
  } = Wf(), [r, n] = H(!1), [i, a] = H(!1), [o, s] = H([]), [l, d] = H(null), [u, c] = H(null), [h, f] = H(!1), [p, g] = H(), [v, m] = ua(), $ = Ln(), {
    draftPrescriptions: w,
    setDraftPrescriptions: k
  } = pd(), [, C] = Ps(), E = L(() => w().map((Z) => Z.id)), N = L(() => w().map((Z) => sj(Z))), M = L(() => Cm(N())), V = L(() => {
    const Z = Cm(N(), ["exclude"]);
    return new Set(Z.constraint_pharmacies?.map((F) => F.id) || []);
  });
  async function q(Z) {
    const {
      data: F
    } = await $.apollo.query({
      query: x6,
      variables: {
        location: {
          latitude: Z?.latitude,
          longitude: Z?.longitude
        }
      }
    });
    return F?.pharmacies ? F.pharmacies : [];
  }
  async function I(Z) {
    const {
      geocoder: F
    } = t();
    if (!F) throw new Error("Geocoder not loaded");
    const oe = `${Z?.street1}, ${Z?.city}, ${Z?.state} ${Z?.postalCode}`, pe = await dc(oe, F);
    return await q(pe[0]);
  }
  me(() => {
    (e.templateIdsPrefill.length > 0 || e.prescriptionIdsPrefill.length > 0) && e.patientId && // must not have created prescriptions yet
    !i() && P();
  }), me(() => {
    e.patientId && z(e.patientId).then(({
      pharmacies: Z,
      address: F
    }) => {
      Z.length > 0 && d(Z[0].id), F && c(F);
    });
  }), me(() => {
    e.patientId && (k([]), g(void 0), f(!1), s([]));
  }), me(() => {
    const Z = l(), F = w();
    if (!h() && // after an alternate is chosen, stop fetching coverages for this patient
    e.enableCoverageCheck && F.length > 0)
      if (Z)
        G(F, Z).then((oe) => {
          s(oe);
        });
      else {
        const oe = u();
        oe && I(oe).then((pe) => {
          let ee = null;
          ee = pe.find((re) => re.name.toLowerCase().includes("cvs") || re.name.toLowerCase().includes("walgreens") || re.name.toLowerCase().includes("walmart") || re.name.toLowerCase().includes("rite aid"))?.id || pe[0]?.id, ee && G(F, ee).then((re) => {
            s(re);
          });
        });
      }
  });
  async function P() {
    a(!0), n(!0);
    try {
      if (e.templateIdsPrefill.length > 0) {
        const Z = Array.from(new Set(e.templateIdsPrefill)).map((oe) => ({
          ...e.templateOverrides?.[oe],
          patientId: e.patientId,
          templateId: oe
        })), F = (await $.apollo.mutate({
          mutation: CV,
          variables: {
            prescriptions: Z
          }
        })).data.createPrescriptions;
        k((oe) => [...oe, ...F]);
      }
      if (e.prescriptionIdsPrefill.length > 0) {
        const Z = await Promise.all(e.prescriptionIdsPrefill.map(async (F) => {
          const {
            data: oe
          } = await $.apollo.query({
            query: Zq,
            variables: {
              id: F
            }
          });
          return oe?.prescription;
        }));
        await Promise.all(Z.map(async (F) => se(F, {
          showSuccessToast: !1
        })));
      }
    } catch (Z) {
      console.error("Error while trying to create prescriptions from prefill IDs", {
        error: Z
      });
    } finally {
      n(!1);
    }
  }
  const z = async (Z) => {
    try {
      const F = await $.apollo.query({
        query: Hf,
        variables: {
          id: Z
        }
      });
      return {
        pharmacies: F.data.patient.preferredPharmacies,
        address: F.data.patient.address
      };
    } catch (F) {
      throw ir({
        status: "error",
        header: "Error Looking Up Patient Pharmacy",
        body: F.message
      }), F;
    }
  }, G = async (Z, F) => (await $.apolloClinical.mutate({
    mutation: EV,
    variables: {
      pharmacyId: F,
      prescriptions: Z.map((oe) => ({
        id: oe.id
        // icd10codes: ['gotta get this']
      }))
    }
  })).data.generateCoverageOptions, se = async (Z, F = {
    showSuccessToast: !0
  }) => {
    if (nB(Z.treatment.id, w()))
      throw ir({
        status: "error",
        body: "You already have this prescription in your order. You can modify the prescription or delete it in Pending Order."
      }), new Error("Prescription already added");
    const oe = C.checkDuplicateFill(Z.treatment.name);
    return e.enableCombineAndDuplicate && oe && await new Promise((pe, ee) => {
      C.setIsDuplicateDialogOpen(!0, oe, pe, ee);
    }), await de(Z, F);
  }, ue = async (Z, F) => {
    try {
      return (await $.apolloClinical.mutate({
        mutation: SV,
        variables: {
          input: {
            ids: Z,
            state: F
          }
        }
      })).data.updatePrescriptionStates;
    } catch (oe) {
      throw console.error("Mutation error:", oe), ir({
        status: "error",
        header: "Error Saving Prescription(s)",
        body: oe.message
      }), oe;
    }
  }, de = async (Z, F = {
    addToTemplates: !1,
    showSuccessToast: !0
  }) => {
    let oe = null;
    try {
      const pe = (await $.apollo.mutate({
        mutation: _V,
        variables: sg(Z, e.patientId)
      })).data.createPrescription;
      oe = pe, k((ee) => [...ee, pe]);
    } catch (pe) {
      throw console.error("Mutation error:", pe), ir({
        status: "error",
        header: "Error Adding Prescription",
        body: "There was an issue adding the prescription. Please try again."
      }), pe;
    }
    return F?.addToTemplates && F?.catalogId != null && (await R(Z, F.catalogId, F.templateName), F.showSuccessToast && ir({
      status: "success",
      header: "Personal Template Saved"
    })), F.showSuccessToast && ir({
      status: "success",
      header: "Prescription Added",
      body: "You can send this order or add another prescription before sending it"
    }), oe;
  }, D = (Z) => {
    k((F) => F.filter((oe) => oe.id !== Z));
  }, R = async (Z, F, oe = "") => await $.apollo.mutate({
    mutation: kV,
    variables: {
      ...sg(Z, e.patientId),
      catalogId: F,
      isPrivate: !0,
      ...oe ? {
        name: oe
      } : {}
    }
  }), Q = {
    // values
    prescriptionIds: E,
    isLoadingPrefills: r,
    coverageOptions: o,
    routingConstraints: N,
    combinedRoutingConstraint: M,
    unroutablePharmacyIds: V,
    orderFormData: v,
    selectedCoverageOption: p,
    // actions
    tryCreatePrescription: se,
    tryUpdatePrescriptionStates: ue,
    deletePrescription: D,
    selectOtherCoverageOption: (Z) => {
      m("pharmacyId", Z.pharmacy.id), g(Z), f(!0);
    },
    setOrderFormData: m
  };
  return b(Qf.Provider, {
    value: Q,
    get children() {
      return e.children;
    }
  });
}, oo = () => {
  const e = cr(Qf);
  if (!e)
    throw new Error("usePrescribe must be used within the PrescribeProvider");
  return e;
}, rB = () => cr(Qf);
function nB(e, t) {
  return t.some((r) => r.treatment.id === e);
}
function ms({
  dispenseQuantity: e = 0,
  dispenseUnit: t = "",
  fillsAllowed: r = 0,
  instructions: n = ""
}) {
  const i = _6(r);
  return `${e} ${t}, ${i} Refill${i === 1 ? "" : "s"} - ${n}`;
}
function _6(e = 0) {
  return Math.max(e - 1, 0);
}
var iB = /* @__PURE__ */ x("<div><span class=font-semibold></span> interaction with "), aB = /* @__PURE__ */ x("<span class=font-semibold>"), oB = /* @__PURE__ */ x('<div class="text-sm text-gray-700">'), sB = /* @__PURE__ */ x("<div>"), lB = /* @__PURE__ */ x('<div class="flex grid-flow-col justify-start"><div class="flex flex-col gap-2"><div class=text-sm> ');
const dB = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase(), uB = {
  MINOR: "info",
  MODERATE: "warning",
  MAJOR: "error"
}, cB = (e, t) => t === "ALLERGEN" ? "error" : uB[e] ?? "info", hB = {
  PrescriptionScreeningAlertInvolvedDraftedPrescription: "(Pending Rx)",
  PrescriptionScreeningAlertInvolvedExistingPrescription: "(Existing Rx)",
  PrescriptionScreeningAlertInvolvedAllergen: "(Allergen)"
}, lg = (e, t) => e.filter((r) => r.id !== t), fB = (e) => hB[e] ?? "", dg = () => Zt("text-pretty mr-2 text-black text-base", {}), pB = (e) => b(X, {
  get when() {
    return e.screeningAlert.type === "DRUG";
  },
  get fallback() {
    return b(ke, {
      bold: !0,
      get class() {
        return dg();
      },
      children: "Allergy found"
    });
  },
  get children() {
    var t = iB(), r = t.firstChild;
    return r.nextSibling, S(r, () => dB(e.screeningAlert.severity)), S(t, b(kt, {
      get each() {
        return lg(e.screeningAlert.involvedEntities, e.owningId);
      },
      children: (n, i) => [(() => {
        var a = aB();
        return S(a, () => n.name), a;
      })(), " ", L(() => fB(n.__typename)), L(() => i() < lg(e.screeningAlert.involvedEntities, e.owningId).length - 1 && " and ")]
    }), null), J(() => ot(t, dg())), t;
  }
}), mB = (e) => {
  const [t, r] = H(), [n, i] = H(!1), a = () => {
    i(!n());
  };
  return me(() => {
    r(e.screeningAlert.type === "ALLERGEN");
  }), b(ca, {
    iconName: "exclamationTriangle",
    get status() {
      return cB(e.screeningAlert.severity, e.screeningAlert.type);
    },
    withBorder: !0,
    get children() {
      var o = lB(), s = o.firstChild, l = s.firstChild;
      return l.firstChild, S(l, () => pB(e), null), S(s, b(X, {
        get when() {
          return n() || t();
        },
        get children() {
          var d = oB();
          return S(d, () => e.screeningAlert.description), d;
        }
      }), null), S(s, b(X, {
        get when() {
          return !t();
        },
        get children() {
          var d = sB();
          return d.$$click = () => {
            a();
          }, S(d, b(ke, {
            bold: !0,
            class: "text-blue-600 cursor-pointer",
            size: "xs",
            get children() {
              return ["See ", L(() => n() ? "less" : "more")];
            }
          })), d;
        }
      }), null), o;
    }
  });
};
cn(["click"]);
var gB = /* @__PURE__ */ x('<div class="grid gap-4">');
const C6 = (e) => b(X, {
  get when() {
    return e.screeningAlerts.length > 0;
  },
  get children() {
    var t = gB();
    return S(t, b(kt, {
      get each() {
        return e.screeningAlerts;
      },
      children: (r) => b(mB, {
        screeningAlert: r,
        get owningId() {
          return e.owningId;
        }
      })
    })), t;
  }
});
var vB = /* @__PURE__ */ x('<div class="flex grid-flow-col justify-start"><div class="flex flex-col gap-2">'), yB = /* @__PURE__ */ x('<div class="text-sm text-gray-700"> interaction with <!> '), bB = /* @__PURE__ */ x('<div class="text-sm text-gray-700">');
const $B = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase(), wB = {
  PrescriptionScreeningAlertInvolvedDraftedPrescription: "(Pending Rx)",
  PrescriptionScreeningAlertInvolvedExistingPrescription: "(Existing Rx)",
  PrescriptionScreeningAlertInvolvedAllergen: "(Allergen)"
}, xB = (e) => wB[e] ?? "", m1 = (e) => e === "PrescriptionScreeningAlertInvolvedAllergen";
function kB(e) {
  const t = /* @__PURE__ */ new Set();
  return e.filter((r) => t.has(r.id) ? !1 : (t.add(r.id), !0));
}
const _B = (e) => b(ca, {
  withoutIcon: !0,
  withBorder: !0,
  status: "suggestion",
  get children() {
    var t = vB(), r = t.firstChild;
    return S(r, b(X, {
      get when() {
        return !m1(e.screeningAlertByEntity.entity.__typename);
      },
      get children() {
        return [b(ke, {
          bold: !0,
          get children() {
            return e.screeningAlertByEntity.entity.name;
          }
        }), b(kt, {
          get each() {
            return e.screeningAlertByEntity.alerts;
          },
          children: (n) => b(kt, {
            get each() {
              return kB(n.involvedEntities);
            },
            children: (i) => [b(X, {
              get when() {
                return !m1(i.__typename);
              },
              get children() {
                return b(X, {
                  get when() {
                    return i.id != e.screeningAlertByEntity.entity.id;
                  },
                  get children() {
                    var a = yB(), o = a.firstChild, s = o.nextSibling;
                    return s.nextSibling, S(a, () => $B(n.severity), o), S(a, () => i.name, s), S(a, () => xB(i.__typename), null), a;
                  }
                });
              }
            }), b(X, {
              get when() {
                return m1(i.__typename);
              },
              get children() {
                return b(kt, {
                  get each() {
                    return e.otherAlertsByEntity.filter((a) => a.entity.id === i.id);
                  },
                  children: (a) => b(kt, {
                    get each() {
                      return a.alerts.filter((o) => o.type === "ALLERGEN");
                    },
                    children: (o) => (() => {
                      var s = bB();
                      return S(s, () => o.description), s;
                    })()
                  })
                });
              }
            })]
          })
        })];
      }
    })), t;
  }
});
var CB = /* @__PURE__ */ x('<div class="grid gap-4">');
function ug(e) {
  return Object.values(e.flatMap((t) => t.involvedEntities.map((r) => ({
    entity: r,
    alert: t
  }))).reduce((t, r) => {
    const n = r.entity.id;
    return t[n] || (t[n] = {
      entity: r.entity,
      alerts: []
    }), t[n].alerts.push(r.alert), t;
  }, {}));
}
const SB = (e) => (() => {
  var t = CB();
  return S(t, b(kt, {
    get each() {
      return ug(e.screeningAlerts).filter((r) => r.entity.__typename != "PrescriptionScreeningAlertInvolvedAllergen");
    },
    children: (r) => b(_B, {
      screeningAlertByEntity: r,
      get otherAlertsByEntity() {
        return ug(e.screeningAlerts);
      }
    })
  })), t;
})(), Kr = (e, t, r) => {
  const n = new CustomEvent("photon-datadog-action", {
    composed: !0,
    bubbles: !0,
    detail: {
      action: e,
      data: { ...t, timestamp: (/* @__PURE__ */ new Date()).toISOString() }
    }
  });
  r?.dispatchEvent(n);
};
var EB = /* @__PURE__ */ x('<div class="grid gap-6"><div class="flex flex-col gap-6"><div><div class="table bg-blue-50 text-blue-600 p-2 rounded-full mb-4"></div></div></div><div class="flex flex-col items-stretch gap-2">');
function TB(e) {
  const t = e.filter((i) => i.type === "ALLERGEN").length, r = e.filter((i) => i.type === "DRUG").length, n = [];
  return t === 1 ? n.push("a known allergy") : t > 1 && n.push("known allergies"), r === 1 ? n.push("a known interaction") : r > 1 && n.push("known interactions"), n.join(" and ");
}
function AB(e) {
  const [t, r] = H(!0);
  let n;
  function i() {
    Kr("prescribe-clinical-alerting-acknowledge-alerts", e.alerts.reduce((o, s, l) => (o[l] = s.description, o), {}), n), e.onIgnoreWarningAndCreateAnyway();
  }
  function a() {
    Kr("prescribe-clinical-alerting-revisit-prescriptions", e.alerts.reduce((o, s, l) => (o[l] = s.description, o), {}), n), e.onRevisitPrescriptions();
  }
  return b(ao, {
    get open() {
      return t();
    },
    onClose: () => {
      r(!1), e.onRevisitPrescriptions();
    },
    get children() {
      var o = EB(), s = o.firstChild, l = s.firstChild, d = l.firstChild, u = s.nextSibling, c = n;
      return typeof c == "function" ? bn(c, o) : n = o, S(d, b(rt, {
        name: "exclamationCircle"
      })), S(l, b(ke, {
        bold: !0,
        get children() {
          return ["Are you sure you want to send an order with ", L(() => TB(e.alerts)), "?"];
        }
      }), null), S(o, b(SB, {
        get screeningAlerts() {
          return e.alerts;
        }
      }), u), S(u, b(st, {
        size: "xl",
        onClick: () => {
          r(!1), i();
        },
        children: "Send order"
      }), null), S(u, b(st, {
        variant: "secondary",
        size: "xl",
        onClick: () => {
          r(!1), a();
        },
        children: "Cancel"
      }), null), o;
    }
  });
}
var OB = /* @__PURE__ */ x('<div class="flex flex-col md:flex-row justify-between md:items-center gap-4 md:gap-1 w-full"><div class="flex flex-col text-xs"><div class=font-bold></div><div></div></div><div class="text-xs text-left md:text-right whitespace-nowrap"><span>Est. Copay: </span><span class=font-bold>'), IB = /* @__PURE__ */ x("<div>Alerts"), PB = /* @__PURE__ */ x("<ul>"), DB = /* @__PURE__ */ x('<div class="flex flex-col gap-4"><div class="flex flex-col"><div class="text-xs text-gray-500"><span>Quantity / Days Supply: </span><span class=font-bold></span></div><div class="text-xs text-gray-500"><span>Pharmacy: </span><span class=font-bold>'), MB = /* @__PURE__ */ x('<div class="text-xs text-gray-500"><span>Instructions: </span><span>'), NB = /* @__PURE__ */ x('<div class="text-xs text-gray-500"><span>Refills: </span><span>'), LB = /* @__PURE__ */ x("<li class=text-xs><span class=text-gray-600>: </span><span class=text-gray-500>");
function S6(e) {
  const t = L(() => e.coverageOption.paRequired ? {
    status: "warning",
    message: "PA Required"
  } : e.coverageOption.status === "COVERED" ? {
    status: "success",
    message: "Covered by Insurance"
  } : e.coverageOption.status === "COVERED_WITH_RESTRICTIONS" ? {
    status: "warning",
    message: "Covered with Restrictions",
    subMessage: e.coverageOption.statusMessage
  } : {
    status: "error",
    message: "Not Covered by Insurance",
    subMessage: e.coverageOption.statusMessage
  }), r = L(() => e.coverageOption.alerts.filter((n) => n.text !== e.coverageOption.statusMessage));
  return (() => {
    var n = DB(), i = n.firstChild, a = i.firstChild, o = a.firstChild, s = o.nextSibling, l = a.nextSibling, d = l.firstChild, u = d.nextSibling;
    return S(s, () => `${e.coverageOption.dispenseQuantity} ${e.coverageOption.dispenseUnit} / ${e.coverageOption.daysSupply}`), S(i, b(X, {
      get when() {
        return e.prescription;
      },
      children: (c) => [(() => {
        var h = MB(), f = h.firstChild, p = f.nextSibling;
        return S(p, () => c().instructions), h;
      })(), (() => {
        var h = NB(), f = h.firstChild, p = f.nextSibling;
        return S(p, () => _6(c().fillsAllowed)), h;
      })()]
    }), l), S(u, () => e.coverageOption.pharmacy.name), S(n, b(ca, {
      get status() {
        return t().status;
      },
      withoutIcon: !0,
      get children() {
        var c = OB(), h = c.firstChild, f = h.firstChild, p = f.nextSibling, g = h.nextSibling, v = g.firstChild, m = v.nextSibling;
        return S(f, () => t().message), S(p, () => t().subMessage), S(m, () => FB(e.coverageOption.price)), c;
      }
    }), null), S(n, b(X, {
      get when() {
        return r().length > 0;
      },
      get children() {
        return [IB(), (() => {
          var c = PB();
          return S(c, b(kt, {
            get each() {
              return r();
            },
            children: (h) => (() => {
              var f = LB(), p = f.firstChild, g = p.firstChild, v = p.nextSibling;
              return S(p, () => h.label, g), S(v, () => h.text), f;
            })()
          })), c;
        })()];
      }
    }), null), n;
  })();
}
function FB(e) {
  return e ? `$${e.toFixed(0)}` : "N/A";
}
var RB = /* @__PURE__ */ x("<div>Other Options"), zB = /* @__PURE__ */ x('<div class="flex flex-col gap-2"><div class="flex flex-col gap-2"><div class="flex flex-col gap-2"><div class=text-sm></div></div></div><div class="flex justify-end mt-2">');
function jB(e) {
  return [RB(), b(kt, {
    get each() {
      return e.coverageOptions;
    },
    children: (t) => b(VB, {
      coverageOption: t,
      get handleSwapToOtherPrescription() {
        return e.handleSwapToOtherPrescription;
      }
    })
  })];
}
function VB(e) {
  const t = async () => {
    e.handleSwapToOtherPrescription(e.coverageOption);
  };
  return b(hn, {
    class: "mb-1",
    get children() {
      var r = zB(), n = r.firstChild, i = n.firstChild, a = i.firstChild, o = n.nextSibling;
      return S(a, () => e.coverageOption.treatment.name), S(i, b(S6, {
        get coverageOption() {
          return e.coverageOption;
        }
      }), null), S(o, b(st, {
        size: "sm",
        variant: "naked",
        "on:click": t,
        children: "Select This Option"
      })), r;
    }
  });
}
function UB(e, t) {
  return {
    id: e.id,
    effectiveDate: If(/* @__PURE__ */ new Date(), "yyyy-MM-dd").toString(),
    dispenseAsWritten: e.dispenseAsWritten || !1,
    dispenseQuantity: e.dispenseQuantity,
    dispenseUnit: e.dispenseUnit,
    daysSupply: e.daysSupply || 0,
    instructions: e.instructions,
    notes: e.notes || "",
    fillsAllowed: e.fillsAllowed,
    diagnoseCodes: [],
    catalogId: t,
    externalId: e.externalId || void 0,
    treatment: {
      id: e.treatment.id,
      name: e.treatment.name
    }
  };
}
var qB = /* @__PURE__ */ x("<button title=Edit>"), BB = /* @__PURE__ */ x("<button title=Delete>"), HB = /* @__PURE__ */ x('<div class="flex flex-col gap-4"><div class="flex justify-between items-center gap-4"><div class="flex flex-col items-start">'), WB = /* @__PURE__ */ x('<div class="flex items-start gap-3"> ');
function QB(e) {
  const t = L(() => e.screeningAlerts.filter((a) => a.involvedEntities.map((o) => o.id).indexOf(e.draft.treatment.id) >= 0)), r = L(() => e.routingConstraint && pj({
    prescription: e.draft,
    routingConstraint: e.routingConstraint
  })), n = L(() => e.coverageOptions.find((a) => !a.isAlternative)), i = L(() => e.coverageOptions.filter((a) => a.isAlternative));
  return b(E6, {
    get LeftChildren() {
      return [b(ke, {
        get children() {
          return e.draft.treatment.name;
        }
      }), b(X, {
        get when() {
          return n() === void 0;
        },
        get children() {
          return b(ke, {
            color: "gray",
            size: "sm",
            get children() {
              return ms({
                // need to use nullish coalescing here because draft types are eg `Maybe<number> | undefined`
                dispenseQuantity: e.draft?.dispenseQuantity ?? void 0,
                dispenseUnit: e.draft?.dispenseUnit ?? void 0,
                fillsAllowed: e.draft?.fillsAllowed ?? void 0,
                instructions: e.draft?.instructions ?? void 0
              });
            }
          });
        }
      })];
    },
    get RightChildren() {
      return [(() => {
        var a = qB();
        return a.$$click = () => e.handleEdit && e.handleEdit(UB(e.draft)), S(a, b(rt, {
          name: "pencilSquare",
          size: "sm",
          class: "text-gray-500 hover:text-amber-500"
        })), a;
      })(), (() => {
        var a = BB();
        return a.$$click = () => e.handleDelete && e.handleDelete(e.draft.id), S(a, b(rt, {
          name: "trash",
          size: "sm",
          class: "text-gray-500 hover:text-red-500"
        })), a;
      })()];
    },
    get BottomChildren() {
      return [b(X, {
        get when() {
          return t().length > 0;
        },
        get children() {
          return b(C6, {
            get screeningAlerts() {
              return t();
            },
            get owningId() {
              return e.draft.treatment.id;
            }
          });
        }
      }), b(X, {
        get when() {
          return r();
        },
        get children() {
          return r();
        }
      }), b(X, {
        get when() {
          return n();
        },
        children: (a) => b(S6, {
          get coverageOption() {
            return a();
          },
          get prescription() {
            return e.draft;
          }
        })
      }), b(X, {
        get when() {
          return i().length > 0;
        },
        get children() {
          return b(jB, {
            get coverageOptions() {
              return i();
            },
            get handleSwapToOtherPrescription() {
              return e.handleSwapToOtherPrescription;
            }
          });
        }
      })];
    }
  });
}
const E6 = (e) => (() => {
  var t = HB(), r = t.firstChild, n = r.firstChild;
  return S(n, () => e.LeftChildren), S(r, b(X, {
    get when() {
      return e?.RightChildren;
    },
    children: (i) => (() => {
      var a = WB();
      return a.firstChild, S(a, i, null), a;
    })()
  }), null), S(t, b(X, {
    get when() {
      return e?.BottomChildren;
    },
    children: (i) => i()
  }), null), t;
})();
cn(["click"]);
var GB = /* @__PURE__ */ x('<div><div aria-hidden=true class="absolute inset-0 flex items-center"><div class="w-full border-t border-gray-300">');
function YB(e) {
  const t = L(() => Zt("relative", e.class));
  return (() => {
    var r = GB();
    return J(() => ot(r, t())), r;
  })();
}
var KB = /* @__PURE__ */ x('<div class="flex flex-col gap-4">'), ZB = /* @__PURE__ */ x("<div class=space-y-3>");
function XB(e) {
  const {
    draftPrescriptions: t
  } = pd(), {
    isLoadingPrefills: r,
    prescriptionIds: n,
    coverageOptions: i
  } = oo(), a = L(() => lj(e.routingConstraints));
  return (() => {
    var o = ZB();
    return S(o, b(X, {
      get when() {
        return r();
      },
      get children() {
        return b(kt, {
          get each() {
            return n();
          },
          children: () => b(E6, {
            get LeftChildren() {
              return [b(ke, {
                size: "lg",
                sampleLoadingText: "Medication 100mg",
                loading: !0
              }), b(ke, {
                size: "sm",
                sampleLoadingText: "Loading notes about the medication",
                loading: !0
              })];
            }
          })
        });
      }
    }), null), S(o, b(X, {
      get when() {
        return L(() => !r())() && n().length === 0;
      },
      get children() {
        return b(ca, {
          status: "info",
          get children() {
            return e.enableOrder ? "Add prescription(s) before sending an order" : "Add prescription(s) before saving";
          }
        });
      }
    }), null), S(o, b(X, {
      get when() {
        return L(() => !r())() && t().length > 0;
      },
      get children() {
        var s = KB();
        return S(s, b(kt, {
          get each() {
            return t();
          },
          children: (l, d) => [b(X, {
            get when() {
              return d() > 0;
            },
            get children() {
              return b(YB, {});
            }
          }), b(QB, {
            get screeningAlerts() {
              return e.screeningAlerts;
            },
            get routingConstraint() {
              return a().get(l.id);
            },
            draft: l,
            get coverageOptions() {
              return i().filter((u) => u.prescriptionId === l.id);
            },
            get handleEdit() {
              return e.handleEdit;
            },
            get handleDelete() {
              return e.handleDelete;
            },
            get handleSwapToOtherPrescription() {
              return e.handleSwapToOtherPrescription;
            }
          })]
        })), s;
      }
    }), null), o;
  })();
}
var Jo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function JB(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Gf = { exports: {} }, T6 = { exports: {} };
(function(e) {
  (function() {
    var t = this || self;
    function r(y, _) {
      function T() {
      }
      T.prototype = _.prototype, y.Ba = _.prototype, y.prototype = new T(), y.prototype.constructor = y, y.Ha = function(B, W, te) {
        for (var ge = Array(arguments.length - 2), Je = 2; Je < arguments.length; Je++) ge[Je - 2] = arguments[Je];
        return _.prototype[W].apply(B, ge);
      };
    }
    function n(y) {
      var _ = [];
      let T = 0;
      for (var B in y) _[T++] = y[B];
      return _;
    }
    function i(y, _) {
      for (this.h = y, this.g = {}, y = 0; y < _.length; y++) {
        var T = _[y];
        this.g[T.g] = T;
      }
    }
    function a(y) {
      return y = n(y.g), y.sort(function(_, T) {
        return _.g - T.g;
      }), y;
    }
    function o(y, _) {
      switch (this.g = y, this.m = !!_.ga, this.h = _.i, this.u = _.type, this.s = !1, this.h) {
        case d:
        case u:
        case c:
        case h:
        case f:
        case l:
        case s:
          this.s = !0;
      }
      this.j = _.defaultValue;
    }
    var s = 1, l = 2, d = 3, u = 4, c = 6, h = 16, f = 18;
    function p() {
      this.h = {}, this.j = this.o().g, this.g = this.m = null;
    }
    p.prototype.has = function(y) {
      return v(this, y.g);
    }, p.prototype.get = function(y, _) {
      return $(this, y.g, _);
    }, p.prototype.set = function(y, _) {
      E(this, y.g, _);
    }, p.prototype.add = function(y, _) {
      N(this, y.g, _);
    };
    function g(y, _) {
      for (var T = a(y.o()), B = 0; B < T.length; B++) {
        var W = T[B], te = W.g;
        if (v(_, te)) {
          y.g && delete y.g[W.g];
          var ge = W.h == 11 || W.h == 10;
          if (W.m) {
            W = k(_, te);
            for (var Je = 0; Je < W.length; Je++) N(y, te, ge ? W[Je].clone() : W[Je]);
          } else W = m(_, te), ge ? (ge = m(y, te)) ? g(ge, W) : E(y, te, W.clone()) : E(y, te, W);
        }
      }
    }
    p.prototype.clone = function() {
      var y = new this.constructor();
      return y != this && (y.h = {}, y.g && (y.g = {}), g(y, this)), y;
    };
    function v(y, _) {
      return y.h[_] != null;
    }
    function m(y, _) {
      var T = y.h[_];
      if (T == null) return null;
      if (y.m) {
        if (!(_ in y.g)) {
          var B = y.m, W = y.j[_];
          if (T != null) if (W.m) {
            for (var te = [], ge = 0; ge < T.length; ge++) te[ge] = B.h(W, T[ge]);
            T = te;
          } else T = B.h(W, T);
          return y.g[_] = T;
        }
        return y.g[_];
      }
      return T;
    }
    function $(y, _, T) {
      var B = m(y, _);
      return y.j[_].m ? B[T || 0] : B;
    }
    function w(y, _) {
      if (v(y, _)) y = $(y, _);
      else e: {
        if (y = y.j[_], y.j === void 0) if (_ = y.u, _ === Boolean) y.j = !1;
        else if (_ === Number) y.j = 0;
        else if (_ === String) y.j = y.s ? "0" : "";
        else {
          y = new _();
          break e;
        }
        y = y.j;
      }
      return y;
    }
    function k(y, _) {
      return m(y, _) || [];
    }
    function C(y, _) {
      return y.j[_].m ? v(y, _) ? y.h[_].length : 0 : v(y, _) ? 1 : 0;
    }
    function E(y, _, T) {
      y.h[_] = T, y.g && (y.g[_] = T);
    }
    function N(y, _, T) {
      y.h[_] || (y.h[_] = []), y.h[_].push(T), y.g && delete y.g[_];
    }
    function M(y, _) {
      var T = [], B;
      for (B in _) B != 0 && T.push(new o(B, _[B]));
      return new i(y, T);
    }
    function V() {
    }
    V.prototype.g = function(y) {
      throw new y.h(), Error("Unimplemented");
    }, V.prototype.h = function(y, _) {
      if (y.h == 11 || y.h == 10) return _ instanceof p ? _ : this.g(y.u.prototype.o(), _);
      if (y.h == 14) return typeof _ == "string" && q.test(_) && (y = Number(_), 0 < y) ? y : _;
      if (!y.s) return _;
      if (y = y.u, y === String) {
        if (typeof _ == "number") return String(_);
      } else if (y === Number && typeof _ == "string" && (_ === "Infinity" || _ === "-Infinity" || _ === "NaN" || q.test(_))) return Number(_);
      return _;
    };
    var q = /^-?[0-9]+$/;
    function I() {
    }
    r(I, V), I.prototype.g = function(y, _) {
      return y = new y.h(), y.m = this, y.h = _, y.g = {}, y;
    };
    function P() {
    }
    r(P, I), P.prototype.h = function(y, _) {
      return y.h == 8 ? !!_ : V.prototype.h.apply(this, arguments);
    }, P.prototype.g = function(y, _) {
      return P.Ba.g.call(this, y, _);
    };
    function z(y, _) {
      y != null && this.g.apply(this, arguments);
    }
    z.prototype.h = "", z.prototype.set = function(y) {
      this.h = "" + y;
    }, z.prototype.g = function(y, _, T) {
      if (this.h += String(y), _ != null) for (let B = 1; B < arguments.length; B++) this.h += arguments[B];
      return this;
    };
    function G(y) {
      y.h = "";
    }
    z.prototype.toString = function() {
      return this.h;
    };
    function se() {
      p.call(this);
    }
    r(se, p);
    var ue = null;
    function de() {
      p.call(this);
    }
    r(de, p);
    var D = null;
    function R() {
      p.call(this);
    }
    r(R, p);
    var Q = null;
    R.prototype.ia = function() {
      return $(this, 10);
    }, se.prototype.o = function() {
      var y = ue;
      return y || (ue = y = M(se, { 0: { name: "NumberFormat", na: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: !0, i: 9, type: String }, 2: { name: "format", required: !0, i: 9, type: String }, 3: { name: "leading_digits_pattern", ga: !0, i: 9, type: String }, 4: { name: "national_prefix_formatting_rule", i: 9, type: String }, 6: { name: "national_prefix_optional_when_formatting", i: 8, defaultValue: !1, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", i: 9, type: String } })), y;
    }, se.o = se.prototype.o, de.prototype.o = function() {
      var y = D;
      return y || (D = y = M(de, { 0: { name: "PhoneNumberDesc", na: "i18n.phonenumbers.PhoneNumberDesc" }, 2: { name: "national_number_pattern", i: 9, type: String }, 9: { name: "possible_length", ga: !0, i: 5, type: Number }, 10: { name: "possible_length_local_only", ga: !0, i: 5, type: Number }, 6: { name: "example_number", i: 9, type: String } })), y;
    }, de.o = de.prototype.o, R.prototype.o = function() {
      var y = Q;
      return y || (Q = y = M(R, {
        0: { name: "PhoneMetadata", na: "i18n.phonenumbers.PhoneMetadata" },
        1: { name: "general_desc", i: 11, type: de },
        2: { name: "fixed_line", i: 11, type: de },
        3: { name: "mobile", i: 11, type: de },
        4: { name: "toll_free", i: 11, type: de },
        5: { name: "premium_rate", i: 11, type: de },
        6: { name: "shared_cost", i: 11, type: de },
        7: { name: "personal_number", i: 11, type: de },
        8: { name: "voip", i: 11, type: de },
        21: { name: "pager", i: 11, type: de },
        25: { name: "uan", i: 11, type: de },
        27: { name: "emergency", i: 11, type: de },
        28: { name: "voicemail", i: 11, type: de },
        29: { name: "short_code", i: 11, type: de },
        30: { name: "standard_rate", i: 11, type: de },
        31: { name: "carrier_specific", i: 11, type: de },
        33: { name: "sms_services", i: 11, type: de },
        24: { name: "no_international_dialling", i: 11, type: de },
        9: { name: "id", required: !0, i: 9, type: String },
        10: { name: "country_code", i: 5, type: Number },
        11: { name: "international_prefix", i: 9, type: String },
        17: { name: "preferred_international_prefix", i: 9, type: String },
        12: { name: "national_prefix", i: 9, type: String },
        13: { name: "preferred_extn_prefix", i: 9, type: String },
        15: {
          name: "national_prefix_for_parsing",
          i: 9,
          type: String
        },
        16: { name: "national_prefix_transform_rule", i: 9, type: String },
        18: { name: "same_mobile_and_fixed_line_pattern", i: 8, defaultValue: !1, type: Boolean },
        19: { name: "number_format", ga: !0, i: 11, type: se },
        20: { name: "intl_number_format", ga: !0, i: 11, type: se },
        22: { name: "main_country_for_code", i: 8, defaultValue: !1, type: Boolean },
        23: { name: "leading_digits", i: 9, type: String }
      })), y;
    }, R.o = R.prototype.o;
    function Z() {
      p.call(this);
    }
    r(Z, p);
    var F = null;
    Z.prototype.ia = function() {
      return $(this, 1);
    };
    var oe = { Ga: 0, Fa: 1, Ea: 5, Da: 10, Ca: 20 };
    Z.prototype.o = function() {
      var y = F;
      return y || (F = y = M(Z, { 0: { name: "PhoneNumber", na: "i18n.phonenumbers.PhoneNumber" }, 1: { name: "country_code", required: !0, i: 5, type: Number }, 2: { name: "national_number", required: !0, i: 4, type: Number }, 3: { name: "extension", i: 9, type: String }, 4: { name: "italian_leading_zero", i: 8, type: Boolean }, 8: { name: "number_of_leading_zeros", i: 5, defaultValue: 1, type: Number }, 5: { name: "raw_input", i: 9, type: String }, 6: { name: "country_code_source", i: 14, defaultValue: 0, type: oe }, 7: {
        name: "preferred_domestic_carrier_code",
        i: 9,
        type: String
      } })), y;
    }, Z.ctor = Z, Z.ctor.o = Z.prototype.o;
    var pe = {
      1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
      7: ["RU", "KZ"],
      20: ["EG"],
      27: ["ZA"],
      30: ["GR"],
      31: ["NL"],
      32: ["BE"],
      33: ["FR"],
      34: ["ES"],
      36: ["HU"],
      39: ["IT", "VA"],
      40: ["RO"],
      41: ["CH"],
      43: ["AT"],
      44: ["GB", "GG", "IM", "JE"],
      45: ["DK"],
      46: ["SE"],
      47: ["NO", "SJ"],
      48: ["PL"],
      49: ["DE"],
      51: ["PE"],
      52: ["MX"],
      53: ["CU"],
      54: ["AR"],
      55: ["BR"],
      56: ["CL"],
      57: ["CO"],
      58: ["VE"],
      60: ["MY"],
      61: ["AU", "CC", "CX"],
      62: ["ID"],
      63: ["PH"],
      64: ["NZ"],
      65: ["SG"],
      66: ["TH"],
      81: ["JP"],
      82: ["KR"],
      84: ["VN"],
      86: ["CN"],
      90: ["TR"],
      91: ["IN"],
      92: ["PK"],
      93: ["AF"],
      94: ["LK"],
      95: ["MM"],
      98: ["IR"],
      211: ["SS"],
      212: ["MA", "EH"],
      213: ["DZ"],
      216: ["TN"],
      218: ["LY"],
      220: ["GM"],
      221: ["SN"],
      222: ["MR"],
      223: ["ML"],
      224: ["GN"],
      225: ["CI"],
      226: ["BF"],
      227: ["NE"],
      228: ["TG"],
      229: ["BJ"],
      230: ["MU"],
      231: ["LR"],
      232: ["SL"],
      233: ["GH"],
      234: ["NG"],
      235: ["TD"],
      236: ["CF"],
      237: ["CM"],
      238: ["CV"],
      239: ["ST"],
      240: ["GQ"],
      241: ["GA"],
      242: ["CG"],
      243: ["CD"],
      244: ["AO"],
      245: ["GW"],
      246: ["IO"],
      247: ["AC"],
      248: ["SC"],
      249: ["SD"],
      250: ["RW"],
      251: ["ET"],
      252: ["SO"],
      253: ["DJ"],
      254: ["KE"],
      255: ["TZ"],
      256: ["UG"],
      257: ["BI"],
      258: ["MZ"],
      260: ["ZM"],
      261: ["MG"],
      262: ["RE", "YT"],
      263: ["ZW"],
      264: ["NA"],
      265: ["MW"],
      266: ["LS"],
      267: ["BW"],
      268: ["SZ"],
      269: ["KM"],
      290: ["SH", "TA"],
      291: ["ER"],
      297: ["AW"],
      298: ["FO"],
      299: ["GL"],
      350: ["GI"],
      351: ["PT"],
      352: ["LU"],
      353: ["IE"],
      354: ["IS"],
      355: ["AL"],
      356: ["MT"],
      357: ["CY"],
      358: ["FI", "AX"],
      359: ["BG"],
      370: ["LT"],
      371: ["LV"],
      372: ["EE"],
      373: ["MD"],
      374: ["AM"],
      375: ["BY"],
      376: ["AD"],
      377: ["MC"],
      378: ["SM"],
      380: ["UA"],
      381: ["RS"],
      382: ["ME"],
      383: ["XK"],
      385: ["HR"],
      386: ["SI"],
      387: ["BA"],
      389: ["MK"],
      420: ["CZ"],
      421: ["SK"],
      423: ["LI"],
      500: ["FK"],
      501: ["BZ"],
      502: ["GT"],
      503: ["SV"],
      504: ["HN"],
      505: ["NI"],
      506: ["CR"],
      507: ["PA"],
      508: ["PM"],
      509: ["HT"],
      590: ["GP", "BL", "MF"],
      591: ["BO"],
      592: ["GY"],
      593: ["EC"],
      594: ["GF"],
      595: ["PY"],
      596: ["MQ"],
      597: ["SR"],
      598: ["UY"],
      599: ["CW", "BQ"],
      670: ["TL"],
      672: ["NF"],
      673: ["BN"],
      674: ["NR"],
      675: ["PG"],
      676: ["TO"],
      677: ["SB"],
      678: ["VU"],
      679: ["FJ"],
      680: ["PW"],
      681: ["WF"],
      682: ["CK"],
      683: ["NU"],
      685: ["WS"],
      686: ["KI"],
      687: ["NC"],
      688: ["TV"],
      689: ["PF"],
      690: ["TK"],
      691: ["FM"],
      692: ["MH"],
      800: ["001"],
      808: ["001"],
      850: ["KP"],
      852: ["HK"],
      853: ["MO"],
      855: ["KH"],
      856: ["LA"],
      870: ["001"],
      878: ["001"],
      880: ["BD"],
      881: ["001"],
      882: ["001"],
      883: ["001"],
      886: ["TW"],
      888: ["001"],
      960: ["MV"],
      961: ["LB"],
      962: ["JO"],
      963: ["SY"],
      964: ["IQ"],
      965: ["KW"],
      966: ["SA"],
      967: ["YE"],
      968: ["OM"],
      970: ["PS"],
      971: ["AE"],
      972: ["IL"],
      973: ["BH"],
      974: ["QA"],
      975: ["BT"],
      976: ["MN"],
      977: ["NP"],
      979: ["001"],
      992: ["TJ"],
      993: ["TM"],
      994: ["AZ"],
      995: ["GE"],
      996: ["KG"],
      998: ["UZ"]
    }, ee = {
      AC: [, [
        ,
        ,
        "(?:[01589]\\d|[46])\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6]
      ], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:0[1-9]|[1589]\\d)\\d{4}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]],
      AD: [
        ,
        [, , "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", , , , , , , [6, 8, 9]],
        [, , "[78]\\d{5}", , , , "712345", , , [6]],
        [, , "690\\d{6}|[356]\\d{5}", , , , "312345", , , [6, 9]],
        [, , "180[02]\\d{4}", , , , "18001234", , , [8]],
        [, , "[19]\\d{5}", , , , "912345", , , [6]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AD",
        376,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "1800\\d{4}", , , , , , , [8]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AE: [
        ,
        [, , "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
        [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]],
        [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]],
        [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"],
        [, , "900[02]\\d{5}", , , , "900234567", , , [9]],
        [, , "700[05]\\d{5}", , , , "700012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AE",
        971,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "600[25]\\d{5}", , , , "600212345", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AF: [, [, , "[2-7]\\d{8}", , , , , , , [9], [7]], [
        ,
        ,
        "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
        ,
        ,
        ,
        "234567890",
        ,
        ,
        ,
        [7]
      ], [, , "7\\d{8}", , , , "701234567", , , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AG: [
        ,
        [, , "(?:268|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
          ,
          ,
          ,
          "2684601234",
          ,
          ,
          ,
          [7]
        ],
        [, , "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}", , , , "2684641234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]],
        "AG",
        1,
        "011",
        "1",
        ,
        ,
        "([457]\\d{6})$|1",
        "268$1",
        ,
        ,
        ,
        ,
        [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]],
        ,
        "268",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AI: [, [, , "(?:264|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "264(?:292|4(?:6[12]|9[78]))\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "([2457]\\d{6})$|1", "264$1", , , , , [, , "264724\\d{4}", , , , "2647241234", , , , [7]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AL: [, [, , "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", , , , , , , [6, 7, 8, 9], [5]], [, , "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[78][2-9]|9\\d)\\d{6}", , , , "672123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [
        ,
        ,
        "900[1-9]\\d\\d",
        ,
        ,
        ,
        "900123",
        ,
        ,
        [6]
      ], [, , "808[1-9]\\d\\d", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AM: [, [
        ,
        ,
        "(?:[1-489]\\d|55|60|77)\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8],
        [5, 6]
      ], [, , "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}", , , , "10123456", , , , [5, 6]], [, , "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], [, , "90[016]\\d{5}", , , , "90012345"], [, , "80[1-4]\\d{5}", , , , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [
        ,
        "(\\d{3})(\\d{5})",
        "$1 $2",
        ["2|3[12]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AO: [
        ,
        [, , "[29]\\d{8}", , , , , , , [9]],
        [, , "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}", , , , "222123456"],
        [, , "9[1-59]\\d{7}", , , , "923123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AO",
        244,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AR: [
        ,
        [, , "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", , , , , , , [10, 11], [6, 7, 8]],
        [
          ,
          ,
          "3888[013-9]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
          ,
          ,
          ,
          "1123456789",
          ,
          ,
          [10],
          [6, 7, 8]
        ],
        [
          ,
          ,
          "93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
          ,
          ,
          ,
          "91123456789",
          ,
          ,
          ,
          [6, 7, 8]
        ],
        [, , "800\\d{7,8}", , , , "8001234567"],
        [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AR",
        54,
        "00",
        "0",
        ,
        ,
        "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
        "9$1",
        ,
        ,
        [[, "(\\d{3})", "$1", ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[1-9]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[1-8]"]], [
          ,
          "(\\d{4})(\\d{2})(\\d{4})",
          "$1 $2-$3",
          [
            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ],
          "0$1",
          ,
          1
        ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [
          ,
          "(\\d)(\\d{4})(\\d{2})(\\d{4})",
          "$2 15-$3-$4",
          [
            "9(?:2[2-469]|3[3-578])",
            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ],
          "0$1"
        ], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]],
        [
          [
            ,
            "(\\d{4})(\\d{2})(\\d{4})",
            "$1 $2-$3",
            [
              "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
              "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
            ],
            "0$1",
            ,
            1
          ],
          [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1],
          [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", [
            "9(?:2[2-469]|3[3-578])",
            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ]],
          [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]],
          [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"],
          [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9"]]
        ],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "810\\d{7}", , , , , , , [10]],
        [, , "810\\d{7}", , , , "8101234567", , , [10]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AS: [, [, , "(?:[58]\\d\\d|684|900)\\d{7}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}", , , , "6847331234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "([267]\\d{6})$|1", "684$1", , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AT: [, [
        ,
        ,
        "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
        ,
        ,
        ,
        ,
        ,
        ,
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        [3]
      ], [, , "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}", , , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], [
        ,
        ,
        "800\\d{6,10}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9, 10, 11, 12, 13]
      ], [, , "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10|2[018])\\d{6,10}|828\\d{5}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", , , , "780123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , [
        [, "(\\d{4})", "$1", ["14"]],
        [, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
        [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
        [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
        [, "(\\d{6})", "$1", ["[18]"]],
        [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"],
        [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
        [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
        [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]
      ], [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3,10})",
        "$1 $2",
        ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AU: [
        ,
        [, , "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", , , , , , , [5, 6, 7, 8, 9, 10, 12]],
        [
          ,
          ,
          "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
          ,
          ,
          ,
          "212345678",
          ,
          ,
          [9],
          [8]
        ],
        [, , "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
        [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
        [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
        [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
        "AU",
        61,
        "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
        "0",
        ,
        ,
        "(183[12])|0",
        ,
        "0011",
        ,
        [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]], [
          ,
          "(\\d{4})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["130"]
        ]],
        [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]],
        [, , "163\\d{2,6}", , , , "1631234", , , [5, 6, 7, 8, 9]],
        1,
        ,
        [, , "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}", , , , , , , [6, 7, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AW: [, [
        ,
        ,
        "(?:[25-79]\\d\\d|800)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7]
      ], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:28\\d|501)\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AX: [, [
        ,
        ,
        "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 8, 9, 10, 11, 12]
      ], [, , "18[1-8]\\d{3,6}", , , , "181234567", , , [6, 7, 8, 9]], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , "18", [, , , , , , , , , [-1]], [
        ,
        ,
        "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
        ,
        ,
        ,
        "10112345"
      ], , , [, , , , , , , , , [-1]]],
      AZ: [, [, , "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", , , , , , , [9], [7]], [, , "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}", , , , "123123456", , , , [7]], [, , "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["90"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[13-9]"],
        "0$1"
      ]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BA: [
        ,
        [, , "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", , , , , , , [8, 9], [6]],
        [, , "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", , , , "30212345", , , [8], [6]],
        [, , "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}", , , , "61123456"],
        [, , "8[08]\\d{6}", , , , "80123456", , , [8]],
        [, , "9[0246]\\d{6}", , , , "90123456", , , [8]],
        [, , "8[12]\\d{6}", , , , "82123456", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BA",
        387,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
        [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BB: [, [, , "(?:246|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}", , , , "2462501234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "(?:246976|900[2-9]\\d\\d)\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "([2-9]\\d{6})$|1", "246$1", , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [
        ,
        ,
        "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
        ,
        ,
        ,
        "2464301234",
        ,
        ,
        ,
        [7]
      ], , , [, , , , , , , , , [-1]]],
      BD: [, [, , "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [
        ,
        ,
        "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
        ,
        ,
        ,
        "27111234"
      ], [, , "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], [
        ,
        "(\\d{3})(\\d{3,7})",
        "$1-$2",
        ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BE: [, [, , "4\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9]], [, , "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", , , , "12345678", , , [8]], [, , "4[5-9]\\d{7}", , , , "470123456", , , [9]], [, , "800[1-9]\\d{4}", , , , "80012345", , , [8]], [, , "(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}", , , , "90012345", , , [8]], [
        ,
        ,
        "7879\\d{4}",
        ,
        ,
        ,
        "78791234",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", , , , "78102345", , , [8]], , , [, , , , , , , , , [-1]]],
      BF: [, [
        ,
        ,
        "[025-7]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BG: [
        ,
        [, , "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", , , , , , , [6, 7, 8, 9, 12], [4, 5]],
        [, , "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", , , , "2123456", , , [6, 7, 8], [4, 5]],
        [, , "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", , , , "43012345", , , [8, 9]],
        [, , "(?:00800\\d\\d|800)\\d{5}", , , , "80012345", , , [8, 12]],
        [, , "90\\d{6}", , , , "90123456", , , [8]],
        [, , "700\\d{5}", , , , "70012345", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BG",
        359,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
          ,
          "(\\d{3})(\\d{4})",
          "$1 $2",
          ["43[1-6]|70[1-9]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
        [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
          ,
          "(\\d{3})(\\d{4})",
          "$1 $2",
          ["43[1-6]|70[1-9]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BH: [, [, , "[136-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
        ,
        ,
        ,
        "17001234"
      ], [, , "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}", , , , "36001234"], [, , "8[02369]\\d{6}", , , , "80123456"], [, , "(?:87|9[0-8])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BI: [, [, , "(?:[267]\\d|31)\\d{6}", , , , , , , [8]], [, , "(?:22|31)\\d{6}", , , , "22201234"], [
        ,
        ,
        "(?:29|[67][125-9])\\d{6}",
        ,
        ,
        ,
        "79561234"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BJ: [
        ,
        [, , "[24-689]\\d{7}", , , , , , , [8]],
        [, , "2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}", , , , "20211234"],
        [, , "(?:4[0-356]|[56]\\d|9[013-9])\\d{6}", , , , "90011234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "857[58]\\d{4}", , , , "85751234"],
        "BJ",
        229,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "81\\d{6}", , , , "81123456"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BL: [
        ,
        [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
        [, , "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}", , , , "590271234"],
        [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"],
        [, , "80[0-5]\\d{6}", , , , "800012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"],
        "BL",
        590,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BM: [, [, , "(?:441|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}", , , , "4414123456", , , , [7]], [, , "441(?:[2378]\\d|5[0-39]|92)\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "([2-9]\\d{6})$|1", "441$1", , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BN: [
        ,
        [, , "[2-578]\\d{6}", , , , , , , [7]],
        [, , "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}", , , , "2345678"],
        [, , "(?:22[89]|[78]\\d\\d)\\d{4}", , , , "7123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "5[34]\\d{5}", , , , "5345678"],
        "BN",
        673,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BO: [
        ,
        [, , "(?:[2-467]\\d\\d|8001)\\d{5}", , , , , , , [8, 9], [7]],
        [, , "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , [8], [7]],
        [, , "[67]\\d{7}", , , , "71234567", , , [8]],
        [, , "8001[07]\\d{4}", , , , "800171234", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BO",
        591,
        "00(?:1\\d)?",
        "0",
        ,
        ,
        "0(1\\d)?",
        ,
        ,
        ,
        [[, "(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"], , "0$CC $1"], [, "(\\d{8})", "$1", ["[67]"], , "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], , "0$CC $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "8001[07]\\d{4}", , , , , , , [9]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BQ: [, [, , "(?:[34]1|7\\d)\\d{5}", , , , , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "[347]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BR: [, [, , "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", , , , "11961234567", , , [10, 11], [8, 9]], [
        ,
        ,
        "800\\d{6,7}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9, 10]
      ], [, , "300\\d{6}|[59]00\\d{6,7}", , , , "300123456", , , [9, 10]], [, , "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", , , , "40041234", , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [[, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
        ,
        "(\\d{4})(\\d{4})",
        "$1-$2",
        ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]
      ], [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
        ,
        "(\\d{3})(\\d{2,3})(\\d{4})",
        "$1 $2 $3",
        ["(?:[358]|90)0"],
        "0$1"
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}", , , , , , , [8, 9, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BS: [, [, , "(?:242|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
        ,
        ,
        ,
        "2423456789",
        ,
        ,
        ,
        [7]
      ], [, , "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}", , , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "BS", 1, "011", "1", , , "([3-8]\\d{6})$|1", "242$1", , , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , "242225\\d{4}", , , , "2422250123"], , , [, , , , , , , , , [-1]]],
      BT: [, [, , "[17]\\d{7}|[2-8]\\d{6}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [
        ,
        "(\\d)(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[2-68]|7[246]"]
      ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BW: [, [, , "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [
        ,
        ,
        "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",
        ,
        ,
        ,
        "2401234",
        ,
        ,
        [7]
      ], [, , "(?:321|7(?:[1-7]\\d|8[0-4]))\\d{5}", , , , "71123456", , , [8]], [, , "(?:0800|800\\d)\\d{6}", , , , "0800012345", , , [10]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79(?:1(?:[01]\\d|2[0-7])|2[0-7]\\d)\\d{3}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], [
        ,
        "(\\d{3})(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["8"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BY: [, [, , "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , "152450911", , , [9], [5, 6, 7]], [
        ,
        ,
        "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
        ,
        ,
        ,
        "294911911",
        ,
        ,
        [9]
      ], [, , "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "0|80?", , "8~10", , [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [
        ,
        "(\\d{4})(\\d{2})(\\d{3})",
        "$1 $2-$3",
        ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
        "8 0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BZ: [, [, , "(?:0800\\d|[2-8])\\d{6}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", , , , "2221234", , , [7]], [
        ,
        ,
        "6[0-35-7]\\d{5}",
        ,
        ,
        ,
        "6221234",
        ,
        ,
        [7]
      ], [, , "0800\\d{7}", , , , "08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CA: [, [, , "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", , , , , , , [7, 10]], [
        ,
        ,
        "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
        ,
        ,
        ,
        "5062345678",
        ,
        ,
        [10],
        [7]
      ], [, , "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", , , , "5062345678", , , [10], [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , [10]], [, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678",
        ,
        ,
        [10]
      ], [, , "600[2-9]\\d{6}", , , , "6002012345", , , [10]], "CA", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "310\\d{4}", , , , "3101234", , , [7]], , , [, , , , , , , , , [-1]]],
      CC: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [
        ,
        ,
        "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
        ,
        ,
        ,
        "412345678",
        ,
        ,
        [9]
      ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CD: [, [
        ,
        ,
        "[189]\\d{8}|[1-68]\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 9]
      ], [, , "12\\d{7}|[1-6]\\d{6}", , , , "1234567"], [, , "88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}", , , , "991234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CF: [, [
        ,
        ,
        "(?:[27]\\d{3}|8776)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[024-7]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CG: [, [, , "222\\d{6}|(?:0\\d|80)\\d{7}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [
        ,
        ,
        "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
        ,
        ,
        ,
        "061234567"
      ], [, , , , , , , , , [-1]], [, , "80[0-2]\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CH: [
        ,
        [, , "8\\d{11}|[2-9]\\d{8}", , , , , , , [9, 12]],
        [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]],
        [, , "7[35-9]\\d{7}", , , , "781234567", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "90[016]\\d{6}", , , , "900123456", , , [9]],
        [, , "84[0248]\\d{6}", , , , "840123456", , , [9]],
        [, , "878\\d{6}", , , , "878123456", , , [9]],
        [, , , , , , , , , [-1]],
        "CH",
        41,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]],
        ,
        [, , "74[0248]\\d{6}", , , , "740123456", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "5[18]\\d{7}", , , , "581234567", , , [9]],
        ,
        ,
        [
          ,
          ,
          "860\\d{9}",
          ,
          ,
          ,
          "860123456789",
          ,
          ,
          [12]
        ]
      ],
      CI: [, [, , "[02]\\d{9}", , , , , , , [10]], [, , "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}", , , , "2123456789"], [, , "0[157]\\d{8}", , , , "0123456789"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CK: [, [
        ,
        ,
        "[2-578]\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5]
      ], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[578]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CL: [, [, , "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", , , , , , , [9, 10, 11]], [
        ,
        ,
        "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
        ,
        ,
        ,
        "221234567",
        ,
        ,
        [9]
      ], [, , "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", , , , "221234567", , , [9]], [, , "(?:123|8)00\\d{6}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [
        ,
        ,
        "600\\d{7,8}",
        ,
        ,
        ,
        "6001234567",
        ,
        ,
        [10, 11]
      ], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , 1, [[, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
        "($1)"
      ], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [[, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["60|8"]
      ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CM: [, [, , "[26]\\d{8}|88\\d{6,7}", , , , , , , [8, 9]], [, , "2(?:22|33)\\d{6}", , , , "222123456", , , [9]], [, , "(?:24[23]|6[25-9]\\d)\\d{6}", , , , "671234567", , , [9]], [, , "88\\d{6,7}", , , , "88012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["88"]
      ], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CN: [, [, , "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [
        ,
        ,
        "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
        ,
        ,
        ,
        "1012345678",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:(?:10|21)8|8)00\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [
        ,
        ,
        "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
        ,
        ,
        ,
        "4001234567",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "00|1(?:[12]\\d|79)\\d\\d00", "0", , , "(1(?:[12]\\d|79)\\d\\d)|0", , "00", , [
        [, "(\\d{5,6})", "$1", ["10|96"]],
        [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])", "1(?:0(?:[0-8]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])|6)|[3-9]"]],
        [, "(\\d{4})(\\d{4})", "$1 $2", ["16[08]"]],
        [
          ,
          "(\\d{3})(\\d{5,6})",
          "$1 $2",
          [
            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
          ],
          "0$1",
          "$CC $1"
        ],
        [, "(\\d{4})(\\d{4})", "$1 $2", [
          "[1-9]",
          "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
          "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
          "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
        ]],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
        [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
        [
          ,
          "(\\d{3})(\\d{7,8})",
          "$1 $2",
          ["9"]
        ],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
      ], [
        [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{5,6})", "$1 $2", [
          "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
          "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
          "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
          "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
        ], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
        [
          ,
          "(\\d{2})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],
          "0$1",
          "$CC $1",
          1
        ],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{7,8})", "$1 $2", ["9"]],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
      ], [, , , , , , , , , [-1]], , , [, , "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}", , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CO: [, [, , "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", , , , , , , [10, 11], [7]], [, , "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60[124-8][2-9]\\d{6}", , , , "6012345678", , , [10], [7]], [
        ,
        ,
        "3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
        ,
        ,
        ,
        "3211234567",
        ,
        ,
        [10]
      ], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "19(?:0[01]|4[78])\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0(4(?:[14]4|56)|[579])?", , , , [[, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1"]], [
        [, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)", "0$CC $1"],
        [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"], , "0$CC $1"],
        [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1"]]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CR: [, [, , "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", , , , , , , [8, 10]], [, , "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", , , , "22123456", , , [8]], [, , "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", , , , "83123456", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
        ,
        ,
        ,
        "40001234",
        ,
        ,
        [8]
      ], "CR", 506, "00", , , , "(19(?:0[0-2468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CU: [, [, , "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", , , , , , , [6, 7, 8, 10], [4, 5]], [, , "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}", , , , "71234567", , , , [4, 5]], [
        ,
        ,
        "(?:5\\d|63)\\d{6}",
        ,
        ,
        ,
        "51234567",
        ,
        ,
        [8]
      ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , "807\\d{7}", , , , "8071234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CV: [, [, , "(?:[2-59]\\d\\d|800)\\d{4}", , , , , , , [7]], [
        ,
        ,
        "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
        ,
        ,
        ,
        "2211234"
      ], [, , "(?:36|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , "800\\d{4}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[3-5]|4[356])\\d{5}", , , , "3401234"], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CW: [, [, , "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", , , , , , , [7, 8]], [
        ,
        ,
        "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
        ,
        ,
        ,
        "94351234"
      ], [, , "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}", , , , "95181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], , [, , "955\\d{5}", , , , "95581234", , , [8]], 1, "[69]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CX: [
        ,
        [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]],
        [
          ,
          ,
          "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
          ,
          ,
          ,
          "891641234",
          ,
          ,
          [9],
          [8]
        ],
        [, , "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
        [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
        [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
        [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
        "CX",
        61,
        "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
        "0",
        ,
        ,
        "([59]\\d{7})$|0",
        "8$1",
        "0011",
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      CY: [
        ,
        [, , "(?:[279]\\d|[58]0)\\d{6}", , , , , , , [8]],
        [, , "2[2-6]\\d{6}", , , , "22345678"],
        [, , "9(?:10|[4-79]\\d)\\d{5}", , , , "96123456"],
        [, , "800\\d{5}", , , , "80001234"],
        [, , "90[09]\\d{5}", , , , "90012345"],
        [, , "80[1-9]\\d{5}", , , , "80112345"],
        [, , "700\\d{5}", , , , "70012345"],
        [, , , , , , , , , [-1]],
        "CY",
        357,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "(?:50|77)\\d{6}", , , , "77123456"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      CZ: [, [, , "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]], [, , "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , , "212345678", , , [9]], [, , "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]], [, , "8[134]\\d{7}", , , , "811234567", , , [9]], [, , "70[01]\\d{6}", , , , "700123456", , , [9]], [, , "9[17]0\\d{6}", , , , "910123456", , , [9]], "CZ", 420, "00", , , , , , , , [
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]],
        [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]
      ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "9(?:5\\d|7[2-4])\\d{6}", , , , "972123456", , , [9]], , , [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]],
      DE: [, [
        ,
        ,
        "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
        ,
        ,
        ,
        ,
        ,
        ,
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        [2, 3]
      ], [
        ,
        ,
        "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
        ,
        ,
        ,
        "30123456",
        ,
        ,
        [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        [2, 3, 4]
      ], [, , "15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", , , , "9001234567", , , [10, 11]], [, , "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, "00", "0", , , "0", , , , [
        [, "(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"],
        [
          ,
          "(\\d{3})(\\d{3,12})",
          "$1 $2",
          ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],
          "0$1"
        ],
        [
          ,
          "(\\d{4})(\\d{2,11})",
          "$1 $2",
          ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
          "0$1"
        ],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
        [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
        [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
        [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
        [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
        [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
        [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
        [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
        [, "(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"],
        [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
        [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
        [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
        [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
        [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
      ], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [
        ,
        ,
        "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
        ,
        ,
        ,
        "177991234567",
        ,
        ,
        [12, 13]
      ]],
      DJ: [, [, , "(?:2\\d|77)\\d{6}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DK: [, [, , "[2-9]\\d{7}", , , , , , , [8]], [, , "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}", , , , "32123456"], [
        ,
        ,
        "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
        ,
        ,
        ,
        "32123456"
      ], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , 1, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DM: [
        ,
        [, , "(?:[58]\\d\\d|767|900)\\d{7}", , , , , , , [10], [7]],
        [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}", , , , "7674201234", , , , [7]],
        [, , "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}", , , , "7672251234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "DM",
        1,
        "011",
        "1",
        ,
        ,
        "([2-7]\\d{6})$|1",
        "767$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "767",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      DO: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}", , , , "8092345678", , , , [7]], [, , "8[024]9[2-9]\\d{6}", , , , "8092345678", , , , [7]], [
        ,
        ,
        "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DO", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "8001|8[024]9", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DZ: [
        ,
        [, , "(?:[1-4]|[5-79]\\d|80)\\d{7}", , , , , , , [8, 9]],
        [, , "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}", , , , "12345678"],
        [, , "(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", , , , "551234567", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]],
        [, , "80[12]1\\d{5}", , , , "801123456", , , [9]],
        [, , , , , , , , , [-1]],
        [, , "98[23]\\d{6}", , , , "983123456", , , [9]],
        "DZ",
        213,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [
          [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"],
          [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"],
          [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]
        ],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EC: [
        ,
        [, , "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", , , , , , , [8, 9, 10, 11], [7]],
        [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]],
        [, , "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", , , , "991234567", , , [9]],
        [, , "1800\\d{7}|1[78]00\\d{6}", , , , "18001234567", , , [10, 11]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]],
        "EC",
        593,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]],
        [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EE: [
        ,
        [, , "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", , , , , , , [7, 8, 10]],
        [
          ,
          ,
          "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
          ,
          ,
          ,
          "3212345",
          ,
          ,
          [7]
        ],
        [, , "(?:5\\d{5}|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", , , , "51234567", , , [7, 8]],
        [, , "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}", , , , "80012345"],
        [, , "(?:40\\d\\d|900)\\d{4}", , , , "9001234", , , [7, 8]],
        [, , , , , , , , , [-1]],
        [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]],
        [, , , , , , , , , [-1]],
        "EE",
        372,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "800[2-9]\\d{3}", , , , , , , [7]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EG: [, [
        ,
        ,
        "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10],
        [6, 7]
      ], [, , "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", , , , "234567890", , , [8, 9], [6, 7]], [, , "1[0-25]\\d{8}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["[89]"],
        "0$1"
      ], [, "(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      EH: [
        ,
        [, , "[5-8]\\d{8}", , , , , , , [9]],
        [, , "528[89]\\d{5}", , , , "528812345"],
        [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}", , , , "650123456"],
        [, , "80\\d{7}", , , , "801234567"],
        [, , "89\\d{7}", , , , "891234567"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "592(?:4[0-2]|93)\\d{4}", , , , "592401234"],
        "EH",
        212,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "528[89]",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ER: [, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", , , , "8370362", , , , [6]], [, , "(?:17[1-3]|7\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ES: [, [, , "[5-9]\\d{8}", , , , , , , [9]], [
        ,
        ,
        "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
        ,
        ,
        ,
        "810123456"
      ], [, , "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}", , , , "612345678"], [, , "[89]00\\d{6}", , , , "800123456"], [, , "80[367]\\d{6}", , , , "803123456"], [, , "90[12]\\d{6}", , , , "901123456"], [, , "70\\d{7}", , , , "701234567"], [, , , , , , , , , [-1]], "ES", 34, "00", , , , , , , , [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], [
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]],
        [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "51\\d{7}", , , , "511234567"], , , [, , , , , , , , , [-1]]],
      ET: [, [, , "(?:11|[2-579]\\d)\\d{7}", , , , , , , [9], [7]], [
        ,
        ,
        "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
        ,
        ,
        ,
        "111112345",
        ,
        ,
        ,
        [7]
      ], [, , "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FI: [
        ,
        [, , "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
        [
          ,
          ,
          "(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",
          ,
          ,
          ,
          "131234567",
          ,
          ,
          [5, 6, 7, 8, 9]
        ],
        [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]],
        [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]],
        [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "FI",
        358,
        "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
        "0",
        ,
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [
          ,
          "(\\d{3})(\\d{3,7})",
          "$1 $2",
          ["[12]00|[368]|70[07-9]"],
          "0$1"
        ], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]],
        [[, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]],
        [, , , , , , , , , [-1]],
        1,
        "1[03-79]|[2-9]",
        [, , "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"],
        [, , "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}", , , , "10112345"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      FJ: [
        ,
        [, , "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", , , , , , , [7, 11]],
        [, , "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]],
        [, , "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", , , , "7012345", , , [7]],
        [, , "0800\\d{7}", , , , "08001234567", , , [11]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "FJ",
        679,
        "0(?:0|52)",
        ,
        ,
        ,
        ,
        ,
        "00",
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      FK: [, [, , "[2-7]\\d{4}", , , , , , , [5]], [, , "[2-47]\\d{4}", , , , "31234"], [, , "[56]\\d{4}", , , , "51234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FK", 500, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FM: [, [, , "(?:[39]\\d\\d|820)\\d{4}", , , , , , , [7]], [
        ,
        ,
        "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
        ,
        ,
        ,
        "3201234"
      ], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FO: [, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[34]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d|9[16])\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [
        ,
        ,
        "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
        ,
        ,
        ,
        "901123"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", ["[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FR: [, [, , "[1-9]\\d{8}", , , , , , , [9]], [, , "59[1-9]\\d{6}|(?:[1-3]\\d|4[1-9]|5[0-8])\\d{7}", , , , "123456789"], [, , "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [
        ,
        ,
        "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
        ,
        ,
        ,
        "891123456"
      ], [, , "8(?:1[01]|2[0156]|4[02]|84)\\d{6}", , , , "884012345"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["10"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]],
      GA: [, [, , "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", , , , , , , [7, 8]], [, , "[01]1\\d{6}", , , , "01441234", , , [8]], [, , "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}", , , , "06031234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["0"]
      ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GB: [, [, , "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", , , , , , , [7, 9, 10], [4, 5, 6, 8]], [
        ,
        ,
        "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
        ,
        ,
        ,
        "1212345678",
        ,
        ,
        [9, 10],
        [4, 5, 6, 7, 8]
      ], [, , "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", , , , "7400123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [
        ,
        ,
        "56\\d{8}",
        ,
        ,
        ,
        "5612345678",
        ,
        ,
        [10]
      ], "GB", 44, "00", "0", " x", , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", [
        "[25]|7(?:0|6[02-9])",
        "[25]|7(?:0|6(?:[03-9]|2[356]))"
      ], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
      GD: [
        ,
        [, , "(?:473|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
          ,
          ,
          ,
          "4732691234",
          ,
          ,
          ,
          [7]
        ],
        [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "GD",
        1,
        "011",
        "1",
        ,
        ,
        "([2-9]\\d{6})$|1",
        "473$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "473",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GE: [, [, , "(?:[3-57]\\d\\d|800)\\d{6}", , , , , , , [9], [6, 7]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6, 7]], [
        ,
        ,
        "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|11|22|33|44|5[05]|77|88|99)|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}",
        ,
        ,
        ,
        "555123456"
      ], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70[67]\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "70[67]\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GF: [, [
        ,
        ,
        "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9]
      ], [, , "594(?:[02-49]\\d|1[0-4]|5[6-9]|6[0-3]|80)\\d{4}", , , , "594101234"], [, , "694(?:[0-249]\\d|3[0-8])\\d{4}", , , , "694201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}", , , , "976012345"], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      GG: [, [, , "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", , , , , , , [7, 9, 10], [6]], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:(?:781|839)\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", , , "([25-9]\\d{5})$|0", "1481$1", , , , , [
        ,
        ,
        "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
        ,
        ,
        ,
        "7640123456",
        ,
        ,
        [10]
      ], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
      GH: [, [, , "(?:[235]\\d{3}|800)\\d{5}", , , , , , , [8, 9], [7]], [, , "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", , , , "302345678", , , [9], [7]], [, , "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", , , , "231234567", , , [9]], [
        ,
        ,
        "800\\d{5}",
        ,
        ,
        ,
        "80012345",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|8[0-2]"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GI: [, [, , "(?:[25]\\d|60)\\d{6}", , , , , , , [8]], [
        ,
        ,
        "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
        ,
        ,
        ,
        "20012345"
      ], [, , "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GL: [
        ,
        [, , "(?:19|[2-689]\\d|70)\\d{4}", , , , , , , [6]],
        [, , "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}", , , , "321000"],
        [, , "[245]\\d{5}", , , , "221234"],
        [, , "80\\d{4}", , , , "801234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "3[89]\\d{4}", , , , "381234"],
        "GL",
        299,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GM: [
        ,
        [, , "[2-9]\\d{6}", , , , , , , [7]],
        [, , "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"],
        [, , "(?:[23679]\\d|5[0-489])\\d{5}", , , , "3012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "GM",
        220,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GN: [, [, , "722\\d{6}|(?:3|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", , , , "30241234", , , [8]], [, , "6[0-356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[67]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GP: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [, , "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}", , , , "590201234"], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"], "GP", 590, "00", "0", , , "0", , , , [[
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[569]"],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GQ: [, [, , "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", , , , , , , [9]], [, , "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}", , , , "333091234"], [, , "(?:222|55\\d)\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], [, , "90\\d[1-9]\\d{5}", , , , "900123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [[
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[235]"]
      ], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GR: [, [, , "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", , , , , , , [10, 11, 12]], [
        ,
        ,
        "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
        ,
        ,
        ,
        "2123456789",
        ,
        ,
        [10]
      ], [, , "68[57-9]\\d{7}|(?:69|94)\\d{8}", , , , "6912345678", , , [10]], [, , "800\\d{7,9}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567", , , [10]], [, , "8(?:0[16]|12|[27]5|50)\\d{7}", , , , "8011234567", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], [
        ,
        "(\\d{3})(\\d{3,4})(\\d{5})",
        "$1 $2 $3",
        ["8"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5005000\\d{3}", , , , "5005000123", , , [10]], , , [, , , , , , , , , [-1]]],
      GT: [
        ,
        [, , "(?:1\\d{3}|[2-7])\\d{7}", , , , , , , [8, 11]],
        [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]],
        [, , "[3-5]\\d{7}", , , , "51234567", , , [8]],
        [, , "18[01]\\d{8}", , , , "18001112222", , , [11]],
        [, , "19\\d{9}", , , , "19001112222", , , [11]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "GT",
        502,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GU: [, [, , "(?:[58]\\d\\d|671|900)\\d{7}", , , , , , , [10], [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [
        ,
        ,
        "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
        ,
        ,
        ,
        "6713001234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "([3-9]\\d{6})$|1", "671$1", , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      GW: [, [, , "[49]\\d{8}|4\\d{6}", , , , , , , [7, 9]], [, , "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GY: [
        ,
        [, , "9008\\d{3}|(?:[2-467]\\d\\d|510|862)\\d{4}", , , , , , , [7]],
        [, , "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}", , , , "2201234"],
        [, , "(?:510|6\\d\\d|7(?:0\\d|1[0-8]|25|49))\\d{4}", , , , "6091234"],
        [, , "(?:289|862)\\d{4}", , , , "2891234"],
        [, , "9008\\d{3}", , , , "9008123"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "GY",
        592,
        "001",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      HK: [, [
        ,
        ,
        "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 8, 9, 11]
      ], [, , "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:[45][0-8]|6[01]|9\\d))|58(?:0[1-9]|1[2-9]))\\d{4}", , , , "21234567", , , [8]], [
        ,
        ,
        "(?:4(?:44[5-9]|6(?:0[0-7]|1[0-6]|4[0-57-9]|6[0-4]|7[0-8]))|573[0-6]|6(?:26[013-8]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|9(?:29[013-9]|59[0-4]))\\d{4}|(?:4(?:4[01]|6[2358])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
        ,
        ,
        ,
        "51234567",
        ,
        ,
        [8]
      ], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "900(?:[0-24-9]\\d{7}|3\\d{1,4})", , , , "90012345678", , , [5, 6, 7, 8, 11]], [, , , , , , , , , [-1]], [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", , , , "81123456", , , [8]], [, , , , , , , , , [-1]], "HK", 852, "00(?:30|5[09]|[126-9]?)", , , , , , "00", , [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3 $4",
        ["9"]
      ]], , [, , "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", , , , "71123456", , , [8]], , , [, , , , , , , , , [-1]], [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]], , , [, , , , , , , , , [-1]]],
      HN: [, [, , "8\\d{10}|[237-9]\\d{7}", , , , , , , [8, 11]], [
        ,
        ,
        "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
        ,
        ,
        ,
        "22123456",
        ,
        ,
        [8]
      ], [, , "[37-9]\\d{7}", , , , "91234567", , , [8]], [, , "8002\\d{7}", , , , "80021234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [, , , , , , , , , [-1]], , , [, , "8002\\d{7}", , , , , , , [11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      HR: [, [, , "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", , , , , , , [6, 7, 8, 9]], [
        ,
        ,
        "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
        ,
        ,
        ,
        "12345678",
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[67])))\\d{4}|98\\d{6}", , , , "921234567", , , [8, 9]], [, , "80[01]\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "6[01459]\\d{6}|6[01]\\d{4,5}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [
        ,
        "(\\d)(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["1"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "62\\d{6,7}|72\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]],
      HT: [
        ,
        [, , "(?:[2-489]\\d|55)\\d{6}", , , , , , , [8]],
        [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"],
        [, , "(?:[34]\\d|55)\\d{6}", , , , "34101234"],
        [, , "8\\d{7}", , , , "80012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}", , , , "98901234"],
        "HT",
        509,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      HU: [
        ,
        [, , "[235-7]\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9], [6, 7]],
        [, , "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6, 7]],
        [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]],
        [, , "(?:[48]0\\d|680[29])\\d{5}", , , , "80123456"],
        [, , "9[01]\\d{6}", , , , "90123456", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "21\\d{7}", , , , "211234567", , , [9]],
        "HU",
        36,
        "00",
        "06",
        ,
        ,
        "06",
        ,
        ,
        ,
        [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "(?:[48]0\\d|680[29])\\d{5}"],
        [, , "38\\d{7}", , , , "381234567", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ID: [, [
        ,
        ,
        "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 8, 9, 10, 11, 12, 13],
        [5, 6]
      ], [
        ,
        ,
        "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
        ,
        ,
        ,
        "218350123",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , "8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}", , , , "8001234567", , , [8, 9, 10, 11, 12, 13]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "00[89]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [
        ,
        "(\\d{3})(\\d{5,8})",
        "$1 $2",
        ["[2-79]"],
        "(0$1)"
      ], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["001"]], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [
        ,
        "(\\d{2})(\\d{5,9})",
        "$1 $2",
        ["2[124]|[36]1"],
        "(0$1)"
      ], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "001803\\d{6,7}|(?:007803\\d|8071)\\d{6}", , , , , , , [10, 12, 13]], [
        ,
        ,
        "(?:1500|8071\\d{3})\\d{3}",
        ,
        ,
        ,
        "8071123456",
        ,
        ,
        [7, 10]
      ], , , [, , , , , , , , , [-1]]],
      IE: [, [, , "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", , , , , , , [7, 8, 9, 10], [5, 6]], [, , "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}", , , , "2212345", , , , [5, 6]], [, , "8(?:22|[35-9]\\d)\\d{6}", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", , , , "1520123456", , , [10]], [
        ,
        ,
        "18[59]0\\d{6}",
        ,
        ,
        ,
        "1850123456",
        ,
        ,
        [10]
      ], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["[78]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , , , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", , , , "8551234567", , , [10]]],
      IL: [, [, , "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", , , , , , , [7, 8, 9, 10, 11, 12]], [
        ,
        ,
        "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
        ,
        ,
        ,
        "21234567",
        ,
        ,
        [8, 11, 12],
        [7]
      ], [, , "55410\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2[2-9]|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", , , , "502345678", , , [9]], [, , "1(?:255|80[019]\\d{3})\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", , , , "1919123456", , , [8, 10]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [
        ,
        ,
        "7(?:38(?:0\\d|5[09]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
        ,
        ,
        ,
        "771234567",
        ,
        ,
        [9]
      ], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "(\\d{4})(\\d{3})", "$1-$2", ["125"]], [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], , [, , , , , , , , , [-1]], , , [, , "1700\\d{6}", , , , , , , [10]], [
        ,
        ,
        "1599\\d{6}",
        ,
        ,
        ,
        "1599123456",
        ,
        ,
        [10]
      ], , , [, , "151\\d{8,9}", , , , "15112340000", , , [11, 12]]],
      IM: [
        ,
        [, , "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]],
        [, , "1624(?:230|[5-8]\\d\\d)\\d{3}", , , , "1624756789", , , , [6]],
        [, , "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"],
        [, , "808162\\d{4}", , , , "8081624567"],
        [, , "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}", , , , "9016247890"],
        [, , , , , , , , , [-1]],
        [, , "70\\d{8}", , , , "7012345678"],
        [, , "56\\d{8}", , , , "5612345678"],
        "IM",
        44,
        "00",
        "0",
        ,
        ,
        "([25-8]\\d{5})$|0",
        "1624$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "74576|(?:16|7[56])24",
        [, , , , , , , , , [-1]],
        [, , "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}", , , , "5512345678"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      IN: [, [, , "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [
        ,
        ,
        "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
        ,
        ,
        ,
        "7410410123",
        ,
        ,
        [10],
        [6, 7, 8]
      ], [
        ,
        ,
        "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
        ,
        ,
        ,
        "8123456789",
        ,
        ,
        [10]
      ], [, , "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["140"],
        ,
        ,
        1
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        [
          "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
        ],
        "0$1",
        ,
        1
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
      ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3 $4",
        ["0"]
      ], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
        "0$1",
        ,
        1
      ], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        [
          "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
        ],
        "0$1",
        ,
        1
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
      ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
        ,
        "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3 $4",
        ["18"],
        ,
        ,
        1
      ]], [, , , , , , , , , [-1]], , , [, , "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]],
      IO: [, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      IQ: [, [
        ,
        ,
        "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10],
        [6, 7]
      ], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      IR: [
        ,
        [, , "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", , , , , , , [4, 5, 6, 7, 10], [8]],
        [, , "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}", , , , "2123456789", , , [6, 7, 10], [4, 5, 8]],
        [, , "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", , , , "9123456789", , , [10]],
        [, , , , , , , , , [-1]],
        [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "IR",
        98,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))", , , , , , , [4, 5, 10]],
        [
          ,
          ,
          "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
          ,
          ,
          ,
          "9601",
          ,
          ,
          [4, 5]
        ],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      IS: [, [, , "(?:38\\d|[4-9])\\d{6}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", , , , "4101234", , , [7]], [, , "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}", , , , "6111234"], [, , "80[0-8]\\d{4}", , , , "8001234", , , [7]], [
        ,
        ,
        "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
        ,
        ,
        ,
        "9001234",
        ,
        ,
        [7]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49[0-24-79]\\d{4}", , , , "4921234", , , [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:689|8(?:7[18]|80)|95[48])\\d{4}", , , , "6891234", , , [7]]],
      IT: [, [, , "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [
        ,
        ,
        "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
        ,
        ,
        ,
        "0212345678",
        ,
        ,
        [6, 7, 8, 9, 10, 11]
      ], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "IT", 39, "00", , , , , , , , [
        [, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]],
        [, "(\\d{6})", "$1", ["1(?:1|92)"]],
        [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
        [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],
        [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
        [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]],
        [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]],
        [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]],
        [
          ,
          "(\\d{2})(\\d{4})(\\d{5})",
          "$1 $2 $3",
          ["0[26]"]
        ],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
        [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]
      ], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["1(?:44|[679])|[378]"]
      ], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
      JE: [, [, , "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [
        ,
        ,
        "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}",
        ,
        ,
        ,
        "7797712345"
      ], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , , , , , , , , [-1]], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "([0-24-8]\\d{5})$|0", "1534$1", , , , , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
        ,
        ,
        ,
        "5512345678"
      ], , , [, , , , , , , , , [-1]]],
      JM: [, [, , "(?:[58]\\d\\d|658|900)\\d{7}", , , , , , , [10], [7]], [, , "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", , , , "8765230123", , , , [7]], [
        ,
        ,
        "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
        ,
        ,
        ,
        "8762101234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "658|876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      JO: [, [, , "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", , , , , , , [8, 9]], [
        ,
        ,
        "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
        ,
        ,
        ,
        "62001234",
        ,
        ,
        [8]
      ], [, , "7(?:[78][0-25-9]|9\\d)\\d{6}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "9\\d{7}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [
        ,
        ,
        "74(?:66|77)\\d{5}",
        ,
        ,
        ,
        "746612345",
        ,
        ,
        [9]
      ], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]],
      JP: [, [, , "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", , , , "312345678", , , [9]], [
        ,
        ,
        "[7-9]0[1-9]\\d{7}",
        ,
        ,
        ,
        "9012345678",
        ,
        ,
        [10]
      ], [, , "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
        ,
        "(\\d{4})(\\d)(\\d{4})",
        "$1-$2-$3",
        ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
        "0$1"
      ], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        ["60"],
        "0$1"
      ], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
        ],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [
        ,
        "(\\d{4})(\\d{6})(\\d{6,7})",
        "$1-$2-$3",
        ["0"]
      ]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
        ,
        "(\\d{4})(\\d)(\\d{4})",
        "$1-$2-$3",
        ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
        ],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"], [, , "570\\d{6}", , , , "570123456", , , [9]], , , [, , , , , , , , , [-1]]],
      KE: [, [, , "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", , , , , , , [7, 8, 9, 10]], [
        ,
        ,
        "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
        ,
        ,
        ,
        "202012345",
        ,
        ,
        [7, 8, 9]
      ], [, , "(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}", , , , "712123456", , , [9]], [, , "800[2-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KG: [, [
        ,
        ,
        "8\\d{9}|[235-9]\\d{8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9, 10],
        [5, 6]
      ], [, , "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", , , , "312123456", , , [9], [5, 6]], [, , "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KH: [
        ,
        [, , "1\\d{9}|[1-9]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]],
        [
          ,
          ,
          "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
          ,
          ,
          ,
          "23756789",
          ,
          ,
          [8, 9],
          [6, 7]
        ],
        [, , "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", , , , "91234567", , , [8, 9]],
        [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]],
        [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "KH",
        855,
        "00[14-9]",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      KI: [, [, , "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", , , , "31234"], [
        ,
        ,
        "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
        ,
        ,
        ,
        "72001234",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", , , , "30010000", , , [8]], "KI", 686, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KM: [, [, , "[3478]\\d{6}", , , , , , , [7], [4]], [, , "7[4-7]\\d{5}", , , , "7712345", , , , [4]], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[
        ,
        "(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3",
        ["[3478]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KN: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "([2-7]\\d{6})$|1", "869$1", , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KP: [, [, , "85\\d{6}|(?:19\\d|[2-7])\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}", , , , "21234567", , , , [6, 7]], [, , "19[1-3]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[
        ,
        "(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["8"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KR: [, [, , "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [
        ,
        ,
        "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
        ,
        ,
        ,
        "22123456",
        ,
        ,
        [5, 6, 8, 9, 10],
        [3, 4, 7]
      ], [, , "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", , , , "1020000000", , , [9, 10]], [, , "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8,9}", , , , "5012345678", , , [10, 11]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0", , , "0(8(?:[1-46-8]|5\\d\\d))?", , , , [[
        ,
        "(\\d{5})",
        "$1",
        ["1[016-9]1", "1[016-9]11", "1[016-9]114"],
        "0$1"
      ], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [
        ,
        "(\\d{2})(\\d{5})(\\d{4})",
        "$1-$2-$3",
        ["5"],
        "0$1",
        "0$CC-$1"
      ], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [
        [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"],
        [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]],
        [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]
      ], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})", , , , , , , [11, 12, 13, 14]], [, , "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]],
      KW: [, [, , "18\\d{5}|(?:[2569]\\d|41)\\d{6}", , , , , , , [7, 8]], [, , "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", , , , "22345678", , , [8]], [
        ,
        ,
        "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
        ,
        ,
        ,
        "50012345",
        ,
        ,
        [8]
      ], [, , "18\\d{5}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KY: [, [, , "(?:345|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",
        ,
        ,
        ,
        "3452221234",
        ,
        ,
        ,
        [7]
      ], [, , "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "(?:345976|900[2-9]\\d\\d)\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "([2-9]\\d{6})$|1", "345$1", , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KZ: [, [, , "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", , , , , , , [10, 14], [5, 6, 7]], [
        ,
        ,
        "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
        ,
        ,
        ,
        "7123456789",
        ,
        ,
        [10],
        [5, 6, 7]
      ], [, , "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", , , , "7710009998", , , [10]], [, , "8(?:00|108\\d{3})\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , "751\\d{7}", , , , "7511234567", , , [10]], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , "33|7", [, , "751\\d{7}", , , , , , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LA: [, [, , "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", , , , , , , [8, 9, 10], [6]], [
        ,
        ,
        "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
        ,
        ,
        ,
        "21212862",
        ,
        ,
        [8],
        [6]
      ], [, , "(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}", , , , "2023123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "30[013-9]\\d{6}", , , , "301234567", , , [9]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      LB: [, [, , "[27-9]\\d{7}|[13-9]\\d{6}", , , , , , , [7, 8]], [, , "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}", , , , "1123456"], [, , "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[
        ,
        "(\\d)(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LC: [
        ,
        [, , "(?:[58]\\d\\d|758|900)\\d{7}", , , , , , , [10], [7]],
        [, , "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}", , , , "7584305678", , , , [7]],
        [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}", , , , "7582845678", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "LC",
        1,
        "011",
        "1",
        ,
        ,
        "([2-8]\\d{6})$|1",
        "758$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "758",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      LI: [, [, , "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", , , , , , , [7, 9]], [
        ,
        ,
        "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
        ,
        ,
        ,
        "2345678",
        ,
        ,
        [7]
      ], [, , "(?:6(?:(?:4[5-9]|5[0-4])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}", , , , "660234567"], [, , "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}", , , , "8002222"], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", , , , "9002222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "(1001)|0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["69"],
        ,
        "$CC $1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d\\d", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]],
      LK: [, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", , , , "112345678", , , , [7]], [, , "7(?:[0-25-8]\\d|4[0-4])\\d{6}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "1973\\d{5}", , , , "197312345"], , , [, , , , , , , , , [-1]]],
      LR: [, [, , "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", , , , , , , [7, 8, 9]], [, , "2\\d{7}", , , , "21234567", , , [8]], [, , "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [
        ,
        ,
        "332(?:02|[34]\\d)\\d{4}",
        ,
        ,
        ,
        "332021234",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LS: [, [, , "(?:[256]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LT: [, [, , "(?:[3469]\\d|52|[78]0)\\d{6}", , , , , , , [8]], [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"], [, , "6\\d{7}", , , , "61234567"], [, , "80[02]\\d{5}", , , , "80012345"], [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , "70[05]\\d{5}", , , , "70012345"], [, , "[89]01\\d{5}", , , , "80123456"], "LT", 370, "00", "8", , , "[08]", , , , [[
        ,
        "(\\d)(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["52[0-7]"],
        "(8-$1)",
        ,
        1
      ], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", , 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", , 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70[67]\\d{5}", , , , "70712345"], , , [, , , , , , , , , [-1]]],
      LU: [, [, , "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
        ,
        ,
        ,
        "27123456"
      ], [, , "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3",
        ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
        ,
        "$CC $1"
      ], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
        "$1 $2 $3 $4",
        ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],
        ,
        "$CC $1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LV: [, [, , "(?:[268]\\d|90)\\d{6}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[269]|8[01]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LY: [
        ,
        [, , "[2-9]\\d{8}", , , , , , , [9], [7]],
        [, , "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}", , , , "212345678", , , , [7]],
        [, , "9[1-6]\\d{7}", , , , "912345678"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "LY",
        218,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MA: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}", , , , "520123456"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , "592(?:4[0-2]|93)\\d{4}", , , , "592401234"], "MA", 212, "00", "0", , , "0", , , , [[, "(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[1289]|389)", "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], [, "(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MC: [, [, , "(?:[3489]|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "(?:870|9[2-47-9]\\d)\\d{5}", , , , "99123456", , , [8]], [, , "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}", , , , "612345678"], [, , "(?:800|90\\d)\\d{5}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MC", 377, "00", "0", , , "0", , , , [
        [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["87"]],
        [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"],
        [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]],
        [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]
      ], [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "8[07]0\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MD: [
        ,
        [, , "(?:[235-7]\\d|[89]0)\\d{6}", , , , , , , [8]],
        [, , "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"],
        [, , "562\\d{5}|(?:6\\d|7[16-9])\\d{6}", , , , "62112345"],
        [, , "800\\d{5}", , , , "80012345"],
        [, , "90[056]\\d{5}", , , , "90012345"],
        [, , "808\\d{5}", , , , "80812345"],
        [, , , , , , , , , [-1]],
        [, , "3[08]\\d{6}", , , , "30123456"],
        "MD",
        373,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "803\\d{5}", , , , "80312345"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ME: [, [, , "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", , , , , , , [8, 9], [6]], [
        ,
        ,
        "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
        ,
        ,
        ,
        "30234567",
        ,
        ,
        [8],
        [6]
      ], [, , "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", , , , "67622901", , , [8]], [, , "80(?:[0-2578]|9\\d)\\d{5}", , , , "80080002"], [, , "9(?:4[1568]|5[178])\\d{5}", , , , "94515151", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780", , , [8]], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012", , , [8]], , , [, , , , , , , , , [-1]]],
      MF: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [
        ,
        ,
        "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}",
        ,
        ,
        ,
        "590271234"
      ], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"], "MF", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MG: [, [, , "[23]\\d{8}", , , , , , , [9], [7]], [, , "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}", , , , "202123456", , , , [7]], [, , "3[2-47-9]\\d{7}", , , , "321234567"], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "22\\d{7}", , , , "221234567"], "MG", 261, "00", "0", , , "([24-9]\\d{6})$|0", "20$1", , , [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MH: [, [, , "329\\d{4}|(?:[256]\\d|45)\\d{5}", , , , , , , [7]], [, , "(?:247|45[78]|528|625)\\d{4}", , , , "2471234"], [, , "(?:(?:23|54)5|329|45[356])\\d{4}", , , , "2351234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "635\\d{4}",
        ,
        ,
        ,
        "6351234"
      ], "MH", 692, "011", "1", , , "1", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MK: [, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]], [
        ,
        ,
        "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
        ,
        ,
        ,
        "72345678"
      ], [, , "800\\d{5}", , , , "80012345"], [, , "5\\d{7}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MK", 389, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ML: [, [, , "[24-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
        ,
        ,
        ,
        "20212345"
      ], [, , "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}", , , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MM: [
        ,
        [, , "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", , , , , , , [6, 7, 8, 9, 10], [5]],
        [
          ,
          ,
          "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4[67]0)))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
          ,
          ,
          ,
          "1234567",
          ,
          ,
          [6, 7, 8, 9],
          [5]
        ],
        [, , "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", , , , "92123456", , , [7, 8, 9, 10]],
        [, , "80080(?:0[1-9]|2\\d)\\d{3}", , , , "8008001234", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "1333\\d{4}|[12]468\\d{4}", , , , "13331234", , , [8]],
        "MM",
        95,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [
          ,
          "(\\d{2})(\\d{2})(\\d{3})",
          "$1 $2 $3",
          ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [, "(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]],
        ,
        [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MN: [, [, , "[12]\\d{7,9}|[5-9]\\d{7}", , , , , , , [8, 9, 10], [4, 5, 6]], [, , "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}", , , , "53123456", , , , [4, 5, 6]], [, , "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", , , , "88123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",
        ,
        ,
        ,
        "75123456",
        ,
        ,
        [8]
      ], "MN", 976, "001", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MO: [, [, , "0800\\d{3}|(?:28|[68]\\d)\\d{6}", , , , , , , [7, 8]], [
        ,
        ,
        "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
        ,
        ,
        ,
        "28212345",
        ,
        ,
        [8]
      ], [, , "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", , , , "66123456", , , [8]], [, , "0800\\d{3}", , , , "0800501", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MP: [, [, , "[58]\\d{9}|(?:67|90)0\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
        ,
        ,
        ,
        "6702345678",
        ,
        ,
        ,
        [7]
      ], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "([2-9]\\d{6})$|1", "670$1", , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MQ: [
        ,
        [, , "596\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
        [, , "596(?:[03-7]\\d|10|2[7-9]|8[0-39]|9[04-9])\\d{4}", , , , "596301234"],
        [, , "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}", , , , "696201234"],
        [, , "80[0-5]\\d{6}", , , , "800012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:397[0-2]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}", , , , "976612345"],
        "MQ",
        596,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MR: [, [, , "(?:[2-4]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "(?:25[08]|35\\d|45[1-7])\\d{5}", , , , "35123456"], [, , "[2-4][0-46-9]\\d{6}", , , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[2-48]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MS: [, [, , "(?:[58]\\d\\d|664|900)\\d{7}", , , , , , , [10], [7]], [, , "6644(?:1[0-3]|91)\\d{4}", , , , "6644912345", , , , [7]], [, , "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "([34]\\d{6})$|1", "664$1", , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MT: [, [, , "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}", , , , "96961234"], [, , "800(?:02|[3467]\\d)\\d{3}", , , , "80071234"], [
        ,
        ,
        "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
        ,
        ,
        ,
        "50037123"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]],
      MU: [, [, , "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", , , , , , , [7, 8, 10]], [, , "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", , , , "54480123", , , [7, 8]], [
        ,
        ,
        "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-2]|3[013]))\\d{5}",
        ,
        ,
        ,
        "52512345",
        ,
        ,
        [8]
      ], [, , "802\\d{7}|80[0-2]\\d{4}", , , , "8001234", , , [7, 10]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", , , , , , "020", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], [, "(\\d{5})(\\d{5})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MV: [, [, , "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", , , , , , , [7, 10]], [
        ,
        ,
        "(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
        ,
        ,
        ,
        "6701234",
        ,
        ,
        [7]
      ], [, , "(?:46[46]|[79]\\d\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "4(?:0[01]|50)\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]],
      MW: [, [, , "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", , , , , , , [7, 9]], [
        ,
        ,
        "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
        ,
        ,
        ,
        "1234567"
      ], [, , "111\\d{6}|(?:31|77|[89][89])\\d{7}", , , , "991234567", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MX: [
        ,
        [
          ,
          ,
          "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [10, 11],
          [7, 8]
        ],
        [, , "657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}", , , , "2001234567", , , [10], [7, 8]],
        [
          ,
          ,
          "657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
          ,
          ,
          ,
          "12221234567",
          ,
          ,
          ,
          [7, 8]
        ],
        [, , "8(?:00|88)\\d{7}", , , , "8001234567", , , [10]],
        [, , "900\\d{7}", , , , "9001234567", , , [10]],
        [, , "300\\d{7}", , , , "3001234567", , , [10]],
        [, , "500\\d{7}", , , , "5001234567", , , [10]],
        [, , , , , , , , , [-1]],
        "MX",
        52,
        "0[09]",
        "01",
        ,
        ,
        "0(?:[12]|4[45])|1",
        ,
        "00",
        ,
        [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [
          ,
          "(\\d)(\\d{3})(\\d{3})(\\d{4})",
          "$2 $3 $4",
          ["1"],
          ,
          ,
          1
        ]],
        [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], , , 1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MY: [, [, , "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [
        ,
        ,
        "(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
        ,
        ,
        ,
        "323856789",
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", , , , "123456789", , , [9, 10]], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
        ,
        ,
        ,
        "1546012345",
        ,
        ,
        [10]
      ], "MY", 60, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      MZ: [, [, , "(?:2|8\\d)\\d{7}", , , , , , , [8, 9]], [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]], [, , "8[2-79]\\d{7}", , , , "821234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MZ", 258, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NA: [, [
        ,
        ,
        "[68]\\d{7,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9]
      ], [, , "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}", , , , "61221234"], [, , "(?:60|8[1245])\\d{7}", , , , "811234567", , , [9]], [, , "80\\d{7}", , , , "800123456", , , [9]], [
        ,
        ,
        "8701\\d{5}",
        ,
        ,
        ,
        "870123456",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d\\d|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NC: [, [, , "(?:050|[2-57-9]\\d\\d)\\d{3}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [
        ,
        ,
        "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",
        ,
        ,
        ,
        "751234"
      ], [, , "050\\d{3}", , , , "050012"], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{3})", "$1", ["5[6-8]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NE: [, [, , "[027-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
        ,
        ,
        ,
        "20201234"
      ], [, , "(?:23|7[047]|[89]\\d)\\d{6}", , , , "93123456"], [, , "08\\d{6}", , , , "08123456"], [, , "09\\d{6}", , , , "09123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NE", 227, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NF: [, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", , , , "106609", , , , [5]], [
        ,
        ,
        "(?:14|3[58])\\d{4}",
        ,
        ,
        ,
        "381234",
        ,
        ,
        ,
        [5]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , "([0-258]\\d{4})$", "3$1", , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], [, "(\\d)(\\d{5})", "$1 $2", ["[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NG: [, [, , "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", , , , , , , [7, 8, 10, 11, 12, 13, 14], [5, 6]], [
        ,
        ,
        "(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",
        ,
        ,
        ,
        "18040123",
        ,
        ,
        [7, 8],
        [5, 6]
      ], [, , "(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}", , , , "8021234567", , , [10]], [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["[7-9]"],
        "0$1"
      ], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]]],
      NI: [, [, , "(?:1800|[25-8]\\d{3})\\d{4}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [, , "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}", , , , "81234567"], [, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NL: [, [, , "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", , , , , , , [5, 6, 7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
        ,
        ,
        ,
        "101234567",
        ,
        ,
        [9]
      ], [, , "(?:6[1-58]|970\\d)\\d{7}", , , , "612345678", , , [9, 11]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:85|91)\\d{7}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{5})",
        "$1 $2 $3",
        ["9"],
        "0$1"
      ]], [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d", , , , , , , [5, 6]], [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", , , , "14020", , , [5, 6, 9]], , , [, , , , , , , , , [-1]]],
      NO: [, [, , "(?:0|[2-9]\\d{3})\\d{4}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [
        ,
        ,
        "(?:4[015-8]|9\\d)\\d{6}",
        ,
        ,
        ,
        "40612345",
        ,
        ,
        [8]
      ], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], , [, , , , , , , , , [-1]], 1, "[02-689]|7[0-8]", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
        ,
        ,
        "81[23]\\d{5}",
        ,
        ,
        ,
        "81212345",
        ,
        ,
        [8]
      ]],
      NP: [, [, , "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", , , , , , , [8, 10, 11], [6, 7]], [, , "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", , , , "14567890", , , [8], [6, 7]], [, , "9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , "1(?:66001|800\\d\\d)\\d{5}", , , , "16600101234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [
        ,
        "(\\d{2})(\\d{6})",
        "$1-$2",
        ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
        "0$1"
      ], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]], [, "(\\d{4})(\\d{2})(\\d{5})", "$1-$2-$3", ["1"]]], [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NR: [, [, , "(?:444|(?:55|8\\d)\\d|666)\\d{4}", , , , , , , [7]], [, , "444\\d{4}", , , , "4441234"], [, , "(?:55[3-9]|666|8\\d\\d)\\d{4}", , , , "5551234"], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NU: [, [, , "(?:[47]|888\\d)\\d{3}", , , , , , , [4, 7]], [, , "[47]\\d{3}", , , , "7012", , , [4]], [, , "888[4-9]\\d{3}", , , , "8884012", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NU", 683, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      NZ: [
        ,
        [, , "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", , , , , , , [5, 6, 7, 8, 9, 10]],
        [, , "24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", , , , "32345678", , , [8], [7]],
        [, , "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", , , , "211234567", , , [8, 9, 10]],
        [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456", , , [8, 9, 10]],
        [, , "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", , , , "900123456", , , [7, 8, 9, 10]],
        [, , , , , , , , , [-1]],
        [
          ,
          ,
          "70\\d{7}",
          ,
          ,
          ,
          "701234567",
          ,
          ,
          [9]
        ],
        [, , , , , , , , , [-1]],
        "NZ",
        64,
        "0(?:0|161)",
        "0",
        ,
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}", , , , "83012378"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      OM: [
        ,
        [, , "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", , , , , , , [7, 8, 9]],
        [, , "2[1-6]\\d{6}", , , , "23123456", , , [8]],
        [, , "1505\\d{4}|(?:7(?:[1289]\\d|6[89]|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}", , , , "92123456", , , [8]],
        [, , "8007\\d{4,5}|(?:500|800[05])\\d{4}", , , , "80071234"],
        [, , "900\\d{5}", , , , "90012345", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "OM",
        968,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PA: [, [, , "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", , , , , , , [7, 8, 10, 11]], [
        ,
        ,
        "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
        ,
        ,
        ,
        "2001234",
        ,
        ,
        [7]
      ], [, , "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", , , , "61234567", , , [7, 8]], [, , "800\\d{4,5}|(?:00800|800\\d)\\d{6}", , , , "8001234"], [, , "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PE: [, [
        ,
        ,
        "(?:[14-8]|9\\d)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "00|19(?:1[124]|77|90)00", "0", " Anexo ", , "0", , "00", , [[
        ,
        "(\\d{3})(\\d{5})",
        "$1 $2",
        ["80"],
        "(0$1)"
      ], [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PF: [
        ,
        [, , "4\\d{5}(?:\\d{2})?|8\\d{7,8}", , , , , , , [6, 8, 9]],
        [, , "4(?:0[4-689]|9[4-68])\\d{5}", , , , "40412345", , , [8]],
        [, , "8[7-9]\\d{6}", , , , "87123456", , , [8]],
        [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "499\\d{5}", , , , "49901234", , , [8]],
        "PF",
        689,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "44\\d{4}", , , , , , , [6]],
        [, , "44\\d{4}", , , , "440123", , , [6]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PG: [, [, , "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", , , , , , , [7, 8]], [, , "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", , , , "3123456", , , [7]], [, , "(?:7\\d|8[128])\\d{6}", , , , "70123456", , , [8]], [
        ,
        ,
        "180\\d{4}",
        ,
        ,
        ,
        "1801234",
        ,
        ,
        [7]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-57]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "00|140[1-3]", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], , [, , "27[01]\\d{4}", , , , "2700123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PH: [, [, , "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [
        ,
        ,
        "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
        ,
        ,
        ,
        "232345678",
        ,
        ,
        [6, 8, 9, 10],
        [4, 5, 7]
      ], [, , "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [
        ,
        "(\\d{4})(\\d{4,6})",
        "$1 $2",
        ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
        "(0$1)"
      ], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PK: [, [
        ,
        ,
        "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10, 11, 12],
        [5, 6, 7]
      ], [, , "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", , , , "2123456789", , , [9, 10], [5, 6, 7, 8]], [, , "3(?:[0-24]\\d|3[0-79]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}(?:\\d{3})?", , , , "80012345", , , [8, 11]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [
        ,
        ,
        "122\\d{6}",
        ,
        ,
        ,
        "122044444",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [
        ,
        "(\\d{3})(\\d{6,7})",
        "$1 $2",
        ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
        ,
        ,
        ,
        "21111825888",
        ,
        ,
        [11, 12]
      ], , , [, , , , , , , , , [-1]]],
      PL: [, [, , "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [, , "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", , , , "123456789", , , [7, 9]], [, , "21(?:1(?:[145]\\d|3[1-5])|2\\d\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [
        ,
        ,
        "801\\d{6}",
        ,
        ,
        ,
        "801234567",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [
        [, "(\\d{5})", "$1", ["19"]],
        [, "(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]],
        [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],
        [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]],
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],
        [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]
      ], , [, , "64\\d{4,7}", , , , "641234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]],
      PM: [
        ,
        [, , "[45]\\d{5}|(?:708|80\\d)\\d{6}", , , , , , , [6, 9]],
        [, , "(?:4[1-35-7]|5[01])\\d{4}", , , , "430123", , , [6]],
        [, , "(?:4[02-4]|5[056]|708[45][0-5])\\d{4}", , , , "551234"],
        [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "PM",
        508,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PR: [, [, , "(?:[589]\\d\\d|787)\\d{7}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
        ,
        ,
        "900[2-9]\\d{6}",
        ,
        ,
        ,
        "9002345678"
      ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PS: [, [, , "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", , , , , , , [8, 9, 10], [7]], [
        ,
        ,
        "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
        ,
        ,
        ,
        "22234567",
        ,
        ,
        [8],
        [7]
      ], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PT: [
        ,
        [, , "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", , , , , , , [9]],
        [, , "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}", , , , "212345678"],
        [, , "6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}", , , , "912345678"],
        [, , "80[02]\\d{6}", , , , "800123456"],
        [, , "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}", , , , "760123456"],
        [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"],
        [, , "884[0-4689]\\d{5}", , , , "884123456"],
        [, , "30\\d{7}", , , , "301234567"],
        "PT",
        351,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["2[12]"]
        ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]],
        ,
        [, , "6222\\d{5}", , , , "622212345"],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}", , , , "707123456"],
        ,
        ,
        [, , "600\\d{6}|6[06]9233\\d{3}", , , , "600110000"]
      ],
      PW: [, [, , "(?:[24-8]\\d\\d|345|900)\\d{4}", , , , , , , [7]], [, , "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}", , , , "2771234"], [, , "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}", , , , "6201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PW", 680, "01[12]", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PY: [, [, , "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [
        ,
        ,
        "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
        ,
        ,
        ,
        "212345678",
        ,
        ,
        [7, 8, 9],
        [5, 6]
      ], [, , "9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , "9800\\d{5,7}", , , , "98000123456", , , [9, 10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]]],
      QA: [, [, , "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", , , , , , , [7, 8, 9, 11]], [
        ,
        ,
        "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
        ,
        ,
        ,
        "44123456",
        ,
        ,
        [8]
      ], [, , "[35-7]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}|(?:0080[01]|800)\\d{6}", , , , "8001234", , , [7, 9, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2[16]\\d{5}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RE: [, [, , "(?:26|[689]\\d)\\d{7}", , , , , , , [9]], [, , "26(?:2\\d\\d|3(?:0\\d|1[0-5]))\\d{4}", , , , "262161234"], [
        ,
        ,
        "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-27]|8[0-8]|9[0-479]))\\d{4}",
        ,
        ,
        ,
        "692123456"
      ], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}", , , , "939901234"], "RE", 262, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RO: [, [, , "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", , , , , , , [6, 9]], [
        ,
        ,
        "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
        ,
        ,
        ,
        "211234567"
      ], [, , "7020\\d{5}|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-29])\\d{6}", , , , "712034567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[0136]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[237-9]"],
        "0$1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:37\\d|80[578])\\d{6}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]],
      RS: [, [, , "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", , , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [, , "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [4, 5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [, , "800\\d{3,9}", , , , "80012345"], [
        ,
        ,
        "(?:78\\d|90[0169])\\d{3,7}",
        ,
        ,
        ,
        "90012345",
        ,
        ,
        [6, 7, 8, 9, 10]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]],
      RU: [, [, , "8\\d{13}|[347-9]\\d{9}", , , , , , , [10, 14], [7]], [
        ,
        ,
        "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
        ,
        ,
        ,
        "3011234567",
        ,
        ,
        [10],
        [7]
      ], [, , "9\\d{9}", , , , "9123456789", , , [10]], [, , "8(?:0[04]|108\\d{3})\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[0-79]"]], [
        ,
        "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2-$3-$4",
        ["[349]|8(?:[02-7]|1[1-8])"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
        ,
        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [, , , , , , , , , [-1]], 1, "3[04-689]|[489]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RW: [, [, , "(?:06|[27]\\d\\d|[89]00)\\d{6}", , , , , , , [8, 9]], [, , "(?:06|2[23568]\\d)\\d{6}", , , , "250123456"], [, , "7[237-9]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
        ,
        ,
        "900\\d{6}",
        ,
        ,
        ,
        "900123456",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SA: [, [, , "92\\d{7}|(?:[15]|8\\d)\\d{8}", , , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [9], [7]], [
        ,
        ,
        "579[01]\\d{5}|5(?:[013-689]\\d|7[0-35-8])\\d{6}",
        ,
        ,
        ,
        "512345678",
        ,
        ,
        [9]
      ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "925\\d{6}", , , , "925012345", , , [9]], [, , "920\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "811\\d{7}",
        ,
        ,
        ,
        "8110123456",
        ,
        ,
        [10]
      ], , , [, , , , , , , , , [-1]]],
      SB: [
        ,
        [, , "(?:[1-6]|[7-9]\\d\\d)\\d{4}", , , , , , , [5, 7]],
        [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]],
        [, , "48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}", , , , "7421234"],
        [, , "1[38]\\d{3}", , , , "18123", , , [5]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "5[12]\\d{3}", , , , "51123", , , [5]],
        "SB",
        677,
        "0[01]",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SC: [, [, , "800\\d{4}|(?:[249]\\d|64)\\d{5}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[125-8]\\d{5}", , , , "2510123"], [, , "800[08]\\d{3}", , , , "8000000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "971\\d{4}|(?:64|95)\\d{5}", , , , "6412345"], "SC", 248, "010|0[0-2]", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SD: [, [, , "[19]\\d{8}", , , , , , , [9]], [
        ,
        ,
        "1(?:5\\d|8[35-7])\\d{6}",
        ,
        ,
        ,
        "153123456"
      ], [, , "(?:1[0-2]|9[0-3569])\\d{7}", , , , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SE: [, [, , "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", , , , , , , [6, 7, 8, 9, 10, 12]], [
        ,
        ,
        "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
        ,
        ,
        ,
        "8123456",
        ,
        ,
        [7, 8, 9]
      ], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77[0-7]\\d{6}", , , , "771234567", , , [9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{2})",
        "$1-$2 $3",
        ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
        "0$1"
      ], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1"], [
        ,
        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
        "$1-$2 $3 $4",
        ["8"],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44|9)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [
        ,
        "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["8"]
      ], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["10|7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "10[1-8]\\d{6}", , , , "102345678", , , [9]], , , [, , "(?:25[245]|67[3-68])\\d{9}", , , , "254123456789", , , [12]]],
      SG: [, [, , "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", , , , , , , [8, 10, 11]], [
        ,
        ,
        "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
        ,
        ,
        ,
        "61234567",
        ,
        ,
        [8]
      ], [, , "8(?:08[01]|95[0-2])\\d{4}|(?:8(?:0[1-7]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}", , , , "81234567", , , [8]], [, , "(?:18|8)00\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[12]\\d|666)\\d{5}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [[, "(\\d{4,5})", "$1", ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{4})(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["7"]
      ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]],
      SH: [, [, , "(?:[256]\\d|8)\\d{3}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d\\d", , , , "22158"], [
        ,
        ,
        "[56]\\d{4}",
        ,
        ,
        ,
        "51234",
        ,
        ,
        [5]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "262\\d\\d", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, "[256]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SI: [
        ,
        [, , "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", , , , , , , [5, 6, 7, 8]],
        [, , "(?:[1-357][2-8]|4[24-8])\\d{6}", , , , "12345678", , , [8], [7]],
        [, , "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", , , , "31234567", , , [8]],
        [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]],
        [, , "89[1-3]\\d{2,5}|90\\d{4,6}", , , , "90123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", , , , "59012345", , , [8]],
        "SI",
        386,
        "00|10(?:22|66|88|99)",
        "0",
        ,
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SJ: [, [, , "0\\d{4}|(?:[489]\\d|79)\\d{6}", , , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "79", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
        ,
        ,
        "81[23]\\d{5}",
        ,
        ,
        ,
        "81212345",
        ,
        ,
        [8]
      ]],
      SK: [
        ,
        [, , "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", , , , , , , [6, 7, 9]],
        [, , "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", , , , "221234567"],
        [, , "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", , , , "912123456", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "9(?:00|[78]\\d)\\d{6}", , , , "900123456", , , [9]],
        [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]],
        [, , , , , , , , , [-1]],
        [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]],
        "SK",
        421,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
        [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", [
          "[3-5][1-8]1",
          "[3-5][1-8]1[67]"
        ], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
        [, , "9090\\d{3}", , , , "9090123", , , [7]],
        ,
        ,
        [, , "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}", , , , , , , [7, 9]],
        [, , "96\\d{7}", , , , "961234567", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SL: [, [, , "(?:[237-9]\\d|66)\\d{6}", , , , , , , [8], [6]], [, , "22[2-4][2-9]\\d{4}", , , , "22221234", , , , [6]], [
        ,
        ,
        "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
        ,
        ,
        ,
        "25123456"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SM: [, [, , "(?:0549|[5-7]\\d)\\d{6}", , , , , , , [8, 10], [6]], [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , "66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "5[158]\\d{6}",
        ,
        ,
        ,
        "58001110",
        ,
        ,
        [8]
      ], "SM", 378, "00", , , , "([89]\\d{5})$", "0549$1", , , [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SN: [, [, , "(?:[378]\\d|93)\\d{7}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [
        ,
        ,
        "7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}",
        ,
        ,
        ,
        "701234567"
      ], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SO: [, [, , "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", , , , , , , [6, 7, 8, 9]], [
        ,
        ,
        "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
        ,
        ,
        ,
        "4012345",
        ,
        ,
        [6, 7]
      ], [, , "(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], [
        ,
        "(\\d)(\\d{7})",
        "$1 $2",
        ["(?:2|90)4|[67]"]
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SR: [, [, , "(?:[2-5]|68|[78]\\d)\\d{5}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}", , , , "211234"], [, , "(?:7[124-7]|8[124-9])\\d{5}", , , , "7412345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "56\\d{4}", , , , "561234", , , [6]], "SR", 597, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})",
        "$1-$2-$3",
        ["56"]
      ], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SS: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1[89]\\d{7}", , , , "181234567"], [, , "(?:12|9[1257-9])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      ST: [, [, , "(?:22|9\\d)\\d{5}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SV: [, [, , "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", , , , , , , [7, 8, 11]], [
        ,
        ,
        "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
        ,
        ,
        ,
        "21234567",
        ,
        ,
        [8]
      ], [, , "[67]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{4}(?:\\d{4})?", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SX: [
        ,
        [, , "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
          ,
          ,
          ,
          "7215425678",
          ,
          ,
          ,
          [7]
        ],
        [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "SX",
        1,
        "011",
        "1",
        ,
        ,
        "(5\\d{6})$|1",
        "721$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "721",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SY: [, [, , "[1-39]\\d{8}|[1-5]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "9[1-689]\\d{7}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["9"],
        "0$1",
        ,
        1
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SZ: [, [, , "0800\\d{4}|(?:[237]\\d|900)\\d{6}", , , , , , , [8, 9]], [, , "[23][2-5]\\d{6}", , , , "22171234", , , [8]], [, , "7[6-9]\\d{6}", , , , "76123456", , , [8]], [, , "0800\\d{4}", , , , "08001234", , , [8]], [, , "900\\d{6}", , , , "900012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{6}", , , , "70012345", , , [8]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["9"]]], , [, , , , , , , , , [-1]], , , [
        ,
        ,
        "0800\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TA: [, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TC: [, [, , "(?:[58]\\d\\d|649|900)\\d{7}", , , , , , , [10], [7]], [, , "649(?:266|712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [, , "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002345678"
      ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "649(?:71[01]|966)\\d{4}", , , , "6497101234", , , , [7]], "TC", 1, "011", "1", , , "([2-479]\\d{6})$|1", "649$1", , , , , [, , , , , , , , , [-1]], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TD: [, [, , "(?:22|[69]\\d|77)\\d{6}", , , , , , , [8]], [, , "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:6[0235689]|77|9\\d)\\d{6}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", , , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TG: [, [, , "[279]\\d{7}", , , , , , , [8]], [, , "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}", , , , "22212345"], [
        ,
        ,
        "(?:7[019]|9[0-36-9])\\d{6}",
        ,
        ,
        ,
        "90112345"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TH: [, [, , "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", , , , , , , [8, 9, 10, 13]], [, , "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [, , "671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", , , , "812345678", , , [9]], [
        ,
        ,
        "(?:001800\\d|1800)\\d{6}",
        ,
        ,
        ,
        "1800123456",
        ,
        ,
        [10, 13]
      ], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00[1-9]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TJ: [, [, , "[0-57-9]\\d{8}", , , , , , , [9], [3, 5, 6, 7]], [
        ,
        ,
        "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:4[046]|74|87))\\d{6}",
        ,
        ,
        ,
        "372123456",
        ,
        ,
        ,
        [3, 5, 6, 7]
      ], [, , "(?:41[18]|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[0178]|8[078]|9\\d)\\d{7}", , , , "917123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TJ", 992, "810", , , , , , "8~10", , [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[04]|[34]7"]], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      TK: [, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TL: [, [, , "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", , , , , , , [7, 8]], [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]], [, , "7[2-8]\\d{6}", , , , "77212345", , , [8]], [
        ,
        ,
        "80\\d{5}",
        ,
        ,
        ,
        "8012345",
        ,
        ,
        [7]
      ], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , "70\\d{5}", , , , "7012345", , , [7]], [, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TM: [
        ,
        [, , "[1-6]\\d{7}", , , , , , , [8]],
        [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"],
        [, , "6\\d{7}", , , , "66123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "TM",
        993,
        "810",
        "8",
        ,
        ,
        "8",
        ,
        "8~10",
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      TN: [, [, , "[2-57-9]\\d{7}", , , , , , , [8]], [, , "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}", , , , "30010123"], [
        ,
        ,
        "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
        ,
        ,
        ,
        "20123456"
      ], [, , "8010\\d{4}", , , , "80101234"], [, , "88\\d{6}", , , , "88123456"], [, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TO: [, [, , "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", , , , , , , [5, 7]], [, , "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", , , , "20123", , , [5]], [
        ,
        ,
        "(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
        ,
        ,
        ,
        "7715123",
        ,
        ,
        [7]
      ], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "55[0-37-9]\\d{4}", , , , "5510123", , , [7]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TR: [, [, , "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", , , , , , , [7, 10, 12, 13]], [
        ,
        ,
        "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
        ,
        ,
        ,
        "2123456789",
        ,
        ,
        [10]
      ], [, , "56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", , , , "5012345678", , , [10]], [, , "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", , , , "8001234567", , , [10, 12, 13]], [, , "(?:8[89]8|900)\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , "592(?:21[12]|461)\\d{4}", , , , "5922121234", , , [10]], [, , "850\\d{7}", , , , "8500123456", , , [10]], "TR", 90, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"],
        "0$1",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{6,7})",
        "$1 $2 $3",
        ["80"],
        "0$1",
        ,
        1
      ]], [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "(?:444|811\\d{3})\\d{4}", , , , , , , [7, 10]], [, , "444\\d{4}", , , , "4441444", , , [7]], , , [, , , , , , , , , [-1]]],
      TT: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [, , "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}", , , , "8682911234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002345678"
      ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "([2-46-8]\\d{6})$|1", "868$1", , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]],
      TV: [, [
        ,
        ,
        "(?:2|7\\d\\d|90)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7]
      ], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:7[01]\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["90"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TW: [, [, , "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", , , , , , , [7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
        ,
        ,
        ,
        "221234567",
        ,
        ,
        [8, 9]
      ], [, , "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}|800\\d{5}", , , , "800123456", , , [8, 9]], [, , "20(?:[013-9]\\d\\d|2)\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", , , , "7012345678", , , [10, 11]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", , "0", , , , [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], [
        ,
        "(\\d)(\\d{3,4})(\\d{4})",
        "$1 $2 $3",
        ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],
        "0$1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]],
      TZ: [, [, , "(?:[25-8]\\d|41|90)\\d{7}", , , , , , , [9]], [, , "2[2-8]\\d{7}", , , , "222345678"], [, , "77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}", , , , "621234567"], [, , "80[08]\\d{6}", , , , "800123456"], [
        ,
        ,
        "90\\d{7}",
        ,
        ,
        ,
        "900123456"
      ], [, , "8(?:40|6[01])\\d{6}", , , , "840123456"], [, , , , , , , , , [-1]], [, , "41\\d{7}", , , , "412345678"], "TZ", 255, "00[056]", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["5"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UA: [, [, , "[89]\\d{9}|[3-9]\\d{8}", , , , , , , [9, 10], [5, 6, 7]], [
        ,
        ,
        "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
        ,
        ,
        ,
        "311234567",
        ,
        ,
        [9],
        [5, 6, 7]
      ], [, , "(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}", , , , "501234567", , , [9]], [, , "800[1-8]\\d{5,6}", , , , "800123456"], [, , "900[239]\\d{5,6}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567", , , [9]], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [
        ,
        "(\\d{4})(\\d{5})",
        "$1 $2",
        ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UG: [, [, , "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", , , , , , , [9], [5, 6, 7]], [
        ,
        ,
        "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
        ,
        ,
        ,
        "312345678",
        ,
        ,
        ,
        [5, 6, 7]
      ], [, , "726[01]\\d{5}|7(?:[01578]\\d|20|36|4[0-4]|6[0-5]|9[89])\\d{6}", , , , "712345678"], [, , "800[1-3]\\d{5}", , , , "800123456"], [, , "90[1-3]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      US: [, [
        ,
        ,
        "[2-9]\\d{9}|3\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [10],
        [7]
      ], [
        ,
        ,
        "5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9]|983[29])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
        ,
        ,
        ,
        "2015550123",
        ,
        ,
        ,
        [7]
      ], [
        ,
        ,
        "5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9]|983[29])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
        ,
        ,
        ,
        "2015550123",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "US", 1, "011", "1", , , "1", , , 1, [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [
        ,
        "(\\d{3})(\\d{4})",
        "$1-$2",
        ["[24-9]|3(?:[02-9]|1[1-9])"]
      ], [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], , , 1]], [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UY: [, [, , "0004\\d{2,9}|4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11, 12, 13]], [, , "(?:1(?:770|9(?:20|87))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [
        ,
        ,
        "0004\\d{2,9}|(?:4\\d{5}|80[05])\\d{4}|405\\d{4}",
        ,
        ,
        ,
        "8001234"
      ], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", , "0", , "00", , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], [, "(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UZ: [, [, , "200\\d{6}|(?:33|[5-79]\\d|88)\\d{7}", , , , , , , [9]], [
        ,
        ,
        "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}",
        ,
        ,
        ,
        "669050123"
      ], [
        ,
        ,
        "(?:(?:200[01]|(?:33|50|88|9[0-57-9])\\d\\d)\\d|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
        ,
        ,
        ,
        "912345678"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VA: [, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , "06698\\d{1,6}", , , , "0669812345", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [
        ,
        ,
        "80(?:0\\d{3}|3)\\d{3}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [6, 9]
      ], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "06698", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
      VC: [
        ,
        [, , "(?:[58]\\d\\d|784|900)\\d{7}", , , , , , , [10], [7]],
        [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]],
        [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}", , , , "7844301234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
        [, , "900[2-9]\\d{6}", , , , "9002345678"],
        [, , , , , , , , , [-1]],
        [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ],
        [, , "78451[0-2]\\d{4}", , , , "7845101234", , , , [7]],
        "VC",
        1,
        "011",
        "1",
        ,
        ,
        "([2-7]\\d{6})$|1",
        "784$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "784",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      VE: [
        ,
        [, , "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", , , , , , , [10], [7]],
        [, , "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}", , , , "2121234567", , , , [7]],
        [, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"],
        [, , "800\\d{7}", , , , "8001234567"],
        [, , "90[01]\\d{7}", , , , "9001234567"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "VE",
        58,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1", "$CC $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "501\\d{7}", , , , "5010123456", , , , [7]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      VG: [, [, , "(?:284|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}", , , , "2842291234", , , , [7]], [, , "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
        ,
        ,
        "900[2-9]\\d{6}",
        ,
        ,
        ,
        "9002345678"
      ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "([2-578]\\d{6})$|1", "284$1", , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VI: [, [, , "[58]\\d{9}|(?:34|90)0\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
        ,
        ,
        ,
        "3406421234",
        ,
        ,
        ,
        [7]
      ], [, , "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "([2-9]\\d{6})$|1", "340$1", , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VN: [, [, , "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", , , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", , , , "912345678", , , [9]], [
        ,
        ,
        "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
        ,
        ,
        ,
        "1800123456",
        ,
        ,
        [8, 9, 10]
      ], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "672\\d{6}", , , , "672012345", , , [9]], "VN", 84, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["2[48]"],
        "0$1",
        ,
        1
      ], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , , , , [7, 8]], [
        ,
        ,
        "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
        ,
        ,
        ,
        "1992000",
        ,
        ,
        [7, 8]
      ], , , [, , , , , , , , , [-1]]],
      VU: [
        ,
        [, , "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", , , , , , , [5, 7]],
        [, , "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", , , , "22123", , , [5]],
        [, , "(?:[58]\\d|7[013-7])\\d{5}", , , , "5912345", , , [7]],
        [, , "81[18]\\d\\d", , , , "81123", , , [5]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:0[1-9]|1[01])\\d{4}", , , , "9010123", , , [7]],
        "VU",
        678,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "(?:3[03]|900\\d)\\d{3}", , , , "30123"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      WF: [, [, , "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", , , , , , , [6, 9]], [, , "72\\d{4}", , , , "721234", , , [6]], [, , "(?:72|8[23])\\d{4}", , , , "821234", , , [6]], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234", , , [6]]],
      WS: [, [
        ,
        ,
        "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 10]
      ], [, , "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", , , , "22123", , , [5, 6]], [, , "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", , , , "7212345", , , [7, 10]], [, , "800\\d{3}", , , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(\\d{5})", "$1", ["[2-5]|6[1-9]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      XK: [, [, , "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", , , , , , , [
        8,
        9
      ]], [, , "(?:2[89]|39)0\\d{6}|[23][89]\\d{6}", , , , "28012345"], [, , "4[3-9]\\d{6}", , , , "43201234", , , [8]], [, , "800\\d{5}", , , , "80001234", , , [8]], [, , "900\\d{5}", , , , "90001234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "XK", 383, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      YE: [, [
        ,
        ,
        "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 8, 9],
        [6]
      ], [, , "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", , , , "1234567", , , [7, 8], [6]], [, , "7[01378]\\d{7}", , , , "712345678", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YE", 967, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      YT: [, [
        ,
        ,
        "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9]
      ], [, , "269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}", , , , "269601234"], [, , "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:39|47)8[01]|769\\d)\\d{4}", , , , "939801234"], "YT", 262, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ZA: [, [, , "[1-79]\\d{8}|8\\d{4,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [
        ,
        ,
        "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
        ,
        ,
        ,
        "101234567",
        ,
        ,
        [9]
      ], [, , "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", , , , "711234567", , , [5, 6, 7, 8, 9]], [, , "80\\d{7}", , , , "801234567", , , [9]], [, , "(?:86[2-9]|9[0-2]\\d)\\d{6}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [
        ,
        ,
        "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
        ,
        ,
        ,
        "871234567",
        ,
        ,
        [9]
      ], "ZA", 27, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6,7}", , , , "861123456", , , [9, 10]], , , [, , , , , , , , , [-1]]],
      ZM: [, [, , "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", , , , , , , [9], [6]], [
        ,
        ,
        "21[1-8]\\d{6}",
        ,
        ,
        ,
        "211234567",
        ,
        ,
        ,
        [6]
      ], [, , "(?:7[5-79]|9[5-8])\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "63\\d{7}", , , , "630123456"], "ZM", 260, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      ZW: [, [, , "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [
        ,
        ,
        "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
        ,
        ,
        ,
        "1312345",
        ,
        ,
        ,
        [3, 4]
      ], [, , "7(?:[178]\\d|3[1-9])\\d{6}", , , , "712345678", , , [9]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [
        [, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"],
        [, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
        [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"],
        [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"],
        [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
        [
          ,
          "(\\d{2})(\\d{3,5})",
          "$1 $2",
          ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
          "0$1"
        ],
        [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"],
        [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]
      ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      800: [
        ,
        [, , "(?:00|[1-9]\\d)\\d{6}", , , , , , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "(?:00|[1-9]\\d)\\d{6}", , , , "12345678"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "001",
        800,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        1,
        [[, "(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      808: [, [, , "[1-9]\\d{7}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1-9]\\d{7}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      870: [, [, , "7\\d{11}|[35-7]\\d{8}", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      878: [, [, , "10\\d{10}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      881: [, [, , "[0-36-9]\\d{8}", , , , , , , [9]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , "[0-36-9]\\d{8}", , , , "612345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 881, , , , , , , , , [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      882: [, [, , "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", , , , "3421234", , , [7, 8, 9, 10, 12]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["49"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["10|23|3(?:[15]|4[57])|4|51"]
      ], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]],
      883: [, [, , "(?:[1-4]\\d|51)\\d{6,10}", , , , , , , [8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
        ,
        ,
        ,
        "510012345"
      ], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      888: [, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]],
      979: [, [, , "[1359]\\d{8}", , , , , , , [9], [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1359]\\d{8}", , , , "123456789", , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]
    };
    function re() {
      this.g = {};
    }
    re.g = void 0, re.h = function() {
      return re.g ? re.g : re.g = new re();
    };
    var Ie = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "０": "0", "１": "1", "２": "2", "３": "3", "４": "4", "５": "5", "６": "6", "７": "7", "８": "8", "９": "9", "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4", "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9", "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4", "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9" }, Pe = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      "+": "+",
      "*": "*",
      "#": "#"
    }, at = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      "０": "0",
      "１": "1",
      "２": "2",
      "３": "3",
      "４": "4",
      "５": "5",
      "６": "6",
      "７": "7",
      "８": "8",
      "９": "9",
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9",
      "۰": "0",
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
      A: "2",
      B: "2",
      C: "2",
      D: "3",
      E: "3",
      F: "3",
      G: "4",
      H: "4",
      I: "4",
      J: "5",
      K: "5",
      L: "5",
      M: "6",
      N: "6",
      O: "6",
      P: "7",
      Q: "7",
      R: "7",
      S: "7",
      T: "8",
      U: "8",
      V: "8",
      W: "9",
      X: "9",
      Y: "9",
      Z: "9"
    }, Xe = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/, ft = RegExp("[+＋]+"), bt = RegExp("^[+＋]+"), le = RegExp("([0-9０-９٠-٩۰-۹])"), Y = RegExp("[+＋0-9０-９٠-٩۰-۹]"), ve = /[\\\/] *x/, xe = RegExp("[^0-9０-９٠-٩۰-۹A-Za-z#]+$"), Qe = /(?:.*?[A-Za-z]){3}.*/, Fe = RegExp("^\\+([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*[0-9０-９٠-٩۰-۹]([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*$"), He = RegExp("^([A-Za-z0-9０-９٠-٩۰-۹]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.)*[A-Za-z]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.?$");
    function Ge(y) {
      return "([0-9０-９٠-٩۰-۹]{1," + y + "})";
    }
    function Gt() {
      return ";ext=" + Ge("20") + "|[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*" + (Ge("20") + "#?|[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*") + (Ge("9") + "#?|[- ]+") + (Ge("6") + "#|[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*") + (Ge("15") + "#?|[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*") + (Ge("9") + "#?");
    }
    var Ze = new RegExp("(?:" + Gt() + ")$", "i"), Pr = new RegExp("^[0-9０-９٠-٩۰-۹]{2}$|^[+＋]*(?:[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*]*[0-9０-９٠-٩۰-۹]){3,}[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*A-Za-z0-9０-９٠-٩۰-۹]*(?:" + Gt() + ")?$", "i"), zs = /(\$\d)/, v0 = /^\(?\$1\)?$/;
    function Ct(y) {
      return 2 > y.length ? !1 : Vn(Pr, y);
    }
    function Vt(y) {
      return Vn(Qe, y) ? tn(y, at) : tn(y, Ie);
    }
    function Ut(y) {
      var _ = Vt(y.toString());
      G(y), y.g(_);
    }
    function Jr() {
      return Object.keys(ee).filter(function(y) {
        return isNaN(y);
      });
    }
    function zn() {
      return Object.keys(ee).filter(function(y) {
        return !isNaN(y);
      }).map(function(y) {
        return parseInt(y, 10);
      });
    }
    function en() {
      var y = Object.keys(pe);
      return [...zn(), ...y.map(function(_) {
        return parseInt(_, 10);
      })];
    }
    function tn(y, _) {
      for (var T = new z(), B, W = y.length, te = 0; te < W; ++te) B = y.charAt(te), B = _[B.toUpperCase()], B != null && T.g(B);
      return T.toString();
    }
    function di(y) {
      return y.length == 0 || v0.test(y);
    }
    function Hr(y) {
      return y != null && isNaN(y) && y.toUpperCase() in ee;
    }
    function rn(y, _, T) {
      if ($(_, 2) == 0 && v(_, 5)) {
        var B = w(_, 5);
        if (0 < B.length) return B;
      }
      B = w(_, 1);
      var W = Ai(_);
      return T == 0 ? y0(B, 0, W, "") : B in pe ? (y = Ti(y, B, Oi(B)), _ = Pp(_, y, T), W = Op(W, y, T), y0(B, T, W, _)) : W;
    }
    function Ti(y, _, T) {
      return T == "001" ? jn(y, "" + _) : jn(y, T);
    }
    function _y(y, _) {
      var T = Dr;
      if (!Hr(_)) return rn(T, y, 1);
      var B = w(y, 1), W = Ai(y);
      if (!(B in pe)) return W;
      if (B == 1) {
        if (_ != null && pe[1].includes(_.toUpperCase())) return B + " " + rn(T, y, 2);
      } else if (B == js(T, _)) return rn(T, y, 2);
      var te = jn(T, _), ge = w(te, 11);
      return _ = "", v(te, 17) ? _ = w(te, 17) : Vn(Xe, ge) && (_ = ge), T = Ti(T, B, Oi(B)), W = Op(W, T, 1), y = Pp(y, T, 1), 0 < _.length ? _ + " " + B + " " + W + y : y0(B, 1, W, y);
    }
    function Ai(y) {
      if (!v(y, 2)) return "";
      var _ = "" + $(y, 2);
      return v(y, 4) && $(y, 4) && 0 < w(y, 8) ? Array(w(y, 8) + 1).join("0") + _ : _;
    }
    function y0(y, _, T, B) {
      switch (_) {
        case 0:
          return "+" + y + T + B;
        case 1:
          return "+" + y + " " + T + B;
        case 3:
          return "tel:+" + y + "-" + T + B;
        default:
          return T + B;
      }
    }
    function Op(y, _, T) {
      e: {
        _ = k(_, 20).length == 0 || T == 2 ? k(_, 19) : k(_, 20);
        for (var B, W = _.length, te = 0; te < W; ++te) {
          B = _[te];
          var ge = C(B, 3);
          if ((ge == 0 || y.search($(B, 3, ge - 1)) == 0) && (ge = new RegExp($(B, 1)), Vn(ge, y))) {
            _ = B;
            break e;
          }
        }
        _ = null;
      }
      return _ == null || (W = _, _ = w(W, 2), B = new RegExp($(W, 1)), w(W, 5), W = w(W, 4), y = T == 2 && W != null && 0 < W.length ? y.replace(B, _.replace(zs, W)) : y.replace(B, _), T == 3 && (y = y.replace(RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+"), ""), y = y.replace(RegExp("[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+", "g"), "-"))), T = y, T;
    }
    function Ip(y, _) {
      var T = Dr;
      if (!Hr(y)) return null;
      _ = Dp(jn(T, y), _);
      try {
        if (v(_, 6)) {
          var B = $(_, 6);
          return w0(T, B, y);
        }
      } catch {
      }
      return null;
    }
    function Pp(y, _, T) {
      return v(y, 3) && $(y, 3).length != 0 ? T == 3 ? ";ext=" + $(y, 3) : v(_, 13) ? $(_, 13) + w(y, 3) : " ext. " + w(y, 3) : "";
    }
    function Dp(y, _) {
      switch (_) {
        case 4:
          return $(y, 5);
        case 3:
          return $(y, 4);
        case 1:
          return $(y, 3);
        case 0:
        case 2:
          return $(y, 2);
        case 5:
          return $(y, 6);
        case 6:
          return $(y, 8);
        case 7:
          return $(y, 7);
        case 8:
          return $(y, 21);
        case 9:
          return $(y, 25);
        case 10:
          return $(y, 28);
        default:
          return $(y, 1);
      }
    }
    function b0(y, _) {
      return nn(y, $(_, 1)) ? nn(y, $(_, 5)) ? 4 : nn(y, $(_, 4)) ? 3 : nn(y, $(_, 6)) ? 5 : nn(y, $(_, 8)) ? 6 : nn(y, $(_, 7)) ? 7 : nn(y, $(_, 21)) ? 8 : nn(y, $(_, 25)) ? 9 : nn(y, $(_, 28)) ? 10 : nn(y, $(_, 2)) ? $(_, 18) || nn(y, $(_, 3)) ? 2 : 0 : !$(_, 18) && nn(y, $(_, 3)) ? 1 : -1 : -1;
    }
    function jn(y, _) {
      if (_ == null) return null;
      _ = _.toUpperCase();
      var T = y.g[_];
      if (T == null) {
        if (T = ee[_], T == null) return null;
        T = new P().g(R.o(), T), y.g[_] = T;
      }
      return T;
    }
    function nn(y, _) {
      var T = y.length;
      return 0 < C(_, 9) && k(_, 9).indexOf(T) == -1 ? !1 : Vn(w(_, 2), y);
    }
    function Mp(y) {
      var _ = Dr, T = Ed(_, y), B = w(y, 1), W = Ti(_, B, T);
      return W == null || T != "001" && B != js(_, T) ? W = !1 : (y = Ai(y), W = b0(y, W) != -1), W;
    }
    function Ed(y, _) {
      if (_ == null) return null;
      var T = w(_, 1);
      if (T = pe[T], T == null) y = null;
      else if (T.length == 1) y = T[0];
      else e: {
        _ = Ai(_);
        for (var B, W = T.length, te = 0; te < W; te++) {
          B = T[te];
          var ge = jn(y, B);
          if (v(ge, 23)) {
            if (_.search($(ge, 23)) == 0) {
              y = B;
              break e;
            }
          } else if (b0(_, ge) != -1) {
            y = B;
            break e;
          }
        }
        y = null;
      }
      return y;
    }
    function Oi(y) {
      return y = pe[y], y == null ? "ZZ" : y[0];
    }
    function js(y, _) {
      if (y = jn(y, _), y == null) throw Error("Invalid region code: " + _);
      return w(y, 10);
    }
    function Np(y) {
      return y = Lp(y), y == 0 || y == 4;
    }
    function $0(y, _, T, B) {
      var W = Dp(T, B), te = C(W, 9) == 0 ? k($(T, 1), 9) : k(W, 9);
      return W = k(W, 10), te[0] == -1 ? 5 : (_ = _.length, -1 < W.indexOf(_) ? 4 : (T = te[0], T == _ ? 0 : T > _ ? 2 : te[te.length - 1] < _ ? 3 : -1 < te.indexOf(_, 1) ? 0 : 5));
    }
    function Lp(y) {
      var _ = Dr, T = Ai(y);
      return y = w(y, 1), y in pe ? (y = Ti(_, y, Oi(y)), $0(_, T, y, -1)) : 1;
    }
    function Fp(y, _) {
      if (y = y.toString(), y.length == 0 || y.charAt(0) == "0") return 0;
      for (var T, B = y.length, W = 1; 3 >= W && W <= B; ++W) if (T = parseInt(y.substring(0, W), 10), T in pe) return _.g(y.substring(W)), T;
      return 0;
    }
    function Rp(y, _, T, B, W) {
      if (_.length == 0) return 0;
      _ = new z(_);
      var te;
      T != null && (te = $(T, 11)), te == null && (te = "NonMatch");
      var ge = _.toString();
      if (ge.length == 0) te = 20;
      else if (bt.test(ge)) ge = ge.replace(bt, ""), G(_), _.g(Vt(ge)), te = 1;
      else {
        if (ge = new RegExp(te), Ut(_), te = _.toString(), te.search(ge) == 0) {
          ge = te.match(ge)[0].length;
          var Je = te.substring(ge).match(le);
          Je && Je[1] != null && 0 < Je[1].length && tn(Je[1], Ie) == "0" ? te = !1 : (G(_), _.g(te.substring(ge)), te = !0);
        } else te = !1;
        te = te ? 5 : 20;
      }
      if (te != 20) {
        if (2 >= _.h.length) throw Error("Phone number too short after IDD");
        if (y = Fp(
          _,
          B
        ), y != 0) return E(W, 1, y), y;
        throw Error("Invalid country calling code");
      }
      return T != null && (te = w(T, 10), ge = "" + te, Je = _.toString(), Je.lastIndexOf(ge, 0) == 0 && (ge = new z(Je.substring(ge.length)), Je = $(T, 1), Je = new RegExp(w(Je, 2)), zp(ge, T, null), ge = ge.toString(), !Vn(Je, _.toString()) && Vn(Je, ge) || $0(y, _.toString(), T, -1) == 3)) ? (B.g(ge), E(W, 1, te), te) : (E(W, 1, 0), 0);
    }
    function zp(y, _, T) {
      var B = y.toString(), W = B.length, te = $(_, 15);
      if (W != 0 && te != null && te.length != 0) {
        var ge = new RegExp("^(?:" + te + ")");
        if (W = ge.exec(B)) {
          te = new RegExp(w($(_, 1), 2));
          var Je = Vn(te, B), or = W.length - 1;
          _ = $(_, 16), _ == null || _.length == 0 || W[or] == null || W[or].length == 0 ? (!Je || Vn(te, B.substring(W[0].length))) && (T != null && 0 < or && W[or] != null && T.g(W[1]), y.set(B.substring(W[0].length))) : (B = B.replace(ge, _), (!Je || Vn(te, B)) && (T != null && 0 < or && T.g(W[1]), y.set(B)));
        }
      }
    }
    function w0(y, _, T) {
      if (_ == null) throw Error("The string supplied did not seem to be a phone number");
      if (250 < _.length) throw Error("The string supplied is too long to be a phone number");
      var B = new z(), W = _.indexOf(";phone-context=");
      if (W === -1) W = null;
      else if (W += 15, W >= _.length) W = "";
      else {
        var te = _.indexOf(";", W);
        W = te !== -1 ? _.substring(W, te) : _.substring(W);
      }
      var ge = W;
      if (ge == null ? te = !0 : ge.length === 0 ? te = !1 : (te = Fe.exec(ge), ge = He.exec(ge), te = te !== null || ge !== null), !te || (W != null ? (W.charAt(0) === "+" && B.g(W), W = _.indexOf("tel:"), B.g(_.substring(0 <= W ? W + 4 : 0, _.indexOf(";phone-context=")))) : (W = B.g, _ = _ ?? "", te = _.search(Y), 0 <= te ? (_ = _.substring(te), _ = _.replace(xe, ""), te = _.search(ve), 0 <= te && (_ = _.substring(0, te))) : _ = "", W.call(B, _)), _ = B.toString(), W = _.indexOf(";isub="), 0 < W && (G(B), B.g(_.substring(0, W))), !Ct(B.toString()))) throw Error("The string supplied did not seem to be a phone number");
      if (_ = B.toString(), !(Hr(T) || _ != null && 0 < _.length && bt.test(_))) throw Error("Invalid country calling code");
      _ = new Z();
      e: {
        if (W = B.toString(), te = W.search(Ze), 0 <= te && Ct(W.substring(0, te))) {
          ge = W.match(Ze);
          for (var Je = ge.length, or = 1; or < Je; ++or) if (ge[or] != null && 0 < ge[or].length) {
            G(B), B.g(W.substring(0, te)), W = ge[or];
            break e;
          }
        }
        W = "";
      }
      0 < W.length && E(_, 3, W), te = jn(y, T), W = new z(), ge = 0, Je = B.toString();
      try {
        ge = Rp(y, Je, te, W, _);
      } catch (co) {
        if (co.message == "Invalid country calling code" && bt.test(Je)) {
          if (Je = Je.replace(bt, ""), ge = Rp(y, Je, te, W, _), ge == 0) throw co;
        } else throw co;
      }
      if (ge != 0 ? (B = Oi(ge), B != T && (te = Ti(y, ge, B))) : (Ut(B), W.g(B.toString()), T != null && (ge = w(te, 10), E(_, 1, ge))), 2 > W.h.length || (te != null && (T = new z(W.toString()), zp(T, te, new z()), y = $0(y, T.toString(), te, -1), y != 2 && y != 4 && y != 5 && (W = T)), y = W.toString(), T = y.length, 2 > T)) throw Error("The string supplied is too short to be a phone number");
      if (17 < T) throw Error("The string supplied is too long to be a phone number");
      if (1 < y.length && y.charAt(0) == "0") {
        for (E(_, 4, !0), T = 1; T < y.length - 1 && y.charAt(T) == "0"; ) T++;
        T != 1 && E(_, 8, T);
      }
      return E(_, 2, parseInt(y, 10)), _;
    }
    re.prototype.ja = function(y) {
      var _ = jn(this, Ed(this, y));
      return _ == null ? !0 : (y = Ai(y), !nn(y, $(_, 24)));
    };
    function Vn(y, _) {
      return !!((y = typeof y == "string" ? _.match("^(?:" + y + ")$") : _.match(y)) && y[0].length == _.length);
    }
    function Cy(y) {
      this.ka = RegExp(" "), this.la = "", this.$ = new z(), this.da = "", this.u = new z(), this.ba = new z(), this.v = !0, this.ea = this.ca = this.oa = !1, this.pa = re.h(), this.aa = 0, this.h = new z(), this.ha = !1, this.s = "", this.g = new z(), this.j = [], this.ma = y, this.wa = this.m = x0(this, this.ma);
    }
    var jp = new R();
    E(jp, 11, "NA");
    var Sy = RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*\\$1[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*(\\$\\d[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*)*$"), Vp = /[- ]/;
    function x0(y, _) {
      return _ = Hr(_) ? js(y.pa, _) : 0, y = jn(y.pa, Oi(_)), y ?? jp;
    }
    function Up(y) {
      for (var _ = y.j.length, T = 0; T < _; ++T) {
        var B = y.j[T], W = w(B, 1);
        if (y.da == W) return !1;
        var te = y, ge = B, Je = w(ge, 1);
        G(te.$);
        var or = te;
        ge = w(ge, 2);
        var co = "999999999999999".match(Je)[0];
        if (co.length < or.g.h.length ? or = "" : (or = co.replace(new RegExp(Je, "g"), ge), or = or.replace(RegExp("9", "g"), " ")), 0 < or.length ? (te.$.g(or), te = !0) : te = !1, te) return y.da = W, y.ha = Vp.test($(B, 4)), y.aa = 0, !0;
      }
      return y.v = !1;
    }
    function qp(y, _) {
      for (var T = [], B = _.length - 3, W = y.j.length, te = 0; te < W; ++te) {
        var ge = y.j[te];
        C(ge, 3) == 0 ? T.push(y.j[te]) : (ge = $(ge, 3, Math.min(B, C(ge, 3) - 1)), _.search(ge) == 0 && T.push(y.j[te]));
      }
      y.j = T;
    }
    function Ey(y, _) {
      y.u.g(_);
      var T = _;
      if (le.test(T) || y.u.h.length == 1 && ft.test(T) ? (_ == "+" ? (T = _, y.ba.g(_)) : (T = Ie[_], y.ba.g(T), y.g.g(T)), _ = T) : (y.v = !1, y.oa = !0), !y.v) {
        if (!y.oa) {
          if (Gp(y)) {
            if (Yp(y)) return Bp(y);
          } else if (0 < y.s.length && (_ = y.g.toString(), G(y.g), y.g.g(y.s), y.g.g(_), _ = y.h.toString(), T = _.lastIndexOf(y.s), G(y.h), y.h.g(_.substring(0, T))), y.s != Qp(y)) return y.h.g(" "), Bp(y);
        }
        return y.u.toString();
      }
      switch (y.ba.h.length) {
        case 0:
        case 1:
        case 2:
          return y.u.toString();
        case 3:
          if (Gp(y)) y.ea = !0;
          else return y.s = Qp(y), k0(y);
        default:
          return y.ea ? (Yp(y) && (y.ea = !1), y.h.toString() + y.g.toString()) : 0 < y.j.length ? (_ = Kp(y, _), T = Hp(y), 0 < T.length ? T : (qp(y, y.g.toString()), Up(y) ? Wp(y) : y.v ? Td(y, _) : y.u.toString())) : k0(y);
      }
    }
    function Bp(y) {
      return y.v = !0, y.ea = !1, y.j = [], y.aa = 0, G(y.$), y.da = "", k0(y);
    }
    function Hp(y) {
      for (var _ = y.g.toString(), T = y.j.length, B = 0; B < T; ++B) {
        var W = y.j[B], te = w(W, 1);
        if (new RegExp("^(?:" + te + ")$").test(_) && (y.ha = Vp.test($(W, 4)), W = _.replace(new RegExp(te, "g"), $(W, 2)), W = Td(y, W), tn(W, Pe) == y.ba)) return W;
      }
      return "";
    }
    function Td(y, _) {
      var T = y.h.h.length;
      return y.ha && 0 < T && y.h.toString().charAt(T - 1) != " " ? y.h + " " + _ : y.h + _;
    }
    function k0(y) {
      var _ = y.g.toString();
      if (3 <= _.length) {
        for (var T = y.ca && y.s.length == 0 && 0 < C(y.m, 20) ? k(y.m, 20) : k(y.m, 19), B = T.length, W = 0; W < B; ++W) {
          var te = T[W];
          0 < y.s.length && di(w(te, 4)) && !$(te, 6) && !v(te, 5) || (y.s.length != 0 || y.ca || di(w(te, 4)) || $(te, 6)) && Sy.test(w(te, 2)) && y.j.push(te);
        }
        return qp(y, _), _ = Hp(y), 0 < _.length ? _ : Up(y) ? Wp(y) : y.u.toString();
      }
      return Td(y, _);
    }
    function Wp(y) {
      var _ = y.g.toString(), T = _.length;
      if (0 < T) {
        for (var B = "", W = 0; W < T; W++) B = Kp(y, _.charAt(W));
        return y.v ? Td(y, B) : y.u.toString();
      }
      return y.h.toString();
    }
    function Qp(y) {
      var _ = y.g.toString(), T = 0;
      if (y.m.ia() != 1) var B = !1;
      else B = y.g.toString(), B = B.charAt(0) == "1" && B.charAt(1) != "0" && B.charAt(1) != "1";
      return B ? (T = 1, y.h.g("1").g(" "), y.ca = !0) : v(y.m, 15) && (B = new RegExp("^(?:" + $(y.m, 15) + ")"), B = _.match(B), B != null && B[0] != null && 0 < B[0].length && (y.ca = !0, T = B[0].length, y.h.g(_.substring(0, T)))), G(y.g), y.g.g(_.substring(T)), _.substring(0, T);
    }
    function Gp(y) {
      var _ = y.ba.toString(), T = new RegExp("^(?:\\+|" + $(y.m, 11) + ")");
      return T = _.match(T), T != null && T[0] != null && 0 < T[0].length ? (y.ca = !0, T = T[0].length, G(y.g), y.g.g(_.substring(T)), G(y.h), y.h.g(_.substring(0, T)), _.charAt(0) != "+" && y.h.g(" "), !0) : !1;
    }
    function Yp(y) {
      if (y.g.h.length == 0) return !1;
      var _ = new z(), T = Fp(y.g, _);
      return T == 0 ? !1 : (G(y.g), y.g.g(_.toString()), _ = Oi(T), _ == "001" ? y.m = jn(y.pa, "" + T) : _ != y.ma && (y.m = x0(y, _)), y.h.g("" + T).g(" "), y.s = "", !0);
    }
    function Kp(y, _) {
      var T = y.$.toString();
      if (0 <= T.substring(y.aa).search(y.ka)) {
        var B = T.search(y.ka);
        return _ = T.replace(y.ka, _), G(y.$), y.$.g(_), y.aa = B, _.substring(0, y.aa + 1);
      }
      return y.j.length == 1 && (y.v = !1), y.da = "", y.u.toString();
    }
    var Dr = re.h();
    function Ty(y) {
      var _ = Dr, T = Ed(_, y);
      switch (_ = Ti(_, w(y, 1), T), _ == null ? y = -1 : (y = Ai(y), y = b0(y, _)), y) {
        case 0:
          return "fixed-line";
        case 2:
          return "fixed-line-or-mobile";
        case 1:
          return "mobile";
        case 8:
          return "pager";
        case 7:
          return "personal-number";
        case 4:
          return "premium-rate";
        case 5:
          return "shared-cost";
        case 3:
          return "toll-free";
        case 9:
          return "uan";
        case 6:
          return "voip";
        default:
        case -1:
          return "unknown";
      }
    }
    function Ay(y) {
      switch (y) {
        case "fixed-line":
          return 0;
        case "fixed-line-or-mobile":
          return 2;
        case "mobile":
          return 1;
        case "pager":
          return 8;
        case "personal-number":
          return 7;
        case "premium-rate":
          return 4;
        case "shared-cost":
          return 5;
        case "toll-free":
          return 3;
        case "uan":
          return 9;
        case "voip":
          return 6;
        default:
        case "unknown":
          return -1;
      }
    }
    function Zp(y) {
      try {
        switch (Lp(y)) {
          case 0:
            return "is-possible";
          case 1:
            return "invalid-country-code";
          case 3:
            return "too-long";
          case 2:
            return "too-short";
        }
        if (Np(y)) return "is-possible";
      } catch {
      }
      return "unknown";
    }
    function Oy(y, _) {
      if (y.charAt(0) !== "+" && y.slice(0, 2) !== "00") return { parsed: T, fa: B };
      try {
        var T = w0(Dr, y, _);
      } catch {
      }
      if (T) {
        var B = Ed(Dr, T);
        if (B != null && B !== "ZZ") return { parsed: T, fa: B };
      }
      for (_ = 1; 4 > _; ++_) {
        if (B = void 0, y.length < _ + 1) return { parsed: T, fa: B };
        if (B = Oi(y.substring(1, _ + 1)), B !== "ZZ") return { fa: B };
      }
      return { parsed: T, fa: void 0 };
    }
    var _0;
    e: {
      try {
        _0 = /* @__PURE__ */ new WeakMap();
        break e;
      } catch {
      }
      _0 = void 0;
    }
    var Ad = _0;
    function je(y, _) {
      if (!(this instanceof je)) return new je(y, _);
      var T = _?.regionCode;
      if (typeof y == "string") var B = !1;
      else try {
        Mp(y), B = !0;
      } catch {
        B = !1;
      }
      let W;
      if (!B && typeof y != "string") throw Error("Invalid phone number, expected a string");
      if (!B && typeof _ != "object" && typeof _ < "u") throw Error(`Invalid options, expected object, got ${typeof _}. This may be because of not yet upgraded code.`);
      if (!B && T != null && typeof T != "string") throw Error(`Invalid region code, expected a string, got ${typeof T} ${T}`);
      if (B || (y = y.trim(), T && y.charAt(0) === "+" && (T = null), T && y.charAt(0) !== "+" && y.slice(0, 2) !== "00" || ({ fa: T = null, parsed: W } = Oy(y, T))), this.g = { number: {}, regionCode: T, valid: !1, possible: !1 }, Ad && Ad.set(this.g, this), B) this.l = y;
      else {
        if (this.l = null, this.g.number.input = y, !T) {
          this.g.possibility = "invalid-country-code";
          return;
        }
        if (C0(T) === 0) {
          this.g.possibility = "invalid-country-code";
          return;
        }
        try {
          this.l = W || w0(Dr, y, T);
        } catch {
          this.g.possibility = Zp(y);
          return;
        }
      }
      this.g.number.international = rn(Dr, this.l, 1), this.g.number.national = rn(Dr, this.l, 2), this.g.number.e164 = rn(Dr, this.l, 0), this.g.number.rfc3966 = rn(Dr, this.l, 3), this.g.number.significant = Ai(this.l), this.g.canBeInternationallyDialled = Dr.ja(this.l), this.g.valid = Mp(this.l), this.g.possible = Np(this.l), this.g.possibility = Zp(this.l), !this.g.valid && this.g.possible && (this.g.possibility = "invalid", this.g.possible = !1), this.g.type = Ty(this.l), this.g.typeIsMobile = this.sa(), this.g.typeIsFixedLine = this.ra(), this.g.countryCode = Hr(T) ? js(Dr, T) : 0;
    }
    var Vs = ["PhoneNumber$$module$src$index"], Un = t;
    Vs[0] in Un || typeof Un.execScript > "u" || Un.execScript("var " + Vs[0]);
    for (var fa; Vs.length && (fa = Vs.shift()); ) Vs.length || je === void 0 ? Un[fa] && Un[fa] !== Object.prototype[fa] ? Un = Un[fa] : Un = Un[fa] = {} : Un[fa] = je;
    function C0(y) {
      return Hr(y) ? js(Dr, y) : 0;
    }
    je.getCountryCodeForRegionCode = C0, je.getRegionCodeForCountryCode = function(y) {
      return Oi(y);
    };
    function Xp(y) {
      var _ = {};
      return y.filter((T) => _.hasOwnProperty(T) ? !1 : (_[T] = 1, !0));
    }
    je.getSupportedRegionCodes = function() {
      return Xp(Jr());
    }, je.getSupportedCallingCodes = function() {
      return Xp(en());
    }, je.getExample = function(y, _) {
      var T;
      return _ ? T = Ip(y, Ay(_)) : T = Ip(y, 0), new je(T, y).toJSON();
    }, je.getAsYouType = function(y) {
      return new Cr(y);
    }, je.getNumberFrom = function(y, _) {
      try {
        e: {
          if (Ad) {
            var T = Ad.get(y);
            if (T) {
              var B = T;
              break e;
            }
          }
          let W;
          B = new je(y == null || (W = y.number) == null ? void 0 : W.e164, {});
        }
        return { valid: !0, number: _y(B.l, _) };
      } catch (W) {
        return { valid: !1, error: W };
      }
    }, je.prototype.toJSON = function() {
      return this.g;
    }, je.prototype.toJSON = je.prototype.toJSON, je.prototype.ja = function() {
      return this.g.canBeInternationallyDialled;
    }, je.prototype.canBeInternationallyDialled = je.prototype.ja, je.prototype.ya = function() {
      return this.g.valid;
    }, je.prototype.isValid = je.prototype.ya, je.prototype.xa = function() {
      return this.g.possible;
    }, je.prototype.isPossible = je.prototype.xa, je.prototype.getType = function() {
      return this.g.type;
    }, je.prototype.getType = je.prototype.getType, je.prototype.sa = function() {
      return this.g.type === "mobile" || this.g.type === "fixed-line-or-mobile";
    }, je.prototype.isMobile = je.prototype.sa, je.prototype.ra = function() {
      return this.g.type === "fixed-line" || this.g.type === "fixed-line-or-mobile";
    }, je.prototype.isFixedLine = je.prototype.ra, je.prototype.ta = function(y) {
      return this.g.number[y ?? "e164"];
    }, je.prototype.getNumber = je.prototype.ta, je.prototype.va = function() {
      return this.g.regionCode;
    }, je.prototype.getRegionCode = je.prototype.va, je.prototype.ia = function() {
      return C0(this.g.regionCode);
    }, je.prototype.getCountryCode = je.prototype.ia;
    function Cr(y) {
      this.j = y, this.h = new Cy(y), this.l = this.g = "";
    }
    Cr.prototype.qa = function(y) {
      this.g += y;
      var _ = this.h;
      return _.la = Ey(_, y), this.l = _.la;
    }, Cr.prototype.addChar = Cr.prototype.qa, Cr.prototype.za = function() {
      return this.l;
    }, Cr.prototype.number = Cr.prototype.za, Cr.prototype.Aa = function() {
      return this.g === "" ? this.l : this.reset(this.g.slice(0, this.g.length - 1));
    }, Cr.prototype.removeChar = Cr.prototype.Aa, Cr.prototype.reset = function(y) {
      var _ = this.h;
      if (_.la = "", G(_.u), G(_.ba), G(_.$), _.aa = 0, _.da = "", G(_.h), _.s = "", G(_.g), _.v = !0, _.oa = !1, _.ca = !1, _.ea = !1, _.j = [], _.ha = !1, _.m != _.wa && (_.m = x0(_, _.ma)), this.l = this.g = "", y) {
        _ = 0;
        for (var T = y.length; _ < T; ++_) this.qa(y.charAt(_));
      }
      return this.l;
    }, Cr.prototype.reset = Cr.prototype.reset, Cr.prototype.ua = function() {
      return new je(this.l, { regionCode: this.j }).toJSON();
    }, Cr.prototype.getPhoneNumber = Cr.prototype.ua;
  }).call(
    e.exports || typeof globalThis < "u" && globalThis || typeof Jo < "u" && Jo || typeof window < "u" && window || typeof self < "u" && self || Jo
  );
})(T6);
var eH = T6.exports;
Gf.exports;
(function(e) {
  const t = "PhoneNumber$$module$src$index";
  e.exports = eH[t] || (typeof globalThis < "u" && globalThis || typeof Jo < "u" && Jo || typeof window < "u" && window || typeof self < "u" && self || Jo)[t], Object.defineProperty(
    e.exports,
    "__esModule",
    {
      value: !0
    }
  ), e.exports.parsePhoneNumber = (...r) => {
    try {
      const n = e.exports(...r).toJSON();
      return !n.valid && !n.possible && (n.possible = !1, n.possibility || (n.possibility = "invalid")), n;
    } catch (n) {
      return {
        valid: !1,
        possible: !1,
        possibility: "invalid",
        error: n
      };
    }
  }, e.exports.getCountryCodeForRegionCode = e.exports.getCountryCodeForRegionCode, e.exports.getRegionCodeForCountryCode = e.exports.getRegionCodeForCountryCode, e.exports.getSupportedCallingCodes = e.exports.getSupportedCallingCodes, e.exports.getSupportedRegionCodes = e.exports.getSupportedRegionCodes, e.exports.getExample = e.exports.getExample, e.exports.getAsYouType = e.exports.getAsYouType, e.exports.getNumberFrom = e.exports.getNumberFrom;
})(Gf);
var tH = Gf.exports, A6 = /* @__PURE__ */ JB(tH);
const {
  PhoneNumber: Uae,
  AsYouType: qae,
  getCountryCodeForRegionCode: Bae,
  getRegionCodeForCountryCode: Hae,
  getSupportedCallingCodes: Wae,
  getSupportedRegionCodes: Qae,
  getExample: Gae,
  getAsYouType: Yae,
  getNumberFrom: Kae
} = A6, rH = (...e) => {
  try {
    const t = A6(...e).toJSON();
    return !t.valid && !t.possible && (t.possible = !1, t.possibility || (t.possibility = "invalid")), t;
  } catch (t) {
    return {
      valid: !1,
      possible: !1,
      possibility: "invalid",
      error: t
    };
  }
};
var nH = /* @__PURE__ */ x('<tr><td class="align-top py-1 w-20"></td><td class="align-top py-1">'), iH = /* @__PURE__ */ x('<div class="flex items-center justify-between">'), g1 = /* @__PURE__ */ x("<div>"), aH = /* @__PURE__ */ x('<div class=pt-4 data-dd-privacy=mask><div class="pt-4 sm:grid sm:grid-cols-2 sm:gap-2"><table class=table-auto><tbody></tbody></table><table class=table-auto><tbody>'), oH = /* @__PURE__ */ x("<div>N/A");
const sH = Le`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      id
      name {
        full
      }
      email
      phone
      sex
      gender
      dateOfBirth
      address {
        street1
        street2
        city
        state
        postalCode
      }
    }
  }
`, ga = (e) => (() => {
  var t = nH(), r = t.firstChild, n = r.nextSibling;
  return S(r, b(ke, {
    size: "sm",
    color: "gray",
    get children() {
      return e.label;
    }
  })), S(n, () => e.children), t;
})(), lH = (e) => {
  const [t, r, n] = e.split("-");
  return `${r}-${n}-${t}`;
};
function dH(e) {
  const t = Ln(), [r, n] = H(void 0), i = async () => {
    const {
      data: s
    } = await t.apollo.query({
      query: sH,
      variables: {
        id: e.patientId
      }
    });
    s?.patient && n(s?.patient);
  };
  me(() => {
    e.patientId && i();
  });
  const a = L(() => e.address || r()?.address), o = L(() => {
    if (r()?.phone) {
      const s = rH(r()?.phone);
      return s.valid ? s.number.national : r()?.phone;
    }
    return "";
  });
  return b(hn, {
    addChildrenDivider: !0,
    get children() {
      return [(() => {
        var s = iH();
        return S(s, b(ke, {
          color: "gray",
          children: "Patient Info"
        }), null), S(s, b(X, {
          get when() {
            return e?.editPatient;
          },
          get children() {
            return b(st, {
              variant: "secondary",
              size: "sm",
              get onClick() {
                return e?.editPatient;
              },
              children: "Edit patient"
            });
          }
        }), null), s;
      })(), (() => {
        var s = aH(), l = s.firstChild, d = l.firstChild, u = d.firstChild, c = d.nextSibling, h = c.firstChild;
        return S(s, b(ke, {
          size: "lg",
          bold: !0,
          get loading() {
            return !r();
          },
          sampleLoadingText: "Sally Patient",
          get children() {
            return r()?.name.full || "N/A";
          }
        }), l), S(u, b(ga, {
          label: "Email",
          get children() {
            return b(ke, {
              size: "sm",
              get loading() {
                return !r();
              },
              sampleLoadingText: "fake@email.com",
              get children() {
                return r()?.email || "N/A";
              }
            });
          }
        }), null), S(u, b(ga, {
          label: "Phone",
          get children() {
            return b(ke, {
              size: "sm",
              get loading() {
                return !r();
              },
              sampleLoadingText: "555-555-5555",
              get children() {
                return o() || "N/A";
              }
            });
          }
        }), null), S(u, b(ga, {
          label: "Address",
          get children() {
            return b(X, {
              get when() {
                return !r() || a();
              },
              get fallback() {
                return oH();
              },
              get children() {
                return [(() => {
                  var f = g1();
                  return S(f, b(ke, {
                    size: "sm",
                    get loading() {
                      return !r();
                    },
                    sampleLoadingText: "123 Fake St",
                    get children() {
                      return a()?.street1;
                    }
                  })), f;
                })(), b(X, {
                  get when() {
                    return !r() || a()?.street2;
                  },
                  get children() {
                    var f = g1();
                    return S(f, b(ke, {
                      size: "sm",
                      get loading() {
                        return !r();
                      },
                      sampleLoadingText: "Apt 3",
                      get children() {
                        return a()?.street2;
                      }
                    })), f;
                  }
                }), (() => {
                  var f = g1();
                  return S(f, b(ke, {
                    size: "sm",
                    get loading() {
                      return !r();
                    },
                    sampleLoadingText: "Brooklyn, NY 11221",
                    get children() {
                      return [L(() => a()?.city), ", ", L(() => a()?.state), " ", L(() => a()?.postalCode)];
                    }
                  })), f;
                })()];
              }
            });
          }
        }), null), S(h, b(ga, {
          label: "DOB",
          get children() {
            return b(ke, {
              size: "sm",
              get loading() {
                return !r();
              },
              sampleLoadingText: "female",
              get children() {
                return lH(r()?.dateOfBirth || "N/A");
              }
            });
          }
        }), null), S(h, b(ga, {
          label: "Weight",
          get children() {
            return b(ke, {
              size: "sm",
              get loading() {
                return !r();
              },
              sampleLoadingText: "150 lbs",
              get children() {
                return e?.weight ? `${e.weight} ${e.weightUnit}` : "N/A";
              }
            });
          }
        }), null), S(h, b(ga, {
          label: "Sex",
          get children() {
            return b(ke, {
              size: "sm",
              get loading() {
                return !r();
              },
              sampleLoadingText: "female",
              get children() {
                return r()?.sex || "N/A";
              }
            });
          }
        }), null), S(h, b(ga, {
          label: "Gender",
          get children() {
            return b(ke, {
              size: "sm",
              get loading() {
                return !r();
              },
              sampleLoadingText: "female",
              get children() {
                return r()?.gender || "N/A";
              }
            });
          }
        }), null), s;
      })()];
    }
  });
}
var uH = /* @__PURE__ */ x('<div class="group relative w-max"><span class="pointer-events-none absolute -bottom-8 left-0 w-max rounded bg-gray-900 px-2 py-1 text-sm font-medium text-gray-50 opacity-0 shadow transition-opacity group-hover:opacity-100">');
function O6(e) {
  return (() => {
    var t = uH(), r = t.firstChild;
    return S(t, () => e.children, r), S(r, () => e.text), t;
  })();
}
var cH = /* @__PURE__ */ x('<button class="text-gray-700 hover:text-gray-900 hover:bg-blue-50 rounded-md p-2 disabled:opacity-50 disabled:hover:bg-transparent disabled:hover:text-gray-700 disabled:cursor-not-allowed"type=button>');
const hH = (e) => {
  const t = Be({
    size: "md"
  }, e), r = (() => {
    var n = cH();
    return n.$$click = () => {
      e.loading || e.onClick();
    }, S(n, b(X, {
      get when() {
        return !e.loading;
      },
      get children() {
        return b(rt, {
          get name() {
            return e.iconName;
          },
          get size() {
            return t.iconSize;
          }
        });
      }
    }), null), S(n, b(X, {
      get when() {
        return e.loading;
      },
      get children() {
        return b(ni, {
          get size() {
            return t.iconSize;
          }
        });
      }
    }), null), J((i) => {
      var a = e.label, o = e.disabled;
      return a !== i.e && pt(n, "aria-label", i.e = a), o !== i.t && (n.disabled = i.t = o), i;
    }, {
      e: void 0,
      t: void 0
    }), n;
  })();
  return L(() => L(() => !!e.disabled)() ? r : b(O6, {
    get text() {
      return e.label;
    },
    children: r
  }));
};
cn(["click"]);
var fH = /* @__PURE__ */ x('<div class="px-4 sm:px-6 py-3.5">Actions'), pH = /* @__PURE__ */ x('<div class="px-4 sm:px-6 py-4 col-span-3 text-center">'), mH = /* @__PURE__ */ x('<div class="grid w-full text-xs relative"><div><div class="px-4 sm:px-6 py-3.5">Medication</div><div class="px-4 sm:px-6 py-3.5 cursor-pointer flex">Written<div class=ml-1>'), gH = /* @__PURE__ */ x('<div class="px-4 sm:px-6 py-4 truncate"><div class="flex-col flex-1 min-w-0 whitespace-normal"><div class="text-gray-500 text-ellipsis overflow-hidden">'), vH = /* @__PURE__ */ x('<div class="px-4 sm:px-6 py-4 self-center">'), yH = /* @__PURE__ */ x('<div class="px-4 sm:px-6 py-4 m-auto">'), v1 = /* @__PURE__ */ x('<div class="px-4 sm:px-6 py-4 select-none">'), bH = /* @__PURE__ */ x('<div class="text-ellipsis overflow-hidden">'), $H = /* @__PURE__ */ x('<a class="text-ellipsis block overflow-hidden text-blue-500 underline"target=_blank>');
function wH(e) {
  const t = rB(), [r, n] = H(void 0), i = L(() => e.enableRefillButton), a = L(() => Zt("grid grid-cols-subgrid border-b text-xs font-semibold text-gray-900 sticky top-0 bg-white z-10", {
    "col-span-3": i(),
    "col-span-2": !i()
  })), o = async (s, l) => {
    if (r() === void 0) {
      if (n(s.id), !t)
        throw new Error("Refill requires <PrescribeProvider>");
      try {
        await t.tryCreatePrescription({
          ...s,
          treatment: l,
          effectiveDate: If(/* @__PURE__ */ new Date(), "yyyy-MM-dd").toString(),
          diagnoseCodes: s.diagnoses?.map((d) => d.code) || []
        });
      } finally {
        n(void 0);
      }
    }
  };
  return (() => {
    var s = mH(), l = s.firstChild, d = l.firstChild, u = d.nextSibling, c = u.firstChild, h = c.nextSibling;
    return u.$$click = () => e.onSortOrderToggle(), S(h, b(X, {
      get when() {
        return e.sortOrder === "desc";
      },
      get children() {
        return b(rt, {
          name: "chevronDown",
          size: "sm"
        });
      }
    }), null), S(h, b(X, {
      get when() {
        return e.sortOrder === "asc";
      },
      get children() {
        return b(rt, {
          name: "chevronUp",
          size: "sm"
        });
      }
    }), null), S(l, b(X, {
      get when() {
        return e.enableRefillButton;
      },
      get children() {
        return fH();
      }
    }), null), S(s, b(X, {
      get when() {
        return !e.isLoading && e.rowItems;
      },
      get fallback() {
        return [b(y1, {
          get enableRefill() {
            return e.enableRefillButton;
          }
        }), b(y1, {
          get enableRefill() {
            return e.enableRefillButton;
          }
        }), b(y1, {
          get enableRefill() {
            return e.enableRefillButton;
          }
        })];
      },
      get children() {
        return b(kt, {
          get each() {
            return e.rowItems;
          },
          children: (f) => [(() => {
            var p = gH(), g = p.firstChild, v = g.firstChild;
            return S(g, b(kH, {
              get treatmentName() {
                return f.treatment.name;
              },
              get prescriptionId() {
                return f.prescription?.id;
              },
              get enableLinks() {
                return e.enableLinks;
              },
              get linkBaseUrl() {
                return e.baseURL;
              }
            }), v), S(v, () => aQ(f.prescription)), p;
          })(), (() => {
            var p = vH();
            return S(p, () => xH(f)), p;
          })(), b(X, {
            get when() {
              return e.enableRefillButton;
            },
            get children() {
              var p = yH();
              return S(p, b(hH, {
                iconName: "documentPlus",
                iconSize: "sm",
                label: "Refill",
                onClick: () => {
                  f.prescription && o(f.prescription, f.treatment);
                },
                get disabled() {
                  return !f.prescription;
                },
                get loading() {
                  return L(() => !!f.prescription)() && r() === f.prescription.id;
                }
              })), p;
            }
          })]
        });
      }
    }), null), S(s, b(X, {
      get when() {
        return !e.isLoading && e.rowItems && e.rowItems.length === 0;
      },
      get children() {
        var f = pH();
        return S(f, b(ke, {
          color: "gray",
          children: "No medication history found."
        })), f;
      }
    }), null), J((f) => {
      var p = `1fr min-content ${i() ? "min-content" : ""}`, g = a();
      return p !== f.e && ((f.e = p) != null ? s.style.setProperty("grid-template-columns", p) : s.style.removeProperty("grid-template-columns")), g !== f.t && ot(l, f.t = g), f;
    }, {
      e: void 0,
      t: void 0
    }), s;
  })();
}
const y1 = (e) => [(() => {
  var t = v1();
  return S(t, b(ke, {
    get sampleLoadingText() {
      return iQ(10, 25);
    },
    loading: !0
  })), t;
})(), (() => {
  var t = v1();
  return S(t, b(ke, {
    sampleLoadingText: "aaaaa",
    loading: !0
  })), t;
})(), b(X, {
  get when() {
    return e.enableRefill;
  },
  get children() {
    var t = v1();
    return S(t, b(ke, {
      sampleLoadingText: "aaa",
      loading: !0
    })), t;
  }
})];
function xH(e) {
  return e.prescription ? R6(e.prescription?.writtenAt) || "N/A" : "External";
}
const kH = (e) => {
  const t = L(() => e.enableLinks && !!e.prescriptionId);
  return [b(X, {
    get when() {
      return !t();
    },
    get children() {
      var r = bH();
      return S(r, () => e.treatmentName), r;
    }
  }), b(X, {
    get when() {
      return t();
    },
    get children() {
      var r = $H();
      return S(r, () => e.treatmentName), J(() => pt(r, "href", `${e.linkBaseUrl}${e.prescriptionId}`)), r;
    }
  })];
};
cn(["click"]);
var _H = /* @__PURE__ */ x('<div class="flex items-center justify-between px-4 py-3 sm:px-6 sm:py-4">'), CH = /* @__PURE__ */ x('<div class="max-h-80 overflow-y-auto">');
const eu = Le`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      id
      treatmentHistory {
        active
        prescription {
          id
          writtenAt
          instructions
          notes
          fillsAllowed
          dispenseQuantity
          dispenseUnit
          dispenseAsWritten
          daysSupply
        }
        treatment {
          id
          name
        }
      }
    }
  }
`, SH = Le`
  mutation UpdateMedicationHistory($id: ID!, $medicationHistory: [MedHistoryInput!]!) {
    updatePatient(id: $id, medicationHistory: $medicationHistory) {
      id
    }
  }
`;
function I6(e) {
  const t = Ln(), [r, n] = H(void 0), [i, a] = H("asc"), o = L(() => `${t?.clinicalUrl}/prescriptions/`), s = L(() => ({
    variables: {
      id: e.patientId
    },
    client: t.apolloClinical,
    skip: !e.patientId,
    fetchPolicy: "network-only",
    refetchQueries: [eu]
  })), l = uc(eu, s);
  me(() => {
    const u = l();
    if (l.loading)
      n(void 0);
    else if (u) {
      const c = EH(u).slice().sort(TH(i()));
      n(c);
    } else
      n([]);
  });
  const d = async (u) => {
    const c = (p) => {
      const g = {
        __typename: "PatientMedication",
        treatment: {
          __typename: "Treatment",
          ...e.newMedication
        },
        active: !1,
        prescription: null
      }, v = p.readQuery({
        query: eu,
        variables: {
          id: e.patientId
        }
      })?.patient?.treatmentHistory ?? [];
      p.writeQuery({
        query: eu,
        variables: {
          id: e.patientId
        },
        data: {
          patient: {
            __typename: "Patient",
            id: e.patientId,
            treatmentHistory: [g, ...v]
          }
        }
      });
    }, h = {
      active: !1
    };
    if (u.startsWith("dme_"))
      h.medicalEquipmentId = u;
    else if (u.startsWith("med_"))
      h.medicationId = u;
    else {
      ir({
        header: `Invalid Treatment Id ${u}`,
        body: "The treatment Id is not valid.",
        status: "error"
      }), console.error(`Invalid Treatment Id ${u}`);
      return;
    }
    await t.apollo.mutate({
      mutation: SH,
      variables: {
        id: e.patientId,
        medicationHistory: [h]
      },
      update: c
    });
    const f = {
      treatment: e.newMedication,
      prescription: void 0
    };
    n((p) => p ? [f, ...p] : [f]), ir({
      header: "Medication Added",
      body: "Medication has been added to patients history.",
      status: "success"
    }), e.hideAddMedicationDialog?.();
  };
  return me(() => {
    e?.newMedication?.id && d(e.newMedication.id);
  }), b(hn, {
    addChildrenDivider: !0,
    autoPadding: !1,
    get children() {
      return [(() => {
        var u = _H();
        return S(u, b(ke, {
          color: "gray",
          children: "Medication History"
        }), null), S(u, b(X, {
          get when() {
            return e?.openAddMedicationDialog;
          },
          get children() {
            return b(st, {
              variant: "secondary",
              size: "sm",
              get onClick() {
                return e?.openAddMedicationDialog;
              },
              children: "+ Add"
            });
          }
        }), null), u;
      })(), (() => {
        var u = CH();
        return S(u, b(wH, {
          get enableLinks() {
            return e.enableLinks;
          },
          get enableRefillButton() {
            return e.enableRefillButton;
          },
          get baseURL() {
            return o();
          },
          get rowItems() {
            return r();
          },
          get isLoading() {
            return l.loading;
          },
          get sortOrder() {
            return i();
          },
          onSortOrderToggle: () => a((c) => c === "asc" ? "desc" : "asc")
        })), u;
      })()];
    }
  });
}
const EH = (e) => e?.patient?.treatmentHistory.map((t) => ({
  treatment: t.treatment,
  prescription: t.prescription
})), TH = (e) => (t, r) => {
  const n = t?.prescription?.writtenAt ? new Date(t.prescription.writtenAt).getTime() : -1 / 0, i = r?.prescription?.writtenAt ? new Date(r.prescription.writtenAt).getTime() : -1 / 0;
  return e === "desc" ? n - i : i - n;
};
async function AH(e = {}) {
  return new Promise((t, r) => {
    "geolocation" in navigator ? navigator.geolocation.getCurrentPosition(
      t,
      (n) => {
        r(n);
      },
      e
    ) : r(new Error("Geolocation not supported"));
  });
}
const OH = async (e, t) => {
  const r = {
    input: e,
    types: ["geocode"],
    componentRestrictions: { country: "us" }
  };
  return (await t.getPlacePredictions(r)).predictions.map((n) => ({
    value: n.place_id,
    label: n.description
  }));
};
var IH = /* @__PURE__ */ x("<div class=text-left><h3 class=mt-0>Set Location</h3><div class=mt-2><p class=text-sm>Enter the zipcode or address where you'd like to search for a pharmacy."), PH = /* @__PURE__ */ x('<div class="mt-5 sm:mt-6 grid grid-cols-1">'), DH = /* @__PURE__ */ x('<div class="flex items-center gap-2 py-2"><hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700 w-full"><p>OR</p><hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700 w-full">'), MH = /* @__PURE__ */ x('<p class="text-sm text-red-500 mt-2 text-center">Could not get current location');
function NH(e) {
  const [t, r] = H(""), [n, i] = H(!1), [a, o] = H(!1), [s, l] = H([]), {
    googleMapsServices: d
  } = Wf(), u = async (f) => {
    const {
      geocoder: p
    } = d();
    if (!p) return;
    o(!1);
    const g = await dc(f, p);
    g.length > 0 && (e.setLocation(g[0]), e.setOpen(!1));
  }, c = async () => {
    const {
      geocoder: f
    } = d();
    if (!f) throw new Error("Geocoder not loaded");
    i(!0), o(!1);
    try {
      const {
        coords: {
          latitude: p,
          longitude: g
        }
      } = await AH({
        timeout: 5e3
      }), v = await dc({
        latitude: p,
        longitude: g
      }, f);
      v.length > 0 && e.setLocation(v[0]), e.setOpen(!1);
    } catch {
      o(!0);
    }
    i(!1);
  }, h = async () => {
    const {
      autocompleteService: f
    } = d();
    if (!f) return;
    const p = await OH(t(), f);
    l(p);
  };
  return me(() => {
    t() && h();
  }), b(ao, {
    get open() {
      return e.open;
    },
    onClose: () => e.setOpen(!1),
    get children() {
      return [IH(), (() => {
        var f = PH();
        return S(f, b(st, {
          variant: "tertiary",
          onClick: c,
          get iconLeft() {
            return L(() => !!n())() ? b(ni, {
              size: "sm"
            }) : b(rt, {
              name: "mapPin",
              size: "sm"
            });
          },
          get children() {
            return n() ? "Getting Current Location" : "Use my Current Location";
          }
        }), null), S(f, (() => {
          var p = L(() => !!a());
          return () => p() && MH();
        })(), null), f;
      })(), DH(), b(wr, {
        label: "Enter an address or zip code",
        get children() {
          return b(Lr, {
            setSelected: u,
            get children() {
              return [b(Lr.Input, {
                displayValue: (f) => f.label,
                onInput: (f) => r(f.currentTarget.value)
              }), b(X, {
                get when() {
                  return s()?.length > 0;
                },
                get children() {
                  return b(Lr.Options, {
                    get children() {
                      return b(kt, {
                        get each() {
                          return s();
                        },
                        children: (f) => b(Lr.Option, {
                          get key() {
                            return f.value;
                          },
                          get value() {
                            return f.label;
                          },
                          get children() {
                            return f.label;
                          }
                        })
                      });
                    }
                  });
                }
              })];
            }
          });
        }
      })];
    }
  });
}
var LH = /* @__PURE__ */ x("<span class=text-gray-500><span class=sr-only> </span> "), FH = /* @__PURE__ */ x('<div class="relative flex items-start"><div class="flex h-6 items-center"><input type=checkbox class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600"></div><div class="ml-3 text-sm leading-6"><label class="font-medium text-gray-900">');
function RH(e) {
  const t = Da(), r = Be({
    id: `checkbox-${t}`,
    checked: !1
  }, e), n = (i) => {
    const a = i.target;
    r.onChange(a.checked);
  };
  return (() => {
    var i = FH(), a = i.firstChild, o = a.firstChild, s = a.nextSibling, l = s.firstChild;
    return o.addEventListener("change", n), S(l, () => r.mainText), S(s, b(X, {
      get when() {
        return r?.secondaryText;
      },
      get children() {
        var d = LH(), u = d.firstChild, c = u.firstChild;
        return u.nextSibling, S(u, () => r.mainText, c), S(d, () => r.secondaryText, null), J(() => pt(d, "id", `${r.id}-description`)), d;
      }
    }), null), J((d) => {
      var u = r.id, c = `${r.id}-description`, h = r.id, f = r.id;
      return u !== d.e && pt(o, "id", d.e = u), c !== d.t && pt(o, "aria-describedby", d.t = c), h !== d.a && pt(o, "name", d.a = h), f !== d.o && pt(l, "for", d.o = f), d;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0
    }), J(() => o.checked = r.checked), i;
  })();
}
const b1 = (e) => e.toLowerCase().split(" ").map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(" ");
function P6(e) {
  if (!e) return "";
  const { city: t, postalCode: r, state: n, street1: i, street2: a } = e;
  return `${b1(i)}${a ? `, ${b1(a)}` : ""}, ${b1(
    t
  )}, ${n} ${r || ""}`;
}
function dh(e) {
  return e.split(" ").map((t) => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase()).join(" ");
}
var zH = /* @__PURE__ */ x("<div>");
function zo(e) {
  const t = Be({
    size: "md",
    color: "blue"
  }, e), r = L(() => Zt(e.class, "inline-flex items-center text-xs font-medium whitespace-nowrap", {
    "px-2 py-1 rounded-xl": t.size === "md",
    "px-1.5 py-0.5 rounded-lg": t.size === "sm",
    "bg-gray-100 text-gray-600 border-gray-300 border-2": t.color === "gray",
    "bg-red-100 text-red-700 border-red-300 border-2": t.color === "red",
    "bg-yellow-100 text-yellow-800 border-yellow-300 border-2": t.color === "yellow",
    "bg-green-100 text-green-700 border-green-300 border-2": t.color === "green",
    "bg-blue-100 text-blue-700 border-blue-300 border-2": t.color === "blue",
    "bg-indigo-100 text-indigo-700 border-indigo-300 border-2": t.color === "indigo",
    "bg-purple-100 text-purple-700 border-purple-300 border-2": t.color === "purple",
    "bg-pink-100 text-pink-700 border-pink-300 border-2": t.color === "pink"
  }));
  return (() => {
    var n = zH();
    return S(n, () => e.children), J(() => ot(n, r())), n;
  })();
}
var jH = /* @__PURE__ */ x("<div class=p-4>No pharmacy matches that search"), VH = /* @__PURE__ */ x('<div class="flex gap-x-1">'), UH = /* @__PURE__ */ x('<div class="flex gap-x-1 items-center"> '), qH = /* @__PURE__ */ x("<div class=text-xs>");
const BH = (e) => `${dh(e.address?.street1 || "")}, ${dh(e.address?.city || "")}, ${e.address?.state}`;
function D6(e) {
  return b(wr, {
    get label() {
      return e.label;
    },
    get helpText() {
      return e.helpText || (e.value?.isPreferred || e.value?.isPrevious) && (() => {
        var t = VH();
        return S(t, b(X, {
          get when() {
            return e.value?.isPreferred;
          },
          get children() {
            return b(zo, {
              size: "sm",
              color: "blue",
              children: "Preferred"
            });
          }
        }), null), S(t, b(X, {
          get when() {
            return !e.value?.isPreferred && e.value?.isPrevious;
          },
          get children() {
            return b(zo, {
              size: "sm",
              color: "green",
              children: "Previous"
            });
          }
        }), null), t;
      })();
    },
    get loading() {
      return e.loading;
    },
    get children() {
      return b(Lr, {
        get value() {
          return e.value;
        },
        get setSelected() {
          return e.setValue;
        },
        get children() {
          return [b(Lr.Input, {
            onInput: (t) => e.onSearch?.(t.currentTarget.value),
            displayValue: (t) => t?.name ? `${t.name}, ${dh(t.address?.street1 || "")}` : ""
          }), b(Lr.Options, {
            get children() {
              return [b(X, {
                get when() {
                  return (e.options?.length || 0) > 0;
                },
                get children() {
                  return b(kt, {
                    get each() {
                      return e.options;
                    },
                    children: (t) => b(Lr.Option, {
                      get key() {
                        return t.id;
                      },
                      value: t,
                      get children() {
                        return [(() => {
                          var r = UH(), n = r.firstChild;
                          return S(r, () => t.name, n), S(r, b(X, {
                            get when() {
                              return t.isPreferred;
                            },
                            get children() {
                              return b(zo, {
                                size: "sm",
                                color: "blue",
                                children: "Preferred"
                              });
                            }
                          }), null), S(r, b(X, {
                            get when() {
                              return !t.isPreferred && t.isPrevious;
                            },
                            get children() {
                              return b(zo, {
                                size: "sm",
                                color: "green",
                                children: "Previous"
                              });
                            }
                          }), null), r;
                        })(), (() => {
                          var r = qH();
                          return S(r, () => BH(t)), r;
                        })()];
                      }
                    })
                  });
                }
              }), b(X, {
                get when() {
                  return e.options?.length === 0;
                },
                get children() {
                  return jH();
                }
              })];
            }
          })];
        }
      });
    }
  });
}
var HH = /* @__PURE__ */ x("<div class=mt-4>"), WH = /* @__PURE__ */ x("<div>"), QH = /* @__PURE__ */ x('<a href=#! role=button class="text-left truncate text-blue-600 font-semibold text-sm flex items-center">'), GH = /* @__PURE__ */ x('<div class="w-full flex flex-col sm:flex-row sm:items-center mb-2"><label class="whitespace-nowrap mr-1">Showing near:');
const M6 = Le`
  query GetLastOrder($id: ID!) {
    orders(filter: { patientId: $id }, first: 1) {
      createdAt
      pharmacy {
        id
        name
        address {
          street1
          street2
          city
          state
          postalCode
        }
      }
    }
  }
`;
function N6(e) {
  const t = Ln(), {
    googleMapsServices: r
  } = Wf(), [n, i] = H(e.initialValue), [a, o] = H(""), [s, l] = H(null), [d, u] = H(null), [c, h] = H([]), [f, p] = H(!1), [g, v] = H(!1), [m, $] = H(!1), [w, k] = H(null);
  async function C() {
    const {
      data: I
    } = await t.apollo.query({
      query: x6,
      variables: {
        location: {
          latitude: s()?.latitude,
          longitude: s()?.longitude
        }
      }
    });
    I?.pharmacies?.length > 0 && u(I.pharmacies.map((P) => ({
      ...P,
      isPreferred: !1
    }))), p(!1);
  }
  async function E(I) {
    v(!0);
    try {
      const {
        data: P
      } = await t.apollo.query({
        query: Hf,
        variables: {
          id: I
        }
      }), {
        data: z
      } = await t.apollo.query({
        query: M6,
        variables: {
          id: I
        }
      }), G = P?.patient?.address;
      if (G) {
        const se = P6(G);
        await q(se);
      }
      P?.patient?.preferredPharmacies?.length > 0 && h(P?.patient?.preferredPharmacies.map((se) => ({
        ...se,
        isPreferred: !0
      }))), z?.orders?.length > 0 && k(z?.orders?.[0]?.pharmacy?.id);
    } catch (P) {
      console.error("Error fetching preferred and previous pharmacies:", P);
    } finally {
      v(!1);
    }
  }
  const N = L(() => {
    const I = d() || [];
    return c().filter((P) => I.some((z) => z.id === P.id));
  }), M = L(() => {
    const I = d() || [], P = N(), z = w(), G = [...P, ...I].reduce((se, ue) => {
      if (!se[ue.id]) {
        const de = z === ue.id;
        se[ue.id] = {
          ...ue,
          isPrevious: de
        };
      }
      return se;
    }, {});
    return Object.values(G);
  });
  me(() => {
    s()?.latitude && s()?.longitude && (u(null), p(!0), C());
  });
  const V = L(() => M() === null || M()?.length === 0 ? [] : a() === "" ? M() : M()?.filter((I) => I.name.toLowerCase().includes(a().toLowerCase())) || []);
  me(() => {
    n()?.id && (o(""), e?.setPharmacy?.(n()));
  });
  async function q(I) {
    const {
      geocoder: P
    } = r();
    if (!P) throw new Error("Geocoder not loaded");
    const z = await dc(I || "", P);
    z.length > 0 && l(z[0]);
  }
  return me(() => {
    e?.patientId && E(e?.patientId);
  }), me(() => {
    e?.address && (p(!0), q(e.address));
  }), me(() => {
    const I = !n()?.id, P = N()?.length > 0, z = M()?.[0];
    I && P && z && i(z);
  }), (() => {
    var I = WH();
    return S(I, b(NH, {
      setLocation: l,
      get open() {
        return m();
      },
      setOpen: $
    }), null), S(I, b(D6, {
      get value() {
        return L(() => !!n()?.id)() ? n() : void 0;
      },
      setValue: i,
      get options() {
        return V();
      },
      onSearch: o,
      get loading() {
        return f();
      },
      get label() {
        return (() => {
          var P = GH();
          return P.firstChild, S(P, b(X, {
            get when() {
              return !g();
            },
            get fallback() {
              return b(ni, {
                size: "sm"
              });
            },
            get children() {
              var z = QH();
              return z.$$click = (G) => {
                G.preventDefault(), $(!0);
              }, S(z, b(rt, {
                name: "mapPin",
                size: "sm",
                class: "inline-block mr-1"
              }), null), S(z, () => s()?.address || "Set a location", null), z;
            }
          }), null), P;
        })();
      }
    }), null), S(I, b(X, {
      get when() {
        return L(() => !!(!e?.hidePreferred && !f() && !g() && n()))() && !n()?.isPreferred;
      },
      get children() {
        var P = HH();
        return S(P, b(RH, {
          id: "set-preferred-pharmacy",
          mainText: "Set as preferred pharmacy",
          checked: !1,
          onChange: (z) => e?.setPreferred?.(z)
        })), P;
      }
    }), null), I;
  })();
}
cn(["click"]);
var Ia = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Yf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Kf(e, t) {
  return e(t = { exports: {} }, t.exports), t.exports;
}
var _a = Kf(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var r = function() {
    function n() {
      var i = this;
      this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(a, o) {
        var s = i.locked.get(a);
        s === void 0 ? o === void 0 ? i.locked.set(a, []) : i.locked.set(a, [o]) : o !== void 0 && (s.unshift(o), i.locked.set(a, s));
      }, this.isLocked = function(a) {
        return i.locked.has(a);
      }, this.lock = function(a) {
        return new Promise(function(o, s) {
          i.isLocked(a) ? i.addToLocked(a, o) : (i.addToLocked(a), o());
        });
      }, this.unlock = function(a) {
        var o = i.locked.get(a);
        if (o !== void 0 && o.length !== 0) {
          var s = o.pop();
          i.locked.set(a, o), s !== void 0 && setTimeout(s, 0);
        } else i.locked.delete(a);
      };
    }
    return n.getInstance = function() {
      return n.instance === void 0 && (n.instance = new n()), n.instance;
    }, n;
  }();
  t.default = function() {
    return r.getInstance();
  };
});
Yf(_a);
var YH = Yf(Kf(function(e, t) {
  var r = Ia && Ia.__awaiter || function(u, c, h, f) {
    return new (h || (h = Promise))(function(p, g) {
      function v(w) {
        try {
          $(f.next(w));
        } catch (k) {
          g(k);
        }
      }
      function m(w) {
        try {
          $(f.throw(w));
        } catch (k) {
          g(k);
        }
      }
      function $(w) {
        w.done ? p(w.value) : new h(function(k) {
          k(w.value);
        }).then(v, m);
      }
      $((f = f.apply(u, c || [])).next());
    });
  }, n = Ia && Ia.__generator || function(u, c) {
    var h, f, p, g, v = { label: 0, sent: function() {
      if (1 & p[0]) throw p[1];
      return p[1];
    }, trys: [], ops: [] };
    return g = { next: m(0), throw: m(1), return: m(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
      return this;
    }), g;
    function m($) {
      return function(w) {
        return function(k) {
          if (h) throw new TypeError("Generator is already executing.");
          for (; v; ) try {
            if (h = 1, f && (p = 2 & k[0] ? f.return : k[0] ? f.throw || ((p = f.return) && p.call(f), 0) : f.next) && !(p = p.call(f, k[1])).done) return p;
            switch (f = 0, p && (k = [2 & k[0], p.value]), k[0]) {
              case 0:
              case 1:
                p = k;
                break;
              case 4:
                return v.label++, { value: k[1], done: !1 };
              case 5:
                v.label++, f = k[1], k = [0];
                continue;
              case 7:
                k = v.ops.pop(), v.trys.pop();
                continue;
              default:
                if (p = v.trys, !((p = p.length > 0 && p[p.length - 1]) || k[0] !== 6 && k[0] !== 2)) {
                  v = 0;
                  continue;
                }
                if (k[0] === 3 && (!p || k[1] > p[0] && k[1] < p[3])) {
                  v.label = k[1];
                  break;
                }
                if (k[0] === 6 && v.label < p[1]) {
                  v.label = p[1], p = k;
                  break;
                }
                if (p && v.label < p[2]) {
                  v.label = p[2], v.ops.push(k);
                  break;
                }
                p[2] && v.ops.pop(), v.trys.pop();
                continue;
            }
            k = c.call(u, v);
          } catch (C) {
            k = [6, C], f = 0;
          } finally {
            h = p = 0;
          }
          if (5 & k[0]) throw k[1];
          return { value: k[0] ? k[1] : void 0, done: !0 };
        }([$, w]);
      };
    }
  }, i = Ia;
  Object.defineProperty(t, "__esModule", { value: !0 });
  var a = "browser-tabs-lock-key", o = { key: function(u) {
    return r(i, void 0, void 0, function() {
      return n(this, function(c) {
        throw new Error("Unsupported");
      });
    });
  }, getItem: function(u) {
    return r(i, void 0, void 0, function() {
      return n(this, function(c) {
        throw new Error("Unsupported");
      });
    });
  }, clear: function() {
    return r(i, void 0, void 0, function() {
      return n(this, function(u) {
        return [2, window.localStorage.clear()];
      });
    });
  }, removeItem: function(u) {
    return r(i, void 0, void 0, function() {
      return n(this, function(c) {
        throw new Error("Unsupported");
      });
    });
  }, setItem: function(u, c) {
    return r(i, void 0, void 0, function() {
      return n(this, function(h) {
        throw new Error("Unsupported");
      });
    });
  }, keySync: function(u) {
    return window.localStorage.key(u);
  }, getItemSync: function(u) {
    return window.localStorage.getItem(u);
  }, clearSync: function() {
    return window.localStorage.clear();
  }, removeItemSync: function(u) {
    return window.localStorage.removeItem(u);
  }, setItemSync: function(u, c) {
    return window.localStorage.setItem(u, c);
  } };
  function s(u) {
    return new Promise(function(c) {
      return setTimeout(c, u);
    });
  }
  function l(u) {
    for (var c = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", h = "", f = 0; f < u; f++)
      h += c[Math.floor(Math.random() * c.length)];
    return h;
  }
  var d = function() {
    function u(c) {
      this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + l(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = c, u.waiters === void 0 && (u.waiters = []);
    }
    return u.prototype.acquireLock = function(c, h) {
      return h === void 0 && (h = 5e3), r(this, void 0, void 0, function() {
        var f, p, g, v, m, $, w;
        return n(this, function(k) {
          switch (k.label) {
            case 0:
              f = Date.now() + l(4), p = Date.now() + h, g = a + "-" + c, v = this.storageHandler === void 0 ? o : this.storageHandler, k.label = 1;
            case 1:
              return Date.now() < p ? [4, s(30)] : [3, 8];
            case 2:
              return k.sent(), v.getItemSync(g) !== null ? [3, 5] : (m = this.id + "-" + c + "-" + f, [4, s(Math.floor(25 * Math.random()))]);
            case 3:
              return k.sent(), v.setItemSync(g, JSON.stringify({ id: this.id, iat: f, timeoutKey: m, timeAcquired: Date.now(), timeRefreshed: Date.now() })), [4, s(30)];
            case 4:
              return k.sent(), ($ = v.getItemSync(g)) !== null && (w = JSON.parse($)).id === this.id && w.iat === f ? (this.acquiredIatSet.add(f), this.refreshLockWhileAcquired(g, f), [2, !0]) : [3, 7];
            case 5:
              return u.lockCorrector(this.storageHandler === void 0 ? o : this.storageHandler), [4, this.waitForSomethingToChange(p)];
            case 6:
              k.sent(), k.label = 7;
            case 7:
              return f = Date.now() + l(4), [3, 1];
            case 8:
              return [2, !1];
          }
        });
      });
    }, u.prototype.refreshLockWhileAcquired = function(c, h) {
      return r(this, void 0, void 0, function() {
        var f = this;
        return n(this, function(p) {
          return setTimeout(function() {
            return r(f, void 0, void 0, function() {
              var g, v, m;
              return n(this, function($) {
                switch ($.label) {
                  case 0:
                    return [4, _a.default().lock(h)];
                  case 1:
                    return $.sent(), this.acquiredIatSet.has(h) ? (g = this.storageHandler === void 0 ? o : this.storageHandler, (v = g.getItemSync(c)) === null ? (_a.default().unlock(h), [2]) : ((m = JSON.parse(v)).timeRefreshed = Date.now(), g.setItemSync(c, JSON.stringify(m)), _a.default().unlock(h), this.refreshLockWhileAcquired(c, h), [2])) : (_a.default().unlock(h), [2]);
                }
              });
            });
          }, 1e3), [2];
        });
      });
    }, u.prototype.waitForSomethingToChange = function(c) {
      return r(this, void 0, void 0, function() {
        return n(this, function(h) {
          switch (h.label) {
            case 0:
              return [4, new Promise(function(f) {
                var p = !1, g = Date.now(), v = !1;
                function m() {
                  if (v || (window.removeEventListener("storage", m), u.removeFromWaiting(m), clearTimeout($), v = !0), !p) {
                    p = !0;
                    var w = 50 - (Date.now() - g);
                    w > 0 ? setTimeout(f, w) : f(null);
                  }
                }
                window.addEventListener("storage", m), u.addToWaiting(m);
                var $ = setTimeout(m, Math.max(0, c - Date.now()));
              })];
            case 1:
              return h.sent(), [2];
          }
        });
      });
    }, u.addToWaiting = function(c) {
      this.removeFromWaiting(c), u.waiters !== void 0 && u.waiters.push(c);
    }, u.removeFromWaiting = function(c) {
      u.waiters !== void 0 && (u.waiters = u.waiters.filter(function(h) {
        return h !== c;
      }));
    }, u.notifyWaiters = function() {
      u.waiters !== void 0 && u.waiters.slice().forEach(function(c) {
        return c();
      });
    }, u.prototype.releaseLock = function(c) {
      return r(this, void 0, void 0, function() {
        return n(this, function(h) {
          switch (h.label) {
            case 0:
              return [4, this.releaseLock__private__(c)];
            case 1:
              return [2, h.sent()];
          }
        });
      });
    }, u.prototype.releaseLock__private__ = function(c) {
      return r(this, void 0, void 0, function() {
        var h, f, p, g;
        return n(this, function(v) {
          switch (v.label) {
            case 0:
              return h = this.storageHandler === void 0 ? o : this.storageHandler, f = a + "-" + c, (p = h.getItemSync(f)) === null ? [2] : (g = JSON.parse(p)).id !== this.id ? [3, 2] : [4, _a.default().lock(g.iat)];
            case 1:
              v.sent(), this.acquiredIatSet.delete(g.iat), h.removeItemSync(f), _a.default().unlock(g.iat), u.notifyWaiters(), v.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, u.lockCorrector = function(c) {
      for (var h = Date.now() - 5e3, f = c, p = [], g = 0; ; ) {
        var v = f.keySync(g);
        if (v === null) break;
        p.push(v), g++;
      }
      for (var m = !1, $ = 0; $ < p.length; $++) {
        var w = p[$];
        if (w.includes(a)) {
          var k = f.getItemSync(w);
          if (k !== null) {
            var C = JSON.parse(k);
            (C.timeRefreshed === void 0 && C.timeAcquired < h || C.timeRefreshed !== void 0 && C.timeRefreshed < h) && (f.removeItemSync(w), m = !0);
          }
        }
      }
      m && u.notifyWaiters();
    }, u.waiters = void 0, u;
  }();
  t.default = d;
})), Fa = Kf(function(e, t) {
  var r = Ia && Ia.__assign || function() {
    return r = Object.assign || function(l) {
      for (var d, u = 1, c = arguments.length; u < c; u++) for (var h in d = arguments[u]) Object.prototype.hasOwnProperty.call(d, h) && (l[h] = d[h]);
      return l;
    }, r.apply(this, arguments);
  };
  function n(l, d) {
    if (!d) return "";
    var u = "; " + l;
    return d === !0 ? u : u + "=" + d;
  }
  function i(l, d, u) {
    return encodeURIComponent(l).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(d).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(c) {
      if (typeof c.expires == "number") {
        var h = /* @__PURE__ */ new Date();
        h.setMilliseconds(h.getMilliseconds() + 864e5 * c.expires), c.expires = h;
      }
      return n("Expires", c.expires ? c.expires.toUTCString() : "") + n("Domain", c.domain) + n("Path", c.path) + n("Secure", c.secure) + n("SameSite", c.sameSite);
    }(u);
  }
  function a(l) {
    for (var d = {}, u = l ? l.split("; ") : [], c = /(%[\dA-F]{2})+/gi, h = 0; h < u.length; h++) {
      var f = u[h].split("="), p = f.slice(1).join("=");
      p.charAt(0) === '"' && (p = p.slice(1, -1));
      try {
        d[f[0].replace(c, decodeURIComponent)] = p.replace(c, decodeURIComponent);
      } catch {
      }
    }
    return d;
  }
  function o() {
    return a(document.cookie);
  }
  function s(l, d, u) {
    document.cookie = i(l, d, r({ path: "/" }, u));
  }
  t.__esModule = !0, t.encode = i, t.parse = a, t.getAll = o, t.get = function(l) {
    return o()[l];
  }, t.set = s, t.remove = function(l, d) {
    s(l, "", r(r({}, d), { expires: -1 }));
  };
});
Yf(Fa), Fa.encode, Fa.parse, Fa.getAll;
Fa.get;
Fa.set;
Fa.remove;
new YH();
Le`
  fragment OrganizationFields on Organization {
    id
    name
  }
`;
const KH = Le`
  fragment PatientFields on Patient {
    id
    externalId
    name {
      full
    }
    dateOfBirth
    sex
    gender
    email
    phone
    address {
      name {
        full
      }
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`;
Le`
  fragment AllergenFields on Allergen {
    id
    name
    rxcui
  }
`;
Le`
  fragment CatalogFields on Catalog {
    id
    name
  }
`;
Le`
  fragment MedicationFields on Medication {
    id
    name
    form
    schedule
    controlled
  }
`;
Le`
  fragment SearchMedicationFields on SearchMedication {
    id
    name
  }
`;
Le`
  fragment MedicalEquipmentFields on MedicalEquipment {
    id
    name
  }
`;
Le`
  fragment CatalogTreatmentFields on Catalog {
    treatments {
      id
      name
    }
  }
`;
Le`
  fragment DispenseUnitFields on DispenseUnit {
    name
  }
`;
const ZH = Le`
  fragment FillPrescriptionFields on Fill {
    id
    state
    requestedAt
    filledAt
    order {
      id
      createdAt
      state
      fulfillment {
        state
      }
      pharmacy {
        id
        name
        address {
          street1
          street2
          city
          state
          postalCode
        }
      }
    }
  }
`;
Le`
  ${ZH}
  fragment PrescriptionFields on Prescription {
    id
    externalId
    fills {
      ...FillPrescriptionFields
    }
    prescriber {
      id
      name {
        full
      }
    }
    patient {
      id
      name {
        full
      }
    }
    state
    treatment {
      id
      name
    }
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    fillsAllowed
    fillsRemaining
    daysSupply
    instructions
    notes
    effectiveDate
    expirationDate
    writtenAt
  }
`;
const XH = Le`
  fragment FillFields on Fill {
    id
    prescription {
      id
    }
    treatment {
      name
    }
    state
    requestedAt
    filledAt
  }
`;
Le`
  ${KH}
  ${XH}
  fragment OrderFields on Order {
    id
    externalId
    state
    fills {
      ...FillFields
    }
    patient {
      ...PatientFields
    }
    pharmacy {
      id
      name
      phone
      address {
        city
        country
        postalCode
        state
        street1
        street2
      }
    }
    fulfillment {
      type
      state
      carrier
      trackingNumber
    }
    createdAt
  }
`;
Le`
  fragment WebhookFields on WebhookConfig {
    id
    name
    filters
    url
  }
`;
Le`
  fragment ClientFields on Client {
    id
    name
    secret
    appType
  }
`;
Le`
  fragment PharmacyFields on Pharmacy {
    id
    NPI
    NCPDP
    name
    fulfillmentTypes
    address {
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`;
Le`
  fragment PrescriptionTemplateFields on PrescriptionTemplate {
    id
    daysSupply
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    instructions
    notes
    fillsAllowed
    treatment {
      id
      name
    }
    isPrivate
  }
`;
var uh;
(function(e) {
  e.Drug = "DRUG", e.Package = "PACKAGE", e.Product = "PRODUCT";
})(uh || (uh = {}));
var ch;
(function(e) {
  e.Icd10 = "ICD10";
})(ch || (ch = {}));
var hh;
(function(e) {
  e.Canceled = "CANCELED", e.New = "NEW", e.Scheduled = "SCHEDULED", e.Sent = "SENT";
})(hh || (hh = {}));
var fh;
(function(e) {
  e.MailOrder = "MAIL_ORDER", e.PickUp = "PICK_UP";
})(fh || (fh = {}));
var ph;
(function(e) {
  e.Otc = "OTC", e.Rx = "RX";
})(ph || (ph = {}));
var mh;
(function(e) {
  e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED", e.Routing = "ROUTING";
})(mh || (mh = {}));
var gh;
(function(e) {
  e.Pharmacy = "PHARMACY", e.Prescriber = "PRESCRIBER";
})(gh || (gh = {}));
var vh;
(function(e) {
  e.Draft = "DRAFT", e.Active = "ACTIVE", e.Depleted = "DEPLETED", e.Expired = "EXPIRED", e.Canceled = "CANCELED";
})(vh || (vh = {}));
var yh;
(function(e) {
  e.I = "I", e.Ii = "II", e.Iii = "III", e.Iv = "IV", e.V = "V";
})(yh || (yh = {}));
var bh;
(function(e) {
  e.Concept = "CONCEPT", e.Form = "FORM", e.Route = "ROUTE", e.Strength = "STRENGTH";
})(bh || (bh = {}));
var $h;
(function(e) {
  e.Female = "FEMALE", e.Male = "MALE", e.Unknown = "UNKNOWN";
})($h || ($h = {}));
const cg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ConceptType() {
    return uh;
  },
  get DiagnosisType() {
    return ch;
  },
  get FillState() {
    return hh;
  },
  get FulfillmentType() {
    return fh;
  },
  get MedicationType() {
    return ph;
  },
  get OrderState() {
    return mh;
  },
  get OrgType() {
    return gh;
  },
  get PrescriptionState() {
    return vh;
  },
  get ScheduleType() {
    return yh;
  },
  get SearchMedicationType() {
    return bh;
  },
  get SexType() {
    return $h;
  }
}, Symbol.toStringTag, { value: "Module" }));
var JH = /* @__PURE__ */ x('<div class="rounded-full bg-slate-100 h-5 w-5 mr-1">'), eW = /* @__PURE__ */ x("<div class=pt-4>"), tW = /* @__PURE__ */ x('<div><div class="flex justify-between items-center"><div><label class=sr-only></label><input type=radio class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600 sr-only">'), rW = /* @__PURE__ */ x("<div>"), nW = /* @__PURE__ */ x("<fieldset><legend class=sr-only></legend><div class=space-y-3>");
const L6 = Tr([{
  selected: "",
  options: [],
  fieldsetLabel: ""
}, {
  addOption: () => {
  },
  setSelected: () => {
  }
}]);
function iW(e) {
  const [t, r] = ua({
    selected: e.initSelected,
    options: [],
    fieldsetLabel: e.label
  }), n = [t, {
    addOption(i) {
      r("options", [...t.options, i]);
    },
    setSelected(i, a) {
      a || (r("selected", i), e?.setSelected && e.setSelected(i));
    }
  }];
  return me(() => {
    e.value && r("selected", e.value);
  }), me(() => {
    e.contextRef && e.contextRef(n);
  }), b(L6.Provider, {
    value: n,
    get children() {
      return e.children;
    }
  });
}
function F6() {
  return cr(L6);
}
function aW(e) {
  const [t, r] = F6();
  Et(() => {
    r.addOption(e.value);
  });
  const n = L(() => t.selected === e.value);
  return (() => {
    var i = rW();
    return i.$$click = () => r.setSelected(e.value, e.disabled), S(i, b(hn, {
      get selected() {
        return n();
      },
      get disabled() {
        return e.disabled;
      },
      get children() {
        var a = tW(), o = a.firstChild, s = o.firstChild, l = s.firstChild, d = l.nextSibling;
        return S(o, () => e.children, s), S(s, b(X, {
          get when() {
            return n();
          },
          get children() {
            return b(rt, {
              name: "checkCircle",
              class: "text-blue-600"
            });
          }
        }), l), S(s, b(X, {
          get when() {
            return !n() && !e.disabled;
          },
          get children() {
            return JH();
          }
        }), l), S(l, () => e.label), S(a, b(X, {
          get when() {
            return e.alert;
          },
          get children() {
            var u = eW();
            return S(u, () => e.alert), u;
          }
        }), null), J((u) => {
          var c = e.value, h = t.fieldsetLabel, f = e.value, p = e.disabled;
          return c !== u.e && pt(l, "for", u.e = c), h !== u.t && pt(d, "name", u.t = h), f !== u.a && pt(d, "id", u.a = f), p !== u.o && (d.disabled = u.o = p), u;
        }, {
          e: void 0,
          t: void 0,
          a: void 0,
          o: void 0
        }), J(() => d.value = e.value), J(() => d.checked = n()), a;
      }
    })), J(() => ot(i, e.disabled ? "" : "cursor-pointer")), i;
  })();
}
function oW(e) {
  const [, t] = F6();
  return Et(() => {
    e.initSelected && t.setSelected(e.initSelected);
  }), (() => {
    var r = nW(), n = r.firstChild, i = n.nextSibling;
    return S(n, () => e.label), S(i, () => e.children), r;
  })();
}
function Zl(e) {
  return b(iW, Be(e, {
    get children() {
      return b(oW, Be(e, {
        get children() {
          return e.children;
        }
      }));
    }
  }));
}
Zl.Option = aW;
cn(["click"]);
var sW = /* @__PURE__ */ x('<div class="border-b border-gray-200"><nav class="-mb-px flex space-x-4 sm:space-x-6 md:space-x-8"aria-label=Tabs>'), lW = /* @__PURE__ */ x("<div>");
function dW(e) {
  const t = "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium cursor-pointer", r = "border-blue-500 text-blue-600 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium";
  return (() => {
    var n = sW(), i = n.firstChild;
    return S(i, b(kt, {
      get each() {
        return e.tabs;
      },
      children: (a) => {
        const o = L(() => a === e.activeTab);
        return (() => {
          var s = lW();
          return s.$$click = () => e.setActiveTab(a), S(s, a), J((l) => {
            var d = o() ? r : t, u = o() ? "page" : void 0;
            return d !== l.e && ot(s, l.e = d), u !== l.t && pt(s, "aria-current", l.t = u), l;
          }, {
            e: void 0,
            t: void 0
          }), s;
        })();
      }
    })), n;
  })();
}
cn(["click"]);
var uW = /* @__PURE__ */ x("<span>, "), cW = /* @__PURE__ */ x('<div class="flex flex-col items-start">');
const hW = Le`
  query GetPharmacy($id: ID!) {
    pharmacy(id: $id) {
      id
      name
      address {
        street1
        city
        state
      }
    }
  }
`;
function fW(e) {
  const t = Ln(), [r, n] = H(null);
  async function i() {
    const {
      data: a
    } = await t.apollo.query({
      query: hW,
      variables: {
        id: e.pharmacyId
      }
    });
    a?.pharmacy && n(a.pharmacy);
  }
  return Et(() => {
    i();
  }), (() => {
    var a = cW();
    return S(a, b(ke, {
      get loading() {
        return !r();
      },
      sampleLoadingText: "Loading Name",
      get children() {
        return r()?.name;
      }
    }), null), S(a, b(ke, {
      get loading() {
        return !r();
      },
      color: "gray",
      size: "sm",
      sampleLoadingText: "Cityville, ST",
      get children() {
        var o = uW(), s = o.firstChild;
        return S(o, () => r()?.address?.city, s), S(o, () => r()?.address?.state, null), o;
      }
    }), null), a;
  })();
}
const uc = (e, t) => {
  const r = (typeof t == "function" ? t() : t).client, n = () => {
    if (typeof t != "function")
      return t.skip && console.warn(
        `you passed options.skip to createQuery, but the options are not an acccessor.
This query will never execute!

Replace your options with a function.`
      ), t;
    const a = typeof t == "function" ? t() : t;
    return a.skip ? !1 : a;
  }, [i] = qv(
    n,
    (a) => {
      const o = r.watchQuery({ query: e, ...a }), [s, l] = ua({});
      let d = !1;
      return new Promise((u, c) => {
        const h = o.subscribe({
          error: c,
          next: ({ data: f, error: p }) => {
            p && c(p), d ? l(vF(f)) : (d = !0, l(f), u(s));
          }
        });
        xr(() => h.unsubscribe());
      });
    }
  );
  return i;
};
var pW = /* @__PURE__ */ x("<div class=mt-4><div>"), mW = /* @__PURE__ */ x("<div><div>");
const nl = {
  patientWillSelect: {
    badgeColor: "purple",
    badgeText: "Patient Will Select",
    text: "Patient will select a pharmacy after you send an order."
  },
  recentPharmacy: {
    badgeColor: "yellow",
    badgeText: "Recent Pharmacy",
    text: "This patient selected this pharmacy in the last 8 hours. After you send this order, the patient can change the pharmacy."
  },
  preferredPharmacy: {
    badgeColor: "blue",
    badgeText: "Preferred Pharmacy",
    text: "This patient selected this as their preferred pharmacy."
  },
  coverageOptionPharmacy: {
    badgeColor: "gray",
    badgeText: "Selected Pharmacy",
    text: "The selected option was for this pharmacy."
  }
};
function gW(e) {
  const t = Ln(), {
    orderFormData: r,
    selectedCoverageOption: n
  } = oo(), [i, a] = H(nl.patientWillSelect), [o, s] = H(void 0), l = L(() => ({
    variables: {
      id: e.patientId
    },
    client: t.apollo
  })), d = uc(Hf, l), u = uc(M6, l), c = L(() => !u.loading && !d.loading), h = L(() => {
    const f = u()?.orders?.[0];
    if (f) {
      const p = /* @__PURE__ */ new Date(), g = new Date(p.getTime() - 8 * 60 * 60 * 1e3);
      if (new Date(f.createdAt) > g)
        return f;
    }
  });
  return me(() => {
    if (c()) {
      const f = d()?.patient?.preferredPharmacies, p = h()?.pharmacy;
      if ((f?.length ?? 0) > 0) {
        if (a(nl.preferredPharmacy), f && f.length > 0) {
          const g = f[0], v = {
            ...g,
            address: {
              country: "",
              postalCode: "",
              ...g.address
            }
          };
          s(v);
        }
      } else p ? (a(nl.recentPharmacy), s(p)) : a(nl.patientWillSelect);
    } else
      s(void 0);
  }), me(() => {
    const f = n();
    f && f.pharmacy.id === r.pharmacyId && (a(nl.coverageOptionPharmacy), t.clinical.pharmacy.getPharmacy({
      id: r.pharmacyId
    }).then((p) => {
      s(p.data.pharmacy);
    }));
  }), b(X, {
    get when() {
      return c();
    },
    get fallback() {
      return b(ni, {
        size: "sm"
      });
    },
    get children() {
      var f = pW(), p = f.firstChild;
      return S(p, b(zo, {
        get color() {
          return i().badgeColor;
        },
        get children() {
          return i().badgeText;
        }
      })), S(f, b(ke, {
        size: "sm",
        class: "py-4",
        get children() {
          return i().text;
        }
      }), null), S(f, b(X, {
        get when() {
          return o();
        },
        children: (g) => b(hn, {
          variant: "gray",
          get children() {
            var v = mW(), m = v.firstChild;
            return S(v, b(ke, {
              size: "sm",
              bold: !0,
              get children() {
                return g().name;
              }
            }), m), S(m, b(ke, {
              size: "sm",
              get children() {
                return P6(g().address);
              }
            })), v;
          }
        })
      }), null), f;
    }
  });
}
var vW = /* @__PURE__ */ x("<div class=mb-2><label>Search home delivery options");
function yW(e) {
  const t = Ln(), [r, n] = H(!1), [i, a] = H(""), [o, s] = H(), l = L(() => {
    const u = o();
    return u && u.length === 0;
  }), d = L(() => {
    const u = i(), c = u ? new RegExp(u, "i") : null, h = (p) => !c || c.test(p.name), f = (p) => ({
      ...p,
      isPreferred: !1,
      isPrevious: !1
    });
    return o()?.filter(h).map(f);
  });
  return me(() => {
    async function u() {
      n(!0);
      try {
        const {
          data: c
        } = await t.apolloClinical.query({
          query: Xq,
          variables: {
            offset: 0,
            limit: 40,
            fulfillmentType: "MAIL_ORDER",
            integrated: !1
          }
        });
        s(c.pharmacies);
      } catch (c) {
        console.error("Failed to load mail order pharmacy options", c);
      } finally {
        n(!1);
      }
    }
    u();
  }), me(() => {
    e.selected || a("");
  }), L(() => L(() => !!l())() ? null : b(D6, {
    get label() {
      return vW();
    },
    get options() {
      return d();
    },
    onSearch: a,
    get value() {
      return e.selected;
    },
    get setValue() {
      return e.selectPharmacy;
    },
    get loading() {
      return r();
    }
  }));
}
var hg = /* @__PURE__ */ x("<div>"), bW = /* @__PURE__ */ x("<div><div class=space-y-4>"), $W = /* @__PURE__ */ x("<div><div class=pt-4>"), wW = /* @__PURE__ */ x("<div>Please select a patient."), xW = /* @__PURE__ */ x("<div class=space-y-2><label>Choose a partner pharmacy");
const fg = [{
  name: "Send to Patient",
  fulfillmentType: "SEND_TO_PATIENT"
  /* sendToPatient */
}, {
  name: "Local Pickup",
  fulfillmentType: cg.FulfillmentType.PickUp
}, {
  name: "Mail Order",
  fulfillmentType: cg.FulfillmentType.MailOrder
}], pg = (e) => e === "SEND_TO_PATIENT" ? void 0 : e;
function kW(e) {
  const {
    orderFormData: t,
    selectedCoverageOption: r,
    unroutablePharmacyIds: n
  } = oo(), [i, a] = H(), [o, s] = H(), [l, d] = H(), [u, c] = H([]), [h, f] = H(
    "Send to Patient"
    /* sendToPatient */
  ), p = L(() => e.mailOrderPharmacyIds?.filter(($) => !n().has($))), g = L(() => p()?.[0]);
  let v;
  me(() => {
    const $ = o();
    $ && n().has($) && v[1].setSelected(g() || "");
  }), Et(() => {
    c([...e.enableSendToPatient ? [
      "Send to Patient"
      /* sendToPatient */
    ] : [], ...e.enableLocalPickup ? [
      "Local Pickup"
      /* localPickup */
    ] : [], ...e.enableDeliveryPharmacies ? [
      "Mail Order"
      /* mailOrder */
    ] : []]);
    const $ = fg.find((w) => w.name === u()[0])?.fulfillmentType;
    e.setFufillmentType(pg($)), f(u()[0]);
  }), me(() => {
    const $ = r(), w = Re(() => t.pharmacyId);
    $ && w === $.pharmacy.id && f(u()[0]);
  });
  const m = ($) => {
    f($), u().includes($) || c([...u(), $]);
    const w = fg.find((k) => k.name === $)?.fulfillmentType;
    e.setFufillmentType(pg(w)), $ === "Local Pickup" && i() ? e.setPharmacyId(i()) : $ === "Mail Order" && o() ? e.setPharmacyId(o()) : e.setPharmacyId(r()?.pharmacy.id);
  };
  return (() => {
    var $ = $W(), w = $.firstChild;
    return S($, b(dW, {
      get tabs() {
        return u();
      },
      get activeTab() {
        return h();
      },
      setActiveTab: m
    }), w), S(w, b(X, {
      get when() {
        return u().includes(
          "Send to Patient"
          /* sendToPatient */
        );
      },
      get children() {
        var k = hg();
        return S(k, b(X, {
          get when() {
            return (e?.patientIds?.length || 0) > 0;
          },
          get fallback() {
            return wW();
          },
          get children() {
            return b(gW, {
              get patientId() {
                return e.patientIds[0];
              }
            });
          }
        })), J(() => ot(k, h() !== "Send to Patient" ? "hidden" : "")), k;
      }
    }), null), S(w, b(X, {
      get when() {
        return u().includes(
          "Local Pickup"
          /* localPickup */
        );
      },
      get children() {
        var k = hg();
        return S(k, b(N6, {
          get address() {
            return e?.address || "";
          },
          get patientId() {
            return e?.patientIds?.[0];
          },
          setPharmacy: (C) => {
            a(C.id), h() === "Local Pickup" && e.setPharmacyId(C.id);
          },
          setPreferred: (C) => e?.setPreferredPharmacy?.(C)
        })), J(() => ot(k, h() !== "Local Pickup" ? "hidden" : "")), k;
      }
    }), null), S(w, b(X, {
      get when() {
        return u().includes(
          "Mail Order"
          /* mailOrder */
        );
      },
      get children() {
        var k = bW(), C = k.firstChild;
        return S(C, b(yW, {
          get selected() {
            return l();
          },
          selectPharmacy: (E) => {
            d(E), s(E.id), h() === "Mail Order" && e.setPharmacyId(E.id);
          }
        }), null), S(C, (() => {
          var E = L(() => (e.mailOrderPharmacyIds?.length ?? 0) > 0);
          return () => E() && (() => {
            var N = xW();
            return N.firstChild, S(N, b(Zl, {
              label: "Pharmacies",
              get value() {
                return o();
              },
              setSelected: (M) => {
                d(void 0), s(M), h() === "Mail Order" && e.setPharmacyId(M);
              },
              contextRef: (M) => v = M,
              get children() {
                return b(kt, {
                  get each() {
                    return e?.mailOrderPharmacyIds || [];
                  },
                  children: (M) => b(Zl.Option, {
                    value: M,
                    get disabled() {
                      return n().has(M);
                    },
                    get alert() {
                      return L(() => !!n().has(M))() && b(mj, {});
                    },
                    get children() {
                      return b(fW, {
                        pharmacyId: M
                      });
                    }
                  })
                });
              }
            }), null), N;
          })();
        })(), null), J(() => ot(k, h() !== "Mail Order" ? "hidden" : "")), k;
      }
    }), null), $;
  })();
}
function R6(e) {
  return e ? new Date(e).toLocaleDateString("en-US", { timeZone: "UTC" }) : "";
}
var _W = /* @__PURE__ */ x("<div class=mr-1>");
const CW = {
  PLACED: "Placed",
  ROUTING: "Routing",
  PENDING: "Pending",
  CANCELED: "Canceled",
  COMPLETED: "Completed",
  ERROR: "Error"
}, SW = {
  PLACED: "arrowUpRight",
  ROUTING: "arrowUturnRight",
  PENDING: "clock",
  CANCELED: "xCircle",
  COMPLETED: "checkCircle",
  ERROR: "questionMarkCircle"
}, EW = {
  SENT: "Sent",
  RECEIVED: "Received",
  READY: "Ready",
  PICKED_UP: "Picked up",
  FILLING: "Filling",
  SHIPPED: "Shipped",
  DELIVERED: "Delivered"
}, TW = {
  SENT: "Order sent to pharmacy",
  RECEIVED: "Order received by pharmacy",
  READY: "Order ready at pharmacy",
  PICKED_UP: "Order picked up by patient",
  FILLING: "Mail order being filled",
  SHIPPED: "Mail order shipped",
  DELIVERED: "Mail order delivered"
}, AW = {
  PLACED: "Order has been placed",
  ROUTING: "Order waiting on patient pharmacy selection",
  PENDING: "Order is pending",
  CANCELED: "Order has been canceled",
  COMPLETED: "Order has been completed",
  ERROR: "Order has an error"
}, OW = {
  ERROR: "red",
  CANCELED: "red",
  ROUTING: "gray",
  PLACED: "yellow",
  PENDING: "yellow",
  COMPLETED: "green"
}, IW = {
  SENT: "yellow",
  RECEIVED: "yellow",
  FILLING: "yellow",
  SHIPPED: "yellow",
  READY: "green",
  PICKED_UP: "green",
  DELIVERED: "green"
};
function PW(e) {
  const t = L(() => {
    if (e.orderState === "PLACED" && e.fulfillmentState) {
      const r = e.fulfillmentState;
      return {
        status: EW[r],
        statusColor: IW[r],
        statusTip: TW[r]
      };
    } else {
      const r = e.orderState;
      return {
        status: CW[r],
        statusTip: AW[r],
        statusIcon: SW[r],
        statusColor: OW[r]
      };
    }
  });
  return b(X, {
    get when() {
      return t().status;
    },
    get children() {
      return b(O6, {
        get text() {
          return t().statusTip;
        },
        get children() {
          return b(zo, {
            get color() {
              return t().statusColor;
            },
            get children() {
              return [b(X, {
                get when() {
                  return t().statusIcon;
                },
                get children() {
                  var r = _W();
                  return S(r, b(rt, {
                    get name() {
                      return t().statusIcon;
                    },
                    size: "sm"
                  })), r;
                }
              }), L(() => t().status)];
            }
          });
        }
      });
    }
  });
}
var DW = /* @__PURE__ */ x('<div class="flex items-center justify-between">'), MW = /* @__PURE__ */ x('<table class="table-fixed divide-y divide-gray-300 break-words"><tbody class="divide-y divide-gray-200">'), NW = /* @__PURE__ */ x('<div class="flex flex-col gap-2"><div class="flex gap-x-4">'), LW = /* @__PURE__ */ x("<div class=mt-4>"), FW = /* @__PURE__ */ x('<tr><td class="align-top whitespace-nowrap pr-4 py-4 text-sm text-gray-500"></td><td class="py-4 text-sm text-gray-500"><div class=flex><div class=pr-4></div><div>');
function RW() {
  const [e, t] = Ps();
  return b(X, {
    get when() {
      return e.orders.length > 0;
    },
    get children() {
      return b(hn, {
        addChildrenDivider: !0,
        get children() {
          return [(() => {
            var r = DW();
            return S(r, b(ke, {
              color: "gray",
              children: "Recent Orders"
            })), r;
          })(), (() => {
            var r = MW(), n = r.firstChild;
            return S(n, b(kt, {
              get each() {
                return e.orders;
              },
              children: (i) => {
                const a = /* @__PURE__ */ new Set();
                return i?.fills.forEach((o) => {
                  a.add(o.treatment?.name);
                }), (() => {
                  var o = FW(), s = o.firstChild, l = s.nextSibling, d = l.firstChild, u = d.firstChild, c = u.nextSibling;
                  return S(s, b(ke, {
                    color: "gray",
                    size: "sm",
                    get children() {
                      return R6(i.createdAt);
                    }
                  })), S(u, b(PW, {
                    get orderState() {
                      return i.state;
                    }
                  })), S(c, b(kt, {
                    get each() {
                      return [...a];
                    },
                    children: (h, f) => b(ke, {
                      color: "black",
                      size: "sm",
                      get children() {
                        return [h, L(() => f() < a.size - 1 ? ",  " : null)];
                      }
                    })
                  })), S(l, b(X, {
                    get when() {
                      return i.state === "ROUTING";
                    },
                    get children() {
                      var h = LW();
                      return S(h, b(ca, {
                        status: "info",
                        withoutIcon: !0,
                        get children() {
                          var f = NW(), p = f.firstChild;
                          return S(f, b(ke, {
                            size: "sm",
                            color: "black",
                            children: "This order is pending pharmacy selection by the patient"
                          }), p), S(p, b(st, {
                            variant: "naked",
                            onClick: () => t.setIsIssueDialogOpen(!0, i),
                            children: "Report Issue"
                          })), f;
                        }
                      })), h;
                    }
                  }), null), o;
                })();
              }
            })), r;
          })()];
        }
      });
    }
  });
}
var zW = /* @__PURE__ */ x('<div class="flex flex-col gap-6"><div><div class="table bg-red-50 text-red-600 p-2 rounded-full mb-4"></div></div><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4"><br></div><div class="flex flex-col items-stretch gap-4">');
function jW() {
  let e;
  const [t, r] = Ps();
  return me(() => {
    t.isDuplicateDialogOpen && Kr("prescribe-duplicate-dialog-open", {
      duplicate: t.duplicateFill,
      order: t.orderWithIssue
    }, e);
  }), b(ao, {
    get open() {
      return t.isDuplicateDialogOpen;
    },
    onClose: () => {
      Kr("prescribe-duplicate-dialog-exit", {}, e), t?.duplicateDialogCancelCb?.(), r.setIsDuplicateDialogOpen(!1);
    },
    get children() {
      var n = zW(), i = n.firstChild, a = i.firstChild, o = i.nextSibling, s = o.firstChild, l = o.nextSibling, d = e;
      return typeof d == "function" ? bn(d, n) : e = n, S(a, b(rt, {
        name: "exclamationCircle"
      })), S(i, b(ke, {
        bold: !0,
        class: "mb-2",
        children: "Looks like a duplicate order"
      }), null), S(i, b(ke, {
        children: "This patient already has an order for the same prescription:"
      }), null), S(o, b(ke, {
        size: "sm",
        get children() {
          return t?.duplicateFill?.treatment?.name;
        }
      }), s), S(o, b(ke, {
        size: "sm",
        color: "gray",
        get children() {
          return ms({
            dispenseQuantity: t?.duplicateFill?.prescription?.dispenseQuantity,
            dispenseUnit: t?.duplicateFill?.prescription?.dispenseUnit,
            fillsAllowed: t?.duplicateFill?.prescription?.fillsAllowed,
            instructions: t?.duplicateFill?.prescription?.instructions
          });
        }
      }), null), S(o, b(ke, {
        size: "sm",
        color: "gray",
        get children() {
          return ["Written by ", L(() => t?.duplicateFill?.prescription?.prescriber?.name?.full), " on", " ", L(() => new Date(t?.duplicateFill?.prescription?.writtenAt).toLocaleDateString())];
        }
      }), null), S(l, b(st, {
        size: "xl",
        onClick: () => {
          t?.duplicateDialogCancelCb?.(), r.setIsDuplicateDialogOpen(!1), r.setIsIssueDialogOpen(!0);
        },
        children: "Report Issue"
      }), null), S(l, b(st, {
        size: "xl",
        variant: "secondary",
        onClick: () => {
          Kr("prescribe-duplicate-dialog-add-anyway", {}, e), t?.duplicateDialogContinueCb?.(), r.setIsDuplicateDialogOpen(!1);
        },
        children: "Add Prescriptions Anyway"
      }), null), S(l, b(st, {
        variant: "naked",
        size: "xl",
        onClick: () => {
          t?.duplicateDialogCancelCb?.(), Kr("prescribe-duplicate-dialog-exit", {}, e), r.setIsDuplicateDialogOpen(!1);
        },
        children: "Go Back"
      }), null), n;
    }
  });
}
var VW = /* @__PURE__ */ x("<label class=hidden>"), UW = /* @__PURE__ */ x("<textarea>");
function qW(e) {
  const t = Da(), r = Be({
    resize: !1,
    rows: 4,
    name: "Comment",
    placeholder: ""
  }, e);
  return [(() => {
    var n = VW();
    return S(n, () => r.name), J(() => pt(n, "for", e?.name ?? t)), n;
  })(), (() => {
    var n = UW();
    return J((i) => {
      var a = r.rows, o = e?.name ?? t, s = e?.name ?? t, l = `block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 ${r.resize ? "resize-y" : "resize-none"}`, d = r.placeholder;
      return a !== i.e && pt(n, "rows", i.e = a), o !== i.t && pt(n, "name", i.t = o), s !== i.a && pt(n, "id", i.a = s), l !== i.o && ot(n, i.o = l), d !== i.i && pt(n, "placeholder", i.i = d), i;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0
    }), n;
  })()];
}
function z6(e) {
  const t = /* @__PURE__ */ new Set();
  return e.fills.filter((r) => {
    const n = r.treatment?.name;
    return !n || t.has(n) ? !1 : (t.add(n), !0);
  });
}
const wh = (e, t) => {
  const r = (typeof t == "function" ? t() : t).client;
  let n = null, i = null;
  const [a, o] = H(!1), [s] = qv(a, async (l) => {
    let d;
    try {
      d = await r.mutate(l);
    } catch (h) {
      throw i && (i(h), i = null), h;
    }
    const { data: u, errors: c } = d;
    if (c)
      throw i && (i(c[0]), i = null), c[0];
    if (u != null)
      return n && (n(u), n = null), u;
    throw new Error("Mutation did not return any data.");
  });
  return [async (l) => {
    const d = {
      mutation: e,
      ...typeof t == "function" ? Re(t) : t
    }, u = ku(l, d);
    return o(u), new Promise((c, h) => {
      n = c, i = h;
    });
  }, s];
};
var BW = /* @__PURE__ */ x('<div class="flex flex-col gap-6"><div></div><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4 flex flex-col gap-4"><div class="flex flex-col"></div><div class="flex flex-col"><div class="flex flex-col gap-y-4"></div></div></div><form class=mt-4 id=prescribe-flow-duplicate></form><div class="flex flex-col items-stretch gap-4">'), HW = /* @__PURE__ */ x("<div><br>");
const WW = B9({
  description: _o().min(1, {
    message: "A description is required"
  })
}), QW = Le`
  mutation CreateTicket($input: TicketInput!) {
    createTicket(input: $input) {
      id
    }
  }
`, GW = ({
  patient: e,
  order: t,
  prescriptions: r,
  values: n
}) => {
  const i = (o) => `
    Name: ${o.name}
    Info: ${ms({
    dispenseQuantity: o.dispenseQuantity,
    dispenseUnit: o.dispenseUnit,
    fillsAllowed: o.fillsAllowed,
    instructions: o.instructions
  })}
  `, a = r.map(i).join(`

`);
  return `
Order:
  ID: ${t.id}

----
Patient:
  ID: ${e.id}
  Name: ${e.name}

----
Prescriptions:
${a}

----
Description:
  ${n.description}
`;
}, YW = "prescribe-flow-duplicate";
function KW() {
  let e;
  const [t, r] = Ps(), n = Ln(), [i, a] = wh(QW, {
    client: n.apolloClinical
  });
  me(() => {
    t.isIssueDialogOpen && Kr("prescribe-issue-dialog-open", {}, e);
  });
  const o = () => {
    const c = new CustomEvent("photon-ticket-created-duplicate", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    e?.dispatchEvent(c);
  }, s = L(() => t?.orderWithIssue ? z6(t.orderWithIssue) : t?.duplicateFill ? [t.duplicateFill] : []), l = async (c) => {
    Kr("prescribe-issue-dialog-submitting", {}, e);
    const h = GW({
      patient: {
        id: t?.patientId,
        name: t?.patientName
      },
      order: {
        id: t?.orderWithIssue?.id
      },
      prescriptions: s().map((f) => ({
        name: f?.treatment?.name,
        dispenseQuantity: f?.prescription?.dispenseQuantity,
        dispenseUnit: f?.prescription?.dispenseUnit,
        fillsAllowed: f?.prescription?.fillsAllowed,
        instructions: f?.prescription?.instructions
      })),
      values: c
    });
    await i({
      variables: {
        input: {
          subject: `Issue with ${t?.duplicateFill?.treatment?.name || t?.orderWithIssue?.id}`,
          comment: {
            body: h
          }
        }
      }
    }), ir({
      header: "Issue reported",
      body: "The customer support team will respond to you shortly.",
      status: "success"
    }), o(), r.setIsIssueDialogOpen(!1);
  }, {
    form: d,
    errors: u
  } = R9({
    onSubmit: async (c) => {
      try {
        l({
          ...c
        });
      } catch {
        ir({
          header: "Error Creating Issue",
          body: "A ticket for this order has not been sent.",
          status: "info"
        });
      }
    },
    extend: z9({
      schema: WW
    })
  });
  return b(ao, {
    get open() {
      return t.isIssueDialogOpen;
    },
    onClose: () => {
      Kr("prescribe-issue-dialog-exit", {}, e), r.setIsIssueDialogOpen(!1);
    },
    get children() {
      var c = BW(), h = c.firstChild, f = h.nextSibling, p = f.firstChild, g = p.nextSibling, v = g.firstChild, m = f.nextSibling, $ = m.nextSibling, w = e;
      return typeof w == "function" ? bn(w, c) : e = c, S(h, b(ke, {
        bold: !0,
        class: "mb-2",
        children: "Report issue with existing order"
      }), null), S(h, b(ke, {
        children: "Start an email thread with the Photon team to discuss next steps."
      }), null), S(p, b(ke, {
        size: "xs",
        color: "gray",
        children: "PATIENT"
      }), null), S(p, b(ke, {
        size: "sm",
        get children() {
          return t?.patientName;
        }
      }), null), S(g, b(ke, {
        size: "xs",
        color: "gray",
        children: "PRESCRIPTION"
      }), v), S(v, b(kt, {
        get each() {
          return s();
        },
        children: (k) => (() => {
          var C = HW(), E = C.firstChild;
          return S(C, b(ke, {
            size: "sm",
            get children() {
              return k?.treatment?.name;
            }
          }), E), S(C, b(ke, {
            size: "sm",
            color: "gray",
            get children() {
              return ms({
                dispenseQuantity: k?.prescription?.dispenseQuantity,
                dispenseUnit: k?.prescription?.dispenseUnit,
                fillsAllowed: k?.prescription?.fillsAllowed,
                instructions: k?.prescription?.instructions
              });
            }
          }), null), C;
        })()
      })), bn(d, m), S(m, b(ke, {
        size: "xs",
        class: "mb-2",
        bold: !0,
        children: "Description"
      }), null), S(m, b(qW, {
        placeholder: "Describe issue with this order",
        name: "description"
      }), null), S(m, b(ke, {
        size: "xs",
        color: "red",
        get children() {
          return u().description;
        }
      }), null), S($, b(st, {
        size: "xl",
        get disabled() {
          return a.loading;
        },
        get loading() {
          return a.loading;
        },
        type: "submit",
        form: YW,
        children: "Report Issue"
      }), null), S($, b(st, {
        variant: "naked",
        size: "xl",
        onClick: () => {
          Kr("prescribe-issue-dialog-exit", {}, e), r.setIsIssueDialogOpen(!1);
        },
        children: "Go Back"
      }), null), c;
    }
  });
}
var ZW = /* @__PURE__ */ x('<div class="flex flex-col gap-6"><div><div class="table bg-blue-50 text-blue-600 p-2 rounded-full mb-4"></div></div><div class="flex flex-col gap-4"><div class="flex flex-col gap-2"><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4"></div></div><div class="flex flex-col gap-2"><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4 flex flex-col gap-4"></div></div></div><div class="flex flex-col items-stretch gap-2">'), mg = /* @__PURE__ */ x("<div><br>");
const XW = Le`
  mutation RecentOrdersCombineDialogUpdateOrder($orderId: ID!, $fills: [FillInput!]!) {
    updateOrder(id: $orderId, fills: $fills) {
      id
      createdAt
      fills {
        id
        prescription {
          id
          dispenseQuantity
          dispenseUnit
          fillsAllowed
          instructions
          notes
        }
        treatment {
          name
        }
      }
    }
  }
`, JW = Le`
  mutation RecentOrdersCombineDialogCreateOrder(
    $patientId: ID!
    $fills: [FillInput!]!
    $address: AddressInput!
  ) {
    createOrder(patientId: $patientId, fills: $fills, address: $address) {
      id
    }
  }
`;
function eQ() {
  let e;
  const t = pd(), {
    draftPrescriptions: r
  } = t, n = Ln(), [i, a] = Ps(), [o, s] = H(!1), [l, d] = H(!1), [u] = wh(XW, {
    client: n.apollo
  }), [c] = wh(JW, {
    client: n.apollo
  }), h = (m) => {
    const $ = new CustomEvent("photon-order-combined", {
      composed: !0,
      bubbles: !0,
      detail: {
        order: m
      }
    });
    e?.dispatchEvent($);
  }, f = (m) => {
    const $ = new CustomEvent("photon-order-created", {
      composed: !0,
      bubbles: !0,
      detail: {
        order: m
      }
    });
    e?.dispatchEvent($);
  };
  me(() => {
    i.isCombineDialogOpen && Kr("prescribe-combine-dialog-open", {}, e);
  });
  const p = L(() => i.orders.find((m) => m.state === "ROUTING")), g = L(() => {
    const m = p();
    return m ? z6(m) : [];
  }), v = async () => {
    const m = p();
    if (!m)
      return;
    d(!0), Kr("prescribe-combine-dialog-combining", {}, e);
    const $ = r().map((w) => ({
      prescriptionId: w.id
    }));
    try {
      const w = await u({
        variables: {
          orderId: m.id,
          fills: $
        }
      });
      h(w.updateOrder), d(!1), a.setIsCombineDialogOpen(!1);
      return;
    } catch {
      try {
        if (!i?.address || !i?.patientId)
          throw new Error("No address provided");
        const w = await c({
          variables: {
            patientId: i.patientId,
            fills: $,
            address: i.address
          }
        });
        f(w.createOrder), d(!1);
      } catch {
        ir({
          header: "Error Creating Order",
          body: "The prescription was created but not turned into an order.",
          status: "info"
        }), d(!1);
        return;
      }
    }
  };
  return b(ao, {
    get open() {
      return i.isCombineDialogOpen;
    },
    onClose: () => {
      Kr("prescribe-combine-dialog-exit", {}, e), a.setIsCombineDialogOpen(!1);
    },
    get children() {
      var m = ZW(), $ = m.firstChild, w = $.firstChild, k = $.nextSibling, C = k.firstChild, E = C.firstChild, N = C.nextSibling, M = N.firstChild, V = k.nextSibling, q = e;
      return typeof q == "function" ? bn(q, m) : e = m, S(w, b(rt, {
        name: "exclamationCircle"
      })), S($, b(ke, {
        bold: !0,
        children: "Add prescription to recent order?"
      }), null), S(C, b(ke, {
        children: "This patient currently has an order for:"
      }), E), S(E, b(kt, {
        get each() {
          return g();
        },
        children: (I) => (() => {
          var P = mg(), z = P.firstChild;
          return S(P, b(ke, {
            size: "sm",
            get children() {
              return I?.treatment?.name;
            }
          }), z), S(P, b(ke, {
            size: "sm",
            color: "gray",
            get children() {
              return ms({
                dispenseQuantity: I?.prescription?.dispenseQuantity,
                dispenseUnit: I?.prescription?.dispenseUnit,
                fillsAllowed: I?.prescription?.fillsAllowed,
                instructions: I?.prescription?.instructions
              });
            }
          }), null), P;
        })()
      })), S(N, b(ke, {
        children: "Select YES to combine orders and enable the patient to send it to the same pharmacy:"
      }), M), S(M, () => b(kt, {
        get each() {
          return r();
        },
        children: (I) => (() => {
          var P = mg(), z = P.firstChild;
          return S(P, b(ke, {
            size: "sm",
            get children() {
              return I.treatment.name;
            }
          }), z), S(P, b(ke, {
            size: "sm",
            color: "gray",
            get children() {
              return ms({
                dispenseQuantity: I?.dispenseQuantity ?? 0,
                dispenseUnit: I?.dispenseUnit ?? "",
                fillsAllowed: I?.fillsAllowed ?? 0,
                instructions: I?.instructions ?? ""
              });
            }
          }), null), P;
        })()
      })), S(V, b(st, {
        size: "xl",
        onClick: v,
        get disabled() {
          return o() || l();
        },
        get loading() {
          return l();
        },
        children: "Yes, combine orders"
      }), null), S(V, b(st, {
        variant: "secondary",
        size: "xl",
        onClick: () => {
          Kr("prescribe-combine-dialog-not-combining", {}, e), i.createOrder?.(), s(!0);
        },
        get disabled() {
          return o() || l();
        },
        get loading() {
          return o();
        },
        get children() {
          return o() ? "Creating order..." : "No, send new order";
        }
      }), null), m;
    }
  });
}
var j6 = /* @__PURE__ */ ((e) => (e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED", e.Routing = "ROUTING", e))(j6 || {});
const tQ = Le`
  query GetPatientOrders($patientId: ID!) {
    patient(id: $patientId) {
      id
      name {
        full
      }
      orders(first: 5) {
        id
        createdAt
        state
        fills {
          treatment {
            name
          }
          prescription {
            dispenseQuantity
            dispenseUnit
            fillsAllowed
            instructions
            writtenAt
            prescriber {
              name {
                full
              }
            }
          }
        }
      }
    }
  }
`, V6 = Tr();
function vi(e) {
  const t = Ln(), [r, n] = ua({
    orders: [],
    isLoading: !0,
    isCombineDialogOpen: !1,
    isDuplicateDialogOpen: !1,
    isIssueDialogOpen: !1,
    duplicateDialogContinueCb: () => {
    },
    duplicateDialogCancelCb: () => {
    }
  }), i = L(() => ({
    variables: {
      patientId: e.patientId
    },
    skip: !e.patientId,
    client: t.apollo,
    fetchPolicy: "network-only"
  })), a = uc(tQ, i), o = [r, {
    setIsCombineDialogOpen(s, l, d) {
      n({
        isCombineDialogOpen: s,
        ...l ? {
          createOrder: l
        } : {
          createOrderCb: void 0
        },
        ...d ? {
          address: d
        } : {
          address: void 0
        }
      });
    },
    setIsDuplicateDialogOpen(s, l, d, u) {
      n({
        isDuplicateDialogOpen: s,
        ...d ? {
          duplicateDialogContinueCb: d
        } : {
          duplicateDialogContinueCb: void 0
        },
        ...u ? {
          duplicateDialogCancelCb: u
        } : {
          duplicateDialogCancelCb: void 0
        },
        ...l ? {
          duplicateFill: l.fill
        } : {},
        ...l ? {
          orderWithIssue: l.order
        } : {}
      });
    },
    setIsIssueDialogOpen(s, l) {
      n({
        isIssueDialogOpen: s,
        ...l && {
          orderWithIssue: l
        },
        ...!s && {
          duplicateFill: void 0,
          orderWithIssue: void 0
        }
      });
    },
    checkDuplicateFill(s) {
      const l = r.orders.filter((d) => d.state !== j6.Canceled);
      for (const d of l) {
        const u = d.fills.find((c) => c.treatment.name === s);
        if (u !== void 0)
          return {
            order: d,
            fill: u
          };
      }
    },
    hasRoutingOrder() {
      return r.orders.some((s) => s.state === "ROUTING");
    }
  }];
  return me(() => {
    n({
      isLoading: a.loading
    });
    const s = a()?.patient;
    if (!a.loading && s) {
      const l = s.orders;
      if (l?.length > 0) {
        const d = /* @__PURE__ */ new Date(), u = new Date(d.getTime() - 8 * 60 * 60 * 1e3), c = l.filter((h) => new Date(h.createdAt) > u);
        n({
          orders: c,
          patientName: s?.name?.full,
          patientId: s?.id
        });
      }
    }
  }), b(V6.Provider, {
    value: o,
    get children() {
      return e.children;
    }
  });
}
function Ps() {
  const e = cr(V6);
  if (!e)
    throw new Error("useRecentOrders must be used within RecentOrdersContext");
  return e;
}
vi.Card = RW;
vi.CombineDialog = eQ;
vi.DuplicateDialog = jW;
vi.IssueDialog = KW;
const rQ = (e) => b(KR, {
  get containerStyle() {
    return {
      "margin-top": `${e?.buffer || 0}px`
    };
  }
});
function nQ(e) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let r = "";
  for (let n = 0; n < e; n++)
    r += t.charAt(Math.floor(Math.random() * t.length));
  return r;
}
function iQ(e = 5, t = 10) {
  const r = Math.floor(Math.random() * (t - e + 1)) + e;
  return nQ(r);
}
function aQ(e) {
  let t = "N/A", r = "", n = "N/A", i = "N/A", a = "N/A";
  return e && (t = e.dispenseQuantity.toString(), e.dispenseQuantity > 0 && (r = ` ${e.dispenseUnit}`), e.daysSupply && (n = e.daysSupply.toString()), e.fillsAllowed ? i = (e.fillsAllowed - 1).toString() : i = "0", e.instructions && (a = e.instructions)), `QTY: ${t}${r} | Days Supply: ${n} | Refills: ${i} | Sig: ${a}`;
}
var oQ = /* @__PURE__ */ x("<span hidden>"), sQ = /* @__PURE__ */ x('<div class="flex justify-center w-full">'), lQ = /* @__PURE__ */ x('<div class="text-red-700 font-bold flex space-x-2 items-center justify-center"><span>An error occurred. Please refresh and try again'), dQ = /* @__PURE__ */ x("<div class=w-full>"), uQ = /* @__PURE__ */ x('<div class="flex flex-col space-y-5"><div class="bg-[#FFFAEB] flex text-[#DC6803] py-2 font-semibold items-center text-sm">Required before writing prescriptions</div><div class=space-y-3><p class=text-base>By selecting <span class=font-bold>Agree</span>, you approve any prescriptions you create and send via Photon Health, Inc and that you are a practitioner authorized to prescribe and licensed in the relevant state. This signature image will not be used for any other purposes.</p></div><div class="flex justify-end space-x-4">');
const U6 = Le`
  query GetCurrentUserSignatureAttestationStatus {
    me {
      signatureAttestationStatus {
        ... on NeedsSignatureAttestation {
          version
          content
        }
        ... on CompletedSignatureAttestation {
          agreedAt
          version
        }
        ... on NotApplicableSignatureAttestation {
          reason
        }
      }
    }
  }
`, cQ = Le`
  mutation AgreeToSignatureAttestation($version: String!) {
    agreeToSignatureAttestation(version: $version)
  }
`, hQ = async (e) => await e.query({
  query: U6,
  fetchPolicy: "cache-first"
}), fQ = (e) => async (t) => await e.mutate({
  mutation: cQ,
  variables: {
    version: t
  },
  refetchQueries: ["GetCurrentUserSignatureAttestationStatus"],
  awaitRefetchQueries: !0,
  update: (r, {
    data: n
  }) => {
    n?.agreeToSignatureAttestation && r.writeQuery({
      query: U6,
      data: {
        me: {
          signatureAttestationStatus: {
            __typename: "CompletedSignatureAttestation",
            agreedAt: /* @__PURE__ */ new Date(),
            version: t
          }
        }
      }
    });
  }
}), pQ = (e) => {
  let t;
  const [r, n] = H({
    status: "LOADING"
  }), [i, a] = H(!1), o = async () => {
    const u = await hQ(e.client);
    u.error || u.errors ? n({
      status: "ERROR",
      errors: [...u.errors?.map((c) => c.message) ?? [], ...u.error ? [u.error.message] : []]
    }) : u.data?.me?.signatureAttestationStatus ? u.data?.me?.signatureAttestationStatus?.__typename === "CompletedSignatureAttestation" || u.data?.me?.signatureAttestationStatus?.__typename === "NotApplicableSignatureAttestation" ? n({
      status: "COMPLETE"
    }) : n({
      status: "NEEDS ATTESTATION",
      version: u.data.me.signatureAttestationStatus.version
    }) : n({
      status: "ERROR",
      errors: ["Could not get user data. Please refresh and try again"]
    });
  }, s = () => {
    const u = new CustomEvent("photon-signature-attestation-agreed", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(u);
  }, l = () => {
    const u = new CustomEvent("photon-signature-attestation-canceled", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(u);
  };
  me(() => {
    r().status === "COMPLETE" && s();
  }), me(() => {
    o();
  });
  const d = async () => {
    if (i())
      return;
    const u = r();
    if (u.status === "NEEDS ATTESTATION") {
      a(!0);
      const c = await fQ(e.client)(u.version);
      c.data?.agreeToSignatureAttestation ? (a(!1), n({
        status: "COMPLETE"
      })) : (c.error || c.errors) && (a(!1), n({
        status: "ERROR",
        errors: [...c.errors?.map((h) => h.message) ?? [], ...c.error ? [c.error.message] : []]
      }));
    }
  };
  return [(() => {
    var u = oQ(), c = t;
    return typeof c == "function" ? bn(c, u) : t = u, u;
  })(), b(Ac, {
    get children() {
      return [b(vn, {
        get when() {
          return r().status === "LOADING";
        },
        get children() {
          var u = sQ();
          return S(u, b(ni, {
            color: "green"
          })), u;
        }
      }), b(vn, {
        get when() {
          return r().status === "COMPLETE";
        },
        get children() {
          return e.children;
        }
      }), b(vn, {
        get when() {
          return r().status === "ERROR";
        },
        get children() {
          var u = lQ(), c = u.firstChild;
          return S(u, b(rt, {
            name: "exclamationCircle"
          }), c), u;
        }
      }), b(vn, {
        get when() {
          return r().status === "NEEDS ATTESTATION";
        },
        get children() {
          var u = dQ();
          return S(u, b(mQ, {
            onAgree: d,
            onCancel: l,
            get disabled() {
              return i();
            }
          })), u;
        }
      })];
    }
  })];
}, mQ = (e) => b(hn, {
  get children() {
    var t = uQ(), r = t.firstChild, n = r.firstChild, i = r.nextSibling, a = i.firstChild, o = i.nextSibling;
    return S(r, b(rt, {
      name: "informationCircle",
      class: "mx-2"
    }), n), S(i, b(ke, {
      bold: !0,
      size: "xl",
      children: "Prescriber Signature Attestation"
    }), a), S(i, b(ke, {
      class: "block",
      children: "Photon Health, Inc. attaches your signature image to the digital signature and timestamp associated with an authorized digital prescription; or digital prescription reproduced as a hard copy facsimile."
    }), a), S(i, b(ke, {
      class: "block",
      children: "In order to send prescriptions via the Photon application, you must be personally logged-in at the time of prescribe to approve the prescription to be created."
    }), a), S(o, b(st, {
      variant: "secondary",
      get onClick() {
        return e.onCancel;
      },
      get disabled() {
        return e.disabled;
      },
      children: "Cancel"
    }), null), S(o, b(st, {
      variant: "primary",
      get onClick() {
        return e.onAgree;
      },
      get disabled() {
        return e.disabled;
      },
      children: "Agree"
    }), null), t;
  }
}), q6 = Tr(), Xr = () => {
  const e = cr(q6);
  if (!e)
    throw new Error("usePhoton must be used within PhotonContext");
  return e;
};
function xh(e) {
  this.message = e;
}
xh.prototype = new Error(), xh.prototype.name = "InvalidCharacterError";
var gg = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new xh("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, n, i = 0, a = 0, o = ""; n = t.charAt(a++); ~n && (r = i % 4 ? 64 * r + n : n, i++ % 4) ? o += String.fromCharCode(255 & r >> (-2 * i & 6)) : 0) n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
  return o;
};
function gQ(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(r) {
      return decodeURIComponent(gg(r).replace(/(.)/g, function(n, i) {
        var a = i.charCodeAt(0).toString(16).toUpperCase();
        return a.length < 2 && (a = "0" + a), "%" + a;
      }));
    }(t);
  } catch {
    return gg(t);
  }
}
function cc(e) {
  this.message = e;
}
function vQ(e, t) {
  if (typeof e != "string") throw new cc("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(gQ(e.split(".")[r]));
  } catch (n) {
    throw new cc("Invalid token specified: " + n.message);
  }
}
cc.prototype = new Error(), cc.prototype.name = "InvalidTokenError";
const yQ = (e) => {
  e?.returnTo ? window.location.replace(e?.returnTo) : window.history.pushState(null, window.document.title, window.location.pathname);
}, bQ = Le`
  fragment CatalogTreatmentsFieldsComponentFragment on Catalog {
    treatments {
      id
      name
    }
    templates {
      id
      daysSupply
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      instructions
      notes
      fillsAllowed
      treatment {
        id
        name
      }
    }
  }
`, $Q = {
  CatalogTreatmentsFieldsComponentFragment: bQ
};
class wQ {
  sdk;
  setStore;
  store;
  authentication;
  getSDK;
  clinical;
  autoLogin;
  constructor(t, r = !1) {
    this.sdk = t, this.autoLogin = r;
    const [n, i] = ua({
      authentication: {
        isAuthenticated: !1,
        isInOrg: !1,
        permissions: [],
        isLoading: !0,
        error: void 0,
        user: void 0
      },
      catalog: {
        isLoading: !1,
        treatments: [],
        templates: []
      },
      catalogs: {
        isLoading: !1,
        catalogs: []
      },
      dispenseUnits: {
        isLoading: !1,
        dispenseUnits: new Array()
      },
      patients: {
        isLoading: !1,
        patients: [],
        finished: !1
      },
      patient: {
        isLoading: !1,
        patient: void 0
      },
      prescription: {
        isLoading: !1,
        errors: [],
        error: void 0,
        data: void 0
      }
    });
    this.setStore = i, this.store = n, this.authentication = {
      state: n.authentication,
      handleRedirect: async (a) => {
        try {
          const o = await this.sdk.authentication.handleRedirect(a);
          yQ(o?.appState), await this.authentication.checkSession();
        } catch (o) {
          const s = new URLSearchParams(window.location.search).get("error_description");
          o.message.includes("must be an organization id") ? this.setStore("authentication", {
            ...this.store.authentication,
            error: "The provided organization id is invalid or does not exist"
          }) : s?.includes("is not part of the org") ? this.setStore("authentication", {
            ...this.store.authentication,
            error: "User is not authorized",
            isLoading: !1
          }) : this.setStore("authentication", {
            ...this.store.authentication,
            error: o.message
          });
        }
      },
      checkSession: this.checkSession.bind(this),
      login: this.login.bind(this),
      logout: this.logout.bind(this)
    }, this.getSDK = this._getSDK.bind(this), this.clinical = {
      catalog: {
        state: n.catalog,
        getCatalog: this.getCatalog.bind(this)
      },
      catalogs: {
        state: n.catalogs,
        getCatalogs: this.getCatalogs.bind(this)
      },
      dispenseUnits: {
        state: n.dispenseUnits,
        getDispenseUnits: this.getDispenseUnits.bind(this)
      },
      patients: {
        state: n.patients,
        getPatients: this.getPatients.bind(this)
      },
      patient: {
        state: n.patient,
        getPatient: this.getPatient.bind(this)
      },
      prescription: {
        state: n.prescription,
        createPrescription: this.createPrescription.bind(this)
      }
    };
  }
  _getSDK() {
    return this.sdk;
  }
  async checkSession() {
    try {
      await this.sdk.authentication.checkSession();
      const t = await this.sdk.authentication.isAuthenticated();
      this.setStore("authentication", {
        ...this.store.authentication,
        isAuthenticated: t
      });
      const r = await this.sdk.authentication.getUser(), n = !!this.sdk?.organization && !!r?.org_id;
      let i = [];
      if (this.autoLogin || t)
        try {
          const o = await this.sdk.authentication.getAccessToken();
          i = vQ(o)?.permissions || [];
        } catch {
          i = [];
        }
      const a = t && n && this.sdk.organization === r.org_id;
      this.setStore("authentication", {
        ...this.store.authentication,
        user: r,
        isLoading: !1,
        isInOrg: a,
        permissions: i || []
      });
    } catch {
      this.setStore("authentication", {
        ...this.store.authentication,
        isLoading: !1
      });
    }
  }
  async login(t = {}) {
    await this.sdk.authentication.login(t), await this.checkSession();
  }
  async logout(t = {}) {
    await this.sdk.authentication.logout(t), this.setStore("authentication", {
      ...this.store.authentication,
      isAuthenticated: !1,
      isInOrg: !1,
      permissions: [],
      user: void 0
    });
  }
  async getPatients(t) {
    t || (t = {}), this.setStore("patients", {
      ...this.store.patients,
      isLoading: !0
    });
    const { data: r } = await this.sdk.clinical.patient.getPatients(t);
    this.setStore("patients", {
      ...this.store.patients,
      isLoading: !1,
      patients: t.clear ? r.patients : this.store.patients.patients.concat(r.patients),
      finished: r.patients.length == 0
    });
  }
  async getPatient(t) {
    this.setStore("patient", {
      ...this.store.patient,
      isLoading: !0
    });
    const { data: r } = await this.sdk.clinical.patient.getPatient(t);
    return this.setStore("patient", {
      ...this.store.patient,
      isLoading: !1,
      patient: r.patient
    }), r.patient;
  }
  async getCatalog(t) {
    this.setStore("catalog", {
      ...this.store.catalog,
      isLoading: !0
    });
    const { data: r } = await this.sdk.clinical.catalog.getCatalog({
      id: t.id,
      fragment: $Q
    });
    this.setStore("catalog", {
      ...this.store.catalog,
      isLoading: !1,
      treatments: r.catalog.treatments.map((n) => n) || [],
      templates: r.catalog.templates.map((n) => n) || []
    });
  }
  async getCatalogs() {
    this.setStore("catalogs", {
      ...this.store.catalogs,
      isLoading: !0
    });
    const { data: t } = await this.sdk.clinical.catalog.getCatalogs();
    this.setStore("catalogs", {
      ...this.store.catalogs,
      isLoading: !1,
      catalogs: t.catalogs
    });
  }
  async getDispenseUnits() {
    this.setStore("dispenseUnits", {
      ...this.store.dispenseUnits,
      isLoading: !0
    });
    const { data: t } = await this.sdk.clinical.prescription.getDispenseUnits();
    this.setStore("dispenseUnits", {
      ...this.store.dispenseUnits,
      isLoading: !1,
      dispenseUnits: t.dispenseUnits.map((r, n) => ({
        id: String(n),
        ...r
      }))
    });
  }
  async createPrescription(t) {
    this.setStore("prescription", {
      ...this.store.prescription,
      isLoading: !0
    });
    const r = this.sdk.clinical.prescription.createPrescription({});
    try {
      const { data: n, errors: i } = await r({
        variables: t,
        refetchQueries: [],
        awaitRefetchQueries: !1
      });
      return i && i.length > 0 && this.setStore("prescription", {
        ...this.store.prescription,
        errors: [...i]
      }), n?.createPrescription && this.setStore("prescription", {
        ...this.store.prescription,
        data: n.createPrescription
      }), this.setStore("prescription", {
        ...this.store.prescription,
        isLoading: !1
      }), {
        data: n,
        errors: i
      };
    } catch (n) {
      return this.setStore("prescription", {
        ...this.store.prescription,
        error: n,
        isLoading: !1
      }), {
        data: null,
        errors: []
      };
    }
  }
}
const xQ = (e, t, r) => {
  const n = r(e, t);
  return xr(() => clearInterval(n));
}, B6 = "%[a-f0-9]{2}", vg = new RegExp("(" + B6 + ")|([^%]+?)", "gi"), yg = new RegExp("(" + B6 + ")+", "gi");
function kh(e, t) {
  try {
    return [decodeURIComponent(e.join(""))];
  } catch {
  }
  if (e.length === 1)
    return e;
  t = t || 1;
  const r = e.slice(0, t), n = e.slice(t);
  return Array.prototype.concat.call([], kh(r), kh(n));
}
function kQ(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    let t = e.match(vg) || [];
    for (let r = 1; r < t.length; r++)
      e = kh(t, r).join(""), t = e.match(vg) || [];
    return e;
  }
}
function _Q(e) {
  const t = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let r = yg.exec(e);
  for (; r; ) {
    try {
      t[r[0]] = decodeURIComponent(r[0]);
    } catch {
      const i = kQ(r[0]);
      i !== r[0] && (t[r[0]] = i);
    }
    r = yg.exec(e);
  }
  t["%C2"] = "�";
  const n = Object.keys(t);
  for (const i of n)
    e = e.replace(new RegExp(i, "g"), t[i]);
  return e;
}
function CQ(e) {
  if (typeof e != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
  try {
    return decodeURIComponent(e);
  } catch {
    return _Q(e);
  }
}
function SQ(e, t) {
  const r = {};
  if (Array.isArray(t))
    for (const n of t) {
      const i = Object.getOwnPropertyDescriptor(e, n);
      i?.enumerable && Object.defineProperty(r, n, i);
    }
  else
    for (const n of Reflect.ownKeys(e)) {
      const i = Object.getOwnPropertyDescriptor(e, n);
      if (i.enumerable) {
        const a = e[n];
        t(n, a, e) && Object.defineProperty(r, n, i);
      }
    }
  return r;
}
function H6(e, t) {
  if (!(typeof e == "string" && typeof t == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "" || t === "")
    return [];
  const r = e.indexOf(t);
  return r === -1 ? [] : [
    e.slice(0, r),
    e.slice(r + t.length)
  ];
}
const EQ = (e) => e == null, TQ = (e) => encodeURIComponent(e).replaceAll(/[!'()*]/g, (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`), _h = Symbol("encodeFragmentIdentifier");
function AQ(e) {
  switch (e.arrayFormat) {
    case "index":
      return (t) => (r, n) => {
        const i = r.length;
        return n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
          ...r,
          [Jt(t, e), "[", i, "]"].join("")
        ] : [
          ...r,
          [Jt(t, e), "[", Jt(i, e), "]=", Jt(n, e)].join("")
        ];
      };
    case "bracket":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [Jt(t, e), "[]"].join("")
      ] : [
        ...r,
        [Jt(t, e), "[]=", Jt(n, e)].join("")
      ];
    case "colon-list-separator":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [Jt(t, e), ":list="].join("")
      ] : [
        ...r,
        [Jt(t, e), ":list=", Jt(n, e)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const t = e.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (r) => (n, i) => i === void 0 || e.skipNull && i === null || e.skipEmptyString && i === "" ? n : (i = i === null ? "" : i, n.length === 0 ? [[Jt(r, e), t, Jt(i, e)].join("")] : [[n, Jt(i, e)].join(e.arrayFormatSeparator)]);
    }
    default:
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        Jt(t, e)
      ] : [
        ...r,
        [Jt(t, e), "=", Jt(n, e)].join("")
      ];
  }
}
function OQ(e) {
  let t;
  switch (e.arrayFormat) {
    case "index":
      return (r, n, i) => {
        if (t = /\[(\d*)]$/.exec(r), r = r.replace(/\[\d*]$/, ""), !t) {
          i[r] = n;
          return;
        }
        i[r] === void 0 && (i[r] = {}), i[r][t[1]] = n;
      };
    case "bracket":
      return (r, n, i) => {
        if (t = /(\[])$/.exec(r), r = r.replace(/\[]$/, ""), !t) {
          i[r] = n;
          return;
        }
        if (i[r] === void 0) {
          i[r] = [n];
          return;
        }
        i[r] = [...i[r], n];
      };
    case "colon-list-separator":
      return (r, n, i) => {
        if (t = /(:list)$/.exec(r), r = r.replace(/:list$/, ""), !t) {
          i[r] = n;
          return;
        }
        if (i[r] === void 0) {
          i[r] = [n];
          return;
        }
        i[r] = [...i[r], n];
      };
    case "comma":
    case "separator":
      return (r, n, i) => {
        const a = typeof n == "string" && n.includes(e.arrayFormatSeparator), o = typeof n == "string" && !a && mi(n, e).includes(e.arrayFormatSeparator);
        n = o ? mi(n, e) : n;
        const s = a || o ? n.split(e.arrayFormatSeparator).map((l) => mi(l, e)) : n === null ? n : mi(n, e);
        i[r] = s;
      };
    case "bracket-separator":
      return (r, n, i) => {
        const a = /(\[])$/.test(r);
        if (r = r.replace(/\[]$/, ""), !a) {
          i[r] = n && mi(n, e);
          return;
        }
        const o = n === null ? [] : mi(n, e).split(e.arrayFormatSeparator);
        if (i[r] === void 0) {
          i[r] = o;
          return;
        }
        i[r] = [...i[r], ...o];
      };
    default:
      return (r, n, i) => {
        if (i[r] === void 0) {
          i[r] = n;
          return;
        }
        i[r] = [...[i[r]].flat(), n];
      };
  }
}
function W6(e) {
  if (typeof e != "string" || e.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function Jt(e, t) {
  return t.encode ? t.strict ? TQ(e) : encodeURIComponent(e) : e;
}
function mi(e, t) {
  return t.decode ? CQ(e) : e;
}
function Q6(e) {
  return Array.isArray(e) ? e.sort() : typeof e == "object" ? Q6(Object.keys(e)).sort((t, r) => Number(t) - Number(r)).map((t) => e[t]) : e;
}
function G6(e) {
  const t = e.indexOf("#");
  return t !== -1 && (e = e.slice(0, t)), e;
}
function IQ(e) {
  let t = "";
  const r = e.indexOf("#");
  return r !== -1 && (t = e.slice(r)), t;
}
function bg(e, t, r) {
  return r === "string" && typeof e == "string" ? e : typeof r == "function" && typeof e == "string" ? r(e) : t.parseBooleans && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") ? e.toLowerCase() === "true" : r === "number" && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" || t.parseNumbers && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? Number(e) : e;
}
function Zf(e) {
  e = G6(e);
  const t = e.indexOf("?");
  return t === -1 ? "" : e.slice(t + 1);
}
function Xf(e, t) {
  t = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    types: /* @__PURE__ */ Object.create(null),
    ...t
  }, W6(t.arrayFormatSeparator);
  const r = OQ(t), n = /* @__PURE__ */ Object.create(null);
  if (typeof e != "string" || (e = e.trim().replace(/^[?#&]/, ""), !e))
    return n;
  for (const i of e.split("&")) {
    if (i === "")
      continue;
    const a = t.decode ? i.replaceAll("+", " ") : i;
    let [o, s] = H6(a, "=");
    o === void 0 && (o = a), s = s === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(t.arrayFormat) ? s : mi(s, t), r(mi(o, t), s, n);
  }
  for (const [i, a] of Object.entries(n))
    if (typeof a == "object" && a !== null && t.types[i] !== "string")
      for (const [o, s] of Object.entries(a)) {
        const l = t.types[i] ? t.types[i].replace("[]", "") : void 0;
        a[o] = bg(s, t, l);
      }
    else typeof a == "object" && a !== null && t.types[i] === "string" ? n[i] = Object.values(a).join(t.arrayFormatSeparator) : n[i] = bg(a, t, t.types[i]);
  return t.sort === !1 ? n : (t.sort === !0 ? Object.keys(n).sort() : Object.keys(n).sort(t.sort)).reduce((i, a) => {
    const o = n[a];
    return i[a] = o && typeof o == "object" && !Array.isArray(o) ? Q6(o) : o, i;
  }, /* @__PURE__ */ Object.create(null));
}
function Y6(e, t) {
  if (!e)
    return "";
  t = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...t
  }, W6(t.arrayFormatSeparator);
  const r = (o) => t.skipNull && EQ(e[o]) || t.skipEmptyString && e[o] === "", n = AQ(t), i = {};
  for (const [o, s] of Object.entries(e))
    r(o) || (i[o] = s);
  const a = Object.keys(i);
  return t.sort !== !1 && a.sort(t.sort), a.map((o) => {
    const s = e[o];
    return s === void 0 ? "" : s === null ? Jt(o, t) : Array.isArray(s) ? s.length === 0 && t.arrayFormat === "bracket-separator" ? Jt(o, t) + "[]" : s.reduce(n(o), []).join("&") : Jt(o, t) + "=" + Jt(s, t);
  }).filter((o) => o.length > 0).join("&");
}
function K6(e, t) {
  t = {
    decode: !0,
    ...t
  };
  let [r, n] = H6(e, "#");
  return r === void 0 && (r = e), {
    url: r?.split("?")?.[0] ?? "",
    query: Xf(Zf(e), t),
    ...t && t.parseFragmentIdentifier && n ? { fragmentIdentifier: mi(n, t) } : {}
  };
}
function Z6(e, t) {
  t = {
    encode: !0,
    strict: !0,
    [_h]: !0,
    ...t
  };
  const r = G6(e.url).split("?")[0] || "", n = Zf(e.url), i = {
    ...Xf(n, { sort: !1 }),
    ...e.query
  };
  let a = Y6(i, t);
  a &&= `?${a}`;
  let o = IQ(e.url);
  if (typeof e.fragmentIdentifier == "string") {
    const s = new URL(r);
    s.hash = e.fragmentIdentifier, o = t[_h] ? s.hash : `#${e.fragmentIdentifier}`;
  }
  return `${r}${a}${o}`;
}
function X6(e, t, r) {
  r = {
    parseFragmentIdentifier: !0,
    [_h]: !1,
    ...r
  };
  const { url: n, query: i, fragmentIdentifier: a } = K6(e, r);
  return Z6({
    url: n,
    query: SQ(i, t),
    fragmentIdentifier: a
  }, r);
}
function PQ(e, t, r) {
  const n = Array.isArray(t) ? (i) => !t.includes(i) : (i, a) => !t(i, a);
  return X6(e, n, r);
}
const J6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude: PQ,
  extract: Zf,
  parse: Xf,
  parseUrl: K6,
  pick: X6,
  stringify: Y6,
  stringifyUrl: Z6
}, Symbol.toStringTag, { value: "Module" })), DQ = (e = window.location.search) => {
  if (!e)
    return !1;
  const t = J6.parse(e);
  return "state" in t && "photon" in t && ("code" in t || "error" in t);
}, MQ = (e) => /^\d+$/.test(e) && e.length >= 5;
function Ch(e, t) {
  return e.every((r) => t.includes(r));
}
const NQ = "0.17.6", LQ = {
  version: NQ
};
var FQ = /* @__PURE__ */ K("<slot>"), RQ = /* @__PURE__ */ K("<div>");
const zQ = LQ?.version, jQ = (e) => {
  let t;
  const r = e.redirectUri ? e.redirectUri : window.location.origin, n = J6.stringifyUrl({
    url: r,
    query: {
      photon: !0
    }
  }), i = new Hk({
    env: e.env,
    domain: e.domain,
    audience: e.audience,
    connection: e.connection,
    uri: e.uri,
    clientId: e.id,
    redirectURI: n,
    organization: e.org,
    developmentMode: e.developmentMode
  }, zQ), a = new wQ(i, e.autoLogin);
  e.developmentMode && console.info("[PhotonClient]: Development mode enabled");
  const [o] = H(a), s = async () => {
    await o()?.authentication.handleRedirect(), e.redirectPath && window.location.replace(e.redirectPath);
  }, l = async () => {
    await o()?.authentication.checkSession(), xQ(async () => {
      await o()?.authentication.checkSession();
    }, 6e4, setInterval);
  };
  return me(() => {
    DQ() && o() ? s() : o() && l();
  }), me(() => {
    if (!o()?.authentication.state.isLoading) {
      if (!o()?.authentication.state.isAuthenticated && e.autoLogin) {
        const d = {
          appState: {}
        };
        e.redirectPath && (d.appState.returnTo = e.redirectPath), o()?.authentication.login(d);
      } else if (
        // If `externalUserId` is set, then we check if it matches the logged in user
        // If it doesn't match then logout and then immediately log back in if possible
        e.externalUserId != null && // Note that we check the last piece of the `sub` which is the id from the auth provider
        // We do an exact match on this last section because ids are not guaranteed to not be substrings of the other
        o().authentication.state.user?.sub?.split("|").reverse()[0] !== e.externalUserId
      ) {
        o()?.authentication.logout();
        const d = {
          appState: {}
        };
        e.redirectPath && (d.appState.returnTo = e.redirectPath), o()?.authentication.login(d);
      }
    }
  }), (() => {
    var d = RQ(), u = t;
    return typeof u == "function" ? ze(u, d) : t = d, A(d, b(q6.Provider, {
      get value() {
        return o();
      },
      get children() {
        return b(eB, {
          get children() {
            return b(DR, {
              client: i,
              get children() {
                var c = FQ();
                return c._$owner = fe(), c;
              }
            });
          }
        });
      }
    })), d;
  })();
};
Tt("photon-client", {
  domain: {
    attribute: "domain",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  id: {
    attribute: "id",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  redirectUri: {
    attribute: "redirect-uri",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  org: {
    attribute: "org",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  audience: {
    attribute: "audience",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  connection: {
    attribute: "connection",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  uri: {
    attribute: "uri",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  developmentMode: {
    attribute: "dev-mode",
    value: !1,
    reflect: !0,
    notify: !1,
    parse: !0
  },
  errorMessage: {
    attribute: "error-message",
    value: "Oh snap! There was an error loading. Please contact your site's administrator",
    reflect: !1,
    notify: !1,
    parse: !1
  },
  autoLogin: {
    attribute: "auto-login",
    value: !1,
    reflect: !1,
    notify: !1,
    parse: !0
  },
  env: {
    attribute: "env",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  externalUserId: {
    attribute: "user-id",
    value: void 0,
    reflect: !0,
    notify: !0,
    parse: !1
  }
}, jQ);
const Rt = '*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.container{width:100%}@media (min-width: 475px){.container{max-width:475px}}@media (min-width: 640px){.container{max-width:640px}}@media (min-width: 768px){.container{max-width:768px}}@media (min-width: 1024px){.container{max-width:1024px}}@media (min-width: 1280px){.container{max-width:1280px}}@media (min-width: 1536px){.container{max-width:1536px}}.visible{visibility:visible}.fixed{position:fixed}.relative{position:relative}.sticky{position:sticky}.bottom-0{bottom:0}.left-0{left:0}.top-0{top:0}.z-2000{z-index:2000}.z-30{z-index:30}.z-40{z-index:40}.z-50{z-index:50}.order-last{order:9999}.m-0{margin:0}.m-3{margin:.75rem}.my-1{margin-top:.25rem;margin-bottom:.25rem}.mb-1{margin-bottom:.25rem}.mb-2{margin-bottom:.5rem}.mb-3{margin-bottom:.75rem}.mb-4{margin-bottom:1rem}.mb-8{margin-bottom:2rem}.ml-1{margin-left:.25rem}.mr-1{margin-right:.25rem}.mt-0{margin-top:0}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-5{margin-top:1.25rem}.mt-6{margin-top:1.5rem}.mt-8{margin-top:2rem}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.hidden{display:none}.h-10{height:2.5rem}.h-\\[21px\\]{height:21px}.h-\\[28px\\]{height:28px}.h-fit{height:-moz-fit-content;height:fit-content}.h-full{height:100%}.h-screen{height:100vh}.min-h-screen{min-height:100vh}.w-2\\/5{width:40%}.w-\\[44px\\]{width:44px}.w-fit{width:-moz-fit-content;width:fit-content}.w-full{width:100%}.w-screen{width:100vw}.min-w-0{min-width:0px}.min-w-\\[40\\%\\]{min-width:40%}.max-w-sm{max-width:24rem}.flex-1{flex:1 1 0%}.flex-shrink{flex-shrink:1}.flex-shrink-0{flex-shrink:0}.flex-grow{flex-grow:1}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.items-stretch{align-items:stretch}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.gap-4{gap:1rem}.gap-8{gap:2rem}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * (1 - var(--tw-space-x-reverse)))}.self-start{align-self:flex-start}.overflow-hidden{overflow:hidden}.overflow-y-auto{overflow-y:auto}.overflow-x-hidden{overflow-x:hidden}.overflow-y-scroll{overflow-y:scroll}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.overflow-ellipsis{text-overflow:ellipsis}.whitespace-normal{white-space:normal}.whitespace-nowrap{white-space:nowrap}.break-words{overflow-wrap:break-word}.rounded{border-radius:.25rem}.rounded-lg{border-radius:.5rem}.border{border-width:1px}.border-2{border-width:2px}.border-none{border-style:none}.border-gray-200{--tw-border-opacity: 1;border-color:rgb(229,231,235,var(--tw-border-opacity))}.border-red-400{--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity))}.bg-\\[\\#F9FAFB\\]{--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.bg-blue-500{--tw-bg-opacity: 1;background-color:rgb(21,112,239,var(--tw-bg-opacity))}.bg-photon-blue{--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity))}.bg-red-100{--tw-bg-opacity: 1;background-color:rgb(254,226,226,var(--tw-bg-opacity))}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255,255,255,var(--tw-bg-opacity))}.p-0{padding:0}.p-4{padding:1rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-4{padding-left:1rem;padding-right:1rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pb-2{padding-bottom:.5rem}.pb-4{padding-bottom:1rem}.pb-40{padding-bottom:10rem}.pl-1{padding-left:.25rem}.pl-2{padding-left:.5rem}.pl-5{padding-left:1.25rem}.pl-\\[19\\.75px\\]{padding-left:19.75px}.pr-2{padding-right:.5rem}.pr-5{padding-right:1.25rem}.pt-1{padding-top:.25rem}.pt-14{padding-top:3.5rem}.pt-3{padding-top:.75rem}.text-center{text-align:center}.font-sans{font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}.text-3xl{font-size:1.875rem;line-height:2.25rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-bold{font-weight:700}.font-extrabold{font-weight:800}.font-light{font-weight:300}.font-medium{font-weight:500}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.italic{font-style:italic}.leading-snug{line-height:1.375}.text-black{--tw-text-opacity: 1;color:rgb(0,0,0,var(--tw-text-opacity))}.text-blue-600{--tw-text-opacity: 1;color:rgb(23,92,211,var(--tw-text-opacity))}.text-gray-400{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.text-gray-500{--tw-text-opacity: 1;color:rgb(107,114,128,var(--tw-text-opacity))}.text-gray-600{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}.text-gray-700{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.text-red-400{--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}.text-red-500{--tw-text-opacity: 1;color:rgb(239,68,68,var(--tw-text-opacity))}.text-red-700{--tw-text-opacity: 1;color:rgb(185,28,28,var(--tw-text-opacity))}.text-slate-500{--tw-text-opacity: 1;color:rgb(100,116,139,var(--tw-text-opacity))}.text-teal-600{--tw-text-opacity: 1;color:rgb(13,148,136,var(--tw-text-opacity))}.text-white{--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.opacity-50{opacity:.5}.shadow-card{--tw-shadow: 0px 0px 1px rgba(48, 49, 51, .05),0px 2px 4px rgba(48, 49, 51, .1);--tw-shadow-colored: 0px 0px 1px var(--tw-shadow-color), 0px 2px 4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.hover\\:cursor-pointer:hover{cursor:pointer}.hover\\:bg-blue-700:hover{--tw-bg-opacity: 1;background-color:rgb(24,73,169,var(--tw-bg-opacity))}.hover\\:bg-photon-blue-dark:hover{--tw-bg-opacity: 1;background-color:rgb(43,108,176,var(--tw-bg-opacity))}.hover\\:text-gray-600:hover{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}.hover\\:underline:hover{text-decoration-line:underline}.disabled\\:bg-gray-500:disabled{--tw-bg-opacity: 1;background-color:rgb(107,114,128,var(--tw-bg-opacity))}@media (min-width: 475px){.xs\\:mx-auto{margin-left:auto;margin-right:auto}.xs\\:\\!w-auto{width:auto!important}.xs\\:w-fit{width:-moz-fit-content;width:fit-content}.xs\\:flex-row{flex-direction:row}.xs\\:flex-row-reverse{flex-direction:row-reverse}.xs\\:justify-start{justify-content:flex-start}.xs\\:text-base{font-size:1rem;line-height:1.5rem}}@media (min-width: 640px){.sm\\:order-first{order:-9999}.sm\\:mt-0{margin-top:0}.sm\\:inline{display:inline}.sm\\:grid{display:grid}.sm\\:w-\\[600px\\]{width:600px}.sm\\:w-auto{width:auto}.sm\\:flex-none{flex:none}.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:gap-3{gap:.75rem}.sm\\:gap-4{gap:1rem}.sm\\:px-4{padding-left:1rem;padding-right:1rem}.sm\\:py-2{padding-top:.5rem;padding-bottom:.5rem}}@media (min-width: 768px){.md\\:flex{display:flex}.md\\:px-4{padding-left:1rem;padding-right:1rem}.md\\:px-8{padding-left:2rem;padding-right:2rem}.md\\:py-2{padding-top:.5rem;padding-bottom:.5rem}.md\\:py-3{padding-top:.75rem;padding-bottom:.75rem}.md\\:pb-52{padding-bottom:13rem}.md\\:pr-2{padding-right:.5rem}.md\\:pt-4{padding-top:1rem}.md\\:text-3xl{font-size:1.875rem;line-height:2.25rem}.md\\:text-xl{font-size:1.25rem;line-height:1.75rem}}';
var VQ = /* @__PURE__ */ K("<style>"), UQ = /* @__PURE__ */ K('<button class="w-full disabled:bg-gray-500 bg-photon-blue hover:bg-blue-700 text-white h-10 px-4 rounded-lg font-sans hover:bg-photon-blue-dark transition ease-in-out delay-50">');
const qQ = (e) => {
  const t = Xr();
  return me(() => {
    t || console.error("[photon-auth-button] No valid PhotonClient instance was provided. Please ensure you are wrapping the element in a photon-client element");
  }), [(() => {
    var r = VQ();
    return A(r, Rt), r;
  })(), t ? (() => {
    var r = UQ();
    return r.$$click = async () => {
      const n = {
        appState: {}
      };
      e.redirectPath && (n.appState.returnTo = e.redirectPath), t.authentication.state.isAuthenticated ? await t.authentication.logout() : await t.authentication.login(n);
    }, A(r, () => t.authentication.state.isAuthenticated ? "Log out" : "Log in"), J(() => r.disabled = t.authentication.state.isLoading), r;
  })() : null];
};
Tt("photon-auth-button", {
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  }
}, qQ);
da(["click"]);
var BQ = /* @__PURE__ */ K("<style>"), HQ = /* @__PURE__ */ K(`<div class="flex flex-col w-screen max-w-sm"><svg viewBox="0 0 305 62.61"xmlns=http://www.w3.org/2000/svg class="h-[28px] pl-[19.75px]"><g fill=#273D52><path d="M0 54.1169H6.81375V35.7722H18.0826C29.5481 35.7722 34.3963 30.3343 34.3963 18.7378V17.4275C34.3963 5.76548 29.417 0.655167 18.0826 0.655167H0V54.1169ZM6.81375 30.1377V6.28961H18.2792C24.7653 6.28961 27.386 8.9758 27.386 16.0516V20.0481C27.386 27.1895 24.7653 30.1377 18.2792 30.1377H6.81375Z"></path><path d="M70.9593 54.1169H77.773V0.655167H70.9593V24.4378H50.8456V0.655167H44.0319V54.1169H50.8456V30.3343H70.9593V54.1169Z"></path><path d="M107.146 54.772C119.528 54.772 125.687 46.5169 125.687 34.9205V19.7861C125.687 8.25511 119.528 0 107.146 0C94.6974 0 88.5388 8.25511 88.5388 19.7861V34.9205C88.5388 46.5169 94.6974 54.772 107.146 54.772ZM95.5491 35.9687V18.8033C95.5491 10.7448 99.4801 5.89651 107.146 5.89651C114.745 5.89651 118.677 10.7448 118.677 18.8033V35.9687C118.677 44.0928 114.745 48.8755 107.146 48.8755C99.4801 48.8755 95.5491 44.0928 95.5491 35.9687Z"></path><path d="M144.295 54.1169H151.109V6.48616H164.54V0.655167H130.864V6.48616H144.295V54.1169Z"></path><path d="M188.299 54.772C200.682 54.772 206.841 46.5169 206.841 34.9205V19.7861C206.841 8.25511 200.682 0 188.299 0C175.851 0 169.693 8.25511 169.693 19.7861V34.9205C169.693 46.5169 175.851 54.772 188.299 54.772ZM176.703 35.9687V18.8033C176.703 10.7448 180.634 5.89651 188.299 5.89651C195.899 5.89651 199.83 10.7448 199.83 18.8033V35.9687C199.83 44.0928 195.899 48.8755 188.299 48.8755C180.634 48.8755 176.703 44.0928 176.703 35.9687Z"></path><path d="M217.6 54.1169H224.021V14.3482L245.576 54.1169H252.608L248.058 45.1084L245.641 40.4239L224.086 0.655167H217.6V54.1169Z"></path></g><g fill=#B35724><circle cx=249.798 cy=5.202 r=5.202></circle></g></svg><h1 class="font-medium text-3xl text-center font-sans mt-6 mb-3">Log in to your account</h1><p class="text-gray-500 font-sans text-center mb-8">Don't have an account? <a href=mailto:support@photon.health class="text-teal-600 hover:underline hover:cursor-pointer font-sans font-light">Contact Support</a></p><photon-auth-button>`, !0, !1, !1);
const WQ = (e) => {
  const t = Xr();
  return me(() => {
    t || console.error("[photon-login] No valid PhotonClient instance was provided. Please ensure you are wrapping the element in a photon-client element");
  }), [(() => {
    var r = BQ();
    return A(r, Rt), r;
  })(), (() => {
    var r = HQ(), n = r.firstChild, i = n.nextSibling, a = i.nextSibling, o = a.nextSibling;
    return o._$owner = fe(), J(() => o.redirectPath = e.redirectPath), r;
  })()];
};
Tt("photon-login", {
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  }
}, WQ);
const $d = (e, t) => {
  let r;
  const n = () => clearTimeout(r);
  return fe() && xr(n), Object.assign((...a) => {
    r !== void 0 && n(), r = setTimeout(() => e(...a), t);
  }, { clear: n });
};
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Cu = globalThis, Jf = Cu.ShadowRoot && (Cu.ShadyCSS === void 0 || Cu.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, ep = Symbol(), $g = /* @__PURE__ */ new WeakMap();
let e8 = class {
  constructor(t, r, n) {
    if (this._$cssResult$ = !0, n !== ep) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = r;
  }
  get styleSheet() {
    let t = this.o;
    const r = this.t;
    if (Jf && t === void 0) {
      const n = r !== void 0 && r.length === 1;
      n && (t = $g.get(r)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), n && $g.set(r, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const QQ = (e) => new e8(typeof e == "string" ? e : e + "", void 0, ep), gr = (e, ...t) => {
  const r = e.length === 1 ? e[0] : t.reduce((n, i, a) => n + ((o) => {
    if (o._$cssResult$ === !0) return o.cssText;
    if (typeof o == "number") return o;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + o + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + e[a + 1], e[0]);
  return new e8(r, e, ep);
}, GQ = (e, t) => {
  if (Jf) e.adoptedStyleSheets = t.map((r) => r instanceof CSSStyleSheet ? r : r.styleSheet);
  else for (const r of t) {
    const n = document.createElement("style"), i = Cu.litNonce;
    i !== void 0 && n.setAttribute("nonce", i), n.textContent = r.cssText, e.appendChild(n);
  }
}, wg = Jf ? (e) => e : (e) => e instanceof CSSStyleSheet ? ((t) => {
  let r = "";
  for (const n of t.cssRules) r += n.cssText;
  return QQ(r);
})(e) : e;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: YQ, defineProperty: KQ, getOwnPropertyDescriptor: ZQ, getOwnPropertyNames: XQ, getOwnPropertySymbols: JQ, getPrototypeOf: eG } = Object, t0 = globalThis, xg = t0.trustedTypes, tG = xg ? xg.emptyScript : "", rG = t0.reactiveElementPolyfillSupport, Il = (e, t) => e, gs = { toAttribute(e, t) {
  switch (t) {
    case Boolean:
      e = e ? tG : null;
      break;
    case Object:
    case Array:
      e = e == null ? e : JSON.stringify(e);
  }
  return e;
}, fromAttribute(e, t) {
  let r = e;
  switch (t) {
    case Boolean:
      r = e !== null;
      break;
    case Number:
      r = e === null ? null : Number(e);
      break;
    case Object:
    case Array:
      try {
        r = JSON.parse(e);
      } catch {
        r = null;
      }
  }
  return r;
} }, tp = (e, t) => !YQ(e, t), kg = { attribute: !0, type: String, converter: gs, reflect: !1, hasChanged: tp };
Symbol.metadata ??= Symbol("metadata"), t0.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
class Ao extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ??= []).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, r = kg) {
    if (r.state && (r.attribute = !1), this._$Ei(), this.elementProperties.set(t, r), !r.noAccessor) {
      const n = Symbol(), i = this.getPropertyDescriptor(t, n, r);
      i !== void 0 && KQ(this.prototype, t, i);
    }
  }
  static getPropertyDescriptor(t, r, n) {
    const { get: i, set: a } = ZQ(this.prototype, t) ?? { get() {
      return this[r];
    }, set(o) {
      this[r] = o;
    } };
    return { get() {
      return i?.call(this);
    }, set(o) {
      const s = i?.call(this);
      a.call(this, o), this.requestUpdate(t, s, n);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? kg;
  }
  static _$Ei() {
    if (this.hasOwnProperty(Il("elementProperties"))) return;
    const t = eG(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(Il("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(Il("properties"))) {
      const r = this.properties, n = [...XQ(r), ...JQ(r)];
      for (const i of n) this.createProperty(i, r[i]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const r = litPropertyMetadata.get(t);
      if (r !== void 0) for (const [n, i] of r) this.elementProperties.set(n, i);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [r, n] of this.elementProperties) {
      const i = this._$Eu(r, n);
      i !== void 0 && this._$Eh.set(i, r);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const r = [];
    if (Array.isArray(t)) {
      const n = new Set(t.flat(1 / 0).reverse());
      for (const i of n) r.unshift(wg(i));
    } else t !== void 0 && r.push(wg(t));
    return r;
  }
  static _$Eu(t, r) {
    const n = r.attribute;
    return n === !1 ? void 0 : typeof n == "string" ? n : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise((t) => this.enableUpdating = t), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t) => t(this));
  }
  addController(t) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(t), this.renderRoot !== void 0 && this.isConnected && t.hostConnected?.();
  }
  removeController(t) {
    this._$EO?.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), r = this.constructor.elementProperties;
    for (const n of r.keys()) this.hasOwnProperty(n) && (t.set(n, this[n]), delete this[n]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return GQ(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t) => t.hostConnected?.());
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    this._$EO?.forEach((t) => t.hostDisconnected?.());
  }
  attributeChangedCallback(t, r, n) {
    this._$AK(t, n);
  }
  _$EC(t, r) {
    const n = this.constructor.elementProperties.get(t), i = this.constructor._$Eu(t, n);
    if (i !== void 0 && n.reflect === !0) {
      const a = (n.converter?.toAttribute !== void 0 ? n.converter : gs).toAttribute(r, n.type);
      this._$Em = t, a == null ? this.removeAttribute(i) : this.setAttribute(i, a), this._$Em = null;
    }
  }
  _$AK(t, r) {
    const n = this.constructor, i = n._$Eh.get(t);
    if (i !== void 0 && this._$Em !== i) {
      const a = n.getPropertyOptions(i), o = typeof a.converter == "function" ? { fromAttribute: a.converter } : a.converter?.fromAttribute !== void 0 ? a.converter : gs;
      this._$Em = i, this[i] = o.fromAttribute(r, a.type), this._$Em = null;
    }
  }
  requestUpdate(t, r, n) {
    if (t !== void 0) {
      if (n ??= this.constructor.getPropertyOptions(t), !(n.hasChanged ?? tp)(this[t], r)) return;
      this.P(t, r, n);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(t, r, n) {
    this._$AL.has(t) || this._$AL.set(t, r), n.reflect === !0 && this._$Em !== t && (this._$Ej ??= /* @__PURE__ */ new Set()).add(t);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (r) {
      Promise.reject(r);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [i, a] of this._$Ep) this[i] = a;
        this._$Ep = void 0;
      }
      const n = this.constructor.elementProperties;
      if (n.size > 0) for (const [i, a] of n) a.wrapped !== !0 || this._$AL.has(i) || this[i] === void 0 || this.P(i, this[i], a);
    }
    let t = !1;
    const r = this._$AL;
    try {
      t = this.shouldUpdate(r), t ? (this.willUpdate(r), this._$EO?.forEach((n) => n.hostUpdate?.()), this.update(r)) : this._$EU();
    } catch (n) {
      throw t = !1, this._$EU(), n;
    }
    t && this._$AE(r);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    this._$EO?.forEach((r) => r.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Ej &&= this._$Ej.forEach((r) => this._$EC(r, this[r])), this._$EU();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
}
Ao.elementStyles = [], Ao.shadowRootOptions = { mode: "open" }, Ao[Il("elementProperties")] = /* @__PURE__ */ new Map(), Ao[Il("finalized")] = /* @__PURE__ */ new Map(), rG?.({ ReactiveElement: Ao }), (t0.reactiveElementVersions ??= []).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const rp = globalThis, hc = rp.trustedTypes, _g = hc ? hc.createPolicy("lit-html", { createHTML: (e) => e }) : void 0, t8 = "$lit$", Bi = `lit$${Math.random().toFixed(9).slice(2)}$`, r8 = "?" + Bi, nG = `<${r8}>`, Za = document, Xl = () => Za.createComment(""), Jl = (e) => e === null || typeof e != "object" && typeof e != "function", np = Array.isArray, iG = (e) => np(e) || typeof e?.[Symbol.iterator] == "function", $1 = `[ 	
\f\r]`, il = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, Cg = /-->/g, Sg = />/g, va = RegExp(`>|${$1}(?:([^\\s"'>=/]+)(${$1}*=${$1}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), Eg = /'/g, Tg = /"/g, n8 = /^(?:script|style|textarea|title)$/i, aG = (e) => (t, ...r) => ({ _$litType$: e, strings: t, values: r }), xt = aG(1), Tn = Symbol.for("lit-noChange"), Bt = Symbol.for("lit-nothing"), Ag = /* @__PURE__ */ new WeakMap(), Ra = Za.createTreeWalker(Za, 129);
function i8(e, t) {
  if (!np(e) || !e.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return _g !== void 0 ? _g.createHTML(t) : t;
}
const oG = (e, t) => {
  const r = e.length - 1, n = [];
  let i, a = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", o = il;
  for (let s = 0; s < r; s++) {
    const l = e[s];
    let d, u, c = -1, h = 0;
    for (; h < l.length && (o.lastIndex = h, u = o.exec(l), u !== null); ) h = o.lastIndex, o === il ? u[1] === "!--" ? o = Cg : u[1] !== void 0 ? o = Sg : u[2] !== void 0 ? (n8.test(u[2]) && (i = RegExp("</" + u[2], "g")), o = va) : u[3] !== void 0 && (o = va) : o === va ? u[0] === ">" ? (o = i ?? il, c = -1) : u[1] === void 0 ? c = -2 : (c = o.lastIndex - u[2].length, d = u[1], o = u[3] === void 0 ? va : u[3] === '"' ? Tg : Eg) : o === Tg || o === Eg ? o = va : o === Cg || o === Sg ? o = il : (o = va, i = void 0);
    const f = o === va && e[s + 1].startsWith("/>") ? " " : "";
    a += o === il ? l + nG : c >= 0 ? (n.push(d), l.slice(0, c) + t8 + l.slice(c) + Bi + f) : l + Bi + (c === -2 ? s : f);
  }
  return [i8(e, a + (e[r] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), n];
};
class ed {
  constructor({ strings: t, _$litType$: r }, n) {
    let i;
    this.parts = [];
    let a = 0, o = 0;
    const s = t.length - 1, l = this.parts, [d, u] = oG(t, r);
    if (this.el = ed.createElement(d, n), Ra.currentNode = this.el.content, r === 2 || r === 3) {
      const c = this.el.content.firstChild;
      c.replaceWith(...c.childNodes);
    }
    for (; (i = Ra.nextNode()) !== null && l.length < s; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes()) for (const c of i.getAttributeNames()) if (c.endsWith(t8)) {
          const h = u[o++], f = i.getAttribute(c).split(Bi), p = /([.?@])?(.*)/.exec(h);
          l.push({ type: 1, index: a, name: p[2], strings: f, ctor: p[1] === "." ? lG : p[1] === "?" ? dG : p[1] === "@" ? uG : r0 }), i.removeAttribute(c);
        } else c.startsWith(Bi) && (l.push({ type: 6, index: a }), i.removeAttribute(c));
        if (n8.test(i.tagName)) {
          const c = i.textContent.split(Bi), h = c.length - 1;
          if (h > 0) {
            i.textContent = hc ? hc.emptyScript : "";
            for (let f = 0; f < h; f++) i.append(c[f], Xl()), Ra.nextNode(), l.push({ type: 2, index: ++a });
            i.append(c[h], Xl());
          }
        }
      } else if (i.nodeType === 8) if (i.data === r8) l.push({ type: 2, index: a });
      else {
        let c = -1;
        for (; (c = i.data.indexOf(Bi, c + 1)) !== -1; ) l.push({ type: 7, index: a }), c += Bi.length - 1;
      }
      a++;
    }
  }
  static createElement(t, r) {
    const n = Za.createElement("template");
    return n.innerHTML = t, n;
  }
}
function vs(e, t, r = e, n) {
  if (t === Tn) return t;
  let i = n !== void 0 ? r._$Co?.[n] : r._$Cl;
  const a = Jl(t) ? void 0 : t._$litDirective$;
  return i?.constructor !== a && (i?._$AO?.(!1), a === void 0 ? i = void 0 : (i = new a(e), i._$AT(e, r, n)), n !== void 0 ? (r._$Co ??= [])[n] = i : r._$Cl = i), i !== void 0 && (t = vs(e, i._$AS(e, t.values), i, n)), t;
}
class sG {
  constructor(t, r) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = r;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: r }, parts: n } = this._$AD, i = (t?.creationScope ?? Za).importNode(r, !0);
    Ra.currentNode = i;
    let a = Ra.nextNode(), o = 0, s = 0, l = n[0];
    for (; l !== void 0; ) {
      if (o === l.index) {
        let d;
        l.type === 2 ? d = new wd(a, a.nextSibling, this, t) : l.type === 1 ? d = new l.ctor(a, l.name, l.strings, this, t) : l.type === 6 && (d = new cG(a, this, t)), this._$AV.push(d), l = n[++s];
      }
      o !== l?.index && (a = Ra.nextNode(), o++);
    }
    return Ra.currentNode = Za, i;
  }
  p(t) {
    let r = 0;
    for (const n of this._$AV) n !== void 0 && (n.strings !== void 0 ? (n._$AI(t, n, r), r += n.strings.length - 2) : n._$AI(t[r])), r++;
  }
}
class wd {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(t, r, n, i) {
    this.type = 2, this._$AH = Bt, this._$AN = void 0, this._$AA = t, this._$AB = r, this._$AM = n, this.options = i, this._$Cv = i?.isConnected ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const r = this._$AM;
    return r !== void 0 && t?.nodeType === 11 && (t = r.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, r = this) {
    t = vs(this, t, r), Jl(t) ? t === Bt || t == null || t === "" ? (this._$AH !== Bt && this._$AR(), this._$AH = Bt) : t !== this._$AH && t !== Tn && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : iG(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== Bt && Jl(this._$AH) ? this._$AA.nextSibling.data = t : this.T(Za.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    const { values: r, _$litType$: n } = t, i = typeof n == "number" ? this._$AC(t) : (n.el === void 0 && (n.el = ed.createElement(i8(n.h, n.h[0]), this.options)), n);
    if (this._$AH?._$AD === i) this._$AH.p(r);
    else {
      const a = new sG(i, this), o = a.u(this.options);
      a.p(r), this.T(o), this._$AH = a;
    }
  }
  _$AC(t) {
    let r = Ag.get(t.strings);
    return r === void 0 && Ag.set(t.strings, r = new ed(t)), r;
  }
  k(t) {
    np(this._$AH) || (this._$AH = [], this._$AR());
    const r = this._$AH;
    let n, i = 0;
    for (const a of t) i === r.length ? r.push(n = new wd(this.O(Xl()), this.O(Xl()), this, this.options)) : n = r[i], n._$AI(a), i++;
    i < r.length && (this._$AR(n && n._$AB.nextSibling, i), r.length = i);
  }
  _$AR(t = this._$AA.nextSibling, r) {
    for (this._$AP?.(!1, !0, r); t && t !== this._$AB; ) {
      const n = t.nextSibling;
      t.remove(), t = n;
    }
  }
  setConnected(t) {
    this._$AM === void 0 && (this._$Cv = t, this._$AP?.(t));
  }
}
class r0 {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, r, n, i, a) {
    this.type = 1, this._$AH = Bt, this._$AN = void 0, this.element = t, this.name = r, this._$AM = i, this.options = a, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(new String()), this.strings = n) : this._$AH = Bt;
  }
  _$AI(t, r = this, n, i) {
    const a = this.strings;
    let o = !1;
    if (a === void 0) t = vs(this, t, r, 0), o = !Jl(t) || t !== this._$AH && t !== Tn, o && (this._$AH = t);
    else {
      const s = t;
      let l, d;
      for (t = a[0], l = 0; l < a.length - 1; l++) d = vs(this, s[n + l], r, l), d === Tn && (d = this._$AH[l]), o ||= !Jl(d) || d !== this._$AH[l], d === Bt ? t = Bt : t !== Bt && (t += (d ?? "") + a[l + 1]), this._$AH[l] = d;
    }
    o && !i && this.j(t);
  }
  j(t) {
    t === Bt ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}
class lG extends r0 {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === Bt ? void 0 : t;
  }
}
class dG extends r0 {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== Bt);
  }
}
class uG extends r0 {
  constructor(t, r, n, i, a) {
    super(t, r, n, i, a), this.type = 5;
  }
  _$AI(t, r = this) {
    if ((t = vs(this, t, r, 0) ?? Bt) === Tn) return;
    const n = this._$AH, i = t === Bt && n !== Bt || t.capture !== n.capture || t.once !== n.once || t.passive !== n.passive, a = t !== Bt && (n === Bt || i);
    i && this.element.removeEventListener(this.name, this, n), a && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    typeof this._$AH == "function" ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
  }
}
class cG {
  constructor(t, r, n) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = r, this.options = n;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    vs(this, t);
  }
}
const hG = rp.litHtmlPolyfillSupport;
hG?.(ed, wd), (rp.litHtmlVersions ??= []).push("3.2.1");
const fG = (e, t, r) => {
  const n = r?.renderBefore ?? t;
  let i = n._$litPart$;
  if (i === void 0) {
    const a = r?.renderBefore ?? null;
    n._$litPart$ = i = new wd(t.insertBefore(Xl(), a), a, void 0, r ?? {});
  }
  return i._$AI(e), i;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let Pl = class extends Ao {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const t = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= t.firstChild, t;
  }
  update(t) {
    const r = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = fG(r, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(!0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(!1);
  }
  render() {
    return Tn;
  }
};
Pl._$litElement$ = !0, Pl.finalized = !0, globalThis.litElementHydrateSupport?.({ LitElement: Pl });
const pG = globalThis.litElementPolyfillSupport;
pG?.({ LitElement: Pl });
(globalThis.litElementVersions ??= []).push("4.1.1");
var mG = gr`
  :host {
    display: inline-block;
  }

  .dropdown::part(popup) {
    z-index: var(--sl-z-index-dropdown);
  }

  .dropdown[data-current-placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .dropdown[data-current-placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .dropdown[data-current-placement^='left']::part(popup) {
    transform-origin: right;
  }

  .dropdown[data-current-placement^='right']::part(popup) {
    transform-origin: left;
  }

  .dropdown__trigger {
    display: block;
  }

  .dropdown__panel {
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    box-shadow: var(--sl-shadow-large);
    border-radius: var(--sl-border-radius-medium);
    pointer-events: none;
  }

  .dropdown--open .dropdown__panel {
    display: block;
    pointer-events: all;
  }

  /* When users slot a menu, make sure it conforms to the popup's auto-size */
  ::slotted(sl-menu) {
    max-width: var(--auto-size-available-width) !important;
    max-height: var(--auto-size-available-height) !important;
  }
`, a8 = Object.defineProperty, gG = Object.defineProperties, vG = Object.getOwnPropertyDescriptor, yG = Object.getOwnPropertyDescriptors, Og = Object.getOwnPropertySymbols, bG = Object.prototype.hasOwnProperty, $G = Object.prototype.propertyIsEnumerable, w1 = (e, t) => (t = Symbol[e]) ? t : Symbol.for("Symbol." + e), ip = (e) => {
  throw TypeError(e);
}, Ig = (e, t, r) => t in e ? a8(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, so = (e, t) => {
  for (var r in t || (t = {}))
    bG.call(t, r) && Ig(e, r, t[r]);
  if (Og)
    for (var r of Og(t))
      $G.call(t, r) && Ig(e, r, t[r]);
  return e;
}, n0 = (e, t) => gG(e, yG(t)), O = (e, t, r, n) => {
  for (var i = n > 1 ? void 0 : n ? vG(t, r) : t, a = e.length - 1, o; a >= 0; a--)
    (o = e[a]) && (i = (n ? o(t, r, i) : o(i)) || i);
  return n && i && a8(t, r, i), i;
}, o8 = (e, t, r) => t.has(e) || ip("Cannot " + r), wG = (e, t, r) => (o8(e, t, "read from private field"), t.get(e)), xG = (e, t, r) => t.has(e) ? ip("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), kG = (e, t, r, n) => (o8(e, t, "write to private field"), t.set(e, r), r), _G = function(e, t) {
  this[0] = e, this[1] = t;
}, CG = (e) => {
  var t = e[w1("asyncIterator")], r = !1, n, i = {};
  return t == null ? (t = e[w1("iterator")](), n = (a) => i[a] = (o) => t[a](o)) : (t = t.call(e), n = (a) => i[a] = (o) => {
    if (r) {
      if (r = !1, a === "throw") throw o;
      return o;
    }
    return r = !0, {
      done: !1,
      value: new _G(new Promise((s) => {
        var l = t[a](o);
        l instanceof Object || ip("Object expected"), s(l);
      }), 1)
    };
  }), i[w1("iterator")] = () => i, n("next"), "throw" in t ? n("throw") : i.throw = (a) => {
    throw a;
  }, "return" in t && n("return"), i;
};
function* ap(e = document.activeElement) {
  e != null && (yield e, "shadowRoot" in e && e.shadowRoot && e.shadowRoot.mode !== "closed" && (yield* CG(ap(e.shadowRoot.activeElement))));
}
function s8() {
  return [...ap()].pop();
}
var Pg = /* @__PURE__ */ new WeakMap();
function l8(e) {
  let t = Pg.get(e);
  return t || (t = window.getComputedStyle(e, null), Pg.set(e, t)), t;
}
function SG(e) {
  if (typeof e.checkVisibility == "function")
    return e.checkVisibility({ checkOpacity: !1, checkVisibilityCSS: !0 });
  const t = l8(e);
  return t.visibility !== "hidden" && t.display !== "none";
}
function EG(e) {
  const t = l8(e), { overflowY: r, overflowX: n } = t;
  return r === "scroll" || n === "scroll" ? !0 : r !== "auto" || n !== "auto" ? !1 : e.scrollHeight > e.clientHeight && r === "auto" || e.scrollWidth > e.clientWidth && n === "auto";
}
function TG(e) {
  const t = e.tagName.toLowerCase(), r = Number(e.getAttribute("tabindex"));
  if (e.hasAttribute("tabindex") && (isNaN(r) || r <= -1) || e.hasAttribute("disabled") || e.closest("[inert]"))
    return !1;
  if (t === "input" && e.getAttribute("type") === "radio") {
    const a = e.getRootNode(), o = `input[type='radio'][name="${e.getAttribute("name")}"]`, s = a.querySelector(`${o}:checked`);
    return s ? s === e : a.querySelector(o) === e;
  }
  return SG(e) ? (t === "audio" || t === "video") && e.hasAttribute("controls") || e.hasAttribute("tabindex") || e.hasAttribute("contenteditable") && e.getAttribute("contenteditable") !== "false" || [
    "button",
    "input",
    "select",
    "textarea",
    "a",
    "audio",
    "video",
    "summary",
    "iframe"
  ].includes(t) ? !0 : EG(e) : !1;
}
function AG(e) {
  var t, r;
  const n = Sh(e), i = (t = n[0]) != null ? t : null, a = (r = n[n.length - 1]) != null ? r : null;
  return { start: i, end: a };
}
function OG(e, t) {
  var r;
  return ((r = e.getRootNode({ composed: !0 })) == null ? void 0 : r.host) !== t;
}
function Sh(e) {
  const t = /* @__PURE__ */ new WeakMap(), r = [];
  function n(i) {
    if (i instanceof Element) {
      if (i.hasAttribute("inert") || i.closest("[inert]") || t.has(i))
        return;
      t.set(i, !0), !r.includes(i) && TG(i) && r.push(i), i instanceof HTMLSlotElement && OG(i, e) && i.assignedElements({ flatten: !0 }).forEach((a) => {
        n(a);
      }), i.shadowRoot !== null && i.shadowRoot.mode === "open" && n(i.shadowRoot);
    }
    for (const a of i.children)
      n(a);
  }
  return n(e), r.sort((i, a) => {
    const o = Number(i.getAttribute("tabindex")) || 0;
    return (Number(a.getAttribute("tabindex")) || 0) - o;
  });
}
var IG = gr`
  :host {
    --arrow-color: var(--sl-color-neutral-1000);
    --arrow-size: 6px;

    /*
     * These properties are computed to account for the arrow's dimensions after being rotated 45º. The constant
     * 0.7071 is derived from sin(45), which is the diagonal size of the arrow's container after rotating.
     */
    --arrow-size-diagonal: calc(var(--arrow-size) * 0.7071);
    --arrow-padding-offset: calc(var(--arrow-size-diagonal) - var(--arrow-size));

    display: contents;
  }

  .popup {
    position: absolute;
    isolation: isolate;
    max-width: var(--auto-size-available-width, none);
    max-height: var(--auto-size-available-height, none);
  }

  .popup--fixed {
    position: fixed;
  }

  .popup:not(.popup--active) {
    display: none;
  }

  .popup__arrow {
    position: absolute;
    width: calc(var(--arrow-size-diagonal) * 2);
    height: calc(var(--arrow-size-diagonal) * 2);
    rotate: 45deg;
    background: var(--arrow-color);
    z-index: -1;
  }

  /* Hover bridge */
  .popup-hover-bridge:not(.popup-hover-bridge--visible) {
    display: none;
  }

  .popup-hover-bridge {
    position: fixed;
    z-index: calc(var(--sl-z-index-dropdown) - 1);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--hover-bridge-top-left-x, 0) var(--hover-bridge-top-left-y, 0),
      var(--hover-bridge-top-right-x, 0) var(--hover-bridge-top-right-y, 0),
      var(--hover-bridge-bottom-right-x, 0) var(--hover-bridge-bottom-right-y, 0),
      var(--hover-bridge-bottom-left-x, 0) var(--hover-bridge-bottom-left-y, 0)
    );
  }
`;
const Eh = /* @__PURE__ */ new Set(), jo = /* @__PURE__ */ new Map();
let Pa, op = "ltr", sp = "en";
const d8 = typeof MutationObserver < "u" && typeof document < "u" && typeof document.documentElement < "u";
if (d8) {
  const e = new MutationObserver(c8);
  op = document.documentElement.dir || "ltr", sp = document.documentElement.lang || navigator.language, e.observe(document.documentElement, {
    attributes: !0,
    attributeFilter: ["dir", "lang"]
  });
}
function u8(...e) {
  e.map((t) => {
    const r = t.$code.toLowerCase();
    jo.has(r) ? jo.set(r, Object.assign(Object.assign({}, jo.get(r)), t)) : jo.set(r, t), Pa || (Pa = t);
  }), c8();
}
function c8() {
  d8 && (op = document.documentElement.dir || "ltr", sp = document.documentElement.lang || navigator.language), [...Eh.keys()].map((e) => {
    typeof e.requestUpdate == "function" && e.requestUpdate();
  });
}
let PG = class {
  constructor(t) {
    this.host = t, this.host.addController(this);
  }
  hostConnected() {
    Eh.add(this.host);
  }
  hostDisconnected() {
    Eh.delete(this.host);
  }
  dir() {
    return `${this.host.dir || op}`.toLowerCase();
  }
  lang() {
    return `${this.host.lang || sp}`.toLowerCase();
  }
  getTranslationData(t) {
    var r, n;
    const i = new Intl.Locale(t.replace(/_/g, "-")), a = i?.language.toLowerCase(), o = (n = (r = i?.region) === null || r === void 0 ? void 0 : r.toLowerCase()) !== null && n !== void 0 ? n : "", s = jo.get(`${a}-${o}`), l = jo.get(a);
    return { locale: i, language: a, region: o, primary: s, secondary: l };
  }
  exists(t, r) {
    var n;
    const { primary: i, secondary: a } = this.getTranslationData((n = r.lang) !== null && n !== void 0 ? n : this.lang());
    return r = Object.assign({ includeFallback: !1 }, r), !!(i && i[t] || a && a[t] || r.includeFallback && Pa && Pa[t]);
  }
  term(t, ...r) {
    const { primary: n, secondary: i } = this.getTranslationData(this.lang());
    let a;
    if (n && n[t])
      a = n[t];
    else if (i && i[t])
      a = i[t];
    else if (Pa && Pa[t])
      a = Pa[t];
    else
      return console.error(`No translation found for: ${String(t)}`), String(t);
    return typeof a == "function" ? a(...r) : a;
  }
  date(t, r) {
    return t = new Date(t), new Intl.DateTimeFormat(this.lang(), r).format(t);
  }
  number(t, r) {
    return t = Number(t), isNaN(t) ? "" : new Intl.NumberFormat(this.lang(), r).format(t);
  }
  relativeTime(t, r, n) {
    return new Intl.RelativeTimeFormat(this.lang(), n).format(t, r);
  }
};
var h8 = {
  $code: "en",
  $name: "English",
  $dir: "ltr",
  carousel: "Carousel",
  clearEntry: "Clear entry",
  close: "Close",
  copied: "Copied",
  copy: "Copy",
  currentValue: "Current value",
  error: "Error",
  goToSlide: (e, t) => `Go to slide ${e} of ${t}`,
  hidePassword: "Hide password",
  loading: "Loading",
  nextSlide: "Next slide",
  numOptionsSelected: (e) => e === 0 ? "No options selected" : e === 1 ? "1 option selected" : `${e} options selected`,
  previousSlide: "Previous slide",
  progress: "Progress",
  remove: "Remove",
  resize: "Resize",
  scrollToEnd: "Scroll to end",
  scrollToStart: "Scroll to start",
  selectAColorFromTheScreen: "Select a color from the screen",
  showPassword: "Show password",
  slideNum: (e) => `Slide ${e}`,
  toggleColorFormat: "Toggle color format"
};
u8(h8);
var DG = h8, Ei = class extends PG {
};
u8(DG);
var Ar = gr`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const MG = { attribute: !0, type: String, converter: gs, reflect: !1, hasChanged: tp }, NG = (e = MG, t, r) => {
  const { kind: n, metadata: i } = r;
  let a = globalThis.litPropertyMetadata.get(i);
  if (a === void 0 && globalThis.litPropertyMetadata.set(i, a = /* @__PURE__ */ new Map()), a.set(r.name, e), n === "accessor") {
    const { name: o } = r;
    return { set(s) {
      const l = t.get.call(this);
      t.set.call(this, s), this.requestUpdate(o, l, e);
    }, init(s) {
      return s !== void 0 && this.P(o, void 0, e), s;
    } };
  }
  if (n === "setter") {
    const { name: o } = r;
    return function(s) {
      const l = this[o];
      t.call(this, s), this.requestUpdate(o, l, e);
    };
  }
  throw Error("Unsupported decorator location: " + n);
};
function U(e) {
  return (t, r) => typeof r == "object" ? NG(e, t, r) : ((n, i, a) => {
    const o = i.hasOwnProperty(a);
    return i.constructor.createProperty(a, o ? { ...n, wrapped: !0 } : n), o ? Object.getOwnPropertyDescriptor(i, a) : void 0;
  })(e, t, r);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Fn(e) {
  return U({ ...e, state: !0, attribute: !1 });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const LG = (e, t, r) => (r.configurable = !0, r.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(e, t, r), r);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function jt(e, t) {
  return (r, n, i) => {
    const a = (o) => o.renderRoot?.querySelector(e) ?? null;
    return LG(r, n, { get() {
      return a(this);
    } });
  };
}
var Su, ar = class extends Pl {
  constructor() {
    super(), xG(this, Su, !1), this.initialReflectedProperties = /* @__PURE__ */ new Map(), Object.entries(this.constructor.dependencies).forEach(([e, t]) => {
      this.constructor.define(e, t);
    });
  }
  emit(e, t) {
    const r = new CustomEvent(e, so({
      bubbles: !0,
      cancelable: !1,
      composed: !0,
      detail: {}
    }, t));
    return this.dispatchEvent(r), r;
  }
  /* eslint-enable */
  static define(e, t = this, r = {}) {
    const n = customElements.get(e);
    if (!n) {
      try {
        customElements.define(e, t, r);
      } catch {
        customElements.define(e, class extends t {
        }, r);
      }
      return;
    }
    let i = " (unknown version)", a = i;
    "version" in t && t.version && (i = " v" + t.version), "version" in n && n.version && (a = " v" + n.version), !(i && a && i === a) && console.warn(
      `Attempted to register <${e}>${i}, but <${e}>${a} has already been registered.`
    );
  }
  attributeChangedCallback(e, t, r) {
    wG(this, Su) || (this.constructor.elementProperties.forEach(
      (n, i) => {
        n.reflect && this[i] != null && this.initialReflectedProperties.set(i, this[i]);
      }
    ), kG(this, Su, !0)), super.attributeChangedCallback(e, t, r);
  }
  willUpdate(e) {
    super.willUpdate(e), this.initialReflectedProperties.forEach((t, r) => {
      e.has(r) && this[r] == null && (this[r] = t);
    });
  }
};
Su = /* @__PURE__ */ new WeakMap();
ar.version = "2.20.1";
ar.dependencies = {};
O([
  U()
], ar.prototype, "dir", 2);
O([
  U()
], ar.prototype, "lang", 2);
const ia = Math.min, on = Math.max, fc = Math.round, tu = Math.floor, Zn = (e) => ({
  x: e,
  y: e
}), FG = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, RG = {
  start: "end",
  end: "start"
};
function Th(e, t, r) {
  return on(e, ia(t, r));
}
function Ds(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function aa(e) {
  return e.split("-")[0];
}
function Ms(e) {
  return e.split("-")[1];
}
function f8(e) {
  return e === "x" ? "y" : "x";
}
function lp(e) {
  return e === "y" ? "height" : "width";
}
function Xa(e) {
  return ["top", "bottom"].includes(aa(e)) ? "y" : "x";
}
function dp(e) {
  return f8(Xa(e));
}
function zG(e, t, r) {
  r === void 0 && (r = !1);
  const n = Ms(e), i = dp(e), a = lp(i);
  let o = i === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = pc(o)), [o, pc(o)];
}
function jG(e) {
  const t = pc(e);
  return [Ah(e), t, Ah(t)];
}
function Ah(e) {
  return e.replace(/start|end/g, (t) => RG[t]);
}
function VG(e, t, r) {
  const n = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? i : n : t ? n : i;
    case "left":
    case "right":
      return t ? a : o;
    default:
      return [];
  }
}
function UG(e, t, r, n) {
  const i = Ms(e);
  let a = VG(aa(e), r === "start", n);
  return i && (a = a.map((o) => o + "-" + i), t && (a = a.concat(a.map(Ah)))), a;
}
function pc(e) {
  return e.replace(/left|right|bottom|top/g, (t) => FG[t]);
}
function qG(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function p8(e) {
  return typeof e != "number" ? qG(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function mc(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: i
  } = e;
  return {
    width: n,
    height: i,
    top: r,
    left: t,
    right: t + n,
    bottom: r + i,
    x: t,
    y: r
  };
}
function Dg(e, t, r) {
  let {
    reference: n,
    floating: i
  } = e;
  const a = Xa(t), o = dp(t), s = lp(o), l = aa(t), d = a === "y", u = n.x + n.width / 2 - i.width / 2, c = n.y + n.height / 2 - i.height / 2, h = n[s] / 2 - i[s] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: u,
        y: n.y - i.height
      };
      break;
    case "bottom":
      f = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: c
      };
      break;
    case "left":
      f = {
        x: n.x - i.width,
        y: c
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (Ms(t)) {
    case "start":
      f[o] -= h * (r && d ? -1 : 1);
      break;
    case "end":
      f[o] += h * (r && d ? -1 : 1);
      break;
  }
  return f;
}
const BG = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = r, s = a.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let d = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: u,
    y: c
  } = Dg(d, n, l), h = n, f = {}, p = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: v,
      fn: m
    } = s[g], {
      x: $,
      y: w,
      data: k,
      reset: C
    } = await m({
      x: u,
      y: c,
      initialPlacement: n,
      placement: h,
      strategy: i,
      middlewareData: f,
      rects: d,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = $ ?? u, c = w ?? c, f = {
      ...f,
      [v]: {
        ...f[v],
        ...k
      }
    }, C && p <= 50 && (p++, typeof C == "object" && (C.placement && (h = C.placement), C.rects && (d = C.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : C.rects), {
      x: u,
      y: c
    } = Dg(d, h, l)), g = -1);
  }
  return {
    x: u,
    y: c,
    placement: h,
    strategy: i,
    middlewareData: f
  };
};
async function up(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: i,
    platform: a,
    rects: o,
    elements: s,
    strategy: l
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: c = "floating",
    altBoundary: h = !1,
    padding: f = 0
  } = Ds(t, e), p = p8(f), v = s[h ? c === "floating" ? "reference" : "floating" : c], m = mc(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(v))) == null || r ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: d,
    rootBoundary: u,
    strategy: l
  })), $ = c === "floating" ? {
    x: n,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, w = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), k = await (a.isElement == null ? void 0 : a.isElement(w)) ? await (a.getScale == null ? void 0 : a.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = mc(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: $,
    offsetParent: w,
    strategy: l
  }) : $);
  return {
    top: (m.top - C.top + p.top) / k.y,
    bottom: (C.bottom - m.bottom + p.bottom) / k.y,
    left: (m.left - C.left + p.left) / k.x,
    right: (C.right - m.right + p.right) / k.x
  };
}
const HG = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: i,
      rects: a,
      platform: o,
      elements: s,
      middlewareData: l
    } = t, {
      element: d,
      padding: u = 0
    } = Ds(e, t) || {};
    if (d == null)
      return {};
    const c = p8(u), h = {
      x: r,
      y: n
    }, f = dp(i), p = lp(f), g = await o.getDimensions(d), v = f === "y", m = v ? "top" : "left", $ = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", k = a.reference[p] + a.reference[f] - h[f] - a.floating[p], C = h[f] - a.reference[f], E = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(d));
    let N = E ? E[w] : 0;
    (!N || !await (o.isElement == null ? void 0 : o.isElement(E))) && (N = s.floating[w] || a.floating[p]);
    const M = k / 2 - C / 2, V = N / 2 - g[p] / 2 - 1, q = ia(c[m], V), I = ia(c[$], V), P = q, z = N - g[p] - I, G = N / 2 - g[p] / 2 + M, se = Th(P, G, z), ue = !l.arrow && Ms(i) != null && G !== se && a.reference[p] / 2 - (G < P ? q : I) - g[p] / 2 < 0, de = ue ? G < P ? G - P : G - z : 0;
    return {
      [f]: h[f] + de,
      data: {
        [f]: se,
        centerOffset: G - se - de,
        ...ue && {
          alignmentOffset: de
        }
      },
      reset: ue
    };
  }
}), WG = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: d
      } = t, {
        mainAxis: u = !0,
        crossAxis: c = !0,
        fallbackPlacements: h,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: g = !0,
        ...v
      } = Ds(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const m = aa(i), $ = Xa(s), w = aa(s) === s, k = await (l.isRTL == null ? void 0 : l.isRTL(d.floating)), C = h || (w || !g ? [pc(s)] : jG(s)), E = p !== "none";
      !h && E && C.push(...UG(s, g, p, k));
      const N = [s, ...C], M = await up(t, v), V = [];
      let q = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (u && V.push(M[m]), c) {
        const G = zG(i, o, k);
        V.push(M[G[0]], M[G[1]]);
      }
      if (q = [...q, {
        placement: i,
        overflows: V
      }], !V.every((G) => G <= 0)) {
        var I, P;
        const G = (((I = a.flip) == null ? void 0 : I.index) || 0) + 1, se = N[G];
        if (se)
          return {
            data: {
              index: G,
              overflows: q
            },
            reset: {
              placement: se
            }
          };
        let ue = (P = q.filter((de) => de.overflows[0] <= 0).sort((de, D) => de.overflows[1] - D.overflows[1])[0]) == null ? void 0 : P.placement;
        if (!ue)
          switch (f) {
            case "bestFit": {
              var z;
              const de = (z = q.filter((D) => {
                if (E) {
                  const R = Xa(D.placement);
                  return R === $ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  R === "y";
                }
                return !0;
              }).map((D) => [D.placement, D.overflows.filter((R) => R > 0).reduce((R, Q) => R + Q, 0)]).sort((D, R) => D[1] - R[1])[0]) == null ? void 0 : z[0];
              de && (ue = de);
              break;
            }
            case "initialPlacement":
              ue = s;
              break;
          }
        if (i !== ue)
          return {
            reset: {
              placement: ue
            }
          };
      }
      return {};
    }
  };
};
async function QG(e, t) {
  const {
    placement: r,
    platform: n,
    elements: i
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), o = aa(r), s = Ms(r), l = Xa(r) === "y", d = ["left", "top"].includes(o) ? -1 : 1, u = a && l ? -1 : 1, c = Ds(t, e);
  let {
    mainAxis: h,
    crossAxis: f,
    alignmentAxis: p
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: c.mainAxis || 0,
    crossAxis: c.crossAxis || 0,
    alignmentAxis: c.alignmentAxis
  };
  return s && typeof p == "number" && (f = s === "end" ? p * -1 : p), l ? {
    x: f * u,
    y: h * d
  } : {
    x: h * d,
    y: f * u
  };
}
const GG = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: s
      } = t, l = await QG(t, e);
      return o === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: i + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, YG = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: i
      } = t, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (v) => {
            let {
              x: m,
              y: $
            } = v;
            return {
              x: m,
              y: $
            };
          }
        },
        ...l
      } = Ds(e, t), d = {
        x: r,
        y: n
      }, u = await up(t, l), c = Xa(aa(i)), h = f8(c);
      let f = d[h], p = d[c];
      if (a) {
        const v = h === "y" ? "top" : "left", m = h === "y" ? "bottom" : "right", $ = f + u[v], w = f - u[m];
        f = Th($, f, w);
      }
      if (o) {
        const v = c === "y" ? "top" : "left", m = c === "y" ? "bottom" : "right", $ = p + u[v], w = p - u[m];
        p = Th($, p, w);
      }
      const g = s.fn({
        ...t,
        [h]: f,
        [c]: p
      });
      return {
        ...g,
        data: {
          x: g.x - r,
          y: g.y - n,
          enabled: {
            [h]: a,
            [c]: o
          }
        }
      };
    }
  };
}, KG = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: i,
        rects: a,
        platform: o,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...d
      } = Ds(e, t), u = await up(t, d), c = aa(i), h = Ms(i), f = Xa(i) === "y", {
        width: p,
        height: g
      } = a.floating;
      let v, m;
      c === "top" || c === "bottom" ? (v = c, m = h === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (m = c, v = h === "end" ? "top" : "bottom");
      const $ = g - u.top - u.bottom, w = p - u.left - u.right, k = ia(g - u[v], $), C = ia(p - u[m], w), E = !t.middlewareData.shift;
      let N = k, M = C;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (M = w), (n = t.middlewareData.shift) != null && n.enabled.y && (N = $), E && !h) {
        const q = on(u.left, 0), I = on(u.right, 0), P = on(u.top, 0), z = on(u.bottom, 0);
        f ? M = p - 2 * (q !== 0 || I !== 0 ? q + I : on(u.left, u.right)) : N = g - 2 * (P !== 0 || z !== 0 ? P + z : on(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: M,
        availableHeight: N
      });
      const V = await o.getDimensions(s.floating);
      return p !== V.width || g !== V.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function i0() {
  return typeof window < "u";
}
function Ns(e) {
  return m8(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function dn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ai(e) {
  var t;
  return (t = (m8(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function m8(e) {
  return i0() ? e instanceof Node || e instanceof dn(e).Node : !1;
}
function Mn(e) {
  return i0() ? e instanceof Element || e instanceof dn(e).Element : !1;
}
function ti(e) {
  return i0() ? e instanceof HTMLElement || e instanceof dn(e).HTMLElement : !1;
}
function Mg(e) {
  return !i0() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof dn(e).ShadowRoot;
}
function xd(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: i
  } = Nn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(i);
}
function ZG(e) {
  return ["table", "td", "th"].includes(Ns(e));
}
function a0(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function o0(e) {
  const t = cp(), r = Mn(e) ? Nn(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function XG(e) {
  let t = oa(e);
  for (; ti(t) && !ys(t); ) {
    if (o0(t))
      return t;
    if (a0(t))
      return null;
    t = oa(t);
  }
  return null;
}
function cp() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ys(e) {
  return ["html", "body", "#document"].includes(Ns(e));
}
function Nn(e) {
  return dn(e).getComputedStyle(e);
}
function s0(e) {
  return Mn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function oa(e) {
  if (Ns(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Mg(e) && e.host || // Fallback.
    ai(e)
  );
  return Mg(t) ? t.host : t;
}
function g8(e) {
  const t = oa(e);
  return ys(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ti(t) && xd(t) ? t : g8(t);
}
function td(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const i = g8(e), a = i === ((n = e.ownerDocument) == null ? void 0 : n.body), o = dn(i);
  if (a) {
    const s = Oh(o);
    return t.concat(o, o.visualViewport || [], xd(i) ? i : [], s && r ? td(s) : []);
  }
  return t.concat(i, td(i, [], r));
}
function Oh(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function v8(e) {
  const t = Nn(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const i = ti(e), a = i ? e.offsetWidth : r, o = i ? e.offsetHeight : n, s = fc(r) !== a || fc(n) !== o;
  return s && (r = a, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function hp(e) {
  return Mn(e) ? e : e.contextElement;
}
function es(e) {
  const t = hp(e);
  if (!ti(t))
    return Zn(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: i,
    $: a
  } = v8(t);
  let o = (a ? fc(r.width) : r.width) / n, s = (a ? fc(r.height) : r.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const JG = /* @__PURE__ */ Zn(0);
function y8(e) {
  const t = dn(e);
  return !cp() || !t.visualViewport ? JG : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function eY(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== dn(e) ? !1 : t;
}
function Ja(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const i = e.getBoundingClientRect(), a = hp(e);
  let o = Zn(1);
  t && (n ? Mn(n) && (o = es(n)) : o = es(e));
  const s = eY(a, r, n) ? y8(a) : Zn(0);
  let l = (i.left + s.x) / o.x, d = (i.top + s.y) / o.y, u = i.width / o.x, c = i.height / o.y;
  if (a) {
    const h = dn(a), f = n && Mn(n) ? dn(n) : n;
    let p = h, g = Oh(p);
    for (; g && n && f !== p; ) {
      const v = es(g), m = g.getBoundingClientRect(), $ = Nn(g), w = m.left + (g.clientLeft + parseFloat($.paddingLeft)) * v.x, k = m.top + (g.clientTop + parseFloat($.paddingTop)) * v.y;
      l *= v.x, d *= v.y, u *= v.x, c *= v.y, l += w, d += k, p = dn(g), g = Oh(p);
    }
  }
  return mc({
    width: u,
    height: c,
    x: l,
    y: d
  });
}
function fp(e, t) {
  const r = s0(e).scrollLeft;
  return t ? t.left + r : Ja(ai(e)).left + r;
}
function b8(e, t, r) {
  r === void 0 && (r = !1);
  const n = e.getBoundingClientRect(), i = n.left + t.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    fp(e, n)
  )), a = n.top + t.scrollTop;
  return {
    x: i,
    y: a
  };
}
function tY(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: i
  } = e;
  const a = i === "fixed", o = ai(n), s = t ? a0(t.floating) : !1;
  if (n === o || s && a)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = Zn(1);
  const u = Zn(0), c = ti(n);
  if ((c || !c && !a) && ((Ns(n) !== "body" || xd(o)) && (l = s0(n)), ti(n))) {
    const f = Ja(n);
    d = es(n), u.x = f.x + n.clientLeft, u.y = f.y + n.clientTop;
  }
  const h = o && !c && !a ? b8(o, l, !0) : Zn(0);
  return {
    width: r.width * d.x,
    height: r.height * d.y,
    x: r.x * d.x - l.scrollLeft * d.x + u.x + h.x,
    y: r.y * d.y - l.scrollTop * d.y + u.y + h.y
  };
}
function rY(e) {
  return Array.from(e.getClientRects());
}
function nY(e) {
  const t = ai(e), r = s0(e), n = e.ownerDocument.body, i = on(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = on(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + fp(e);
  const s = -r.scrollTop;
  return Nn(n).direction === "rtl" && (o += on(t.clientWidth, n.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
function iY(e, t) {
  const r = dn(e), n = ai(e), i = r.visualViewport;
  let a = n.clientWidth, o = n.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    const d = cp();
    (!d || d && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function aY(e, t) {
  const r = Ja(e, !0, t === "fixed"), n = r.top + e.clientTop, i = r.left + e.clientLeft, a = ti(e) ? es(e) : Zn(1), o = e.clientWidth * a.x, s = e.clientHeight * a.y, l = i * a.x, d = n * a.y;
  return {
    width: o,
    height: s,
    x: l,
    y: d
  };
}
function Ng(e, t, r) {
  let n;
  if (t === "viewport")
    n = iY(e, r);
  else if (t === "document")
    n = nY(ai(e));
  else if (Mn(t))
    n = aY(t, r);
  else {
    const i = y8(e);
    n = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return mc(n);
}
function $8(e, t) {
  const r = oa(e);
  return r === t || !Mn(r) || ys(r) ? !1 : Nn(r).position === "fixed" || $8(r, t);
}
function oY(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = td(e, [], !1).filter((s) => Mn(s) && Ns(s) !== "body"), i = null;
  const a = Nn(e).position === "fixed";
  let o = a ? oa(e) : e;
  for (; Mn(o) && !ys(o); ) {
    const s = Nn(o), l = o0(o);
    !l && s.position === "fixed" && (i = null), (a ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || xd(o) && !l && $8(e, o)) ? n = n.filter((u) => u !== o) : i = s, o = oa(o);
  }
  return t.set(e, n), n;
}
function sY(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: i
  } = e;
  const o = [...r === "clippingAncestors" ? a0(t) ? [] : oY(t, this._c) : [].concat(r), n], s = o[0], l = o.reduce((d, u) => {
    const c = Ng(t, u, i);
    return d.top = on(c.top, d.top), d.right = ia(c.right, d.right), d.bottom = ia(c.bottom, d.bottom), d.left = on(c.left, d.left), d;
  }, Ng(t, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function lY(e) {
  const {
    width: t,
    height: r
  } = v8(e);
  return {
    width: t,
    height: r
  };
}
function dY(e, t, r) {
  const n = ti(t), i = ai(t), a = r === "fixed", o = Ja(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Zn(0);
  if (n || !n && !a)
    if ((Ns(t) !== "body" || xd(i)) && (s = s0(t)), n) {
      const h = Ja(t, !0, a, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else i && (l.x = fp(i));
  const d = i && !n && !a ? b8(i, s) : Zn(0), u = o.left + s.scrollLeft - l.x - d.x, c = o.top + s.scrollTop - l.y - d.y;
  return {
    x: u,
    y: c,
    width: o.width,
    height: o.height
  };
}
function x1(e) {
  return Nn(e).position === "static";
}
function Lg(e, t) {
  if (!ti(e) || Nn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return ai(e) === r && (r = r.ownerDocument.body), r;
}
function w8(e, t) {
  const r = dn(e);
  if (a0(e))
    return r;
  if (!ti(e)) {
    let i = oa(e);
    for (; i && !ys(i); ) {
      if (Mn(i) && !x1(i))
        return i;
      i = oa(i);
    }
    return r;
  }
  let n = Lg(e, t);
  for (; n && ZG(n) && x1(n); )
    n = Lg(n, t);
  return n && ys(n) && x1(n) && !o0(n) ? r : n || XG(e) || r;
}
const uY = async function(e) {
  const t = this.getOffsetParent || w8, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: dY(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function cY(e) {
  return Nn(e).direction === "rtl";
}
const Eu = {
  convertOffsetParentRelativeRectToViewportRelativeRect: tY,
  getDocumentElement: ai,
  getClippingRect: sY,
  getOffsetParent: w8,
  getElementRects: uY,
  getClientRects: rY,
  getDimensions: lY,
  getScale: es,
  isElement: Mn,
  isRTL: cY
};
function x8(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function hY(e, t) {
  let r = null, n;
  const i = ai(e);
  function a() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const d = e.getBoundingClientRect(), {
      left: u,
      top: c,
      width: h,
      height: f
    } = d;
    if (s || t(), !h || !f)
      return;
    const p = tu(c), g = tu(i.clientWidth - (u + h)), v = tu(i.clientHeight - (c + f)), m = tu(u), w = {
      rootMargin: -p + "px " + -g + "px " + -v + "px " + -m + "px",
      threshold: on(0, ia(1, l)) || 1
    };
    let k = !0;
    function C(E) {
      const N = E[0].intersectionRatio;
      if (N !== l) {
        if (!k)
          return o();
        N ? o(!1, N) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      N === 1 && !x8(d, e.getBoundingClientRect()) && o(), k = !1;
    }
    try {
      r = new IntersectionObserver(C, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(C, w);
    }
    r.observe(e);
  }
  return o(!0), a;
}
function fY(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, d = hp(e), u = i || a ? [...d ? td(d) : [], ...td(t)] : [];
  u.forEach((m) => {
    i && m.addEventListener("scroll", r, {
      passive: !0
    }), a && m.addEventListener("resize", r);
  });
  const c = d && s ? hY(d, r) : null;
  let h = -1, f = null;
  o && (f = new ResizeObserver((m) => {
    let [$] = m;
    $ && $.target === d && f && (f.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = f) == null || w.observe(t);
    })), r();
  }), d && !l && f.observe(d), f.observe(t));
  let p, g = l ? Ja(e) : null;
  l && v();
  function v() {
    const m = Ja(e);
    g && !x8(g, m) && r(), g = m, p = requestAnimationFrame(v);
  }
  return r(), () => {
    var m;
    u.forEach(($) => {
      i && $.removeEventListener("scroll", r), a && $.removeEventListener("resize", r);
    }), c?.(), (m = f) == null || m.disconnect(), f = null, l && cancelAnimationFrame(p);
  };
}
const pY = GG, mY = YG, gY = WG, Fg = KG, vY = HG, yY = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: Eu,
    ...r
  }, a = {
    ...i.platform,
    _c: n
  };
  return BG(e, t, {
    ...i,
    platform: a
  });
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ui = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4 }, pp = (e) => (...t) => ({ _$litDirective$: e, values: t });
let mp = class {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, r, n) {
    this._$Ct = t, this._$AM = r, this._$Ci = n;
  }
  _$AS(t, r) {
    return this.update(t, r);
  }
  update(t, r) {
    return this.render(...r);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const dr = pp(class extends mp {
  constructor(e) {
    if (super(e), e.type !== Ui.ATTRIBUTE || e.name !== "class" || e.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(e) {
    return " " + Object.keys(e).filter((t) => e[t]).join(" ") + " ";
  }
  update(e, [t]) {
    if (this.st === void 0) {
      this.st = /* @__PURE__ */ new Set(), e.strings !== void 0 && (this.nt = new Set(e.strings.join(" ").split(/\s/).filter((n) => n !== "")));
      for (const n in t) t[n] && !this.nt?.has(n) && this.st.add(n);
      return this.render(t);
    }
    const r = e.element.classList;
    for (const n of this.st) n in t || (r.remove(n), this.st.delete(n));
    for (const n in t) {
      const i = !!t[n];
      i === this.st.has(n) || this.nt?.has(n) || (i ? (r.add(n), this.st.add(n)) : (r.remove(n), this.st.delete(n)));
    }
    return Tn;
  }
});
function bY(e) {
  return $Y(e);
}
function k1(e) {
  return e.assignedSlot ? e.assignedSlot : e.parentNode instanceof ShadowRoot ? e.parentNode.host : e.parentNode;
}
function $Y(e) {
  for (let t = e; t; t = k1(t)) if (t instanceof Element && getComputedStyle(t).display === "none") return null;
  for (let t = k1(e); t; t = k1(t)) {
    if (!(t instanceof Element)) continue;
    const r = getComputedStyle(t);
    if (r.display !== "contents" && (r.position !== "static" || o0(r) || t.tagName === "BODY"))
      return t;
  }
  return null;
}
function wY(e) {
  return e !== null && typeof e == "object" && "getBoundingClientRect" in e && ("contextElement" in e ? e.contextElement instanceof Element : !0);
}
var At = class extends ar {
  constructor() {
    super(...arguments), this.localize = new Ei(this), this.active = !1, this.placement = "top", this.strategy = "absolute", this.distance = 0, this.skidding = 0, this.arrow = !1, this.arrowPlacement = "anchor", this.arrowPadding = 10, this.flip = !1, this.flipFallbackPlacements = "", this.flipFallbackStrategy = "best-fit", this.flipPadding = 0, this.shift = !1, this.shiftPadding = 0, this.autoSizePadding = 0, this.hoverBridge = !1, this.updateHoverBridge = () => {
      if (this.hoverBridge && this.anchorEl) {
        const e = this.anchorEl.getBoundingClientRect(), t = this.popup.getBoundingClientRect(), r = this.placement.includes("top") || this.placement.includes("bottom");
        let n = 0, i = 0, a = 0, o = 0, s = 0, l = 0, d = 0, u = 0;
        r ? e.top < t.top ? (n = e.left, i = e.bottom, a = e.right, o = e.bottom, s = t.left, l = t.top, d = t.right, u = t.top) : (n = t.left, i = t.bottom, a = t.right, o = t.bottom, s = e.left, l = e.top, d = e.right, u = e.top) : e.left < t.left ? (n = e.right, i = e.top, a = t.left, o = t.top, s = e.right, l = e.bottom, d = t.left, u = t.bottom) : (n = t.right, i = t.top, a = e.left, o = e.top, s = t.right, l = t.bottom, d = e.left, u = e.bottom), this.style.setProperty("--hover-bridge-top-left-x", `${n}px`), this.style.setProperty("--hover-bridge-top-left-y", `${i}px`), this.style.setProperty("--hover-bridge-top-right-x", `${a}px`), this.style.setProperty("--hover-bridge-top-right-y", `${o}px`), this.style.setProperty("--hover-bridge-bottom-left-x", `${s}px`), this.style.setProperty("--hover-bridge-bottom-left-y", `${l}px`), this.style.setProperty("--hover-bridge-bottom-right-x", `${d}px`), this.style.setProperty("--hover-bridge-bottom-right-y", `${u}px`);
      }
    };
  }
  async connectedCallback() {
    super.connectedCallback(), await this.updateComplete, this.start();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.stop();
  }
  async updated(e) {
    super.updated(e), e.has("active") && (this.active ? this.start() : this.stop()), e.has("anchor") && this.handleAnchorChange(), this.active && (await this.updateComplete, this.reposition());
  }
  async handleAnchorChange() {
    if (await this.stop(), this.anchor && typeof this.anchor == "string") {
      const e = this.getRootNode();
      this.anchorEl = e.getElementById(this.anchor);
    } else this.anchor instanceof Element || wY(this.anchor) ? this.anchorEl = this.anchor : this.anchorEl = this.querySelector('[slot="anchor"]');
    this.anchorEl instanceof HTMLSlotElement && (this.anchorEl = this.anchorEl.assignedElements({ flatten: !0 })[0]), this.anchorEl && this.active && this.start();
  }
  start() {
    !this.anchorEl || !this.active || (this.cleanup = fY(this.anchorEl, this.popup, () => {
      this.reposition();
    }));
  }
  async stop() {
    return new Promise((e) => {
      this.cleanup ? (this.cleanup(), this.cleanup = void 0, this.removeAttribute("data-current-placement"), this.style.removeProperty("--auto-size-available-width"), this.style.removeProperty("--auto-size-available-height"), requestAnimationFrame(() => e())) : e();
    });
  }
  /** Forces the popup to recalculate and reposition itself. */
  reposition() {
    if (!this.active || !this.anchorEl)
      return;
    const e = [
      // The offset middleware goes first
      pY({ mainAxis: this.distance, crossAxis: this.skidding })
    ];
    this.sync ? e.push(
      Fg({
        apply: ({ rects: r }) => {
          const n = this.sync === "width" || this.sync === "both", i = this.sync === "height" || this.sync === "both";
          this.popup.style.width = n ? `${r.reference.width}px` : "", this.popup.style.height = i ? `${r.reference.height}px` : "";
        }
      })
    ) : (this.popup.style.width = "", this.popup.style.height = ""), this.flip && e.push(
      gY({
        boundary: this.flipBoundary,
        // @ts-expect-error - We're converting a string attribute to an array here
        fallbackPlacements: this.flipFallbackPlacements,
        fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
        padding: this.flipPadding
      })
    ), this.shift && e.push(
      mY({
        boundary: this.shiftBoundary,
        padding: this.shiftPadding
      })
    ), this.autoSize ? e.push(
      Fg({
        boundary: this.autoSizeBoundary,
        padding: this.autoSizePadding,
        apply: ({ availableWidth: r, availableHeight: n }) => {
          this.autoSize === "vertical" || this.autoSize === "both" ? this.style.setProperty("--auto-size-available-height", `${n}px`) : this.style.removeProperty("--auto-size-available-height"), this.autoSize === "horizontal" || this.autoSize === "both" ? this.style.setProperty("--auto-size-available-width", `${r}px`) : this.style.removeProperty("--auto-size-available-width");
        }
      })
    ) : (this.style.removeProperty("--auto-size-available-width"), this.style.removeProperty("--auto-size-available-height")), this.arrow && e.push(
      vY({
        element: this.arrowEl,
        padding: this.arrowPadding
      })
    );
    const t = this.strategy === "absolute" ? (r) => Eu.getOffsetParent(r, bY) : Eu.getOffsetParent;
    yY(this.anchorEl, this.popup, {
      placement: this.placement,
      middleware: e,
      strategy: this.strategy,
      platform: n0(so({}, Eu), {
        getOffsetParent: t
      })
    }).then(({ x: r, y: n, middlewareData: i, placement: a }) => {
      const o = this.localize.dir() === "rtl", s = { top: "bottom", right: "left", bottom: "top", left: "right" }[a.split("-")[0]];
      if (this.setAttribute("data-current-placement", a), Object.assign(this.popup.style, {
        left: `${r}px`,
        top: `${n}px`
      }), this.arrow) {
        const l = i.arrow.x, d = i.arrow.y;
        let u = "", c = "", h = "", f = "";
        if (this.arrowPlacement === "start") {
          const p = typeof l == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          u = typeof d == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "", c = o ? p : "", f = o ? "" : p;
        } else if (this.arrowPlacement === "end") {
          const p = typeof l == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          c = o ? "" : p, f = o ? p : "", h = typeof d == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
        } else this.arrowPlacement === "center" ? (f = typeof l == "number" ? "calc(50% - var(--arrow-size-diagonal))" : "", u = typeof d == "number" ? "calc(50% - var(--arrow-size-diagonal))" : "") : (f = typeof l == "number" ? `${l}px` : "", u = typeof d == "number" ? `${d}px` : "");
        Object.assign(this.arrowEl.style, {
          top: u,
          right: c,
          bottom: h,
          left: f,
          [s]: "calc(var(--arrow-size-diagonal) * -1)"
        });
      }
    }), requestAnimationFrame(() => this.updateHoverBridge()), this.emit("sl-reposition");
  }
  render() {
    return xt`
      <slot name="anchor" @slotchange=${this.handleAnchorChange}></slot>

      <span
        part="hover-bridge"
        class=${dr({
      "popup-hover-bridge": !0,
      "popup-hover-bridge--visible": this.hoverBridge && this.active
    })}
      ></span>

      <div
        part="popup"
        class=${dr({
      popup: !0,
      "popup--active": this.active,
      "popup--fixed": this.strategy === "fixed",
      "popup--has-arrow": this.arrow
    })}
      >
        <slot></slot>
        ${this.arrow ? xt`<div part="arrow" class="popup__arrow" role="presentation"></div>` : ""}
      </div>
    `;
  }
};
At.styles = [Ar, IG];
O([
  jt(".popup")
], At.prototype, "popup", 2);
O([
  jt(".popup__arrow")
], At.prototype, "arrowEl", 2);
O([
  U()
], At.prototype, "anchor", 2);
O([
  U({ type: Boolean, reflect: !0 })
], At.prototype, "active", 2);
O([
  U({ reflect: !0 })
], At.prototype, "placement", 2);
O([
  U({ reflect: !0 })
], At.prototype, "strategy", 2);
O([
  U({ type: Number })
], At.prototype, "distance", 2);
O([
  U({ type: Number })
], At.prototype, "skidding", 2);
O([
  U({ type: Boolean })
], At.prototype, "arrow", 2);
O([
  U({ attribute: "arrow-placement" })
], At.prototype, "arrowPlacement", 2);
O([
  U({ attribute: "arrow-padding", type: Number })
], At.prototype, "arrowPadding", 2);
O([
  U({ type: Boolean })
], At.prototype, "flip", 2);
O([
  U({
    attribute: "flip-fallback-placements",
    converter: {
      fromAttribute: (e) => e.split(" ").map((t) => t.trim()).filter((t) => t !== ""),
      toAttribute: (e) => e.join(" ")
    }
  })
], At.prototype, "flipFallbackPlacements", 2);
O([
  U({ attribute: "flip-fallback-strategy" })
], At.prototype, "flipFallbackStrategy", 2);
O([
  U({ type: Object })
], At.prototype, "flipBoundary", 2);
O([
  U({ attribute: "flip-padding", type: Number })
], At.prototype, "flipPadding", 2);
O([
  U({ type: Boolean })
], At.prototype, "shift", 2);
O([
  U({ type: Object })
], At.prototype, "shiftBoundary", 2);
O([
  U({ attribute: "shift-padding", type: Number })
], At.prototype, "shiftPadding", 2);
O([
  U({ attribute: "auto-size" })
], At.prototype, "autoSize", 2);
O([
  U()
], At.prototype, "sync", 2);
O([
  U({ type: Object })
], At.prototype, "autoSizeBoundary", 2);
O([
  U({ attribute: "auto-size-padding", type: Number })
], At.prototype, "autoSizePadding", 2);
O([
  U({ attribute: "hover-bridge", type: Boolean })
], At.prototype, "hoverBridge", 2);
var k8 = /* @__PURE__ */ new Map(), xY = /* @__PURE__ */ new WeakMap();
function kY(e) {
  return e ?? { keyframes: [], options: { duration: 0 } };
}
function Rg(e, t) {
  return t.toLowerCase() === "rtl" ? {
    keyframes: e.rtlKeyframes || e.keyframes,
    options: e.options
  } : e;
}
function Rn(e, t) {
  k8.set(e, kY(t));
}
function Sn(e, t, r) {
  const n = xY.get(e);
  if (n?.[t])
    return Rg(n[t], r.dir);
  const i = k8.get(t);
  return i ? Rg(i, r.dir) : {
    keyframes: [],
    options: { duration: 0 }
  };
}
function sa(e, t) {
  return new Promise((r) => {
    function n(i) {
      i.target === e && (e.removeEventListener(t, n), r());
    }
    e.addEventListener(t, n);
  });
}
function En(e, t, r) {
  return new Promise((n) => {
    if (r?.duration === 1 / 0)
      throw new Error("Promise-based animations must be finite.");
    const i = e.animate(t, n0(so({}, r), {
      duration: _Y() ? 0 : r.duration
    }));
    i.addEventListener("cancel", n, { once: !0 }), i.addEventListener("finish", n, { once: !0 });
  });
}
function zg(e) {
  return e = e.toString().toLowerCase(), e.indexOf("ms") > -1 ? parseFloat(e) : e.indexOf("s") > -1 ? parseFloat(e) * 1e3 : parseFloat(e);
}
function _Y() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function Gn(e) {
  return Promise.all(
    e.getAnimations().map((t) => new Promise((r) => {
      t.cancel(), requestAnimationFrame(r);
    }))
  );
}
function Nt(e, t) {
  const r = so({
    waitUntilFirstUpdate: !1
  }, t);
  return (n, i) => {
    const { update: a } = n, o = Array.isArray(e) ? e : [e];
    n.update = function(s) {
      o.forEach((l) => {
        const d = l;
        if (s.has(d)) {
          const u = s.get(d), c = this[d];
          u !== c && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[i](u, c);
        }
      }), a.call(this, s);
    };
  };
}
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Me = (e) => e ?? Bt;
var Or = class extends ar {
  constructor() {
    super(...arguments), this.localize = new Ei(this), this.open = !1, this.placement = "bottom-start", this.disabled = !1, this.stayOpenOnSelect = !1, this.distance = 0, this.skidding = 0, this.hoist = !1, this.sync = void 0, this.handleKeyDown = (e) => {
      this.open && e.key === "Escape" && (e.stopPropagation(), this.hide(), this.focusOnTrigger());
    }, this.handleDocumentKeyDown = (e) => {
      var t;
      if (e.key === "Escape" && this.open && !this.closeWatcher) {
        e.stopPropagation(), this.focusOnTrigger(), this.hide();
        return;
      }
      if (e.key === "Tab") {
        if (this.open && ((t = document.activeElement) == null ? void 0 : t.tagName.toLowerCase()) === "sl-menu-item") {
          e.preventDefault(), this.hide(), this.focusOnTrigger();
          return;
        }
        const r = (n, i) => {
          if (!n) return null;
          const a = n.closest(i);
          if (a) return a;
          const o = n.getRootNode();
          return o instanceof ShadowRoot ? r(o.host, i) : null;
        };
        setTimeout(() => {
          var n;
          const i = ((n = this.containingElement) == null ? void 0 : n.getRootNode()) instanceof ShadowRoot ? s8() : document.activeElement;
          (!this.containingElement || r(i, this.containingElement.tagName.toLowerCase()) !== this.containingElement) && this.hide();
        });
      }
    }, this.handleDocumentMouseDown = (e) => {
      const t = e.composedPath();
      this.containingElement && !t.includes(this.containingElement) && this.hide();
    }, this.handlePanelSelect = (e) => {
      const t = e.target;
      !this.stayOpenOnSelect && t.tagName.toLowerCase() === "sl-menu" && (this.hide(), this.focusOnTrigger());
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.containingElement || (this.containingElement = this);
  }
  firstUpdated() {
    this.panel.hidden = !this.open, this.open && (this.addOpenListeners(), this.popup.active = !0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeOpenListeners(), this.hide();
  }
  focusOnTrigger() {
    const e = this.trigger.assignedElements({ flatten: !0 })[0];
    typeof e?.focus == "function" && e.focus();
  }
  getMenu() {
    return this.panel.assignedElements({ flatten: !0 }).find((e) => e.tagName.toLowerCase() === "sl-menu");
  }
  handleTriggerClick() {
    this.open ? this.hide() : (this.show(), this.focusOnTrigger());
  }
  async handleTriggerKeyDown(e) {
    if ([" ", "Enter"].includes(e.key)) {
      e.preventDefault(), this.handleTriggerClick();
      return;
    }
    const t = this.getMenu();
    if (t) {
      const r = t.getAllItems(), n = r[0], i = r[r.length - 1];
      ["ArrowDown", "ArrowUp", "Home", "End"].includes(e.key) && (e.preventDefault(), this.open || (this.show(), await this.updateComplete), r.length > 0 && this.updateComplete.then(() => {
        (e.key === "ArrowDown" || e.key === "Home") && (t.setCurrentItem(n), n.focus()), (e.key === "ArrowUp" || e.key === "End") && (t.setCurrentItem(i), i.focus());
      }));
    }
  }
  handleTriggerKeyUp(e) {
    e.key === " " && e.preventDefault();
  }
  handleTriggerSlotChange() {
    this.updateAccessibleTrigger();
  }
  //
  // Slotted triggers can be arbitrary content, but we need to link them to the dropdown panel with `aria-haspopup` and
  // `aria-expanded`. These must be applied to the "accessible trigger" (the tabbable portion of the trigger element
  // that gets slotted in) so screen readers will understand them. The accessible trigger could be the slotted element,
  // a child of the slotted element, or an element in the slotted element's shadow root.
  //
  // For example, the accessible trigger of an <sl-button> is a <button> located inside its shadow root.
  //
  // To determine this, we assume the first tabbable element in the trigger slot is the "accessible trigger."
  //
  updateAccessibleTrigger() {
    const t = this.trigger.assignedElements({ flatten: !0 }).find((n) => AG(n).start);
    let r;
    if (t) {
      switch (t.tagName.toLowerCase()) {
        case "sl-button":
        case "sl-icon-button":
          r = t.button;
          break;
        default:
          r = t;
      }
      r.setAttribute("aria-haspopup", "true"), r.setAttribute("aria-expanded", this.open ? "true" : "false");
    }
  }
  /** Shows the dropdown panel. */
  async show() {
    if (!this.open)
      return this.open = !0, sa(this, "sl-after-show");
  }
  /** Hides the dropdown panel */
  async hide() {
    if (this.open)
      return this.open = !1, sa(this, "sl-after-hide");
  }
  /**
   * Instructs the dropdown menu to reposition. Useful when the position or size of the trigger changes when the menu
   * is activated.
   */
  reposition() {
    this.popup.reposition();
  }
  addOpenListeners() {
    var e;
    this.panel.addEventListener("sl-select", this.handlePanelSelect), "CloseWatcher" in window ? ((e = this.closeWatcher) == null || e.destroy(), this.closeWatcher = new CloseWatcher(), this.closeWatcher.onclose = () => {
      this.hide(), this.focusOnTrigger();
    }) : this.panel.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keydown", this.handleDocumentKeyDown), document.addEventListener("mousedown", this.handleDocumentMouseDown);
  }
  removeOpenListeners() {
    var e;
    this.panel && (this.panel.removeEventListener("sl-select", this.handlePanelSelect), this.panel.removeEventListener("keydown", this.handleKeyDown)), document.removeEventListener("keydown", this.handleDocumentKeyDown), document.removeEventListener("mousedown", this.handleDocumentMouseDown), (e = this.closeWatcher) == null || e.destroy();
  }
  async handleOpenChange() {
    if (this.disabled) {
      this.open = !1;
      return;
    }
    if (this.updateAccessibleTrigger(), this.open) {
      this.emit("sl-show"), this.addOpenListeners(), await Gn(this), this.panel.hidden = !1, this.popup.active = !0;
      const { keyframes: e, options: t } = Sn(this, "dropdown.show", { dir: this.localize.dir() });
      await En(this.popup.popup, e, t), this.emit("sl-after-show");
    } else {
      this.emit("sl-hide"), this.removeOpenListeners(), await Gn(this);
      const { keyframes: e, options: t } = Sn(this, "dropdown.hide", { dir: this.localize.dir() });
      await En(this.popup.popup, e, t), this.panel.hidden = !0, this.popup.active = !1, this.emit("sl-after-hide");
    }
  }
  render() {
    return xt`
      <sl-popup
        part="base"
        exportparts="popup:base__popup"
        id="dropdown"
        placement=${this.placement}
        distance=${this.distance}
        skidding=${this.skidding}
        strategy=${this.hoist ? "fixed" : "absolute"}
        flip
        shift
        auto-size="vertical"
        auto-size-padding="10"
        sync=${Me(this.sync ? this.sync : void 0)}
        class=${dr({
      dropdown: !0,
      "dropdown--open": this.open
    })}
      >
        <slot
          name="trigger"
          slot="anchor"
          part="trigger"
          class="dropdown__trigger"
          @click=${this.handleTriggerClick}
          @keydown=${this.handleTriggerKeyDown}
          @keyup=${this.handleTriggerKeyUp}
          @slotchange=${this.handleTriggerSlotChange}
        ></slot>

        <div aria-hidden=${this.open ? "false" : "true"} aria-labelledby="dropdown">
          <slot part="panel" class="dropdown__panel"></slot>
        </div>
      </sl-popup>
    `;
  }
};
Or.styles = [Ar, mG];
Or.dependencies = { "sl-popup": At };
O([
  jt(".dropdown")
], Or.prototype, "popup", 2);
O([
  jt(".dropdown__trigger")
], Or.prototype, "trigger", 2);
O([
  jt(".dropdown__panel")
], Or.prototype, "panel", 2);
O([
  U({ type: Boolean, reflect: !0 })
], Or.prototype, "open", 2);
O([
  U({ reflect: !0 })
], Or.prototype, "placement", 2);
O([
  U({ type: Boolean, reflect: !0 })
], Or.prototype, "disabled", 2);
O([
  U({ attribute: "stay-open-on-select", type: Boolean, reflect: !0 })
], Or.prototype, "stayOpenOnSelect", 2);
O([
  U({ attribute: !1 })
], Or.prototype, "containingElement", 2);
O([
  U({ type: Number })
], Or.prototype, "distance", 2);
O([
  U({ type: Number })
], Or.prototype, "skidding", 2);
O([
  U({ type: Boolean })
], Or.prototype, "hoist", 2);
O([
  U({ reflect: !0 })
], Or.prototype, "sync", 2);
O([
  Nt("open", { waitUntilFirstUpdate: !0 })
], Or.prototype, "handleOpenChange", 1);
Rn("dropdown.show", {
  keyframes: [
    { opacity: 0, scale: 0.9 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 100, easing: "ease" }
});
Rn("dropdown.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.9 }
  ],
  options: { duration: 100, easing: "ease" }
});
Or.define("sl-dropdown");
var Ih = "";
function Xt(e) {
  Ih = e;
}
function CY(e = "") {
  if (!Ih) {
    const t = [...document.getElementsByTagName("script")], r = t.find((n) => n.hasAttribute("data-shoelace"));
    if (r)
      Xt(r.getAttribute("data-shoelace"));
    else {
      const n = t.find((a) => /shoelace(\.min)?\.js($|\?)/.test(a.src) || /shoelace-autoloader(\.min)?\.js($|\?)/.test(a.src));
      let i = "";
      n && (i = n.getAttribute("src")), Xt(i.split("/").slice(0, -1).join("/"));
    }
  }
  return Ih.replace(/\/$/, "") + (e ? `/${e.replace(/^\//, "")}` : "");
}
var SY = {
  name: "default",
  resolver: (e) => CY(`assets/icons/${e}.svg`)
}, EY = SY, jg = {
  caret: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  `,
  check: `
    <svg part="checked-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor">
          <g transform="translate(3.428571, 3.428571)">
            <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
            <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
  "chevron-down": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
  "chevron-left": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
  `,
  "chevron-right": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
  copy: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z"/>
    </svg>
  `,
  eye: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
    </svg>
  `,
  "eye-slash": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  `,
  eyedropper: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyedropper" viewBox="0 0 16 16">
      <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"></path>
    </svg>
  `,
  "grip-vertical": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-vertical" viewBox="0 0 16 16">
      <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  `,
  indeterminate: `
    <svg part="indeterminate-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(2.285714, 6.857143)">
            <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
  "person-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    </svg>
  `,
  "play-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
    </svg>
  `,
  "pause-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"></path>
    </svg>
  `,
  radio: `
    <svg part="checked-icon" class="radio__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="currentColor">
          <circle cx="8" cy="8" r="3.42857143"></circle>
        </g>
      </g>
    </svg>
  `,
  "star-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
    </svg>
  `,
  "x-lg": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  `,
  "x-circle-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
    </svg>
  `
}, TY = {
  name: "system",
  resolver: (e) => e in jg ? `data:image/svg+xml,${encodeURIComponent(jg[e])}` : ""
}, AY = TY, OY = [EY, AY], Ph = [];
function IY(e) {
  Ph.push(e);
}
function PY(e) {
  Ph = Ph.filter((t) => t !== e);
}
function Vg(e) {
  return OY.find((t) => t.name === e);
}
var DY = gr`
  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const MY = (e, t) => e?._$litType$ !== void 0, _8 = (e) => e.strings === void 0, NY = {}, LY = (e, t = NY) => e._$AH = t;
var al = Symbol(), ru = Symbol(), _1, C1 = /* @__PURE__ */ new Map(), Vr = class extends ar {
  constructor() {
    super(...arguments), this.initialRender = !1, this.svg = null, this.label = "", this.library = "default";
  }
  /** Given a URL, this function returns the resulting SVG element or an appropriate error symbol. */
  async resolveIcon(e, t) {
    var r;
    let n;
    if (t?.spriteSheet)
      return this.svg = xt`<svg part="svg">
        <use part="use" href="${e}"></use>
      </svg>`, this.svg;
    try {
      if (n = await fetch(e, { mode: "cors" }), !n.ok) return n.status === 410 ? al : ru;
    } catch {
      return ru;
    }
    try {
      const i = document.createElement("div");
      i.innerHTML = await n.text();
      const a = i.firstElementChild;
      if (((r = a?.tagName) == null ? void 0 : r.toLowerCase()) !== "svg") return al;
      _1 || (_1 = new DOMParser());
      const s = _1.parseFromString(a.outerHTML, "text/html").body.querySelector("svg");
      return s ? (s.part.add("svg"), document.adoptNode(s)) : al;
    } catch {
      return al;
    }
  }
  connectedCallback() {
    super.connectedCallback(), IY(this);
  }
  firstUpdated() {
    this.initialRender = !0, this.setIcon();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), PY(this);
  }
  getIconSource() {
    const e = Vg(this.library);
    return this.name && e ? {
      url: e.resolver(this.name),
      fromLibrary: !0
    } : {
      url: this.src,
      fromLibrary: !1
    };
  }
  handleLabelChange() {
    typeof this.label == "string" && this.label.length > 0 ? (this.setAttribute("role", "img"), this.setAttribute("aria-label", this.label), this.removeAttribute("aria-hidden")) : (this.removeAttribute("role"), this.removeAttribute("aria-label"), this.setAttribute("aria-hidden", "true"));
  }
  async setIcon() {
    var e;
    const { url: t, fromLibrary: r } = this.getIconSource(), n = r ? Vg(this.library) : void 0;
    if (!t) {
      this.svg = null;
      return;
    }
    let i = C1.get(t);
    if (i || (i = this.resolveIcon(t, n), C1.set(t, i)), !this.initialRender)
      return;
    const a = await i;
    if (a === ru && C1.delete(t), t === this.getIconSource().url) {
      if (MY(a)) {
        if (this.svg = a, n) {
          await this.updateComplete;
          const o = this.shadowRoot.querySelector("[part='svg']");
          typeof n.mutator == "function" && o && n.mutator(o);
        }
        return;
      }
      switch (a) {
        case ru:
        case al:
          this.svg = null, this.emit("sl-error");
          break;
        default:
          this.svg = a.cloneNode(!0), (e = n?.mutator) == null || e.call(n, this.svg), this.emit("sl-load");
      }
    }
  }
  render() {
    return this.svg;
  }
};
Vr.styles = [Ar, DY];
O([
  Fn()
], Vr.prototype, "svg", 2);
O([
  U({ reflect: !0 })
], Vr.prototype, "name", 2);
O([
  U()
], Vr.prototype, "src", 2);
O([
  U()
], Vr.prototype, "label", 2);
O([
  U({ reflect: !0 })
], Vr.prototype, "library", 2);
O([
  Nt("label")
], Vr.prototype, "handleLabelChange", 1);
O([
  Nt(["name", "src", "library"])
], Vr.prototype, "setIcon", 1);
Vr.define("sl-icon");
var FY = gr`
  :host {
    display: block;
  }

  .input {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: stretch;
    justify-content: start;
    position: relative;
    width: 100%;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    overflow: hidden;
    cursor: text;
    transition:
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) border,
      var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
  }

  /* Standard inputs */
  .input--standard {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .input--standard:hover:not(.input--disabled) {
    background-color: var(--sl-input-background-color-hover);
    border-color: var(--sl-input-border-color-hover);
  }

  .input--standard.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  .input--standard.input--focused:not(.input--disabled) .input__control {
    color: var(--sl-input-color-focus);
  }

  .input--standard.input--disabled {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input--standard.input--disabled .input__control {
    color: var(--sl-input-color-disabled);
  }

  .input--standard.input--disabled .input__control::placeholder {
    color: var(--sl-input-placeholder-color-disabled);
  }

  /* Filled inputs */
  .input--filled {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .input--filled:hover:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .input--filled.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .input--filled.input--disabled {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input__control {
    flex: 1 1 auto;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    min-width: 0;
    height: 100%;
    color: var(--sl-input-color);
    border: none;
    background: inherit;
    box-shadow: none;
    padding: 0;
    margin: 0;
    cursor: inherit;
    -webkit-appearance: none;
  }

  .input__control::-webkit-search-decoration,
  .input__control::-webkit-search-cancel-button,
  .input__control::-webkit-search-results-button,
  .input__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .input__control:-webkit-autofill,
  .input__control:-webkit-autofill:hover,
  .input__control:-webkit-autofill:focus,
  .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-background-color-hover) inset !important;
    -webkit-text-fill-color: var(--sl-color-primary-500);
    caret-color: var(--sl-input-color);
  }

  .input--filled .input__control:-webkit-autofill,
  .input--filled .input__control:-webkit-autofill:hover,
  .input--filled .input__control:-webkit-autofill:focus,
  .input--filled .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-filled-background-color) inset !important;
  }

  .input__control::placeholder {
    color: var(--sl-input-placeholder-color);
    user-select: none;
    -webkit-user-select: none;
  }

  .input:hover:not(.input--disabled) .input__control {
    color: var(--sl-input-color-hover);
  }

  .input__control:focus {
    outline: none;
  }

  .input__prefix,
  .input__suffix {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    cursor: default;
  }

  .input__prefix ::slotted(sl-icon),
  .input__suffix ::slotted(sl-icon) {
    color: var(--sl-input-icon-color);
  }

  /*
   * Size modifiers
   */

  .input--small {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
    height: var(--sl-input-height-small);
  }

  .input--small .input__control {
    height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-small);
  }

  .input--small .input__clear,
  .input--small .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-small) * 2);
  }

  .input--small .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-small);
  }

  .input--small .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-small);
  }

  .input--medium {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
    height: var(--sl-input-height-medium);
  }

  .input--medium .input__control {
    height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-medium);
  }

  .input--medium .input__clear,
  .input--medium .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-medium) * 2);
  }

  .input--medium .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-medium);
  }

  .input--medium .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-medium);
  }

  .input--large {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
    height: var(--sl-input-height-large);
  }

  .input--large .input__control {
    height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-large);
  }

  .input--large .input__clear,
  .input--large .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-large) * 2);
  }

  .input--large .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-large);
  }

  .input--large .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-large);
  }

  /*
   * Pill modifier
   */

  .input--pill.input--small {
    border-radius: var(--sl-input-height-small);
  }

  .input--pill.input--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .input--pill.input--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Clearable + Password Toggle
   */

  .input__clear,
  .input__password-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--sl-input-icon-color);
    border: none;
    background: none;
    padding: 0;
    transition: var(--sl-transition-fast) color;
    cursor: pointer;
  }

  .input__clear:hover,
  .input__password-toggle:hover {
    color: var(--sl-input-icon-color-hover);
  }

  .input__clear:focus,
  .input__password-toggle:focus {
    outline: none;
  }

  /* Don't show the browser's password toggle in Edge */
  ::-ms-reveal {
    display: none;
  }

  /* Hide the built-in number spinner */
  .input--no-spin-buttons input[type='number']::-webkit-outer-spin-button,
  .input--no-spin-buttons input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
  }

  .input--no-spin-buttons input[type='number'] {
    -moz-appearance: textfield;
  }
`, l0 = (e = "value") => (t, r) => {
  const n = t.constructor, i = n.prototype.attributeChangedCallback;
  n.prototype.attributeChangedCallback = function(a, o, s) {
    var l;
    const d = n.getPropertyOptions(e), u = typeof d.attribute == "string" ? d.attribute : e;
    if (a === u) {
      const c = d.converter || gs, f = (typeof c == "function" ? c : (l = c?.fromAttribute) != null ? l : gs.fromAttribute)(s, d.type);
      this[e] !== f && (this[r] = f);
    }
    i.call(this, a, o, s);
  };
}, d0 = gr`
  .form-control .form-control__label {
    display: none;
  }

  .form-control .form-control__help-text {
    display: none;
  }

  /* Label */
  .form-control--has-label .form-control__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    margin-bottom: var(--sl-spacing-3x-small);
  }

  .form-control--has-label.form-control--small .form-control__label {
    font-size: var(--sl-input-label-font-size-small);
  }

  .form-control--has-label.form-control--medium .form-control__label {
    font-size: var(--sl-input-label-font-size-medium);
  }

  .form-control--has-label.form-control--large .form-control__label {
    font-size: var(--sl-input-label-font-size-large);
  }

  :host([required]) .form-control--has-label .form-control__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
    color: var(--sl-input-required-content-color);
  }

  /* Help text */
  .form-control--has-help-text .form-control__help-text {
    display: block;
    color: var(--sl-input-help-text-color);
    margin-top: var(--sl-spacing-3x-small);
  }

  .form-control--has-help-text.form-control--small .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-small);
  }

  .form-control--has-help-text.form-control--medium .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-medium);
  }

  .form-control--has-help-text.form-control--large .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-large);
  }

  .form-control--has-help-text.form-control--radio-group .form-control__help-text {
    margin-top: var(--sl-spacing-2x-small);
  }
`, ol = /* @__PURE__ */ new WeakMap(), sl = /* @__PURE__ */ new WeakMap(), ll = /* @__PURE__ */ new WeakMap(), S1 = /* @__PURE__ */ new WeakSet(), nu = /* @__PURE__ */ new WeakMap(), kd = class {
  constructor(e, t) {
    this.handleFormData = (r) => {
      const n = this.options.disabled(this.host), i = this.options.name(this.host), a = this.options.value(this.host), o = this.host.tagName.toLowerCase() === "sl-button";
      this.host.isConnected && !n && !o && typeof i == "string" && i.length > 0 && typeof a < "u" && (Array.isArray(a) ? a.forEach((s) => {
        r.formData.append(i, s.toString());
      }) : r.formData.append(i, a.toString()));
    }, this.handleFormSubmit = (r) => {
      var n;
      const i = this.options.disabled(this.host), a = this.options.reportValidity;
      this.form && !this.form.noValidate && ((n = ol.get(this.form)) == null || n.forEach((o) => {
        this.setUserInteracted(o, !0);
      })), this.form && !this.form.noValidate && !i && !a(this.host) && (r.preventDefault(), r.stopImmediatePropagation());
    }, this.handleFormReset = () => {
      this.options.setValue(this.host, this.options.defaultValue(this.host)), this.setUserInteracted(this.host, !1), nu.set(this.host, []);
    }, this.handleInteraction = (r) => {
      const n = nu.get(this.host);
      n.includes(r.type) || n.push(r.type), n.length === this.options.assumeInteractionOn.length && this.setUserInteracted(this.host, !0);
    }, this.checkFormValidity = () => {
      if (this.form && !this.form.noValidate) {
        const r = this.form.querySelectorAll("*");
        for (const n of r)
          if (typeof n.checkValidity == "function" && !n.checkValidity())
            return !1;
      }
      return !0;
    }, this.reportFormValidity = () => {
      if (this.form && !this.form.noValidate) {
        const r = this.form.querySelectorAll("*");
        for (const n of r)
          if (typeof n.reportValidity == "function" && !n.reportValidity())
            return !1;
      }
      return !0;
    }, (this.host = e).addController(this), this.options = so({
      form: (r) => {
        const n = r.form;
        if (n) {
          const a = r.getRootNode().querySelector(`#${n}`);
          if (a)
            return a;
        }
        return r.closest("form");
      },
      name: (r) => r.name,
      value: (r) => r.value,
      defaultValue: (r) => r.defaultValue,
      disabled: (r) => {
        var n;
        return (n = r.disabled) != null ? n : !1;
      },
      reportValidity: (r) => typeof r.reportValidity == "function" ? r.reportValidity() : !0,
      checkValidity: (r) => typeof r.checkValidity == "function" ? r.checkValidity() : !0,
      setValue: (r, n) => r.value = n,
      assumeInteractionOn: ["sl-input"]
    }, t);
  }
  hostConnected() {
    const e = this.options.form(this.host);
    e && this.attachForm(e), nu.set(this.host, []), this.options.assumeInteractionOn.forEach((t) => {
      this.host.addEventListener(t, this.handleInteraction);
    });
  }
  hostDisconnected() {
    this.detachForm(), nu.delete(this.host), this.options.assumeInteractionOn.forEach((e) => {
      this.host.removeEventListener(e, this.handleInteraction);
    });
  }
  hostUpdated() {
    const e = this.options.form(this.host);
    e || this.detachForm(), e && this.form !== e && (this.detachForm(), this.attachForm(e)), this.host.hasUpdated && this.setValidity(this.host.validity.valid);
  }
  attachForm(e) {
    e ? (this.form = e, ol.has(this.form) ? ol.get(this.form).add(this.host) : ol.set(this.form, /* @__PURE__ */ new Set([this.host])), this.form.addEventListener("formdata", this.handleFormData), this.form.addEventListener("submit", this.handleFormSubmit), this.form.addEventListener("reset", this.handleFormReset), sl.has(this.form) || (sl.set(this.form, this.form.reportValidity), this.form.reportValidity = () => this.reportFormValidity()), ll.has(this.form) || (ll.set(this.form, this.form.checkValidity), this.form.checkValidity = () => this.checkFormValidity())) : this.form = void 0;
  }
  detachForm() {
    if (!this.form) return;
    const e = ol.get(this.form);
    e && (e.delete(this.host), e.size <= 0 && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit), this.form.removeEventListener("reset", this.handleFormReset), sl.has(this.form) && (this.form.reportValidity = sl.get(this.form), sl.delete(this.form)), ll.has(this.form) && (this.form.checkValidity = ll.get(this.form), ll.delete(this.form)), this.form = void 0));
  }
  setUserInteracted(e, t) {
    t ? S1.add(e) : S1.delete(e), e.requestUpdate();
  }
  doAction(e, t) {
    if (this.form) {
      const r = document.createElement("button");
      r.type = e, r.style.position = "absolute", r.style.width = "0", r.style.height = "0", r.style.clipPath = "inset(50%)", r.style.overflow = "hidden", r.style.whiteSpace = "nowrap", t && (r.name = t.name, r.value = t.value, ["formaction", "formenctype", "formmethod", "formnovalidate", "formtarget"].forEach((n) => {
        t.hasAttribute(n) && r.setAttribute(n, t.getAttribute(n));
      })), this.form.append(r), r.click(), r.remove();
    }
  }
  /** Returns the associated `<form>` element, if one exists. */
  getForm() {
    var e;
    return (e = this.form) != null ? e : null;
  }
  /** Resets the form, restoring all the control to their default value */
  reset(e) {
    this.doAction("reset", e);
  }
  /** Submits the form, triggering validation and form data injection. */
  submit(e) {
    this.doAction("submit", e);
  }
  /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */
  setValidity(e) {
    const t = this.host, r = !!S1.has(t), n = !!t.required;
    t.toggleAttribute("data-required", n), t.toggleAttribute("data-optional", !n), t.toggleAttribute("data-invalid", !e), t.toggleAttribute("data-valid", e), t.toggleAttribute("data-user-invalid", !e && r), t.toggleAttribute("data-user-valid", e && r);
  }
  /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */
  updateValidity() {
    const e = this.host;
    this.setValidity(e.validity.valid);
  }
  /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */
  emitInvalidEvent(e) {
    const t = new CustomEvent("sl-invalid", {
      bubbles: !1,
      composed: !1,
      cancelable: !0,
      detail: {}
    });
    e || t.preventDefault(), this.host.dispatchEvent(t) || e?.preventDefault();
  }
}, gp = Object.freeze({
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: !0,
  valueMissing: !1
});
Object.freeze(n0(so({}, gp), {
  valid: !1,
  valueMissing: !0
}));
Object.freeze(n0(so({}, gp), {
  valid: !1,
  customError: !0
}));
var ha = class {
  constructor(e, ...t) {
    this.slotNames = [], this.handleSlotChange = (r) => {
      const n = r.target;
      (this.slotNames.includes("[default]") && !n.name || n.name && this.slotNames.includes(n.name)) && this.host.requestUpdate();
    }, (this.host = e).addController(this), this.slotNames = t;
  }
  hasDefaultSlot() {
    return [...this.host.childNodes].some((e) => {
      if (e.nodeType === e.TEXT_NODE && e.textContent.trim() !== "")
        return !0;
      if (e.nodeType === e.ELEMENT_NODE) {
        const t = e;
        if (t.tagName.toLowerCase() === "sl-visually-hidden")
          return !1;
        if (!t.hasAttribute("slot"))
          return !0;
      }
      return !1;
    });
  }
  hasNamedSlot(e) {
    return this.host.querySelector(`:scope > [slot="${e}"]`) !== null;
  }
  test(e) {
    return e === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(e);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
  }
};
function RY(e) {
  if (!e)
    return "";
  const t = e.assignedNodes({ flatten: !0 });
  let r = "";
  return [...t].forEach((n) => {
    n.nodeType === Node.TEXT_NODE && (r += n.textContent);
  }), r;
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const rd = pp(class extends mp {
  constructor(e) {
    if (super(e), e.type !== Ui.PROPERTY && e.type !== Ui.ATTRIBUTE && e.type !== Ui.BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
    if (!_8(e)) throw Error("`live` bindings can only contain a single expression");
  }
  render(e) {
    return e;
  }
  update(e, [t]) {
    if (t === Tn || t === Bt) return t;
    const r = e.element, n = e.name;
    if (e.type === Ui.PROPERTY) {
      if (t === r[n]) return Tn;
    } else if (e.type === Ui.BOOLEAN_ATTRIBUTE) {
      if (!!t === r.hasAttribute(n)) return Tn;
    } else if (e.type === Ui.ATTRIBUTE && r.getAttribute(n) === t + "") return Tn;
    return LY(e), t;
  }
});
var We = class extends ar {
  constructor() {
    super(...arguments), this.formControlController = new kd(this, {
      assumeInteractionOn: ["sl-blur", "sl-input"]
    }), this.hasSlotController = new ha(this, "help-text", "label"), this.localize = new Ei(this), this.hasFocus = !1, this.title = "", this.__numberInput = Object.assign(document.createElement("input"), { type: "number" }), this.__dateInput = Object.assign(document.createElement("input"), { type: "date" }), this.type = "text", this.name = "", this.value = "", this.defaultValue = "", this.size = "medium", this.filled = !1, this.pill = !1, this.label = "", this.helpText = "", this.clearable = !1, this.disabled = !1, this.placeholder = "", this.readonly = !1, this.passwordToggle = !1, this.passwordVisible = !1, this.noSpinButtons = !1, this.form = "", this.required = !1, this.spellcheck = !0;
  }
  //
  // NOTE: We use an in-memory input for these getters/setters instead of the one in the template because the properties
  // can be set before the component is rendered.
  //
  /**
   * Gets or sets the current value as a `Date` object. Returns `null` if the value can't be converted. This will use the native `<input type="{{type}}">` implementation and may result in an error.
   */
  get valueAsDate() {
    var e;
    return this.__dateInput.type = this.type, this.__dateInput.value = this.value, ((e = this.input) == null ? void 0 : e.valueAsDate) || this.__dateInput.valueAsDate;
  }
  set valueAsDate(e) {
    this.__dateInput.type = this.type, this.__dateInput.valueAsDate = e, this.value = this.__dateInput.value;
  }
  /** Gets or sets the current value as a number. Returns `NaN` if the value can't be converted. */
  get valueAsNumber() {
    var e;
    return this.__numberInput.value = this.value, ((e = this.input) == null ? void 0 : e.valueAsNumber) || this.__numberInput.valueAsNumber;
  }
  set valueAsNumber(e) {
    this.__numberInput.valueAsNumber = e, this.value = this.__numberInput.value;
  }
  /** Gets the validity state object */
  get validity() {
    return this.input.validity;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.input.validationMessage;
  }
  firstUpdated() {
    this.formControlController.updateValidity();
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleChange() {
    this.value = this.input.value, this.emit("sl-change");
  }
  handleClearClick(e) {
    e.preventDefault(), this.value !== "" && (this.value = "", this.emit("sl-clear"), this.emit("sl-input"), this.emit("sl-change")), this.input.focus();
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleInput() {
    this.value = this.input.value, this.formControlController.updateValidity(), this.emit("sl-input");
  }
  handleInvalid(e) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(e);
  }
  handleKeyDown(e) {
    const t = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
    e.key === "Enter" && !t && setTimeout(() => {
      !e.defaultPrevented && !e.isComposing && this.formControlController.submit();
    });
  }
  handlePasswordToggle() {
    this.passwordVisible = !this.passwordVisible;
  }
  handleDisabledChange() {
    this.formControlController.setValidity(this.disabled);
  }
  handleStepChange() {
    this.input.step = String(this.step), this.formControlController.updateValidity();
  }
  async handleValueChange() {
    await this.updateComplete, this.formControlController.updateValidity();
  }
  /** Sets focus on the input. */
  focus(e) {
    this.input.focus(e);
  }
  /** Removes focus from the input. */
  blur() {
    this.input.blur();
  }
  /** Selects all the text in the input. */
  select() {
    this.input.select();
  }
  /** Sets the start and end positions of the text selection (0-based). */
  setSelectionRange(e, t, r = "none") {
    this.input.setSelectionRange(e, t, r);
  }
  /** Replaces a range of text with a new string. */
  setRangeText(e, t, r, n = "preserve") {
    const i = t ?? this.input.selectionStart, a = r ?? this.input.selectionEnd;
    this.input.setRangeText(e, i, a, n), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Displays the browser picker for an input element (only works if the browser supports it for the input type). */
  showPicker() {
    "showPicker" in HTMLInputElement.prototype && this.input.showPicker();
  }
  /** Increments the value of a numeric input type by the value of the step attribute. */
  stepUp() {
    this.input.stepUp(), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Decrements the value of a numeric input type by the value of the step attribute. */
  stepDown() {
    this.input.stepDown(), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.input.checkValidity();
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return this.input.reportValidity();
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(e) {
    this.input.setCustomValidity(e), this.formControlController.updateValidity();
  }
  render() {
    const e = this.hasSlotController.test("label"), t = this.hasSlotController.test("help-text"), r = this.label ? !0 : !!e, n = this.helpText ? !0 : !!t, a = this.clearable && !this.disabled && !this.readonly && (typeof this.value == "number" || this.value.length > 0);
    return xt`
      <div
        part="form-control"
        class=${dr({
      "form-control": !0,
      "form-control--small": this.size === "small",
      "form-control--medium": this.size === "medium",
      "form-control--large": this.size === "large",
      "form-control--has-label": r,
      "form-control--has-help-text": n
    })}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${r ? "false" : "true"}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${dr({
      input: !0,
      // Sizes
      "input--small": this.size === "small",
      "input--medium": this.size === "medium",
      "input--large": this.size === "large",
      // States
      "input--pill": this.pill,
      "input--standard": !this.filled,
      "input--filled": this.filled,
      "input--disabled": this.disabled,
      "input--focused": this.hasFocus,
      "input--empty": !this.value,
      "input--no-spin-buttons": this.noSpinButtons
    })}
          >
            <span part="prefix" class="input__prefix">
              <slot name="prefix"></slot>
            </span>

            <input
              part="input"
              id="input"
              class="input__control"
              type=${this.type === "password" && this.passwordVisible ? "text" : this.type}
              title=${this.title}
              name=${Me(this.name)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${Me(this.placeholder)}
              minlength=${Me(this.minlength)}
              maxlength=${Me(this.maxlength)}
              min=${Me(this.min)}
              max=${Me(this.max)}
              step=${Me(this.step)}
              .value=${rd(this.value)}
              autocapitalize=${Me(this.autocapitalize)}
              autocomplete=${Me(this.autocomplete)}
              autocorrect=${Me(this.autocorrect)}
              ?autofocus=${this.autofocus}
              spellcheck=${this.spellcheck}
              pattern=${Me(this.pattern)}
              enterkeyhint=${Me(this.enterkeyhint)}
              inputmode=${Me(this.inputmode)}
              aria-describedby="help-text"
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @keydown=${this.handleKeyDown}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
            />

            ${a ? xt`
                  <button
                    part="clear-button"
                    class="input__clear"
                    type="button"
                    aria-label=${this.localize.term("clearEntry")}
                    @click=${this.handleClearClick}
                    tabindex="-1"
                  >
                    <slot name="clear-icon">
                      <sl-icon name="x-circle-fill" library="system"></sl-icon>
                    </slot>
                  </button>
                ` : ""}
            ${this.passwordToggle && !this.disabled ? xt`
                  <button
                    part="password-toggle-button"
                    class="input__password-toggle"
                    type="button"
                    aria-label=${this.localize.term(this.passwordVisible ? "hidePassword" : "showPassword")}
                    @click=${this.handlePasswordToggle}
                    tabindex="-1"
                  >
                    ${this.passwordVisible ? xt`
                          <slot name="show-password-icon">
                            <sl-icon name="eye-slash" library="system"></sl-icon>
                          </slot>
                        ` : xt`
                          <slot name="hide-password-icon">
                            <sl-icon name="eye" library="system"></sl-icon>
                          </slot>
                        `}
                  </button>
                ` : ""}

            <span part="suffix" class="input__suffix">
              <slot name="suffix"></slot>
            </span>
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${n ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
  }
};
We.styles = [Ar, d0, FY];
We.dependencies = { "sl-icon": Vr };
O([
  jt(".input__control")
], We.prototype, "input", 2);
O([
  Fn()
], We.prototype, "hasFocus", 2);
O([
  U()
], We.prototype, "title", 2);
O([
  U({ reflect: !0 })
], We.prototype, "type", 2);
O([
  U()
], We.prototype, "name", 2);
O([
  U()
], We.prototype, "value", 2);
O([
  l0()
], We.prototype, "defaultValue", 2);
O([
  U({ reflect: !0 })
], We.prototype, "size", 2);
O([
  U({ type: Boolean, reflect: !0 })
], We.prototype, "filled", 2);
O([
  U({ type: Boolean, reflect: !0 })
], We.prototype, "pill", 2);
O([
  U()
], We.prototype, "label", 2);
O([
  U({ attribute: "help-text" })
], We.prototype, "helpText", 2);
O([
  U({ type: Boolean })
], We.prototype, "clearable", 2);
O([
  U({ type: Boolean, reflect: !0 })
], We.prototype, "disabled", 2);
O([
  U()
], We.prototype, "placeholder", 2);
O([
  U({ type: Boolean, reflect: !0 })
], We.prototype, "readonly", 2);
O([
  U({ attribute: "password-toggle", type: Boolean })
], We.prototype, "passwordToggle", 2);
O([
  U({ attribute: "password-visible", type: Boolean })
], We.prototype, "passwordVisible", 2);
O([
  U({ attribute: "no-spin-buttons", type: Boolean })
], We.prototype, "noSpinButtons", 2);
O([
  U({ reflect: !0 })
], We.prototype, "form", 2);
O([
  U({ type: Boolean, reflect: !0 })
], We.prototype, "required", 2);
O([
  U()
], We.prototype, "pattern", 2);
O([
  U({ type: Number })
], We.prototype, "minlength", 2);
O([
  U({ type: Number })
], We.prototype, "maxlength", 2);
O([
  U()
], We.prototype, "min", 2);
O([
  U()
], We.prototype, "max", 2);
O([
  U()
], We.prototype, "step", 2);
O([
  U()
], We.prototype, "autocapitalize", 2);
O([
  U()
], We.prototype, "autocorrect", 2);
O([
  U()
], We.prototype, "autocomplete", 2);
O([
  U({ type: Boolean })
], We.prototype, "autofocus", 2);
O([
  U()
], We.prototype, "enterkeyhint", 2);
O([
  U({
    type: Boolean,
    converter: {
      // Allow "true|false" attribute values but keep the property boolean
      fromAttribute: (e) => !(!e || e === "false"),
      toAttribute: (e) => e ? "true" : "false"
    }
  })
], We.prototype, "spellcheck", 2);
O([
  U()
], We.prototype, "inputmode", 2);
O([
  Nt("disabled", { waitUntilFirstUpdate: !0 })
], We.prototype, "handleDisabledChange", 1);
O([
  Nt("step", { waitUntilFirstUpdate: !0 })
], We.prototype, "handleStepChange", 1);
O([
  Nt("value", { waitUntilFirstUpdate: !0 })
], We.prototype, "handleValueChange", 1);
We.define("sl-input");
var zY = gr`
  :host {
    --submenu-offset: -2px;

    display: block;
  }

  :host([inert]) {
    display: none;
  }

  .menu-item {
    position: relative;
    display: flex;
    align-items: stretch;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    line-height: var(--sl-line-height-normal);
    letter-spacing: var(--sl-letter-spacing-normal);
    color: var(--sl-color-neutral-700);
    padding: var(--sl-spacing-2x-small) var(--sl-spacing-2x-small);
    transition: var(--sl-transition-fast) fill;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    cursor: pointer;
  }

  .menu-item.menu-item--disabled {
    outline: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .menu-item.menu-item--loading {
    outline: none;
    cursor: wait;
  }

  .menu-item.menu-item--loading *:not(sl-spinner) {
    opacity: 0.5;
  }

  .menu-item--loading sl-spinner {
    --indicator-color: currentColor;
    --track-width: 1px;
    position: absolute;
    font-size: 0.75em;
    top: calc(50% - 0.5em);
    left: 0.65rem;
    opacity: 1;
  }

  .menu-item .menu-item__label {
    flex: 1 1 auto;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .menu-item .menu-item__prefix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .menu-item .menu-item__prefix::slotted(*) {
    margin-inline-end: var(--sl-spacing-x-small);
  }

  .menu-item .menu-item__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .menu-item .menu-item__suffix::slotted(*) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  /* Safe triangle */
  .menu-item--submenu-expanded::after {
    content: '';
    position: fixed;
    z-index: calc(var(--sl-z-index-dropdown) - 1);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--safe-triangle-cursor-x, 0) var(--safe-triangle-cursor-y, 0),
      var(--safe-triangle-submenu-start-x, 0) var(--safe-triangle-submenu-start-y, 0),
      var(--safe-triangle-submenu-end-x, 0) var(--safe-triangle-submenu-end-y, 0)
    );
  }

  :host(:focus-visible) {
    outline: none;
  }

  :host(:hover:not([aria-disabled='true'], :focus-visible)) .menu-item,
  .menu-item--submenu-expanded {
    background-color: var(--sl-color-neutral-100);
    color: var(--sl-color-neutral-1000);
  }

  :host(:focus-visible) .menu-item {
    outline: none;
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
    opacity: 1;
  }

  .menu-item .menu-item__check,
  .menu-item .menu-item__chevron {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5em;
    visibility: hidden;
  }

  .menu-item--checked .menu-item__check,
  .menu-item--has-submenu .menu-item__chevron {
    visibility: visible;
  }

  /* Add elevation and z-index to submenus */
  sl-popup::part(popup) {
    box-shadow: var(--sl-shadow-large);
    z-index: var(--sl-z-index-dropdown);
    margin-left: var(--submenu-offset);
  }

  .menu-item--rtl sl-popup::part(popup) {
    margin-left: calc(-1 * var(--submenu-offset));
  }

  @media (forced-colors: active) {
    :host(:hover:not([aria-disabled='true'])) .menu-item,
    :host(:focus-visible) .menu-item {
      outline: dashed 1px SelectedItem;
      outline-offset: -1px;
    }
  }

  ::slotted(sl-menu) {
    max-width: var(--auto-size-available-width) !important;
    max-height: var(--auto-size-available-height) !important;
  }
`;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Dl = (e, t) => {
  const r = e._$AN;
  if (r === void 0) return !1;
  for (const n of r) n._$AO?.(t, !1), Dl(n, t);
  return !0;
}, gc = (e) => {
  let t, r;
  do {
    if ((t = e._$AM) === void 0) break;
    r = t._$AN, r.delete(e), e = t;
  } while (r?.size === 0);
}, C8 = (e) => {
  for (let t; t = e._$AM; e = t) {
    let r = t._$AN;
    if (r === void 0) t._$AN = r = /* @__PURE__ */ new Set();
    else if (r.has(e)) break;
    r.add(e), UY(t);
  }
};
function jY(e) {
  this._$AN !== void 0 ? (gc(this), this._$AM = e, C8(this)) : this._$AM = e;
}
function VY(e, t = !1, r = 0) {
  const n = this._$AH, i = this._$AN;
  if (i !== void 0 && i.size !== 0) if (t) if (Array.isArray(n)) for (let a = r; a < n.length; a++) Dl(n[a], !1), gc(n[a]);
  else n != null && (Dl(n, !1), gc(n));
  else Dl(this, e);
}
const UY = (e) => {
  e.type == Ui.CHILD && (e._$AP ??= VY, e._$AQ ??= jY);
};
class qY extends mp {
  constructor() {
    super(...arguments), this._$AN = void 0;
  }
  _$AT(t, r, n) {
    super._$AT(t, r, n), C8(this), this.isConnected = t._$AU;
  }
  _$AO(t, r = !0) {
    t !== this.isConnected && (this.isConnected = t, t ? this.reconnected?.() : this.disconnected?.()), r && (Dl(this, t), gc(this));
  }
  setValue(t) {
    if (_8(this._$Ct)) this._$Ct._$AI(t, this);
    else {
      const r = [...this._$Ct._$AH];
      r[this._$Ci] = t, this._$Ct._$AI(r, this, 0);
    }
  }
  disconnected() {
  }
  reconnected() {
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const BY = () => new HY();
class HY {
}
const E1 = /* @__PURE__ */ new WeakMap(), WY = pp(class extends qY {
  render(e) {
    return Bt;
  }
  update(e, [t]) {
    const r = t !== this.Y;
    return r && this.Y !== void 0 && this.rt(void 0), (r || this.lt !== this.ct) && (this.Y = t, this.ht = e.options?.host, this.rt(this.ct = e.element)), Bt;
  }
  rt(e) {
    if (this.isConnected || (e = void 0), typeof this.Y == "function") {
      const t = this.ht ?? globalThis;
      let r = E1.get(t);
      r === void 0 && (r = /* @__PURE__ */ new WeakMap(), E1.set(t, r)), r.get(this.Y) !== void 0 && this.Y.call(this.ht, void 0), r.set(this.Y, e), e !== void 0 && this.Y.call(this.ht, e);
    } else this.Y.value = e;
  }
  get lt() {
    return typeof this.Y == "function" ? E1.get(this.ht ?? globalThis)?.get(this.Y) : this.Y?.value;
  }
  disconnected() {
    this.lt === this.ct && this.rt(void 0);
  }
  reconnected() {
    this.rt(this.ct);
  }
});
var QY = class {
  constructor(e, t) {
    this.popupRef = BY(), this.enableSubmenuTimer = -1, this.isConnected = !1, this.isPopupConnected = !1, this.skidding = 0, this.submenuOpenDelay = 100, this.handleMouseMove = (r) => {
      this.host.style.setProperty("--safe-triangle-cursor-x", `${r.clientX}px`), this.host.style.setProperty("--safe-triangle-cursor-y", `${r.clientY}px`);
    }, this.handleMouseOver = () => {
      this.hasSlotController.test("submenu") && this.enableSubmenu();
    }, this.handleKeyDown = (r) => {
      switch (r.key) {
        case "Escape":
        case "Tab":
          this.disableSubmenu();
          break;
        case "ArrowLeft":
          r.target !== this.host && (r.preventDefault(), r.stopPropagation(), this.host.focus(), this.disableSubmenu());
          break;
        case "ArrowRight":
        case "Enter":
        case " ":
          this.handleSubmenuEntry(r);
          break;
      }
    }, this.handleClick = (r) => {
      var n;
      r.target === this.host ? (r.preventDefault(), r.stopPropagation()) : r.target instanceof Element && (r.target.tagName === "sl-menu-item" || (n = r.target.role) != null && n.startsWith("menuitem")) && this.disableSubmenu();
    }, this.handleFocusOut = (r) => {
      r.relatedTarget && r.relatedTarget instanceof Element && this.host.contains(r.relatedTarget) || this.disableSubmenu();
    }, this.handlePopupMouseover = (r) => {
      r.stopPropagation();
    }, this.handlePopupReposition = () => {
      const r = this.host.renderRoot.querySelector("slot[name='submenu']"), n = r?.assignedElements({ flatten: !0 }).filter((d) => d.localName === "sl-menu")[0], i = getComputedStyle(this.host).direction === "rtl";
      if (!n)
        return;
      const { left: a, top: o, width: s, height: l } = n.getBoundingClientRect();
      this.host.style.setProperty("--safe-triangle-submenu-start-x", `${i ? a + s : a}px`), this.host.style.setProperty("--safe-triangle-submenu-start-y", `${o}px`), this.host.style.setProperty("--safe-triangle-submenu-end-x", `${i ? a + s : a}px`), this.host.style.setProperty("--safe-triangle-submenu-end-y", `${o + l}px`);
    }, (this.host = e).addController(this), this.hasSlotController = t;
  }
  hostConnected() {
    this.hasSlotController.test("submenu") && !this.host.disabled && this.addListeners();
  }
  hostDisconnected() {
    this.removeListeners();
  }
  hostUpdated() {
    this.hasSlotController.test("submenu") && !this.host.disabled ? (this.addListeners(), this.updateSkidding()) : this.removeListeners();
  }
  addListeners() {
    this.isConnected || (this.host.addEventListener("mousemove", this.handleMouseMove), this.host.addEventListener("mouseover", this.handleMouseOver), this.host.addEventListener("keydown", this.handleKeyDown), this.host.addEventListener("click", this.handleClick), this.host.addEventListener("focusout", this.handleFocusOut), this.isConnected = !0), this.isPopupConnected || this.popupRef.value && (this.popupRef.value.addEventListener("mouseover", this.handlePopupMouseover), this.popupRef.value.addEventListener("sl-reposition", this.handlePopupReposition), this.isPopupConnected = !0);
  }
  removeListeners() {
    this.isConnected && (this.host.removeEventListener("mousemove", this.handleMouseMove), this.host.removeEventListener("mouseover", this.handleMouseOver), this.host.removeEventListener("keydown", this.handleKeyDown), this.host.removeEventListener("click", this.handleClick), this.host.removeEventListener("focusout", this.handleFocusOut), this.isConnected = !1), this.isPopupConnected && this.popupRef.value && (this.popupRef.value.removeEventListener("mouseover", this.handlePopupMouseover), this.popupRef.value.removeEventListener("sl-reposition", this.handlePopupReposition), this.isPopupConnected = !1);
  }
  handleSubmenuEntry(e) {
    const t = this.host.renderRoot.querySelector("slot[name='submenu']");
    if (!t) {
      console.error("Cannot activate a submenu if no corresponding menuitem can be found.", this);
      return;
    }
    let r = null;
    for (const n of t.assignedElements())
      if (r = n.querySelectorAll("sl-menu-item, [role^='menuitem']"), r.length !== 0)
        break;
    if (!(!r || r.length === 0)) {
      r[0].setAttribute("tabindex", "0");
      for (let n = 1; n !== r.length; ++n)
        r[n].setAttribute("tabindex", "-1");
      this.popupRef.value && (e.preventDefault(), e.stopPropagation(), this.popupRef.value.active ? r[0] instanceof HTMLElement && r[0].focus() : (this.enableSubmenu(!1), this.host.updateComplete.then(() => {
        r[0] instanceof HTMLElement && r[0].focus();
      }), this.host.requestUpdate()));
    }
  }
  setSubmenuState(e) {
    this.popupRef.value && this.popupRef.value.active !== e && (this.popupRef.value.active = e, this.host.requestUpdate());
  }
  // Shows the submenu. Supports disabling the opening delay, e.g. for keyboard events that want to set the focus to the
  // newly opened menu.
  enableSubmenu(e = !0) {
    e ? (window.clearTimeout(this.enableSubmenuTimer), this.enableSubmenuTimer = window.setTimeout(() => {
      this.setSubmenuState(!0);
    }, this.submenuOpenDelay)) : this.setSubmenuState(!0);
  }
  disableSubmenu() {
    window.clearTimeout(this.enableSubmenuTimer), this.setSubmenuState(!1);
  }
  // Calculate the space the top of a menu takes-up, for aligning the popup menu-item with the activating element.
  updateSkidding() {
    var e;
    if (!((e = this.host.parentElement) != null && e.computedStyleMap))
      return;
    const t = this.host.parentElement.computedStyleMap(), n = ["padding-top", "border-top-width", "margin-top"].reduce((i, a) => {
      var o;
      const s = (o = t.get(a)) != null ? o : new CSSUnitValue(0, "px"), d = (s instanceof CSSUnitValue ? s : new CSSUnitValue(0, "px")).to("px");
      return i - d.value;
    }, 0);
    this.skidding = n;
  }
  isExpanded() {
    return this.popupRef.value ? this.popupRef.value.active : !1;
  }
  renderSubmenu() {
    const e = getComputedStyle(this.host).direction === "rtl";
    return this.isConnected ? xt`
      <sl-popup
        ${WY(this.popupRef)}
        placement=${e ? "left-start" : "right-start"}
        anchor="anchor"
        flip
        flip-fallback-strategy="best-fit"
        skidding="${this.skidding}"
        strategy="fixed"
        auto-size="vertical"
        auto-size-padding="10"
      >
        <slot name="submenu"></slot>
      </sl-popup>
    ` : xt` <slot name="submenu" hidden></slot> `;
  }
}, GY = gr`
  :host {
    --track-width: 2px;
    --track-color: rgb(128 128 128 / 25%);
    --indicator-color: var(--sl-color-primary-600);
    --speed: 2s;

    display: inline-flex;
    width: 1em;
    height: 1em;
    flex: none;
  }

  .spinner {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .spinner__track,
  .spinner__indicator {
    fill: none;
    stroke-width: var(--track-width);
    r: calc(0.5em - var(--track-width) / 2);
    cx: 0.5em;
    cy: 0.5em;
    transform-origin: 50% 50%;
  }

  .spinner__track {
    stroke: var(--track-color);
    transform-origin: 0% 0%;
  }

  .spinner__indicator {
    stroke: var(--indicator-color);
    stroke-linecap: round;
    stroke-dasharray: 150% 75%;
    animation: spin var(--speed) linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
      stroke-dasharray: 0.05em, 3em;
    }

    50% {
      transform: rotate(450deg);
      stroke-dasharray: 1.375em, 1.375em;
    }

    100% {
      transform: rotate(1080deg);
      stroke-dasharray: 0.05em, 3em;
    }
  }
`, u0 = class extends ar {
  constructor() {
    super(...arguments), this.localize = new Ei(this);
  }
  render() {
    return xt`
      <svg part="base" class="spinner" role="progressbar" aria-label=${this.localize.term("loading")}>
        <circle class="spinner__track"></circle>
        <circle class="spinner__indicator"></circle>
      </svg>
    `;
  }
};
u0.styles = [Ar, GY];
var fn = class extends ar {
  constructor() {
    super(...arguments), this.localize = new Ei(this), this.type = "normal", this.checked = !1, this.value = "", this.loading = !1, this.disabled = !1, this.hasSlotController = new ha(this, "submenu"), this.submenuController = new QY(this, this.hasSlotController), this.handleHostClick = (e) => {
      this.disabled && (e.preventDefault(), e.stopImmediatePropagation());
    }, this.handleMouseOver = (e) => {
      this.focus(), e.stopPropagation();
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", this.handleHostClick), this.addEventListener("mouseover", this.handleMouseOver);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("click", this.handleHostClick), this.removeEventListener("mouseover", this.handleMouseOver);
  }
  handleDefaultSlotChange() {
    const e = this.getTextLabel();
    if (typeof this.cachedTextLabel > "u") {
      this.cachedTextLabel = e;
      return;
    }
    e !== this.cachedTextLabel && (this.cachedTextLabel = e, this.emit("slotchange", { bubbles: !0, composed: !1, cancelable: !1 }));
  }
  handleCheckedChange() {
    if (this.checked && this.type !== "checkbox") {
      this.checked = !1, console.error('The checked attribute can only be used on menu items with type="checkbox"', this);
      return;
    }
    this.type === "checkbox" ? this.setAttribute("aria-checked", this.checked ? "true" : "false") : this.removeAttribute("aria-checked");
  }
  handleDisabledChange() {
    this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  handleTypeChange() {
    this.type === "checkbox" ? (this.setAttribute("role", "menuitemcheckbox"), this.setAttribute("aria-checked", this.checked ? "true" : "false")) : (this.setAttribute("role", "menuitem"), this.removeAttribute("aria-checked"));
  }
  /** Returns a text label based on the contents of the menu item's default slot. */
  getTextLabel() {
    return RY(this.defaultSlot);
  }
  isSubmenu() {
    return this.hasSlotController.test("submenu");
  }
  render() {
    const e = this.localize.dir() === "rtl", t = this.submenuController.isExpanded();
    return xt`
      <div
        id="anchor"
        part="base"
        class=${dr({
      "menu-item": !0,
      "menu-item--rtl": e,
      "menu-item--checked": this.checked,
      "menu-item--disabled": this.disabled,
      "menu-item--loading": this.loading,
      "menu-item--has-submenu": this.isSubmenu(),
      "menu-item--submenu-expanded": t
    })}
        ?aria-haspopup="${this.isSubmenu()}"
        ?aria-expanded="${!!t}"
      >
        <span part="checked-icon" class="menu-item__check">
          <sl-icon name="check" library="system" aria-hidden="true"></sl-icon>
        </span>

        <slot name="prefix" part="prefix" class="menu-item__prefix"></slot>

        <slot part="label" class="menu-item__label" @slotchange=${this.handleDefaultSlotChange}></slot>

        <slot name="suffix" part="suffix" class="menu-item__suffix"></slot>

        <span part="submenu-icon" class="menu-item__chevron">
          <sl-icon name=${e ? "chevron-left" : "chevron-right"} library="system" aria-hidden="true"></sl-icon>
        </span>

        ${this.submenuController.renderSubmenu()}
        ${this.loading ? xt` <sl-spinner part="spinner" exportparts="base:spinner__base"></sl-spinner> ` : ""}
      </div>
    `;
  }
};
fn.styles = [Ar, zY];
fn.dependencies = {
  "sl-icon": Vr,
  "sl-popup": At,
  "sl-spinner": u0
};
O([
  jt("slot:not([name])")
], fn.prototype, "defaultSlot", 2);
O([
  jt(".menu-item")
], fn.prototype, "menuItem", 2);
O([
  U()
], fn.prototype, "type", 2);
O([
  U({ type: Boolean, reflect: !0 })
], fn.prototype, "checked", 2);
O([
  U()
], fn.prototype, "value", 2);
O([
  U({ type: Boolean, reflect: !0 })
], fn.prototype, "loading", 2);
O([
  U({ type: Boolean, reflect: !0 })
], fn.prototype, "disabled", 2);
O([
  Nt("checked")
], fn.prototype, "handleCheckedChange", 1);
O([
  Nt("disabled")
], fn.prototype, "handleDisabledChange", 1);
O([
  Nt("type")
], fn.prototype, "handleTypeChange", 1);
fn.define("sl-menu-item");
var YY = gr`
  :host {
    display: block;
    position: relative;
    background: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-radius: var(--sl-border-radius-medium);
    padding: var(--sl-spacing-x-small) 0;
    overflow: auto;
    overscroll-behavior: none;
  }

  ::slotted(sl-divider) {
    --spacing: var(--sl-spacing-x-small);
  }
`, vp = class extends ar {
  connectedCallback() {
    super.connectedCallback(), this.setAttribute("role", "menu");
  }
  handleClick(e) {
    const t = ["menuitem", "menuitemcheckbox"], r = e.composedPath(), n = r.find((s) => {
      var l;
      return t.includes(((l = s?.getAttribute) == null ? void 0 : l.call(s, "role")) || "");
    });
    if (!n || r.find((s) => {
      var l;
      return ((l = s?.getAttribute) == null ? void 0 : l.call(s, "role")) === "menu";
    }) !== this) return;
    const o = n;
    o.type === "checkbox" && (o.checked = !o.checked), this.emit("sl-select", { detail: { item: o } });
  }
  handleKeyDown(e) {
    if (e.key === "Enter" || e.key === " ") {
      const t = this.getCurrentItem();
      e.preventDefault(), e.stopPropagation(), t?.click();
    } else if (["ArrowDown", "ArrowUp", "Home", "End"].includes(e.key)) {
      const t = this.getAllItems(), r = this.getCurrentItem();
      let n = r ? t.indexOf(r) : 0;
      t.length > 0 && (e.preventDefault(), e.stopPropagation(), e.key === "ArrowDown" ? n++ : e.key === "ArrowUp" ? n-- : e.key === "Home" ? n = 0 : e.key === "End" && (n = t.length - 1), n < 0 && (n = t.length - 1), n > t.length - 1 && (n = 0), this.setCurrentItem(t[n]), t[n].focus());
    }
  }
  handleMouseDown(e) {
    const t = e.target;
    this.isMenuItem(t) && this.setCurrentItem(t);
  }
  handleSlotChange() {
    const e = this.getAllItems();
    e.length > 0 && this.setCurrentItem(e[0]);
  }
  isMenuItem(e) {
    var t;
    return e.tagName.toLowerCase() === "sl-menu-item" || ["menuitem", "menuitemcheckbox", "menuitemradio"].includes((t = e.getAttribute("role")) != null ? t : "");
  }
  /** @internal Gets all slotted menu items, ignoring dividers, headers, and other elements. */
  getAllItems() {
    return [...this.defaultSlot.assignedElements({ flatten: !0 })].filter((e) => !(e.inert || !this.isMenuItem(e)));
  }
  /**
   * @internal Gets the current menu item, which is the menu item that has `tabindex="0"` within the roving tab index.
   * The menu item may or may not have focus, but for keyboard interaction purposes it's considered the "active" item.
   */
  getCurrentItem() {
    return this.getAllItems().find((e) => e.getAttribute("tabindex") === "0");
  }
  /**
   * @internal Sets the current menu item to the specified element. This sets `tabindex="0"` on the target element and
   * `tabindex="-1"` to all other items. This method must be called prior to setting focus on a menu item.
   */
  setCurrentItem(e) {
    this.getAllItems().forEach((r) => {
      r.setAttribute("tabindex", r === e ? "0" : "-1");
    });
  }
  render() {
    return xt`
      <slot
        @slotchange=${this.handleSlotChange}
        @click=${this.handleClick}
        @keydown=${this.handleKeyDown}
        @mousedown=${this.handleMouseDown}
      ></slot>
    `;
  }
};
vp.styles = [Ar, YY];
O([
  jt("slot")
], vp.prototype, "defaultSlot", 2);
vp.define("sl-menu");
u0.define("sl-spinner");
const Ur = ':host,.sl-theme-dark{color-scheme:dark;--sl-color-gray-50: hsl(240 5.1% 15%);--sl-color-gray-100: hsl(240 5.7% 18.2%);--sl-color-gray-200: hsl(240 4.6% 22%);--sl-color-gray-300: hsl(240 5% 27.6%);--sl-color-gray-400: hsl(240 5% 35.5%);--sl-color-gray-500: hsl(240 3.7% 44%);--sl-color-gray-600: hsl(240 5.3% 58%);--sl-color-gray-700: hsl(240 5.6% 73%);--sl-color-gray-800: hsl(240 7.3% 84%);--sl-color-gray-900: hsl(240 9.1% 91.8%);--sl-color-gray-950: hsl(0 0% 95%);--sl-color-red-50: hsl(0 56% 23.9%);--sl-color-red-100: hsl(.6 60% 33.9%);--sl-color-red-200: hsl(.9 67.2% 37.1%);--sl-color-red-300: hsl(1.1 71.3% 43.7%);--sl-color-red-400: hsl(1 76% 52.5%);--sl-color-red-500: hsl(.7 89.6% 57.2%);--sl-color-red-600: hsl(0 98.6% 67.9%);--sl-color-red-700: hsl(0 100% 72.3%);--sl-color-red-800: hsl(0 100% 85.6%);--sl-color-red-900: hsl(0 100% 90.3%);--sl-color-red-950: hsl(0 100% 95.9%);--sl-color-orange-50: hsl(15 64.2% 23.3%);--sl-color-orange-100: hsl(15.1 70.9% 31.1%);--sl-color-orange-200: hsl(15.3 75.7% 35.5%);--sl-color-orange-300: hsl(17.1 83.5% 42.7%);--sl-color-orange-400: hsl(20.1 88% 50.8%);--sl-color-orange-500: hsl(24.3 100% 50.5%);--sl-color-orange-600: hsl(27.2 100% 57.7%);--sl-color-orange-700: hsl(31.3 100% 68.7%);--sl-color-orange-800: hsl(33.8 100% 79.3%);--sl-color-orange-900: hsl(38.9 100% 87.7%);--sl-color-orange-950: hsl(46.2 100% 95%);--sl-color-amber-50: hsl(21.9 66.3% 21.1%);--sl-color-amber-100: hsl(21.5 73.6% 29.7%);--sl-color-amber-200: hsl(22.3 77.6% 33.3%);--sl-color-amber-300: hsl(25.4 84.2% 39.6%);--sl-color-amber-400: hsl(31.4 87.4% 46.7%);--sl-color-amber-500: hsl(37 96.6% 48.3%);--sl-color-amber-600: hsl(43.3 100% 53.4%);--sl-color-amber-700: hsl(46.5 100% 61.1%);--sl-color-amber-800: hsl(49.3 100% 73%);--sl-color-amber-900: hsl(51.8 100% 85%);--sl-color-amber-950: hsl(60 100% 94.6%);--sl-color-yellow-50: hsl(32.5 60% 18.2%);--sl-color-yellow-100: hsl(28.1 68.6% 29%);--sl-color-yellow-200: hsl(31.3 75.8% 30.8%);--sl-color-yellow-300: hsl(34.7 84.4% 35.3%);--sl-color-yellow-400: hsl(40.1 87.3% 43.3%);--sl-color-yellow-500: hsl(44.7 88% 46%);--sl-color-yellow-600: hsl(47.7 100% 50.9%);--sl-color-yellow-700: hsl(51.3 100% 59.9%);--sl-color-yellow-800: hsl(54.6 100% 73%);--sl-color-yellow-900: hsl(58.9 100% 84.2%);--sl-color-yellow-950: hsl(60 100% 94%);--sl-color-lime-50: hsl(86.5 54.4% 18%);--sl-color-lime-100: hsl(87.6 56.8% 23.3%);--sl-color-lime-200: hsl(85.8 63.2% 24.5%);--sl-color-lime-300: hsl(86.1 72% 29.4%);--sl-color-lime-400: hsl(85.5 76.8% 37.3%);--sl-color-lime-500: hsl(84.3 74.2% 42.1%);--sl-color-lime-600: hsl(82.8 81.5% 52.6%);--sl-color-lime-700: hsl(82 89.9% 64%);--sl-color-lime-800: hsl(80.9 97.9% 76.6%);--sl-color-lime-900: hsl(77.9 100% 85.8%);--sl-color-lime-950: hsl(69.5 100% 93.8%);--sl-color-green-50: hsl(144.3 53.6% 16%);--sl-color-green-100: hsl(143.2 55.4% 23.5%);--sl-color-green-200: hsl(141.5 58.2% 26.3%);--sl-color-green-300: hsl(140.8 64.2% 31.8%);--sl-color-green-400: hsl(140.3 68% 39.2%);--sl-color-green-500: hsl(141.1 64.9% 43%);--sl-color-green-600: hsl(141.6 72.4% 55.2%);--sl-color-green-700: hsl(141.7 82.7% 70.1%);--sl-color-green-800: hsl(141 90.9% 82.1%);--sl-color-green-900: hsl(142 100% 89.1%);--sl-color-green-950: hsl(144 100% 95.5%);--sl-color-emerald-50: hsl(164.3 75% 13.5%);--sl-color-emerald-100: hsl(163.5 72.6% 20.1%);--sl-color-emerald-200: hsl(162.1 73.7% 22.4%);--sl-color-emerald-300: hsl(161.3 77.3% 27.6%);--sl-color-emerald-400: hsl(159.6 77.1% 34.3%);--sl-color-emerald-500: hsl(159.1 73.5% 37.9%);--sl-color-emerald-600: hsl(157.8 66.8% 48.9%);--sl-color-emerald-700: hsl(156.2 76.1% 63.8%);--sl-color-emerald-800: hsl(152.4 84.4% 77.4%);--sl-color-emerald-900: hsl(149.3 100% 87%);--sl-color-emerald-950: hsl(158.6 100% 94.8%);--sl-color-teal-50: hsl(176.5 51.5% 15.4%);--sl-color-teal-100: hsl(175.9 54.7% 22.3%);--sl-color-teal-200: hsl(175.9 60.7% 23.9%);--sl-color-teal-300: hsl(174.5 67.3% 28.8%);--sl-color-teal-400: hsl(174.4 71.9% 34.9%);--sl-color-teal-500: hsl(173.1 71% 38.3%);--sl-color-teal-600: hsl(172.3 68.2% 48.1%);--sl-color-teal-700: hsl(170.5 81.3% 61.5%);--sl-color-teal-800: hsl(168.4 92.1% 75.2%);--sl-color-teal-900: hsl(168.3 100% 86%);--sl-color-teal-950: hsl(180 100% 95.5%);--sl-color-cyan-50: hsl(197.1 53.8% 20.3%);--sl-color-cyan-100: hsl(196.8 57.3% 27.2%);--sl-color-cyan-200: hsl(195.3 62.7% 29.4%);--sl-color-cyan-300: hsl(193.5 71.3% 34.1%);--sl-color-cyan-400: hsl(192.5 76.8% 40.6%);--sl-color-cyan-500: hsl(189.4 78.6% 42.6%);--sl-color-cyan-600: hsl(188.2 89.1% 51.7%);--sl-color-cyan-700: hsl(187 98.6% 66.2%);--sl-color-cyan-800: hsl(184.9 100% 78.3%);--sl-color-cyan-900: hsl(180 100% 86.6%);--sl-color-cyan-950: hsl(180 100% 94.8%);--sl-color-sky-50: hsl(203 63.8% 20.9%);--sl-color-sky-100: hsl(203.4 70.4% 28%);--sl-color-sky-200: hsl(202.7 75.8% 30.8%);--sl-color-sky-300: hsl(203.1 80.4% 36.1%);--sl-color-sky-400: hsl(202.1 80.5% 44.3%);--sl-color-sky-500: hsl(199.7 85.9% 47.7%);--sl-color-sky-600: hsl(198.7 97.9% 57.2%);--sl-color-sky-700: hsl(198.7 100% 70.5%);--sl-color-sky-800: hsl(198.8 100% 82.5%);--sl-color-sky-900: hsl(198.5 100% 89.9%);--sl-color-sky-950: hsl(186 100% 95.5%);--sl-color-blue-50: hsl(227.1 49.5% 22.7%);--sl-color-blue-100: hsl(225.8 58.9% 36.8%);--sl-color-blue-200: hsl(227.7 64.4% 42.9%);--sl-color-blue-300: hsl(226.1 72.7% 51.2%);--sl-color-blue-400: hsl(222.6 86.5% 56.3%);--sl-color-blue-500: hsl(217.8 95.8% 57.4%);--sl-color-blue-600: hsl(213.3 100% 65%);--sl-color-blue-700: hsl(210.9 100% 74.8%);--sl-color-blue-800: hsl(211.5 100% 83.4%);--sl-color-blue-900: hsl(211 100% 88.9%);--sl-color-blue-950: hsl(201.8 100% 95.3%);--sl-color-indigo-50: hsl(243.5 40.8% 27%);--sl-color-indigo-100: hsl(242.9 45.7% 37.6%);--sl-color-indigo-200: hsl(244.7 52.7% 43.1%);--sl-color-indigo-300: hsl(245.3 60.5% 52.4%);--sl-color-indigo-400: hsl(244.1 79.2% 60.4%);--sl-color-indigo-500: hsl(239.6 88.7% 63.8%);--sl-color-indigo-600: hsl(234.5 96.7% 70.9%);--sl-color-indigo-700: hsl(229.4 100% 78.3%);--sl-color-indigo-800: hsl(227.1 100% 85%);--sl-color-indigo-900: hsl(223.8 100% 89.9%);--sl-color-indigo-950: hsl(220 100% 95.1%);--sl-color-violet-50: hsl(265.1 57.3% 25.4%);--sl-color-violet-100: hsl(263.5 63.8% 39.4%);--sl-color-violet-200: hsl(263.4 66.2% 44.1%);--sl-color-violet-300: hsl(263.7 72.8% 52.4%);--sl-color-violet-400: hsl(262.5 87.3% 59.8%);--sl-color-violet-500: hsl(258.3 95.1% 63.2%);--sl-color-violet-600: hsl(255.1 100% 67.2%);--sl-color-violet-700: hsl(253 100% 81.5%);--sl-color-violet-800: hsl(251.7 100% 87.9%);--sl-color-violet-900: hsl(254.1 100% 91.7%);--sl-color-violet-950: hsl(257.1 100% 96.1%);--sl-color-purple-50: hsl(276 54.3% 20.5%);--sl-color-purple-100: hsl(273.6 61.8% 35.4%);--sl-color-purple-200: hsl(272.9 64% 41.4%);--sl-color-purple-300: hsl(271.9 68.1% 49.2%);--sl-color-purple-400: hsl(271.5 85.1% 57.8%);--sl-color-purple-500: hsl(270.7 96.4% 62.1%);--sl-color-purple-600: hsl(270.5 100% 71.9%);--sl-color-purple-700: hsl(270.9 100% 81.3%);--sl-color-purple-800: hsl(272.4 100% 87.7%);--sl-color-purple-900: hsl(276.7 100% 91.5%);--sl-color-purple-950: hsl(300 100% 96.5%);--sl-color-fuchsia-50: hsl(297.1 51.2% 18.6%);--sl-color-fuchsia-100: hsl(296.7 59.5% 31.5%);--sl-color-fuchsia-200: hsl(295.4 65.4% 35.1%);--sl-color-fuchsia-300: hsl(294.6 67.4% 42.2%);--sl-color-fuchsia-400: hsl(293.3 68.7% 51.2%);--sl-color-fuchsia-500: hsl(292.1 88.4% 57.7%);--sl-color-fuchsia-600: hsl(292 98.5% 59.5%);--sl-color-fuchsia-700: hsl(292.4 100% 79.5%);--sl-color-fuchsia-800: hsl(292.9 100% 86.8%);--sl-color-fuchsia-900: hsl(300 100% 91.5%);--sl-color-fuchsia-950: hsl(300 100% 96.3%);--sl-color-pink-50: hsl(336.2 59.6% 20%);--sl-color-pink-100: hsl(336.8 63.9% 34%);--sl-color-pink-200: hsl(336.8 68.7% 37.6%);--sl-color-pink-300: hsl(336.1 71.8% 44.5%);--sl-color-pink-400: hsl(333.9 74.9% 53.1%);--sl-color-pink-500: hsl(330.7 86.3% 57.7%);--sl-color-pink-600: hsl(328.6 91.5% 67.2%);--sl-color-pink-700: hsl(327.4 97.6% 78.7%);--sl-color-pink-800: hsl(325.1 100% 86.6%);--sl-color-pink-900: hsl(322.1 100% 91.3%);--sl-color-pink-950: hsl(315 100% 95.9%);--sl-color-rose-50: hsl(342.3 62.9% 21.5%);--sl-color-rose-100: hsl(342.8 68.9% 34.2%);--sl-color-rose-200: hsl(344.8 72.6% 37.3%);--sl-color-rose-300: hsl(346.9 75.8% 43.7%);--sl-color-rose-400: hsl(348.2 80.1% 52.7%);--sl-color-rose-500: hsl(350.4 94.8% 57.5%);--sl-color-rose-600: hsl(351.2 100% 58.1%);--sl-color-rose-700: hsl(352.3 100% 78.1%);--sl-color-rose-800: hsl(352 100% 86.2%);--sl-color-rose-900: hsl(354.5 100% 90.7%);--sl-color-rose-950: hsl(353.3 100% 95.7%);--sl-color-primary-50: var(--sl-color-sky-50);--sl-color-primary-100: var(--sl-color-sky-100);--sl-color-primary-200: var(--sl-color-sky-200);--sl-color-primary-300: var(--sl-color-sky-300);--sl-color-primary-400: var(--sl-color-sky-400);--sl-color-primary-500: var(--sl-color-sky-500);--sl-color-primary-600: var(--sl-color-sky-600);--sl-color-primary-700: var(--sl-color-sky-700);--sl-color-primary-800: var(--sl-color-sky-800);--sl-color-primary-900: var(--sl-color-sky-900);--sl-color-primary-950: var(--sl-color-sky-950);--sl-color-success-50: var(--sl-color-green-50);--sl-color-success-100: var(--sl-color-green-100);--sl-color-success-200: var(--sl-color-green-200);--sl-color-success-300: var(--sl-color-green-300);--sl-color-success-400: var(--sl-color-green-400);--sl-color-success-500: var(--sl-color-green-500);--sl-color-success-600: var(--sl-color-green-600);--sl-color-success-700: var(--sl-color-green-700);--sl-color-success-800: var(--sl-color-green-800);--sl-color-success-900: var(--sl-color-green-900);--sl-color-success-950: var(--sl-color-green-950);--sl-color-warning-50: var(--sl-color-amber-50);--sl-color-warning-100: var(--sl-color-amber-100);--sl-color-warning-200: var(--sl-color-amber-200);--sl-color-warning-300: var(--sl-color-amber-300);--sl-color-warning-400: var(--sl-color-amber-400);--sl-color-warning-500: var(--sl-color-amber-500);--sl-color-warning-600: var(--sl-color-amber-600);--sl-color-warning-700: var(--sl-color-amber-700);--sl-color-warning-800: var(--sl-color-amber-800);--sl-color-warning-900: var(--sl-color-amber-900);--sl-color-warning-950: var(--sl-color-amber-950);--sl-color-danger-50: var(--sl-color-red-50);--sl-color-danger-100: var(--sl-color-red-100);--sl-color-danger-200: var(--sl-color-red-200);--sl-color-danger-300: var(--sl-color-red-300);--sl-color-danger-400: var(--sl-color-red-400);--sl-color-danger-500: var(--sl-color-red-500);--sl-color-danger-600: var(--sl-color-red-600);--sl-color-danger-700: var(--sl-color-red-700);--sl-color-danger-800: var(--sl-color-red-800);--sl-color-danger-900: var(--sl-color-red-900);--sl-color-danger-950: var(--sl-color-red-950);--sl-color-neutral-50: var(--sl-color-gray-50);--sl-color-neutral-100: var(--sl-color-gray-100);--sl-color-neutral-200: var(--sl-color-gray-200);--sl-color-neutral-300: var(--sl-color-gray-300);--sl-color-neutral-400: var(--sl-color-gray-400);--sl-color-neutral-500: var(--sl-color-gray-500);--sl-color-neutral-600: var(--sl-color-gray-600);--sl-color-neutral-700: var(--sl-color-gray-700);--sl-color-neutral-800: var(--sl-color-gray-800);--sl-color-neutral-900: var(--sl-color-gray-900);--sl-color-neutral-950: var(--sl-color-gray-950);--sl-color-neutral-0: hsl(240, 5.9%, 11%);--sl-color-neutral-1000: hsl(0, 0%, 100%);--sl-border-radius-small: .1875rem;--sl-border-radius-medium: .25rem;--sl-border-radius-large: .5rem;--sl-border-radius-x-large: 1rem;--sl-border-radius-circle: 50%;--sl-border-radius-pill: 9999px;--sl-shadow-x-small: 0 1px 2px rgb(0 0 0 / 18%);--sl-shadow-small: 0 1px 2px rgb(0 0 0 / 24%);--sl-shadow-medium: 0 2px 4px rgb(0 0 0 / 24%);--sl-shadow-large: 0 2px 8px rgb(0 0 0 / 24%);--sl-shadow-x-large: 0 4px 16px rgb(0 0 0 / 24%);--sl-spacing-3x-small: .125rem;--sl-spacing-2x-small: .25rem;--sl-spacing-x-small: .5rem;--sl-spacing-small: .75rem;--sl-spacing-medium: 1rem;--sl-spacing-large: 1.25rem;--sl-spacing-x-large: 1.75rem;--sl-spacing-2x-large: 2.25rem;--sl-spacing-3x-large: 3rem;--sl-spacing-4x-large: 4.5rem;--sl-transition-x-slow: 1s;--sl-transition-slow: .5s;--sl-transition-medium: .25s;--sl-transition-fast: .15s;--sl-transition-x-fast: 50ms;--sl-font-mono: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;--sl-font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";--sl-font-serif: Georgia, "Times New Roman", serif;--sl-font-size-2x-small: .625rem;--sl-font-size-x-small: .75rem;--sl-font-size-small: .875rem;--sl-font-size-medium: 1rem;--sl-font-size-large: 1.25rem;--sl-font-size-x-large: 1.5rem;--sl-font-size-2x-large: 2.25rem;--sl-font-size-3x-large: 3rem;--sl-font-size-4x-large: 4.5rem;--sl-font-weight-light: 300;--sl-font-weight-normal: 400;--sl-font-weight-semibold: 500;--sl-font-weight-bold: 700;--sl-letter-spacing-denser: -.03em;--sl-letter-spacing-dense: -.015em;--sl-letter-spacing-normal: normal;--sl-letter-spacing-loose: .075em;--sl-letter-spacing-looser: .15em;--sl-line-height-denser: 1;--sl-line-height-dense: 1.4;--sl-line-height-normal: 1.8;--sl-line-height-loose: 2.2;--sl-line-height-looser: 2.6;--sl-focus-ring-color: var(--sl-color-primary-700);--sl-focus-ring-style: solid;--sl-focus-ring-width: 3px;--sl-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width) var(--sl-focus-ring-color);--sl-focus-ring-offset: 1px;--sl-button-font-size-small: var(--sl-font-size-x-small);--sl-button-font-size-medium: var(--sl-font-size-small);--sl-button-font-size-large: var(--sl-font-size-medium);--sl-input-height-small: 1.875rem;--sl-input-height-medium: 2.5rem;--sl-input-height-large: 3.125rem;--sl-input-background-color: var(--sl-color-neutral-0);--sl-input-background-color-hover: var(--sl-input-background-color);--sl-input-background-color-focus: var(--sl-input-background-color);--sl-input-background-color-disabled: var(--sl-color-neutral-100);--sl-input-border-color: var(--sl-color-neutral-400);--sl-input-border-color-hover: var(--sl-color-neutral-500);--sl-input-border-color-focus: var(--sl-color-primary-600);--sl-input-border-color-disabled: var(--sl-color-neutral-400);--sl-input-border-width: 1px;--sl-input-required-content: "*";--sl-input-required-content-offset: -2px;--sl-input-required-content-color: var(--sl-input-label-color);--sl-input-border-radius-small: var(--sl-border-radius-medium);--sl-input-border-radius-medium: var(--sl-border-radius-medium);--sl-input-border-radius-large: var(--sl-border-radius-medium);--sl-input-font-family: var(--sl-font-sans);--sl-input-font-weight: var(--sl-font-weight-normal);--sl-input-font-size-small: var(--sl-font-size-small);--sl-input-font-size-medium: var(--sl-font-size-medium);--sl-input-font-size-large: var(--sl-font-size-large);--sl-input-letter-spacing: var(--sl-letter-spacing-normal);--sl-input-color: var(--sl-color-neutral-700);--sl-input-color-hover: var(--sl-color-neutral-700);--sl-input-color-focus: var(--sl-color-neutral-700);--sl-input-color-disabled: var(--sl-color-neutral-900);--sl-input-icon-color: var(--sl-color-neutral-500);--sl-input-icon-color-hover: var(--sl-color-neutral-600);--sl-input-icon-color-focus: var(--sl-color-neutral-600);--sl-input-placeholder-color: var(--sl-color-neutral-500);--sl-input-placeholder-color-disabled: var(--sl-color-neutral-600);--sl-input-spacing-small: var(--sl-spacing-small);--sl-input-spacing-medium: var(--sl-spacing-medium);--sl-input-spacing-large: var(--sl-spacing-large);--sl-input-focus-ring-color: hsl(198.6 88.7% 48.4% / 40%);--sl-input-focus-ring-offset: 0;--sl-input-filled-background-color: var(--sl-color-neutral-100);--sl-input-filled-background-color-hover: var(--sl-color-neutral-100);--sl-input-filled-background-color-focus: var(--sl-color-neutral-100);--sl-input-filled-background-color-disabled: var(--sl-color-neutral-100);--sl-input-filled-color: var(--sl-color-neutral-800);--sl-input-filled-color-hover: var(--sl-color-neutral-800);--sl-input-filled-color-focus: var(--sl-color-neutral-700);--sl-input-filled-color-disabled: var(--sl-color-neutral-800);--sl-input-label-font-size-small: var(--sl-font-size-small);--sl-input-label-font-size-medium: var(--sl-font-size-medium);--sl-input-label-font-size-large: var(--sl-font-size-large);--sl-input-label-color: inherit;--sl-input-help-text-font-size-small: var(--sl-font-size-x-small);--sl-input-help-text-font-size-medium: var(--sl-font-size-small);--sl-input-help-text-font-size-large: var(--sl-font-size-medium);--sl-input-help-text-color: var(--sl-color-neutral-600);--sl-toggle-size-small: .875rem;--sl-toggle-size-medium: 1.125rem;--sl-toggle-size-large: 1.375rem;--sl-overlay-background-color: hsl(0 0% 0% / 43%);--sl-panel-background-color: var(--sl-color-neutral-50);--sl-panel-border-color: var(--sl-color-neutral-200);--sl-panel-border-width: 1px;--sl-tooltip-border-radius: var(--sl-border-radius-medium);--sl-tooltip-background-color: var(--sl-color-neutral-800);--sl-tooltip-color: var(--sl-color-neutral-0);--sl-tooltip-font-family: var(--sl-font-sans);--sl-tooltip-font-weight: var(--sl-font-weight-normal);--sl-tooltip-font-size: var(--sl-font-size-small);--sl-tooltip-line-height: var(--sl-line-height-dense);--sl-tooltip-padding: var(--sl-spacing-2x-small) var(--sl-spacing-x-small);--sl-tooltip-arrow-size: 6px;--sl-z-index-drawer: 700;--sl-z-index-dialog: 800;--sl-z-index-dropdown: 900;--sl-z-index-toast: 950;--sl-z-index-tooltip: 1000}@supports (scrollbar-gutter: stable){.sl-scroll-lock{scrollbar-gutter:var(--sl-scroll-lock-gutter)!important}.sl-scroll-lock body{overflow:hidden!important}}@supports not (scrollbar-gutter: stable){.sl-scroll-lock body{padding-right:var(--sl-scroll-lock-size)!important;overflow:hidden!important}}.sl-toast-stack{position:fixed;top:0;inset-inline-end:0;z-index:var(--sl-z-index-toast);width:28rem;max-width:100%;max-height:100%;overflow:auto}.sl-toast-stack sl-alert{margin:var(--sl-spacing-medium)}.sl-toast-stack sl-alert::part(base){box-shadow:var(--sl-shadow-large)}', qr = ':root,:host,.sl-theme-light{color-scheme:light;--sl-color-gray-50: hsl(0 0% 97.5%);--sl-color-gray-100: hsl(240 4.8% 95.9%);--sl-color-gray-200: hsl(240 5.9% 90%);--sl-color-gray-300: hsl(240 4.9% 83.9%);--sl-color-gray-400: hsl(240 5% 64.9%);--sl-color-gray-500: hsl(240 3.8% 46.1%);--sl-color-gray-600: hsl(240 5.2% 33.9%);--sl-color-gray-700: hsl(240 5.3% 26.1%);--sl-color-gray-800: hsl(240 3.7% 15.9%);--sl-color-gray-900: hsl(240 5.9% 10%);--sl-color-gray-950: hsl(240 7.3% 8%);--sl-color-red-50: hsl(0 85.7% 97.3%);--sl-color-red-100: hsl(0 93.3% 94.1%);--sl-color-red-200: hsl(0 96.3% 89.4%);--sl-color-red-300: hsl(0 93.5% 81.8%);--sl-color-red-400: hsl(0 90.6% 70.8%);--sl-color-red-500: hsl(0 84.2% 60.2%);--sl-color-red-600: hsl(0 72.2% 50.6%);--sl-color-red-700: hsl(0 73.7% 41.8%);--sl-color-red-800: hsl(0 70% 35.3%);--sl-color-red-900: hsl(0 62.8% 30.6%);--sl-color-red-950: hsl(0 60% 19.6%);--sl-color-orange-50: hsl(33.3 100% 96.5%);--sl-color-orange-100: hsl(34.3 100% 91.8%);--sl-color-orange-200: hsl(32.1 97.7% 83.1%);--sl-color-orange-300: hsl(30.7 97.2% 72.4%);--sl-color-orange-400: hsl(27 96% 61%);--sl-color-orange-500: hsl(24.6 95% 53.1%);--sl-color-orange-600: hsl(20.5 90.2% 48.2%);--sl-color-orange-700: hsl(17.5 88.3% 40.4%);--sl-color-orange-800: hsl(15 79.1% 33.7%);--sl-color-orange-900: hsl(15.3 74.6% 27.8%);--sl-color-orange-950: hsl(15.2 69.1% 19%);--sl-color-amber-50: hsl(48 100% 96.1%);--sl-color-amber-100: hsl(48 96.5% 88.8%);--sl-color-amber-200: hsl(48 96.6% 76.7%);--sl-color-amber-300: hsl(45.9 96.7% 64.5%);--sl-color-amber-400: hsl(43.3 96.4% 56.3%);--sl-color-amber-500: hsl(37.7 92.1% 50.2%);--sl-color-amber-600: hsl(32.1 94.6% 43.7%);--sl-color-amber-700: hsl(26 90.5% 37.1%);--sl-color-amber-800: hsl(22.7 82.5% 31.4%);--sl-color-amber-900: hsl(21.7 77.8% 26.5%);--sl-color-amber-950: hsl(22.9 74.1% 16.7%);--sl-color-yellow-50: hsl(54.5 91.7% 95.3%);--sl-color-yellow-100: hsl(54.9 96.7% 88%);--sl-color-yellow-200: hsl(52.8 98.3% 76.9%);--sl-color-yellow-300: hsl(50.4 97.8% 63.5%);--sl-color-yellow-400: hsl(47.9 95.8% 53.1%);--sl-color-yellow-500: hsl(45.4 93.4% 47.5%);--sl-color-yellow-600: hsl(40.6 96.1% 40.4%);--sl-color-yellow-700: hsl(35.5 91.7% 32.9%);--sl-color-yellow-800: hsl(31.8 81% 28.8%);--sl-color-yellow-900: hsl(28.4 72.5% 25.7%);--sl-color-yellow-950: hsl(33.1 69% 13.9%);--sl-color-lime-50: hsl(78.3 92% 95.1%);--sl-color-lime-100: hsl(79.6 89.1% 89.2%);--sl-color-lime-200: hsl(80.9 88.5% 79.6%);--sl-color-lime-300: hsl(82 84.5% 67.1%);--sl-color-lime-400: hsl(82.7 78% 55.5%);--sl-color-lime-500: hsl(83.7 80.5% 44.3%);--sl-color-lime-600: hsl(84.8 85.2% 34.5%);--sl-color-lime-700: hsl(85.9 78.4% 27.3%);--sl-color-lime-800: hsl(86.3 69% 22.7%);--sl-color-lime-900: hsl(87.6 61.2% 20.2%);--sl-color-lime-950: hsl(86.5 60.6% 13.9%);--sl-color-green-50: hsl(138.5 76.5% 96.7%);--sl-color-green-100: hsl(140.6 84.2% 92.5%);--sl-color-green-200: hsl(141 78.9% 85.1%);--sl-color-green-300: hsl(141.7 76.6% 73.1%);--sl-color-green-400: hsl(141.9 69.2% 58%);--sl-color-green-500: hsl(142.1 70.6% 45.3%);--sl-color-green-600: hsl(142.1 76.2% 36.3%);--sl-color-green-700: hsl(142.4 71.8% 29.2%);--sl-color-green-800: hsl(142.8 64.2% 24.1%);--sl-color-green-900: hsl(143.8 61.2% 20.2%);--sl-color-green-950: hsl(144.3 60.7% 12%);--sl-color-emerald-50: hsl(151.8 81% 95.9%);--sl-color-emerald-100: hsl(149.3 80.4% 90%);--sl-color-emerald-200: hsl(152.4 76% 80.4%);--sl-color-emerald-300: hsl(156.2 71.6% 66.9%);--sl-color-emerald-400: hsl(158.1 64.4% 51.6%);--sl-color-emerald-500: hsl(160.1 84.1% 39.4%);--sl-color-emerald-600: hsl(161.4 93.5% 30.4%);--sl-color-emerald-700: hsl(162.9 93.5% 24.3%);--sl-color-emerald-800: hsl(163.1 88.1% 19.8%);--sl-color-emerald-900: hsl(164.2 85.7% 16.5%);--sl-color-emerald-950: hsl(164.3 87.5% 9.4%);--sl-color-teal-50: hsl(166.2 76.5% 96.7%);--sl-color-teal-100: hsl(167.2 85.5% 89.2%);--sl-color-teal-200: hsl(168.4 83.8% 78.2%);--sl-color-teal-300: hsl(170.6 76.9% 64.3%);--sl-color-teal-400: hsl(172.5 66% 50.4%);--sl-color-teal-500: hsl(173.4 80.4% 40%);--sl-color-teal-600: hsl(174.7 83.9% 31.6%);--sl-color-teal-700: hsl(175.3 77.4% 26.1%);--sl-color-teal-800: hsl(176.1 69.4% 21.8%);--sl-color-teal-900: hsl(175.9 60.8% 19%);--sl-color-teal-950: hsl(176.5 58.6% 11.4%);--sl-color-cyan-50: hsl(183.2 100% 96.3%);--sl-color-cyan-100: hsl(185.1 95.9% 90.4%);--sl-color-cyan-200: hsl(186.2 93.5% 81.8%);--sl-color-cyan-300: hsl(187 92.4% 69%);--sl-color-cyan-400: hsl(187.9 85.7% 53.3%);--sl-color-cyan-500: hsl(188.7 94.5% 42.7%);--sl-color-cyan-600: hsl(191.6 91.4% 36.5%);--sl-color-cyan-700: hsl(192.9 82.3% 31%);--sl-color-cyan-800: hsl(194.4 69.6% 27.1%);--sl-color-cyan-900: hsl(196.4 63.6% 23.7%);--sl-color-cyan-950: hsl(196.8 61% 16.1%);--sl-color-sky-50: hsl(204 100% 97.1%);--sl-color-sky-100: hsl(204 93.8% 93.7%);--sl-color-sky-200: hsl(200.6 94.4% 86.1%);--sl-color-sky-300: hsl(199.4 95.5% 73.9%);--sl-color-sky-400: hsl(198.4 93.2% 59.6%);--sl-color-sky-500: hsl(198.6 88.7% 48.4%);--sl-color-sky-600: hsl(200.4 98% 39.4%);--sl-color-sky-700: hsl(201.3 96.3% 32.2%);--sl-color-sky-800: hsl(201 90% 27.5%);--sl-color-sky-900: hsl(202 80.3% 23.9%);--sl-color-sky-950: hsl(202.3 73.8% 16.5%);--sl-color-blue-50: hsl(213.8 100% 96.9%);--sl-color-blue-100: hsl(214.3 94.6% 92.7%);--sl-color-blue-200: hsl(213.3 96.9% 87.3%);--sl-color-blue-300: hsl(211.7 96.4% 78.4%);--sl-color-blue-400: hsl(213.1 93.9% 67.8%);--sl-color-blue-500: hsl(217.2 91.2% 59.8%);--sl-color-blue-600: hsl(221.2 83.2% 53.3%);--sl-color-blue-700: hsl(224.3 76.3% 48%);--sl-color-blue-800: hsl(225.9 70.7% 40.2%);--sl-color-blue-900: hsl(224.4 64.3% 32.9%);--sl-color-blue-950: hsl(226.2 55.3% 18.4%);--sl-color-indigo-50: hsl(225.9 100% 96.7%);--sl-color-indigo-100: hsl(226.5 100% 93.9%);--sl-color-indigo-200: hsl(228 96.5% 88.8%);--sl-color-indigo-300: hsl(229.7 93.5% 81.8%);--sl-color-indigo-400: hsl(234.5 89.5% 73.9%);--sl-color-indigo-500: hsl(238.7 83.5% 66.7%);--sl-color-indigo-600: hsl(243.4 75.4% 58.6%);--sl-color-indigo-700: hsl(244.5 57.9% 50.6%);--sl-color-indigo-800: hsl(243.7 54.5% 41.4%);--sl-color-indigo-900: hsl(242.2 47.4% 34.3%);--sl-color-indigo-950: hsl(243.5 43.6% 22.9%);--sl-color-violet-50: hsl(250 100% 97.6%);--sl-color-violet-100: hsl(251.4 91.3% 95.5%);--sl-color-violet-200: hsl(250.5 95.2% 91.8%);--sl-color-violet-300: hsl(252.5 94.7% 85.1%);--sl-color-violet-400: hsl(255.1 91.7% 76.3%);--sl-color-violet-500: hsl(258.3 89.5% 66.3%);--sl-color-violet-600: hsl(262.1 83.3% 57.8%);--sl-color-violet-700: hsl(263.4 70% 50.4%);--sl-color-violet-800: hsl(263.4 69.3% 42.2%);--sl-color-violet-900: hsl(263.5 67.4% 34.9%);--sl-color-violet-950: hsl(265.1 61.5% 21.4%);--sl-color-purple-50: hsl(270 100% 98%);--sl-color-purple-100: hsl(268.7 100% 95.5%);--sl-color-purple-200: hsl(268.6 100% 91.8%);--sl-color-purple-300: hsl(269.2 97.4% 85.1%);--sl-color-purple-400: hsl(270 95.2% 75.3%);--sl-color-purple-500: hsl(270.7 91% 65.1%);--sl-color-purple-600: hsl(271.5 81.3% 55.9%);--sl-color-purple-700: hsl(272.1 71.7% 47.1%);--sl-color-purple-800: hsl(272.9 67.2% 39.4%);--sl-color-purple-900: hsl(273.6 65.6% 32%);--sl-color-purple-950: hsl(276 59.5% 16.5%);--sl-color-fuchsia-50: hsl(289.1 100% 97.8%);--sl-color-fuchsia-100: hsl(287 100% 95.5%);--sl-color-fuchsia-200: hsl(288.3 95.8% 90.6%);--sl-color-fuchsia-300: hsl(291.1 93.1% 82.9%);--sl-color-fuchsia-400: hsl(292 91.4% 72.5%);--sl-color-fuchsia-500: hsl(292.2 84.1% 60.6%);--sl-color-fuchsia-600: hsl(293.4 69.5% 48.8%);--sl-color-fuchsia-700: hsl(294.7 72.4% 39.8%);--sl-color-fuchsia-800: hsl(295.4 70.2% 32.9%);--sl-color-fuchsia-900: hsl(296.7 63.6% 28%);--sl-color-fuchsia-950: hsl(297.1 56.8% 14.5%);--sl-color-pink-50: hsl(327.3 73.3% 97.1%);--sl-color-pink-100: hsl(325.7 77.8% 94.7%);--sl-color-pink-200: hsl(325.9 84.6% 89.8%);--sl-color-pink-300: hsl(327.4 87.1% 81.8%);--sl-color-pink-400: hsl(328.6 85.5% 70.2%);--sl-color-pink-500: hsl(330.4 81.2% 60.4%);--sl-color-pink-600: hsl(333.3 71.4% 50.6%);--sl-color-pink-700: hsl(335.1 77.6% 42%);--sl-color-pink-800: hsl(335.8 74.4% 35.3%);--sl-color-pink-900: hsl(335.9 69% 30.4%);--sl-color-pink-950: hsl(336.2 65.4% 15.9%);--sl-color-rose-50: hsl(355.7 100% 97.3%);--sl-color-rose-100: hsl(355.6 100% 94.7%);--sl-color-rose-200: hsl(352.7 96.1% 90%);--sl-color-rose-300: hsl(352.6 95.7% 81.8%);--sl-color-rose-400: hsl(351.3 94.5% 71.4%);--sl-color-rose-500: hsl(349.7 89.2% 60.2%);--sl-color-rose-600: hsl(346.8 77.2% 49.8%);--sl-color-rose-700: hsl(345.3 82.7% 40.8%);--sl-color-rose-800: hsl(343.4 79.7% 34.7%);--sl-color-rose-900: hsl(341.5 75.5% 30.4%);--sl-color-rose-950: hsl(341.3 70.1% 17.1%);--sl-color-primary-50: var(--sl-color-sky-50);--sl-color-primary-100: var(--sl-color-sky-100);--sl-color-primary-200: var(--sl-color-sky-200);--sl-color-primary-300: var(--sl-color-sky-300);--sl-color-primary-400: var(--sl-color-sky-400);--sl-color-primary-500: var(--sl-color-sky-500);--sl-color-primary-600: var(--sl-color-sky-600);--sl-color-primary-700: var(--sl-color-sky-700);--sl-color-primary-800: var(--sl-color-sky-800);--sl-color-primary-900: var(--sl-color-sky-900);--sl-color-primary-950: var(--sl-color-sky-950);--sl-color-success-50: var(--sl-color-green-50);--sl-color-success-100: var(--sl-color-green-100);--sl-color-success-200: var(--sl-color-green-200);--sl-color-success-300: var(--sl-color-green-300);--sl-color-success-400: var(--sl-color-green-400);--sl-color-success-500: var(--sl-color-green-500);--sl-color-success-600: var(--sl-color-green-600);--sl-color-success-700: var(--sl-color-green-700);--sl-color-success-800: var(--sl-color-green-800);--sl-color-success-900: var(--sl-color-green-900);--sl-color-success-950: var(--sl-color-green-950);--sl-color-warning-50: var(--sl-color-amber-50);--sl-color-warning-100: var(--sl-color-amber-100);--sl-color-warning-200: var(--sl-color-amber-200);--sl-color-warning-300: var(--sl-color-amber-300);--sl-color-warning-400: var(--sl-color-amber-400);--sl-color-warning-500: var(--sl-color-amber-500);--sl-color-warning-600: var(--sl-color-amber-600);--sl-color-warning-700: var(--sl-color-amber-700);--sl-color-warning-800: var(--sl-color-amber-800);--sl-color-warning-900: var(--sl-color-amber-900);--sl-color-warning-950: var(--sl-color-amber-950);--sl-color-danger-50: var(--sl-color-red-50);--sl-color-danger-100: var(--sl-color-red-100);--sl-color-danger-200: var(--sl-color-red-200);--sl-color-danger-300: var(--sl-color-red-300);--sl-color-danger-400: var(--sl-color-red-400);--sl-color-danger-500: var(--sl-color-red-500);--sl-color-danger-600: var(--sl-color-red-600);--sl-color-danger-700: var(--sl-color-red-700);--sl-color-danger-800: var(--sl-color-red-800);--sl-color-danger-900: var(--sl-color-red-900);--sl-color-danger-950: var(--sl-color-red-950);--sl-color-neutral-50: var(--sl-color-gray-50);--sl-color-neutral-100: var(--sl-color-gray-100);--sl-color-neutral-200: var(--sl-color-gray-200);--sl-color-neutral-300: var(--sl-color-gray-300);--sl-color-neutral-400: var(--sl-color-gray-400);--sl-color-neutral-500: var(--sl-color-gray-500);--sl-color-neutral-600: var(--sl-color-gray-600);--sl-color-neutral-700: var(--sl-color-gray-700);--sl-color-neutral-800: var(--sl-color-gray-800);--sl-color-neutral-900: var(--sl-color-gray-900);--sl-color-neutral-950: var(--sl-color-gray-950);--sl-color-neutral-0: hsl(0, 0%, 100%);--sl-color-neutral-1000: hsl(0, 0%, 0%);--sl-border-radius-small: .1875rem;--sl-border-radius-medium: .25rem;--sl-border-radius-large: .5rem;--sl-border-radius-x-large: 1rem;--sl-border-radius-circle: 50%;--sl-border-radius-pill: 9999px;--sl-shadow-x-small: 0 1px 2px hsl(240 3.8% 46.1% / 6%);--sl-shadow-small: 0 1px 2px hsl(240 3.8% 46.1% / 12%);--sl-shadow-medium: 0 2px 4px hsl(240 3.8% 46.1% / 12%);--sl-shadow-large: 0 2px 8px hsl(240 3.8% 46.1% / 12%);--sl-shadow-x-large: 0 4px 16px hsl(240 3.8% 46.1% / 12%);--sl-spacing-3x-small: .125rem;--sl-spacing-2x-small: .25rem;--sl-spacing-x-small: .5rem;--sl-spacing-small: .75rem;--sl-spacing-medium: 1rem;--sl-spacing-large: 1.25rem;--sl-spacing-x-large: 1.75rem;--sl-spacing-2x-large: 2.25rem;--sl-spacing-3x-large: 3rem;--sl-spacing-4x-large: 4.5rem;--sl-transition-x-slow: 1s;--sl-transition-slow: .5s;--sl-transition-medium: .25s;--sl-transition-fast: .15s;--sl-transition-x-fast: 50ms;--sl-font-mono: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;--sl-font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";--sl-font-serif: Georgia, "Times New Roman", serif;--sl-font-size-2x-small: .625rem;--sl-font-size-x-small: .75rem;--sl-font-size-small: .875rem;--sl-font-size-medium: 1rem;--sl-font-size-large: 1.25rem;--sl-font-size-x-large: 1.5rem;--sl-font-size-2x-large: 2.25rem;--sl-font-size-3x-large: 3rem;--sl-font-size-4x-large: 4.5rem;--sl-font-weight-light: 300;--sl-font-weight-normal: 400;--sl-font-weight-semibold: 500;--sl-font-weight-bold: 700;--sl-letter-spacing-denser: -.03em;--sl-letter-spacing-dense: -.015em;--sl-letter-spacing-normal: normal;--sl-letter-spacing-loose: .075em;--sl-letter-spacing-looser: .15em;--sl-line-height-denser: 1;--sl-line-height-dense: 1.4;--sl-line-height-normal: 1.8;--sl-line-height-loose: 2.2;--sl-line-height-looser: 2.6;--sl-focus-ring-color: var(--sl-color-primary-600);--sl-focus-ring-style: solid;--sl-focus-ring-width: 3px;--sl-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width) var(--sl-focus-ring-color);--sl-focus-ring-offset: 1px;--sl-button-font-size-small: var(--sl-font-size-x-small);--sl-button-font-size-medium: var(--sl-font-size-small);--sl-button-font-size-large: var(--sl-font-size-medium);--sl-input-height-small: 1.875rem;--sl-input-height-medium: 2.5rem;--sl-input-height-large: 3.125rem;--sl-input-background-color: var(--sl-color-neutral-0);--sl-input-background-color-hover: var(--sl-input-background-color);--sl-input-background-color-focus: var(--sl-input-background-color);--sl-input-background-color-disabled: var(--sl-color-neutral-100);--sl-input-border-color: var(--sl-color-neutral-300);--sl-input-border-color-hover: var(--sl-color-neutral-400);--sl-input-border-color-focus: var(--sl-color-primary-500);--sl-input-border-color-disabled: var(--sl-color-neutral-300);--sl-input-border-width: 1px;--sl-input-required-content: "*";--sl-input-required-content-offset: -2px;--sl-input-required-content-color: var(--sl-input-label-color);--sl-input-border-radius-small: var(--sl-border-radius-medium);--sl-input-border-radius-medium: var(--sl-border-radius-medium);--sl-input-border-radius-large: var(--sl-border-radius-medium);--sl-input-font-family: var(--sl-font-sans);--sl-input-font-weight: var(--sl-font-weight-normal);--sl-input-font-size-small: var(--sl-font-size-small);--sl-input-font-size-medium: var(--sl-font-size-medium);--sl-input-font-size-large: var(--sl-font-size-large);--sl-input-letter-spacing: var(--sl-letter-spacing-normal);--sl-input-color: var(--sl-color-neutral-700);--sl-input-color-hover: var(--sl-color-neutral-700);--sl-input-color-focus: var(--sl-color-neutral-700);--sl-input-color-disabled: var(--sl-color-neutral-900);--sl-input-icon-color: var(--sl-color-neutral-500);--sl-input-icon-color-hover: var(--sl-color-neutral-600);--sl-input-icon-color-focus: var(--sl-color-neutral-600);--sl-input-placeholder-color: var(--sl-color-neutral-500);--sl-input-placeholder-color-disabled: var(--sl-color-neutral-600);--sl-input-spacing-small: var(--sl-spacing-small);--sl-input-spacing-medium: var(--sl-spacing-medium);--sl-input-spacing-large: var(--sl-spacing-large);--sl-input-focus-ring-color: hsl(198.6 88.7% 48.4% / 40%);--sl-input-focus-ring-offset: 0;--sl-input-filled-background-color: var(--sl-color-neutral-100);--sl-input-filled-background-color-hover: var(--sl-color-neutral-100);--sl-input-filled-background-color-focus: var(--sl-color-neutral-100);--sl-input-filled-background-color-disabled: var(--sl-color-neutral-100);--sl-input-filled-color: var(--sl-color-neutral-800);--sl-input-filled-color-hover: var(--sl-color-neutral-800);--sl-input-filled-color-focus: var(--sl-color-neutral-700);--sl-input-filled-color-disabled: var(--sl-color-neutral-800);--sl-input-label-font-size-small: var(--sl-font-size-small);--sl-input-label-font-size-medium: var(--sl-font-size-medium);--sl-input-label-font-size-large: var(--sl-font-size-large);--sl-input-label-color: inherit;--sl-input-help-text-font-size-small: var(--sl-font-size-x-small);--sl-input-help-text-font-size-medium: var(--sl-font-size-small);--sl-input-help-text-font-size-large: var(--sl-font-size-medium);--sl-input-help-text-color: var(--sl-color-neutral-500);--sl-toggle-size-small: .875rem;--sl-toggle-size-medium: 1.125rem;--sl-toggle-size-large: 1.375rem;--sl-overlay-background-color: hsl(240 3.8% 46.1% / 33%);--sl-panel-background-color: var(--sl-color-neutral-0);--sl-panel-border-color: var(--sl-color-neutral-200);--sl-panel-border-width: 1px;--sl-tooltip-border-radius: var(--sl-border-radius-medium);--sl-tooltip-background-color: var(--sl-color-neutral-800);--sl-tooltip-color: var(--sl-color-neutral-0);--sl-tooltip-font-family: var(--sl-font-sans);--sl-tooltip-font-weight: var(--sl-font-weight-normal);--sl-tooltip-font-size: var(--sl-font-size-small);--sl-tooltip-line-height: var(--sl-line-height-dense);--sl-tooltip-padding: var(--sl-spacing-2x-small) var(--sl-spacing-x-small);--sl-tooltip-arrow-size: 6px;--sl-z-index-drawer: 700;--sl-z-index-dialog: 800;--sl-z-index-dropdown: 900;--sl-z-index-toast: 950;--sl-z-index-tooltip: 1000}@supports (scrollbar-gutter: stable){.sl-scroll-lock{scrollbar-gutter:var(--sl-scroll-lock-gutter)!important}.sl-scroll-lock body{overflow:hidden!important}}@supports not (scrollbar-gutter: stable){.sl-scroll-lock body{padding-right:var(--sl-scroll-lock-size)!important;overflow:hidden!important}}.sl-toast-stack{position:fixed;top:0;inset-inline-end:0;z-index:var(--sl-z-index-toast);width:28rem;max-width:100%;max-height:100%;overflow:auto}.sl-toast-stack sl-alert{margin:var(--sl-spacing-medium)}.sl-toast-stack sl-alert::part(base){box-shadow:var(--sl-shadow-large)}', KY = ".invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.input::part(base){border-radius:var(--photon-border-radius, .5rem)}.input::part(base):hover{cursor:pointer}.input::part(input){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.input{--sl-input-required-content-color: #f87171;--sl-input-label-font-size-medium: .875rem;--sl-input-label-color: #374151}.input::part(form-control-label){padding-bottom:.5rem}.disabled::part(base):hover{cursor:not-allowed}.selected::part(base){--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.default::part(base):hover{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity))}.default::part(label){width:100%;overflow:hidden}.group-member::part(base){padding-left:1rem;font-weight:500}.group::part(base){background:#d1e9ff;padding-top:.25rem;padding-bottom:.25rem;--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity));font-size:.75rem;font-weight:600}.dropdown::part(panel){border-radius:var(--photon-border-radius, .5rem)}.dropdown-container{border-radius:var(--photon-border-radius, .5rem)}";
function go(e, t, r) {
  let n = r.initialDeps ?? [], i;
  function a() {
    var o, s, l, d;
    let u;
    r.key && ((o = r.debug) != null && o.call(r)) && (u = Date.now());
    const c = e();
    if (!(c.length !== n.length || c.some((p, g) => n[g] !== p)))
      return i;
    n = c;
    let f;
    if (r.key && ((s = r.debug) != null && s.call(r)) && (f = Date.now()), i = t(...c), r.key && ((l = r.debug) != null && l.call(r))) {
      const p = Math.round((Date.now() - u) * 100) / 100, g = Math.round((Date.now() - f) * 100) / 100, v = g / 16, m = ($, w) => {
        for ($ = String($); $.length < w; )
          $ = " " + $;
        return $;
      };
      console.info(
        `%c⏱ ${m(g, 5)} /${m(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * v, 120)
        )}deg 100% 31%);`,
        r?.key
      );
    }
    return (d = r?.onChange) == null || d.call(r, i), i;
  }
  return a.updateDeps = (o) => {
    n = o;
  }, a;
}
function T1(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const ZY = (e, t) => Math.abs(e - t) < 1, XY = (e, t, r) => {
  let n;
  return function(...i) {
    e.clearTimeout(n), n = e.setTimeout(() => t.apply(this, i), r);
  };
}, JY = (e) => e, eK = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), r = Math.min(e.endIndex + e.overscan, e.count - 1), n = [];
  for (let i = t; i <= r; i++)
    n.push(i);
  return n;
}, tK = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const n = e.targetWindow;
  if (!n)
    return;
  const i = (o) => {
    const { width: s, height: l } = o;
    t({ width: Math.round(s), height: Math.round(l) });
  };
  if (i(r.getBoundingClientRect()), !n.ResizeObserver)
    return () => {
    };
  const a = new n.ResizeObserver((o) => {
    const s = () => {
      const l = o[0];
      if (l?.borderBoxSize) {
        const d = l.borderBoxSize[0];
        if (d) {
          i({ width: d.inlineSize, height: d.blockSize });
          return;
        }
      }
      i(r.getBoundingClientRect());
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
  });
  return a.observe(r, { box: "border-box" }), () => {
    a.unobserve(r);
  };
}, Ug = {
  passive: !0
}, qg = typeof window > "u" ? !0 : "onscrollend" in window, rK = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const n = e.targetWindow;
  if (!n)
    return;
  let i = 0;
  const a = e.options.useScrollendEvent && qg ? () => {
  } : XY(
    n,
    () => {
      t(i, !1);
    },
    e.options.isScrollingResetDelay
  ), o = (u) => () => {
    const { horizontal: c, isRtl: h } = e.options;
    i = c ? r.scrollLeft * (h && -1 || 1) : r.scrollTop, a(), t(i, u);
  }, s = o(!0), l = o(!1);
  l(), r.addEventListener("scroll", s, Ug);
  const d = e.options.useScrollendEvent && qg;
  return d && r.addEventListener("scrollend", l, Ug), () => {
    r.removeEventListener("scroll", s), d && r.removeEventListener("scrollend", l);
  };
}, nK = (e, t, r) => {
  if (t?.borderBoxSize) {
    const n = t.borderBoxSize[0];
    if (n)
      return Math.round(
        n[r.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[r.options.horizontal ? "width" : "height"]
  );
}, iK = (e, {
  adjustments: t = 0,
  behavior: r
}, n) => {
  var i, a;
  const o = e + t;
  (a = (i = n.scrollElement) == null ? void 0 : i.scrollTo) == null || a.call(i, {
    [n.options.horizontal ? "left" : "top"]: o,
    behavior: r
  });
};
class aK {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let r = null;
      const n = () => r || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : r = new this.targetWindow.ResizeObserver((i) => {
        i.forEach((a) => {
          const o = () => {
            this._measureElement(a.target, a);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(o) : o();
        });
      }));
      return {
        disconnect: () => {
          var i;
          (i = n()) == null || i.disconnect(), r = null;
        },
        observe: (i) => {
          var a;
          return (a = n()) == null ? void 0 : a.observe(i, { box: "border-box" });
        },
        unobserve: (i) => {
          var a;
          return (a = n()) == null ? void 0 : a.unobserve(i);
        }
      };
    })(), this.range = null, this.setOptions = (r) => {
      Object.entries(r).forEach(([n, i]) => {
        typeof i > "u" && delete r[n];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: JY,
        rangeExtractor: eK,
        onChange: () => {
        },
        measureElement: nK,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...r
      };
    }, this.notify = (r) => {
      var n, i;
      (i = (n = this.options).onChange) == null || i.call(n, this, r);
    }, this.maybeNotify = go(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (r) => {
        this.notify(r);
      },
      {
        key: !1,
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var r;
      const n = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== n) {
        if (this.cleanup(), !n) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = n, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((r = this.scrollElement) == null ? void 0 : r.window) ?? null, this.elementsCache.forEach((i) => {
          this.observer.observe(i);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (i) => {
            this.scrollRect = i, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (i, a) => {
            this.scrollAdjustments = 0, this.scrollDirection = a ? this.getScrollOffset() < i ? "forward" : "backward" : null, this.scrollOffset = i, this.isScrolling = a, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (r, n) => {
      const i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
      for (let o = n - 1; o >= 0; o--) {
        const s = r[o];
        if (i.has(s.lane))
          continue;
        const l = a.get(
          s.lane
        );
        if (l == null || s.end > l.end ? a.set(s.lane, s) : s.end < l.end && i.set(s.lane, !0), i.size === this.options.lanes)
          break;
      }
      return a.size === this.options.lanes ? Array.from(a.values()).sort((o, s) => o.end === s.end ? o.index - s.index : o.end - s.end)[0] : void 0;
    }, this.getMeasurementOptions = go(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (r, n, i, a, o) => (this.pendingMeasuredCacheIndexes = [], {
        count: r,
        paddingStart: n,
        scrollMargin: i,
        getItemKey: a,
        enabled: o
      }),
      {
        key: !1
      }
    ), this.getMeasurements = go(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: r, paddingStart: n, scrollMargin: i, getItemKey: a, enabled: o }, s) => {
        if (!o)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const d = this.measurementsCache.slice(0, l);
        for (let u = l; u < r; u++) {
          const c = a(u), h = this.options.lanes === 1 ? d[u - 1] : this.getFurthestMeasurement(d, u), f = h ? h.end + this.options.gap : n + i, p = s.get(c), g = typeof p == "number" ? p : this.options.estimateSize(u), v = f + g, m = h ? h.lane : u % this.options.lanes;
          d[u] = {
            index: u,
            start: f,
            size: g,
            end: v,
            key: c,
            lane: m
          };
        }
        return this.measurementsCache = d, d;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.calculateRange = go(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (r, n, i, a) => this.range = r.length > 0 && n > 0 ? oK({
        measurements: r,
        outerSize: n,
        scrollOffset: i,
        lanes: a
      }) : null,
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = go(
      () => {
        let r = null, n = null;
        const i = this.calculateRange();
        return i && (r = i.startIndex, n = i.endIndex), this.maybeNotify.updateDeps([this.isScrolling, r, n]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          r,
          n
        ];
      },
      (r, n, i, a, o) => a === null || o === null ? [] : r({
        startIndex: a,
        endIndex: o,
        overscan: n,
        count: i
      }),
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (r) => {
      const n = this.options.indexAttribute, i = r.getAttribute(n);
      return i ? parseInt(i, 10) : (console.warn(
        `Missing attribute name '${n}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (r, n) => {
      const i = this.indexFromElement(r), a = this.measurementsCache[i];
      if (!a)
        return;
      const o = a.key, s = this.elementsCache.get(o);
      s !== r && (s && this.observer.unobserve(s), this.observer.observe(r), this.elementsCache.set(o, r)), r.isConnected && this.resizeItem(i, this.options.measureElement(r, n, this));
    }, this.resizeItem = (r, n) => {
      const i = this.measurementsCache[r];
      if (!i)
        return;
      const a = this.itemSizeCache.get(i.key) ?? i.size, o = n - a;
      o !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(i, o, this) : i.start < this.getScrollOffset() + this.scrollAdjustments) && this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += o,
        behavior: void 0
      }), this.pendingMeasuredCacheIndexes.push(i.index), this.itemSizeCache = new Map(this.itemSizeCache.set(i.key, n)), this.notify(!1));
    }, this.measureElement = (r) => {
      if (!r) {
        this.elementsCache.forEach((n, i) => {
          n.isConnected || (this.observer.unobserve(n), this.elementsCache.delete(i));
        });
        return;
      }
      this._measureElement(r, void 0);
    }, this.getVirtualItems = go(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (r, n) => {
        const i = [];
        for (let a = 0, o = r.length; a < o; a++) {
          const s = r[a], l = n[s];
          i.push(l);
        }
        return i;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (r) => {
      const n = this.getMeasurements();
      if (n.length !== 0)
        return T1(
          n[S8(
            0,
            n.length - 1,
            (i) => T1(n[i]).start,
            r
          )]
        );
    }, this.getOffsetForAlignment = (r, n, i = 0) => {
      const a = this.getSize(), o = this.getScrollOffset();
      n === "auto" && (n = r >= o + a ? "end" : "start"), n === "center" ? r += (i - a) / 2 : n === "end" && (r -= a);
      const s = this.options.horizontal ? "scrollWidth" : "scrollHeight", d = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[s] : this.scrollElement[s] : 0) - a;
      return Math.max(Math.min(d, r), 0);
    }, this.getOffsetForIndex = (r, n = "auto") => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const i = this.measurementsCache[r];
      if (!i)
        return;
      const a = this.getSize(), o = this.getScrollOffset();
      if (n === "auto")
        if (i.end >= o + a - this.options.scrollPaddingEnd)
          n = "end";
        else if (i.start <= o + this.options.scrollPaddingStart)
          n = "start";
        else
          return [o, n];
      const s = n === "end" ? i.end + this.options.scrollPaddingEnd : i.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(s, n, i.size),
        n
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (r, { align: n = "start", behavior: i } = {}) => {
      this.cancelScrollToIndex(), i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(r, n), {
        adjustments: void 0,
        behavior: i
      });
    }, this.scrollToIndex = (r, { align: n = "auto", behavior: i } = {}) => {
      r = Math.max(0, Math.min(r, this.options.count - 1)), this.cancelScrollToIndex(), i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const a = this.getOffsetForIndex(r, n);
      if (!a) return;
      const [o, s] = a;
      this._scrollToOffset(o, { adjustments: void 0, behavior: i }), i !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(r)
        )) {
          const [d] = T1(
            this.getOffsetForIndex(r, s)
          );
          ZY(d, this.getScrollOffset()) || this.scrollToIndex(r, { align: s, behavior: i });
        } else
          this.scrollToIndex(r, { align: s, behavior: i });
      }));
    }, this.scrollBy = (r, { behavior: n } = {}) => {
      this.cancelScrollToIndex(), n === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + r, {
        adjustments: void 0,
        behavior: n
      });
    }, this.getTotalSize = () => {
      var r;
      const n = this.getMeasurements();
      let i;
      if (n.length === 0)
        i = this.options.paddingStart;
      else if (this.options.lanes === 1)
        i = ((r = n[n.length - 1]) == null ? void 0 : r.end) ?? 0;
      else {
        const a = Array(this.options.lanes).fill(null);
        let o = n.length - 1;
        for (; o >= 0 && a.some((s) => s === null); ) {
          const s = n[o];
          a[s.lane] === null && (a[s.lane] = s.end), o--;
        }
        i = Math.max(...a.filter((s) => s !== null));
      }
      return Math.max(
        i - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (r, {
      adjustments: n,
      behavior: i
    }) => {
      this.options.scrollToFn(r, { behavior: i, adjustments: n }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const S8 = (e, t, r, n) => {
  for (; e <= t; ) {
    const i = (e + t) / 2 | 0, a = r(i);
    if (a < n)
      e = i + 1;
    else if (a > n)
      t = i - 1;
    else
      return i;
  }
  return e > 0 ? e - 1 : 0;
};
function oK({
  measurements: e,
  outerSize: t,
  scrollOffset: r,
  lanes: n
}) {
  const i = e.length - 1, a = (l) => e[l].start;
  if (e.length <= n)
    return {
      startIndex: 0,
      endIndex: i
    };
  let o = S8(
    0,
    i,
    a,
    r
  ), s = o;
  if (n === 1)
    for (; s < i && e[s].end < r + t; )
      s++;
  else if (n > 1) {
    const l = Array(n).fill(0);
    for (; s < i && l.some((u) => u < r + t); ) {
      const u = e[s];
      l[u.lane] = u.end, s++;
    }
    const d = Array(n).fill(r + t);
    for (; o >= 0 && d.some((u) => u >= r); ) {
      const u = e[o];
      d[u.lane] = u.start, o--;
    }
    o = Math.max(0, o - o % n), s = Math.min(i, s + (n - 1 - s % n));
  }
  return { startIndex: o, endIndex: s };
}
const Dh = Symbol("store-raw"), ts = Symbol("store-node"), gi = Symbol("store-has"), E8 = Symbol("store-self");
function T8(e) {
  let t = e[mr];
  if (!t && (Object.defineProperty(e, mr, {
    value: t = new Proxy(e, dK)
  }), !Array.isArray(e))) {
    const r = Object.keys(e), n = Object.getOwnPropertyDescriptors(e);
    for (let i = 0, a = r.length; i < a; i++) {
      const o = r[i];
      n[o].get && Object.defineProperty(e, o, {
        enumerable: n[o].enumerable,
        get: n[o].get.bind(t)
      });
    }
  }
  return t;
}
function la(e) {
  let t;
  return e != null && typeof e == "object" && (e[mr] || !(t = Object.getPrototypeOf(e)) || t === Object.prototype || Array.isArray(e));
}
function bs(e, t = /* @__PURE__ */ new Set()) {
  let r, n, i, a;
  if (r = e != null && e[Dh]) return r;
  if (!la(e) || t.has(e)) return e;
  if (Array.isArray(e)) {
    Object.isFrozen(e) ? e = e.slice(0) : t.add(e);
    for (let o = 0, s = e.length; o < s; o++)
      i = e[o], (n = bs(i, t)) !== i && (e[o] = n);
  } else {
    Object.isFrozen(e) ? e = Object.assign({}, e) : t.add(e);
    const o = Object.keys(e), s = Object.getOwnPropertyDescriptors(e);
    for (let l = 0, d = o.length; l < d; l++)
      a = o[l], !s[a].get && (i = e[a], (n = bs(i, t)) !== i && (e[a] = n));
  }
  return e;
}
function vc(e, t) {
  let r = e[t];
  return r || Object.defineProperty(e, t, {
    value: r = /* @__PURE__ */ Object.create(null)
  }), r;
}
function nd(e, t, r) {
  if (e[t]) return e[t];
  const [n, i] = H(r, {
    equals: !1,
    internal: !0
  });
  return n.$ = i, e[t] = n;
}
function sK(e, t) {
  const r = Reflect.getOwnPropertyDescriptor(e, t);
  return !r || r.get || !r.configurable || t === mr || t === ts || (delete r.value, delete r.writable, r.get = () => e[mr][t]), r;
}
function A8(e) {
  ns() && nd(vc(e, ts), E8)();
}
function lK(e) {
  return A8(e), Reflect.ownKeys(e);
}
const dK = {
  get(e, t, r) {
    if (t === Dh) return e;
    if (t === mr) return r;
    if (t === Ml)
      return A8(e), r;
    const n = vc(e, ts), i = n[t];
    let a = i ? i() : e[t];
    if (t === ts || t === gi || t === "__proto__") return a;
    if (!i) {
      const o = Object.getOwnPropertyDescriptor(e, t);
      ns() && (typeof a != "function" || e.hasOwnProperty(t)) && !(o && o.get) && (a = nd(n, t, a)());
    }
    return la(a) ? T8(a) : a;
  },
  has(e, t) {
    return t === Dh || t === mr || t === Ml || t === ts || t === gi || t === "__proto__" ? !0 : (ns() && nd(vc(e, gi), t)(), t in e);
  },
  set() {
    return !0;
  },
  deleteProperty() {
    return !0;
  },
  ownKeys: lK,
  getOwnPropertyDescriptor: sK
};
function gn(e, t, r, n = !1) {
  if (!n && e[t] === r) return;
  const i = e[t], a = e.length;
  r === void 0 ? (delete e[t], e[gi] && e[gi][t] && i !== void 0 && e[gi][t].$()) : (e[t] = r, e[gi] && e[gi][t] && i === void 0 && e[gi][t].$());
  let o = vc(e, ts), s;
  if ((s = nd(o, t, i)) && s.$(() => r), Array.isArray(e) && e.length !== a) {
    for (let l = e.length; l < a; l++) (s = o[l]) && s.$();
    (s = nd(o, "length", a)) && s.$(e.length);
  }
  (s = o[E8]) && s.$();
}
function O8(e, t) {
  const r = Object.keys(t);
  for (let n = 0; n < r.length; n += 1) {
    const i = r[n];
    gn(e, i, t[i]);
  }
}
function uK(e, t) {
  if (typeof t == "function" && (t = t(e)), t = bs(t), Array.isArray(t)) {
    if (e === t) return;
    let r = 0, n = t.length;
    for (; r < n; r++) {
      const i = t[r];
      e[r] !== i && gn(e, r, i);
    }
    gn(e, "length", n);
  } else O8(e, t);
}
function kl(e, t, r = []) {
  let n, i = e;
  if (t.length > 1) {
    n = t.shift();
    const o = typeof n, s = Array.isArray(e);
    if (Array.isArray(n)) {
      for (let l = 0; l < n.length; l++)
        kl(e, [n[l]].concat(t), r);
      return;
    } else if (s && o === "function") {
      for (let l = 0; l < e.length; l++)
        n(e[l], l) && kl(e, [l].concat(t), r);
      return;
    } else if (s && o === "object") {
      const { from: l = 0, to: d = e.length - 1, by: u = 1 } = n;
      for (let c = l; c <= d; c += u)
        kl(e, [c].concat(t), r);
      return;
    } else if (t.length > 1) {
      kl(e[n], t, [n].concat(r));
      return;
    }
    i = e[n], r = [n].concat(r);
  }
  let a = t[0];
  typeof a == "function" && (a = a(i, r), a === i) || n === void 0 && a == null || (a = bs(a), n === void 0 || la(i) && la(a) && !Array.isArray(a) ? O8(i, a) : gn(e, n, a));
}
function Ls(...[e, t]) {
  const r = bs(e || {}), n = Array.isArray(r), i = T8(r);
  function a(...o) {
    Mu(() => {
      n && o.length === 1 ? uK(r, o[0]) : kl(r, o);
    });
  }
  return [i, a];
}
const Mh = Symbol("store-root");
function Oo(e, t, r, n, i) {
  const a = t[r];
  if (e === a) return;
  const o = Array.isArray(e);
  if (r !== Mh && (!la(e) || !la(a) || o !== Array.isArray(a) || i && e[i] !== a[i])) {
    gn(t, r, e);
    return;
  }
  if (o) {
    if (e.length && a.length && (!n || i && e[0] && e[0][i] != null)) {
      let d, u, c, h, f, p, g, v;
      for (c = 0, h = Math.min(a.length, e.length); c < h && (a[c] === e[c] || i && a[c] && e[c] && a[c][i] === e[c][i]); c++)
        Oo(e[c], a, c, n, i);
      const m = new Array(e.length), $ = /* @__PURE__ */ new Map();
      for (h = a.length - 1, f = e.length - 1; h >= c && f >= c && (a[h] === e[f] || i && a[h] && e[f] && a[h][i] === e[f][i]); h--, f--)
        m[f] = a[h];
      if (c > f || c > h) {
        for (u = c; u <= f; u++) gn(a, u, e[u]);
        for (; u < e.length; u++)
          gn(a, u, m[u]), Oo(e[u], a, u, n, i);
        a.length > e.length && gn(a, "length", e.length);
        return;
      }
      for (g = new Array(f + 1), u = f; u >= c; u--)
        p = e[u], v = i && p ? p[i] : p, d = $.get(v), g[u] = d === void 0 ? -1 : d, $.set(v, u);
      for (d = c; d <= h; d++)
        p = a[d], v = i && p ? p[i] : p, u = $.get(v), u !== void 0 && u !== -1 && (m[u] = a[d], u = g[u], $.set(v, u));
      for (u = c; u < e.length; u++)
        u in m ? (gn(a, u, m[u]), Oo(e[u], a, u, n, i)) : gn(a, u, e[u]);
    } else
      for (let d = 0, u = e.length; d < u; d++)
        Oo(e[d], a, d, n, i);
    a.length > e.length && gn(a, "length", e.length);
    return;
  }
  const s = Object.keys(e);
  for (let d = 0, u = s.length; d < u; d++)
    Oo(e[s[d]], a, s[d], n, i);
  const l = Object.keys(a);
  for (let d = 0, u = l.length; d < u; d++)
    e[l[d]] === void 0 && gn(a, l[d], void 0);
}
function cK(e, t = {}) {
  const { merge: r, key: n = "id" } = t, i = bs(e);
  return (a) => {
    if (!la(a) || !la(i)) return i;
    const o = Oo(
      i,
      {
        [Mh]: a
      },
      Mh,
      r,
      n
    );
    return o === void 0 ? a : o;
  };
}
function hK(e) {
  const t = Be(e), r = new aK(t), [n, i] = Ls(r.getVirtualItems()), [a, o] = H(r.getTotalSize()), s = {
    get(d, u) {
      switch (u) {
        case "getVirtualItems":
          return () => n;
        case "getTotalSize":
          return () => a();
        default:
          return Reflect.get(d, u);
      }
    }
  }, l = new Proxy(r, s);
  return l.setOptions(t), Et(() => {
    const d = l._didMount();
    l._willUpdate(), xr(d);
  }), Kh(() => {
    l.setOptions(Be(t, e, {
      onChange: (d, u) => {
        var c;
        d._willUpdate(), i(cK(d.getVirtualItems(), {
          key: "index"
        })), o(d.getTotalSize()), (c = e.onChange) == null || c.call(e, d, u);
      }
    })), l.measure();
  }), l;
}
function yp(e) {
  return hK(Be({
    observeElementRect: tK,
    observeElementOffset: rK,
    scrollToFn: iK
  }, e));
}
var fK = /* @__PURE__ */ K('<div slot=suffix class=flex><sl-icon class="text-gray-400 hover:text-gray-600"name=x-circle-fill>', !0, !1, !1), pK = /* @__PURE__ */ K('<div><style></style><style></style><style></style><style></style><sl-dropdown class="dropdown relative"hoist><sl-input slot=trigger autocomplete=off size=medium class=input><p slot=help-text class="text-red-400 pt-1 font-sans"></p><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div><div slot=suffix class=flex><sl-icon></sl-icon></div></sl-input><div class="border border-gray-200 dropdown-container overflow-hidden relative"><div class="bg-white overflow-x-hidden overflow-y-auto relative"><div>', !0, !1, !1), mK = /* @__PURE__ */ K('<sl-menu-item><p class="text-center text-gray-400 italic">Loading...', !0, !1, !1), I8 = /* @__PURE__ */ K("<sl-menu-item>", !0, !1, !1), gK = /* @__PURE__ */ K("<sl-menu-item class=group>", !0, !1, !1), vK = /* @__PURE__ */ K('<p class="text-center text-gray-400 italic">Loading...'), yK = /* @__PURE__ */ K('<p class="text-center text-gray-400 italic">Nothing more to load'), bK = /* @__PURE__ */ K("<p>");
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const lo = (e) => {
  let t, r, n, i, a;
  e.actionRef && (e.actionRef.clear = () => {
    d(void 0), c(-1), i.value = "", p(""), $();
  });
  const [o, s] = H(!1), [l, d] = H(void 0), [u, c] = H(-1), [h, f] = H(), p = $d(async (E) => {
    e.onSearchChange && await e.onSearchChange(E);
  }, 250), g = new IntersectionObserver(async (E) => {
    E?.at(-1)?.isIntersecting && e.hasMore && e.fetchMore && await e.fetchMore();
  });
  me(() => {
    e.data.length === 0 && d(void 0);
  }), me(() => {
    h() && g.observe(h());
  });
  const v = (E) => {
    if (E)
      return e.helpText ? e.helpText : e.required ? "Please select data..." : void 0;
  }, m = (E) => {
    const N = new CustomEvent("photon-data-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        data: E
      }
    });
    t?.dispatchEvent(N);
  }, $ = () => {
    const E = new CustomEvent("photon-data-unselected", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(E);
  };
  me(() => {
    e.selectedData && d(e.selectedData), e.selectedData === void 0 && d(void 0);
  }), Et(() => {
    i && i.addEventListener("keydown", (E) => {
      (E.code == "Space" || E.key == " ") && E.stopImmediatePropagation();
    });
  });
  const w = L(() => {
    const E = l();
    return E ? e.displayAccessor(E, !1) : e.placeholder ?? "Select data...";
  }), k = L(() => e.groups ? e.groups.map((E) => {
    const N = e.data.map((M, V) => ({
      data: M,
      allItemsIdx: V
    })).filter((M) => E.filter(M.data));
    return N.length > 0 ? [{
      title: E.label
    }, ...N] : [];
  }).flat() : e.data.map((E, N) => ({
    data: E,
    allItemsIdx: N
  }))), C = L(() => yp({
    count: k().length,
    getScrollElement: () => n ?? null,
    estimateSize: () => 36.8,
    overscan: 100
  }));
  return (() => {
    var E = pK(), N = E.firstChild, M = N.nextSibling, V = M.nextSibling, q = V.nextSibling, I = q.nextSibling, P = I.firstChild, z = P.firstChild, G = z.nextSibling, se = G.firstChild, ue = G.nextSibling, de = ue.firstChild, D = P.nextSibling, R = D.firstChild, Q = R.firstChild, Z = t;
    typeof Z == "function" ? ze(Z, E) : t = E, A(N, Rt), A(M, Ur), A(V, qr), A(q, KY), ce(I, "sl-show", async () => {
      s(!0), e.onOpen && await e.onOpen();
    }), ce(I, "sl-hide", async () => {
      l() || (i.value = "", e.onHide && await e.onHide()), s(!1);
    });
    var F = r;
    typeof F == "function" ? ze(F, I) : r = I, I.style.setProperty("width", "100%"), I._$owner = fe(), ce(P, "sl-focus", (re) => {
      e.onInputFocus ? (e.onInputFocus(), re.stopImmediatePropagation()) : (r.children[1].style.width = `${i.clientWidth}px`, u() > 0 && C().scrollToIndex(u()));
    }), ce(P, "click", async (re) => {
      re.preventDefault();
    }), ce(P, "sl-input", (re) => {
      o() || r.show(), p(re.target.value);
    });
    var oe = i;
    typeof oe == "function" ? ze(oe, P) : i = P, P._$owner = fe(), A(z, () => v(e.invalid ?? !1)), se._$owner = fe(), A(P, b(X, {
      get when() {
        return e.clearable;
      },
      get children() {
        var re = fK(), Ie = re.firstChild;
        return ce(Ie, "click", (Pe) => {
          Pe.stopImmediatePropagation(), d(void 0), c(-1), i.value = "", p(""), $(), r.hide();
        }), Ie._$owner = fe(), J(() => re.classList.toggle("hidden", !!(e.isLoading || l() == null))), re;
      }
    }), ue), de._$owner = fe();
    var pe = a;
    typeof pe == "function" ? ze(pe, R) : a = R, R.style.setProperty("max-height", "200px"), R.style.setProperty("min-height", "37px"), R.style.setProperty("width", "100%"), R.style.setProperty("display", "flex"), R.style.setProperty("flex-direction", "column"), R.style.setProperty("justify-content", "start");
    var ee = n;
    return typeof ee == "function" ? ze(ee, Q) : n = Q, Q.style.setProperty("width", "100%"), A(Q, b(kt, {
      get each() {
        return C().getVirtualItems();
      },
      get fallback() {
        return b($K, {
          get noDataMsg() {
            return e.noDataMsg;
          },
          get isLoading() {
            return e.isLoading;
          }
        });
      },
      children: (re) => {
        const Ie = re.index > k().length - 1, Pe = k()[re.index], at = l(), Xe = !Ie && !!at && "id" in at && "data" in Pe && at.id === Pe.data.id;
        return b(Ac, {
          get children() {
            return [b(vn, {
              get when() {
                return "title" in Pe;
              },
              get children() {
                return b(wK, {
                  item: Pe
                });
              }
            }), b(vn, {
              get when() {
                return "data" in Pe;
              },
              get children() {
                return b(xK, {
                  item: re,
                  isLoader: Ie,
                  isSelected: Xe,
                  get index() {
                    return re.index;
                  },
                  get hasMore() {
                    return e.hasMore;
                  },
                  get showOverflow() {
                    return e.showOverflow;
                  },
                  onClick: () => {
                    Ie || (d(Pe.data), c(Pe.allItemsIdx), i.value = "", p(""), m(Pe.data), r.hide());
                  },
                  setLastIndex: f,
                  get children() {
                    return e.displayAccessor(Pe.data, !0);
                  }
                });
              }
            })];
          }
        });
      }
    })), J((re) => {
      var Ie = e.forceLabelSize && !e.invalid ? -20 : e.invalid ? -18 : 0, Pe = e.disabled ?? !1, at = e.label, Xe = w(), ft = e.disabled ?? !1, bt = !!(e.invalid ?? !1), le = !!(e.disabled ?? !1), Y = !l() && i.value === "", ve = e.required, xe = !!e.forceLabelSize, Qe = !e.isLoading, Fe = !!e.isLoading, He = o() ? "chevron-up" : "chevron-down", Ge = `${C().getTotalSize()}px`;
      return Ie !== re.e && (I.distance = re.e = Ie), Pe !== re.t && (I.disabled = re.t = Pe), at !== re.a && (P.label = re.a = at), Xe !== re.o && (P.placeholder = re.o = Xe), ft !== re.i && (P.disabled = re.i = ft), bt !== re.n && P.classList.toggle("invalid", re.n = bt), le !== re.s && P.classList.toggle("disabled", re.s = le), Y !== re.h && P.classList.toggle("placeholder", re.h = Y), ve !== re.r && (P.required = re.r = ve), xe !== re.d && z.classList.toggle("h-[21px]", re.d = xe), Qe !== re.l && G.classList.toggle("hidden", re.l = Qe), Fe !== re.u && ue.classList.toggle("hidden", re.u = Fe), He !== re.c && (de.name = re.c = He), Ge !== re.w && ((re.w = Ge) != null ? Q.style.setProperty("height", Ge) : Q.style.removeProperty("height")), re;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0,
      h: void 0,
      r: void 0,
      d: void 0,
      l: void 0,
      u: void 0,
      c: void 0,
      w: void 0
    }), E;
  })();
}, $K = (e) => b(X, {
  get when() {
    return e.isLoading;
  },
  get fallback() {
    return (() => {
      var t = I8();
      return t._$owner = fe(), A(t, () => e.noDataMsg ? e.noDataMsg : "No data found"), t;
    })();
  },
  get children() {
    var t = mK();
    return t._$owner = fe(), t;
  }
}), wK = (e) => (() => {
  var t = gK();
  return t._$owner = fe(), A(t, () => e.item.title), t;
})(), xK = (e) => (() => {
  var t = I8();
  return ze((r) => {
    e.isLoader && e.index > 0 && e.setLastIndex(r);
  }, t), t.$$click = () => e.onClick(), t.style.setProperty("width", "100%"), t._$owner = fe(), A(t, (() => {
    var r = L(() => !!e.isLoader);
    return () => r() ? L(() => !!e.hasMore)() ? vK() : yK() : (() => {
      var n = bK();
      return A(n, () => e.children), J((i) => {
        var a = !e.showOverflow, o = !e.showOverflow, s = !e.showOverflow, l = !!e.showOverflow;
        return a !== i.e && n.classList.toggle("overflow-hidden", i.e = a), o !== i.t && n.classList.toggle("overflow-ellipsis", i.t = o), s !== i.a && n.classList.toggle("whitespace-nowrap", i.a = s), l !== i.o && n.classList.toggle("whitespace-normal", i.o = l), i;
      }, {
        e: void 0,
        t: void 0,
        a: void 0,
        o: void 0
      }), n;
    })();
  })()), J((r) => {
    var n = e.isSelected ? "selected default" : "default", i = `${e.item.size}px`;
    return n !== r.e && Wi(t, r.e = n), i !== r.t && ((r.t = i) != null ? t.style.setProperty("min-height", i) : t.style.removeProperty("min-height")), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
da(["click"]);
const Bg = Ce`
  fragment PatientOrderFields on Patient {
    id
    externalId
    name {
      full
      first
      middle
      last
      title
    }
    dateOfBirth
    sex
    gender
    email
    phone
    address {
      name {
        full
      }
      city
      country
      postalCode
      state
      street1
      street2
    }
    preferredPharmacies {
      id
      name
      address {
        city
        country
        postalCode
        state
        street1
        street2
      }
      phone
    }
  }
`, kK = () => {
  const [e, t] = Ls({
    patients: {
      data: [],
      errors: [],
      isLoading: !1,
      finished: !1
    },
    selectedPatient: {
      data: void 0,
      errors: [],
      isLoading: !1
    }
  }), r = async (s, l) => {
    t("selectedPatient", {
      ...e.selectedPatient,
      isLoading: !0
    });
    const { data: d, errors: u } = await s.clinical.patient.getPatient({
      id: l,
      fragment: {
        PatientOrderFields: Bg
      }
    });
    t("selectedPatient", {
      ...e.selectedPatient,
      isLoading: !1,
      data: d.patient,
      errors: u
    });
  }, n = async (s, l) => {
    l || (l = {}), t("patients", {
      ...e.patients,
      isLoading: !0
    });
    const { data: d, errors: u } = await s.clinical.patient.getPatients({
      first: l.first,
      name: l.name,
      fragment: {
        PatientOrderFields: Bg
      }
    });
    return t("patients", {
      ...e.patients,
      isLoading: !1,
      errors: u,
      data: d.patients,
      finished: d.patients.length === 0
    }), (!u || u.length === 0) && d.patients.length > 0 ? () => i(s, {
      ...l,
      after: d.patients?.at(-1).id
    }) : void 0;
  }, i = async (s, l) => {
    t("patients", {
      ...e.patients,
      isLoading: !0
    });
    const { data: d, errors: u } = await s.clinical.patient.getPatients(l);
    return t("patients", {
      ...e.patients,
      isLoading: !1,
      errors: u,
      data: [...e.patients.data, ...d.patients],
      finished: d.patients.length === 0
    }), (!u || u.length === 0) && d.patients.length > 0 ? () => i(s, {
      ...l,
      after: d.patients?.at(-1).id
    }) : void 0;
  };
  return {
    store: e,
    actions: {
      getPatients: n,
      getSelectedPatient: r,
      clearSelectedPatient: async () => {
        t("selectedPatient", {
          ...e.selectedPatient,
          data: void 0
        });
      },
      reset: async () => {
        t("patients", {
          data: [],
          errors: [],
          isLoading: !1,
          finished: !1
        }), t("selectedPatient", {
          data: void 0,
          errors: [],
          isLoading: !1
        });
      }
    }
  };
}, _d = kK();
var _K = /* @__PURE__ */ K("<div>");
const CK = (e) => {
  let t;
  const r = Xr(), {
    store: n,
    actions: i
  } = _d;
  let a;
  Et(() => {
    i.reset();
  });
  const o = (l) => {
    const d = new CustomEvent("photon-patient-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        patient: l
      }
    });
    t?.dispatchEvent(d);
  }, s = L(() => n.selectedPatient.data ? [n.selectedPatient.data, ...n.patients.data.filter((l) => l?.id !== n.selectedPatient.data.id)] : n.patients.data);
  return me(async () => {
    e.selected && !n.selectedPatient.data && Re(async () => {
      await i.getSelectedPatient(r ? r.getSDK() : e.sdk, e.selected);
    });
  }), (() => {
    var l = _K();
    ce(l, "photon-data-selected", (u) => {
      o(u.detail.data);
    });
    var d = t;
    return typeof d == "function" ? ze(d, l) : t = l, A(l, b(lo, {
      get data() {
        return s();
      },
      get label() {
        return e.label;
      },
      get forceLabelSize() {
        return e.forceLabelSize;
      },
      get required() {
        return e.required;
      },
      get disabled() {
        return e.disabled;
      },
      placeholder: "Select patient...",
      get invalid() {
        return e.invalid;
      },
      get isLoading() {
        return n.patients.isLoading || n.selectedPatient.isLoading;
      },
      get hasMore() {
        return n.patients.data.length % 25 === 0 && !n.patients.finished;
      },
      displayAccessor: (u) => u?.name?.full || "",
      onSearchChange: async (u) => a = await i.getPatients(r.getSDK(), {
        name: u
      }),
      onOpen: async () => {
        n.patients.data.length == 0 && (a = await i.getPatients(r.getSDK()));
      },
      onHide: async () => {
        a = await i.getPatients(r.getSDK());
      },
      fetchMore: async () => {
        a && (a = await a());
      },
      noDataMsg: "No patients found",
      get helpText() {
        return e.helpText;
      },
      get selectedData() {
        return n.selectedPatient.data;
      }
    })), l;
  })();
};
Tt("photon-patient-select", {
  label: void 0,
  required: !1,
  invalid: !1,
  helpText: void 0,
  selected: void 0,
  formName: void 0,
  disabled: !1,
  forceLabelSize: !1,
  sdk: void 0
}, CK);
var A1 = /* @__PURE__ */ K("<style>"), SK = /* @__PURE__ */ K("<slot>"), EK = /* @__PURE__ */ K("<photon-login>", !0, !1, !1), TK = /* @__PURE__ */ K('<div class="w-full flex justify-center"><sl-spinner>', !0, !1, !1);
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const AK = (e) => {
  const t = Xr(), [r, n] = H(!1), [i, a] = H(!0);
  return me(() => {
    t || console.error("[photon-auth-wrapper] No valid PhotonClient instance was provided. Please ensure you are wrapping the element in a photon-client element");
  }), me(() => {
    if (t?.authentication.state.isLoading)
      a(!0);
    else {
      if (a(!1), !t?.authentication.state.isAuthenticated && e.autoLogin) {
        const o = {
          appState: {}
        };
        e.redirectPath && (o.appState.returnTo = e.redirectPath), t?.authentication.login(o);
      }
      n(t?.authentication.state.isAuthenticated || !1);
    }
  }), [(() => {
    var o = A1();
    return A(o, Rt), o;
  })(), (() => {
    var o = A1();
    return A(o, Ur), o;
  })(), (() => {
    var o = A1();
    return A(o, qr), o;
  })(), b(X, {
    get when() {
      return t && r();
    },
    get children() {
      var o = SK();
      return o._$owner = fe(), o;
    }
  }), b(X, {
    get when() {
      return t && !r() && !i() && !e.autoLogin;
    },
    get children() {
      var o = EK();
      return o._$owner = fe(), J(() => o.redirectPath = e.redirectPath), o;
    }
  }), b(X, {
    get when() {
      return t && i() && !e.hideLoader;
    },
    get children() {
      var o = TK(), s = o.firstChild;
      return s.style.setProperty("font-size", "3rem"), s._$owner = fe(), o;
    }
  })];
};
Tt("photon-auth-wrapper", {
  autoLogin: !1,
  hideLoader: !1,
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  }
}, AK);
class OK extends TypeError {
  constructor(t, r) {
    let n;
    const { message: i, explanation: a, ...o } = t, { path: s } = t, l = s.length === 0 ? i : `At path: ${s.join(".")} -- ${i}`;
    super(a ?? l), a != null && (this.cause = l), Object.assign(this, o), this.name = this.constructor.name, this.failures = () => n ?? (n = [t, ...r()]);
  }
}
function IK(e) {
  return rs(e) && typeof e[Symbol.iterator] == "function";
}
function rs(e) {
  return typeof e == "object" && e != null;
}
function eo(e) {
  return typeof e == "symbol" ? e.toString() : typeof e == "string" ? JSON.stringify(e) : `${e}`;
}
function PK(e) {
  const { done: t, value: r } = e.next();
  return t ? void 0 : r;
}
function DK(e, t, r, n) {
  if (e === !0)
    return;
  e === !1 ? e = {} : typeof e == "string" && (e = { message: e });
  const { path: i, branch: a } = t, { type: o } = r, { refinement: s, message: l = `Expected a value of type \`${o}\`${s ? ` with refinement \`${s}\`` : ""}, but received: \`${eo(n)}\`` } = e;
  return {
    value: n,
    type: o,
    refinement: s,
    key: i[i.length - 1],
    path: i,
    branch: a,
    ...e,
    message: l
  };
}
function* Nh(e, t, r, n) {
  IK(e) || (e = [e]);
  for (const i of e) {
    const a = DK(i, t, r, n);
    a && (yield a);
  }
}
function* bp(e, t, r = {}) {
  const { path: n = [], branch: i = [e], coerce: a = !1, mask: o = !1 } = r, s = { path: n, branch: i };
  if (a && (e = t.coercer(e, s), o && t.type !== "type" && rs(t.schema) && rs(e) && !Array.isArray(e)))
    for (const d in e)
      t.schema[d] === void 0 && delete e[d];
  let l = "valid";
  for (const d of t.validator(e, s))
    d.explanation = r.message, l = "not_valid", yield [d, void 0];
  for (let [d, u, c] of t.entries(e, s)) {
    const h = bp(u, c, {
      path: d === void 0 ? n : [...n, d],
      branch: d === void 0 ? i : [...i, u],
      coerce: a,
      mask: o,
      message: r.message
    });
    for (const f of h)
      f[0] ? (l = f[0].refinement != null ? "not_refined" : "not_valid", yield [f[0], void 0]) : a && (u = f[1], d === void 0 ? e = u : e instanceof Map ? e.set(d, u) : e instanceof Set ? e.add(u) : rs(e) && (u !== void 0 || d in e) && (e[d] = u));
  }
  if (l !== "not_valid")
    for (const d of t.refiner(e, s))
      d.explanation = r.message, l = "not_refined", yield [d, void 0];
  l === "valid" && (yield [void 0, e]);
}
class Cd {
  constructor(t) {
    const { type: r, schema: n, validator: i, refiner: a, coercer: o = (l) => l, entries: s = function* () {
    } } = t;
    this.type = r, this.schema = n, this.entries = s, this.coercer = o, i ? this.validator = (l, d) => {
      const u = i(l, d);
      return Nh(u, d, this, l);
    } : this.validator = () => [], a ? this.refiner = (l, d) => {
      const u = a(l, d);
      return Nh(u, d, this, l);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(t, r) {
    return P8(t, this, r);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(t, r) {
    return MK(t, this, r);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(t) {
    return D8(t, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(t, r) {
    return NK(t, this, r);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(t, r = {}) {
    return Sd(t, this, r);
  }
}
function P8(e, t, r) {
  const n = Sd(e, t, { message: r });
  if (n[0])
    throw n[0];
}
function MK(e, t, r) {
  const n = Sd(e, t, { coerce: !0, message: r });
  if (n[0])
    throw n[0];
  return n[1];
}
function NK(e, t, r) {
  const n = Sd(e, t, { coerce: !0, mask: !0, message: r });
  if (n[0])
    throw n[0];
  return n[1];
}
function D8(e, t) {
  return !Sd(e, t)[0];
}
function Sd(e, t, r = {}) {
  const n = bp(e, t, r), i = PK(n);
  return i[0] ? [new OK(i[0], function* () {
    for (const o of n)
      o[0] && (yield o[0]);
  }), void 0] : [void 0, i[1]];
}
function uo(e, t) {
  return new Cd({ type: e, schema: null, validator: t });
}
function c0() {
  return uo("any", () => !0);
}
function LK(e) {
  const t = {}, r = e.map((n) => eo(n)).join();
  for (const n of e)
    t[n] = n;
  return new Cd({
    type: "enums",
    schema: t,
    validator(n) {
      return e.includes(n) || `Expected one of \`${r}\`, but received: ${eo(n)}`;
    }
  });
}
function Hg() {
  return uo("number", (e) => typeof e == "number" && !isNaN(e) || `Expected a number, but received: ${eo(e)}`);
}
function $p(e, t) {
  return new Cd({
    type: "record",
    schema: null,
    *entries(r) {
      if (rs(r))
        for (const n in r) {
          const i = r[n];
          yield [n, n, e], yield [n, i, t];
        }
    },
    validator(r) {
      return rs(r) || `Expected an object, but received: ${eo(r)}`;
    }
  });
}
function sn() {
  return uo("string", (e) => typeof e == "string" || `Expected a string, but received: ${eo(e)}`);
}
function Wg(e) {
  const t = e.map((r) => r.type).join(" | ");
  return new Cd({
    type: "union",
    schema: null,
    coercer(r) {
      for (const n of e) {
        const [i, a] = n.validate(r, { coerce: !0 });
        if (!i)
          return a;
      }
      return r;
    },
    validator(r, n) {
      const i = [];
      for (const a of e) {
        const [...o] = bp(r, a, n), [s] = o;
        if (s[0])
          for (const [l] of o)
            l && i.push(l);
        else
          return [];
      }
      return [
        `Expected the value to satisfy a union of \`${t}\`, but received: ${eo(r)}`,
        ...i
      ];
    }
  });
}
function Qg(e, t, r = {}) {
  const { exclusive: n } = r;
  return Fs(e, "min", (i) => n ? i > t : i >= t || `Expected a ${e.type} greater than ${n ? "" : "or equal to "}${t} but received \`${i}\``);
}
function Ca(e, t, r = t) {
  const n = `Expected a ${e.type}`, i = t === r ? `of \`${t}\`` : `between \`${t}\` and \`${r}\``;
  return Fs(e, "size", (a) => {
    if (typeof a == "number" || a instanceof Date)
      return t <= a && a <= r || `${n} ${i} but received \`${a}\``;
    if (a instanceof Map || a instanceof Set) {
      const { size: o } = a;
      return t <= o && o <= r || `${n} with a size ${i} but received one with a size of \`${o}\``;
    } else {
      const { length: o } = a;
      return t <= o && o <= r || `${n} with a length ${i} but received one with a length of \`${o}\``;
    }
  });
}
function Fs(e, t, r) {
  return new Cd({
    ...e,
    *refiner(n, i) {
      yield* e.refiner(n, i);
      const a = r(n, i), o = Nh(a, i, e, n);
      for (const s of o)
        yield { ...s, refinement: t };
    }
  });
}
const M8 = (e) => {
  const t = {};
  if (e) {
    const h = {};
    for (const f of Object.keys(e))
      h[f] = {
        value: e[f],
        error: void 0
      };
    e = h;
  }
  const [r, n] = Ls(e || {}), i = ({ key: h, value: f }) => {
    n(h, {
      value: f,
      error: void 0
    });
  }, a = (h) => {
    let f = 0;
    for (const p in r)
      h.includes(p) && r[p]?.error && (f += 1);
    return f > 0;
  }, o = (h) => {
    let f = [];
    for (const p in r)
      h.includes(p) && r[p]?.error && (f = [...f, { key: p, error: r[p]?.error ?? "" }]);
    return f;
  }, s = (h) => {
    for (const f of h)
      n(f, void 0);
  };
  return {
    store: r,
    actions: {
      updateFormValue: i,
      clearKeys: s,
      registerValidator: ({ key: h, validator: f }) => {
        if (h in t) {
          t[h] = [...t[h], f];
          return;
        }
        t[h] = [f];
      },
      unRegisterValidator: (h) => {
        delete t[h];
      },
      validate: (h) => {
        Object.entries(r).filter(([f]) => h ? h.includes(f) : !0).forEach(([f, p]) => {
          t[f] && t[f].forEach((g) => {
            try {
              P8(p?.value, g);
            } catch (v) {
              for (const m of v.failures())
                n(f, {
                  value: p?.value,
                  error: m.message
                });
            }
          });
        });
      },
      hasErrors: a,
      getErrors: o,
      reset: () => {
        const h = Object.keys(r);
        s(h);
        const f = Object.keys(t);
        for (const p of f)
          delete t[p];
      }
    }
  };
};
var N8 = (e) => {
  var t;
  const { activeElement: r } = document;
  r && e.contains(r) && ((t = document.activeElement) == null || t.blur());
}, FK = gr`
  :host {
    display: inline-block;
    color: var(--sl-color-neutral-600);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-x-fast) color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--sl-color-primary-600);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: var(--sl-color-primary-700);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const L8 = Symbol.for(""), RK = (e) => {
  if (e?.r === L8) return e?._$litStatic$;
}, yc = (e, ...t) => ({ _$litStatic$: t.reduce((r, n, i) => r + ((a) => {
  if (a._$litStatic$ !== void 0) return a._$litStatic$;
  throw Error(`Value passed to 'literal' function must be a 'literal' result: ${a}. Use 'unsafeStatic' to pass non-literal values, but
            take care to ensure page security.`);
})(n) + e[i + 1], e[0]), r: L8 }), Gg = /* @__PURE__ */ new Map(), zK = (e) => (t, ...r) => {
  const n = r.length;
  let i, a;
  const o = [], s = [];
  let l, d = 0, u = !1;
  for (; d < n; ) {
    for (l = t[d]; d < n && (a = r[d], (i = RK(a)) !== void 0); ) l += i + t[++d], u = !0;
    d !== n && s.push(a), o.push(l), d++;
  }
  if (d === n && o.push(t[n]), u) {
    const c = o.join("$$lit$$");
    (t = Gg.get(c)) === void 0 && (o.raw = o, Gg.set(c, t = o)), r = s;
  }
  return e(t, ...r);
}, Tu = zK(xt);
var Br = class extends ar {
  constructor() {
    super(...arguments), this.hasFocus = !1, this.label = "", this.disabled = !1;
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleClick(e) {
    this.disabled && (e.preventDefault(), e.stopPropagation());
  }
  /** Simulates a click on the icon button. */
  click() {
    this.button.click();
  }
  /** Sets focus on the icon button. */
  focus(e) {
    this.button.focus(e);
  }
  /** Removes focus from the icon button. */
  blur() {
    this.button.blur();
  }
  render() {
    const e = !!this.href, t = e ? yc`a` : yc`button`;
    return Tu`
      <${t}
        part="base"
        class=${dr({
      "icon-button": !0,
      "icon-button--disabled": !e && this.disabled,
      "icon-button--focused": this.hasFocus
    })}
        ?disabled=${Me(e ? void 0 : this.disabled)}
        type=${Me(e ? void 0 : "button")}
        href=${Me(e ? this.href : void 0)}
        target=${Me(e ? this.target : void 0)}
        download=${Me(e ? this.download : void 0)}
        rel=${Me(e && this.target ? "noreferrer noopener" : void 0)}
        role=${Me(e ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label="${this.label}"
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <sl-icon
          class="icon-button__icon"
          name=${Me(this.name)}
          library=${Me(this.library)}
          src=${Me(this.src)}
          aria-hidden="true"
        ></sl-icon>
      </${t}>
    `;
  }
};
Br.styles = [Ar, FK];
Br.dependencies = { "sl-icon": Vr };
O([
  jt(".icon-button")
], Br.prototype, "button", 2);
O([
  Fn()
], Br.prototype, "hasFocus", 2);
O([
  U()
], Br.prototype, "name", 2);
O([
  U()
], Br.prototype, "library", 2);
O([
  U()
], Br.prototype, "src", 2);
O([
  U()
], Br.prototype, "href", 2);
O([
  U()
], Br.prototype, "target", 2);
O([
  U()
], Br.prototype, "download", 2);
O([
  U()
], Br.prototype, "label", 2);
O([
  U({ type: Boolean, reflect: !0 })
], Br.prototype, "disabled", 2);
var jK = gr`
  :host {
    display: contents;

    /* For better DX, we'll reset the margin here so the base part can inherit it */
    margin: 0;
  }

  .alert {
    position: relative;
    display: flex;
    align-items: stretch;
    background-color: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-top-width: calc(var(--sl-panel-border-width) * 3);
    border-radius: var(--sl-border-radius-medium);
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-small);
    font-weight: var(--sl-font-weight-normal);
    line-height: 1.6;
    color: var(--sl-color-neutral-700);
    margin: inherit;
    overflow: hidden;
  }

  .alert:not(.alert--has-icon) .alert__icon,
  .alert:not(.alert--closable) .alert__close-button {
    display: none;
  }

  .alert__icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-large);
    padding-inline-start: var(--sl-spacing-large);
  }

  .alert--has-countdown {
    border-bottom: none;
  }

  .alert--primary {
    border-top-color: var(--sl-color-primary-600);
  }

  .alert--primary .alert__icon {
    color: var(--sl-color-primary-600);
  }

  .alert--success {
    border-top-color: var(--sl-color-success-600);
  }

  .alert--success .alert__icon {
    color: var(--sl-color-success-600);
  }

  .alert--neutral {
    border-top-color: var(--sl-color-neutral-600);
  }

  .alert--neutral .alert__icon {
    color: var(--sl-color-neutral-600);
  }

  .alert--warning {
    border-top-color: var(--sl-color-warning-600);
  }

  .alert--warning .alert__icon {
    color: var(--sl-color-warning-600);
  }

  .alert--danger {
    border-top-color: var(--sl-color-danger-600);
  }

  .alert--danger .alert__icon {
    color: var(--sl-color-danger-600);
  }

  .alert__message {
    flex: 1 1 auto;
    display: block;
    padding: var(--sl-spacing-large);
    overflow: hidden;
  }

  .alert__close-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
    margin-inline-end: var(--sl-spacing-medium);
    align-self: center;
  }

  .alert__countdown {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: calc(var(--sl-panel-border-width) * 3);
    background-color: var(--sl-panel-border-color);
    display: flex;
  }

  .alert__countdown--ltr {
    justify-content: flex-end;
  }

  .alert__countdown .alert__countdown-elapsed {
    height: 100%;
    width: 0;
  }

  .alert--primary .alert__countdown-elapsed {
    background-color: var(--sl-color-primary-600);
  }

  .alert--success .alert__countdown-elapsed {
    background-color: var(--sl-color-success-600);
  }

  .alert--neutral .alert__countdown-elapsed {
    background-color: var(--sl-color-neutral-600);
  }

  .alert--warning .alert__countdown-elapsed {
    background-color: var(--sl-color-warning-600);
  }

  .alert--danger .alert__countdown-elapsed {
    background-color: var(--sl-color-danger-600);
  }

  .alert__timer {
    display: none;
  }
`, pn = class Sa extends ar {
  constructor() {
    super(...arguments), this.hasSlotController = new ha(this, "icon", "suffix"), this.localize = new Ei(this), this.open = !1, this.closable = !1, this.variant = "primary", this.duration = 1 / 0, this.remainingTime = this.duration;
  }
  static get toastStack() {
    return this.currentToastStack || (this.currentToastStack = Object.assign(document.createElement("div"), {
      className: "sl-toast-stack"
    })), this.currentToastStack;
  }
  firstUpdated() {
    this.base.hidden = !this.open;
  }
  restartAutoHide() {
    this.handleCountdownChange(), clearTimeout(this.autoHideTimeout), clearInterval(this.remainingTimeInterval), this.open && this.duration < 1 / 0 && (this.autoHideTimeout = window.setTimeout(() => this.hide(), this.duration), this.remainingTime = this.duration, this.remainingTimeInterval = window.setInterval(() => {
      this.remainingTime -= 100;
    }, 100));
  }
  pauseAutoHide() {
    var t;
    (t = this.countdownAnimation) == null || t.pause(), clearTimeout(this.autoHideTimeout), clearInterval(this.remainingTimeInterval);
  }
  resumeAutoHide() {
    var t;
    this.duration < 1 / 0 && (this.autoHideTimeout = window.setTimeout(() => this.hide(), this.remainingTime), this.remainingTimeInterval = window.setInterval(() => {
      this.remainingTime -= 100;
    }, 100), (t = this.countdownAnimation) == null || t.play());
  }
  handleCountdownChange() {
    if (this.open && this.duration < 1 / 0 && this.countdown) {
      const { countdownElement: t } = this, r = "100%", n = "0";
      this.countdownAnimation = t.animate([{ width: r }, { width: n }], {
        duration: this.duration,
        easing: "linear"
      });
    }
  }
  handleCloseClick() {
    this.hide();
  }
  async handleOpenChange() {
    if (this.open) {
      this.emit("sl-show"), this.duration < 1 / 0 && this.restartAutoHide(), await Gn(this.base), this.base.hidden = !1;
      const { keyframes: t, options: r } = Sn(this, "alert.show", { dir: this.localize.dir() });
      await En(this.base, t, r), this.emit("sl-after-show");
    } else {
      N8(this), this.emit("sl-hide"), clearTimeout(this.autoHideTimeout), clearInterval(this.remainingTimeInterval), await Gn(this.base);
      const { keyframes: t, options: r } = Sn(this, "alert.hide", { dir: this.localize.dir() });
      await En(this.base, t, r), this.base.hidden = !0, this.emit("sl-after-hide");
    }
  }
  handleDurationChange() {
    this.restartAutoHide();
  }
  /** Shows the alert. */
  async show() {
    if (!this.open)
      return this.open = !0, sa(this, "sl-after-show");
  }
  /** Hides the alert */
  async hide() {
    if (this.open)
      return this.open = !1, sa(this, "sl-after-hide");
  }
  /**
   * Displays the alert as a toast notification. This will move the alert out of its position in the DOM and, when
   * dismissed, it will be removed from the DOM completely. By storing a reference to the alert, you can reuse it by
   * calling this method again. The returned promise will resolve after the alert is hidden.
   */
  async toast() {
    return new Promise((t) => {
      this.handleCountdownChange(), Sa.toastStack.parentElement === null && document.body.append(Sa.toastStack), Sa.toastStack.appendChild(this), requestAnimationFrame(() => {
        this.clientWidth, this.show();
      }), this.addEventListener(
        "sl-after-hide",
        () => {
          Sa.toastStack.removeChild(this), t(), Sa.toastStack.querySelector("sl-alert") === null && Sa.toastStack.remove();
        },
        { once: !0 }
      );
    });
  }
  render() {
    return xt`
      <div
        part="base"
        class=${dr({
      alert: !0,
      "alert--open": this.open,
      "alert--closable": this.closable,
      "alert--has-countdown": !!this.countdown,
      "alert--has-icon": this.hasSlotController.test("icon"),
      "alert--primary": this.variant === "primary",
      "alert--success": this.variant === "success",
      "alert--neutral": this.variant === "neutral",
      "alert--warning": this.variant === "warning",
      "alert--danger": this.variant === "danger"
    })}
        role="alert"
        aria-hidden=${this.open ? "false" : "true"}
        @mouseenter=${this.pauseAutoHide}
        @mouseleave=${this.resumeAutoHide}
      >
        <div part="icon" class="alert__icon">
          <slot name="icon"></slot>
        </div>

        <div part="message" class="alert__message" aria-live="polite">
          <slot></slot>
        </div>

        ${this.closable ? xt`
              <sl-icon-button
                part="close-button"
                exportparts="base:close-button__base"
                class="alert__close-button"
                name="x-lg"
                library="system"
                label=${this.localize.term("close")}
                @click=${this.handleCloseClick}
              ></sl-icon-button>
            ` : ""}

        <div role="timer" class="alert__timer">${this.remainingTime}</div>

        ${this.countdown ? xt`
              <div
                class=${dr({
      alert__countdown: !0,
      "alert__countdown--ltr": this.countdown === "ltr"
    })}
              >
                <div class="alert__countdown-elapsed"></div>
              </div>
            ` : ""}
      </div>
    `;
  }
};
pn.styles = [Ar, jK];
pn.dependencies = { "sl-icon-button": Br };
O([
  jt('[part~="base"]')
], pn.prototype, "base", 2);
O([
  jt(".alert__countdown-elapsed")
], pn.prototype, "countdownElement", 2);
O([
  U({ type: Boolean, reflect: !0 })
], pn.prototype, "open", 2);
O([
  U({ type: Boolean, reflect: !0 })
], pn.prototype, "closable", 2);
O([
  U({ reflect: !0 })
], pn.prototype, "variant", 2);
O([
  U({ type: Number })
], pn.prototype, "duration", 2);
O([
  U({ type: String, reflect: !0 })
], pn.prototype, "countdown", 2);
O([
  Fn()
], pn.prototype, "remainingTime", 2);
O([
  Nt("open", { waitUntilFirstUpdate: !0 })
], pn.prototype, "handleOpenChange", 1);
O([
  Nt("duration")
], pn.prototype, "handleDurationChange", 1);
var VK = pn;
Rn("alert.show", {
  keyframes: [
    { opacity: 0, scale: 0.8 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 250, easing: "ease" }
});
Rn("alert.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.8 }
  ],
  options: { duration: 250, easing: "ease" }
});
VK.define("sl-alert");
var UK = /* @__PURE__ */ K('<div class="w-full flex justify-center">');
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
function O1(e) {
  return b(U2, {
    type: "error",
    header: "Unauthorized",
    get message() {
      return e.message;
    }
  });
}
const F8 = (e) => {
  const t = Be({
    permissions: []
  }, e), r = Xr(), [n, i] = H(r?.authentication.state.isLoading || !1), [a, o] = H(r?.authentication.state.isAuthenticated || !1), [s, l] = H(r?.authentication.state.isInOrg || !1), [d, u] = H(Ch(t.permissions, r?.authentication.state.permissions || []));
  me(() => {
    i(r?.authentication.state.isLoading || !1);
  }), me(() => {
    o(r?.authentication.state.isAuthenticated || !1);
  }), me(() => {
    l(r?.authentication.state.isInOrg || !1);
  }), me(() => {
    u(Ch(t.permissions, r?.authentication.state.permissions || []));
  });
  const c = L(() => a() && s() && d());
  return b(X, {
    get when() {
      return r && !n();
    },
    get children() {
      return b(X, {
        get when() {
          return c();
        },
        get fallback() {
          return b(X, {
            get when() {
              return !a();
            },
            get fallback() {
              return b(X, {
                get when() {
                  return !s();
                },
                get fallback() {
                  return b(O1, {
                    message: "You are not authorized to prescribe"
                  });
                },
                get children() {
                  return b(O1, {
                    message: "You tried logging in with an account not associated with any organizations. Please check your email for an invite, or ask your administrator for assistance."
                  });
                }
              });
            },
            get children() {
              return b(X, {
                get when() {
                  return r?.autoLogin;
                },
                get fallback() {
                  return b(O1, {
                    message: "You are not signed in"
                  });
                },
                get children() {
                  var h = UK();
                  return A(h, b(ni, {
                    color: "green"
                  })), h;
                }
              });
            }
          });
        },
        get children() {
          return t.children;
        }
      });
    }
  });
}, oi = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}[type=text],input:where(:not([type])),[type=email],[type=url],[type=password],[type=number],[type=date],[type=datetime-local],[type=month],[type=search],[type=tel],[type=time],[type=week],[multiple],textarea,select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border-color:#6b7280;border-width:1px;border-radius:0;padding:.5rem .75rem;font-size:1rem;line-height:1.5rem;--tw-shadow: 0 0 #0000}[type=text]:focus,input:where(:not([type])):focus,[type=email]:focus,[type=url]:focus,[type=password]:focus,[type=number]:focus,[type=date]:focus,[type=datetime-local]:focus,[type=month]:focus,[type=search]:focus,[type=tel]:focus,[type=time]:focus,[type=week]:focus,[multiple]:focus,textarea:focus,select:focus{outline:2px solid transparent;outline-offset:2px;--tw-ring-inset: var(--tw-empty, );--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: #175CD3;--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow);border-color:#175cd3}input::-moz-placeholder,textarea::-moz-placeholder{color:#6b7280;opacity:1}input::placeholder,textarea::placeholder{color:#6b7280;opacity:1}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{padding-top:0;padding-bottom:0}select{background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");background-position:right .5rem center;background-repeat:no-repeat;background-size:1.5em 1.5em;padding-right:2.5rem;-webkit-print-color-adjust:exact;print-color-adjust:exact}[multiple],[size]:where(select:not([size="1"])){background-image:initial;background-position:initial;background-repeat:unset;background-size:initial;padding-right:.75rem;-webkit-print-color-adjust:unset;print-color-adjust:unset}[type=checkbox],[type=radio]{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;-webkit-print-color-adjust:exact;print-color-adjust:exact;display:inline-block;vertical-align:middle;background-origin:border-box;-webkit-user-select:none;-moz-user-select:none;user-select:none;flex-shrink:0;height:1rem;width:1rem;color:#175cd3;background-color:#fff;border-color:#6b7280;border-width:1px;--tw-shadow: 0 0 #0000}[type=checkbox]{border-radius:0}[type=radio]{border-radius:100%}[type=checkbox]:focus,[type=radio]:focus{outline:2px solid transparent;outline-offset:2px;--tw-ring-inset: var(--tw-empty, );--tw-ring-offset-width: 2px;--tw-ring-offset-color: #fff;--tw-ring-color: #175CD3;--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}[type=checkbox]:checked,[type=radio]:checked{border-color:transparent;background-color:currentColor;background-size:100% 100%;background-position:center;background-repeat:no-repeat}[type=checkbox]:checked{background-image:url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e")}@media (forced-colors: active){[type=checkbox]:checked{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}[type=radio]:checked{background-image:url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e")}@media (forced-colors: active){[type=radio]:checked{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}[type=checkbox]:checked:hover,[type=checkbox]:checked:focus,[type=radio]:checked:hover,[type=radio]:checked:focus{border-color:transparent;background-color:currentColor}[type=checkbox]:indeterminate{background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3e%3cpath stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8h8'/%3e%3c/svg%3e");border-color:transparent;background-color:currentColor;background-size:100% 100%;background-position:center;background-repeat:no-repeat}@media (forced-colors: active){[type=checkbox]:indeterminate{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}[type=checkbox]:indeterminate:hover,[type=checkbox]:indeterminate:focus{border-color:transparent;background-color:currentColor}[type=file]{background:unset;border-color:inherit;border-width:0;border-radius:0;padding:0;font-size:unset;line-height:inherit}[type=file]:focus{outline:1px solid ButtonText;outline:1px auto -webkit-focus-ring-color}h1,h2,h3,h4,h5,h6,p,div,li,a,ul,input{font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-weight:400;line-height:1.625}body,html{--tw-text-opacity: 1;color:rgb(17,24,39,var(--tw-text-opacity))}h1,h2,h3,h4,h5,h6,label{font-weight:500;line-height:1.25}h1{font-size:1.875rem;line-height:2.25rem;margin-top:.5rem;margin-bottom:.5rem}h2{font-size:1.5rem;line-height:2rem;margin-top:.5rem;margin-bottom:.5rem}h3{font-size:1.25rem;line-height:1.75rem;margin-top:.25rem;margin-bottom:.25rem}h4{font-size:1.125rem;line-height:1.75rem;margin-top:.25rem;margin-bottom:.25rem}h5{font-size:1rem;line-height:1.5rem;margin-top:.25rem;margin-bottom:.25rem}h6,label{font-size:.875rem;line-height:1.25rem;margin-top:.25rem;margin-bottom:.25rem}p{margin-top:.5rem;margin-bottom:.5rem}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.container{width:100%}@media (min-width: 640px){.container{max-width:640px}}@media (min-width: 768px){.container{max-width:768px}}@media (min-width: 1024px){.container{max-width:1024px}}@media (min-width: 1280px){.container{max-width:1280px}}@media (min-width: 1536px){.container{max-width:1536px}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.visible{visibility:visible}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:sticky}.inset-0{inset:0}.inset-y-0{top:0;bottom:0}.-bottom-8{bottom:-2rem}.bottom-full{bottom:100%}.left-0{left:0}.right-0{right:0}.top-0{top:0}.top-full{top:100%}.isolate{isolation:isolate}.z-10{z-index:10}.z-100{z-index:100}.z-20{z-index:20}.z-50{z-index:50}.col-span-2{grid-column:span 2/span 2}.col-span-3{grid-column:span 3/span 3}.m-auto{margin:auto}.-mx-4{margin-left:-1rem;margin-right:-1rem}.-my-2{margin-top:-.5rem;margin-bottom:-.5rem}.mx-2{margin-left:.5rem;margin-right:.5rem}.mx-auto{margin-left:auto;margin-right:auto}.my-8{margin-top:2rem;margin-bottom:2rem}.my-px{margin-top:1px;margin-bottom:1px}.-mb-px{margin-bottom:-1px}.mb-0{margin-bottom:0}.mb-1{margin-bottom:.25rem}.mb-10{margin-bottom:2.5rem}.mb-2{margin-bottom:.5rem}.mb-4{margin-bottom:1rem}.mb-8{margin-bottom:2rem}.ml-1{margin-left:.25rem}.ml-3{margin-left:.75rem}.ml-auto{margin-left:auto}.mr-1{margin-right:.25rem}.mr-2{margin-right:.5rem}.mr-4{margin-right:1rem}.mt-0{margin-top:0}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-3{margin-top:.75rem}.mt-4{margin-top:1rem}.mt-5{margin-top:1.25rem}.mt-8{margin-top:2rem}.box-border{box-sizing:border-box}.block{display:block}.inline-block{display:inline-block}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.flow-root{display:flow-root}.grid{display:grid}.contents{display:contents}.hidden{display:none}.h-10{height:2.5rem}.h-12{height:3rem}.h-4{height:1rem}.h-5{height:1.25rem}.h-6{height:1.5rem}.h-8{height:2rem}.h-px{height:1px}.max-h-60{max-height:15rem}.max-h-80{max-height:20rem}.min-h-full{min-height:100%}.w-10{width:2.5rem}.w-12{width:3rem}.w-20{width:5rem}.w-4{width:1rem}.w-5{width:1.25rem}.w-6{width:1.5rem}.w-8{width:2rem}.w-96{width:24rem}.w-full{width:100%}.w-max{width:-moz-max-content;width:max-content}.min-w-0{min-width:0px}.min-w-full{min-width:100%}.max-w-lg{max-width:32rem}.max-w-md{max-width:28rem}.max-w-sm{max-width:24rem}.flex-1{flex:1 1 0%}.flex-auto{flex:1 1 auto}.flex-shrink-0{flex-shrink:0}.grow{flex-grow:1}.table-auto{table-layout:auto}.table-fixed{table-layout:fixed}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes spin{to{transform:rotate(360deg)}}.animate-spin{animation:spin 1s linear infinite}.cursor-default{cursor:default}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.resize-none{resize:none}.resize-y{resize:vertical}.resize{resize:both}.grid-flow-col{grid-auto-flow:column}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.grid-cols-subgrid{grid-template-columns:subgrid}.flex-col{flex-direction:column}.place-items-start{place-items:start}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.items-stretch{align-items:stretch}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.gap-4{gap:1rem}.gap-6{gap:1.5rem}.gap-8{gap:2rem}.gap-x-1{-moz-column-gap:.25rem;column-gap:.25rem}.gap-x-3{-moz-column-gap:.75rem;column-gap:.75rem}.gap-x-4{-moz-column-gap:1rem;column-gap:1rem}.gap-y-10{row-gap:2.5rem}.gap-y-4{row-gap:1rem}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * (1 - var(--tw-space-x-reverse)))}.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1rem * var(--tw-space-x-reverse));margin-left:calc(1rem * (1 - var(--tw-space-x-reverse)))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.space-y-3>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.75rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(.75rem * var(--tw-space-y-reverse))}.space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem * var(--tw-space-y-reverse))}.space-y-5>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.25rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.25rem * var(--tw-space-y-reverse))}.divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse: 0;border-top-width:calc(1px * (1 - var(--tw-divide-y-reverse)));border-bottom-width:calc(1px * var(--tw-divide-y-reverse))}.divide-gray-200>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(229,231,235,var(--tw-divide-opacity))}.divide-gray-300>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(209,213,219,var(--tw-divide-opacity))}.self-center{align-self:center}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-ellipsis{text-overflow:ellipsis}.whitespace-normal{white-space:normal}.whitespace-nowrap{white-space:nowrap}.text-pretty{text-wrap:pretty}.break-words{overflow-wrap:break-word}.rounded{border-radius:.25rem}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-md{border-radius:.375rem}.rounded-xl{border-radius:.75rem}.rounded-r-md{border-top-right-radius:.375rem;border-bottom-right-radius:.375rem}.border{border-width:1px}.border-0{border-width:0px}.border-2{border-width:2px}.border-b{border-bottom-width:1px}.border-b-2{border-bottom-width:2px}.border-t{border-top-width:1px}.border-solid{border-style:solid}.border-blue-200{--tw-border-opacity: 1;border-color:rgb(132,202,255,var(--tw-border-opacity))}.border-blue-300{--tw-border-opacity: 1;border-color:rgb(83,177,253,var(--tw-border-opacity))}.border-blue-400{--tw-border-opacity: 1;border-color:rgb(46,144,250,var(--tw-border-opacity))}.border-blue-500{--tw-border-opacity: 1;border-color:rgb(21,112,239,var(--tw-border-opacity))}.border-blue-600{--tw-border-opacity: 1;border-color:rgb(23,92,211,var(--tw-border-opacity))}.border-gray-200{--tw-border-opacity: 1;border-color:rgb(229,231,235,var(--tw-border-opacity))}.border-gray-300{--tw-border-opacity: 1;border-color:rgb(209,213,219,var(--tw-border-opacity))}.border-green-200{--tw-border-opacity: 1;border-color:rgb(187,247,208,var(--tw-border-opacity))}.border-green-300{--tw-border-opacity: 1;border-color:rgb(134,239,172,var(--tw-border-opacity))}.border-green-400{--tw-border-opacity: 1;border-color:rgb(74,222,128,var(--tw-border-opacity))}.border-green-600{--tw-border-opacity: 1;border-color:rgb(22,163,74,var(--tw-border-opacity))}.border-indigo-300{--tw-border-opacity: 1;border-color:rgb(165,180,252,var(--tw-border-opacity))}.border-pink-300{--tw-border-opacity: 1;border-color:rgb(249,168,212,var(--tw-border-opacity))}.border-purple-300{--tw-border-opacity: 1;border-color:rgb(216,180,254,var(--tw-border-opacity))}.border-red-200{--tw-border-opacity: 1;border-color:rgb(254,202,202,var(--tw-border-opacity))}.border-red-300{--tw-border-opacity: 1;border-color:rgb(252,165,165,var(--tw-border-opacity))}.border-red-400{--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity))}.border-red-600{--tw-border-opacity: 1;border-color:rgb(220,38,38,var(--tw-border-opacity))}.border-slate-600{--tw-border-opacity: 1;border-color:rgb(71,85,105,var(--tw-border-opacity))}.border-transparent{border-color:transparent}.border-yellow-200{--tw-border-opacity: 1;border-color:rgb(254,240,138,var(--tw-border-opacity))}.border-yellow-300{--tw-border-opacity: 1;border-color:rgb(253,224,71,var(--tw-border-opacity))}.border-yellow-600{--tw-border-opacity: 1;border-color:rgb(202,138,4,var(--tw-border-opacity))}.bg-\\[\\#FFFAEB\\]{--tw-bg-opacity: 1;background-color:rgb(255,250,235,var(--tw-bg-opacity))}.bg-blue-100{--tw-bg-opacity: 1;background-color:rgb(178,221,255,var(--tw-bg-opacity))}.bg-blue-50{--tw-bg-opacity: 1;background-color:rgb(209,233,255,var(--tw-bg-opacity))}.bg-blue-500{--tw-bg-opacity: 1;background-color:rgb(21,112,239,var(--tw-bg-opacity))}.bg-blue-600{--tw-bg-opacity: 1;background-color:rgb(23,92,211,var(--tw-bg-opacity))}.bg-gray-100{--tw-bg-opacity: 1;background-color:rgb(243,244,246,var(--tw-bg-opacity))}.bg-gray-200{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity))}.bg-gray-50{--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.bg-gray-500{--tw-bg-opacity: 1;background-color:rgb(107,114,128,var(--tw-bg-opacity))}.bg-gray-900{--tw-bg-opacity: 1;background-color:rgb(17,24,39,var(--tw-bg-opacity))}.bg-green-100{--tw-bg-opacity: 1;background-color:rgb(220,252,231,var(--tw-bg-opacity))}.bg-green-50{--tw-bg-opacity: 1;background-color:rgb(240,253,244,var(--tw-bg-opacity))}.bg-indigo-100{--tw-bg-opacity: 1;background-color:rgb(224,231,255,var(--tw-bg-opacity))}.bg-pink-100{--tw-bg-opacity: 1;background-color:rgb(252,231,243,var(--tw-bg-opacity))}.bg-purple-100{--tw-bg-opacity: 1;background-color:rgb(243,232,255,var(--tw-bg-opacity))}.bg-red-100{--tw-bg-opacity: 1;background-color:rgb(254,226,226,var(--tw-bg-opacity))}.bg-red-50{--tw-bg-opacity: 1;background-color:rgb(254,242,242,var(--tw-bg-opacity))}.bg-red-500{--tw-bg-opacity: 1;background-color:rgb(239,68,68,var(--tw-bg-opacity))}.bg-slate-100{--tw-bg-opacity: 1;background-color:rgb(241,245,249,var(--tw-bg-opacity))}.bg-slate-50{--tw-bg-opacity: 1;background-color:rgb(248,250,252,var(--tw-bg-opacity))}.bg-transparent{background-color:transparent}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255,255,255,var(--tw-bg-opacity))}.bg-yellow-100{--tw-bg-opacity: 1;background-color:rgb(254,249,195,var(--tw-bg-opacity))}.bg-yellow-50{--tw-bg-opacity: 1;background-color:rgb(254,252,232,var(--tw-bg-opacity))}.bg-opacity-75{--tw-bg-opacity: .75}.fill-blue-500{fill:#1570ef}.fill-green-500{fill:#22c55e}.p-0{padding:0}.p-2{padding:.5rem}.p-4{padding:1rem}.px-1{padding-left:.25rem;padding-right:.25rem}.px-1\\.5{padding-left:.375rem;padding-right:.375rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-2\\.5{padding-left:.625rem;padding-right:.625rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-3\\.5{padding-left:.875rem;padding-right:.875rem}.px-4{padding-left:1rem;padding-right:1rem}.py-0{padding-top:0;padding-bottom:0}.py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-1\\.5{padding-top:.375rem;padding-bottom:.375rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-2\\.5{padding-top:.625rem;padding-bottom:.625rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-3\\.5{padding-top:.875rem;padding-bottom:.875rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pl-10{padding-left:2.5rem}.pl-3{padding-left:.75rem}.pr-1{padding-right:.25rem}.pr-2{padding-right:.5rem}.pr-3{padding-right:.75rem}.pr-4{padding-right:1rem}.pr-9{padding-right:2.25rem}.pt-4{padding-top:1rem}.text-left{text-align:left}.text-center{text-align:center}.text-end{text-align:end}.align-top{vertical-align:top}.align-middle{vertical-align:middle}.font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.text-base{font-size:1rem;line-height:1.5rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-sm\\/6{font-size:.875rem;line-height:1.5rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-bold{font-weight:700}.font-light{font-weight:300}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.capitalize{text-transform:capitalize}.italic{font-style:italic}.leading-6{line-height:1.5rem}.leading-snug{line-height:1.375}.text-\\[\\#DC6803\\]{--tw-text-opacity: 1;color:rgb(220,104,3,var(--tw-text-opacity))}.text-black{--tw-text-opacity: 1;color:rgb(0,0,0,var(--tw-text-opacity))}.text-blue-500{--tw-text-opacity: 1;color:rgb(21,112,239,var(--tw-text-opacity))}.text-blue-600{--tw-text-opacity: 1;color:rgb(23,92,211,var(--tw-text-opacity))}.text-blue-700{--tw-text-opacity: 1;color:rgb(24,73,169,var(--tw-text-opacity))}.text-blue-800{--tw-text-opacity: 1;color:rgb(25,65,133,var(--tw-text-opacity))}.text-blue-900{--tw-text-opacity: 1;color:rgb(16,42,86,var(--tw-text-opacity))}.text-current{color:currentColor}.text-gray-200{--tw-text-opacity: 1;color:rgb(229,231,235,var(--tw-text-opacity))}.text-gray-400{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.text-gray-50{--tw-text-opacity: 1;color:rgb(249,250,251,var(--tw-text-opacity))}.text-gray-500{--tw-text-opacity: 1;color:rgb(107,114,128,var(--tw-text-opacity))}.text-gray-600{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}.text-gray-700{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.text-gray-900{--tw-text-opacity: 1;color:rgb(17,24,39,var(--tw-text-opacity))}.text-green-500{--tw-text-opacity: 1;color:rgb(34,197,94,var(--tw-text-opacity))}.text-green-600{--tw-text-opacity: 1;color:rgb(22,163,74,var(--tw-text-opacity))}.text-green-700{--tw-text-opacity: 1;color:rgb(21,128,61,var(--tw-text-opacity))}.text-green-800{--tw-text-opacity: 1;color:rgb(22,101,52,var(--tw-text-opacity))}.text-indigo-700{--tw-text-opacity: 1;color:rgb(67,56,202,var(--tw-text-opacity))}.text-pink-700{--tw-text-opacity: 1;color:rgb(190,24,93,var(--tw-text-opacity))}.text-purple-700{--tw-text-opacity: 1;color:rgb(126,34,206,var(--tw-text-opacity))}.text-red-400{--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}.text-red-500{--tw-text-opacity: 1;color:rgb(239,68,68,var(--tw-text-opacity))}.text-red-600{--tw-text-opacity: 1;color:rgb(220,38,38,var(--tw-text-opacity))}.text-red-700{--tw-text-opacity: 1;color:rgb(185,28,28,var(--tw-text-opacity))}.text-red-800{--tw-text-opacity: 1;color:rgb(153,27,27,var(--tw-text-opacity))}.text-slate-500{--tw-text-opacity: 1;color:rgb(100,116,139,var(--tw-text-opacity))}.text-slate-600{--tw-text-opacity: 1;color:rgb(71,85,105,var(--tw-text-opacity))}.text-transparent{color:transparent}.text-white{--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.text-yellow-600{--tw-text-opacity: 1;color:rgb(202,138,4,var(--tw-text-opacity))}.text-yellow-800{--tw-text-opacity: 1;color:rgb(133,77,14,var(--tw-text-opacity))}.underline{text-decoration-line:underline}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-35{opacity:.35}.opacity-50{opacity:.5}.shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.shadow-lg{--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.shadow-sm{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.shadow-xl{--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.ring-1{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.ring-2{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.ring-inset{--tw-ring-inset: inset}.ring-black{--tw-ring-opacity: 1;--tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity))}.ring-blue-300{--tw-ring-opacity: 1;--tw-ring-color: rgb(83 177 253 / var(--tw-ring-opacity))}.ring-blue-600{--tw-ring-opacity: 1;--tw-ring-color: rgb(23 92 211 / var(--tw-ring-opacity))}.ring-gray-200{--tw-ring-opacity: 1;--tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity))}.ring-gray-300{--tw-ring-opacity: 1;--tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity))}.ring-gray-900\\/5{--tw-ring-color: rgb(17 24 39 / .05)}.ring-red-300{--tw-ring-opacity: 1;--tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity))}.ring-red-500{--tw-ring-opacity: 1;--tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity))}.ring-opacity-5{--tw-ring-opacity: .05}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-opacity{transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-100{transition-duration:.1s}.ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.theme-photon,[data-theme=photon]{--twc-primaryText: 210 20% 98%;--twc-primary500: 238.70000000000005 83.5% 66.7%;--twc-primary600: 243.39999999999998 75.4% 58.6%;--twc-secondaryText: 220.89999999999998 39.3% 11%;--twc-secondary50: 225.89999999999998 100% 96.7%;--twc-secondary100: 226.5 100% 93.9%}.theme-weekend,[data-theme=weekend]{--twc-primaryText: 210 20% 98%;--twc-primary500: 198.60000000000002 88.7% 48.4%;--twc-primary600: 200.39999999999998 98% 39.4%;--twc-secondaryText: 220.89999999999998 39.3% 11%;--twc-secondary50: 204 100% 97.1%;--twc-secondary100: 204 93.8% 93.7%}.\\[overflow-wrap\\:anywhere\\]{overflow-wrap:anywhere}@keyframes animateEnter{0%{transform:translate3d(0,-20%,0) scale(.8);opacity:.5}to{transform:translateZ(0) scale(1);opacity:1}}@keyframes animateLeave{0%{transform:translateZ(-1px) scale(1);opacity:1}to{transform:translate3d(0,-20%,-1px) scale(.8);opacity:0}}.animate-enter{animation:animateEnter .2s cubic-bezier(.21,1.02,.73,1) forwards}.animate-leave{animation:animateLeave .2s cubic-bezier(.06,.71,.55,1) forwards}.placeholder\\:text-gray-400::-moz-placeholder{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.placeholder\\:text-gray-400::placeholder{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.placeholder\\:text-red-300::-moz-placeholder{--tw-text-opacity: 1;color:rgb(252,165,165,var(--tw-text-opacity))}.placeholder\\:text-red-300::placeholder{--tw-text-opacity: 1;color:rgb(252,165,165,var(--tw-text-opacity))}.even\\:bg-gray-50:nth-child(2n){--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.hover\\:border-gray-300:hover{--tw-border-opacity: 1;border-color:rgb(209,213,219,var(--tw-border-opacity))}.hover\\:bg-blue-100:hover{--tw-bg-opacity: 1;background-color:rgb(178,221,255,var(--tw-bg-opacity))}.hover\\:bg-blue-50:hover{--tw-bg-opacity: 1;background-color:rgb(209,233,255,var(--tw-bg-opacity))}.hover\\:bg-blue-600:hover{--tw-bg-opacity: 1;background-color:rgb(23,92,211,var(--tw-bg-opacity))}.hover\\:bg-gray-50:hover{--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.hover\\:bg-red-600:hover{--tw-bg-opacity: 1;background-color:rgb(220,38,38,var(--tw-bg-opacity))}.hover\\:text-amber-500:hover{--tw-text-opacity: 1;color:rgb(245,158,11,var(--tw-text-opacity))}.hover\\:text-blue-500:hover{--tw-text-opacity: 1;color:rgb(21,112,239,var(--tw-text-opacity))}.hover\\:text-gray-500:hover{--tw-text-opacity: 1;color:rgb(107,114,128,var(--tw-text-opacity))}.hover\\:text-gray-700:hover{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.hover\\:text-gray-900:hover{--tw-text-opacity: 1;color:rgb(17,24,39,var(--tw-text-opacity))}.hover\\:text-red-500:hover{--tw-text-opacity: 1;color:rgb(239,68,68,var(--tw-text-opacity))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:outline-0:focus{outline-width:0px}.focus\\:ring-1:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.focus\\:ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.focus\\:ring-inset:focus{--tw-ring-inset: inset}.focus\\:ring-blue-300:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(83 177 253 / var(--tw-ring-opacity))}.focus\\:ring-blue-500:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(21 112 239 / var(--tw-ring-opacity))}.focus\\:ring-blue-600:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(23 92 211 / var(--tw-ring-opacity))}.focus\\:ring-gray-300:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity))}.focus\\:ring-red-500:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity))}.focus\\:ring-offset-2:focus{--tw-ring-offset-width: 2px}.focus-visible\\:outline:focus-visible{outline-style:solid}.focus-visible\\:outline-2:focus-visible{outline-width:2px}.focus-visible\\:outline-offset-2:focus-visible{outline-offset:2px}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:opacity-50:disabled{opacity:.5}.disabled\\:hover\\:bg-transparent:hover:disabled{background-color:transparent}.disabled\\:hover\\:text-gray-700:hover:disabled{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.group:hover .group-hover\\:bg-blue-100{--tw-bg-opacity: 1;background-color:rgb(178,221,255,var(--tw-bg-opacity))}.group:hover .group-hover\\:text-blue-600{--tw-text-opacity: 1;color:rgb(23,92,211,var(--tw-text-opacity))}.group:hover .group-hover\\:text-blue-900{--tw-text-opacity: 1;color:rgb(16,42,86,var(--tw-text-opacity))}.group:hover .group-hover\\:opacity-100{opacity:1}@media (min-width: 640px){.sm\\:-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.sm\\:my-8{margin-top:2rem;margin-bottom:2rem}.sm\\:mt-5{margin-top:1.25rem}.sm\\:mt-6{margin-top:1.5rem}.sm\\:block{display:block}.sm\\:grid{display:grid}.sm\\:w-auto{width:auto}.sm\\:max-w-lg{max-width:32rem}.sm\\:max-w-md{max-width:28rem}.sm\\:max-w-sm{max-width:24rem}.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.sm\\:flex-row{flex-direction:row}.sm\\:items-center{align-items:center}.sm\\:gap-2{gap:.5rem}.sm\\:gap-4{gap:1rem}.sm\\:space-x-6>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1.5rem * var(--tw-space-x-reverse));margin-left:calc(1.5rem * (1 - var(--tw-space-x-reverse)))}.sm\\:p-0{padding:0}.sm\\:p-6{padding:1.5rem}.sm\\:px-4{padding-left:1rem;padding-right:1rem}.sm\\:px-6{padding-left:1.5rem;padding-right:1.5rem}.sm\\:py-4{padding-top:1rem;padding-bottom:1rem}.sm\\:pr-6{padding-right:1.5rem}.sm\\:pt-6{padding-top:1.5rem}.sm\\:text-base{font-size:1rem;line-height:1.5rem}.sm\\:text-sm{font-size:.875rem;line-height:1.25rem}.sm\\:leading-6{line-height:1.5rem}}@media (min-width: 768px){.md\\:grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.md\\:flex-row{flex-direction:row}.md\\:items-center{align-items:center}.md\\:gap-1{gap:.25rem}.md\\:space-x-8>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(2rem * var(--tw-space-x-reverse));margin-left:calc(2rem * (1 - var(--tw-space-x-reverse)))}.md\\:text-right{text-align:right}}@media (min-width: 1024px){.lg\\:-mx-8{margin-left:-2rem;margin-right:-2rem}.lg\\:px-8{padding-left:2rem;padding-right:2rem}}@media (prefers-color-scheme: dark){.dark\\:bg-gray-700{--tw-bg-opacity: 1;background-color:rgb(55,65,81,var(--tw-bg-opacity))}.dark\\:text-gray-600{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}}`;
function ki(e) {
  "@babel/helpers - typeof";
  return ki = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ki(e);
}
function Zr(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Lt(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ur(e) {
  Lt(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || ki(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function qK(e, t) {
  Lt(2, arguments);
  var r = ur(e).getTime(), n = Zr(t);
  return new Date(r + n);
}
var BK = {};
function Rs() {
  return BK;
}
function R8(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Yg(e) {
  Lt(1, arguments);
  var t = ur(e);
  return t.setHours(0, 0, 0, 0), t;
}
var HK = 6e4, z8 = 36e5, WK = 1e3;
function QK(e, t) {
  Lt(2, arguments);
  var r = Yg(e), n = Yg(t);
  return r.getTime() === n.getTime();
}
function GK(e) {
  return Lt(1, arguments), e instanceof Date || ki(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function YK(e) {
  if (Lt(1, arguments), !GK(e) && typeof e != "number")
    return !1;
  var t = ur(e);
  return !isNaN(Number(t));
}
function KK(e, t) {
  return Lt(2, arguments), ur(e).getTime() - ur(t).getTime();
}
var Kg = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, ZK = "trunc";
function XK(e) {
  return e ? Kg[e] : Kg[ZK];
}
function JK(e, t, r) {
  Lt(2, arguments);
  var n = KK(e, t) / z8;
  return XK(void 0)(n);
}
function j8(e, t) {
  Lt(2, arguments);
  var r = Zr(t);
  return qK(e, -r);
}
var eZ = 864e5;
function tZ(e) {
  Lt(1, arguments);
  var t = ur(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), i = r - n;
  return Math.floor(i / eZ) + 1;
}
function $s(e) {
  Lt(1, arguments);
  var t = 1, r = ur(e), n = r.getUTCDay(), i = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - i), r.setUTCHours(0, 0, 0, 0), r;
}
function V8(e) {
  Lt(1, arguments);
  var t = ur(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var i = $s(n), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(r, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = $s(a);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function rZ(e) {
  Lt(1, arguments);
  var t = V8(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = $s(r);
  return n;
}
var nZ = 6048e5;
function U8(e) {
  Lt(1, arguments);
  var t = ur(e), r = $s(t).getTime() - rZ(t).getTime();
  return Math.round(r / nZ) + 1;
}
function to(e, t) {
  var r, n, i, a, o, s, l, d;
  Lt(1, arguments);
  var u = Rs(), c = Zr((r = (n = (i = (a = t?.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : u.weekStartsOn) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(c >= 0 && c <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ur(e), f = h.getUTCDay(), p = (f < c ? 7 : 0) + f - c;
  return h.setUTCDate(h.getUTCDate() - p), h.setUTCHours(0, 0, 0, 0), h;
}
function wp(e, t) {
  var r, n, i, a, o, s, l, d;
  Lt(1, arguments);
  var u = ur(e), c = u.getUTCFullYear(), h = Rs(), f = Zr((r = (n = (i = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : h.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = h.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(f >= 1 && f <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(c + 1, 0, f), p.setUTCHours(0, 0, 0, 0);
  var g = to(p, t), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(c, 0, f), v.setUTCHours(0, 0, 0, 0);
  var m = to(v, t);
  return u.getTime() >= g.getTime() ? c + 1 : u.getTime() >= m.getTime() ? c : c - 1;
}
function iZ(e, t) {
  var r, n, i, a, o, s, l, d;
  Lt(1, arguments);
  var u = Rs(), c = Zr((r = (n = (i = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : u.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), h = wp(e, t), f = /* @__PURE__ */ new Date(0);
  f.setUTCFullYear(h, 0, c), f.setUTCHours(0, 0, 0, 0);
  var p = to(f, t);
  return p;
}
var aZ = 6048e5;
function q8(e, t) {
  Lt(1, arguments);
  var r = ur(e), n = to(r, t).getTime() - iZ(r, t).getTime();
  return Math.round(n / aZ) + 1;
}
function wt(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var Ni = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), i = n > 0 ? n : 1 - n;
    return wt(r === "yy" ? i % 100 : i, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : wt(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return wt(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return wt(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return wt(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return wt(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return wt(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, i = t.getUTCMilliseconds(), a = Math.floor(i * Math.pow(10, n - 3));
    return wt(a, r.length);
  }
}, vo = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, oZ = {
  // Era
  G: function(t, r, n) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var i = t.getUTCFullYear(), a = i > 0 ? i : 1 - i;
      return n.ordinalNumber(a, {
        unit: "year"
      });
    }
    return Ni.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, i) {
    var a = wp(t, i), o = a > 0 ? a : 1 - a;
    if (r === "YY") {
      var s = o % 100;
      return wt(s, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : wt(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = V8(t);
    return wt(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return wt(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(i);
      case "QQ":
        return wt(i, 2);
      case "Qo":
        return n.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(i);
      case "qq":
        return wt(i, 2);
      case "qo":
        return n.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var i = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return Ni.M(t, r);
      case "Mo":
        return n.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var i = t.getUTCMonth();
    switch (r) {
      case "L":
        return String(i + 1);
      case "LL":
        return wt(i + 1, 2);
      case "Lo":
        return n.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, i) {
    var a = q8(t, i);
    return r === "wo" ? n.ordinalNumber(a, {
      unit: "week"
    }) : wt(a, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var i = U8(t);
    return r === "Io" ? n.ordinalNumber(i, {
      unit: "week"
    }) : wt(i, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Ni.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var i = tZ(t);
    return r === "Do" ? n.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : wt(i, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var i = t.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return wt(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return wt(o, r.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var i = t.getUTCDay(), a = i === 0 ? 7 : i;
    switch (r) {
      case "i":
        return String(a);
      case "ii":
        return wt(a, r.length);
      case "io":
        return n.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var i = t.getUTCHours(), a = i / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var i = t.getUTCHours(), a;
    switch (i === 12 ? a = vo.noon : i === 0 ? a = vo.midnight : a = i / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var i = t.getUTCHours(), a;
    switch (i >= 17 ? a = vo.evening : i >= 12 ? a = vo.afternoon : i >= 4 ? a = vo.morning : a = vo.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), n.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Ni.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Ni.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var i = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(i, {
      unit: "hour"
    }) : wt(i, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), r === "ko" ? n.ordinalNumber(i, {
      unit: "hour"
    }) : wt(i, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Ni.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Ni.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return Ni.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return Xg(o);
      case "XXXX":
      case "XX":
        return Ea(o);
      case "XXXXX":
      case "XXX":
      default:
        return Ea(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      case "x":
        return Xg(o);
      case "xxxx":
      case "xx":
        return Ea(o);
      case "xxxxx":
      case "xxx":
      default:
        return Ea(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Zg(o, ":");
      case "OOOO":
      default:
        return "GMT" + Ea(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Zg(o, ":");
      case "zzzz":
      default:
        return "GMT" + Ea(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, i) {
    var a = i._originalDate || t, o = Math.floor(a.getTime() / 1e3);
    return wt(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTime();
    return wt(o, r.length);
  }
};
function Zg(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.floor(n / 60), a = n % 60;
  if (a === 0)
    return r + String(i);
  var o = t;
  return r + String(i) + o + wt(a, 2);
}
function Xg(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + wt(Math.abs(e) / 60, 2);
  }
  return Ea(e, t);
}
function Ea(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", i = Math.abs(e), a = wt(Math.floor(i / 60), 2), o = wt(i % 60, 2);
  return n + a + r + o;
}
var Jg = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, B8 = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, sZ = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], i = n[1], a = n[2];
  if (!a)
    return Jg(t, r);
  var o;
  switch (i) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Jg(i, r)).replace("{{time}}", B8(a, r));
}, Lh = {
  p: B8,
  P: sZ
}, lZ = ["D", "DD"], dZ = ["YY", "YYYY"];
function H8(e) {
  return lZ.indexOf(e) !== -1;
}
function W8(e) {
  return dZ.indexOf(e) !== -1;
}
function bc(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var uZ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, cZ = function(t, r, n) {
  var i, a = uZ[t];
  return typeof a == "string" ? i = a : r === 1 ? i = a.one : i = a.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + i : i + " ago" : i;
};
function I1(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var hZ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, fZ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, pZ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, mZ = {
  date: I1({
    formats: hZ,
    defaultWidth: "full"
  }),
  time: I1({
    formats: fZ,
    defaultWidth: "full"
  }),
  dateTime: I1({
    formats: pZ,
    defaultWidth: "full"
  })
}, gZ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, vZ = function(t, r, n, i) {
  return gZ[t];
};
function dl(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", i;
    if (n === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : a;
      i = e.formattingValues[o] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth, l = r != null && r.width ? String(r.width) : e.defaultWidth;
      i = e.values[l] || e.values[s];
    }
    var d = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[d];
  };
}
var yZ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, bZ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, $Z = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, wZ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, xZ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, kZ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, _Z = function(t, r) {
  var n = Number(t), i = n % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, CZ = {
  ordinalNumber: _Z,
  era: dl({
    values: yZ,
    defaultWidth: "wide"
  }),
  quarter: dl({
    values: bZ,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: dl({
    values: $Z,
    defaultWidth: "wide"
  }),
  day: dl({
    values: wZ,
    defaultWidth: "wide"
  }),
  dayPeriod: dl({
    values: xZ,
    defaultWidth: "wide",
    formattingValues: kZ,
    defaultFormattingWidth: "wide"
  })
};
function ul(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    var o = a[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? EZ(s, function(c) {
      return c.test(o);
    }) : SZ(s, function(c) {
      return c.test(o);
    }), d;
    d = e.valueCallback ? e.valueCallback(l) : l, d = r.valueCallback ? r.valueCallback(d) : d;
    var u = t.slice(o.length);
    return {
      value: d,
      rest: u
    };
  };
}
function SZ(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function EZ(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function TZ(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n) return null;
    var i = n[0], a = t.match(e.parsePattern);
    if (!a) return null;
    var o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var s = t.slice(i.length);
    return {
      value: o,
      rest: s
    };
  };
}
var AZ = /^(\d+)(th|st|nd|rd)?/i, OZ = /\d+/i, IZ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, PZ = {
  any: [/^b/i, /^(a|c)/i]
}, DZ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, MZ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, NZ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, LZ = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, FZ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, RZ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, zZ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, jZ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, VZ = {
  ordinalNumber: TZ({
    matchPattern: AZ,
    parsePattern: OZ,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ul({
    matchPatterns: IZ,
    defaultMatchWidth: "wide",
    parsePatterns: PZ,
    defaultParseWidth: "any"
  }),
  quarter: ul({
    matchPatterns: DZ,
    defaultMatchWidth: "wide",
    parsePatterns: MZ,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ul({
    matchPatterns: NZ,
    defaultMatchWidth: "wide",
    parsePatterns: LZ,
    defaultParseWidth: "any"
  }),
  day: ul({
    matchPatterns: FZ,
    defaultMatchWidth: "wide",
    parsePatterns: RZ,
    defaultParseWidth: "any"
  }),
  dayPeriod: ul({
    matchPatterns: zZ,
    defaultMatchWidth: "any",
    parsePatterns: jZ,
    defaultParseWidth: "any"
  })
}, Q8 = {
  code: "en-US",
  formatDistance: cZ,
  formatLong: mZ,
  formatRelative: vZ,
  localize: CZ,
  match: VZ,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, UZ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, qZ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, BZ = /^'([^]*?)'?$/, HZ = /''/g, WZ = /[a-zA-Z]/;
function h0(e, t, r) {
  var n, i, a, o, s, l, d, u, c, h, f, p, g, v;
  Lt(2, arguments);
  var m = String(t), $ = Rs(), w = (n = (i = void 0) !== null && i !== void 0 ? i : $.locale) !== null && n !== void 0 ? n : Q8, k = Zr((a = (o = (s = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && s !== void 0 ? s : $.firstWeekContainsDate) !== null && o !== void 0 ? o : (d = $.locale) === null || d === void 0 || (u = d.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(k >= 1 && k <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var C = Zr((c = (h = (f = (p = void 0) !== null && p !== void 0 ? p : void 0) !== null && f !== void 0 ? f : $.weekStartsOn) !== null && h !== void 0 ? h : (g = $.locale) === null || g === void 0 || (v = g.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && c !== void 0 ? c : 0);
  if (!(C >= 0 && C <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!w.localize)
    throw new RangeError("locale must contain localize property");
  if (!w.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var E = ur(e);
  if (!YK(E))
    throw new RangeError("Invalid time value");
  var N = R8(E), M = j8(E, N), V = {
    firstWeekContainsDate: k,
    weekStartsOn: C,
    locale: w,
    _originalDate: E
  }, q = m.match(qZ).map(function(I) {
    var P = I[0];
    if (P === "p" || P === "P") {
      var z = Lh[P];
      return z(I, w.formatLong);
    }
    return I;
  }).join("").match(UZ).map(function(I) {
    if (I === "''")
      return "'";
    var P = I[0];
    if (P === "'")
      return QZ(I);
    var z = oZ[P];
    if (z)
      return W8(I) && bc(I, t, String(e)), H8(I) && bc(I, t, String(e)), z(M, I, w.localize, V);
    if (P.match(WZ))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + P + "`");
    return I;
  }).join("");
  return q;
}
function QZ(e) {
  var t = e.match(BZ);
  return t ? t[1].replace(HZ, "'") : e;
}
function GZ(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e;
}
function ev(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function YZ(e, t) {
  if (e) {
    if (typeof e == "string") return ev(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ev(e, t) : void 0;
  }
}
function tv(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = YZ(e)) || t) {
      r && (e = r);
      var n = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function(d) {
          throw d;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, o = !0, s = !1;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var d = r.next();
      return o = d.done, d;
    },
    e: function(d) {
      s = !0, a = d;
    },
    f: function() {
      try {
        o || r.return == null || r.return();
      } finally {
        if (s) throw a;
      }
    }
  };
}
function _e(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Fh(e, t) {
  return Fh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Fh(e, t);
}
function dt(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Fh(e, t);
}
function $c(e) {
  return $c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, $c(e);
}
function G8() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (G8 = function() {
    return !!e;
  })();
}
function KZ(e, t) {
  if (t && (ki(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _e(e);
}
function ut(e) {
  var t = G8();
  return function() {
    var r, n = $c(e);
    if (t) {
      var i = $c(this).constructor;
      r = Reflect.construct(n, arguments, i);
    } else r = n.apply(this, arguments);
    return KZ(this, r);
  };
}
function nt(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function ZZ(e, t) {
  if (ki(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ki(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Y8(e) {
  var t = ZZ(e, "string");
  return ki(t) == "symbol" ? t : t + "";
}
function XZ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Y8(n.key), n);
  }
}
function it(e, t, r) {
  return t && XZ(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function be(e, t, r) {
  return (t = Y8(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var JZ = 10, K8 = /* @__PURE__ */ function() {
  function e() {
    nt(this, e), be(this, "priority", void 0), be(this, "subPriority", 0);
  }
  return it(e, [{
    key: "validate",
    value: function(r, n) {
      return !0;
    }
  }]), e;
}(), eX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r(n, i, a, o, s) {
    var l;
    return nt(this, r), l = t.call(this), l.value = n, l.validateValue = i, l.setValue = a, l.priority = o, s && (l.subPriority = s), l;
  }
  return it(r, [{
    key: "validate",
    value: function(i, a) {
      return this.validateValue(i, this.value, a);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return this.setValue(i, a, this.value, o);
    }
  }]), r;
}(K8), tX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", JZ), be(_e(n), "subPriority", -1), n;
  }
  return it(r, [{
    key: "set",
    value: function(i, a) {
      if (a.timestampIsSet)
        return i;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), o.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), o;
    }
  }]), r;
}(K8), mt = /* @__PURE__ */ function() {
  function e() {
    nt(this, e), be(this, "incompatibleTokens", void 0), be(this, "priority", void 0), be(this, "subPriority", void 0);
  }
  return it(e, [{
    key: "run",
    value: function(r, n, i, a) {
      var o = this.parse(r, n, i, a);
      return o ? {
        setter: new eX(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, n, i) {
      return !0;
    }
  }]), e;
}(), rX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 140), be(_e(n), "incompatibleTokens", ["R", "u", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(i, {
            width: "abbreviated"
          }) || o.era(i, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(i, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(i, {
            width: "wide"
          }) || o.era(i, {
            width: "abbreviated"
          }) || o.era(i, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.era = o, i.setUTCFullYear(o, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt), Yt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Bn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Kt(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function zt(e, t) {
  var r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function Hn(e, t) {
  var r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var n = r[1] === "+" ? 1 : -1, i = r[2] ? parseInt(r[2], 10) : 0, a = r[3] ? parseInt(r[3], 10) : 0, o = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (i * z8 + a * HK + o * WK),
    rest: t.slice(r[0].length)
  };
}
function Z8(e) {
  return zt(Yt.anyDigitsSigned, e);
}
function Qt(e, t) {
  switch (e) {
    case 1:
      return zt(Yt.singleDigit, t);
    case 2:
      return zt(Yt.twoDigits, t);
    case 3:
      return zt(Yt.threeDigits, t);
    case 4:
      return zt(Yt.fourDigits, t);
    default:
      return zt(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function wc(e, t) {
  switch (e) {
    case 1:
      return zt(Yt.singleDigitSigned, t);
    case 2:
      return zt(Yt.twoDigitsSigned, t);
    case 3:
      return zt(Yt.threeDigitsSigned, t);
    case 4:
      return zt(Yt.fourDigitsSigned, t);
    default:
      return zt(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function xp(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function X8(e, t) {
  var r = t > 0, n = r ? t : 1 - t, i;
  if (n <= 50)
    i = e || 100;
  else {
    var a = n + 50, o = Math.floor(a / 100) * 100, s = e >= a % 100;
    i = e + o - (s ? 100 : 0);
  }
  return r ? i : 1 - i;
}
function J8(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var nX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 130), be(_e(n), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return {
          year: d,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return Kt(Qt(4, i), s);
        case "yo":
          return Kt(o.ordinalNumber(i, {
            unit: "year"
          }), s);
        default:
          return Kt(Qt(a.length, i), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var l = X8(o.year, s);
        return i.setUTCFullYear(l, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
      }
      var d = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return i.setUTCFullYear(d, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt), iX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 130), be(_e(n), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return {
          year: d,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return Kt(Qt(4, i), s);
        case "Yo":
          return Kt(o.ordinalNumber(i, {
            unit: "year"
          }), s);
        default:
          return Kt(Qt(a.length, i), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      var l = wp(i, s);
      if (o.isTwoDigitYear) {
        var d = X8(o.year, l);
        return i.setUTCFullYear(d, 0, s.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), to(i, s);
      }
      var u = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return i.setUTCFullYear(u, 0, s.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), to(i, s);
    }
  }]), r;
}(mt), aX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 130), be(_e(n), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a) {
      return wc(a === "R" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), $s(s);
    }
  }]), r;
}(mt), oX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 130), be(_e(n), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a) {
      return wc(a === "u" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCFullYear(o, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt), sX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 120), be(_e(n), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "Q":
        case "QQ":
          return Qt(a.length, i);
        case "Qo":
          return o.ordinalNumber(i, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(i, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth((o - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt), lX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 120), be(_e(n), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "q":
        case "qq":
          return Qt(a.length, i);
        case "qo":
          return o.ordinalNumber(i, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(i, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth((o - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt), dX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), be(_e(n), "priority", 110), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d - 1;
      };
      switch (a) {
        case "M":
          return Kt(zt(Yt.month, i), s);
        case "MM":
          return Kt(Qt(2, i), s);
        case "Mo":
          return Kt(o.ordinalNumber(i, {
            unit: "month"
          }), s);
        case "MMM":
          return o.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(i, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(i, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(i, {
            width: "wide",
            context: "formatting"
          }) || o.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(o, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt), uX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 110), be(_e(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d - 1;
      };
      switch (a) {
        case "L":
          return Kt(zt(Yt.month, i), s);
        case "LL":
          return Kt(Qt(2, i), s);
        case "Lo":
          return Kt(o.ordinalNumber(i, {
            unit: "month"
          }), s);
        case "LLL":
          return o.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(i, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(i, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(i, {
            width: "wide",
            context: "standalone"
          }) || o.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(o, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt);
function cX(e, t, r) {
  Lt(2, arguments);
  var n = ur(e), i = Zr(t), a = q8(n, r) - i;
  return n.setUTCDate(n.getUTCDate() - a * 7), n;
}
var hX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 100), be(_e(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "w":
          return zt(Yt.week, i);
        case "wo":
          return o.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return Qt(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return to(cX(i, o, s), s);
    }
  }]), r;
}(mt);
function fX(e, t) {
  Lt(2, arguments);
  var r = ur(e), n = Zr(t), i = U8(r) - n;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
var pX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 100), be(_e(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "I":
          return zt(Yt.week, i);
        case "Io":
          return o.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return Qt(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return $s(fX(i, o));
    }
  }]), r;
}(mt), mX = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], gX = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], vX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 90), be(_e(n), "subPriority", 1), be(_e(n), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "d":
          return zt(Yt.date, i);
        case "do":
          return o.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return Qt(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var o = i.getUTCFullYear(), s = J8(o), l = i.getUTCMonth();
      return s ? a >= 1 && a <= gX[l] : a >= 1 && a <= mX[l];
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCDate(o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt), yX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 90), be(_e(n), "subpriority", 1), be(_e(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "D":
        case "DD":
          return zt(Yt.dayOfYear, i);
        case "Do":
          return o.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return Qt(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var o = i.getUTCFullYear(), s = J8(o);
      return s ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(0, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt);
function kp(e, t, r) {
  var n, i, a, o, s, l, d, u;
  Lt(2, arguments);
  var c = Rs(), h = Zr((n = (i = (a = (o = r?.weekStartsOn) !== null && o !== void 0 ? o : r == null || (s = r.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && a !== void 0 ? a : c.weekStartsOn) !== null && i !== void 0 ? i : (d = c.locale) === null || d === void 0 || (u = d.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ur(e), p = Zr(t), g = f.getUTCDay(), v = p % 7, m = (v + 7) % 7, $ = (m < h ? 7 : 0) + p - g;
  return f.setUTCDate(f.getUTCDate() + $), f;
}
var bX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 90), be(_e(n), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = kp(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt), $X = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 90), be(_e(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o, s) {
      var l = function(u) {
        var c = Math.floor((u - 1) / 7) * 7;
        return (u + s.weekStartsOn + 6) % 7 + c;
      };
      switch (a) {
        case "e":
        case "ee":
          return Kt(Qt(a.length, i), l);
        case "eo":
          return Kt(o.ordinalNumber(i, {
            unit: "day"
          }), l);
        case "eee":
          return o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = kp(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt), wX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 90), be(_e(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o, s) {
      var l = function(u) {
        var c = Math.floor((u - 1) / 7) * 7;
        return (u + s.weekStartsOn + 6) % 7 + c;
      };
      switch (a) {
        case "c":
        case "cc":
          return Kt(Qt(a.length, i), l);
        case "co":
          return Kt(o.ordinalNumber(i, {
            unit: "day"
          }), l);
        case "ccc":
          return o.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(i, {
            width: "wide",
            context: "standalone"
          }) || o.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = kp(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt);
function xX(e, t) {
  Lt(2, arguments);
  var r = Zr(t);
  r % 7 === 0 && (r = r - 7);
  var n = 1, i = ur(e), a = i.getUTCDay(), o = r % 7, s = (o + 7) % 7, l = (s < n ? 7 : 0) + r - a;
  return i.setUTCDate(i.getUTCDate() + l), i;
}
var kX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 90), be(_e(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d === 0 ? 7 : d;
      };
      switch (a) {
        case "i":
        case "ii":
          return Qt(a.length, i);
        case "io":
          return o.ordinalNumber(i, {
            unit: "day"
          });
        case "iii":
          return Kt(o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return Kt(o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return Kt(o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return Kt(o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i = xX(i, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
}(mt), _X = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 80), be(_e(n), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(xp(o), 0, 0, 0), i;
    }
  }]), r;
}(mt), CX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 80), be(_e(n), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(xp(o), 0, 0, 0), i;
    }
  }]), r;
}(mt), SX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 80), be(_e(n), "incompatibleTokens", ["a", "b", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(xp(o), 0, 0, 0), i;
    }
  }]), r;
}(mt), EX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 70), be(_e(n), "incompatibleTokens", ["H", "K", "k", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "h":
          return zt(Yt.hour12h, i);
        case "ho":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return Qt(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCHours() >= 12;
      return s && o < 12 ? i.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? i.setUTCHours(0, 0, 0, 0) : i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), r;
}(mt), TX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 70), be(_e(n), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "H":
          return zt(Yt.hour23h, i);
        case "Ho":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return Qt(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), r;
}(mt), AX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 70), be(_e(n), "incompatibleTokens", ["h", "H", "k", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "K":
          return zt(Yt.hour11h, i);
        case "Ko":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return Qt(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCHours() >= 12;
      return s && o < 12 ? i.setUTCHours(o + 12, 0, 0, 0) : i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), r;
}(mt), OX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 70), be(_e(n), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "k":
          return zt(Yt.hour24h, i);
        case "ko":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return Qt(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = o <= 24 ? o % 24 : o;
      return i.setUTCHours(s, 0, 0, 0), i;
    }
  }]), r;
}(mt), IX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 60), be(_e(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "m":
          return zt(Yt.minute, i);
        case "mo":
          return o.ordinalNumber(i, {
            unit: "minute"
          });
        default:
          return Qt(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMinutes(o, 0, 0), i;
    }
  }]), r;
}(mt), PX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 50), be(_e(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "s":
          return zt(Yt.second, i);
        case "so":
          return o.ordinalNumber(i, {
            unit: "second"
          });
        default:
          return Qt(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCSeconds(o, 0), i;
    }
  }]), r;
}(mt), DX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 30), be(_e(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a) {
      var o = function(l) {
        return Math.floor(l * Math.pow(10, -a.length + 3));
      };
      return Kt(Qt(a.length, i), o);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMilliseconds(o), i;
    }
  }]), r;
}(mt), MX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 10), be(_e(n), "incompatibleTokens", ["t", "T", "x"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "X":
          return Hn(Bn.basicOptionalMinutes, i);
        case "XX":
          return Hn(Bn.basic, i);
        case "XXXX":
          return Hn(Bn.basicOptionalSeconds, i);
        case "XXXXX":
          return Hn(Bn.extendedOptionalSeconds, i);
        case "XXX":
        default:
          return Hn(Bn.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.timestampIsSet ? i : new Date(i.getTime() - o);
    }
  }]), r;
}(mt), NX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 10), be(_e(n), "incompatibleTokens", ["t", "T", "X"]), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "x":
          return Hn(Bn.basicOptionalMinutes, i);
        case "xx":
          return Hn(Bn.basic, i);
        case "xxxx":
          return Hn(Bn.basicOptionalSeconds, i);
        case "xxxxx":
          return Hn(Bn.extendedOptionalSeconds, i);
        case "xxx":
        default:
          return Hn(Bn.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.timestampIsSet ? i : new Date(i.getTime() - o);
    }
  }]), r;
}(mt), LX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 40), be(_e(n), "incompatibleTokens", "*"), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i) {
      return Z8(i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(mt), FX = /* @__PURE__ */ function(e) {
  dt(r, e);
  var t = ut(r);
  function r() {
    var n;
    nt(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), be(_e(n), "priority", 20), be(_e(n), "incompatibleTokens", "*"), n;
  }
  return it(r, [{
    key: "parse",
    value: function(i) {
      return Z8(i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(mt), RX = {
  G: new rX(),
  y: new nX(),
  Y: new iX(),
  R: new aX(),
  u: new oX(),
  Q: new sX(),
  q: new lX(),
  M: new dX(),
  L: new uX(),
  w: new hX(),
  I: new pX(),
  d: new vX(),
  D: new yX(),
  E: new bX(),
  e: new $X(),
  c: new wX(),
  i: new kX(),
  a: new _X(),
  b: new CX(),
  B: new SX(),
  h: new EX(),
  H: new TX(),
  K: new AX(),
  k: new OX(),
  m: new IX(),
  s: new PX(),
  S: new DX(),
  X: new MX(),
  x: new NX(),
  t: new LX(),
  T: new FX()
}, zX = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, jX = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, VX = /^'([^]*?)'?$/, UX = /''/g, qX = /\S/, BX = /[a-zA-Z]/;
function HX(e, t, r, n) {
  var i, a, o, s, l, d, u, c, h, f, p, g, v, m;
  Lt(3, arguments);
  var $ = String(e), w = String(t), k = Rs(), C = (i = (a = void 0) !== null && a !== void 0 ? a : k.locale) !== null && i !== void 0 ? i : Q8;
  if (!C.match)
    throw new RangeError("locale must contain match property");
  var E = Zr((o = (s = (l = (d = void 0) !== null && d !== void 0 ? d : void 0) !== null && l !== void 0 ? l : k.firstWeekContainsDate) !== null && s !== void 0 ? s : (u = k.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(E >= 1 && E <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var N = Zr((h = (f = (p = (g = void 0) !== null && g !== void 0 ? g : void 0) !== null && p !== void 0 ? p : k.weekStartsOn) !== null && f !== void 0 ? f : (v = k.locale) === null || v === void 0 || (m = v.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(N >= 0 && N <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (w === "")
    return $ === "" ? ur(r) : /* @__PURE__ */ new Date(NaN);
  var M = {
    firstWeekContainsDate: E,
    weekStartsOn: N,
    locale: C
  }, V = [new tX()], q = w.match(jX).map(function(pe) {
    var ee = pe[0];
    if (ee in Lh) {
      var re = Lh[ee];
      return re(pe, C.formatLong);
    }
    return pe;
  }).join("").match(zX), I = [], P = tv(q), z;
  try {
    var G = function() {
      var ee = z.value;
      !(n != null && n.useAdditionalWeekYearTokens) && W8(ee) && bc(ee, w, e), !(n != null && n.useAdditionalDayOfYearTokens) && H8(ee) && bc(ee, w, e);
      var re = ee[0], Ie = RX[re];
      if (Ie) {
        var Pe = Ie.incompatibleTokens;
        if (Array.isArray(Pe)) {
          var at = I.find(function(ft) {
            return Pe.includes(ft.token) || ft.token === re;
          });
          if (at)
            throw new RangeError("The format string mustn't contain `".concat(at.fullToken, "` and `").concat(ee, "` at the same time"));
        } else if (Ie.incompatibleTokens === "*" && I.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(ee, "` and any other token at the same time"));
        I.push({
          token: re,
          fullToken: ee
        });
        var Xe = Ie.run($, ee, C.match, M);
        if (!Xe)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        V.push(Xe.setter), $ = Xe.rest;
      } else {
        if (re.match(BX))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + re + "`");
        if (ee === "''" ? ee = "'" : re === "'" && (ee = WX(ee)), $.indexOf(ee) === 0)
          $ = $.slice(ee.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (P.s(); !(z = P.n()).done; ) {
      var se = G();
      if (ki(se) === "object") return se.v;
    }
  } catch (pe) {
    P.e(pe);
  } finally {
    P.f();
  }
  if ($.length > 0 && qX.test($))
    return /* @__PURE__ */ new Date(NaN);
  var ue = V.map(function(pe) {
    return pe.priority;
  }).sort(function(pe, ee) {
    return ee - pe;
  }).filter(function(pe, ee, re) {
    return re.indexOf(pe) === ee;
  }).map(function(pe) {
    return V.filter(function(ee) {
      return ee.priority === pe;
    }).sort(function(ee, re) {
      return re.subPriority - ee.subPriority;
    });
  }).map(function(pe) {
    return pe[0];
  }), de = ur(r);
  if (isNaN(de.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var D = j8(de, R8(de)), R = {}, Q = tv(ue), Z;
  try {
    for (Q.s(); !(Z = Q.n()).done; ) {
      var F = Z.value;
      if (!F.validate(D, M))
        return /* @__PURE__ */ new Date(NaN);
      var oe = F.set(D, R, M);
      Array.isArray(oe) ? (D = oe[0], GZ(R, oe[1])) : D = oe;
    }
  } catch (pe) {
    Q.e(pe);
  } finally {
    Q.f();
  }
  return D;
}
function WX(e) {
  return e.match(VX)[1].replace(UX, "'");
}
function QX(e) {
  return Lt(1, arguments), QK(e, Date.now());
}
const sr = (e, t) => uo("message", (r) => D8(r, e) ? !0 : t), GX = (e, t, r = !0) => uo("between", function(i) {
  return typeof i == "number" && (r ? i >= e && i <= t : i > e && i < t);
}), YX = uo("NotFutureDate", (e) => {
  const t = new Date(e);
  return t instanceof Date ? t <= /* @__PURE__ */ new Date() : !1;
}), KX = (e, t = (r) => HX(r, "yyyy-MM-dd", /* @__PURE__ */ new Date())) => uo("between", function(n) {
  return JK(t(n), e) >= 0 || QX(t(n));
}), ZX = () => Fs(sn(), "zipString", (e) => /^\d{5}(-\d{4})?$/.test(e)), XX = () => Fs(sn(), "email", (e) => e.length === 0 ? !0 : /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(e)), rv = () => Fs(c0(), "empty", (e) => e === null || e == null);
var JX = gr`
  :host {
    display: inline-block;
    position: relative;
    width: auto;
    cursor: pointer;
  }

  .button {
    display: inline-flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    border-style: solid;
    border-width: var(--sl-input-border-width);
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-font-weight-semibold);
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    vertical-align: middle;
    padding: 0;
    transition:
      var(--sl-transition-x-fast) background-color,
      var(--sl-transition-x-fast) color,
      var(--sl-transition-x-fast) border,
      var(--sl-transition-x-fast) box-shadow;
    cursor: inherit;
  }

  .button::-moz-focus-inner {
    border: 0;
  }

  .button:focus {
    outline: none;
  }

  .button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When disabled, prevent mouse events from bubbling up from children */
  .button--disabled * {
    pointer-events: none;
  }

  .button__prefix,
  .button__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .button__label {
    display: inline-block;
  }

  .button__label::slotted(sl-icon) {
    vertical-align: -2px;
  }

  /*
   * Standard buttons
   */

  /* Default */
  .button--standard.button--default {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--standard.button--default:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-300);
    color: var(--sl-color-primary-700);
  }

  .button--standard.button--default:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-100);
    border-color: var(--sl-color-primary-400);
    color: var(--sl-color-primary-700);
  }

  /* Primary */
  .button--standard.button--primary {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--standard.button--success {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:hover:not(.button--disabled) {
    background-color: var(--sl-color-success-500);
    border-color: var(--sl-color-success-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:active:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--standard.button--neutral {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:hover:not(.button--disabled) {
    background-color: var(--sl-color-neutral-500);
    border-color: var(--sl-color-neutral-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:active:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--standard.button--warning {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }
  .button--standard.button--warning:hover:not(.button--disabled) {
    background-color: var(--sl-color-warning-500);
    border-color: var(--sl-color-warning-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--warning:active:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--standard.button--danger {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:hover:not(.button--disabled) {
    background-color: var(--sl-color-danger-500);
    border-color: var(--sl-color-danger-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:active:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  /*
   * Outline buttons
   */

  .button--outline {
    background: none;
    border: solid 1px;
  }

  /* Default */
  .button--outline.button--default {
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--outline.button--default:hover:not(.button--disabled),
  .button--outline.button--default.button--checked:not(.button--disabled) {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--default:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Primary */
  .button--outline.button--primary {
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-primary-600);
  }

  .button--outline.button--primary:hover:not(.button--disabled),
  .button--outline.button--primary.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--primary:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--outline.button--success {
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-success-600);
  }

  .button--outline.button--success:hover:not(.button--disabled),
  .button--outline.button--success.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--success:active:not(.button--disabled) {
    border-color: var(--sl-color-success-700);
    background-color: var(--sl-color-success-700);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--outline.button--neutral {
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-600);
  }

  .button--outline.button--neutral:hover:not(.button--disabled),
  .button--outline.button--neutral.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--neutral:active:not(.button--disabled) {
    border-color: var(--sl-color-neutral-700);
    background-color: var(--sl-color-neutral-700);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--outline.button--warning {
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-warning-600);
  }

  .button--outline.button--warning:hover:not(.button--disabled),
  .button--outline.button--warning.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--warning:active:not(.button--disabled) {
    border-color: var(--sl-color-warning-700);
    background-color: var(--sl-color-warning-700);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--outline.button--danger {
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-danger-600);
  }

  .button--outline.button--danger:hover:not(.button--disabled),
  .button--outline.button--danger.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--danger:active:not(.button--disabled) {
    border-color: var(--sl-color-danger-700);
    background-color: var(--sl-color-danger-700);
    color: var(--sl-color-neutral-0);
  }

  @media (forced-colors: active) {
    .button.button--outline.button--checked:not(.button--disabled) {
      outline: solid 2px transparent;
    }
  }

  /*
   * Text buttons
   */

  .button--text {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-600);
  }

  .button--text:hover:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:focus-visible:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:active:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-700);
  }

  /*
   * Size modifiers
   */

  .button--small {
    height: auto;
    min-height: var(--sl-input-height-small);
    font-size: var(--sl-button-font-size-small);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
  }

  .button--medium {
    height: auto;
    min-height: var(--sl-input-height-medium);
    font-size: var(--sl-button-font-size-medium);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
  }

  .button--large {
    height: auto;
    min-height: var(--sl-input-height-large);
    font-size: var(--sl-button-font-size-large);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
  }

  /*
   * Pill modifier
   */

  .button--pill.button--small {
    border-radius: var(--sl-input-height-small);
  }

  .button--pill.button--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .button--pill.button--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Circle modifier
   */

  .button--circle {
    padding-left: 0;
    padding-right: 0;
  }

  .button--circle.button--small {
    width: var(--sl-input-height-small);
    border-radius: 50%;
  }

  .button--circle.button--medium {
    width: var(--sl-input-height-medium);
    border-radius: 50%;
  }

  .button--circle.button--large {
    width: var(--sl-input-height-large);
    border-radius: 50%;
  }

  .button--circle .button__prefix,
  .button--circle .button__suffix,
  .button--circle .button__caret {
    display: none;
  }

  /*
   * Caret modifier
   */

  .button--caret .button__suffix {
    display: none;
  }

  .button--caret .button__caret {
    height: auto;
  }

  /*
   * Loading modifier
   */

  .button--loading {
    position: relative;
    cursor: wait;
  }

  .button--loading .button__prefix,
  .button--loading .button__label,
  .button--loading .button__suffix,
  .button--loading .button__caret {
    visibility: hidden;
  }

  .button--loading sl-spinner {
    --indicator-color: currentColor;
    position: absolute;
    font-size: 1em;
    height: 1em;
    width: 1em;
    top: calc(50% - 0.5em);
    left: calc(50% - 0.5em);
  }

  /*
   * Badges
   */

  .button ::slotted(sl-badge) {
    position: absolute;
    top: 0;
    right: 0;
    translate: 50% -50%;
    pointer-events: none;
  }

  .button--rtl ::slotted(sl-badge) {
    right: auto;
    left: 0;
    translate: -50% -50%;
  }

  /*
   * Button spacing
   */

  .button--has-label.button--small .button__label {
    padding: 0 var(--sl-spacing-small);
  }

  .button--has-label.button--medium .button__label {
    padding: 0 var(--sl-spacing-medium);
  }

  .button--has-label.button--large .button__label {
    padding: 0 var(--sl-spacing-large);
  }

  .button--has-prefix.button--small {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--small .button__label {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--medium {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--medium .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-suffix.button--small,
  .button--caret.button--small {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--small .button__label,
  .button--caret.button--small .button__label {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--medium,
  .button--caret.button--medium {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--medium .button__label,
  .button--caret.button--medium .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large,
  .button--caret.button--large {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large .button__label,
  .button--caret.button--large .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  /*
   * Button groups support a variety of button types (e.g. buttons with tooltips, buttons as dropdown triggers, etc.).
   * This means buttons aren't always direct descendants of the button group, thus we can't target them with the
   * ::slotted selector. To work around this, the button group component does some magic to add these special classes to
   * buttons and we style them here instead.
   */

  :host([data-sl-button-group__button--first]:not([data-sl-button-group__button--last])) .button {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }

  :host([data-sl-button-group__button--inner]) .button {
    border-radius: 0;
  }

  :host([data-sl-button-group__button--last]:not([data-sl-button-group__button--first])) .button {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }

  /* All except the first */
  :host([data-sl-button-group__button]:not([data-sl-button-group__button--first])) {
    margin-inline-start: calc(-1 * var(--sl-input-border-width));
  }

  /* Add a visual separator between solid buttons */
  :host(
      [data-sl-button-group__button]:not(
          [data-sl-button-group__button--first],
          [data-sl-button-group__button--radio],
          [variant='default']
        ):not(:hover)
    )
    .button:after {
    content: '';
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    bottom: 0;
    border-left: solid 1px rgb(128 128 128 / 33%);
    mix-blend-mode: multiply;
  }

  /* Bump hovered, focused, and checked buttons up so their focus ring isn't clipped */
  :host([data-sl-button-group__button--hover]) {
    z-index: 1;
  }

  /* Focus and checked are always on top */
  :host([data-sl-button-group__button--focus]),
  :host([data-sl-button-group__button][checked]) {
    z-index: 2;
  }
`, _t = class extends ar {
  constructor() {
    super(...arguments), this.formControlController = new kd(this, {
      assumeInteractionOn: ["click"]
    }), this.hasSlotController = new ha(this, "[default]", "prefix", "suffix"), this.localize = new Ei(this), this.hasFocus = !1, this.invalid = !1, this.title = "", this.variant = "default", this.size = "medium", this.caret = !1, this.disabled = !1, this.loading = !1, this.outline = !1, this.pill = !1, this.circle = !1, this.type = "button", this.name = "", this.value = "", this.href = "", this.rel = "noreferrer noopener";
  }
  /** Gets the validity state object */
  get validity() {
    return this.isButton() ? this.button.validity : gp;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.isButton() ? this.button.validationMessage : "";
  }
  firstUpdated() {
    this.isButton() && this.formControlController.updateValidity();
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleClick() {
    this.type === "submit" && this.formControlController.submit(this), this.type === "reset" && this.formControlController.reset(this);
  }
  handleInvalid(e) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(e);
  }
  isButton() {
    return !this.href;
  }
  isLink() {
    return !!this.href;
  }
  handleDisabledChange() {
    this.isButton() && this.formControlController.setValidity(this.disabled);
  }
  /** Simulates a click on the button. */
  click() {
    this.button.click();
  }
  /** Sets focus on the button. */
  focus(e) {
    this.button.focus(e);
  }
  /** Removes focus from the button. */
  blur() {
    this.button.blur();
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.isButton() ? this.button.checkValidity() : !0;
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return this.isButton() ? this.button.reportValidity() : !0;
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(e) {
    this.isButton() && (this.button.setCustomValidity(e), this.formControlController.updateValidity());
  }
  render() {
    const e = this.isLink(), t = e ? yc`a` : yc`button`;
    return Tu`
      <${t}
        part="base"
        class=${dr({
      button: !0,
      "button--default": this.variant === "default",
      "button--primary": this.variant === "primary",
      "button--success": this.variant === "success",
      "button--neutral": this.variant === "neutral",
      "button--warning": this.variant === "warning",
      "button--danger": this.variant === "danger",
      "button--text": this.variant === "text",
      "button--small": this.size === "small",
      "button--medium": this.size === "medium",
      "button--large": this.size === "large",
      "button--caret": this.caret,
      "button--circle": this.circle,
      "button--disabled": this.disabled,
      "button--focused": this.hasFocus,
      "button--loading": this.loading,
      "button--standard": !this.outline,
      "button--outline": this.outline,
      "button--pill": this.pill,
      "button--rtl": this.localize.dir() === "rtl",
      "button--has-label": this.hasSlotController.test("[default]"),
      "button--has-prefix": this.hasSlotController.test("prefix"),
      "button--has-suffix": this.hasSlotController.test("suffix")
    })}
        ?disabled=${Me(e ? void 0 : this.disabled)}
        type=${Me(e ? void 0 : this.type)}
        title=${this.title}
        name=${Me(e ? void 0 : this.name)}
        value=${Me(e ? void 0 : this.value)}
        href=${Me(e && !this.disabled ? this.href : void 0)}
        target=${Me(e ? this.target : void 0)}
        download=${Me(e ? this.download : void 0)}
        rel=${Me(e ? this.rel : void 0)}
        role=${Me(e ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @invalid=${this.isButton() ? this.handleInvalid : null}
        @click=${this.handleClick}
      >
        <slot name="prefix" part="prefix" class="button__prefix"></slot>
        <slot part="label" class="button__label"></slot>
        <slot name="suffix" part="suffix" class="button__suffix"></slot>
        ${this.caret ? Tu` <sl-icon part="caret" class="button__caret" library="system" name="caret"></sl-icon> ` : ""}
        ${this.loading ? Tu`<sl-spinner part="spinner"></sl-spinner>` : ""}
      </${t}>
    `;
  }
};
_t.styles = [Ar, JX];
_t.dependencies = {
  "sl-icon": Vr,
  "sl-spinner": u0
};
O([
  jt(".button")
], _t.prototype, "button", 2);
O([
  Fn()
], _t.prototype, "hasFocus", 2);
O([
  Fn()
], _t.prototype, "invalid", 2);
O([
  U()
], _t.prototype, "title", 2);
O([
  U({ reflect: !0 })
], _t.prototype, "variant", 2);
O([
  U({ reflect: !0 })
], _t.prototype, "size", 2);
O([
  U({ type: Boolean, reflect: !0 })
], _t.prototype, "caret", 2);
O([
  U({ type: Boolean, reflect: !0 })
], _t.prototype, "disabled", 2);
O([
  U({ type: Boolean, reflect: !0 })
], _t.prototype, "loading", 2);
O([
  U({ type: Boolean, reflect: !0 })
], _t.prototype, "outline", 2);
O([
  U({ type: Boolean, reflect: !0 })
], _t.prototype, "pill", 2);
O([
  U({ type: Boolean, reflect: !0 })
], _t.prototype, "circle", 2);
O([
  U()
], _t.prototype, "type", 2);
O([
  U()
], _t.prototype, "name", 2);
O([
  U()
], _t.prototype, "value", 2);
O([
  U()
], _t.prototype, "href", 2);
O([
  U()
], _t.prototype, "target", 2);
O([
  U()
], _t.prototype, "rel", 2);
O([
  U()
], _t.prototype, "download", 2);
O([
  U()
], _t.prototype, "form", 2);
O([
  U({ attribute: "formaction" })
], _t.prototype, "formAction", 2);
O([
  U({ attribute: "formenctype" })
], _t.prototype, "formEnctype", 2);
O([
  U({ attribute: "formmethod" })
], _t.prototype, "formMethod", 2);
O([
  U({ attribute: "formnovalidate", type: Boolean })
], _t.prototype, "formNoValidate", 2);
O([
  U({ attribute: "formtarget" })
], _t.prototype, "formTarget", 2);
O([
  Nt("disabled", { waitUntilFirstUpdate: !0 })
], _t.prototype, "handleDisabledChange", 1);
_t.define("sl-button");
const Au = (e, t) => {
  e.updateFormValue({
    key: "treatment",
    value: void 0
  }), e.updateFormValue({
    key: "dispenseAsWritten",
    value: !1
  }), e.updateFormValue({
    key: "dispenseQuantity",
    value: void 0
  }), e.updateFormValue({
    key: "dispenseUnit",
    value: void 0
  }), e.updateFormValue({
    key: "daysSupply",
    value: void 0
  }), e.updateFormValue({
    key: "refillsInput",
    value: void 0
  }), e.updateFormValue({
    key: "instructions",
    value: ""
  }), e.updateFormValue({
    key: "notes",
    value: t?.notes ?? ""
  }), e.updateFormValue({
    key: "addToTemplates",
    value: !1
  });
}, ey = (e, t) => {
  if (e.updateFormValue({
    key: "treatment",
    value: t.treatment
  }), t.dispenseAsWritten && e.updateFormValue({
    key: "dispenseAsWritten",
    value: t.dispenseAsWritten
  }), t.dispenseQuantity && e.updateFormValue({
    key: "dispenseQuantity",
    value: Number(t.dispenseQuantity)
  }), t.dispenseUnit && e.updateFormValue({
    key: "dispenseUnit",
    value: t.dispenseUnit
  }), t.daysSupply && e.updateFormValue({
    key: "daysSupply",
    value: Number(t.daysSupply)
  }), t.fillsAllowed !== void 0 && t.fillsAllowed !== null) {
    const r = Number(t.fillsAllowed);
    e.updateFormValue({
      key: "refillsInput",
      value: r > 0 ? r - 1 : 0
    });
  }
  t.instructions && e.updateFormValue({
    key: "instructions",
    value: t.instructions
  }), t.notes && e.updateFormValue({
    key: "notes",
    value: t.notes
  });
};
var eJ = /* @__PURE__ */ K('<div class="flex items-center justify-between">'), tJ = /* @__PURE__ */ K('<photon-checkbox label="Add To Personal Templates"form-name=addToTemplates>', !0, !1, !1), rJ = /* @__PURE__ */ K('<photon-text-input class="flex-grow flex-shrink flex-1"label="Template Name"optional=true>', !0, !1, !1), nJ = /* @__PURE__ */ K('<div class="flex flex-col sm:gap-3"><photon-medication-search label="Search for Treatment"></photon-medication-search><div class="flex flex-col sm:flex-none sm:grid sm:grid-cols-2 sm:gap-4"><div class="order-last sm:order-first"><photon-checkbox label="Dispense as written"tip="This prescription will be filled generically unless this box is checked"form-name=daw class=flex-grow></photon-checkbox></div></div><div class="mt-2 sm:mt-0 w-full md:pr-2"><photon-datepicker label="Do Not Fill Before"required=true></photon-datepicker></div><div class="mt-2 sm:mt-0 sm:grid sm:grid-cols-2 sm:gap-4"><div class="flex items-end gap-1 items-stretch"><photon-number-input class="flex-grow flex-1 w-2/5 sm:w-auto"label=Quantity required=true min=0></photon-number-input><div><div class=pt-1></div></div></div><photon-dispense-units label="Dispense Unit"required=true force-label-size=true></photon-dispense-units></div><div class="sm:grid sm:grid-cols-2 sm:gap-4"><photon-number-input class="flex-grow flex-shrink flex-1"label="Days Supply"required=true min=0></photon-number-input><photon-number-input class="flex-grow flex-shrink flex-1"label=Refills required=true min=0 max=11></photon-number-input></div><photon-textarea label="Patient Instructions (SIG)"form-name=patient_instructions required=true placeholder="Enter patient instructions"></photon-textarea><photon-textarea label="Pharmacy Note"placeholder="Enter pharmacy note"></photon-textarea><div class="flex flex-col xs:flex-row gap-2"><div class="flex flex-grow justify-end">', !0, !1, !1), iJ = /* @__PURE__ */ K("<div><style>");
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const nv = {
  treatment: sr($p(sn(), c0()), "Please select a treatment..."),
  dispenseQuantity: sr(Qg(Hg(), 0, {
    exclusive: !0
  }), "Quantity must be positive"),
  dispenseUnit: sr(Fs(sn(), "nonEmptyString", (e) => e.trim().length > 0), "Please select a dispensing unit..."),
  daysSupply: sr(Qg(Hg(), 0), "Days Supply must be at least 0"),
  refillsInput: sr(GX(0, 11), "Refills must be 0 to 11"),
  instructions: sr(Ca(sn(), 1, 1 / 0), "Please enter instructions for the patient..."),
  effectiveDate: sr(KX(/* @__PURE__ */ new Date()), "Please choose a date that isn't in the past")
}, aJ = (e) => {
  const t = oo();
  if (!t)
    throw new Error("PrescribeWorkflow must be wrapped with PrescribeProvider");
  const {
    tryCreatePrescription: r
  } = t, [n, i] = H(void 0), [a] = H(void 0), [o, s] = H(!1), [l, d] = H(""), [u, c] = H(!1);
  let h;
  Et(() => {
    for (const [g, v] of Object.entries(nv))
      e.actions.registerValidator({
        key: g,
        validator: v
      });
    Au(e.actions, e?.prefillNotes ? {
      notes: e.prefillNotes
    } : void 0);
  });
  const f = (g) => {
    const v = new CustomEvent("photon-order-error", {
      composed: !0,
      bubbles: !0,
      detail: {
        errors: g
      }
    });
    h?.dispatchEvent(v);
  }, p = async () => {
    c(!0);
    const g = Object.keys(nv);
    if (e.actions.validate(g), e.actions.hasErrors(g)) {
      c(!1), ir({
        status: "error",
        body: "Some items in the form are incomplete, please check for errors"
      });
      return;
    }
    const m = {
      effectiveDate: e.store.effectiveDate.value,
      treatment: {
        id: e.store.treatment.value.id,
        name: e.store.treatment.value.name
      },
      dispenseAsWritten: e.store.dispenseAsWritten.value,
      dispenseQuantity: e.store.dispenseQuantity.value,
      dispenseUnit: e.store.dispenseUnit.value,
      daysSupply: e.store.daysSupply.value,
      instructions: e.store.instructions.value,
      notes: e.store.notes.value,
      fillsAllowed: e.store.refillsInput.value + 1,
      // TODO: set this from template-overrides. can we stop using the props.store, with this param as a starting point?
      diagnoseCodes: []
    };
    let $ = null;
    try {
      const w = {
        addToTemplates: e.store.addToTemplates?.value ?? !1,
        templateName: e.store.templateName?.value,
        catalogId: e.store.catalogId?.value,
        showSuccessToast: !0
      };
      $ = await r(m, w), $ && e.onDraftPrescriptionCreated($);
    } catch (w) {
      f([w]);
    } finally {
      c(!1);
    }
    $ && (e.screenDraftedPrescriptions(), e.actions.updateFormValue({
      key: "effectiveDate",
      value: h0(/* @__PURE__ */ new Date(), "yyyy-MM-dd").toString()
    }), e.actions.clearKeys(["treatment", "dispenseAsWritten", "dispenseQuantity", "dispenseUnit", "daysSupply", "refillsInput", "instructions", "notes", "templateName", "addToTemplates"]), i(void 0), Au(e.actions, e.prefillNotes ? {
      notes: e.prefillNotes
    } : void 0), d(""));
  };
  return me(() => {
    e.store.treatment?.value && d(e.store.treatment.value.name);
  }), (() => {
    var g = iJ(), v = g.firstChild, m = h;
    return typeof m == "function" ? ze(m, g) : h = g, A(v, oi), A(g, b(hn, {
      addChildrenDivider: !0,
      get children() {
        return [(() => {
          var $ = eJ();
          return A($, b(ke, {
            color: "gray",
            children: "Add Prescription"
          })), $;
        })(), (() => {
          var $ = nJ(), w = $.firstChild, k = w.nextSibling, C = k.firstChild, E = C.firstChild, N = k.nextSibling, M = N.firstChild, V = N.nextSibling, q = V.firstChild, I = q.firstChild, P = I.nextSibling, z = P.firstChild, G = q.nextSibling, se = V.nextSibling, ue = se.firstChild, de = ue.nextSibling, D = se.nextSibling, R = D.nextSibling, Q = R.nextSibling, Z = Q.firstChild;
          return ce($, "photon-medication-selected", (F) => {
            i(F.detail.medication), e.actions.updateFormValue({
              key: "treatment",
              value: F.detail.medication
            }), e.draftedPrescriptionChanged();
          }), ce(w, "photon-search-text-changed", (F) => d(F.detail.text)), ce(w, "photon-treatment-unselected", () => {
            Au(e.actions, e?.prefillNotes ? {
              notes: e.prefillNotes
            } : void 0), e.draftedPrescriptionChanged();
          }), ce(w, "photon-treatment-selected", (F) => {
            F.detail.data.__typename === "PrescriptionTemplate" ? ey(e.actions, {
              ...F.detail.data,
              notes: [F.detail.data?.notes, e.prefillNotes].filter((oe) => oe).join(`

`)
            }) : e.actions.updateFormValue({
              key: "treatment",
              value: F.detail.data
            }), F.detail.catalogId && e.actions.updateFormValue({
              key: "catalogId",
              value: F.detail.catalogId
            }), e.draftedPrescriptionChanged();
          }), w._$owner = fe(), A($, b(
            C6,
            {
              get screeningAlerts() {
                return e.screeningAlerts.filter((F) => F.involvedEntities.map((oe) => oe.id).indexOf(e.store.treatment?.value?.id) >= 0);
              },
              get owningId() {
                return e.store.treatment?.value?.id;
              }
            }
          ), k), ce(E, "photon-checkbox-toggled", (F) => e.actions.updateFormValue({
            key: "dispenseAsWritten",
            value: F.detail.checked
          })), E._$owner = fe(), ce(M, "photon-datepicker-selected", (F) => e.actions.updateFormValue({
            key: "effectiveDate",
            value: F.detail.date
          })), M._$owner = fe(), ce(I, "photon-input-changed", (F) => {
            const oe = Number(F.detail.input);
            !isNaN(oe) && F.detail.input !== "" && e.actions.updateFormValue({
              key: "dispenseQuantity",
              value: oe
            });
          }), I.style.setProperty("width", "100px"), I._$owner = fe(), A(q, b(oj, {
            get open() {
              return o();
            },
            onClose: () => s(!1),
            get medicationName() {
              return e.store.treatment?.value?.name;
            },
            get weight() {
              return e.weight;
            },
            get weightUnit() {
              return e.weightUnit;
            },
            setAutocompleteValues: ({
              liquidDose: F,
              totalLiquid: oe,
              unit: pe,
              days: ee
            }) => {
              e.actions.updateFormValue({
                key: "daysSupply",
                value: Number(ee)
              }), e.actions.updateFormValue({
                key: "dispenseQuantity",
                value: Number(oe)
              }), e.actions.updateFormValue({
                key: "instructions",
                value: `${F} ${pe} ${e.store.instructions?.value}`
              }), pe === "mL" && e.actions.updateFormValue({
                key: "dispenseUnit",
                value: "Milliliter"
              });
            }
          }), P), A(P, b(st, {
            variant: "secondary",
            class: "w-fit",
            onClick: () => s(!0),
            style: {
              // ya, it ain't pretty, but it works. just need it for a lil bit longer
              height: "40px",
              "margin-top": "32px"
            },
            get children() {
              return b(rt, {
                name: "calculator",
                size: "sm"
              });
            }
          }), z), z.style.setProperty("height", "23px"), ce(G, "photon-dispense-unit-selected", (F) => {
            e.actions.updateFormValue({
              key: "dispenseUnit",
              value: F.detail.dispenseUnit.name
            });
          }), G._$owner = fe(), ce(ue, "photon-input-changed", (F) => {
            e.actions.updateFormValue({
              key: "daysSupply",
              value: Number(F.detail.input)
            });
          }), ue._$owner = fe(), ce(de, "photon-input-changed", (F) => e.actions.updateFormValue({
            key: "refillsInput",
            value: Number(F.detail.input)
          })), de._$owner = fe(), ce(D, "photon-textarea-changed", (F) => e.actions.updateFormValue({
            key: "instructions",
            value: F.detail.value
          })), D._$owner = fe(), ce(R, "photon-textarea-changed", (F) => e.actions.updateFormValue({
            key: "notes",
            value: F.detail.value
          })), R._$owner = fe(), A(Q, b(X, {
            get when() {
              return !e.hideAddToTemplates;
            },
            get children() {
              var F = tJ();
              return ce(F, "photon-checkbox-toggled", (oe) => {
                e.actions.updateFormValue({
                  key: "addToTemplates",
                  value: oe.detail.checked
                });
              }), F._$owner = fe(), J(() => F.checked = e.store.addToTemplates?.value || !1), F;
            }
          }), Z), A(Q, b(X, {
            get when() {
              return e.store.addToTemplates?.value ?? !1;
            },
            get children() {
              var F = rJ();
              return ce(F, "photon-input-changed", (oe) => e.actions.updateFormValue({
                key: "templateName",
                value: oe.detail.input
              })), F._$owner = fe(), J((oe) => {
                var pe = e.store.templateName?.error ?? !1, ee = e.store.templateName?.error;
                return pe !== oe.e && (F.invalid = oe.e = pe), ee !== oe.t && (F.helpText = oe.t = ee), oe;
              }, {
                e: void 0,
                t: void 0
              }), J(() => F.value = e.store.templateName?.value ?? ""), F;
            }
          }), Z), A(Z, b(st, {
            class: "w-full xs:!w-auto h-fit",
            size: "lg",
            onClick: () => {
              u() || p();
            },
            get loading() {
              return u();
            },
            variant: "secondary",
            color: "blue",
            get children() {
              return e.enableOrder ? "Add Prescription to Order" : "Add Prescription to Drafts";
            }
          })), J((F) => {
            var oe = e.catalogId, pe = e.allowOffCatalogSearch, ee = e.store.treatment?.value ?? void 0, re = e.store.treatment?.error ?? !1, Ie = e.store.treatment?.error, Pe = n(), at = l(), Xe = e.disableList, ft = e.store.effectiveDate?.error ?? !1, bt = e.store.effectiveDate?.error, le = e.store.dispenseQuantity?.error ?? !1, Y = e.store.dispenseQuantity?.error, ve = e.store.dispenseUnit?.value ?? a()?.name, xe = e.store.dispenseUnit?.error ?? !1, Qe = e.store.dispenseUnit?.error, Fe = e.store.daysSupply?.error ?? !1, He = e.store.daysSupply?.error, Ge = e.store.refillsInput?.error ?? !1, Gt = e.store.refillsInput?.error, Ze = e.store.instructions?.error ?? !1, Pr = e.store.instructions?.error;
            return oe !== F.e && (w.catalogId = F.e = oe), pe !== F.t && (w.allowOffCatalogSearch = F.t = pe), ee !== F.a && (w.selected = F.a = ee), re !== F.o && (w.invalid = F.o = re), Ie !== F.i && (w.helpText = F.i = Ie), Pe !== F.n && (w.offCatalogOption = F.n = Pe), at !== F.s && (w.searchText = F.s = at), Xe !== F.h && (w.disableList = F.h = Xe), ft !== F.r && (M.invalid = F.r = ft), bt !== F.d && (M.helpText = F.d = bt), le !== F.l && (I.invalid = F.l = le), Y !== F.u && (I.helpText = F.u = Y), ve !== F.c && (G.selected = F.c = ve), xe !== F.w && (G.invalid = F.w = xe), Qe !== F.m && (G.helpText = F.m = Qe), Fe !== F.f && (ue.invalid = F.f = Fe), He !== F.y && (ue.helpText = F.y = He), Ge !== F.g && (de.invalid = F.g = Ge), Gt !== F.p && (de.helpText = F.p = Gt), Ze !== F.b && (D.invalid = F.b = Ze), Pr !== F.T && (D.helpText = F.T = Pr), F;
          }, {
            e: void 0,
            t: void 0,
            a: void 0,
            o: void 0,
            i: void 0,
            n: void 0,
            s: void 0,
            h: void 0,
            r: void 0,
            d: void 0,
            l: void 0,
            u: void 0,
            c: void 0,
            w: void 0,
            m: void 0,
            f: void 0,
            y: void 0,
            g: void 0,
            p: void 0,
            b: void 0,
            T: void 0
          }), J(() => E.checked = e.store.dispenseAsWritten?.value || !1), J(() => I.value = e.store.dispenseQuantity?.value ?? null), J(() => ue.value = e.store.daysSupply?.value ?? null), J(() => de.value = e.store.refillsInput?.value), J(() => D.value = e.store.instructions?.value), J(() => R.value = e.store.notes?.value), $;
        })()];
      }
    }), null), g;
  })();
};
var oJ = gr`
  :host {
    --max-width: 20rem;
    --hide-delay: 0ms;
    --show-delay: 150ms;

    display: contents;
  }

  .tooltip {
    --arrow-size: var(--sl-tooltip-arrow-size);
    --arrow-color: var(--sl-tooltip-background-color);
  }

  .tooltip::part(popup) {
    z-index: var(--sl-z-index-tooltip);
  }

  .tooltip[placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .tooltip[placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .tooltip[placement^='left']::part(popup) {
    transform-origin: right;
  }

  .tooltip[placement^='right']::part(popup) {
    transform-origin: left;
  }

  .tooltip__body {
    display: block;
    width: max-content;
    max-width: var(--max-width);
    border-radius: var(--sl-tooltip-border-radius);
    background-color: var(--sl-tooltip-background-color);
    font-family: var(--sl-tooltip-font-family);
    font-size: var(--sl-tooltip-font-size);
    font-weight: var(--sl-tooltip-font-weight);
    line-height: var(--sl-tooltip-line-height);
    text-align: start;
    white-space: normal;
    color: var(--sl-tooltip-color);
    padding: var(--sl-tooltip-padding);
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
  }
`, _r = class extends ar {
  constructor() {
    super(), this.localize = new Ei(this), this.content = "", this.placement = "top", this.disabled = !1, this.distance = 8, this.open = !1, this.skidding = 0, this.trigger = "hover focus", this.hoist = !1, this.handleBlur = () => {
      this.hasTrigger("focus") && this.hide();
    }, this.handleClick = () => {
      this.hasTrigger("click") && (this.open ? this.hide() : this.show());
    }, this.handleFocus = () => {
      this.hasTrigger("focus") && this.show();
    }, this.handleDocumentKeyDown = (e) => {
      e.key === "Escape" && (e.stopPropagation(), this.hide());
    }, this.handleMouseOver = () => {
      if (this.hasTrigger("hover")) {
        const e = zg(getComputedStyle(this).getPropertyValue("--show-delay"));
        clearTimeout(this.hoverTimeout), this.hoverTimeout = window.setTimeout(() => this.show(), e);
      }
    }, this.handleMouseOut = () => {
      if (this.hasTrigger("hover")) {
        const e = zg(getComputedStyle(this).getPropertyValue("--hide-delay"));
        clearTimeout(this.hoverTimeout), this.hoverTimeout = window.setTimeout(() => this.hide(), e);
      }
    }, this.addEventListener("blur", this.handleBlur, !0), this.addEventListener("focus", this.handleFocus, !0), this.addEventListener("click", this.handleClick), this.addEventListener("mouseover", this.handleMouseOver), this.addEventListener("mouseout", this.handleMouseOut);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this.closeWatcher) == null || e.destroy(), document.removeEventListener("keydown", this.handleDocumentKeyDown);
  }
  firstUpdated() {
    this.body.hidden = !this.open, this.open && (this.popup.active = !0, this.popup.reposition());
  }
  hasTrigger(e) {
    return this.trigger.split(" ").includes(e);
  }
  async handleOpenChange() {
    var e, t;
    if (this.open) {
      if (this.disabled)
        return;
      this.emit("sl-show"), "CloseWatcher" in window ? ((e = this.closeWatcher) == null || e.destroy(), this.closeWatcher = new CloseWatcher(), this.closeWatcher.onclose = () => {
        this.hide();
      }) : document.addEventListener("keydown", this.handleDocumentKeyDown), await Gn(this.body), this.body.hidden = !1, this.popup.active = !0;
      const { keyframes: r, options: n } = Sn(this, "tooltip.show", { dir: this.localize.dir() });
      await En(this.popup.popup, r, n), this.popup.reposition(), this.emit("sl-after-show");
    } else {
      this.emit("sl-hide"), (t = this.closeWatcher) == null || t.destroy(), document.removeEventListener("keydown", this.handleDocumentKeyDown), await Gn(this.body);
      const { keyframes: r, options: n } = Sn(this, "tooltip.hide", { dir: this.localize.dir() });
      await En(this.popup.popup, r, n), this.popup.active = !1, this.body.hidden = !0, this.emit("sl-after-hide");
    }
  }
  async handleOptionsChange() {
    this.hasUpdated && (await this.updateComplete, this.popup.reposition());
  }
  handleDisabledChange() {
    this.disabled && this.open && this.hide();
  }
  /** Shows the tooltip. */
  async show() {
    if (!this.open)
      return this.open = !0, sa(this, "sl-after-show");
  }
  /** Hides the tooltip */
  async hide() {
    if (this.open)
      return this.open = !1, sa(this, "sl-after-hide");
  }
  //
  // NOTE: Tooltip is a bit unique in that we're using aria-live instead of aria-labelledby to trick screen readers into
  // announcing the content. It works really well, but it violates an accessibility rule. We're also adding the
  // aria-describedby attribute to a slot, which is required by <sl-popup> to correctly locate the first assigned
  // element, otherwise positioning is incorrect.
  //
  render() {
    return xt`
      <sl-popup
        part="base"
        exportparts="
          popup:base__popup,
          arrow:base__arrow
        "
        class=${dr({
      tooltip: !0,
      "tooltip--open": this.open
    })}
        placement=${this.placement}
        distance=${this.distance}
        skidding=${this.skidding}
        strategy=${this.hoist ? "fixed" : "absolute"}
        flip
        shift
        arrow
        hover-bridge
      >
        ${""}
        <slot slot="anchor" aria-describedby="tooltip"></slot>

        ${""}
        <div part="body" id="tooltip" class="tooltip__body" role="tooltip" aria-live=${this.open ? "polite" : "off"}>
          <slot name="content">${this.content}</slot>
        </div>
      </sl-popup>
    `;
  }
};
_r.styles = [Ar, oJ];
_r.dependencies = { "sl-popup": At };
O([
  jt("slot:not([name])")
], _r.prototype, "defaultSlot", 2);
O([
  jt(".tooltip__body")
], _r.prototype, "body", 2);
O([
  jt("sl-popup")
], _r.prototype, "popup", 2);
O([
  U()
], _r.prototype, "content", 2);
O([
  U()
], _r.prototype, "placement", 2);
O([
  U({ type: Boolean, reflect: !0 })
], _r.prototype, "disabled", 2);
O([
  U({ type: Number })
], _r.prototype, "distance", 2);
O([
  U({ type: Boolean, reflect: !0 })
], _r.prototype, "open", 2);
O([
  U({ type: Number })
], _r.prototype, "skidding", 2);
O([
  U()
], _r.prototype, "trigger", 2);
O([
  U({ type: Boolean })
], _r.prototype, "hoist", 2);
O([
  Nt("open", { waitUntilFirstUpdate: !0 })
], _r.prototype, "handleOpenChange", 1);
O([
  Nt(["content", "distance", "hoist", "placement", "skidding"])
], _r.prototype, "handleOptionsChange", 1);
O([
  Nt("disabled")
], _r.prototype, "handleDisabledChange", 1);
Rn("tooltip.show", {
  keyframes: [
    { opacity: 0, scale: 0.8 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 150, easing: "ease" }
});
Rn("tooltip.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.8 }
  ],
  options: { duration: 150, easing: "ease" }
});
_r.define("sl-tooltip");
var P1 = /* @__PURE__ */ K("<style>"), sJ = /* @__PURE__ */ K("<sl-tooltip><sl-icon name=info-circle>", !0, !1, !1);
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const ty = (e) => {
  const t = Be({
    placement: "top",
    maxWidth: "200px"
  }, e);
  return [(() => {
    var r = P1();
    return A(r, Rt), r;
  })(), (() => {
    var r = P1();
    return A(r, Ur), r;
  })(), (() => {
    var r = P1();
    return A(r, qr), r;
  })(), (() => {
    var r = sJ(), n = r.firstChild;
    return r._$owner = fe(), n._$owner = fe(), J((i) => {
      var a = t.tip, o = t.placement, s = t.maxWidth;
      return a !== i.e && (r.content = i.e = a), o !== i.t && (r.placement = i.t = o), s !== i.a && ((i.a = s) != null ? r.style.setProperty("--max-width", s) : r.style.removeProperty("--max-width")), i;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), r;
  })()];
};
var lJ = /* @__PURE__ */ K('<div class="flex items-center space-x-2 text-slate-500">'), dJ = /* @__PURE__ */ K('<div><style></style><photon-dialog label="Overwrite in progress prescription?"confirm-text="Yes, Overwrite"cancel-text="No, Cancel"><p class="font-sans text-lg xs:text-base">You are editing a prescription that has not been added. This will be overwritten if you edit another prescription.</p></photon-dialog><photon-dialog label="Delete pending prescription?"confirm-text="Yes, Delete"cancel-text="No, Cancel"><p class="font-sans text-lg xs:text-base">Deleting this prescription will remove it from your pending prescriptions. This action cannot be undone.', !0, !1, !1);
const uJ = (e) => {
  let t;
  const [r, n] = H(!1), [i, a] = H(!1), [o, s] = H(), [l, d] = H(void 0), [u, c] = H(), {
    prescriptionIds: h,
    deletePrescription: f,
    selectOtherCoverageOption: p
  } = oo(), {
    draftPrescriptions: g
  } = pd(), v = (M) => {
    const V = new CustomEvent("photon-draft-prescription-deleted", {
      composed: !0,
      bubbles: !0,
      detail: {
        prescription: M
      }
    });
    t?.dispatchEvent(V);
  }, m = () => {
    const M = l();
    M && M.treatment && (ey(e.actions, M), e.actions.updateFormValue({
      key: "catalogId",
      value: M.catalogId
    }), M.id && f(M.id), e.prescriptionRef?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    }), e.handleDraftPrescriptionsChange());
  }, $ = (M, V) => {
    d(M), e.store.treatment.value ? (a(!0), s(V)) : (e.setIsEditing(!0), m(), V?.());
  }, w = (M) => {
    $(cJ(M), () => {
      p(M);
    });
  }, k = () => {
    m(), a(!1), d(void 0), o()?.(), s(void 0);
  }, C = () => {
    a(!1), d(void 0), s(void 0);
  }, E = () => {
    const M = u();
    if (M) {
      const V = g().find((q) => q.id === M);
      f(M), v(V);
    }
    n(!1), c(void 0), h().length === 0 && e.setIsEditing(!0), e.handleDraftPrescriptionsChange();
  }, N = () => {
    n(!1), c(void 0);
  };
  return (() => {
    var M = dJ(), V = M.firstChild, q = V.nextSibling, I = q.nextSibling, P = t;
    return typeof P == "function" ? ze(P, M) : t = M, A(V, oi), ce(q, "photon-dialog-alt", C), ce(q, "photon-dialog-canceled", C), ce(q, "photon-dialog-confirmed", k), q._$owner = fe(), ce(I, "photon-dialog-alt", N), ce(I, "photon-dialog-canceled", N), ce(I, "photon-dialog-confirmed", E), I._$owner = fe(), A(M, b(hn, {
      addChildrenDivider: !0,
      get children() {
        return [(() => {
          var z = lJ();
          return A(z, b(ke, {
            color: "gray",
            class: "pr-2",
            get children() {
              return e.enableOrder ? "Pending Order" : "Pending Prescriptions";
            }
          }), null), A(z, b(ty, {
            maxWidth: "300px",
            tip: "Each prescription will include the prescriber’s digital signature and the date it was written when the order is sent to the pharmacy."
          }), null), z;
        })(), b(XB, {
          handleDelete: (z) => {
            n(!0), c(z);
          },
          handleEdit: (z) => {
            $(z);
          },
          handleSwapToOtherPrescription: w,
          get screeningAlerts() {
            return e.screeningAlerts;
          },
          get routingConstraints() {
            return e.routingConstraints;
          },
          get enableOrder() {
            return e.enableOrder;
          }
        })];
      }
    }), null), J((z) => {
      var G = i(), se = r();
      return G !== z.e && (q.open = z.e = G), se !== z.t && (I.open = z.t = se), z;
    }, {
      e: void 0,
      t: void 0
    }), M;
  })();
};
function cJ(e) {
  return {
    // re-using the prescriptionId (via coverageOption.prescriptionId) of the original Prescription
    // so that the edit flow will remove it from the list of prescriptions
    id: e.prescriptionId,
    effectiveDate: h0(/* @__PURE__ */ new Date(), "yyyy-MM-dd").toString(),
    dispenseAsWritten: !1,
    dispenseQuantity: e.dispenseQuantity,
    dispenseUnit: e.dispenseUnit,
    daysSupply: e.daysSupply,
    instructions: "",
    notes: "",
    fillsAllowed: void 0,
    diagnoseCodes: [],
    externalId: void 0,
    catalogId: void 0,
    treatment: {
      id: e.treatment.id,
      name: e.treatment.name
    }
  };
}
var hJ = /* @__PURE__ */ K('<div class="flex items-center justify-between">'), fJ = /* @__PURE__ */ K("<div><style>");
const pJ = (e) => {
  const {
    setOrderFormData: t
  } = oo(), r = L(() => e.store.patient?.value ? [e.store.patient?.value?.id] : []), n = L(() => {
    const i = e.store.patient?.value?.address;
    return i ? `${i.street1} ${i.street2 || ""} ${i.city}, ${i.state} ${i.postalCode}` : "";
  });
  return (() => {
    var i = fJ(), a = i.firstChild;
    return A(a, oi), A(i, b(hn, {
      addChildrenDivider: !0,
      get children() {
        return [(() => {
          var o = hJ();
          return A(o, b(ke, {
            color: "gray",
            children: "Select Pharmacy"
          })), o;
        })(), b(kW, {
          get enableSendToPatient() {
            return e.enableSendToPatient;
          },
          get enableDeliveryPharmacies() {
            return e.enableDeliveryPharmacies;
          },
          get enableLocalPickup() {
            return e.enableLocalPickup || !e?.enableSendToPatient && !e?.mailOrderIds;
          },
          get mailOrderPharmacyIds() {
            return L(() => !!e.mailOrderIds)() ? e.mailOrderIds.split(",") : void 0;
          },
          get patientIds() {
            return r();
          },
          get address() {
            return n();
          },
          setFufillmentType: (o) => {
            e.actions.updateFormValue({
              key: "fulfillmentType",
              value: o || ""
            });
          },
          setPreferredPharmacy: (o = !1) => {
            e.actions.updateFormValue({
              key: "updatePreferredPharmacy",
              value: o
            });
          },
          setPharmacyId: (o) => {
            t("pharmacyId", o);
          }
        })];
      }
    }), null), i;
  })();
};
var mJ = /* @__PURE__ */ K('<div class="flex items-center justify-between">'), gJ = /* @__PURE__ */ K("<photon-patient-select>", !0, !1, !1), vJ = /* @__PURE__ */ K("<div><photon-patient-dialog>", !0, !1, !1), yJ = /* @__PURE__ */ K("<div><photon-add-medication-history-dialog>", !0, !1, !1), bJ = /* @__PURE__ */ K('<div class="flex flex-col gap-8">');
const $J = sr($p(sn(), c0()), "Please select a patient..."), wJ = sr($p(sn(), c0()), "Please enter an address for patient..."), xJ = (e) => {
  const [t, r] = H(), [n, i] = H(!1), [a, o] = H(!1), {
    actions: s,
    store: l
  } = _d, [d, u] = H(!1);
  Et(() => {
    e.actions.registerValidator({
      key: "patient",
      validator: $J
    }), e.enableOrder && e.actions.registerValidator({
      key: "address",
      validator: wJ
    }), e?.patientId && s.getSelectedPatient(e.client.getSDK(), e.patientId);
  });
  const c = (g) => {
    e.actions.updateFormValue({
      key: "patient",
      value: g.detail.patient
    }), e.enableOrder && !e.address && e.actions.updateFormValue({
      key: "address",
      value: g.detail.patient.address
    });
  };
  me(() => {
    l?.selectedPatient?.data && e?.patientId && c({
      detail: {
        patient: l?.selectedPatient?.data
      }
    });
  });
  const h = L(
    // prefer the passed-in patientId if it exists
    () => e?.patientId || e.store.patient?.value?.id
  ), f = L(() => d() ? "" : h() ?? ""), p = L(() => e.store.patient?.value?.id && !e.store.patient?.value?.address && e.enableOrder);
  return (() => {
    var g = bJ();
    return A(g, b(X, {
      get when() {
        return !e?.patientId;
      },
      get children() {
        return b(hn, {
          addChildrenDivider: !0,
          get children() {
            return [(() => {
              var v = mJ();
              return A(v, b(ke, {
                color: "gray",
                get children() {
                  return e?.patientId ? "Patient" : "Select Patient";
                }
              })), v;
            })(), (() => {
              var v = gJ();
              return ce(v, "photon-patient-selected", c), v._$owner = fe(), J((m) => {
                var $ = e.store.patient?.error ?? !1, w = e.store.patient?.error, k = e.store.patient?.value?.id ?? e.patientId, C = e.client.getSDK();
                return $ !== m.e && (v.invalid = m.e = $), w !== m.t && (v.helpText = m.t = w), k !== m.a && (v.selected = m.a = k), C !== m.o && (v.sdk = m.o = C), m;
              }, {
                e: void 0,
                t: void 0,
                a: void 0,
                o: void 0
              }), v;
            })()];
          }
        });
      }
    }), null), A(g, b(X, {
      get when() {
        return f() && !e.hidePatientCard;
      },
      get children() {
        var v = vJ(), m = v.firstChild;
        return A(v, b(dH, {
          get patientId() {
            return f();
          },
          get weight() {
            return e?.weight;
          },
          get weightUnit() {
            return e?.weightUnit;
          },
          get editPatient() {
            return e?.enableOrder && !p() ? () => i(!0) : void 0;
          },
          get address() {
            return e?.address || e.store.patient?.value?.address;
          }
        }), m), ce(m, "photon-patient-closed", () => {
          i(!1);
        }), ce(m, "photon-patient-updated", () => {
          u(!0), s.getSelectedPatient(e.client.getSDK(), e.store.patient.value.id), setTimeout(() => {
            u(!1), i(!1);
          }, 100);
        }), m.hideCreatePrescription = !0, m._$owner = fe(), J(($) => {
          var w = n(), k = f();
          return w !== $.e && (m.open = $.e = w), k !== $.t && (m.patientId = $.t = k), $;
        }, {
          e: void 0,
          t: void 0
        }), v;
      }
    }), null), A(g, b(X, {
      get when() {
        return L(() => !!e.enableMedHistory)() && f();
      },
      get children() {
        var v = yJ(), m = v.firstChild;
        return A(v, b(I6, {
          get patientId() {
            return f();
          },
          get newMedication() {
            return t();
          },
          get enableLinks() {
            return e.enableMedHistoryLinks ?? !1;
          },
          get enableRefillButton() {
            return e.enableMedHistoryRefillButton ?? !1;
          },
          openAddMedicationDialog: () => o(!0),
          hideAddMedicationDialog: () => o(!1)
        }), m), ce(m, "photon-medication-closed", () => {
          o(!1);
        }), ce(m, "photon-medication-selected", ($) => {
          r($.detail.medication);
        }), m._$owner = fe(), J(() => m.open = a()), v;
      }
    }), null), A(g, b(X, {
      get when() {
        return p();
      },
      get children() {
        return b(yz, {
          get patientId() {
            return f();
          },
          setAddress: (v) => {
            e.actions.updateFormValue({
              key: "address",
              value: v
            }), e.actions.updateFormValue({
              key: "patient",
              value: {
                ...e.store.patient.value,
                address: v
              }
            });
          }
        });
      }
    }), null), g;
  })();
};
var kJ = /* @__PURE__ */ K("<span>, "), _J = /* @__PURE__ */ K('<div class="flex flex-col items-start">'), CJ = /* @__PURE__ */ K('<photon-card><div class="flex flex-col gap-3"><div class="flex flex-row"><p class="font-sans text-l font-medium flex-grow">Selected Pharmacy', !0, !1, !1);
const SJ = (e) => {
  const t = Xr(), [r, n] = H(null), i = async (a) => {
    if (a && t) {
      const {
        data: o
      } = await t.getSDK().clinical.pharmacy.getPharmacy({
        id: a
      });
      n(o.pharmacy);
    }
  };
  return me(() => {
    e.pharmacyId && i(e.pharmacyId);
  }), (() => {
    var a = CJ(), o = a.firstChild;
    return o.firstChild, a._$owner = fe(), A(o, b(X, {
      get when() {
        return r();
      },
      get children() {
        return b(Zl, {
          label: "Pharmacies",
          get initSelected() {
            return e?.pharmacyId || "";
          },
          get children() {
            return b(Zl.Option, {
              get value() {
                return e?.pharmacyId || "";
              },
              get children() {
                var s = _J();
                return A(s, b(ke, {
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "Loading Name",
                  get children() {
                    return r()?.name;
                  }
                }), null), A(s, b(ke, {
                  get loading() {
                    return !r();
                  },
                  color: "gray",
                  size: "sm",
                  sampleLoadingText: "Cityville, ST",
                  get children() {
                    var l = kJ(), d = l.firstChild;
                    return A(l, () => r()?.address?.city, d), A(l, () => r()?.address?.state, null), l;
                  }
                }), null), s;
              }
            });
          }
        });
      }
    }), null), a;
  })();
}, EJ = ".remove-icon-button::part(base):hover,.remove-icon-button::part(base):focus{--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}.edit-icon-button::part(base):hover,.edit-icon-button::part(base):focus{--tw-text-opacity: 1;color:rgb(234,179,8,var(--tw-text-opacity))}.enable-switch{--width: 60px;--height: 32px;--thumb-size: 26px;--sl-color-primary-600: #22c55e}", TJ = (e, t = "lb") => `Patient weight: ${e} ${t}`;
var ry = /* @__PURE__ */ ((e) => (e.Draft = "DRAFT", e.Active = "ACTIVE", e.Depleted = "DEPLETED", e.Expired = "EXPIRED", e.Canceled = "CANCELED", e))(ry || {});
Br.define("sl-icon-button");
var AJ = gr`
  :host {
    display: inline-block;
  }

  :host([size='small']) {
    --height: var(--sl-toggle-size-small);
    --thumb-size: calc(var(--sl-toggle-size-small) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-small);
  }

  :host([size='medium']) {
    --height: var(--sl-toggle-size-medium);
    --thumb-size: calc(var(--sl-toggle-size-medium) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-medium);
  }

  :host([size='large']) {
    --height: var(--sl-toggle-size-large);
    --thumb-size: calc(var(--sl-toggle-size-large) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-large);
  }

  .switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    font-family: var(--sl-input-font-family);
    font-size: inherit;
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .switch__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--width);
    height: var(--height);
    background-color: var(--sl-color-neutral-400);
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    border-radius: var(--height);
    transition:
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) background-color;
  }

  .switch__control .switch__thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    background-color: var(--sl-color-neutral-0);
    border-radius: 50%;
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    translate: calc((var(--width) - var(--height)) / -2);
    transition:
      var(--sl-transition-fast) translate ease,
      var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) box-shadow;
  }

  .switch__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Hover */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-neutral-400);
  }

  /* Focus */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Checked */
  .switch--checked .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch--checked .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    translate: calc((var(--width) - var(--height)) / 2);
  }

  /* Checked + hover */
  .switch.switch--checked:not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
  }

  /* Checked + focus */
  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .switch--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .switch__label {
    display: inline-block;
    line-height: var(--height);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }

  :host([required]) .switch__label::after {
    content: var(--sl-input-required-content);
    color: var(--sl-input-required-content-color);
    margin-inline-start: var(--sl-input-required-content-offset);
  }

  @media (forced-colors: active) {
    .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb,
    .switch--checked .switch__control .switch__thumb {
      background-color: ButtonText;
    }
  }
`, Ir = class extends ar {
  constructor() {
    super(...arguments), this.formControlController = new kd(this, {
      value: (e) => e.checked ? e.value || "on" : void 0,
      defaultValue: (e) => e.defaultChecked,
      setValue: (e, t) => e.checked = t
    }), this.hasSlotController = new ha(this, "help-text"), this.hasFocus = !1, this.title = "", this.name = "", this.size = "medium", this.disabled = !1, this.checked = !1, this.defaultChecked = !1, this.form = "", this.required = !1, this.helpText = "";
  }
  /** Gets the validity state object */
  get validity() {
    return this.input.validity;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.input.validationMessage;
  }
  firstUpdated() {
    this.formControlController.updateValidity();
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleInput() {
    this.emit("sl-input");
  }
  handleInvalid(e) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(e);
  }
  handleClick() {
    this.checked = !this.checked, this.emit("sl-change");
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleKeyDown(e) {
    e.key === "ArrowLeft" && (e.preventDefault(), this.checked = !1, this.emit("sl-change"), this.emit("sl-input")), e.key === "ArrowRight" && (e.preventDefault(), this.checked = !0, this.emit("sl-change"), this.emit("sl-input"));
  }
  handleCheckedChange() {
    this.input.checked = this.checked, this.formControlController.updateValidity();
  }
  handleDisabledChange() {
    this.formControlController.setValidity(!0);
  }
  /** Simulates a click on the switch. */
  click() {
    this.input.click();
  }
  /** Sets focus on the switch. */
  focus(e) {
    this.input.focus(e);
  }
  /** Removes focus from the switch. */
  blur() {
    this.input.blur();
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.input.checkValidity();
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return this.input.reportValidity();
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(e) {
    this.input.setCustomValidity(e), this.formControlController.updateValidity();
  }
  render() {
    const e = this.hasSlotController.test("help-text"), t = this.helpText ? !0 : !!e;
    return xt`
      <div
        class=${dr({
      "form-control": !0,
      "form-control--small": this.size === "small",
      "form-control--medium": this.size === "medium",
      "form-control--large": this.size === "large",
      "form-control--has-help-text": t
    })}
      >
        <label
          part="base"
          class=${dr({
      switch: !0,
      "switch--checked": this.checked,
      "switch--disabled": this.disabled,
      "switch--focused": this.hasFocus,
      "switch--small": this.size === "small",
      "switch--medium": this.size === "medium",
      "switch--large": this.size === "large"
    })}
        >
          <input
            class="switch__input"
            type="checkbox"
            title=${this.title}
            name=${this.name}
            value=${Me(this.value)}
            .checked=${rd(this.checked)}
            .disabled=${this.disabled}
            .required=${this.required}
            role="switch"
            aria-checked=${this.checked ? "true" : "false"}
            aria-describedby="help-text"
            @click=${this.handleClick}
            @input=${this.handleInput}
            @invalid=${this.handleInvalid}
            @blur=${this.handleBlur}
            @focus=${this.handleFocus}
            @keydown=${this.handleKeyDown}
          />

          <span part="control" class="switch__control">
            <span part="thumb" class="switch__thumb"></span>
          </span>

          <div part="label" class="switch__label">
            <slot></slot>
          </div>
        </label>

        <div
          aria-hidden=${t ? "false" : "true"}
          class="form-control__help-text"
          id="help-text"
          part="form-control-help-text"
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
  }
};
Ir.styles = [Ar, d0, AJ];
O([
  jt('input[type="checkbox"]')
], Ir.prototype, "input", 2);
O([
  Fn()
], Ir.prototype, "hasFocus", 2);
O([
  U()
], Ir.prototype, "title", 2);
O([
  U()
], Ir.prototype, "name", 2);
O([
  U()
], Ir.prototype, "value", 2);
O([
  U({ reflect: !0 })
], Ir.prototype, "size", 2);
O([
  U({ type: Boolean, reflect: !0 })
], Ir.prototype, "disabled", 2);
O([
  U({ type: Boolean, reflect: !0 })
], Ir.prototype, "checked", 2);
O([
  l0("checked")
], Ir.prototype, "defaultChecked", 2);
O([
  U({ reflect: !0 })
], Ir.prototype, "form", 2);
O([
  U({ type: Boolean, reflect: !0 })
], Ir.prototype, "required", 2);
O([
  U({ attribute: "help-text" })
], Ir.prototype, "helpText", 2);
O([
  Nt("checked", { waitUntilFirstUpdate: !0 })
], Ir.prototype, "handleCheckedChange", 1);
O([
  Nt("disabled", { waitUntilFirstUpdate: !0 })
], Ir.prototype, "handleDisabledChange", 1);
Ir.define("sl-switch");
var OJ = /* @__PURE__ */ K('<div class="w-full flex justify-center">'), IJ = /* @__PURE__ */ K("<div>"), PJ = /* @__PURE__ */ K('<div class="m-3 gap-4">'), DJ = /* @__PURE__ */ K('<div class="flex flex-row justify-end gap-2">'), MJ = /* @__PURE__ */ K('<div><style></style><style></style><style></style><style></style><style></style><div><div class="flex flex-col gap-8">'), NJ = /* @__PURE__ */ K("<div>No errors...");
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const LJ = Ce`
  query ScreenDraftedPrescriptionsQuery(
    $draftedPrescriptions: [DraftedPrescriptionInput!]!
    $patientId: ID!
  ) {
    prescriptionScreen(draftedPrescriptions: $draftedPrescriptions, patientId: $patientId) {
      alerts {
        type
        description
        involvedEntities {
          id
          name
          __typename
        }
        severity
      }
    }
  }
`;
function FJ(e) {
  let t;
  const {
    draftPrescriptions: r
  } = pd(), {
    routingConstraints: n,
    combinedRoutingConstraint: i,
    tryUpdatePrescriptionStates: a,
    isLoadingPrefills: o,
    orderFormData: s
  } = oo(), l = L(() => r().map((le) => le.id)), d = L(() => {
    if (e.pharmacyId)
      return e.pharmacyId;
    if (i()?.routing_constraint_type === "include" && i()?.constraint_pharmacies?.length === 1)
      return i().constraint_pharmacies?.[0].id;
  }), u = Xr(), [c, h] = H(
    // this logic keeps the rx form closed when refilling a particular template/prescription
    !e.templateIds && !e.prescriptionIds
  ), [f, p] = H([]), [g, v] = H(!0), [m, $] = H(!1), [w, k] = H(u?.authentication.state.isAuthenticated || !1), [, C] = Ps(), [E, N] = H([]), [M, V] = H(!1), [q, I] = H(!1);
  let P = "";
  e.additionalNotes && (P = `${e.additionalNotes}

`), e.weight && (P = `${P}${TJ(e.weight, e?.weightUnit)}`), Et(() => {
    e.address && e.formActions.updateFormValue({
      key: "address",
      value: e.address
    }), t.addEventListener("photon-ticket-created-duplicate", () => {
      Au(e.formActions, P ? {
        notes: P
      } : void 0);
    });
  }), me(() => {
    !u?.authentication.state.isAuthenticated && !u?.authentication.state.isLoading && !u?.authentication.state.error && u?.autoLogin && u?.authentication.login({
      appState: {
        returnTo: window.location.pathname
      }
    });
  }), me(() => {
    v(u?.authentication.state.isLoading || !1);
  }), me(() => {
    k(u?.authentication.state.isAuthenticated || !1);
  });
  const z = L(() => Ch(["write:prescription"], u?.authentication.state.permissions || [])), G = L(() => {
    const le = e.formStore?.address?.value ?? e.formStore?.patient?.value?.address ?? {}, {
      __typename: Y,
      name: ve,
      ...xe
    } = le;
    return {
      street2: "",
      country: "US",
      ...xe
    };
  }), se = (le) => {
    const Y = new CustomEvent("photon-prescriptions-created", {
      composed: !0,
      bubbles: !0,
      detail: {
        prescriptions: le
      }
    });
    t?.dispatchEvent(Y);
  }, ue = (le) => {
    const Y = new CustomEvent("photon-draft-prescription-created", {
      composed: !0,
      bubbles: !0,
      detail: {
        draft: le
      }
    });
    t?.dispatchEvent(Y);
  }, de = (le) => {
    const Y = new CustomEvent("photon-order-created", {
      composed: !0,
      bubbles: !0,
      detail: {
        order: le
      }
    });
    t?.dispatchEvent(Y);
  }, D = (le) => {
    const Y = /* @__PURE__ */ new Set();
    return le.filter((ve) => {
      const xe = ve.treatment.id;
      return Y.has(xe) ? !1 : (Y.add(xe), !0);
    });
  }, R = async () => {
    const le = e.formStore.treatment?.value?.id, Y = r().map(RJ);
    le && Y.push({
      treatment: {
        id: le
      }
    });
    const ve = D(Y), {
      data: xe
    } = await at.query({
      query: LJ,
      variables: {
        patientId: e.formStore.patient?.value.id,
        draftedPrescriptions: ve
      }
    });
    N(xe?.prescriptionScreen?.alerts ?? []);
  };
  me(() => {
    r().length > 0 && R();
  });
  const Q = (le) => {
    const Y = new CustomEvent("photon-prescriptions-error", {
      composed: !0,
      bubbles: !0,
      detail: {
        errors: le
      }
    });
    t?.dispatchEvent(Y);
  }, Z = (le = []) => {
    const Y = new CustomEvent("photon-order-error", {
      composed: !0,
      bubbles: !0,
      detail: {
        errors: le
      }
    });
    t?.dispatchEvent(Y);
  }, F = (le) => {
    const Y = new CustomEvent("photon-form-validate", {
      composed: !0,
      bubbles: !0,
      detail: {
        canSubmit: le,
        form: e.formStore,
        actions: e.formActions
      }
    });
    t?.dispatchEvent(Y);
  }, oe = () => {
    I(!0);
  }, pe = () => C.setIsCombineDialogOpen(!0, () => ee(e.enableOrder), G()), ee = async (le) => {
    if (g())
      return;
    if (p([]), V(!1), !z())
      return ir({
        status: "error",
        header: "Unauthorized",
        body: "You do not have permission to prescribe"
      });
    const Y = le ? ["patient", "address"] : ["patient"];
    e.formActions.validate(Y);
    const ve = e.formActions.getErrors(Y);
    ve.length === 0 ? (v(!0), e.formActions.updateFormValue({
      key: "errors",
      value: []
    }), e.enableOrder ? await Ie() : await re(), se(r())) : p(ve);
  }, re = async () => {
    try {
      await a(l(), ry.Active);
    } catch (le) {
      Q([le]);
    }
    v(!1);
  }, Ie = async () => {
    const le = u.getSDK().clinical.order.createOrder({}), Y = u.getSDK().clinical.patient.removePatientPreferredPharmacy({}), ve = u.getSDK().clinical.patient.updatePatient({});
    try {
      if (e.formStore.updatePreferredPharmacy?.value && s.pharmacyId && e.formStore.fulfillmentType?.value === "PICK_UP") {
        const He = e.formStore.patient?.value;
        He?.preferredPharmacies && He?.preferredPharmacies?.length > 0 && Y({
          variables: {
            patientId: He.id,
            pharmacyId: He.preferredPharmacies[0].id
          },
          awaitRefetchQueries: !1
        }), ve({
          variables: {
            id: He.id,
            preferredPharmacies: [s.pharmacyId]
          },
          awaitRefetchQueries: !1
        });
      }
      let xe = d();
      s.pharmacyId && (xe = s.pharmacyId), xe || (xe = "");
      const {
        data: Qe,
        errors: Fe
      } = await le({
        variables: {
          ...e.externalOrderId ? {
            externalId: e.externalOrderId
          } : {},
          ...e.groupId ? {
            groupId: e.groupId
          } : {},
          patientId: e.formStore.patient?.value.id,
          pharmacyId: xe,
          fulfillmentType: e.formStore.fulfillmentType?.value || "",
          address: G(),
          fills: l().map((He) => ({
            prescriptionId: He
          }))
        },
        refetchQueries: [],
        awaitRefetchQueries: !1
      });
      if (v(!1), Fe) {
        Z(Fe);
        return;
      }
      de(Qe.createOrder);
    } catch (xe) {
      Z([xe]), v(!1), ir({
        status: "error",
        header: "Error Creating Order",
        body: xe?.message
      });
    }
  }, Pe = () => E().length > 0 && M() === !1 ? oe() : e.enableCombineAndDuplicate && C.hasRoutingOrder() ? pe() : ee(e.enableOrder);
  me(() => {
    e.triggerSubmit && Re(() => Pe());
  }), me(() => {
    F(!!(r().length > 0 && e.formStore.patient?.value));
  });
  const at = u.sdk.apolloClinical;
  let Xe;
  const ft = L(() => !e.patientId || e.patientId === e.formStore.patient?.value?.id || e.patientId === e.formStore.patient?.value?.externalId), bt = (le) => {
    ue(le), m() && $(!1);
  };
  return (() => {
    var le = MJ(), Y = le.firstChild, ve = Y.nextSibling, xe = ve.nextSibling, Qe = xe.nextSibling, Fe = Qe.nextSibling, He = Fe.nextSibling, Ge = He.firstChild, Gt = t;
    return typeof Gt == "function" ? ze(Gt, le) : t = le, A(Y, Rt), A(ve, Ur), A(xe, qr), A(Qe, EJ), A(Fe, oi), A(le, b(X, {
      get when() {
        return L(() => !!(q() && E().length > 0))() && !M();
      },
      get children() {
        return b(AB, {
          get alerts() {
            return E();
          },
          get isOpen() {
            return q();
          },
          onIgnoreWarningAndCreateAnyway: () => {
            v(!1), V(!0), I(!1);
            const Ze = new CustomEvent("photon-clinical-alert-acknowledge", {
              composed: !0,
              bubbles: !0,
              detail: {
                alerts: E()
              }
            });
            Pe(), t?.dispatchEvent(Ze);
          },
          onRevisitPrescriptions: () => {
            v(!1), I(!1);
            const Ze = new CustomEvent("photon-clinical-alert-cancel", {
              composed: !0,
              bubbles: !0,
              detail: {
                alerts: E()
              }
            });
            t?.dispatchEvent(Ze);
          }
        });
      }
    }), He), A(le, b(X, {
      get when() {
        return e.enableCombineAndDuplicate;
      },
      get children() {
        return [b(vi.DuplicateDialog, {}), b(vi.CombineDialog, {}), b(vi.IssueDialog, {})];
      }
    }), He), A(He, b(rQ, {
      get buffer() {
        return e?.toastBuffer || 0;
      }
    }), Ge), A(Ge, b(X, {
      get when() {
        return L(() => !!(!u || g()))() && !w();
      },
      get children() {
        var Ze = OJ();
        return A(Ze, b(ni, {
          color: "green"
        })), Ze;
      }
    }), null), A(Ge, b(F8, {
      permissions: ["read:patient"],
      get children() {
        return b(pQ, {
          client: at,
          get children() {
            return [b(X, {
              get when() {
                return !z();
              },
              get children() {
                return b(U2, {
                  type: "warning",
                  header: "You do not have permission to prescribe",
                  message: "You have access to see the form but you will not be able to submit an order."
                });
              }
            }), b(xJ, {
              get actions() {
                return e.formActions;
              },
              get store() {
                return e.formStore;
              },
              get patientId() {
                return e.patientId;
              },
              client: u,
              get enableOrder() {
                return e.enableOrder;
              },
              get address() {
                return e.address;
              },
              get weight() {
                return e.weight;
              },
              get weightUnit() {
                return e.weightUnit;
              },
              get enableMedHistory() {
                return e.enableMedHistory;
              },
              get enableMedHistoryLinks() {
                return e.enableMedHistoryLinks ?? !1;
              },
              get enableMedHistoryRefillButton() {
                return e.enableMedHistoryRefillButton ?? !1;
              },
              get hidePatientCard() {
                return e.hidePatientCard;
              }
            }), b(X, {
              get when() {
                return (
                  // if patientId is passed in, we need to ensure it matches the patient id in our store
                  // so we are not referencing stale data
                  ft() && // if orders are enabled, we need a patient's address
                  (e.formStore.patient?.value?.address || // if orders are disabled, we need only a patient id
                  e.formStore.patient?.value?.id && !e.enableOrder)
                );
              },
              get children() {
                return [b(X, {
                  get when() {
                    return e.enableCombineAndDuplicate;
                  },
                  get children() {
                    return b(vi.Card, {});
                  }
                }), b(X, {
                  get when() {
                    return c() || m();
                  },
                  get children() {
                    var Ze = IJ(), Pr = Xe;
                    return typeof Pr == "function" ? ze(Pr, Ze) : Xe = Ze, A(Ze, b(aJ, {
                      get hideAddToTemplates() {
                        return e.hideTemplates;
                      },
                      get actions() {
                        return e.formActions;
                      },
                      get store() {
                        return e.formStore;
                      },
                      get weight() {
                        return e.weight;
                      },
                      get weightUnit() {
                        return e.weightUnit;
                      },
                      prefillNotes: P,
                      get enableCombineAndDuplicate() {
                        return e.enableCombineAndDuplicate;
                      },
                      screenDraftedPrescriptions: function() {
                        R();
                      },
                      draftedPrescriptionChanged: function() {
                        R();
                      },
                      onDraftPrescriptionCreated: bt,
                      get screeningAlerts() {
                        return E();
                      },
                      get catalogId() {
                        return e.catalogId;
                      },
                      get allowOffCatalogSearch() {
                        return e.allowOffCatalogSearch;
                      },
                      get enableOrder() {
                        return e.enableOrder;
                      },
                      get disableList() {
                        return e.disableList;
                      }
                    })), Ze;
                  }
                }), b(uJ, {
                  prescriptionRef: Xe,
                  get actions() {
                    return e.formActions;
                  },
                  get store() {
                    return e.formStore;
                  },
                  setIsEditing: $,
                  handleDraftPrescriptionsChange: function() {
                    R();
                  },
                  get screeningAlerts() {
                    return E();
                  },
                  get routingConstraints() {
                    return n();
                  },
                  get enableOrder() {
                    return e.enableOrder;
                  }
                }), b(X, {
                  get when() {
                    return L(() => !!e.enableOrder)() && !d();
                  },
                  get children() {
                    return b(pJ, {
                      get store() {
                        return e.formStore;
                      },
                      get actions() {
                        return e.formActions;
                      },
                      get enableLocalPickup() {
                        return e.enableLocalPickup;
                      },
                      get enableSendToPatient() {
                        return e.enableSendToPatient;
                      },
                      get enableDeliveryPharmacies() {
                        return e.enableDeliveryPharmacies;
                      },
                      get mailOrderIds() {
                        return e.mailOrderIds;
                      }
                    });
                  }
                }), b(X, {
                  get when() {
                    return L(() => !!e.enableOrder)() && d();
                  },
                  get children() {
                    return b(SJ, {
                      get pharmacyId() {
                        return d();
                      }
                    });
                  }
                }), b(X, {
                  get when() {
                    return !e.hideSubmit;
                  },
                  get children() {
                    return [b(X, {
                      get when() {
                        return f().length > 0 && e.enableOrder;
                      },
                      get children() {
                        var Ze = PJ();
                        return A(Ze, b(kt, {
                          get each() {
                            return f();
                          },
                          get fallback() {
                            return NJ();
                          },
                          children: ({
                            key: Pr,
                            error: zs
                          }) => b(U2, {
                            type: "warning",
                            header: `Error with ${Pr}`,
                            message: zs
                          })
                        })), Ze;
                      }
                    }), (() => {
                      var Ze = DJ();
                      return A(Ze, b(X, {
                        get when() {
                          return !c();
                        },
                        get children() {
                          return b(st, {
                            variant: "secondary",
                            onClick: () => h(!0),
                            children: "Add Prescription"
                          });
                        }
                      }), null), A(Ze, b(st, {
                        get loading() {
                          return o() || g();
                        },
                        onClick: Pe,
                        get children() {
                          return e.enableOrder ? "Send order" : "Save prescriptions";
                        }
                      }), null), Ze;
                    })()];
                  }
                })];
              }
            })];
          }
        });
      }
    }), null), le;
  })();
}
const RJ = (e) => ({
  dispenseAsWritten: e.dispenseAsWritten || void 0,
  dispenseQuantity: e.dispenseQuantity,
  dispenseUnit: e.dispenseUnit,
  fillsAllowed: e.fillsAllowed,
  daysSupply: e.daysSupply || void 0,
  instructions: e.instructions,
  notes: e.notes || void 0,
  effectiveDate: e.effectiveDate,
  treatment: {
    id: e.treatment.id
  }
}), zJ = (e) => {
  const {
    actions: t
  } = _d, {
    store: r,
    actions: n
  } = M8({
    dispenseAsWritten: !1,
    patient: void 0,
    treatment: void 0,
    pharmacy: void 0,
    errors: [],
    address: void 0
  });
  return xr(() => {
    t.clearSelectedPatient(), n.reset();
  }), b(gj, {
    get children() {
      return b(vi, {
        get patientId() {
          return r.patient?.value?.id;
        },
        get children() {
          return b(tB, {
            get templateIdsPrefill() {
              return e.templateIds?.split(",").map((i) => i.trim()) || [];
            },
            get templateOverrides() {
              return e.templateOverrides || {};
            },
            get prescriptionIdsPrefill() {
              return e.prescriptionIds?.split(",").map((i) => i.trim()) || [];
            },
            get patientId() {
              return r.patient?.value?.id;
            },
            get enableCombineAndDuplicate() {
              return e.enableCombineAndDuplicate;
            },
            get enableCoverageCheck() {
              return e.enableCoverageCheck;
            },
            get children() {
              return b(FJ, {
                get patientId() {
                  return e.patientId;
                },
                get templateIds() {
                  return e.templateIds;
                },
                get templateOverrides() {
                  return e.templateOverrides;
                },
                get prescriptionIds() {
                  return e.prescriptionIds;
                },
                get hideSubmit() {
                  return e.hideSubmit;
                },
                get hideTemplates() {
                  return e.hideTemplates;
                },
                get hidePatientCard() {
                  return e.hidePatientCard;
                },
                get enableOrder() {
                  return e.enableOrder;
                },
                get enableLocalPickup() {
                  return e.enableLocalPickup;
                },
                get enableSendToPatient() {
                  return e.enableSendToPatient;
                },
                get enableDeliveryPharmacies() {
                  return e.enableDeliveryPharmacies;
                },
                get enableMedHistory() {
                  return e.enableMedHistory;
                },
                get enableMedHistoryLinks() {
                  return e.enableMedHistoryLinks;
                },
                get enableMedHistoryRefillButton() {
                  return e.enableMedHistoryRefillButton;
                },
                get enableCombineAndDuplicate() {
                  return e.enableCombineAndDuplicate;
                },
                get enableCoverageCheck() {
                  return e.enableCoverageCheck;
                },
                get mailOrderIds() {
                  return e.mailOrderIds;
                },
                get pharmacyId() {
                  return e.pharmacyId;
                },
                get loading() {
                  return e.loading;
                },
                get address() {
                  return e.address;
                },
                get weight() {
                  return e.weight;
                },
                get weightUnit() {
                  return e.weightUnit;
                },
                get additionalNotes() {
                  return e.additionalNotes;
                },
                get triggerSubmit() {
                  return e.triggerSubmit;
                },
                get toastBuffer() {
                  return e.toastBuffer;
                },
                formStore: r,
                formActions: n,
                get externalOrderId() {
                  return e.externalOrderId;
                },
                get catalogId() {
                  return e.catalogId;
                },
                get allowOffCatalogSearch() {
                  return e.allowOffCatalogSearch;
                },
                get disableList() {
                  return e.disableList;
                },
                get groupId() {
                  return e.groupId;
                }
              });
            }
          });
        }
      });
    }
  });
};
Tt("photon-prescribe-workflow", {
  patientId: void 0,
  templateIds: void 0,
  templateOverrides: void 0,
  prescriptionIds: void 0,
  hideSubmit: !1,
  hideTemplates: !1,
  hidePatientCard: !1,
  enableOrder: !1,
  enableLocalPickup: !1,
  enableSendToPatient: !1,
  enableDeliveryPharmacies: !0,
  enableCombineAndDuplicate: !1,
  enableMedHistory: !1,
  enableMedHistoryRefillButton: !1,
  enableMedHistoryLinks: !1,
  mailOrderIds: void 0,
  pharmacyId: void 0,
  loading: !1,
  address: void 0,
  weight: void 0,
  weightUnit: "lbs",
  additionalNotes: void 0,
  triggerSubmit: !1,
  setTriggerSubmit: void 0,
  toastBuffer: 0,
  externalOrderId: void 0,
  catalogId: void 0,
  allowOffCatalogSearch: !0,
  enableCoverageCheck: !1,
  disableList: void 0,
  groupId: void 0
}, zJ);
var jJ = /* @__PURE__ */ K('<p class="font-sans text-l font-medium mb-2">'), VJ = /* @__PURE__ */ K("<sl-icon-button class=self-start>", !0, !1, !1), UJ = /* @__PURE__ */ K("<style>"), qJ = /* @__PURE__ */ K('<div class="rounded-lg bg-white p-4 shadow-card border border-gray-200">'), BJ = /* @__PURE__ */ K('<div class="flex flex-row justify-between">'), HJ = /* @__PURE__ */ K("<slot>");
const WJ = (e) => {
  const [t, r] = H(!0);
  let n = null, i = null;
  return e.title && (n = (() => {
    var a = jJ();
    return A(a, () => e.title), a;
  })()), e.collapsable && (i = (() => {
    var a = VJ();
    return ce(a, "click", () => {
      r(!t());
    }), a._$owner = fe(), J(() => a.name = t() ? "chevron-right" : "chevron-down"), a;
  })()), [(() => {
    var a = UJ();
    return A(a, Rt), a;
  })(), (() => {
    var a = qJ();
    return A(a, n || i ? (() => {
      var o = BJ();
      return A(o, n, null), A(o, i, null), o;
    })() : null, null), A(a, (() => {
      var o = L(() => !!(e.collapsable && t()));
      return () => o() ? null : (() => {
        var s = HJ();
        return s._$owner = fe(), s;
      })();
    })(), null), J((o) => {
      var s = !!e.invalid, l = !!e.invalid;
      return s !== o.e && a.classList.toggle("border-red-400", o.e = s), l !== o.t && a.classList.toggle("border-2", o.t = l), o;
    }, {
      e: void 0,
      t: void 0
    }), a;
  })()];
};
Tt("photon-card", {
  invalid: !1,
  title: null,
  collapsable: !1
}, WJ);
const QJ = Ce`
  fragment CatalogFields on Catalog {
    id
  }
`, GJ = { CatalogFields: QJ }, YJ = Ce`
  fragment CatalogTreatmentsFields on Catalog {
    id
    treatments {
      id
      name
    }
    templates {
      id
      name
      daysSupply
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      instructions
      notes
      fillsAllowed
      treatment {
        id
        name
      }
      isPrivate
    }
  }
`, KJ = { CatalogTreatmentsFields: YJ }, ZJ = () => {
  const [e, t] = Ls({
    catalogs: {
      data: [],
      errors: [],
      isLoading: !1
    },
    catalog: {
      data: void 0,
      errors: [],
      isLoading: !1
    }
  });
  return {
    store: e,
    actions: {
      getCatalogs: async (i) => {
        t("catalogs", {
          ...e.catalogs,
          isLoading: !0
        });
        const { data: a, errors: o } = await i.clinical.catalog.getCatalogs({
          fragment: GJ
        });
        t("catalogs", {
          ...e.catalogs,
          isLoading: !1,
          data: a.catalogs,
          errors: o
        });
      },
      getCatalog: async (i, a) => {
        t("catalog", {
          ...e.catalog,
          isLoading: !0
        });
        const { data: o, errors: s } = await i.clinical.catalog.getCatalog({
          id: a,
          fragment: KJ
        });
        t("catalog", {
          ...e.catalog,
          isLoading: !1,
          data: o.catalog,
          errors: s
        });
      }
    }
  };
}, _p = ZJ();
var XJ = /* @__PURE__ */ K("<div>"), JJ = /* @__PURE__ */ K('<p class="text-sm whitespace-normal leading-snug my-1">'), eee = /* @__PURE__ */ K('<div class=my-1><div class="text-sm whitespace-normal leading-snug"></div><p class="text-xs text-gray-500 overflow-hidden whitespace-nowrap overflow-ellipsis">QTY: <!> <!> | Days Supply: <!> | Refills: <!> | Sig: '), tee = /* @__PURE__ */ K("<span class=font-bold>: ");
const ree = (e) => {
  let t;
  const r = Xr(), {
    store: n,
    actions: i
  } = _p, [a, o] = H("");
  Et(async () => {
    await i.getCatalogs(r.getSDK());
  });
  const s = (h) => {
    const f = new CustomEvent("photon-treatment-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        data: h,
        catalogId: n.catalogs.data[0]?.id || ""
      }
    });
    t?.dispatchEvent(f);
  }, l = (h) => {
    if (n.catalogs.data.length > 0) {
      const f = [...e.offCatalogOption ? [e.offCatalogOption] : [], ...n.catalogs.data[0].templates.map((g) => g), ...n.catalogs.data[0].treatments.map((g) => g)];
      return h.length === 0 ? f : f.filter((g) => "treatment" in g ? g.treatment.name.toLowerCase().includes(h.toLowerCase()) || g.name?.toLowerCase().includes(h.toLowerCase()) : g.name.toLowerCase().includes(h.toLowerCase()));
    }
    return [];
  }, d = async () => o(""), u = async (h) => o(h), c = L(() => l(a()));
  return (() => {
    var h = XJ();
    ce(h, "photon-data-selected", (p) => {
      s(p.detail.data);
    });
    var f = t;
    return typeof f == "function" ? ze(f, h) : t = h, A(h, b(lo, {
      get data() {
        return c();
      },
      groups: [{
        label: "Off Catalog",
        filter: (p) => p && typeof p == "object" && e.offCatalogOption && p.id === e.offCatalogOption.id
      }, {
        label: "Personal Templates",
        filter: (p) => p && typeof p == "object" && "treatment" in p && p.isPrivate
      }, {
        label: "Organization Templates",
        filter: (p) => p && typeof p == "object" && "treatment" in p && !p.isPrivate
      }, {
        label: "Catalog",
        filter: (p) => p && typeof p == "object" && "name" in p && !("treatment" in p)
      }],
      get label() {
        return e.label;
      },
      get disabled() {
        return e.disabled;
      },
      get required() {
        return e.required;
      },
      placeholder: "Select a treatment...",
      get invalid() {
        return e.invalid;
      },
      get isLoading() {
        return n.catalogs.isLoading;
      },
      hasMore: !1,
      get selectedData() {
        return e.selected ?? e.offCatalogOption;
      },
      displayAccessor: (p, g) => p?.__typename !== "PrescriptionTemplate" ? g ? (() => {
        var v = JJ();
        return A(v, () => p.name), v;
      })() : p?.name || "" : g ? (() => {
        var v = eee(), m = v.firstChild, $ = m.nextSibling, w = $.firstChild, k = w.nextSibling, C = k.nextSibling, E = C.nextSibling, N = E.nextSibling, M = N.nextSibling, V = M.nextSibling, q = V.nextSibling;
        return q.nextSibling, A(m, (() => {
          var I = L(() => !!p?.name);
          return () => I() ? (() => {
            var P = tee(), z = P.firstChild;
            return A(P, () => p.name, z), P;
          })() : "";
        })(), null), A(m, () => p.treatment.name, null), A($, () => p.dispenseQuantity, k), A($, () => p.dispenseUnit, E), A($, () => p.daysSupply, M), A($, () => p.fillsAllowed ? p.fillsAllowed - 1 : 0, q), A($, () => p.instructions, null), v;
      })() : p.treatment.name,
      onSearchChange: u,
      onHide: d,
      get helpText() {
        return e.helpText;
      }
    })), h;
  })();
};
Tt("photon-treatment-select", {
  label: void 0,
  required: !1,
  invalid: !1,
  helpText: void 0,
  catalogId: void 0,
  disabled: !1,
  formName: void 0,
  selected: void 0,
  offCatalogOption: void 0
}, ree);
var nee = gr`
  :host {
    display: inline-block;
  }

  .checkbox {
    position: relative;
    display: inline-flex;
    align-items: flex-start;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .checkbox--small {
    --toggle-size: var(--sl-toggle-size-small);
    font-size: var(--sl-input-font-size-small);
  }

  .checkbox--medium {
    --toggle-size: var(--sl-toggle-size-medium);
    font-size: var(--sl-input-font-size-medium);
  }

  .checkbox--large {
    --toggle-size: var(--sl-toggle-size-large);
    font-size: var(--sl-input-font-size-large);
  }

  .checkbox__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--toggle-size);
    height: var(--toggle-size);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
    border-radius: 2px;
    background-color: var(--sl-input-background-color);
    color: var(--sl-color-neutral-0);
    transition:
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) box-shadow;
  }

  .checkbox__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  .checkbox__checked-icon,
  .checkbox__indeterminate-icon {
    display: inline-flex;
    width: var(--toggle-size);
    height: var(--toggle-size);
  }

  /* Hover */
  .checkbox:not(.checkbox--checked):not(.checkbox--disabled) .checkbox__control:hover {
    border-color: var(--sl-input-border-color-hover);
    background-color: var(--sl-input-background-color-hover);
  }

  /* Focus */
  .checkbox:not(.checkbox--checked):not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Checked/indeterminate */
  .checkbox--checked .checkbox__control,
  .checkbox--indeterminate .checkbox__control {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
  }

  /* Checked/indeterminate + hover */
  .checkbox.checkbox--checked:not(.checkbox--disabled) .checkbox__control:hover,
  .checkbox.checkbox--indeterminate:not(.checkbox--disabled) .checkbox__control:hover {
    border-color: var(--sl-color-primary-500);
    background-color: var(--sl-color-primary-500);
  }

  /* Checked/indeterminate + focus */
  .checkbox.checkbox--checked:not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control,
  .checkbox.checkbox--indeterminate:not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .checkbox--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .checkbox__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    line-height: var(--toggle-size);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }

  :host([required]) .checkbox__label::after {
    content: var(--sl-input-required-content);
    color: var(--sl-input-required-content-color);
    margin-inline-start: var(--sl-input-required-content-offset);
  }
`, vr = class extends ar {
  constructor() {
    super(...arguments), this.formControlController = new kd(this, {
      value: (e) => e.checked ? e.value || "on" : void 0,
      defaultValue: (e) => e.defaultChecked,
      setValue: (e, t) => e.checked = t
    }), this.hasSlotController = new ha(this, "help-text"), this.hasFocus = !1, this.title = "", this.name = "", this.size = "medium", this.disabled = !1, this.checked = !1, this.indeterminate = !1, this.defaultChecked = !1, this.form = "", this.required = !1, this.helpText = "";
  }
  /** Gets the validity state object */
  get validity() {
    return this.input.validity;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.input.validationMessage;
  }
  firstUpdated() {
    this.formControlController.updateValidity();
  }
  handleClick() {
    this.checked = !this.checked, this.indeterminate = !1, this.emit("sl-change");
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleInput() {
    this.emit("sl-input");
  }
  handleInvalid(e) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(e);
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleDisabledChange() {
    this.formControlController.setValidity(this.disabled);
  }
  handleStateChange() {
    this.input.checked = this.checked, this.input.indeterminate = this.indeterminate, this.formControlController.updateValidity();
  }
  /** Simulates a click on the checkbox. */
  click() {
    this.input.click();
  }
  /** Sets focus on the checkbox. */
  focus(e) {
    this.input.focus(e);
  }
  /** Removes focus from the checkbox. */
  blur() {
    this.input.blur();
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.input.checkValidity();
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return this.input.reportValidity();
  }
  /**
   * Sets a custom validation message. The value provided will be shown to the user when the form is submitted. To clear
   * the custom validation message, call this method with an empty string.
   */
  setCustomValidity(e) {
    this.input.setCustomValidity(e), this.formControlController.updateValidity();
  }
  render() {
    const e = this.hasSlotController.test("help-text"), t = this.helpText ? !0 : !!e;
    return xt`
      <div
        class=${dr({
      "form-control": !0,
      "form-control--small": this.size === "small",
      "form-control--medium": this.size === "medium",
      "form-control--large": this.size === "large",
      "form-control--has-help-text": t
    })}
      >
        <label
          part="base"
          class=${dr({
      checkbox: !0,
      "checkbox--checked": this.checked,
      "checkbox--disabled": this.disabled,
      "checkbox--focused": this.hasFocus,
      "checkbox--indeterminate": this.indeterminate,
      "checkbox--small": this.size === "small",
      "checkbox--medium": this.size === "medium",
      "checkbox--large": this.size === "large"
    })}
        >
          <input
            class="checkbox__input"
            type="checkbox"
            title=${this.title}
            name=${this.name}
            value=${Me(this.value)}
            .indeterminate=${rd(this.indeterminate)}
            .checked=${rd(this.checked)}
            .disabled=${this.disabled}
            .required=${this.required}
            aria-checked=${this.checked ? "true" : "false"}
            aria-describedby="help-text"
            @click=${this.handleClick}
            @input=${this.handleInput}
            @invalid=${this.handleInvalid}
            @blur=${this.handleBlur}
            @focus=${this.handleFocus}
          />

          <span
            part="control${this.checked ? " control--checked" : ""}${this.indeterminate ? " control--indeterminate" : ""}"
            class="checkbox__control"
          >
            ${this.checked ? xt`
                  <sl-icon part="checked-icon" class="checkbox__checked-icon" library="system" name="check"></sl-icon>
                ` : ""}
            ${!this.checked && this.indeterminate ? xt`
                  <sl-icon
                    part="indeterminate-icon"
                    class="checkbox__indeterminate-icon"
                    library="system"
                    name="indeterminate"
                  ></sl-icon>
                ` : ""}
          </span>

          <div part="label" class="checkbox__label">
            <slot></slot>
          </div>
        </label>

        <div
          aria-hidden=${t ? "false" : "true"}
          class="form-control__help-text"
          id="help-text"
          part="form-control-help-text"
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
  }
};
vr.styles = [Ar, d0, nee];
vr.dependencies = { "sl-icon": Vr };
O([
  jt('input[type="checkbox"]')
], vr.prototype, "input", 2);
O([
  Fn()
], vr.prototype, "hasFocus", 2);
O([
  U()
], vr.prototype, "title", 2);
O([
  U()
], vr.prototype, "name", 2);
O([
  U()
], vr.prototype, "value", 2);
O([
  U({ reflect: !0 })
], vr.prototype, "size", 2);
O([
  U({ type: Boolean, reflect: !0 })
], vr.prototype, "disabled", 2);
O([
  U({ type: Boolean, reflect: !0 })
], vr.prototype, "checked", 2);
O([
  U({ type: Boolean, reflect: !0 })
], vr.prototype, "indeterminate", 2);
O([
  l0("checked")
], vr.prototype, "defaultChecked", 2);
O([
  U({ reflect: !0 })
], vr.prototype, "form", 2);
O([
  U({ type: Boolean, reflect: !0 })
], vr.prototype, "required", 2);
O([
  U({ attribute: "help-text" })
], vr.prototype, "helpText", 2);
O([
  Nt("disabled", { waitUntilFirstUpdate: !0 })
], vr.prototype, "handleDisabledChange", 1);
O([
  Nt(["checked", "indeterminate"], { waitUntilFirstUpdate: !0 })
], vr.prototype, "handleStateChange", 1);
vr.define("sl-checkbox");
var D1 = /* @__PURE__ */ K("<style>"), iee = /* @__PURE__ */ K('<div class="flex items-start py-2"><div class=cursor-pointer><p class="flex items-center text-gray-500 text-sm font-medium font-sans"><span class=mr-1> </span></p><p class="text-gray-400 text-xs font-sans">'), aee = /* @__PURE__ */ K("<sl-checkbox checked>", !0, !1, !1), oee = /* @__PURE__ */ K("<sl-checkbox>", !0, !1, !1);
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const see = (e) => {
  const [t, r] = H(!1);
  let n;
  const i = (a) => {
    const o = new CustomEvent("photon-checkbox-toggled", {
      composed: !0,
      bubbles: !0,
      detail: {
        checked: a
      }
    });
    n?.dispatchEvent(o);
  };
  return Et(() => {
    r(e.checked), i(t());
  }), me(() => {
    e.checked !== t() && r(e.checked);
  }), [(() => {
    var a = D1();
    return A(a, Rt), a;
  })(), (() => {
    var a = D1();
    return A(a, Ur), a;
  })(), (() => {
    var a = D1();
    return A(a, qr), a;
  })(), (() => {
    var a = iee(), o = a.firstChild, s = o.firstChild, l = s.firstChild, d = l.firstChild, u = s.nextSibling;
    return A(a, (() => {
      var c = L(() => !!e.checked);
      return () => c() ? (() => {
        var h = aee();
        ce(h, "sl-change", () => {
          i(!t()), r(!t());
        });
        var f = n;
        return typeof f == "function" ? ze(f, h) : n = h, h._$owner = fe(), J(() => h.disabled = e.disabled), h;
      })() : (() => {
        var h = oee();
        ce(h, "sl-change", () => {
          i(!t()), r(!t());
        });
        var f = n;
        return typeof f == "function" ? ze(f, h) : n = h, h._$owner = fe(), J(() => h.disabled = e.disabled), h;
      })();
    })(), o), o.$$click = () => {
      i(!t()), r(!t());
    }, A(l, () => e.label, d), A(s, b(X, {
      get when() {
        return e.tip;
      },
      get children() {
        return b(ty, {
          get tip() {
            return e.tip || "";
          },
          placement: "right"
        });
      }
    }), null), A(u, () => e.required ? "Required" : "Optional"), a;
  })()];
};
Tt("photon-checkbox", {
  label: void 0,
  required: !1,
  disabled: !1,
  checked: !1,
  tip: void 0
}, see);
da(["click"]);
const lee = '.input::part(base){border-radius:var(--photon-border-radius, .5rem)}.invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.invalid::part(form-control-help-text){--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity));font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";padding-top:.5rem}.input{--sl-input-required-content-color: #f87171;--sl-input-label-font-size-medium: .875rem;--sl-input-label-color: #374151}.input::part(form-control-label){padding-bottom:.5rem}';
function dee(e) {
  const t = e.split(/[/\s-]/);
  if (t.length !== 3)
    return "";
  const [r, n, i] = t.map((a) => parseInt(a));
  return isNaN(r) || isNaN(n) || isNaN(i) || r < 1 || r > 12 || n < 1 || n > 31 ? "" : `${i}-${r.toString().padStart(2, "0")}-${n.toString().padStart(2, "0")}`;
}
var iu = /* @__PURE__ */ K("<style>"), uee = /* @__PURE__ */ K('<div class="md:py-2 flex flex-col"><sl-input class=input type=date><p slot=help-text class="text-sm text-red-400 pt-1 h-[21px] font-sans">', !0, !1, !1);
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const cee = (e) => {
  let t, r;
  const n = e?.noInitialDate ? "" : h0(/* @__PURE__ */ new Date(), "yyyy-MM-dd").toString(), [i, a] = H(e?.value || n), o = (s) => {
    const l = new CustomEvent("photon-datepicker-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        date: s
      }
    });
    t?.dispatchEvent(l);
  };
  return Et(() => {
    o(i()), r?.addEventListener("paste", (s) => {
      const l = s.clipboardData.getData("Text"), d = dee(l);
      d && (a(d), o(d));
    });
  }), [(() => {
    var s = iu();
    return A(s, Rt), s;
  })(), (() => {
    var s = iu();
    return A(s, Ur), s;
  })(), (() => {
    var s = iu();
    return A(s, qr), s;
  })(), (() => {
    var s = iu();
    return A(s, lee), s;
  })(), (() => {
    var s = uee(), l = s.firstChild, d = l.firstChild, u = t;
    typeof u == "function" ? ze(u, s) : t = s, ce(l, "sl-input", (h) => {
      o(h.target.value);
    });
    var c = r;
    return typeof c == "function" ? ze(c, l) : r = l, l._$owner = fe(), A(d, () => e.helpText), J((h) => {
      var f = e.label, p = e.required, g = e.disabled, v = !!e.invalid, m = e.invalid;
      return f !== h.e && (l.label = h.e = f), p !== h.t && (l.required = h.t = p), g !== h.a && (l.disabled = h.a = g), v !== h.o && l.classList.toggle("invalid", h.o = v), m !== h.i && (l.invalid = h.i = m), h;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0
    }), J(() => l.value = i()), s;
  })()];
};
Tt("photon-datepicker", {
  label: void 0,
  required: !1,
  invalid: !1,
  helpText: void 0,
  disabled: !1,
  value: void 0,
  noInitialDate: void 0
}, cee);
const hee = ".input::part(base){border-radius:var(--photon-border-radius, .5rem)}.invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.invalid::part(form-control-help-text){--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}";
var au = /* @__PURE__ */ K("<style>"), fee = /* @__PURE__ */ K('<div class="flex flex-col font-sans"><sl-input class=input type=number><p slot=help-text class="text-red-400 pt-1 h-[21px] font-sans">', !0, !1, !1), pee = /* @__PURE__ */ K('<div class="flex items-center pb-2"><p class="text-gray-700 text-sm">'), mee = /* @__PURE__ */ K('<p class="pl-1 text-red-400">*');
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const gee = (e) => {
  let t;
  const r = (n) => {
    const i = new CustomEvent("photon-input-changed", {
      composed: !0,
      bubbles: !0,
      detail: {
        input: n
      }
    });
    t?.dispatchEvent(i);
  };
  return [(() => {
    var n = au();
    return A(n, Rt), n;
  })(), (() => {
    var n = au();
    return A(n, Ur), n;
  })(), (() => {
    var n = au();
    return A(n, qr), n;
  })(), (() => {
    var n = au();
    return A(n, hee), n;
  })(), (() => {
    var n = fee(), i = n.firstChild, a = i.firstChild, o = t;
    return typeof o == "function" ? ze(o, n) : t = n, A(n, (() => {
      var s = L(() => !!e.label);
      return () => s() ? (() => {
        var l = pee(), d = l.firstChild;
        return A(d, () => e.label), A(l, (() => {
          var u = L(() => !!e.required);
          return () => u() ? mee() : null;
        })(), null), l;
      })() : null;
    })(), i), ce(i, "wheel", (s) => {
      s.preventDefault(), s.stopPropagation(), s.stopImmediatePropagation();
    }), ce(i, "sl-input", (s) => {
      r(s.target.value);
    }), i._$owner = fe(), A(a, () => e.helpText), J((s) => {
      var l = !!e.invalid, d = e.disabled, u = e.min, c = e.max, h = e.invalid;
      return l !== s.e && i.classList.toggle("invalid", s.e = l), d !== s.t && (i.disabled = s.t = d), u !== s.a && (i.min = s.a = u), c !== s.o && (i.max = s.o = c), h !== s.i && (i.invalid = s.i = h), s;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0
    }), J(() => i.value = e.value), n;
  })()];
};
Tt("photon-number-input", {
  label: void 0,
  required: !1,
  value: void 0,
  formName: void 0,
  min: void 0,
  max: void 0,
  invalid: !1,
  helpText: void 0,
  disabled: !1
}, gee);
const vee = () => {
  const [e, t] = Ls({
    dispenseUnits: {
      data: [],
      errors: [],
      isLoading: !1
    }
  });
  return {
    store: e,
    actions: {
      getDispenseUnits: async (n) => {
        t("dispenseUnits", {
          ...e.dispenseUnits,
          isLoading: !0
        });
        const { data: i, errors: a } = await n.clinical.prescription.getDispenseUnits();
        t("dispenseUnits", {
          ...e.dispenseUnits,
          isLoading: !1,
          data: i.dispenseUnits.map((o, s) => ({
            id: s.toString(),
            ...o
          })),
          errors: a
        });
      }
    }
  };
}, yee = vee();
var bee = /* @__PURE__ */ K("<div>");
const $ee = (e) => {
  let t;
  const r = Xr(), {
    store: n,
    actions: i
  } = yee, [a, o] = H(""), s = (d) => {
    const u = new CustomEvent("photon-dispense-unit-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        dispenseUnit: {
          name: d.name
        }
      }
    });
    t?.dispatchEvent(u);
  };
  Et(async () => {
    await i.getDispenseUnits(r.getSDK());
  });
  const l = (d) => {
    if (n.dispenseUnits.data.length > 0) {
      const u = n.dispenseUnits.data;
      return d.length === 0 ? u : u.filter((c) => c.name.toLowerCase().includes(d.toLowerCase()));
    }
    return [];
  };
  return (() => {
    var d = bee();
    ce(d, "photon-data-selected", (c) => {
      s(c.detail.data);
    });
    var u = t;
    return typeof u == "function" ? ze(u, d) : t = d, A(d, b(lo, {
      get data() {
        return l(a());
      },
      get label() {
        return e.label;
      },
      get disabled() {
        return e.disabled;
      },
      get required() {
        return e.required;
      },
      get forceLabelSize() {
        return e.forceLabelSize;
      },
      placeholder: "Select a dispense unit...",
      get invalid() {
        return e.invalid;
      },
      get isLoading() {
        return r?.clinical.dispenseUnits.state.isLoading || !1;
      },
      hasMore: !1,
      get selectedData() {
        return L(() => !!e.selected)() ? n.dispenseUnits.data?.filter((c) => c.name === e.selected)[0] : void 0;
      },
      displayAccessor: (c) => c?.name || "",
      onSearchChange: async (c) => {
        o(c);
      },
      onHide: async () => {
        o("");
      },
      noDataMsg: "No dispense units found",
      get helpText() {
        return e.helpText;
      }
    })), d;
  })();
};
Tt("photon-dispense-units", {
  label: void 0,
  required: !1,
  invalid: !1,
  helpText: void 0,
  formName: void 0,
  disabled: !1,
  forceLabelSize: !1,
  selected: void 0
}, $ee);
var wee = gr`
  :host {
    display: block;
  }

  .textarea {
    display: grid;
    align-items: center;
    position: relative;
    width: 100%;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    line-height: var(--sl-line-height-normal);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    transition:
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) border,
      var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
    cursor: text;
  }

  /* Standard textareas */
  .textarea--standard {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .textarea--standard:hover:not(.textarea--disabled) {
    background-color: var(--sl-input-background-color-hover);
    border-color: var(--sl-input-border-color-hover);
  }
  .textarea--standard:hover:not(.textarea--disabled) .textarea__control {
    color: var(--sl-input-color-hover);
  }

  .textarea--standard.textarea--focused:not(.textarea--disabled) {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    color: var(--sl-input-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  .textarea--standard.textarea--focused:not(.textarea--disabled) .textarea__control {
    color: var(--sl-input-color-focus);
  }

  .textarea--standard.textarea--disabled {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .textarea__control,
  .textarea__size-adjuster {
    grid-area: 1 / 1 / 2 / 2;
  }

  .textarea__size-adjuster {
    visibility: hidden;
    pointer-events: none;
    opacity: 0;
  }

  .textarea--standard.textarea--disabled .textarea__control {
    color: var(--sl-input-color-disabled);
  }

  .textarea--standard.textarea--disabled .textarea__control::placeholder {
    color: var(--sl-input-placeholder-color-disabled);
  }

  /* Filled textareas */
  .textarea--filled {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .textarea--filled:hover:not(.textarea--disabled) {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .textarea--filled.textarea--focused:not(.textarea--disabled) {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .textarea--filled.textarea--disabled {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .textarea__control {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: 1.4;
    color: var(--sl-input-color);
    border: none;
    background: none;
    box-shadow: none;
    cursor: inherit;
    -webkit-appearance: none;
  }

  .textarea__control::-webkit-search-decoration,
  .textarea__control::-webkit-search-cancel-button,
  .textarea__control::-webkit-search-results-button,
  .textarea__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .textarea__control::placeholder {
    color: var(--sl-input-placeholder-color);
    user-select: none;
    -webkit-user-select: none;
  }

  .textarea__control:focus {
    outline: none;
  }

  /*
   * Size modifiers
   */

  .textarea--small {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
  }

  .textarea--small .textarea__control {
    padding: 0.5em var(--sl-input-spacing-small);
  }

  .textarea--medium {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
  }

  .textarea--medium .textarea__control {
    padding: 0.5em var(--sl-input-spacing-medium);
  }

  .textarea--large {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
  }

  .textarea--large .textarea__control {
    padding: 0.5em var(--sl-input-spacing-large);
  }

  /*
   * Resize types
   */

  .textarea--resize-none .textarea__control {
    resize: none;
  }

  .textarea--resize-vertical .textarea__control {
    resize: vertical;
  }

  .textarea--resize-auto .textarea__control {
    height: auto;
    resize: none;
    overflow-y: hidden;
  }
`, ht = class extends ar {
  constructor() {
    super(...arguments), this.formControlController = new kd(this, {
      assumeInteractionOn: ["sl-blur", "sl-input"]
    }), this.hasSlotController = new ha(this, "help-text", "label"), this.hasFocus = !1, this.title = "", this.name = "", this.value = "", this.size = "medium", this.filled = !1, this.label = "", this.helpText = "", this.placeholder = "", this.rows = 4, this.resize = "vertical", this.disabled = !1, this.readonly = !1, this.form = "", this.required = !1, this.spellcheck = !0, this.defaultValue = "";
  }
  /** Gets the validity state object */
  get validity() {
    return this.input.validity;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.input.validationMessage;
  }
  connectedCallback() {
    super.connectedCallback(), this.resizeObserver = new ResizeObserver(() => this.setTextareaHeight()), this.updateComplete.then(() => {
      this.setTextareaHeight(), this.resizeObserver.observe(this.input);
    });
  }
  firstUpdated() {
    this.formControlController.updateValidity();
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), this.input && ((e = this.resizeObserver) == null || e.unobserve(this.input));
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleChange() {
    this.value = this.input.value, this.setTextareaHeight(), this.emit("sl-change");
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleInput() {
    this.value = this.input.value, this.emit("sl-input");
  }
  handleInvalid(e) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(e);
  }
  setTextareaHeight() {
    this.resize === "auto" ? (this.sizeAdjuster.style.height = `${this.input.clientHeight}px`, this.input.style.height = "auto", this.input.style.height = `${this.input.scrollHeight}px`) : this.input.style.height = "";
  }
  handleDisabledChange() {
    this.formControlController.setValidity(this.disabled);
  }
  handleRowsChange() {
    this.setTextareaHeight();
  }
  async handleValueChange() {
    await this.updateComplete, this.formControlController.updateValidity(), this.setTextareaHeight();
  }
  /** Sets focus on the textarea. */
  focus(e) {
    this.input.focus(e);
  }
  /** Removes focus from the textarea. */
  blur() {
    this.input.blur();
  }
  /** Selects all the text in the textarea. */
  select() {
    this.input.select();
  }
  /** Gets or sets the textarea's scroll position. */
  scrollPosition(e) {
    if (e) {
      typeof e.top == "number" && (this.input.scrollTop = e.top), typeof e.left == "number" && (this.input.scrollLeft = e.left);
      return;
    }
    return {
      top: this.input.scrollTop,
      left: this.input.scrollTop
    };
  }
  /** Sets the start and end positions of the text selection (0-based). */
  setSelectionRange(e, t, r = "none") {
    this.input.setSelectionRange(e, t, r);
  }
  /** Replaces a range of text with a new string. */
  setRangeText(e, t, r, n = "preserve") {
    const i = t ?? this.input.selectionStart, a = r ?? this.input.selectionEnd;
    this.input.setRangeText(e, i, a, n), this.value !== this.input.value && (this.value = this.input.value, this.setTextareaHeight());
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.input.checkValidity();
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return this.input.reportValidity();
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(e) {
    this.input.setCustomValidity(e), this.formControlController.updateValidity();
  }
  render() {
    const e = this.hasSlotController.test("label"), t = this.hasSlotController.test("help-text"), r = this.label ? !0 : !!e, n = this.helpText ? !0 : !!t;
    return xt`
      <div
        part="form-control"
        class=${dr({
      "form-control": !0,
      "form-control--small": this.size === "small",
      "form-control--medium": this.size === "medium",
      "form-control--large": this.size === "large",
      "form-control--has-label": r,
      "form-control--has-help-text": n
    })}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${r ? "false" : "true"}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${dr({
      textarea: !0,
      "textarea--small": this.size === "small",
      "textarea--medium": this.size === "medium",
      "textarea--large": this.size === "large",
      "textarea--standard": !this.filled,
      "textarea--filled": this.filled,
      "textarea--disabled": this.disabled,
      "textarea--focused": this.hasFocus,
      "textarea--empty": !this.value,
      "textarea--resize-none": this.resize === "none",
      "textarea--resize-vertical": this.resize === "vertical",
      "textarea--resize-auto": this.resize === "auto"
    })}
          >
            <textarea
              part="textarea"
              id="input"
              class="textarea__control"
              title=${this.title}
              name=${Me(this.name)}
              .value=${rd(this.value)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${Me(this.placeholder)}
              rows=${Me(this.rows)}
              minlength=${Me(this.minlength)}
              maxlength=${Me(this.maxlength)}
              autocapitalize=${Me(this.autocapitalize)}
              autocorrect=${Me(this.autocorrect)}
              ?autofocus=${this.autofocus}
              spellcheck=${Me(this.spellcheck)}
              enterkeyhint=${Me(this.enterkeyhint)}
              inputmode=${Me(this.inputmode)}
              aria-describedby="help-text"
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
            ></textarea>
            <!-- This "adjuster" exists to prevent layout shifting. https://github.com/shoelace-style/shoelace/issues/2180 -->
            <div part="textarea-adjuster" class="textarea__size-adjuster" ?hidden=${this.resize !== "auto"}></div>
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${n ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
  }
};
ht.styles = [Ar, d0, wee];
O([
  jt(".textarea__control")
], ht.prototype, "input", 2);
O([
  jt(".textarea__size-adjuster")
], ht.prototype, "sizeAdjuster", 2);
O([
  Fn()
], ht.prototype, "hasFocus", 2);
O([
  U()
], ht.prototype, "title", 2);
O([
  U()
], ht.prototype, "name", 2);
O([
  U()
], ht.prototype, "value", 2);
O([
  U({ reflect: !0 })
], ht.prototype, "size", 2);
O([
  U({ type: Boolean, reflect: !0 })
], ht.prototype, "filled", 2);
O([
  U()
], ht.prototype, "label", 2);
O([
  U({ attribute: "help-text" })
], ht.prototype, "helpText", 2);
O([
  U()
], ht.prototype, "placeholder", 2);
O([
  U({ type: Number })
], ht.prototype, "rows", 2);
O([
  U()
], ht.prototype, "resize", 2);
O([
  U({ type: Boolean, reflect: !0 })
], ht.prototype, "disabled", 2);
O([
  U({ type: Boolean, reflect: !0 })
], ht.prototype, "readonly", 2);
O([
  U({ reflect: !0 })
], ht.prototype, "form", 2);
O([
  U({ type: Boolean, reflect: !0 })
], ht.prototype, "required", 2);
O([
  U({ type: Number })
], ht.prototype, "minlength", 2);
O([
  U({ type: Number })
], ht.prototype, "maxlength", 2);
O([
  U()
], ht.prototype, "autocapitalize", 2);
O([
  U()
], ht.prototype, "autocorrect", 2);
O([
  U()
], ht.prototype, "autocomplete", 2);
O([
  U({ type: Boolean })
], ht.prototype, "autofocus", 2);
O([
  U()
], ht.prototype, "enterkeyhint", 2);
O([
  U({
    type: Boolean,
    converter: {
      // Allow "true|false" attribute values but keep the property boolean
      fromAttribute: (e) => !(!e || e === "false"),
      toAttribute: (e) => e ? "true" : "false"
    }
  })
], ht.prototype, "spellcheck", 2);
O([
  U()
], ht.prototype, "inputmode", 2);
O([
  l0()
], ht.prototype, "defaultValue", 2);
O([
  Nt("disabled", { waitUntilFirstUpdate: !0 })
], ht.prototype, "handleDisabledChange", 1);
O([
  Nt("rows", { waitUntilFirstUpdate: !0 })
], ht.prototype, "handleRowsChange", 1);
O([
  Nt("value", { waitUntilFirstUpdate: !0 })
], ht.prototype, "handleValueChange", 1);
ht.define("sl-textarea");
const xee = ".input::part(base){border-radius:var(--photon-border-radius, .5rem)}.invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.invalid::part(form-control-help-text){--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}";
var ou = /* @__PURE__ */ K("<style>"), kee = /* @__PURE__ */ K('<div class="sm:py-2 flex flex-col"><sl-textarea class=input><p slot=help-text class="text-red-400 pt-1 h-[21px] font-sans">', !0, !1, !1), _ee = /* @__PURE__ */ K('<div class="flex items-center pb-2 font-sans"><p class="text-gray-700 text-sm">'), Cee = /* @__PURE__ */ K('<p class="pl-1 text-red-400">*'), See = /* @__PURE__ */ K('<p class="text-gray-400 text-xs pl-2">Optional');
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const Eee = (e) => {
  let t;
  const r = (n) => {
    const i = new CustomEvent("photon-textarea-changed", {
      composed: !0,
      bubbles: !0,
      detail: {
        value: n
      }
    });
    t?.dispatchEvent(i);
  };
  return Et(() => {
    r(e.value ?? "");
  }), [(() => {
    var n = ou();
    return A(n, Rt), n;
  })(), (() => {
    var n = ou();
    return A(n, Ur), n;
  })(), (() => {
    var n = ou();
    return A(n, qr), n;
  })(), (() => {
    var n = ou();
    return A(n, xee), n;
  })(), (() => {
    var n = kee(), i = n.firstChild, a = i.firstChild, o = t;
    return typeof o == "function" ? ze(o, n) : t = n, A(n, (() => {
      var s = L(() => !!e.label);
      return () => s() ? (() => {
        var l = _ee(), d = l.firstChild;
        return A(d, () => e.label), A(l, (() => {
          var u = L(() => !!e.required);
          return () => u() ? Cee() : null;
        })(), null), A(l, (() => {
          var u = L(() => !e.required);
          return () => u() ? See() : null;
        })(), null), l;
      })() : null;
    })(), i), ce(i, "sl-input", (s) => {
      r(s.target.value);
    }), i._$owner = fe(), A(a, () => e.helpText), J((s) => {
      var l = !!e.invalid, d = e.disabled, u = e.invalid, c = e.placeholder;
      return l !== s.e && i.classList.toggle("invalid", s.e = l), d !== s.t && (i.disabled = s.t = d), u !== s.a && (i.invalid = s.a = u), c !== s.o && (i.placeholder = s.o = c), s;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0
    }), J(() => i.value = e.value ? e.value : ""), n;
  })()];
};
Tt("photon-textarea", {
  label: void 0,
  required: !1,
  placeholder: void 0,
  value: void 0,
  formName: void 0,
  helpText: void 0,
  invalid: !1,
  disabled: !1
}, Eee);
const Tee = ".input::part(base){border-radius:var(--photon-border-radius, .5rem)}.invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.invalid::part(form-control-help-text){--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}.input{--sl-input-required-content-color: #f87171;--sl-input-label-font-size-medium: .875rem;--sl-input-label-color: #374151}.input::part(form-control-label){padding-bottom:.5rem}";
var su = /* @__PURE__ */ K("<style>"), Aee = /* @__PURE__ */ K('<div class="flex flex-col font-sans"><sl-input class=input type=text><p slot=help-text class="text-red-400 pt-1 h-[21px] font-sans">', !0, !1, !1);
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const Oee = (e) => {
  let t;
  const r = (i) => {
    const a = new CustomEvent("photon-input-changed", {
      composed: !0,
      bubbles: !0,
      detail: {
        input: i
      }
    });
    t?.dispatchEvent(a);
  }, n = $d((i) => r(i), e.debounceTime);
  return Et(() => {
    e.dispatchOnMount && r(e.value ?? "");
  }), [(() => {
    var i = su();
    return A(i, Rt), i;
  })(), (() => {
    var i = su();
    return A(i, Ur), i;
  })(), (() => {
    var i = su();
    return A(i, qr), i;
  })(), (() => {
    var i = su();
    return A(i, Tee), i;
  })(), (() => {
    var i = Aee(), a = i.firstChild, o = a.firstChild, s = t;
    return typeof s == "function" ? ze(s, i) : t = i, ce(a, "sl-input", (l) => {
      n(l.target.value);
    }), a._$owner = fe(), A(o, () => e.helpText), J((l) => {
      var d = !!e.invalid, u = e.disabled, c = e.invalid, h = e.label, f = e.required;
      return d !== l.e && a.classList.toggle("invalid", l.e = d), u !== l.t && (a.disabled = l.t = u), c !== l.a && (a.invalid = l.a = c), h !== l.o && (a.label = l.o = h), f !== l.i && (a.required = l.i = f), l;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0
    }), J(() => a.value = e.value || ""), i;
  })()];
};
Tt("photon-text-input", {
  label: void 0,
  required: !1,
  value: void 0,
  formName: void 0,
  invalid: !1,
  helpText: void 0,
  disabled: !1,
  debounceTime: 250,
  dispatchOnMount: !1,
  optional: !1
}, Oee);
var cl = [], Iee = class {
  constructor(e) {
    this.tabDirection = "forward", this.handleFocusIn = () => {
      this.isActive() && this.checkFocus();
    }, this.handleKeyDown = (t) => {
      var r;
      if (t.key !== "Tab" || this.isExternalActivated || !this.isActive()) return;
      const n = s8();
      if (this.previousFocus = n, this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus))
        return;
      t.shiftKey ? this.tabDirection = "backward" : this.tabDirection = "forward";
      const i = Sh(this.element);
      let a = i.findIndex((s) => s === n);
      this.previousFocus = this.currentFocus;
      const o = this.tabDirection === "forward" ? 1 : -1;
      for (; ; ) {
        a + o >= i.length ? a = 0 : a + o < 0 ? a = i.length - 1 : a += o, this.previousFocus = this.currentFocus;
        const s = (
          /** @type {HTMLElement} */
          i[a]
        );
        if (this.tabDirection === "backward" && this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus) || s && this.possiblyHasTabbableChildren(s))
          return;
        t.preventDefault(), this.currentFocus = s, (r = this.currentFocus) == null || r.focus({ preventScroll: !1 });
        const l = [...ap()];
        if (l.includes(this.currentFocus) || !l.includes(this.previousFocus))
          break;
      }
      setTimeout(() => this.checkFocus());
    }, this.handleKeyUp = () => {
      this.tabDirection = "forward";
    }, this.element = e, this.elementsWithTabbableControls = ["iframe"];
  }
  /** Activates focus trapping. */
  activate() {
    cl.push(this.element), document.addEventListener("focusin", this.handleFocusIn), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  /** Deactivates focus trapping. */
  deactivate() {
    cl = cl.filter((e) => e !== this.element), this.currentFocus = null, document.removeEventListener("focusin", this.handleFocusIn), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
  }
  /** Determines if this modal element is currently active or not. */
  isActive() {
    return cl[cl.length - 1] === this.element;
  }
  /** Activates external modal behavior and temporarily disables focus trapping. */
  activateExternal() {
    this.isExternalActivated = !0;
  }
  /** Deactivates external modal behavior and re-enables focus trapping. */
  deactivateExternal() {
    this.isExternalActivated = !1;
  }
  checkFocus() {
    if (this.isActive() && !this.isExternalActivated) {
      const e = Sh(this.element);
      if (!this.element.matches(":focus-within")) {
        const t = e[0], r = e[e.length - 1], n = this.tabDirection === "forward" ? t : r;
        typeof n?.focus == "function" && (this.currentFocus = n, n.focus({ preventScroll: !1 }));
      }
    }
  }
  possiblyHasTabbableChildren(e) {
    return this.elementsWithTabbableControls.includes(e.tagName.toLowerCase()) || e.hasAttribute("controls");
  }
}, Rh = /* @__PURE__ */ new Set();
function Pee() {
  const e = document.documentElement.clientWidth;
  return Math.abs(window.innerWidth - e);
}
function Dee() {
  const e = Number(getComputedStyle(document.body).paddingRight.replace(/px/, ""));
  return isNaN(e) || !e ? 0 : e;
}
function iv(e) {
  if (Rh.add(e), !document.documentElement.classList.contains("sl-scroll-lock")) {
    const t = Pee() + Dee();
    let r = getComputedStyle(document.documentElement).scrollbarGutter;
    (!r || r === "auto") && (r = "stable"), t < 2 && (r = ""), document.documentElement.style.setProperty("--sl-scroll-lock-gutter", r), document.documentElement.classList.add("sl-scroll-lock"), document.documentElement.style.setProperty("--sl-scroll-lock-size", `${t}px`);
  }
}
function av(e) {
  Rh.delete(e), Rh.size === 0 && (document.documentElement.classList.remove("sl-scroll-lock"), document.documentElement.style.removeProperty("--sl-scroll-lock-size"));
}
var Mee = gr`
  :host {
    --width: 31rem;
    --header-spacing: var(--sl-spacing-large);
    --body-spacing: var(--sl-spacing-large);
    --footer-spacing: var(--sl-spacing-large);

    display: contents;
  }

  .dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: var(--sl-z-index-dialog);
  }

  .dialog__panel {
    display: flex;
    flex-direction: column;
    z-index: 2;
    width: var(--width);
    max-width: calc(100% - var(--sl-spacing-2x-large));
    max-height: calc(100% - var(--sl-spacing-2x-large));
    background-color: var(--sl-panel-background-color);
    border-radius: var(--sl-border-radius-medium);
    box-shadow: var(--sl-shadow-x-large);
  }

  .dialog__panel:focus {
    outline: none;
  }

  /* Ensure there's enough vertical padding for phones that don't update vh when chrome appears (e.g. iPhone) */
  @media screen and (max-width: 420px) {
    .dialog__panel {
      max-height: 80vh;
    }
  }

  .dialog--open .dialog__panel {
    display: flex;
    opacity: 1;
  }

  .dialog__header {
    flex: 0 0 auto;
    display: flex;
  }

  .dialog__title {
    flex: 1 1 auto;
    font: inherit;
    font-size: var(--sl-font-size-large);
    line-height: var(--sl-line-height-dense);
    padding: var(--header-spacing);
    margin: 0;
  }

  .dialog__header-actions {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    gap: var(--sl-spacing-2x-small);
    padding: 0 var(--header-spacing);
  }

  .dialog__header-actions sl-icon-button,
  .dialog__header-actions ::slotted(sl-icon-button) {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
  }

  .dialog__body {
    flex: 1 1 auto;
    display: block;
    padding: var(--body-spacing);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: right;
    padding: var(--footer-spacing);
  }

  .dialog__footer ::slotted(sl-button:not(:first-of-type)) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  .dialog:not(.dialog--has-footer) .dialog__footer {
    display: none;
  }

  .dialog__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--sl-overlay-background-color);
  }

  @media (forced-colors: active) {
    .dialog__panel {
      border: solid 1px var(--sl-color-neutral-0);
    }
  }
`, si = class extends ar {
  constructor() {
    super(...arguments), this.hasSlotController = new ha(this, "footer"), this.localize = new Ei(this), this.modal = new Iee(this), this.open = !1, this.label = "", this.noHeader = !1, this.handleDocumentKeyDown = (e) => {
      e.key === "Escape" && this.modal.isActive() && this.open && (e.stopPropagation(), this.requestClose("keyboard"));
    };
  }
  firstUpdated() {
    this.dialog.hidden = !this.open, this.open && (this.addOpenListeners(), this.modal.activate(), iv(this));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.modal.deactivate(), av(this), this.removeOpenListeners();
  }
  requestClose(e) {
    if (this.emit("sl-request-close", {
      cancelable: !0,
      detail: { source: e }
    }).defaultPrevented) {
      const r = Sn(this, "dialog.denyClose", { dir: this.localize.dir() });
      En(this.panel, r.keyframes, r.options);
      return;
    }
    this.hide();
  }
  addOpenListeners() {
    var e;
    "CloseWatcher" in window ? ((e = this.closeWatcher) == null || e.destroy(), this.closeWatcher = new CloseWatcher(), this.closeWatcher.onclose = () => this.requestClose("keyboard")) : document.addEventListener("keydown", this.handleDocumentKeyDown);
  }
  removeOpenListeners() {
    var e;
    (e = this.closeWatcher) == null || e.destroy(), document.removeEventListener("keydown", this.handleDocumentKeyDown);
  }
  async handleOpenChange() {
    if (this.open) {
      this.emit("sl-show"), this.addOpenListeners(), this.originalTrigger = document.activeElement, this.modal.activate(), iv(this);
      const e = this.querySelector("[autofocus]");
      e && e.removeAttribute("autofocus"), await Promise.all([Gn(this.dialog), Gn(this.overlay)]), this.dialog.hidden = !1, requestAnimationFrame(() => {
        this.emit("sl-initial-focus", { cancelable: !0 }).defaultPrevented || (e ? e.focus({ preventScroll: !0 }) : this.panel.focus({ preventScroll: !0 })), e && e.setAttribute("autofocus", "");
      });
      const t = Sn(this, "dialog.show", { dir: this.localize.dir() }), r = Sn(this, "dialog.overlay.show", { dir: this.localize.dir() });
      await Promise.all([
        En(this.panel, t.keyframes, t.options),
        En(this.overlay, r.keyframes, r.options)
      ]), this.emit("sl-after-show");
    } else {
      N8(this), this.emit("sl-hide"), this.removeOpenListeners(), this.modal.deactivate(), await Promise.all([Gn(this.dialog), Gn(this.overlay)]);
      const e = Sn(this, "dialog.hide", { dir: this.localize.dir() }), t = Sn(this, "dialog.overlay.hide", { dir: this.localize.dir() });
      await Promise.all([
        En(this.overlay, t.keyframes, t.options).then(() => {
          this.overlay.hidden = !0;
        }),
        En(this.panel, e.keyframes, e.options).then(() => {
          this.panel.hidden = !0;
        })
      ]), this.dialog.hidden = !0, this.overlay.hidden = !1, this.panel.hidden = !1, av(this);
      const r = this.originalTrigger;
      typeof r?.focus == "function" && setTimeout(() => r.focus()), this.emit("sl-after-hide");
    }
  }
  /** Shows the dialog. */
  async show() {
    if (!this.open)
      return this.open = !0, sa(this, "sl-after-show");
  }
  /** Hides the dialog */
  async hide() {
    if (this.open)
      return this.open = !1, sa(this, "sl-after-hide");
  }
  render() {
    return xt`
      <div
        part="base"
        class=${dr({
      dialog: !0,
      "dialog--open": this.open,
      "dialog--has-footer": this.hasSlotController.test("footer")
    })}
      >
        <div part="overlay" class="dialog__overlay" @click=${() => this.requestClose("overlay")} tabindex="-1"></div>

        <div
          part="panel"
          class="dialog__panel"
          role="dialog"
          aria-modal="true"
          aria-hidden=${this.open ? "false" : "true"}
          aria-label=${Me(this.noHeader ? this.label : void 0)}
          aria-labelledby=${Me(this.noHeader ? void 0 : "title")}
          tabindex="-1"
        >
          ${this.noHeader ? "" : xt`
                <header part="header" class="dialog__header">
                  <h2 part="title" class="dialog__title" id="title">
                    <slot name="label"> ${this.label.length > 0 ? this.label : "\uFEFF"} </slot>
                  </h2>
                  <div part="header-actions" class="dialog__header-actions">
                    <slot name="header-actions"></slot>
                    <sl-icon-button
                      part="close-button"
                      exportparts="base:close-button__base"
                      class="dialog__close"
                      name="x-lg"
                      label=${this.localize.term("close")}
                      library="system"
                      @click="${() => this.requestClose("close-button")}"
                    ></sl-icon-button>
                  </div>
                </header>
              `}
          ${""}
          <div part="body" class="dialog__body" tabindex="-1"><slot></slot></div>

          <footer part="footer" class="dialog__footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    `;
  }
};
si.styles = [Ar, Mee];
si.dependencies = {
  "sl-icon-button": Br
};
O([
  jt(".dialog")
], si.prototype, "dialog", 2);
O([
  jt(".dialog__panel")
], si.prototype, "panel", 2);
O([
  jt(".dialog__overlay")
], si.prototype, "overlay", 2);
O([
  U({ type: Boolean, reflect: !0 })
], si.prototype, "open", 2);
O([
  U({ reflect: !0 })
], si.prototype, "label", 2);
O([
  U({ attribute: "no-header", type: Boolean, reflect: !0 })
], si.prototype, "noHeader", 2);
O([
  Nt("open", { waitUntilFirstUpdate: !0 })
], si.prototype, "handleOpenChange", 1);
Rn("dialog.show", {
  keyframes: [
    { opacity: 0, scale: 0.8 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 250, easing: "ease" }
});
Rn("dialog.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.8 }
  ],
  options: { duration: 250, easing: "ease" }
});
Rn("dialog.denyClose", {
  keyframes: [{ scale: 1 }, { scale: 1.02 }, { scale: 1 }],
  options: { duration: 250 }
});
Rn("dialog.overlay.show", {
  keyframes: [{ opacity: 0 }, { opacity: 1 }],
  options: { duration: 250 }
});
Rn("dialog.overlay.hide", {
  keyframes: [{ opacity: 1 }, { opacity: 0 }],
  options: { duration: 250 }
});
si.define("sl-dialog");
const Nee = '.dialog::part(overlay){background-color:#0000007a}.dialog::part(body){padding-bottom:.25rem}.dialog::part(footer){padding-top:0}.hideFooter::part(footer){display:none}.showHeader::part(body){padding-top:0}.dialog::part(title){font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-weight:500}';
var hl = /* @__PURE__ */ K("<style>"), Lee = /* @__PURE__ */ K('<slot name=label><p class="text-xl font-sans font-medium">'), Fee = /* @__PURE__ */ K('<sl-dialog class=dialog><div><slot></slot></div><div class="flex flex-col xs:flex-row justify-end gap-2"slot=footer>', !0, !1, !1);
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const Ree = (e) => {
  let t;
  const r = (n) => {
    const i = new CustomEvent(n, {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(i);
  };
  return [(() => {
    var n = hl();
    return A(n, oi), n;
  })(), (() => {
    var n = hl();
    return A(n, Rt), n;
  })(), (() => {
    var n = hl();
    return A(n, Ur), n;
  })(), (() => {
    var n = hl();
    return A(n, qr), n;
  })(), (() => {
    var n = hl();
    return A(n, Nee), n;
  })(), (() => {
    var n = Fee(), i = n.firstChild, a = i.firstChild, o = i.nextSibling;
    ce(n, "sl-request-close", (l) => {
      l.detail.source === "overlay" && !e.overlayClose || l.detail.source === "keyboard" ? l.preventDefault() : r("photon-dialog-canceled");
    });
    var s = t;
    return typeof s == "function" ? ze(s, n) : t = n, n._$owner = fe(), A(n, b(X, {
      get when() {
        return !e.header;
      },
      get children() {
        var l = Lee(), d = l.firstChild;
        return l._$owner = fe(), A(d, () => e.label), l;
      }
    }), i), a._$owner = fe(), A(o, b(st, {
      variant: "secondary",
      get disabled() {
        return e.disableButtons || e.loading;
      },
      onClick: () => {
        r("photon-dialog-alt");
      },
      get children() {
        return e.cancelText;
      }
    }), null), A(o, b(st, {
      get disabled() {
        return e.disableButtons || e.disableSubmit;
      },
      get loading() {
        return e.loading;
      },
      onClick: () => {
        r("photon-dialog-confirmed");
      },
      get children() {
        return e.confirmText;
      }
    }), null), J((l) => {
      var d = !!e.hideFooter, u = !!e.header, c = `--width: ${e.width};`, h = e.label, f = e.open, p = !e.header, g = `font-sans ${e.header ? "pb-4" : "py-4"}`, v = !!e.hideFooter;
      return d !== l.e && n.classList.toggle("hideFooter", l.e = d), u !== l.t && n.classList.toggle("showHeader", l.t = u), l.a = Kv(n, c, l.a), h !== l.o && (n.label = l.o = h), f !== l.i && (n.open = l.i = f), p !== l.n && (n.noHeader = l.n = p), g !== l.s && Wi(i, l.s = g), v !== l.h && o.classList.toggle("hidden", l.h = v), l;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0,
      h: void 0
    }), n;
  })()];
};
Tt("photon-dialog", {
  label: void 0,
  header: !0,
  open: !1,
  confirmText: "Yes, Cancel",
  cancelText: "No, Keep Editing",
  disableButtons: !1,
  loading: !1,
  hideFooter: !1,
  disableSubmit: !1,
  width: "500px",
  overlayClose: !1
}, Ree);
const ny = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function zee(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(ny), e.apply(this, r);
}
function ov(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var r = e[0].split("."), n = t[0].split("."), i = 0; i < 3; i++) {
    var a = Number(r[i]), o = Number(n[i]);
    if (a > o) return 1;
    if (o > a) return -1;
    if (!isNaN(a) && isNaN(o)) return 1;
    if (isNaN(a) && !isNaN(o)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var jee = {}.constructor;
function Va(e) {
  return e != null && e.constructor === jee;
}
function zh(e) {
  "@babel/helpers - typeof";
  return zh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zh(e);
}
function f0(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Vee(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function p0(e, t, r) {
  return t && Vee(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Uee = "1.2.0", qee = "1.7.35", sv = " ext. ", Bee = /^\d+$/, kr = /* @__PURE__ */ function() {
  function e(t) {
    f0(this, e), iy(t), this.metadata = t, ay.call(this, t);
  }
  return p0(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(r) {
        return r !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(r) {
      return this.metadata.countries[r];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(r) {
      return this.getCountryMetadata(r) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(r) {
      if (this.getCountryCodesForCallingCode(r))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[r])
          return !0;
      } else {
        var n = this.countryCallingCodes()[r];
        if (n && n.length === 1 && n[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(r) {
      return this.nonGeographic() ? !!this.nonGeographic()[r] : !this.getCountryCodesForCallingCode(r);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(r, n) {
      if (r && Bee.test(r) && (n = r, r = null), r && r !== "001") {
        if (!this.hasCountry(r))
          throw new Error("Unknown country: ".concat(r));
        this.numberingPlan = new lv(this.getCountryMetadata(r), this);
      } else if (n) {
        if (!this.hasCallingCode(n))
          throw new Error("Unknown calling code: ".concat(n));
        this.numberingPlan = new lv(this.getNumberingPlanMetadata(n), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(r) {
      var n = this.countryCallingCodes()[r];
      if (n)
        return n.length === 1 && n[0].length === 3 ? void 0 : n;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(r) {
      var n = this.getCountryCodesForCallingCode(r);
      if (n)
        return n[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(r) {
      var n = this.getCountryCodeForCallingCode(r);
      if (n)
        return this.getCountryMetadata(n);
      if (this.nonGeographic()) {
        var i = this.nonGeographic()[r];
        if (i)
          return i;
      } else {
        var a = this.countryCallingCodes()[r];
        if (a && a.length === 1 && a[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(r) {
      return this.numberingPlan.type(r);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), lv = /* @__PURE__ */ function() {
  function e(t, r) {
    f0(this, e), this.globalMetadataObject = r, this.metadata = t, ay.call(this, r.metadata);
  }
  return p0(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(r) {
      return r[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var r = this, n = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return n.map(function(i) {
        return new Hee(i, r);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(r) {
      return r[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(r) {
      if (this.hasTypes() && dv(this.types(), r))
        return new Qee(dv(this.types(), r), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? sv : this.metadata[13] || sv;
    }
  }]), e;
}(), Hee = /* @__PURE__ */ function() {
  function e(t, r) {
    f0(this, e), this._format = t, this.metadata = r;
  }
  return p0(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !Wee.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), Wee = /^\(?\$1\)?$/, Qee = /* @__PURE__ */ function() {
  function e(t, r) {
    f0(this, e), this.type = t, this.metadata = r;
  }
  return p0(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function dv(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function iy(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Va(e) || !Va(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Va(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + Gee(e) + ": " + e, "."));
}
var Gee = function(t) {
  return zh(t);
};
function Cp(e, t) {
  if (t = new kr(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function ay(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? ov(t, Uee) === -1 ? this.v2 = !0 : ov(t, qee) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function m0(e, t) {
  return Yee(e, void 0, t);
}
function Yee(e, t, r) {
  var n = r.type(t), i = n && n.possibleLengths() || r.possibleLengths();
  if (!i)
    return "IS_POSSIBLE";
  var a = e.length, o = i[0];
  return o === a ? "IS_POSSIBLE" : o > a ? "TOO_SHORT" : i[i.length - 1] < a ? "TOO_LONG" : i.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function Kee(e, t, r) {
  if (t === void 0 && (t = {}), r = new kr(r), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!r.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      r.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return oy(e.phone || e.nationalNumber, r);
  if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function oy(e, t) {
  switch (m0(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function _i(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function Zee(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Xee(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xee(e, t) {
  if (e) {
    if (typeof e == "string") return uv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return uv(e, t);
  }
}
function uv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Jee = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Sp(e, t, r) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    r = new kr(r), r.selectNumberingPlan(e.country, e.countryCallingCode);
    var n = t.v2 ? e.nationalNumber : e.phone;
    if (_i(n, r.nationalNumberPattern())) {
      if (M1(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || M1(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var i = Zee(Jee), a; !(a = i()).done; ) {
        var o = a.value;
        if (M1(n, o, r))
          return o;
      }
    }
  }
}
function M1(e, t, r) {
  return t = r.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : _i(e, t.pattern());
}
function ete(e, t, r) {
  if (t = t || {}, r = new kr(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return Sp(e, t, r.metadata) !== void 0;
  var n = t.v2 ? e.nationalNumber : e.phone;
  return _i(n, r.nationalNumberPattern());
}
function tte(e, t, r) {
  var n = new kr(r), i = n.getCountryCodesForCallingCode(e);
  return i ? i.filter(function(a) {
    return rte(t, a, r);
  }) : [];
}
function rte(e, t, r) {
  var n = new kr(r);
  return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var Ep = 2, nte = 17, ite = 3, zr = "0-9０-９٠-٩۰-۹", ate = "-‐-―−ー－", ote = "／/", ste = "．.", lte = "  ­​⁠　", dte = "()（）［］\\[\\]", ute = "~⁓∼～", On = "".concat(ate).concat(ote).concat(ste).concat(lte).concat(dte).concat(ute), g0 = "+＋", cte = new RegExp("([" + zr + "])");
function sy(e, t, r, n) {
  if (t) {
    var i = new kr(n);
    i.selectNumberingPlan(t, r);
    var a = new RegExp(i.IDDPrefix());
    if (e.search(a) === 0) {
      e = e.slice(e.match(a)[0].length);
      var o = e.match(cte);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function jh(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(e);
    if (n) {
      var i, a, o = n.length - 1, s = o > 0 && n[o];
      if (t.nationalPrefixTransformRule() && s)
        i = e.replace(r, t.nationalPrefixTransformRule()), o > 1 && (a = n[1]);
      else {
        var l = n[0];
        i = e.slice(l.length), s && (a = n[1]);
      }
      var d;
      if (s) {
        var u = e.indexOf(n[1]), c = e.slice(0, u);
        c === t.numberingPlan.nationalPrefix() && (d = t.numberingPlan.nationalPrefix());
      } else
        d = n[0];
      return {
        nationalNumber: i,
        nationalPrefix: d,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function Vh(e, t) {
  var r = jh(e, t), n = r.carrierCode, i = r.nationalNumber;
  if (i !== e) {
    if (!hte(e, i, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !fte(i, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: i,
    carrierCode: n
  };
}
function hte(e, t, r) {
  return !(_i(e, r.nationalNumberPattern()) && !_i(t, r.nationalNumberPattern()));
}
function fte(e, t) {
  switch (m0(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function ly(e, t, r, n) {
  var i = t ? Cp(t, n) : r;
  if (e.indexOf(i) === 0) {
    n = new kr(n), n.selectNumberingPlan(t, r);
    var a = e.slice(i.length), o = Vh(a, n), s = o.nationalNumber, l = Vh(e, n), d = l.nationalNumber;
    if (!_i(d, n.nationalNumberPattern()) && _i(s, n.nationalNumberPattern()) || m0(d, n) === "TOO_LONG")
      return {
        countryCallingCode: i,
        number: a
      };
  }
  return {
    number: e
  };
}
function Tp(e, t, r, n) {
  if (!e)
    return {};
  var i;
  if (e[0] !== "+") {
    var a = sy(e, t, r, n);
    if (a && a !== e)
      i = !0, e = "+" + a;
    else {
      if (t || r) {
        var o = ly(e, t, r, n), s = o.countryCallingCode, l = o.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  n = new kr(n);
  for (var d = 2; d - 1 <= ite && d <= e.length; ) {
    var u = e.slice(1, d);
    if (n.hasCallingCode(u))
      return n.selectNumberingPlan(u), {
        countryCallingCodeSource: i ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: e.slice(d)
      };
    d++;
  }
  return {};
}
function dy(e) {
  return e.replace(new RegExp("[".concat(On, "]+"), "g"), " ").trim();
}
var uy = /(\$\d)/;
function cy(e, t, r) {
  var n = r.useInternationalFormat, i = r.withNationalPrefix;
  r.carrierCode, r.metadata;
  var a = e.replace(new RegExp(t.pattern()), n ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && t.nationalPrefixFormattingRule() ? t.format().replace(uy, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return n ? dy(a) : a;
}
var pte = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function mte(e, t, r) {
  var n = new kr(r);
  if (n.selectNumberingPlan(e, t), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (pte.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
var gte = ";ext=", yo = function(t) {
  return "([".concat(zr, "]{1,").concat(t, "})");
};
function hy(e) {
  var t = "20", r = "15", n = "9", i = "6", a = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", s = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", c = "[  \\t]*", h = "(?:,{2}|;)", f = gte + yo(t), p = a + l + o + yo(t) + s, g = a + d + o + yo(n) + s, v = u + yo(i) + "#", m = c + h + o + yo(r) + s, $ = c + "(?:,)+" + o + yo(n) + s;
  return f + "|" + p + "|" + g + "|" + v + "|" + m + "|" + $;
}
var vte = "[" + zr + "]{" + Ep + "}", yte = "[" + g0 + "]{0,1}(?:[" + On + "]*[" + zr + "]){3,}[" + On + zr + "]*", bte = new RegExp("^[" + g0 + "]{0,1}(?:[" + On + "]*[" + zr + "]){1,2}$", "i"), $te = yte + // Phone number extensions
"(?:" + hy() + ")?", wte = new RegExp(
  // Either a short two-digit-only phone number
  "^" + vte + "$|^" + $te + "$",
  "i"
);
function xte(e) {
  return e.length >= Ep && wte.test(e);
}
function kte(e) {
  return bte.test(e);
}
function _te(e) {
  var t = e.number, r = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(r ? ";ext=" + r : "");
}
function Cte(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Ste(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ste(e, t) {
  if (e) {
    if (typeof e == "string") return cv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return cv(e, t);
  }
}
function cv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function hv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function fv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hv(Object(r), !0).forEach(function(n) {
      Ete(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ete(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var pv = {
  formatExtension: function(t, r, n) {
    return "".concat(t).concat(n.ext()).concat(r);
  }
};
function Tte(e, t, r, n) {
  if (r ? r = fv(fv({}, pv), r) : r = pv, n = new kr(n), e.country && e.country !== "001") {
    if (!n.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    n.country(e.country);
  } else if (e.countryCallingCode)
    n.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var i = n.countryCallingCode(), a = r.v2 ? e.nationalNumber : e.phone, o;
  switch (t) {
    case "NATIONAL":
      return a ? (o = xc(a, e.carrierCode, "NATIONAL", n, r), N1(o, e.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (o = xc(a, null, "INTERNATIONAL", n, r), o = "+".concat(i, " ").concat(o), N1(o, e.ext, n, r.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(a);
    case "RFC3966":
      return _te({
        number: "+".concat(i).concat(a),
        ext: e.ext
      });
    case "IDD":
      if (!r.fromCountry)
        return;
      var s = Ote(a, e.carrierCode, i, r.fromCountry, n);
      return N1(s, e.ext, n, r.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function xc(e, t, r, n, i) {
  var a = Ate(n.formats(), e);
  return a ? cy(e, a, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1),
    carrierCode: t,
    metadata: n
  }) : e;
}
function Ate(e, t) {
  for (var r = Cte(e), n; !(n = r()).done; ) {
    var i = n.value;
    if (i.leadingDigitsPatterns().length > 0) {
      var a = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
      if (t.search(a) !== 0)
        continue;
    }
    if (_i(t, i.pattern()))
      return i;
  }
}
function N1(e, t, r, n) {
  return t ? n(e, t, r) : e;
}
function Ote(e, t, r, n, i) {
  var a = Cp(n, i.metadata);
  if (a === r) {
    var o = xc(e, t, "NATIONAL", i);
    return r === "1" ? r + " " + o : o;
  }
  var s = mte(n, void 0, i.metadata);
  if (s)
    return "".concat(s, " ").concat(r, " ").concat(xc(e, null, "INTERNATIONAL", i));
}
function mv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function gv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mv(Object(r), !0).forEach(function(n) {
      Ite(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ite(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Pte(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Dte(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Mte(e, t, r) {
  return t && Dte(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var fy = /* @__PURE__ */ function() {
  function e(t, r, n) {
    if (Pte(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (typeof t == "string") {
      if (t[0] === "+" && !r)
        throw new TypeError("`metadata` argument not passed");
      if (Va(r) && Va(r.countries)) {
        n = r;
        var i = t;
        if (!Fte.test(i))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var a = Tp(i, void 0, void 0, n), o = a.countryCallingCode, s = a.number;
        if (r = s, t = o, !r)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!r)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof r != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    iy(n);
    var l = Lte(t, n), d = l.country, u = l.countryCallingCode;
    this.country = d, this.countryCallingCode = u, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n;
    };
  }
  return Mte(e, [{
    key: "setExt",
    value: function(r) {
      this.ext = r;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : tte(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return Kee(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return ete(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var r = new kr(this.getMetadata());
      return r.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(r) {
      return this.number === r.number && this.ext === r.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return Sp(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(r, n) {
      return Tte(this, r, n ? gv(gv({}, n), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(r) {
      return this.format("NATIONAL", r);
    }
  }, {
    key: "formatInternational",
    value: function(r) {
      return this.format("INTERNATIONAL", r);
    }
  }, {
    key: "getURI",
    value: function(r) {
      return this.format("RFC3966", r);
    }
  }]), e;
}(), Nte = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function Lte(e, t) {
  var r, n, i = new kr(t);
  return Nte(e) ? (r = e, i.selectNumberingPlan(r), n = i.countryCallingCode()) : n = e, {
    country: r,
    countryCallingCode: n
  };
}
var Fte = /^\+\d+$/;
function Uh(e) {
  "@babel/helpers - typeof";
  return Uh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Uh(e);
}
function Rte(e, t, r) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function zte(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function jte(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && id(e, t);
}
function Vte(e) {
  var t = my();
  return function() {
    var n = ad(e), i;
    if (t) {
      var a = ad(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return Ute(this, i);
  };
}
function Ute(e, t) {
  if (t && (Uh(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return py(e);
}
function py(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function qh(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return qh = function(n) {
    if (n === null || !qte(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n)) return t.get(n);
      t.set(n, i);
    }
    function i() {
      return Ou(n, arguments, ad(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), id(i, n);
  }, qh(e);
}
function Ou(e, t, r) {
  return my() ? Ou = Reflect.construct : Ou = function(i, a, o) {
    var s = [null];
    s.push.apply(s, a);
    var l = Function.bind.apply(i, s), d = new l();
    return o && id(d, o.prototype), d;
  }, Ou.apply(null, arguments);
}
function my() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function qte(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function id(e, t) {
  return id = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, id(e, t);
}
function ad(e) {
  return ad = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ad(e);
}
var qi = /* @__PURE__ */ function(e) {
  jte(r, e);
  var t = Vte(r);
  function r(n) {
    var i;
    return zte(this, r), i = t.call(this, n), Object.setPrototypeOf(py(i), r.prototype), i.name = i.constructor.name, i;
  }
  return Rte(r);
}(/* @__PURE__ */ qh(Error)), vv = new RegExp("(?:" + hy() + ")$", "i");
function Bte(e) {
  var t = e.search(vv);
  if (t < 0)
    return {};
  for (var r = e.slice(0, t), n = e.match(vv), i = 1; i < n.length; ) {
    if (n[i])
      return {
        number: r,
        ext: n[i]
      };
    i++;
  }
}
function Hte(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Wte(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wte(e, t) {
  if (e) {
    if (typeof e == "string") return yv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return yv(e, t);
  }
}
function yv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Qte = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function gy(e) {
  return Qte[e];
}
function kc(e) {
  for (var t = "", r = Hte(e.split("")), n; !(n = r()).done; ) {
    var i = n.value, a = gy(i);
    a && (t += a);
  }
  return t;
}
function Gte(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Yte(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yte(e, t) {
  if (e) {
    if (typeof e == "string") return bv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return bv(e, t);
  }
}
function bv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function $v(e) {
  for (var t = "", r = Gte(e.split("")), n; !(n = r()).done; ) {
    var i = n.value;
    t += Kte(i, t) || "";
  }
  return t;
}
function Kte(e, t, r) {
  return e === "+" ? t ? void 0 : "+" : gy(e);
}
function Zte(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Xte(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xte(e, t) {
  if (e) {
    if (typeof e == "string") return wv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return wv(e, t);
  }
}
function wv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function vy(e, t) {
  var r = t.countries;
  t.defaultCountry;
  var n = t.metadata;
  n = new kr(n);
  for (var i = Zte(r), a; !(a = i()).done; ) {
    var o = a.value;
    if (n.country(o), n.leadingDigits()) {
      if (e && e.search(n.leadingDigits()) === 0)
        return o;
    } else if (Sp({
      phone: e,
      country: o
    }, void 0, n.metadata))
      return o;
  }
}
function yy(e, t) {
  var r = t.nationalNumber, n = t.defaultCountry, i = t.metadata, a = i.getCountryCodesForCallingCode(e);
  if (a)
    return a.length === 1 ? a[0] : vy(r, {
      countries: a,
      defaultCountry: n,
      metadata: i.metadata
    });
}
var by = "+", Jte = "[\\-\\.\\(\\)]?", xv = "([" + zr + "]|" + Jte + ")", ere = "^\\" + by + xv + "*[" + zr + "]" + xv + "*$", tre = new RegExp(ere, "g"), Bh = zr, rre = "[" + Bh + "]+((\\-)*[" + Bh + "])*", nre = "a-zA-Z", ire = "[" + nre + "]+((\\-)*[" + Bh + "])*", are = "^(" + rre + "\\.)*" + ire + "\\.?$", ore = new RegExp(are, "g"), kv = "tel:", Hh = ";phone-context=", sre = ";isub=";
function lre(e) {
  var t = e.indexOf(Hh);
  if (t < 0)
    return null;
  var r = t + Hh.length;
  if (r >= e.length)
    return "";
  var n = e.indexOf(";", r);
  return n >= 0 ? e.substring(r, n) : e.substring(r);
}
function dre(e) {
  return e === null ? !0 : e.length === 0 ? !1 : tre.test(e) || ore.test(e);
}
function ure(e, t) {
  var r = t.extractFormattedPhoneNumber, n = lre(e);
  if (!dre(n))
    throw new qi("NOT_A_NUMBER");
  var i;
  if (n === null)
    i = r(e) || "";
  else {
    i = "", n.charAt(0) === by && (i += n);
    var a = e.indexOf(kv), o;
    a >= 0 ? o = a + kv.length : o = 0;
    var s = e.indexOf(Hh);
    i += e.substring(o, s);
  }
  var l = i.indexOf(sre);
  if (l > 0 && (i = i.substring(0, l)), i !== "")
    return i;
}
var cre = 250, hre = new RegExp("[" + g0 + zr + "]"), fre = new RegExp("[^" + zr + "#]+$");
function pre(e, t, r) {
  if (t = t || {}, r = new kr(r), t.defaultCountry && !r.hasCountry(t.defaultCountry))
    throw t.v2 ? new qi("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var n = gre(e, t.v2, t.extract), i = n.number, a = n.ext, o = n.error;
  if (!i) {
    if (t.v2)
      throw o === "TOO_SHORT" ? new qi("TOO_SHORT") : new qi("NOT_A_NUMBER");
    return {};
  }
  var s = yre(i, t.defaultCountry, t.defaultCallingCode, r), l = s.country, d = s.nationalNumber, u = s.countryCallingCode, c = s.countryCallingCodeSource, h = s.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new qi("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < Ep) {
    if (t.v2)
      throw new qi("TOO_SHORT");
    return {};
  }
  if (d.length > nte) {
    if (t.v2)
      throw new qi("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var f = new fy(u, d, r.metadata);
    return l && (f.country = l), h && (f.carrierCode = h), a && (f.ext = a), f.__countryCallingCodeSource = c, f;
  }
  var p = (t.extended ? r.hasSelectedNumberingPlan() : l) ? _i(d, r.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: l,
    countryCallingCode: u,
    carrierCode: h,
    valid: p,
    possible: p ? !0 : !!(t.extended === !0 && r.possibleLengths() && oy(d, r)),
    phone: d,
    ext: a
  } : p ? vre(l, d, a) : {};
}
function mre(e, t, r) {
  if (e) {
    if (e.length > cre) {
      if (r)
        throw new qi("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var n = e.search(hre);
    if (!(n < 0))
      return e.slice(n).replace(fre, "");
  }
}
function gre(e, t, r) {
  var n = ure(e, {
    extractFormattedPhoneNumber: function(o) {
      return mre(o, r, t);
    }
  });
  if (!n)
    return {};
  if (!xte(n))
    return kte(n) ? {
      error: "TOO_SHORT"
    } : {};
  var i = Bte(n);
  return i.ext ? i : {
    number: n
  };
}
function vre(e, t, r) {
  var n = {
    country: e,
    phone: t
  };
  return r && (n.ext = r), n;
}
function yre(e, t, r, n) {
  var i = Tp($v(e), t, r, n.metadata), a = i.countryCallingCodeSource, o = i.countryCallingCode, s = i.number, l;
  if (o)
    n.selectNumberingPlan(o);
  else if (s && (t || r))
    n.selectNumberingPlan(t, r), t && (l = t), o = r || Cp(t, n.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: o
    };
  var d = Vh($v(s), n), u = d.nationalNumber, c = d.carrierCode, h = yy(o, {
    nationalNumber: u,
    defaultCountry: t,
    metadata: n
  });
  return h && (l = h, h === "001" || n.country(l)), {
    country: l,
    countryCallingCode: o,
    countryCallingCodeSource: a,
    nationalNumber: u,
    carrierCode: c
  };
}
function _v(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Cv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _v(Object(r), !0).forEach(function(n) {
      bre(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _v(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function bre(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $re(e, t, r) {
  return pre(e, Cv(Cv({}, t), {}, {
    v2: !0
  }), r);
}
function Sv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wre(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sv(Object(r), !0).forEach(function(n) {
      xre(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function xre(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kre(e, t) {
  return Ere(e) || Sre(e, t) || Cre(e, t) || _re();
}
function _re() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Cre(e, t) {
  if (e) {
    if (typeof e == "string") return Ev(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ev(e, t);
  }
}
function Ev(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Sre(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], i = !0, a = !1, o, s;
    try {
      for (r = r.call(e); !(i = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); i = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (a) throw s;
      }
    }
    return n;
  }
}
function Ere(e) {
  if (Array.isArray(e)) return e;
}
function Tre(e) {
  var t = Array.prototype.slice.call(e), r = kre(t, 4), n = r[0], i = r[1], a = r[2], o = r[3], s, l, d;
  if (typeof n == "string")
    s = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!i || typeof i == "string")
    o ? (l = a, d = o) : (l = void 0, d = a), i && (l = wre({
      defaultCountry: i
    }, l));
  else if (Va(i))
    a ? (l = i, d = a) : d = i;
  else throw new Error("Invalid second argument: ".concat(i));
  return {
    text: s,
    options: l,
    metadata: d
  };
}
function Are() {
  var e = Tre(arguments), t = e.text, r = e.options, n = e.metadata;
  return $re(t, r, n);
}
function Ore(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ire(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Pre(e, t, r) {
  return t && Ire(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Dre = /* @__PURE__ */ function() {
  function e(t) {
    var r = t.onCountryChange, n = t.onCallingCodeChange;
    Ore(this, e), this.onCountryChange = r, this.onCallingCodeChange = n;
  }
  return Pre(e, [{
    key: "reset",
    value: function(r) {
      var n = r.country, i = r.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(n, i);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(r) {
      for (var n = 0, i = Object.keys(r); n < i.length; n++) {
        var a = i[n];
        this[a] = r[a];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(r, n) {
      this.setCountry(r), this.setCallingCode(n);
    }
  }, {
    key: "setCountry",
    value: function(r) {
      this.country = r, this.onCountryChange(r);
    }
  }, {
    key: "setCallingCode",
    value: function(r) {
      this.callingCode = r, this.onCallingCodeChange(r, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(r, n) {
      this.international = !0, this.initCountryAndCallingCode(r, n);
    }
  }, {
    key: "appendDigits",
    value: function(r) {
      this.digits += r;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(r) {
      this.nationalSignificantNumber += r;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function Mre(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Nre(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Nre(e, t) {
  if (e) {
    if (typeof e == "string") return Tv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Tv(e, t);
  }
}
function Tv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var kn = "x", L1 = new RegExp(kn);
function Iu(e, t) {
  if (t < 1)
    return "";
  for (var r = ""; t > 1; )
    t & 1 && (r += e), t >>= 1, e += e;
  return r + e;
}
function Av(e, t) {
  return e[t] === ")" && t++, Lre(e.slice(0, t));
}
function Lre(e) {
  for (var t = [], r = 0; r < e.length; )
    e[r] === "(" ? t.push(r) : e[r] === ")" && t.pop(), r++;
  var n = 0, i = "";
  t.push(e.length);
  for (var a = 0, o = t; a < o.length; a++) {
    var s = o[a];
    i += e.slice(n, s), n = s + 1;
  }
  return i;
}
function Fre(e, t, r) {
  for (var n = Mre(r.split("")), i; !(i = n()).done; ) {
    var a = i.value;
    if (e.slice(t + 1).search(L1) < 0)
      return;
    t = e.search(L1), e = e.replace(L1, a);
  }
  return [e, t];
}
function Rre(e, t, r) {
  var n = r.metadata, i = r.shouldTryNationalPrefixFormattingRule, a = r.getSeparatorAfterNationalPrefix, o = new RegExp("^(?:".concat(t.pattern(), ")$"));
  if (o.test(e.nationalSignificantNumber))
    return jre(e, t, {
      metadata: n,
      shouldTryNationalPrefixFormattingRule: i,
      getSeparatorAfterNationalPrefix: a
    });
}
function zre(e, t) {
  return m0(e, t) === "IS_POSSIBLE";
}
function jre(e, t, r) {
  var n = r.metadata, i = r.shouldTryNationalPrefixFormattingRule, a = r.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, i(t)) {
    var o = Ov(e, t, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: a,
      metadata: n
    });
    if (o)
      return o;
  }
  return Ov(e, t, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: a,
    metadata: n
  });
}
function Ov(e, t, r) {
  var n = r.metadata, i = r.useNationalPrefixFormattingRule, a = r.getSeparatorAfterNationalPrefix, o = cy(e.nationalSignificantNumber, t, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: i,
    metadata: n
  });
  if (i || (e.nationalPrefix ? o = e.nationalPrefix + a(t) + o : e.complexPrefixBeforeNationalSignificantNumber && (o = e.complexPrefixBeforeNationalSignificantNumber + " " + o)), Vre(o, e))
    return o;
}
function Vre(e, t) {
  return kc(e) === t.getNationalDigits();
}
function Ure(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qre(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Bre(e, t, r) {
  return t && qre(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Hre = /* @__PURE__ */ function() {
  function e() {
    Ure(this, e);
  }
  return Bre(e, [{
    key: "parse",
    value: function(r) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(r), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var n = this.context[0], i = n.branches, a = n.instructions;
      if (i)
        return {
          op: "|",
          args: i.concat([F1(a)])
        };
      if (a.length === 0)
        throw new Error("Pattern is required");
      return a.length === 1 ? a[0] : a;
    }
  }, {
    key: "startContext",
    value: function(r) {
      this.context.push(r);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(r) {
      if (!r)
        throw new Error("Pattern is required");
      var n = r.match(Gre);
      if (!n) {
        if (Qre.test(r))
          throw new Error("Illegal characters found in a pattern: ".concat(r));
        this.getContext().instructions = this.getContext().instructions.concat(r.split(""));
        return;
      }
      var i = n[1], a = r.slice(0, n.index), o = r.slice(n.index + i.length);
      switch (i) {
        case "(?:":
          a && this.parsePattern(a), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (a && this.parsePattern(a), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var s = this.getContext(), l = s.branches;
          l.push(F1(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: l
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (a && this.parsePattern(a), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(F1(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          a && this.parsePattern(a), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: Wre(a)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(i));
      }
      o && this.parsePattern(o);
    }
  }]), e;
}();
function Wre(e) {
  for (var t = [], r = 0; r < e.length; ) {
    if (e[r] === "-") {
      if (r === 0 || r === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var n = e[r - 1].charCodeAt(0) + 1, i = e[r + 1].charCodeAt(0) - 1, a = n; a <= i; )
        t.push(String.fromCharCode(a)), a++;
    } else
      t.push(e[r]);
    r++;
  }
  return t;
}
var Qre = /[\(\)\[\]\?\:\|]/, Gre = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function F1(e) {
  return e.length === 1 ? e[0] : e;
}
function Iv(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Yre(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yre(e, t) {
  if (e) {
    if (typeof e == "string") return Pv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Pv(e, t);
  }
}
function Pv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Kre(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Zre(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Xre(e, t, r) {
  return t && Zre(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Jre = /* @__PURE__ */ function() {
  function e(t) {
    Kre(this, e), this.matchTree = new Hre().parse(t);
  }
  return Xre(e, [{
    key: "match",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = n.allowOverflow;
      if (!r)
        throw new Error("String is required");
      var a = Wh(r.split(""), this.matchTree, !0);
      if (a && a.match && delete a.matchedChars, !(a && a.overflow && !i))
        return a;
    }
  }]), e;
}();
function Wh(e, t, r) {
  if (typeof t == "string") {
    var n = e.join("");
    return t.indexOf(n) === 0 ? e.length === t.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : n.indexOf(t) === 0 ? r && e.length > t.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var i = e.slice(), a = 0; a < t.length; ) {
      var o = t[a], s = Wh(i, o, r && a === t.length - 1);
      if (s) {
        if (s.overflow)
          return s;
        if (s.match) {
          if (i = i.slice(s.matchedChars.length), i.length === 0)
            return a === t.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (s.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(s, null, 2)));
        }
      } else return;
      a++;
    }
    return r ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - i.length)
    };
  }
  switch (t.op) {
    case "|":
      for (var l, d = Iv(t.args), u; !(u = d()).done; ) {
        var c = u.value, h = Wh(e, c, r);
        if (h) {
          if (h.overflow)
            return h;
          if (h.match)
            return {
              match: !0,
              matchedChars: h.matchedChars
            };
          if (h.partialMatch)
            l = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(h, null, 2)));
        }
      }
      return l ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var f = Iv(t.args), p; !(p = f()).done; ) {
        var g = p.value;
        if (e[0] === g)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : r ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [g]
          };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
function Dv(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = ene(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ene(e, t) {
  if (e) {
    if (typeof e == "string") return Mv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Mv(e, t);
  }
}
function Mv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function tne(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function rne(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function nne(e, t, r) {
  return t && rne(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Qh = "9", ine = 15, ane = Iu(Qh, ine), one = /[- ]/, sne = function() {
  return /\[([^\[\]])*\]/g;
}, lne = function() {
  return /\d(?=[^,}][^,}])/g;
}, dne = new RegExp("[" + On + "]*\\$1[" + On + "]*(\\$\\d[" + On + "]*)*$"), Nv = 3, une = /* @__PURE__ */ function() {
  function e(t) {
    t.state;
    var r = t.metadata;
    tne(this, e), this.metadata = r, this.resetFormat();
  }
  return nne(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(r, n) {
      this.resetFormat(), r ? (this.isNANP = r.callingCode() === "1", this.matchingFormats = r.formats(), n.nationalSignificantNumber && this.narrowDownMatchingFormats(n)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(r, n) {
      var i = this;
      if (zre(n.nationalSignificantNumber, this.metadata))
        for (var a = Dv(this.matchingFormats), o; !(o = a()).done; ) {
          var s = o.value, l = Rre(n, s, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(u) {
              return i.shouldTryNationalPrefixFormattingRule(u, {
                international: n.international,
                nationalPrefix: n.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(u) {
              return i.getSeparatorAfterNationalPrefix(u);
            }
          });
          if (l)
            return this.resetFormat(), this.chosenFormat = s, this.setNationalNumberTemplate(l.replace(/\d/g, kn), n), this.populatedNationalNumberTemplate = l, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(kn), l;
        }
      return this.formatNationalNumberWithNextDigits(r, n);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(r, n) {
      var i = this.chosenFormat, a = this.chooseFormat(n);
      if (a)
        return a === i ? this.formatNextNationalNumberDigits(r) : this.formatNextNationalNumberDigits(n.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(r) {
      var n = this, i = r.nationalSignificantNumber, a = r.nationalPrefix, o = r.international, s = i, l = s.length - Nv;
      l < 0 && (l = 0), this.matchingFormats = this.matchingFormats.filter(function(d) {
        return n.formatSuits(d, o, a) && n.formatMatches(d, s, l);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(r, n, i) {
      return !(i && !r.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !r.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !n && !i && r.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(r, n, i) {
      var a = r.leadingDigitsPatterns().length;
      if (a === 0)
        return !0;
      i = Math.min(i, a - 1);
      var o = r.leadingDigitsPatterns()[i];
      if (n.length < Nv)
        try {
          return new Jre(o).match(n, {
            allowOverflow: !0
          }) !== void 0;
        } catch (s) {
          return console.error(s), !0;
        }
      return new RegExp("^(".concat(o, ")")).test(n);
    }
  }, {
    key: "getFormatFormat",
    value: function(r, n) {
      return n ? r.internationalFormat() : r.format();
    }
  }, {
    key: "chooseFormat",
    value: function(r) {
      for (var n = this, i = function() {
        var d = o.value;
        return n.chosenFormat === d ? "break" : dne.test(n.getFormatFormat(d, r.international)) ? n.createTemplateForFormat(d, r) ? (n.chosenFormat = d, "break") : (n.matchingFormats = n.matchingFormats.filter(function(u) {
          return u !== d;
        }), "continue") : "continue";
      }, a = Dv(this.matchingFormats.slice()), o; !(o = a()).done; ) {
        var s = i();
        if (s === "break") break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(r, n) {
      if (!(r.pattern().indexOf("|") >= 0)) {
        var i = this.getTemplateForFormat(r, n);
        if (i)
          return this.setNationalNumberTemplate(i, n), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(r) {
      return this.isNANP || r && r.nationalPrefixFormattingRule() && one.test(r.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(r, n) {
      var i = r.IDDPrefix, a = r.missingPlus;
      return i ? n && n.spacing === !1 ? i : i + " " : a ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(r) {
      if (this.template) {
        for (var n = -1, i = 0, a = r.international ? this.getInternationalPrefixBeforeCountryCallingCode(r, {
          spacing: !1
        }) : ""; i < a.length + r.getDigitsWithoutInternationalPrefix().length; )
          n = this.template.indexOf(kn, n + 1), i++;
        return Av(this.template, n + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(r, n) {
      this.nationalNumberTemplate = r, this.populatedNationalNumberTemplate = r, this.populatedNationalNumberTemplatePosition = -1, n.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(n).replace(/[\d\+]/g, kn) + Iu(kn, n.callingCode.length) + " " + r : this.template = r;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(r, n) {
      var i = n.nationalSignificantNumber, a = n.international, o = n.nationalPrefix, s = n.complexPrefixBeforeNationalSignificantNumber, l = r.pattern();
      l = l.replace(sne(), "\\d").replace(lne(), "\\d");
      var d = ane.match(l)[0];
      if (!(i.length > d.length)) {
        var u = new RegExp("^" + l + "$"), c = i.replace(/\d/g, Qh);
        u.test(c) && (d = c);
        var h = this.getFormatFormat(r, a), f;
        if (this.shouldTryNationalPrefixFormattingRule(r, {
          international: a,
          nationalPrefix: o
        })) {
          var p = h.replace(uy, r.nationalPrefixFormattingRule());
          if (kc(r.nationalPrefixFormattingRule()) === (o || "") + kc("$1") && (h = p, f = !0, o))
            for (var g = o.length; g > 0; )
              h = h.replace(/\d/, kn), g--;
        }
        var v = d.replace(new RegExp(l), h).replace(new RegExp(Qh, "g"), kn);
        return f || (s ? v = Iu(kn, s.length) + " " + v : o && (v = Iu(kn, o.length) + this.getSeparatorAfterNationalPrefix(r) + v)), a && (v = dy(v)), v;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(r) {
      var n = Fre(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, r);
      if (!n) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = n[0], this.populatedNationalNumberTemplatePosition = n[1], Av(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(r, n) {
      var i = n.international, a = n.nationalPrefix;
      if (r.nationalPrefixFormattingRule()) {
        var o = r.usesNationalPrefix();
        if (o && a || !o && !i)
          return !0;
      }
    }
  }]), e;
}();
function $y(e, t) {
  return pne(e) || fne(e, t) || hne(e, t) || cne();
}
function cne() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hne(e, t) {
  if (e) {
    if (typeof e == "string") return Lv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Lv(e, t);
  }
}
function Lv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function fne(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], i = !0, a = !1, o, s;
    try {
      for (r = r.call(e); !(i = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); i = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (a) throw s;
      }
    }
    return n;
  }
}
function pne(e) {
  if (Array.isArray(e)) return e;
}
function mne(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function gne(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function vne(e, t, r) {
  return t && gne(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var yne = "[" + On + zr + "]+", bne = new RegExp("^" + yne + "$", "i"), $ne = "(?:[" + g0 + "][" + On + zr + "]*|[" + On + zr + "]+)", wne = new RegExp("[^" + On + zr + "]+.*$"), xne = /[^\d\[\]]/, kne = /* @__PURE__ */ function() {
  function e(t) {
    var r = t.defaultCountry, n = t.defaultCallingCode, i = t.metadata, a = t.onNationalSignificantNumberChange;
    mne(this, e), this.defaultCountry = r, this.defaultCallingCode = n, this.metadata = i, this.onNationalSignificantNumberChange = a;
  }
  return vne(e, [{
    key: "input",
    value: function(r, n) {
      var i = Sne(r), a = $y(i, 2), o = a[0], s = a[1], l = kc(o), d;
      return s && (n.digits || (n.startInternationalNumber(), l || (d = !0))), l && this.inputDigits(l, n), {
        digits: l,
        justLeadingPlus: d
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(r, n) {
      var i = n.digits, a = i.length < 3 && i.length + r.length >= 3;
      if (n.appendDigits(r), a && this.extractIddPrefix(n), this.isWaitingForCountryCallingCode(n)) {
        if (!this.extractCountryCallingCode(n))
          return;
      } else
        n.appendNationalSignificantNumberDigits(r);
      n.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(n.getNationalDigits(), function(o) {
        return n.update(o);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(r) {
      var n = r.international, i = r.callingCode;
      return n && !i;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(r) {
      var n = Tp("+" + r.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), i = n.countryCallingCode, a = n.number;
      if (i)
        return r.setCallingCode(i), r.update({
          nationalSignificantNumber: a
        }), !0;
    }
  }, {
    key: "reset",
    value: function(r) {
      if (r) {
        this.hasSelectedNumberingPlan = !0;
        var n = r._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = n && xne.test(n);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(r, n) {
      if (this.hasSelectedNumberingPlan) {
        var i = jh(r, this.metadata), a = i.nationalPrefix, o = i.nationalNumber, s = i.carrierCode;
        if (o !== r)
          return this.onExtractedNationalNumber(a, s, o, r, n), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(r, n, i) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(r, i);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var a = jh(r, this.metadata), o = a.nationalPrefix, s = a.nationalNumber, l = a.carrierCode;
        if (s !== n)
          return this.onExtractedNationalNumber(o, l, s, r, i), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(r, n, i, a, o) {
      var s, l, d = a.lastIndexOf(i);
      if (d >= 0 && d === a.length - i.length) {
        l = !0;
        var u = a.slice(0, d);
        u !== r && (s = u);
      }
      o({
        nationalPrefix: r,
        carrierCode: n,
        nationalSignificantNumber: i,
        nationalSignificantNumberMatchesInput: l,
        complexPrefixBeforeNationalSignificantNumber: s
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(r) {
      if (this.extractAnotherNationalSignificantNumber(r.getNationalDigits(), r.nationalSignificantNumber, function(n) {
        return r.update(n);
      }))
        return !0;
      if (this.extractIddPrefix(r))
        return this.extractCallingCodeAndNationalSignificantNumber(r), !0;
      if (this.fixMissingPlus(r))
        return this.extractCallingCodeAndNationalSignificantNumber(r), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(r) {
      var n = r.international, i = r.IDDPrefix, a = r.digits;
      if (r.nationalSignificantNumber, !(n || i)) {
        var o = sy(a, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (o !== void 0 && o !== a)
          return r.update({
            IDDPrefix: a.slice(0, a.length - o.length)
          }), this.startInternationalNumber(r, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(r) {
      if (!r.international) {
        var n = ly(r.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), i = n.countryCallingCode;
        if (n.number, i)
          return r.update({
            missingPlus: !0
          }), this.startInternationalNumber(r, {
            country: r.country,
            callingCode: i
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(r, n) {
      var i = n.country, a = n.callingCode;
      r.startInternationalNumber(i, a), r.nationalSignificantNumber && (r.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(r) {
      this.extractCountryCallingCode(r) && this.extractNationalSignificantNumber(r.getNationalDigits(), function(n) {
        return r.update(n);
      });
    }
  }]), e;
}();
function _ne(e) {
  var t = e.search($ne);
  if (!(t < 0)) {
    e = e.slice(t);
    var r;
    return e[0] === "+" && (r = !0, e = e.slice(1)), e = e.replace(wne, ""), r && (e = "+" + e), e;
  }
}
function Cne(e) {
  var t = _ne(e) || "";
  return t[0] === "+" ? [t.slice(1), !0] : [t];
}
function Sne(e) {
  var t = Cne(e), r = $y(t, 2), n = r[0], i = r[1];
  return bne.test(n) || (n = ""), [n, i];
}
function Ene(e, t) {
  return Ine(e) || One(e, t) || Ane(e, t) || Tne();
}
function Tne() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ane(e, t) {
  if (e) {
    if (typeof e == "string") return Fv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Fv(e, t);
  }
}
function Fv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function One(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], i = !0, a = !1, o, s;
    try {
      for (r = r.call(e); !(i = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); i = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (a) throw s;
      }
    }
    return n;
  }
}
function Ine(e) {
  if (Array.isArray(e)) return e;
}
function Pne(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Dne(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Mne(e, t, r) {
  return t && Dne(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var wy = /* @__PURE__ */ function() {
  function e(t, r) {
    Pne(this, e), this.metadata = new kr(r);
    var n = this.getCountryAndCallingCode(t), i = Ene(n, 2), a = i[0], o = i[1];
    this.defaultCountry = a, this.defaultCallingCode = o, this.reset();
  }
  return Mne(e, [{
    key: "getCountryAndCallingCode",
    value: function(r) {
      var n, i;
      return r && (Va(r) ? (n = r.defaultCountry, i = r.defaultCallingCode) : n = r), n && !this.metadata.hasCountry(n) && (n = void 0), [n, i];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(r) {
      var n = this.parser.input(r, this.state), i = n.digits, a = n.justLeadingPlus;
      if (a)
        this.formattedOutput = "+";
      else if (i) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var o;
        if (this.metadata.hasSelectedNumberingPlan() && (o = this.formatter.format(i, this.state)), o === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var s = this.state.getNationalDigits();
          s && (o = this.formatter.format(s, this.state));
        }
        this.formattedOutput = o ? this.getFullNumber(o) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var r = this;
      return this.state = new Dre({
        onCountryChange: function(i) {
          r.country = i;
        },
        onCallingCodeChange: function(i, a) {
          r.metadata.selectNumberingPlan(a, i), r.formatter.reset(r.metadata.numberingPlan, r.state), r.parser.reset(r.metadata.numberingPlan);
        }
      }), this.formatter = new une({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new kne({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          r.determineTheCountryIfNeeded(), r.formatter.reset(r.metadata.numberingPlan, r.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var r = this.state.digits;
      if (r)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var r = this.state.country;
      return r;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(r) {
      var n = this;
      if (this.isInternational()) {
        var i = function(s) {
          return n.formatter.getInternationalPrefixBeforeCountryCallingCode(n.state, {
            spacing: !!s
          }) + s;
        }, a = this.state.callingCode;
        return i(a ? r ? "".concat(a, " ").concat(r) : a : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return r;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var r = this.state, n = r.nationalSignificantNumber, i = r.complexPrefixBeforeNationalSignificantNumber, a = r.nationalPrefix, o = n, s = i || a;
      return s && (o = s + o), o;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var r = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(r ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var r = this.getNonFormattedNumber();
      if (r)
        return r.replace(/[\+\d]/g, kn);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var r = this.state.callingCode, n = this.metadata.getCountryCodesForCallingCode(r);
      return n && n.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(yy(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var r = this.state, n = r.digits, i = r.callingCode, a = r.country, o = r.nationalSignificantNumber;
      if (n) {
        if (this.isInternational())
          return i ? "+" + i + o : "+" + n;
        if (a || i) {
          var s = a ? this.metadata.countryCallingCode() : i;
          return "+" + s + o;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var r = this.state, n = r.nationalSignificantNumber, i = r.carrierCode, a = r.callingCode, o = this._getCountry();
      if (n && !(!o && !a)) {
        if (o && o === this.defaultCountry) {
          var s = new kr(this.metadata.metadata);
          s.selectNumberingPlan(o);
          var l = s.numberingPlan.callingCode(), d = this.metadata.getCountryCodesForCallingCode(l);
          if (d.length > 1) {
            var u = vy(n, {
              countries: d,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            u && (o = u);
          }
        }
        var c = new fy(o || a, n, this.metadata.metadata);
        return i && (c.carrierCode = i), c;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var r = this.getNumber();
      return r ? r.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var r = this.getNumber();
      return r ? r.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function R1() {
  return zee(Are, arguments);
}
function _c(e) {
  return wy.call(this, e, ny);
}
_c.prototype = Object.create(wy.prototype, {});
_c.prototype.constructor = _c;
const Nne = ".input::part(base){border-radius:var(--photon-border-radius, .5rem)}.invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.invalid::part(form-control-help-text){--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}.input{--sl-input-required-content-color: #f87171;--sl-input-label-font-size-medium: .875rem;--sl-input-label-color: #374151}.input::part(form-control-label){padding-bottom:.5rem}";
var lu = /* @__PURE__ */ K("<style>"), Lne = /* @__PURE__ */ K('<div class="md:py-2 flex flex-col font-sans"><sl-input class=input type=tel placeholder="(   ) ___-____"><p slot=help-text class="text-red-400 pt-1 h-[21px] font-sans">', !0, !1, !1);
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const Fne = (e) => {
  let t;
  const r = (i) => {
    const a = new CustomEvent("photon-phone-changed", {
      composed: !0,
      bubbles: !0,
      detail: {
        phone: i
      }
    });
    t?.dispatchEvent(a);
  };
  Et(() => {
    e.value && r(R1(e.value, "US").format("E.164"));
  });
  const n = L(() => e.value ? e.value.length > 2 ? new _c("US").input(R1(e.value, "US").formatNational()) : e.value : "");
  return [(() => {
    var i = lu();
    return A(i, Rt), i;
  })(), (() => {
    var i = lu();
    return A(i, Ur), i;
  })(), (() => {
    var i = lu();
    return A(i, qr), i;
  })(), (() => {
    var i = lu();
    return A(i, Nne), i;
  })(), (() => {
    var i = Lne(), a = i.firstChild, o = a.firstChild, s = t;
    return typeof s == "function" ? ze(s, i) : t = i, ce(a, "sl-input", (l) => {
      try {
        const d = R1(l.target.value, "US").format("E.164");
        r(d);
      } catch {
        r(l.target?.value || "");
      }
    }), a._$owner = fe(), A(o, () => e.helpText), J((l) => {
      var d = !!e.invalid, u = e.disabled, c = e.label, h = e.required, f = e.invalid;
      return d !== l.e && a.classList.toggle("invalid", l.e = d), u !== l.t && (a.disabled = l.t = u), c !== l.a && (a.label = l.a = c), h !== l.o && (a.required = l.o = h), f !== l.i && (a.invalid = l.i = f), l;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0
    }), J(() => a.value = n()), i;
  })()];
};
Tt("photon-phone-input", {
  label: void 0,
  required: !1,
  value: void 0,
  invalid: !1,
  helpText: void 0,
  disabled: !1
}, Fne);
const Rne = ".input::part(base){border-radius:var(--photon-border-radius, .5rem)}.invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.invalid::part(form-control-help-text){--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}";
var zne = /* @__PURE__ */ K("<div><style></style><style>");
const Gh = [{
  id: "1",
  name: "Male"
}, {
  id: "2",
  name: "Female"
}, {
  id: "3",
  name: "Unknown"
}], jne = (e) => {
  let t;
  const r = (n) => {
    const i = new CustomEvent("photon-sex-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        sex: n
      }
    });
    t?.dispatchEvent(i);
  };
  return (() => {
    var n = zne(), i = n.firstChild, a = i.nextSibling;
    ce(n, "photon-data-selected", (s) => {
      r(s.detail.data.name.toUpperCase());
    });
    var o = t;
    return typeof o == "function" ? ze(o, n) : t = n, A(i, Rt), A(a, Rne), A(n, b(lo, {
      data: Gh,
      get label() {
        return e.label;
      },
      get required() {
        return e.required;
      },
      placeholder: "",
      get disabled() {
        return e.disabled;
      },
      get invalid() {
        return e.invalid;
      },
      isLoading: !1,
      hasMore: !1,
      displayAccessor: (s) => s?.name || "",
      showOverflow: !0,
      noDataMsg: "",
      optional: !1,
      get helpText() {
        return e.helpText;
      },
      get selectedData() {
        return Gh.filter((s) => s.name.toUpperCase() === e.selected)?.[0];
      }
    }), null), n;
  })();
};
Tt("photon-sex-input", {
  label: void 0,
  required: !1,
  value: void 0,
  invalid: !1,
  helpText: void 0,
  disabled: !1,
  selected: void 0
}, jne);
const Vne = ".input::part(base){border-radius:var(--photon-border-radius, .5rem)}.invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.invalid::part(form-control-help-text){--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}";
var Une = /* @__PURE__ */ K("<div><style></style><style>");
const z1 = [{
  id: "1",
  name: "Male/Man"
}, {
  id: "2",
  name: "Female/Woman"
}, {
  id: "3",
  name: "TransMale/TransMan"
}, {
  id: "4",
  name: "TransFemale/TransWoman"
}, {
  id: "5",
  name: "Genderqueery/Gender nonconforming"
}, {
  id: "6",
  name: "Something else"
}, {
  id: "7",
  name: "Decline to answer"
}], qne = (e) => {
  const [t, r] = H("");
  let n;
  const i = (s) => s.length === 0 ? z1 : z1.filter((l) => l.name.toLowerCase().includes(s.toLowerCase())), a = (s) => {
    const l = new CustomEvent("photon-gender-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        gender: s
      }
    });
    n?.dispatchEvent(l);
  }, o = () => {
    const s = new CustomEvent("photon-gender-deselected", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    n?.dispatchEvent(s);
  };
  return (() => {
    var s = Une(), l = s.firstChild, d = l.nextSibling;
    ce(s, "photon-data-unselected", () => {
      o();
    }), ce(s, "photon-data-selected", (c) => {
      a(c.detail.data.name);
    });
    var u = n;
    return typeof u == "function" ? ze(u, s) : n = s, A(l, Rt), A(d, Vne), A(s, b(lo, {
      get data() {
        return i(t());
      },
      get label() {
        return e.label;
      },
      get required() {
        return e.required;
      },
      placeholder: "",
      get disabled() {
        return e.disabled;
      },
      get invalid() {
        return e.invalid;
      },
      isLoading: !1,
      hasMore: !1,
      displayAccessor: (c) => c?.name || "",
      showOverflow: !0,
      onSearchChange: async (c) => {
        r(c);
      },
      onHide: async () => {
        r("");
      },
      noDataMsg: "",
      get optional() {
        return !e.required;
      },
      get helpText() {
        return e.helpText;
      },
      get selectedData() {
        return z1.filter((c) => c.name === e.selected)?.[0];
      }
    }), null), s;
  })();
};
Tt("photon-gender-input", {
  label: void 0,
  required: !1,
  value: void 0,
  invalid: !1,
  helpText: void 0,
  disabled: !1,
  selected: void 0
}, qne);
var Bne = /* @__PURE__ */ K('<div class="w-full flex justify-center">'), Hne = /* @__PURE__ */ K('<div class=mb-4><photon-gender-input label="Gender (optional)"required=false></photon-gender-input><photon-text-input class=w-full debounce-time=0 label="Email (optional)"></photon-text-input><p class="font-sans text-sm m-0">Preferred pharmacy (optional)', !0, !1, !1), Wne = /* @__PURE__ */ K('<div><p class="font-sans text-lg flex-grow">Patient info</p><div class="flex flex-col"><photon-text-input class=w-full debounce-time=0 label="First name"required=true></photon-text-input><photon-text-input class=w-full debounce-time=0 label="Last name"required=true></photon-text-input><photon-datepicker no-initial-date=true class=w-full label="Date of birth"required=true></photon-datepicker><photon-phone-input class=w-full label="Mobile number"required=true></photon-phone-input><photon-sex-input label="Sex at birth"required=true></photon-sex-input></div><p class="font-sans text-lg mt-8">Address</p><photon-text-input debounce-time=0 label="Street 1"required=true></photon-text-input><photon-text-input debounce-time=0 label="Street 2"></photon-text-input><photon-text-input debounce-time=0 label=City required=true></photon-text-input><div class="flex gap-4"><photon-state-input class="flex-grow min-w-[40%]"label=State required=true></photon-state-input><photon-text-input debounce-time=0 class="flex-grow min-w-[40%]"label="Zip code"required=true></photon-text-input></div><button class="mb-4 flex items-center"><span class="font-sans text-lg">Show optional fields', !0, !1, !1), Qne = /* @__PURE__ */ K('<div class="flex flex-col gap-8">'), Gne = /* @__PURE__ */ K('<div class="w-full h-full relative"><style></style><style></style><style></style><style>');
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const Yne = (e, t) => {
  const r = e.selectedPatient.data?.address;
  return t.address_zip?.value && MQ(t.address_zip?.value) && t.address_zip?.value != r?.postalCode ? t.address_zip?.value : r ? `${r.street1} ${r.street2 ?? ""} ${r.city}, ${r.state} ${r.postalCode}` : "";
}, Kne = (e) => {
  let t;
  const r = Xr(), [n, i] = H(!1), {
    store: a,
    actions: o
  } = _d, {
    store: s,
    actions: l
  } = M8({
    firstName: void 0,
    lastName: void 0,
    dateOfBirth: void 0,
    phone: void 0,
    gender: void 0,
    sex: void 0,
    email: void 0,
    address_street1: void 0,
    address_street2: void 0,
    address_city: void 0,
    address_state: void 0,
    address_zip: void 0,
    preferredPharmacy: void 0
  });
  l.registerValidator({
    key: "firstName",
    validator: sr(Ca(sn(), 1, 1 / 0), "Please enter a first name.")
  }), l.registerValidator({
    key: "lastName",
    validator: sr(Ca(sn(), 1, 1 / 0), "Please enter a last name.")
  }), l.registerValidator({
    key: "dateOfBirth",
    validator: sr(Wg([YX, rv()]), "Please enter a valid date of birth.")
  }), l.registerValidator({
    key: "sex",
    validator: sr(LK(Gh.map((c) => c.name.toUpperCase())), "Please enter Sex at Birth.")
  }), l.registerValidator({
    key: "phone",
    validator: sr(Ca(sn(), 12), "Please enter a valid mobile number.")
  }), l.registerValidator({
    key: "email",
    validator: sr(Wg([XX(), rv()]), "Please enter a valid email.")
  }), l.registerValidator({
    key: "address_street1",
    validator: sr(Ca(sn(), 1, 1 / 0), "Please enter a valid Street 1.")
  }), l.registerValidator({
    key: "address_city",
    validator: sr(Ca(sn(), 1, 1 / 0), "Please enter a valid City.")
  }), l.registerValidator({
    key: "address_state",
    validator: sr(Ca(sn(), 2, 2), "Please enter a valid State.")
  }), l.registerValidator({
    key: "address_zip",
    validator: sr(ZX(), "Please enter a valid zip code.")
  }), Et(() => {
    e.patientId ? o.getSelectedPatient(r.getSDK(), e.patientId) : o.clearSelectedPatient();
  });
  const d = (c) => {
    const h = new CustomEvent("photon-form-updated", {
      composed: !0,
      bubbles: !0,
      detail: {
        form: c,
        actions: l,
        selected: a,
        reset: () => {
          l.reset(), o.reset();
        }
      }
    });
    t?.dispatchEvent(h);
  };
  me(() => {
    a.selectedPatient.data && (l.updateFormValue({
      key: "firstName",
      value: a.selectedPatient.data.name.first
    }), l.updateFormValue({
      key: "lastName",
      value: a.selectedPatient.data.name.last
    }), l.updateFormValue({
      key: "phone",
      value: a.selectedPatient.data.phone
    }), l.updateFormValue({
      key: "gender",
      value: a.selectedPatient.data.gender
    }), l.updateFormValue({
      key: "sex",
      value: a.selectedPatient.data.sex
    }), l.updateFormValue({
      key: "email",
      value: a.selectedPatient.data.email
    }), l.updateFormValue({
      key: "address_street1",
      value: a.selectedPatient.data.address?.street1
    }), l.updateFormValue({
      key: "address_street2",
      value: a.selectedPatient.data.address?.street2
    }), l.updateFormValue({
      key: "address_city",
      value: a.selectedPatient.data.address?.city
    }), l.updateFormValue({
      key: "address_state",
      value: a.selectedPatient.data.address?.state
    }), l.updateFormValue({
      key: "address_zip",
      value: a.selectedPatient.data.address?.postalCode
    }), l.updateFormValue({
      key: "preferredPharmacy",
      value: a.selectedPatient.data.preferredPharmacies?.[0]?.id
    }));
  }), me(() => {
    d(s);
  }), xr(() => {
    o.clearSelectedPatient(), l.reset();
  });
  const u = L(() => {
    const c = a.selectedPatient.data?.preferredPharmacies?.[0];
    if (!c) return;
    const h = c.address;
    return {
      ...c,
      address: h,
      isPrevious: !0,
      isPreferred: !0
    };
  });
  return (() => {
    var c = Gne(), h = c.firstChild, f = h.nextSibling, p = f.nextSibling, g = p.nextSibling, v = t;
    return typeof v == "function" ? ze(v, c) : t = c, A(h, Rt), A(f, Ur), A(p, qr), A(g, oi), A(c, b(X, {
      get when() {
        return a.selectedPatient.isLoading;
      },
      get children() {
        var m = Bne();
        return A(m, b(ni, {
          color: "green"
        })), m;
      }
    }), null), A(c, b(X, {
      get when() {
        return !a.selectedPatient.isLoading;
      },
      get children() {
        return b(F8, {
          permissions: ["write:patient"],
          get children() {
            var m = Qne();
            return A(m, b(hn, {
              get children() {
                var $ = Wne(), w = $.firstChild, k = w.nextSibling, C = k.firstChild, E = C.nextSibling, N = E.nextSibling, M = N.nextSibling, V = M.nextSibling, q = k.nextSibling, I = q.nextSibling, P = I.nextSibling, z = P.nextSibling, G = z.nextSibling, se = G.firstChild, ue = se.nextSibling, de = G.nextSibling;
                return de.firstChild, ce(C, "photon-input-changed", async (D) => {
                  l.updateFormValue({
                    key: "firstName",
                    value: D.detail.input
                  });
                }), C._$owner = fe(), ce(E, "photon-input-changed", async (D) => {
                  l.updateFormValue({
                    key: "lastName",
                    value: D.detail.input
                  });
                }), E._$owner = fe(), ce(N, "photon-datepicker-selected", async (D) => {
                  l.updateFormValue({
                    key: "dateOfBirth",
                    value: D.detail.date
                  });
                }), N._$owner = fe(), ce(M, "photon-phone-changed", async (D) => {
                  l.updateFormValue({
                    key: "phone",
                    value: D.detail.phone
                  });
                }), M._$owner = fe(), ce(V, "photon-sex-deselected", () => {
                  l.updateFormValue({
                    key: "sex",
                    value: void 0
                  });
                }), ce(V, "photon-sex-selected", (D) => {
                  l.updateFormValue({
                    key: "sex",
                    value: D.detail.sex
                  });
                }), V._$owner = fe(), ce(I, "photon-input-changed", async (D) => {
                  l.updateFormValue({
                    key: "address_street1",
                    value: D.detail.input
                  });
                }), I._$owner = fe(), ce(P, "photon-input-changed", async (D) => {
                  l.updateFormValue({
                    key: "address_street2",
                    value: D.detail.input
                  });
                }), P.optional = !0, P._$owner = fe(), ce(z, "photon-input-changed", async (D) => {
                  l.updateFormValue({
                    key: "address_city",
                    value: D.detail.input
                  });
                }), z._$owner = fe(), ce(se, "photon-state-selected", (D) => {
                  l.updateFormValue({
                    key: "address_state",
                    value: D.detail.state
                  });
                }), se._$owner = fe(), ce(ue, "photon-input-changed", async (D) => {
                  l.updateFormValue({
                    key: "address_zip",
                    value: D.detail.input
                  });
                }), ue._$owner = fe(), de.$$click = () => i((D) => !D), A(de, b(rt, {
                  get name() {
                    return n() ? "chevronUp" : "chevronDown";
                  },
                  size: "md",
                  class: "inline-block ml-1 mt-1"
                }), null), A($, b(X, {
                  get when() {
                    return n();
                  },
                  get children() {
                    var D = Hne(), R = D.firstChild, Q = R.nextSibling;
                    return Q.nextSibling, ce(R, "photon-gender-deselected", () => {
                      l.updateFormValue({
                        key: "gender",
                        value: void 0
                      });
                    }), ce(R, "photon-gender-selected", (Z) => {
                      l.updateFormValue({
                        key: "gender",
                        value: Z.detail.gender
                      });
                    }), R._$owner = fe(), ce(Q, "photon-input-changed", async (Z) => {
                      l.updateFormValue({
                        key: "email",
                        value: Z.detail.input
                      });
                    }), Q._$owner = fe(), A(D, b(N6, {
                      get address() {
                        return Yne(a, s);
                      },
                      setPharmacy: (Z) => {
                        l.updateFormValue({
                          key: "preferredPharmacy",
                          value: Z.id
                        });
                      },
                      get patientId() {
                        return e.patientId;
                      },
                      get initialValue() {
                        return u();
                      },
                      hidePreferred: !0
                    }), null), J((Z) => {
                      var F = s.gender?.error, oe = s.gender?.error !== void 0, pe = a.selectedPatient.data?.gender, ee = s.email?.error, re = s.email?.error;
                      return F !== Z.e && (R.helpText = Z.e = F), oe !== Z.t && (R.invalid = Z.t = oe), pe !== Z.a && (R.selected = Z.a = pe), ee !== Z.o && (Q.invalid = Z.o = ee), re !== Z.i && (Q.helpText = Z.i = re), Z;
                    }, {
                      e: void 0,
                      t: void 0,
                      a: void 0,
                      o: void 0,
                      i: void 0
                    }), J(() => Q.value = s.email?.value ?? a.selectedPatient.data?.email), D;
                  }
                }), null), J((D) => {
                  var R = s.firstName?.error, Q = s.firstName?.error, Z = s.lastName?.error, F = s.lastName?.error, oe = s.dateOfBirth?.error, pe = s.dateOfBirth?.error, ee = s.phone?.error, re = s.phone?.error, Ie = s.sex?.error, Pe = s.sex?.error !== void 0, at = a.selectedPatient.data?.sex, Xe = s.address_street1?.error, ft = s.address_street1?.error, bt = s.address_street2?.error, le = s.address_street2?.error, Y = s.address_city?.error, ve = s.address_city?.error, xe = s.address_state?.error, Qe = s.address_state?.error !== void 0, Fe = s.state?.value ?? a.selectedPatient.data?.address?.state, He = s.address_zip?.error, Ge = s.address_zip?.error;
                  return R !== D.e && (C.invalid = D.e = R), Q !== D.t && (C.helpText = D.t = Q), Z !== D.a && (E.invalid = D.a = Z), F !== D.o && (E.helpText = D.o = F), oe !== D.i && (N.invalid = D.i = oe), pe !== D.n && (N.helpText = D.n = pe), ee !== D.s && (M.invalid = D.s = ee), re !== D.h && (M.helpText = D.h = re), Ie !== D.r && (V.helpText = D.r = Ie), Pe !== D.d && (V.invalid = D.d = Pe), at !== D.l && (V.selected = D.l = at), Xe !== D.u && (I.invalid = D.u = Xe), ft !== D.c && (I.helpText = D.c = ft), bt !== D.w && (P.invalid = D.w = bt), le !== D.m && (P.helpText = D.m = le), Y !== D.f && (z.invalid = D.f = Y), ve !== D.y && (z.helpText = D.y = ve), xe !== D.g && (se.helpText = D.g = xe), Qe !== D.p && (se.invalid = D.p = Qe), Fe !== D.b && (se.selected = D.b = Fe), He !== D.T && (ue.invalid = D.T = He), Ge !== D.A && (ue.helpText = D.A = Ge), D;
                }, {
                  e: void 0,
                  t: void 0,
                  a: void 0,
                  o: void 0,
                  i: void 0,
                  n: void 0,
                  s: void 0,
                  h: void 0,
                  r: void 0,
                  d: void 0,
                  l: void 0,
                  u: void 0,
                  c: void 0,
                  w: void 0,
                  m: void 0,
                  f: void 0,
                  y: void 0,
                  g: void 0,
                  p: void 0,
                  b: void 0,
                  T: void 0,
                  A: void 0
                }), J(() => C.value = s.firstName?.value ?? a.selectedPatient.data?.name.first), J(() => E.value = s.lastName?.value ?? a.selectedPatient.data?.name.last), J(() => N.value = e.patientId ? a.selectedPatient.data?.dateOfBirth : s.dateOfBirth?.value), J(() => M.value = s.phone?.value ?? a.selectedPatient.data?.phone), J(() => I.value = s.address_street1?.value ?? a.selectedPatient.data?.address?.street1), J(() => P.value = s.address_street2?.value ?? a.selectedPatient.data?.address?.street2), J(() => z.value = s.address_city?.value ?? a.selectedPatient.data?.address?.city), J(() => ue.value = s.address_zip?.value ?? a.selectedPatient.data?.address?.postalCode), $;
              }
            })), m;
          }
        });
      }
    }), null), c;
  })();
};
Tt("photon-patient-form", {
  patientId: ""
}, Kne);
da(["click"]);
const Zne = ".input::part(base){border-radius:var(--photon-border-radius, .5rem)}.invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.invalid::part(form-control-help-text){--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}";
var Xne = /* @__PURE__ */ K("<div><style></style><style>");
const j1 = [{
  id: "1",
  name: "AL"
}, {
  id: "2",
  name: "AK"
}, {
  id: "3",
  name: "AZ"
}, {
  id: "4",
  name: "AR"
}, {
  id: "5",
  name: "CA"
}, {
  id: "6",
  name: "CO"
}, {
  id: "7",
  name: "CT"
}, {
  id: "8",
  name: "DE"
}, {
  id: "9",
  name: "DC"
}, {
  id: "10",
  name: "FL"
}, {
  id: "11",
  name: "GA"
}, {
  id: "12",
  name: "HI"
}, {
  id: "13",
  name: "ID"
}, {
  id: "14",
  name: "IL"
}, {
  id: "15",
  name: "IN"
}, {
  id: "16",
  name: "IA"
}, {
  id: "17",
  name: "KS"
}, {
  id: "18",
  name: "KY"
}, {
  id: "19",
  name: "LA"
}, {
  id: "20",
  name: "ME"
}, {
  id: "21",
  name: "MD"
}, {
  id: "22",
  name: "MA"
}, {
  id: "23",
  name: "MI"
}, {
  id: "24",
  name: "MN"
}, {
  id: "25",
  name: "MS"
}, {
  id: "26",
  name: "MO"
}, {
  id: "27",
  name: "MT"
}, {
  id: "28",
  name: "NE"
}, {
  id: "29",
  name: "NV"
}, {
  id: "30",
  name: "NH"
}, {
  id: "31",
  name: "NJ"
}, {
  id: "32",
  name: "NM"
}, {
  id: "33",
  name: "NY"
}, {
  id: "34",
  name: "NC"
}, {
  id: "35",
  name: "ND"
}, {
  id: "36",
  name: "OH"
}, {
  id: "37",
  name: "OK"
}, {
  id: "38",
  name: "OR"
}, {
  id: "39",
  name: "PA"
}, {
  id: "40",
  name: "PR"
}, {
  id: "41",
  name: "RI"
}, {
  id: "42",
  name: "SC"
}, {
  id: "43",
  name: "SD"
}, {
  id: "44",
  name: "TN"
}, {
  id: "45",
  name: "TX"
}, {
  id: "46",
  name: "UT"
}, {
  id: "47",
  name: "VT"
}, {
  id: "48",
  name: "VA"
}, {
  id: "49",
  name: "WA"
}, {
  id: "50",
  name: "WV"
}, {
  id: "51",
  name: "WI"
}, {
  id: "52",
  name: "WY"
}], Jne = (e) => {
  const [t, r] = H("");
  let n;
  const i = (o) => {
    const s = new CustomEvent("photon-state-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        state: o
      }
    });
    n?.dispatchEvent(s);
  }, a = (o) => o.length === 0 ? j1 : j1.filter((s) => s.name.toLowerCase().includes(o.toLowerCase()));
  return (() => {
    var o = Xne(), s = o.firstChild, l = s.nextSibling;
    ce(o, "photon-data-selected", (u) => {
      i(u.detail.data.name);
    });
    var d = n;
    return typeof d == "function" ? ze(d, o) : n = o, A(s, Rt), A(l, Zne), A(o, b(lo, {
      get data() {
        return a(t());
      },
      get label() {
        return e.label;
      },
      get required() {
        return e.required;
      },
      placeholder: "",
      get disabled() {
        return e.disabled;
      },
      get invalid() {
        return e.invalid;
      },
      isLoading: !1,
      hasMore: !1,
      displayAccessor: (u) => u?.name || "",
      showOverflow: !0,
      onSearchChange: async (u) => {
        r(u);
      },
      onHide: async () => {
        r("");
      },
      noDataMsg: "",
      optional: !1,
      get helpText() {
        return e.helpText;
      },
      get selectedData() {
        return j1.filter((u) => u.name === e.selected)?.[0];
      }
    }), null), o;
  })();
};
Tt("photon-state-input", {
  label: void 0,
  required: !1,
  value: void 0,
  invalid: !1,
  helpText: void 0,
  disabled: !1,
  selected: void 0
}, Jne);
var eie = /* @__PURE__ */ K('<div class="text-black text-xl md:text-3xl">'), tie = /* @__PURE__ */ K("<sl-icon class=flex-shrink-0>", !0, !1, !1), rie = /* @__PURE__ */ K('<footer class="z-40 fixed bottom-0 w-full bg-white shadow-card px-4 py-4 md:px-8"><div class="flex flex-col xs:flex-row-reverse xs:justify-start gap-2 items-center w-full sm:w-[600px] xs:mx-auto sm:px-4">'), nie = /* @__PURE__ */ K('<div class="z-50 fixed top-0 left-0 w-full h-screen overflow-y-scroll bg-[#F9FAFB]"><style></style><photon-dialog confirm-text="Yes, Close"cancel-text="Keep Editing"><p class="font-sans text-lg xs:text-base"></p></photon-dialog><header class="z-40 flex items-center px-4 py-2 md:px-8 md:py-3 bg-white fixed w-full shadow-card"><div class="flex items-center"></div><div class="flex-1 flex justify-center items-center min-w-0 px-2"><p class="ml-1 font-sans text-lg md:text-xl font-medium truncate"></p></div><div class="flex items-center w-[44px]"></div></header><div class="z-30 w-full min-h-screen bg-[#F9FAFB] pt-14"><div class="px-4 pb-40 md:pt-4 md:pb-52 md:px-4 w-full h-full sm:w-[600px] xs:mx-auto">', !0, !1, !1);
const xy = (e) => {
  const t = Be({
    closeTitle: "Lose unsaved changes?",
    closeBody: "You will not be able to recover unsaved changes.",
    checkShouldWarn: () => !1
  }, e);
  let r;
  const [n, i] = H(!1), a = () => {
    i(!1), t.onClosed();
  }, o = () => i(!1);
  return (() => {
    var s = nie(), l = s.firstChild, d = l.nextSibling, u = d.firstChild, c = d.nextSibling, h = c.firstChild, f = h.nextSibling, p = f.firstChild, g = c.nextSibling, v = g.firstChild, m = r;
    return typeof m == "function" ? ze(m, s) : r = s, A(l, Rt), ce(d, "photon-dialog-alt", o), ce(d, "photon-dialog-canceled", o), ce(d, "photon-dialog-confirmed", a), d._$owner = fe(), A(u, () => t.closeBody), A(h, b(st, {
      variant: "naked",
      size: "sm",
      onClick: () => {
        t.checkShouldWarn() ? i(!0) : t.onClosed();
      },
      get children() {
        var $ = eie();
        return A($, b(rt, {
          name: "xMark"
        })), $;
      }
    })), A(f, b(X, {
      get when() {
        return t.titleIconName;
      },
      get children() {
        var $ = tie();
        return $._$owner = fe(), J(() => $.name = t.titleIconName), $;
      }
    }), p), A(p, () => t.title), A(v, () => t.form), A(s, b(X, {
      get when() {
        return t.footer;
      },
      get children() {
        var $ = rie(), w = $.firstChild;
        return A(w, () => t.footer), $;
      }
    }), null), J(($) => {
      var w = t.closeTitle, k = n();
      return w !== $.e && (d.label = $.e = w), k !== $.t && (d.open = $.t = k), $;
    }, {
      e: void 0,
      t: void 0
    }), s;
  })();
};
var iie = /* @__PURE__ */ K("<div><style>"), aie = /* @__PURE__ */ K('<div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"role=alert><span class="block sm:inline">'), oie = /* @__PURE__ */ K("<photon-patient-form slot=form>", !0, !1, !1);
const sie = (e) => {
  let t;
  const r = Xr(), [n, i] = H(!1), [a, o] = H(!1), [s, l] = H(void 0), [d, u] = H(void 0), [c, h] = H(void 0), [f, p] = H(void 0), g = (w, k = !1) => {
    const C = new CustomEvent("photon-patient-updated", {
      composed: !0,
      bubbles: !0,
      detail: {
        patientId: w,
        createPrescription: k
      }
    });
    t?.dispatchEvent(C);
  }, v = (w, k = !1) => {
    const C = new CustomEvent("photon-patient-created", {
      composed: !0,
      bubbles: !0,
      detail: {
        patientId: w,
        createPrescription: k
      }
    });
    t?.dispatchEvent(C);
  }, m = () => {
    const w = new CustomEvent("photon-patient-closed", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(w);
  }, $ = async (w, k, C, E = !1) => {
    p(void 0), o(E), i(!0);
    const N = ["firstName", "lastName", "dateOfBirth", "phone", "sex", "email", "address_street1", "address_city", "address_state", "address_zip"];
    if (k.validate(N), k.hasErrors(N))
      return i(!1), !0;
    w.preferredPharmacy.value && C.selectedPatient.data?.preferredPharmacies && C.selectedPatient.data?.preferredPharmacies.length !== 0 && !C.selectedPatient.data?.preferredPharmacies?.map((V) => V?.id).filter((V) => V !== null).includes(w.preferredPharmacy.value) && await r.getSDK().clinical.patient.removePatientPreferredPharmacy({})({
      variables: {
        patientId: e.patientId,
        pharmacyId: C.selectedPatient.data?.preferredPharmacies[0].id
      },
      awaitRefetchQueries: !1
    });
    const M = {
      ...e?.patientId ? {
        id: e.patientId
      } : {},
      name: {
        first: w.firstName.value,
        last: w.lastName.value
      },
      gender: w.gender.value,
      email: w.email.value ? w.email.value : void 0,
      phone: w.phone.value,
      dateOfBirth: w.dateOfBirth.value,
      sex: w.sex.value,
      address: w.address_street1.value !== void 0 ? {
        street1: w.address_street1.value,
        street2: w.address_street2.value,
        city: w.address_city.value,
        state: w.address_state.value,
        postalCode: w.address_zip.value,
        country: "US"
      } : void 0,
      preferredPharmacies: w.preferredPharmacy.value ? [w.preferredPharmacy.value] : []
    };
    try {
      if (e?.patientId)
        await r.getSDK().clinical.patient.updatePatient({})({
          variables: M,
          awaitRefetchQueries: !1
        }), g(e.patientId, E);
      else {
        const q = await r.getSDK().clinical.patient.createPatient({})({
          variables: M,
          awaitRefetchQueries: !1
        });
        v(q?.data?.createPatient?.id || "", E);
      }
      i(!1), k.resetStores(), e.open = !1;
    } catch (V) {
      i(!1), p(V?.message || "An error occurred while saving the patient.");
    }
  };
  return (() => {
    var w = iie(), k = w.firstChild, C = t;
    return typeof C == "function" ? ze(C, w) : t = w, A(k, oi), A(w, b(X, {
      get when() {
        return e.open;
      },
      get children() {
        return b(xy, {
          onClosed: () => {
            m(), c().resetStores(), e.open = !1;
          },
          get title() {
            return e?.patientId ? "Edit patient" : "New patient";
          },
          get titleIconName() {
            return e?.patientId ? "pencil-square" : "person-plus";
          },
          get footer() {
            return [b(X, {
              get when() {
                return !e?.hideCreatePrescription;
              },
              get children() {
                return b(st, {
                  class: "w-full xs:w-fit",
                  size: "lg",
                  get disabled() {
                    return n();
                  },
                  get loading() {
                    return L(() => !!n())() && a();
                  },
                  onClick: () => $(s(), c(), d(), !0),
                  get children() {
                    return [L(() => e?.patientId ? "Save" : "Create"), " and start prescription"];
                  }
                });
              }
            }), b(st, {
              class: "w-full xs:w-fit",
              size: "lg",
              get variant() {
                return e?.hideCreatePrescription ? "primary" : "secondary";
              },
              get disabled() {
                return n();
              },
              get loading() {
                return L(() => !!n())() && !a();
              },
              onClick: () => $(s(), c(), d(), !1),
              get children() {
                return e?.patientId ? "Save" : "Create";
              }
            })];
          },
          get form() {
            return [b(X, {
              get when() {
                return f();
              },
              get children() {
                var E = aie(), N = E.firstChild;
                return A(N, f), E;
              }
            }), (() => {
              var E = oie();
              return ce(E, "photon-form-updated", (N) => {
                l(N.detail.form), h(Object.assign({}, N.detail.actions, {
                  resetStores: N.detail.reset
                })), u(N.detail.selected);
              }), E._$owner = fe(), J(() => E.patientId = e.patientId), E;
            })()];
          }
        });
      }
    }), null), w;
  })();
};
Tt("photon-patient-dialog", {
  patientId: "",
  hideCreatePrescription: !1,
  open: !1
}, sie);
var lie = /* @__PURE__ */ K("<photon-patient-dialog>", !0, !1, !1);
const die = (e) => (console.warn("photon-update-patient-dialog will be deprecated soon. Please use photon-patient-dialog instead."), (() => {
  var t = lie();
  return t._$owner = fe(), J((r) => {
    var n = e.patientId, i = e.open;
    return n !== r.e && (t.patientId = r.e = n), i !== r.t && (t.open = r.t = i), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})());
Tt("photon-update-patient-dialog", {
  patientId: "",
  open: !1
}, die);
const uie = ".invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.input::part(base){border-radius:var(--photon-border-radius, .5rem)}.input::part(base):hover{cursor:pointer}.disabled::part(base):hover{cursor:not-allowed}.selected::part(base){--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.default::part(base):hover{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity))}.default::part(label){width:100%;overflow:hidden}.group-member::part(base){padding-left:1rem;font-weight:500}.group{background:#d1e9ff;padding-top:.25rem;padding-bottom:.25rem;--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity));font-size:.75rem;font-weight:500}.treatment-option::part(checked-icon){display:none;width:0px}.full-screen-close-btn::part(base){padding:0}.treatment-search::part(input){padding-right:0}.treatment-search::part(input)::-moz-placeholder{--tw-text-opacity: 1;color:rgb(209,213,219,var(--tw-text-opacity))}.treatment-search::part(input)::placeholder{--tw-text-opacity: 1;color:rgb(209,213,219,var(--tw-text-opacity))}.dropdown::part(panel){box-shadow:none}.dropdown-container{height:100vh;height:100dvh;max-height:100dvh}.dropdown-container-list-items{-webkit-overflow-scrolling:touch;overscroll-behavior:contain;touch-action:pan-y}";
var cie = /* @__PURE__ */ K('<div slot=suffix class=flex><sl-icon class="text-gray-400 hover:text-gray-600"name=x-circle-fill>', !0, !1, !1), hie = /* @__PURE__ */ K('<div><style></style><style></style><style></style><style></style><div class="dropdown-container fixed top-0 left-0 w-full bg-white overflow-hidden z-2000 flex flex-col"><div class="flex items-center pb-2 pl-5 pr-5 pt-3 flex-shrink-0"><div class="flex items-center"><sl-icon-button name=x label="Close medication search"class=full-screen-close-btn></sl-icon-button></div></div><div class=flex-shrink-0><sl-input slot=trigger clearable autocomplete=off size=medium class="treatment-search input mb-2 px-4"><p slot=help-text class="text-red-400 pt-1 font-sans"></p><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div></sl-input></div><div class="w-full flex-1 overflow-y-auto .dropdown-container-list-items">', !0, !1, !1), fie = /* @__PURE__ */ K('<div class="md:flex flex-1 justify-center items-center pl-2"><div class="flex items-center space-x-2"><p class="text-gray-700 text-sm font-sans inline font-medium">'), pie = /* @__PURE__ */ K('<p class="pl-1 text-red-400">*'), mie = /* @__PURE__ */ K('<p class="text-gray-400 text-xs pl-2 font-sans">Optional'), gie = /* @__PURE__ */ K("<div class=px-4><p class=text-gray-400>Loading..."), vie = /* @__PURE__ */ K("<div class=px-4><p class=text-gray-400>No treatments found"), yie = /* @__PURE__ */ K('<div class="group uppercase px-4">'), bie = /* @__PURE__ */ K("<div class=treatment-option>"), $ie = /* @__PURE__ */ K('<p class="text-center text-gray-400 italic px-3">Loading...'), wie = /* @__PURE__ */ K('<p class="text-center text-gray-400 italic px-3">Nothing more to load'), xie = /* @__PURE__ */ K('<div class="px-4 py-1">');
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const kie = (e) => {
  let t, r, n;
  e.actionRef && (e.actionRef.clear = () => {
    n.value = "", i(""), s();
  });
  const i = $d(async (u) => {
    e.onSearchChange && await e.onSearchChange(u);
  }, 500), a = (u) => {
    if (u)
      return e.helpText ? e.helpText : e.required ? "Please select data..." : void 0;
  }, o = (u) => {
    const c = new CustomEvent("photon-data-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        data: u
      }
    });
    t?.dispatchEvent(c);
  }, s = () => {
    const u = new CustomEvent("photon-data-unselected", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(u);
  };
  Et(() => {
    n && (n.addEventListener("keydown", (u) => {
      (u.code == "Space" || u.key == " ") && u.stopImmediatePropagation();
    }), setTimeout(() => {
      n.focus();
    }, 100));
  }), me(() => {
    if (e.open) {
      const u = window.scrollY;
      document.body.style.position = "fixed", document.body.style.top = `-${u}px`, document.body.style.width = "100%", document.body.style.overflow = "hidden", xr(() => {
        const c = document.body.style.top;
        document.body.style.position = "", document.body.style.top = "", document.body.style.width = "", document.body.style.overflow = "", window.scrollTo(0, parseInt(c || "0") * -1);
      });
    }
  });
  const l = L(() => e.groups ? e.groups.map((u) => {
    const c = e.data.map((h, f) => ({
      data: h,
      allItemsIdx: f
    })).filter((h) => u.filter(h.data));
    return c.length > 0 ? [{
      title: u.label
    }, ...c] : [];
  }).flat() : e.data.map((u, c) => ({
    data: u,
    allItemsIdx: c
  }))), d = L(() => yp({
    count: l().length,
    getScrollElement: () => r ?? null,
    estimateSize: () => 42,
    overscan: 100
  }));
  return (() => {
    var u = hie(), c = u.firstChild, h = c.nextSibling, f = h.nextSibling, p = f.nextSibling, g = p.nextSibling, v = g.firstChild, m = v.firstChild, $ = m.firstChild, w = v.nextSibling, k = w.firstChild, C = k.firstChild, E = C.nextSibling, N = E.firstChild, M = w.nextSibling, V = t;
    typeof V == "function" ? ze(V, u) : t = u, A(c, Rt), A(h, Ur), A(f, qr), A(p, uie), g.$$touchstart = (P) => P.stopPropagation(), g.$$touchmove = (P) => P.stopPropagation(), v.style.setProperty("touch-action", "none"), m.style.setProperty("font-size", "26px"), ce($, "click", () => {
      e.onClose && e.onClose();
    }), $.style.setProperty("padding", "0px"), $._$owner = fe(), A(v, (() => {
      var P = L(() => !!e.label);
      return () => P() ? (() => {
        var z = fie(), G = z.firstChild, se = G.firstChild;
        return A(se, () => e.label), z;
      })() : null;
    })(), null), A(v, (() => {
      var P = L(() => !!e.required);
      return () => P() ? pie() : null;
    })(), null), A(v, (() => {
      var P = L(() => !!e.optional);
      return () => P() ? mie() : null;
    })(), null), w.$$touchstart = (P) => P.stopPropagation(), w.$$touchmove = (P) => P.stopPropagation(), w.style.setProperty("touch-action", "none"), ce(k, "sl-clear", () => {
      n.value = "", i(""), s();
    }), ce(k, "input", (P) => {
      i(P.target.value);
    });
    var q = n;
    typeof q == "function" ? ze(q, k) : n = k, k.style.setProperty("border-radius", "0px"), k.style.setProperty("border", "0px"), k._$owner = fe(), A(C, () => a(e.invalid ?? !1)), N._$owner = fe(), A(k, b(X, {
      get when() {
        return e.clearable;
      },
      get children() {
        var P = cie(), z = P.firstChild;
        return ce(z, "click", (G) => {
          G.stopImmediatePropagation(), n.value = "", i(""), s();
        }), z._$owner = fe(), J(() => P.classList.toggle("hidden", !!(e.isLoading || !e.selectedData))), P;
      }
    }), null);
    var I = r;
    return typeof I == "function" ? ze(I, M) : r = M, A(M, b(kt, {
      get each() {
        return d().getVirtualItems();
      },
      get fallback() {
        return b(_ie, {
          get isLoading() {
            return e.isLoading;
          }
        });
      },
      children: (P) => {
        const z = P.index > l().length - 1, G = l()[P.index], se = e.selectedData, ue = !z && !!se && "id" in se && "data" in G && se.id === G.data.id, de = "title" in G ? Cie : Sie, D = "title" in G ? {
          item: G
        } : {
          item: P,
          isLoader: z,
          isSelected: ue,
          index: P.index,
          hasMore: e.hasMore,
          showOverflow: e.showOverflow,
          onClick: () => {
            z || (n.value = "", i(""), o(G.data));
          }
        };
        return b(gb, Be({
          component: de
        }, D, {
          get children() {
            return L(() => "data" in G)() && e.displayAccessor(G.data, !0);
          }
        }));
      }
    })), J((P) => {
      var z = e.placeholder, G = e.disabled ?? !1, se = !!(e.invalid ?? !1), ue = !!(e.disabled ?? !1), de = e.required, D = !!e.forceLabelSize, R = !e.isLoading;
      return z !== P.e && (k.placeholder = P.e = z), G !== P.t && (k.disabled = P.t = G), se !== P.a && k.classList.toggle("invalid", P.a = se), ue !== P.o && k.classList.toggle("disabled", P.o = ue), de !== P.i && (k.required = P.i = de), D !== P.n && C.classList.toggle("h-[21px]", P.n = D), R !== P.s && E.classList.toggle("hidden", P.s = R), P;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0
    }), J(() => k.value = e.searchText), u;
  })();
}, _ie = (e) => b(X, {
  get when() {
    return e.isLoading;
  },
  get fallback() {
    return vie();
  },
  get children() {
    return gie();
  }
}), Cie = (e) => (() => {
  var t = yie();
  return t.style.setProperty("position", "sticky"), t.style.setProperty("top", "0px"), t.style.setProperty("z-index", "10"), A(t, () => e.item.title), t;
})(), Sie = (e) => (() => {
  var t = bie();
  return t.$$click = () => e.onClick(), A(t, (() => {
    var r = L(() => !!e.isLoader);
    return () => r() ? L(() => !!e.hasMore)() ? $ie() : wie() : (() => {
      var n = xie();
      return A(n, () => e.children), n;
    })();
  })()), J((r) => {
    var n = !!e.isSelected, i = !!e.isSelected;
    return n !== r.e && t.classList.toggle("bg-blue-500", r.e = n), i !== r.t && t.classList.toggle("text-white", r.t = i), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
da(["touchmove", "touchstart", "click"]);
const Eie = ".invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.input::part(base){border-radius:var(--photon-border-radius, .5rem)}.input::part(base):hover{cursor:pointer}.input::part(input){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.disabled::part(base):hover{cursor:not-allowed}.selected::part(base){--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.default::part(base):hover{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity))}.default::part(label){width:100%;overflow:hidden}.group-member::part(base){padding-left:1rem;font-weight:500}.group::part(base){background:#d1e9ff;padding-top:.25rem;padding-bottom:.25rem;--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity));font-size:.75rem;font-weight:600}.dropdown::part(panel){border-radius:var(--photon-border-radius, .5rem)}.dropdown-container{border-radius:var(--photon-border-radius, .5rem)}.group::part(checked-icon){display:none;width:0px}.group::part(label){padding-left:12px;padding-right:12px}.treatment-option::part(checked-icon){display:none;width:0px}";
var Tie = /* @__PURE__ */ K('<div slot=suffix class=flex><sl-icon class="text-gray-400 hover:text-gray-600"name=x-circle-fill>', !0, !1, !1), Aie = /* @__PURE__ */ K('<div><style></style><style></style><style></style><style></style><sl-dropdown class="dropdown relative"hoist><sl-input clearable slot=trigger autocomplete=off size=medium class=input><p slot=help-text class="text-red-400 pt-1 font-sans"></p><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div><div slot=suffix class=flex><sl-icon></sl-icon></div></sl-input><div class="border border-gray-200 dropdown-container overflow-hidden relative"><div class="bg-white overflow-x-hidden overflow-y-auto relative"><div>', !0, !1, !1), Oie = /* @__PURE__ */ K('<div class="flex items-center pb-2"><p class="text-gray-700 text-sm font-sans">'), Iie = /* @__PURE__ */ K('<p class="pl-1 text-red-400">*'), Pie = /* @__PURE__ */ K('<p class="text-gray-400 text-xs pl-2 font-sans">Optional'), Die = /* @__PURE__ */ K('<sl-menu-item><p class="text-center text-gray-400 italic">Loading...', !0, !1, !1), Mie = /* @__PURE__ */ K("<sl-menu-item>", !0, !1, !1), Nie = /* @__PURE__ */ K('<sl-menu-item class="group uppercase">', !0, !1, !1), Lie = /* @__PURE__ */ K("<sl-menu-item class=treatment-option>", !0, !1, !1), Fie = /* @__PURE__ */ K('<p class="text-center text-gray-400 italic">Loading...'), Rie = /* @__PURE__ */ K('<p class="text-center text-gray-400 italic">Nothing more to load'), zie = /* @__PURE__ */ K('<p class="break-words px-3">');
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const jie = (e) => {
  let t, r, n, i, a;
  e.actionRef && (e.actionRef.clear = () => {
    d(void 0), c(-1), i.value = "", p(""), $();
  });
  const [o, s] = H(!1), [l, d] = H(void 0), [u, c] = H(-1), [h, f] = H(), p = $d(async (C) => {
    e.onSearchChange && await e.onSearchChange(C);
  }, 250), g = new IntersectionObserver(async (C) => {
    C?.at(-1)?.isIntersecting && e.hasMore && e.fetchMore && await e.fetchMore();
  });
  me(() => {
    e.data.length === 0 && d(void 0);
  }), me(() => {
    h() && g.observe(h());
  });
  const v = (C) => {
    if (C)
      return e.helpText ? e.helpText : e.required ? "Please select data..." : void 0;
  }, m = (C) => {
    const E = new CustomEvent("photon-data-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        data: C
      }
    });
    t?.dispatchEvent(E);
  }, $ = () => {
    const C = new CustomEvent("photon-data-unselected", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(C);
  };
  me(() => {
    e.selectedData && d(e.selectedData), e.selectedData === void 0 && d(void 0);
  }), Et(() => {
    i && i.addEventListener("keydown", (C) => {
      (C.code == "Space" || C.key == " ") && C.stopImmediatePropagation();
    });
  });
  const w = L(() => e.groups ? e.groups.map((C) => {
    const E = e.data.map((N, M) => ({
      data: N,
      allItemsIdx: M
    })).filter((N) => C.filter(N.data));
    return E.length > 0 ? [{
      title: C.label
    }, ...E] : [];
  }).flat() : e.data.map((C, E) => ({
    data: C,
    allItemsIdx: E
  }))), k = L(() => yp({
    count: w().length,
    getScrollElement: () => n ?? null,
    estimateSize: () => 36.8,
    overscan: 100
  }));
  return (() => {
    var C = Aie(), E = C.firstChild, N = E.nextSibling, M = N.nextSibling, V = M.nextSibling, q = V.nextSibling, I = q.firstChild, P = I.firstChild, z = P.nextSibling, G = z.firstChild, se = z.nextSibling, ue = se.firstChild, de = I.nextSibling, D = de.firstChild, R = D.firstChild, Q = t;
    typeof Q == "function" ? ze(Q, C) : t = C, A(E, Rt), A(N, Ur), A(M, qr), A(V, Eie), A(C, (() => {
      var ee = L(() => !!e.label);
      return () => ee() ? (() => {
        var re = Oie(), Ie = re.firstChild;
        return A(Ie, () => e.label), A(re, (() => {
          var Pe = L(() => !!e.required);
          return () => Pe() ? Iie() : null;
        })(), null), A(re, (() => {
          var Pe = L(() => !!e.optional);
          return () => Pe() ? Pie() : null;
        })(), null), re;
      })() : null;
    })(), q), ce(q, "sl-show", async () => {
      s(!0), e.onOpen && await e.onOpen();
    }), ce(q, "sl-hide", async () => {
      l() || (i.value = "", e.onHide && await e.onHide()), s(!1);
    });
    var Z = r;
    typeof Z == "function" ? ze(Z, q) : r = q, q.style.setProperty("width", "100%"), q._$owner = fe(), ce(I, "sl-clear", () => {
      d(void 0), c(-1), i.value = "", p(""), $();
    }), ce(I, "sl-focus", (ee) => {
      e.onInputFocus ? (e.onInputFocus(), ee.stopImmediatePropagation()) : (r.children[1].style.width = `${i.clientWidth}px`, u() > 0 && k().scrollToIndex(u()));
    }), ce(I, "sl-input", (ee) => {
      o() || r.show(), p(ee.target.value);
    });
    var F = i;
    typeof F == "function" ? ze(F, I) : i = I, I._$owner = fe(), A(P, () => v(e.invalid ?? !1)), G._$owner = fe(), A(I, b(X, {
      get when() {
        return e.clearable;
      },
      get children() {
        var ee = Tie(), re = ee.firstChild;
        return ce(re, "click", (Ie) => {
          Ie.stopImmediatePropagation(), d(void 0), c(-1), i.value = "", p(""), $(), r.hide();
        }), re._$owner = fe(), J(() => ee.classList.toggle("hidden", !!(e.isLoading || l() == null))), ee;
      }
    }), se), ue._$owner = fe(), de.style.setProperty("width", "518px");
    var oe = a;
    typeof oe == "function" ? ze(oe, D) : a = D, D.style.setProperty("max-height", "500px"), D.style.setProperty("min-height", "37px"), D.style.setProperty("width", "100%"), D.style.setProperty("display", "flex"), D.style.setProperty("flex-direction", "column"), D.style.setProperty("justify-content", "start");
    var pe = n;
    return typeof pe == "function" ? ze(pe, R) : n = R, R.style.setProperty("width", "100%"), A(R, b(kt, {
      get each() {
        return k().getVirtualItems();
      },
      get fallback() {
        return b(Vie, {
          get noDataMsg() {
            return e.noDataMsg;
          },
          get isLoading() {
            return e.isLoading;
          }
        });
      },
      children: (ee) => {
        const re = ee.index > w().length - 1, Ie = w()[ee.index], Pe = l(), at = !re && !!Pe && "id" in Pe && "data" in Ie && Pe.id === Ie.data.id;
        return b(Ac, {
          get children() {
            return [b(vn, {
              get when() {
                return "title" in Ie;
              },
              get children() {
                return b(Uie, {
                  item: Ie
                });
              }
            }), b(vn, {
              get when() {
                return "data" in Ie;
              },
              get children() {
                return b(qie, {
                  item: ee,
                  isLoader: re,
                  isSelected: at,
                  get index() {
                    return ee.index;
                  },
                  get hasMore() {
                    return e.hasMore;
                  },
                  get showOverflow() {
                    return e.showOverflow;
                  },
                  onClick: () => {
                    re || (d(Ie.data), c(Ie.allItemsIdx), m(Ie.data), r.hide());
                  },
                  setLastIndex: f,
                  get children() {
                    return e.displayAccessor(Ie.data, !0);
                  }
                });
              }
            })];
          }
        });
      }
    })), J((ee) => {
      var re = e.forceLabelSize && !e.invalid ? -20 : e.invalid ? -18 : 0, Ie = e.disabled ?? !1, Pe = e.placeholder ?? void 0, at = e.disabled ?? !1, Xe = !!(e.invalid ?? !1), ft = !!(e.disabled ?? !1), bt = !l() && i.value === "", le = e.required, Y = !!e.forceLabelSize, ve = !e.isLoading, xe = !!e.isLoading, Qe = o() ? "chevron-up" : "chevron-down", Fe = `${k().getTotalSize()}px`;
      return re !== ee.e && (q.distance = ee.e = re), Ie !== ee.t && (q.disabled = ee.t = Ie), Pe !== ee.a && (I.placeholder = ee.a = Pe), at !== ee.o && (I.disabled = ee.o = at), Xe !== ee.i && I.classList.toggle("invalid", ee.i = Xe), ft !== ee.n && I.classList.toggle("disabled", ee.n = ft), bt !== ee.s && I.classList.toggle("placeholder", ee.s = bt), le !== ee.h && (I.required = ee.h = le), Y !== ee.r && P.classList.toggle("h-[21px]", ee.r = Y), ve !== ee.d && z.classList.toggle("hidden", ee.d = ve), xe !== ee.l && se.classList.toggle("hidden", ee.l = xe), Qe !== ee.u && (ue.name = ee.u = Qe), Fe !== ee.c && ((ee.c = Fe) != null ? R.style.setProperty("height", Fe) : R.style.removeProperty("height")), ee;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0,
      h: void 0,
      r: void 0,
      d: void 0,
      l: void 0,
      u: void 0,
      c: void 0
    }), J(() => I.value = e.searchText), C;
  })();
}, Vie = (e) => b(X, {
  get when() {
    return e.isLoading;
  },
  get fallback() {
    return (() => {
      var t = Mie();
      return t._$owner = fe(), A(t, () => e.noDataMsg ? e.noDataMsg : "No data found"), t;
    })();
  },
  get children() {
    var t = Die();
    return t._$owner = fe(), t;
  }
}), Uie = (e) => (() => {
  var t = Nie();
  return t._$owner = fe(), A(t, () => e.item.title), t;
})(), qie = (e) => (() => {
  var t = Lie();
  return ze((r) => {
    e.isLoader && e.index > 0 && e.setLastIndex(r);
  }, t), t.$$click = () => e.onClick(), t.style.setProperty("width", "100%"), t.style.setProperty("white-space", "normal"), t._$owner = fe(), A(t, (() => {
    var r = L(() => !!e.isLoader);
    return () => r() ? L(() => !!e.hasMore)() ? Fie() : Rie() : (() => {
      var n = zie();
      return A(n, () => e.children), J((i) => {
        var a = !e.showOverflow, o = !e.showOverflow, s = !e.showOverflow, l = !!e.showOverflow;
        return a !== i.e && n.classList.toggle("overflow-hidden", i.e = a), o !== i.t && n.classList.toggle("overflow-ellipsis", i.t = o), s !== i.a && n.classList.toggle("whitespace-nowrap", i.a = s), l !== i.o && n.classList.toggle("whitespace-normal", i.o = l), i;
      }, {
        e: void 0,
        t: void 0,
        a: void 0,
        o: void 0
      }), n;
    })();
  })()), J((r) => {
    var n = !!e.isSelected, i = `${e.item.size}px`;
    return n !== r.e && t.classList.toggle("selected", r.e = n), i !== r.t && ((r.t = i) != null ? t.style.setProperty("min-height", i) : t.style.removeProperty("min-height")), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
da(["click"]);
var Bie = /* @__PURE__ */ K("<strong class=font-extrabold>"), Hie = /* @__PURE__ */ K("<div><p>"), ky = /* @__PURE__ */ K('<p class="text-xs text-red-500 mt-1 italic">'), Wie = /* @__PURE__ */ K("<div><div></div><div> <!>, <!> <!> supply, <!> <!>, "), Qie = /* @__PURE__ */ K("<span class=text-blue-600>(<!>): "), Gie = /* @__PURE__ */ K("<div>");
function Yie(e) {
  return !e || e.length === 0 ? {} : e.reduce((t, r) => {
    if (!r.treatmentIds) return t;
    for (const n of r.treatmentIds)
      t[n] = r.reason;
    return t;
  }, {});
}
function Rv(e, t) {
  return e ? e in t ? {
    disabled: !0,
    disableReason: t[e]
  } : {
    disabled: !1
  } : {
    disabled: !1
  };
}
function Ap(e, t, r) {
  const n = new CustomEvent(t, {
    composed: !0,
    bubbles: !0,
    detail: r
  });
  e?.dispatchEvent(n);
}
function Kie(e, t, r) {
  Ap(e, "photon-treatment-selected", {
    data: t,
    catalogId: r
  });
}
function Zie(e) {
  Ap(e, "photon-treatment-unselected");
}
function mn(e, t) {
  Ap(e, "photon-search-text-changed", {
    text: t
  });
}
const Xie = Ce`
  query SearchTreatments($filter: TreatmentFilter!) {
    treatments(filter: $filter) {
      __typename
      id
      name
    }
  }
`, Jie = async (e, t) => await e.query({
  query: Xie,
  variables: {
    filter: {
      term: t
    }
  },
  fetchPolicy: "no-cache"
});
async function eae(e, t) {
  return (await Jie(e, t))?.data?.treatments?.map((n) => ({
    ...n,
    isOffCatalog: !0
  })) ?? [];
}
function tae(e, t, r) {
  const {
    store: n
  } = _p;
  if (!n.catalog.data) return [];
  const i = [...e.offCatalogOption ? [e.offCatalogOption] : [], ...n.catalog.data ? n.catalog.data.templates.map((o) => o) : [], ...n.catalog.data ? n.catalog.data.treatments.map((o) => o) : [], ...r], a = t.toLowerCase().split(/\s+/);
  return a.length === 0 ? i : i.filter((o) => {
    const s = "treatment" in o ? `${o?.name?.toLowerCase() || ""} ${o.treatment.name.toLowerCase()} ` : o.name.toLowerCase();
    return a.every((l) => s.includes(l));
  });
}
const Cc = (e, t) => {
  const i = ((s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))(t).split(" ").filter((s) => s.length > 0), a = new RegExp(`(${i.join("|")})`, "gi");
  return e.split(a).map((s) => i.some((l) => l.toLowerCase() === s?.toLowerCase()) ? (() => {
    var l = Bie();
    return A(l, s), l;
  })() : s);
};
function rae(e, t, r, n = !1, i) {
  return t ? (() => {
    var a = Hie(), o = a.firstChild;
    return Wi(a, `my-1 ${n ? "opacity-50 cursor-not-allowed" : ""}`), Wi(o, `text-sm whitespace-normal leading-snug ${n ? "text-gray-500" : ""}`), A(o, () => Cc(e.name, r)), A(a, n && i && (() => {
      var s = ky();
      return A(s, i), s;
    })(), null), a;
  })() : e.name || "";
}
function nae(e, t, r, n = !1, i) {
  if (t) {
    const a = e.fillsAllowed ? e.fillsAllowed - 1 : 0;
    return (() => {
      var o = Wie(), s = o.firstChild, l = s.nextSibling, d = l.firstChild, u = d.nextSibling, c = u.nextSibling, h = c.nextSibling, f = h.nextSibling, p = f.nextSibling, g = p.nextSibling, v = g.nextSibling, m = v.nextSibling, $ = m.nextSibling;
      return $.nextSibling, Wi(o, `my-1 ${n ? "opacity-50 cursor-not-allowed" : ""}`), Wi(s, `text-sm whitespace-normal font-medium mb-1 ${n ? "text-gray-500" : ""}`), A(s, (() => {
        var w = L(() => !!e.name);
        return () => w() ? (() => {
          var k = Qie(), C = k.firstChild, E = C.nextSibling;
          return E.nextSibling, A(k, () => Cc(e.name, r), E), k;
        })() : "";
      })(), null), A(s, () => Cc(e.treatment.name, r), null), Wi(l, `text-xs truncate ${n ? "text-gray-400" : "text-gray-500"}`), A(l, () => e.dispenseQuantity, d), A(l, () => e.dispenseUnit, u), A(l, () => e.daysSupply, h), A(l, () => e.daysSupply === 1 ? "day" : "days", p), A(l, a, v), A(l, a === 1 ? "refill" : "refills", $), A(l, () => e.instructions, null), A(o, n && i && (() => {
        var w = ky();
        return A(w, i), w;
      })(), null), o;
    })();
  }
  return e.treatment.name;
}
function V1(e) {
  return [{
    label: "Off Catalog",
    filter: (t) => t && typeof t == "object" && e.offCatalogOption && t.id === e.offCatalogOption.id
  }, {
    label: "Personal Templates",
    filter: (t) => t && typeof t == "object" && "treatment" in t && t.isPrivate
  }, {
    label: "Organization Templates",
    filter: (t) => t && typeof t == "object" && "treatment" in t && !t.isPrivate
  }, {
    label: "Organization Catalog",
    filter: (t) => t && typeof t == "object" && "name" in t && !("treatment" in t) && !("isOffCatalog" in t)
  }, {
    label: "All Treatments",
    filter: (t) => t && typeof t == "object" && !("treatment" in t) && "isOffCatalog" in t
  }];
}
const iae = (e) => {
  let t;
  const r = Xr(), {
    store: n,
    actions: i
  } = _p, [a, o] = H([]), [s, l] = H(!1), [d, u] = H(!1), c = L(() => Yie(e.disableList));
  Et(async () => {
    e.catalogId ? await i.getCatalog(r.getSDK(), e.catalogId) : (await i.getCatalogs(r.getSDK()), n.catalogs.data && n.catalogs.data.length > 0 && await i.getCatalog(r.getSDK(), n.catalogs.data[0].id));
  }), me(() => {
    n.catalog.data && h(e.searchText);
  });
  const h = async (g) => {
    l(!0);
    const v = g?.length >= 3 && // 3 min chars for smaller responses
    e.allowOffCatalogSearch ? await eae(r.sdk.apolloClinical, g) : (
      // Set treatment options to empty array if search term is empty
      []
    ), m = tae(e, e.searchText, v);
    o(m), l(!1);
  }, f = (g, v) => {
    const m = "treatment" in g ? g.treatment.id : g.id, {
      disabled: $,
      disableReason: w
    } = Rv(m, c());
    return g && "__typename" in g && g.__typename == "PrescriptionTemplate" ? nae(g, v, e.searchText, $, w) : rae(g, v, e.searchText, $, w);
  }, p = window.innerWidth < 768;
  return (() => {
    var g = Gie();
    ce(g, "photon-data-unselected", () => {
      Zie(t), mn(t, "");
    }), ce(g, "photon-data-selected", (m) => {
      u(!1);
      const $ = m.detail.data;
      let w;
      if ("treatment" in $ ? w = $.treatment.id : "id" in $ && (w = $.id), w) {
        const {
          disabled: k
        } = Rv(w, c());
        if (k)
          return;
      }
      Kie(t, $, n.catalog.data?.id || ""), "treatment" in $ ? mn(t, $.treatment.name) : mn(t, $.name);
    });
    var v = t;
    return typeof v == "function" ? ze(v, g) : t = g, A(g, b(X, {
      get when() {
        return d();
      },
      get children() {
        return b(kie, {
          get data() {
            return a();
          },
          get groups() {
            return V1(e);
          },
          get label() {
            return e.label;
          },
          get disabled() {
            return e.disabled;
          },
          get required() {
            return e.required ?? !1;
          },
          placeholder: "Type medication",
          get invalid() {
            return e.invalid ?? !1;
          },
          get isLoading() {
            return n.catalogs.isLoading || n.catalog.isLoading || s();
          },
          hasMore: !1,
          get selectedData() {
            return e.selected ?? e.offCatalogOption;
          },
          displayAccessor: f,
          get searchText() {
            return e.searchText;
          },
          onSearchChange: (m) => {
            mn(t, m);
          },
          onHide: () => mn(t, ""),
          get helpText() {
            return e.helpText;
          },
          get open() {
            return d();
          },
          onClose: () => {
            u(!1), mn(t, "");
          }
        });
      }
    }), null), A(g, b(X, {
      get when() {
        return p && !d();
      },
      get children() {
        return b(lo, {
          get data() {
            return a();
          },
          get groups() {
            return V1(e);
          },
          get label() {
            return e.label;
          },
          get disabled() {
            return e.disabled;
          },
          get required() {
            return e.required ?? !1;
          },
          placeholder: "Type medication",
          get invalid() {
            return e.invalid ?? !1;
          },
          get isLoading() {
            return n.catalogs.isLoading || n.catalog.isLoading;
          },
          hasMore: !1,
          get selectedData() {
            return e.selected ?? e.offCatalogOption;
          },
          displayAccessor: f,
          onSearchChange: (m) => mn(t, m),
          onHide: () => mn(t, ""),
          get helpText() {
            return e.helpText;
          },
          onInputFocus: () => {
            u(!0), e.selected?.name && mn(t, e.selected.name);
          }
        });
      }
    }), null), A(g, b(X, {
      when: !p,
      get children() {
        return b(jie, {
          get data() {
            return a();
          },
          get groups() {
            return V1(e);
          },
          get label() {
            return e.label;
          },
          get disabled() {
            return e.disabled;
          },
          get required() {
            return e.required ?? !1;
          },
          placeholder: "Type medication",
          get invalid() {
            return e.invalid ?? !1;
          },
          get isLoading() {
            return n.catalogs.isLoading || n.catalog.isLoading || s();
          },
          hasMore: !1,
          get selectedData() {
            return e.selected ?? e.offCatalogOption;
          },
          displayAccessor: f,
          get searchText() {
            return e.searchText;
          },
          onSearchChange: (m) => {
            mn(t, m);
          },
          onHide: () => mn(t, ""),
          get helpText() {
            return e.helpText;
          },
          onInputFocus: () => {
            e.selected?.name && mn(t, e.selected.name);
          }
        });
      }
    }), null), g;
  })();
};
Tt("photon-medication-search", {
  label: void 0,
  required: !1,
  invalid: !1,
  helpText: void 0,
  catalogId: void 0,
  allowOffCatalogSearch: !0,
  disabled: !1,
  formName: void 0,
  selected: void 0,
  offCatalogOption: void 0,
  searchText: "",
  disableList: void 0
}, iae);
const aae = ".dropdown::part(panel){width:480px}@media (max-width: 768px){.dropdown::part(panel){max-width:100vw;width:100vw}}";
var oae = /* @__PURE__ */ K('<p class="text-lg font-semibold mt-0 mb-4">Add Medication History'), sae = /* @__PURE__ */ K('<div class="flex items-center pb-2"><p class="text-gray-700 text-sm font-sans">Search for Treatment'), lae = /* @__PURE__ */ K('<sl-dropdown class="w-full p-0 dropdown"><sl-input placeholder="Type medication name"autocomplete=off class="border border-none p-0"size=medium clearable slot=trigger><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div></sl-input><sl-menu>', !0, !1, !1), dae = /* @__PURE__ */ K('<div class="mt-5 flex gap-4 justify-end">'), uae = /* @__PURE__ */ K("<div><style></style><style></style><style></style><style></style><style>"), cae = /* @__PURE__ */ K("<sl-menu-item disabled>Type at least 3 characters", !0, !1, !1), hae = /* @__PURE__ */ K("<sl-menu-item>", !0, !1, !1), fae = /* @__PURE__ */ K("<sl-menu-item disabled>No results found", !0, !1, !1);
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const pae = Ce`
  query SearchTreatments($filter: TreatmentFilter!) {
    treatments(filter: $filter) {
      id
      name
    }
  }
`, mae = (e) => {
  let t;
  const r = Xr(), [n, i] = H(!1), [a, o] = H(!1), [s, l] = H(""), [d, u] = H([]), [c, h] = H(void 0), f = $d(async (w) => {
    if (!w || w.length < 3) {
      u([]);
      return;
    }
    try {
      i(!0);
      const {
        data: k
      } = await r.sdk.apolloClinical.query({
        query: pae,
        variables: {
          filter: {
            term: w
          }
        },
        fetchPolicy: "no-cache"
      });
      u(k.treatments || []);
    } catch (k) {
      console.error("Search error:", k);
    } finally {
      i(!1);
    }
  }, 300);
  me(() => {
    f(s());
  });
  const p = () => {
    const w = new CustomEvent("photon-medication-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        medication: c()
      }
    });
    t?.dispatchEvent(w);
  }, g = () => {
    const w = new CustomEvent("photon-medication-closed", {
      composed: !0,
      bubbles: !0
    });
    t?.dispatchEvent(w);
  }, v = async () => {
    o(!0), p();
  };
  me(() => {
    e.open || (o(!1), l(""));
  });
  const m = () => {
    g();
  }, $ = (w) => {
    h(w), l(w.name);
  };
  return (() => {
    var w = uae(), k = w.firstChild, C = k.nextSibling, E = C.nextSibling, N = E.nextSibling, M = N.nextSibling, V = t;
    return typeof V == "function" ? ze(V, w) : t = w, A(k, oi), A(C, Rt), A(E, Ur), A(N, qr), A(M, aae), A(w, b(ao, {
      get open() {
        return e.open;
      },
      onClose: m,
      size: "lg",
      position: "center",
      get children() {
        return [oae(), sae(), (() => {
          var q = lae(), I = q.firstChild, P = I.firstChild, z = P.firstChild, G = I.nextSibling;
          return q._$owner = fe(), ce(I, "keydown", (se) => {
            (se.code === "Space" || se.key === " ") && (se.preventDefault(), se.stopPropagation(), l(s() + " "));
          }), ce(I, "sl-input", (se) => {
            l(se.target.value);
          }), I._$owner = fe(), z._$owner = fe(), G._$owner = fe(), A(G, (() => {
            var se = L(() => s()?.length < 3);
            return () => se() ? (() => {
              var ue = cae();
              return ue._$owner = fe(), ue;
            })() : L(() => d().length > 0)() ? d().map((ue) => (() => {
              var de = hae();
              return de.$$click = () => $(ue), de._$owner = fe(), A(de, () => Cc(ue.name, s())), de;
            })()) : (() => {
              var ue = fae();
              return ue._$owner = fe(), ue;
            })();
          })()), J(() => P.classList.toggle("hidden", !n())), J(() => I.value = s()), q;
        })(), (() => {
          var q = dae();
          return A(q, b(st, {
            variant: "secondary",
            onClick: m,
            children: "Cancel"
          }), null), A(q, b(st, {
            onClick: v,
            get disabled() {
              return !c() || a();
            },
            get loading() {
              return a();
            },
            children: "Select Medication"
          }), null), q;
        })()];
      }
    }), null), w;
  })();
};
Tt("photon-add-medication-history-dialog", {
  open: {
    value: !1,
    reflect: !0,
    notify: !1,
    attribute: "open",
    parse: !0
  }
}, mae);
da(["click"]);
var gae = /* @__PURE__ */ K("<div><style>");
const vae = (e) => (() => {
  var t = gae(), r = t.firstChild;
  return A(r, oi), A(t, b(I6, {
    get patientId() {
      return e.patientId;
    },
    enableLinks: !1,
    enableRefillButton: !1
  }), null), t;
})();
Tt("photon-med-history", {
  patientId: ""
}, vae);
var yae = gr`
  :host {
    display: block;
  }

  :host(:focus-visible) {
    outline: 0px;
  }

  .radio {
    display: inline-flex;
    align-items: top;
    font-family: var(--sl-input-font-family);
    font-size: var(--sl-input-font-size-medium);
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .radio--small {
    --toggle-size: var(--sl-toggle-size-small);
    font-size: var(--sl-input-font-size-small);
  }

  .radio--medium {
    --toggle-size: var(--sl-toggle-size-medium);
    font-size: var(--sl-input-font-size-medium);
  }

  .radio--large {
    --toggle-size: var(--sl-toggle-size-large);
    font-size: var(--sl-input-font-size-large);
  }

  .radio__checked-icon {
    display: inline-flex;
    width: var(--toggle-size);
    height: var(--toggle-size);
  }

  .radio__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--toggle-size);
    height: var(--toggle-size);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
    border-radius: 50%;
    background-color: var(--sl-input-background-color);
    color: transparent;
    transition:
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) box-shadow;
  }

  .radio__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Hover */
  .radio:not(.radio--checked):not(.radio--disabled) .radio__control:hover {
    border-color: var(--sl-input-border-color-hover);
    background-color: var(--sl-input-background-color-hover);
  }

  /* Checked */
  .radio--checked .radio__control {
    color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
  }

  /* Checked + hover */
  .radio.radio--checked:not(.radio--disabled) .radio__control:hover {
    border-color: var(--sl-color-primary-500);
    background-color: var(--sl-color-primary-500);
  }

  /* Checked + focus */
  :host(:focus-visible) .radio__control {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .radio--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When the control isn't checked, hide the circle for Windows High Contrast mode a11y */
  .radio:not(.radio--checked) svg circle {
    opacity: 0;
  }

  .radio__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    line-height: var(--toggle-size);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }
`, li = class extends ar {
  constructor() {
    super(), this.checked = !1, this.hasFocus = !1, this.size = "medium", this.disabled = !1, this.handleBlur = () => {
      this.hasFocus = !1, this.emit("sl-blur");
    }, this.handleClick = () => {
      this.disabled || (this.checked = !0);
    }, this.handleFocus = () => {
      this.hasFocus = !0, this.emit("sl-focus");
    }, this.addEventListener("blur", this.handleBlur), this.addEventListener("click", this.handleClick), this.addEventListener("focus", this.handleFocus);
  }
  connectedCallback() {
    super.connectedCallback(), this.setInitialAttributes();
  }
  setInitialAttributes() {
    this.setAttribute("role", "radio"), this.setAttribute("tabindex", "-1"), this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  handleCheckedChange() {
    this.setAttribute("aria-checked", this.checked ? "true" : "false"), this.setAttribute("tabindex", this.checked ? "0" : "-1");
  }
  handleDisabledChange() {
    this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  render() {
    return xt`
      <span
        part="base"
        class=${dr({
      radio: !0,
      "radio--checked": this.checked,
      "radio--disabled": this.disabled,
      "radio--focused": this.hasFocus,
      "radio--small": this.size === "small",
      "radio--medium": this.size === "medium",
      "radio--large": this.size === "large"
    })}
      >
        <span part="${`control${this.checked ? " control--checked" : ""}`}" class="radio__control">
          ${this.checked ? xt` <sl-icon part="checked-icon" class="radio__checked-icon" library="system" name="radio"></sl-icon> ` : ""}
        </span>

        <slot part="label" class="radio__label"></slot>
      </span>
    `;
  }
};
li.styles = [Ar, yae];
li.dependencies = { "sl-icon": Vr };
O([
  Fn()
], li.prototype, "checked", 2);
O([
  Fn()
], li.prototype, "hasFocus", 2);
O([
  U()
], li.prototype, "value", 2);
O([
  U({ reflect: !0 })
], li.prototype, "size", 2);
O([
  U({ type: Boolean, reflect: !0 })
], li.prototype, "disabled", 2);
O([
  Nt("checked")
], li.prototype, "handleCheckedChange", 1);
O([
  Nt("disabled", { waitUntilFirstUpdate: !0 })
], li.prototype, "handleDisabledChange", 1);
li.define("sl-radio");
var bae = /* @__PURE__ */ K('<div class=cursor-pointer><style></style><photon-card><div class="flex items-center gap-2"><p class="font-sans flex-grow text-gray-600 text-sm"><slot></slot></p><input type=radio>', !0, !1, !1);
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const $ae = (e) => {
  let t;
  const r = () => {
    const n = new CustomEvent("photon-radio-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        value: e.value
      }
    });
    t?.dispatchEvent(n);
  };
  return (() => {
    var n = bae(), i = n.firstChild, a = i.nextSibling, o = a.firstChild, s = o.firstChild, l = s.firstChild, d = s.nextSibling, u = t;
    return typeof u == "function" ? ze(u, n) : t = n, A(i, Rt), ce(a, "click", () => r()), a._$owner = fe(), l._$owner = fe(), J(() => d.checked = e.selected), n;
  })();
};
Tt("photon-radio-card", {
  selected: !1,
  value: ""
}, $ae);
function wae(e) {
  const [t, r] = Ls(Array());
  return me(() => {
    if (!e)
      return;
    const n = () => {
      r(e()?.assignedElements() || []);
    };
    return e()?.addEventListener("slotchange", n);
  }), t;
}
var xae = /* @__PURE__ */ K('<div><style></style><div class="flex flex-col gap-3"><slot>');
Xt("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
Tt("photon-radio-group", {}, () => {
  let e;
  const [t, r] = H(), n = wae(t), i = (a) => {
    const o = new CustomEvent("photon-option-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        value: a
      }
    });
    e?.dispatchEvent(o);
  };
  return (() => {
    var a = xae(), o = a.firstChild, s = o.nextSibling, l = s.firstChild;
    ce(a, "photon-radio-selected", (u) => {
      u.stopImmediatePropagation(), u.stopPropagation();
      for (const c of n)
        c.value.id === u.detail.value.id || c.value === u.detail.value ? c.selected = !0 : c.selected = !1;
      i(u.detail.value);
    });
    var d = e;
    return typeof d == "function" ? ze(d, a) : e = a, A(o, Rt), ze((u) => r(u), l), l._$owner = fe(), a;
  })();
});
function Yh(e) {
  this.message = e;
}
Yh.prototype = new Error(), Yh.prototype.name = "InvalidCharacterError";
var zv = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new Yh("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, n, i = 0, a = 0, o = ""; n = t.charAt(a++); ~n && (r = i % 4 ? 64 * r + n : n, i++ % 4) ? o += String.fromCharCode(255 & r >> (-2 * i & 6)) : 0) n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
  return o;
};
function kae(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(r) {
      return decodeURIComponent(zv(r).replace(/(.)/g, function(n, i) {
        var a = i.charCodeAt(0).toString(16).toUpperCase();
        return a.length < 2 && (a = "0" + a), "%" + a;
      }));
    }(t);
  } catch {
    return zv(t);
  }
}
function Sc(e) {
  this.message = e;
}
function _ae(e, t) {
  if (typeof e != "string") throw new Sc("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(kae(e.split(".")[r]));
  } catch (n) {
    throw new Sc("Invalid token specified: " + n.message);
  }
}
Sc.prototype = new Error(), Sc.prototype.name = "InvalidTokenError";
var Cae = /* @__PURE__ */ K(`<div><style></style><photon-dialog label="Lose Unsaved Prescription?"confirm-text="Yes, Continue"cancel-text="Keep Editing"width=500px><p class="font-sans text-lg xs:text-base">You have a prescription "<!>" that hasn't been added. Please add it or continue.</p></photon-dialog><photon-dialog label="Save prescriptions without an order?"confirm-text="Save and create order"cancel-text="Yes, save only"width=500px><p class="font-sans text-lg xs:text-base">You're about to save prescriptions without creating a pharmacy order. You can create an order now, or at a later date.`, !0, !1, !1), Sae = /* @__PURE__ */ K('<div class="w-full h-full bg-[#F9FAFB]"><photon-prescribe-workflow hide-submit=true>', !0, !1, !1);
const Eae = (e) => e().notes?.value.length > 0 || e().instructions?.value.length > 0 || e().treatment?.value || e().patient?.value || e().dispenseAsWritten?.value != !1 || e().dispenseQuantity?.value != 1 || e().dispenseUnit?.value != "Each" || e().daysSupply?.value != 30 || e().refillsInput?.value != 0 || e().addToTemplates?.value != !1 || e().effectiveDate?.value != h0(/* @__PURE__ */ new Date(), "yyyy-MM-dd").toString(), Tae = (e) => {
  let t;
  const r = Xr(), [n, i] = H(!1), [a, o] = H(!1), [s, l] = H(), [d, u] = H(!1), [c, h] = H(!1), [f, p] = H(!1), [g, v] = H(!1), {
    actions: m
  } = _d, [$, w] = H(!0);
  Et(async () => {
    const q = await r.getSDK().authentication.getAccessToken();
    _ae(q).permissions?.includes("write:prescription") && o(!0);
  });
  const k = (q, I, P) => {
    const z = new CustomEvent("photon-prescriptions-created", {
      composed: !0,
      bubbles: !0,
      detail: {
        patientId: P,
        prescriptionIds: I,
        createOrder: q
      }
    });
    t?.dispatchEvent(z);
  }, C = () => {
    const q = new CustomEvent("photon-prescriptions-closed", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(q);
  }, E = () => {
    u(!1), v(!0);
  }, N = () => u(!1), M = () => {
    if (!n())
      return ir({
        status: "info",
        body: "You need to add prescription(s) to this order before you can send it."
      });
    if (!a())
      return ir({
        status: "error",
        header: "Unauthorized",
        body: "You do not have permission to prescribe"
      });
    if (s()?.treatment?.value?.name)
      return u(!0);
    h(!0), v(!0);
  }, V = () => {
    if (!n())
      return ir({
        status: "info",
        body: "You need to add prescription(s) to this order before you can send it."
      });
    if (!a())
      return ir({
        status: "error",
        header: "Unauthorized",
        body: "You do not have permission to prescribe"
      });
    p(!0);
  };
  return (() => {
    var q = Cae(), I = q.firstChild, P = I.nextSibling, z = P.firstChild, G = z.firstChild, se = G.nextSibling;
    se.nextSibling;
    var ue = P.nextSibling, de = t;
    return typeof de == "function" ? ze(de, q) : t = q, A(I, oi), ce(P, "photon-dialog-alt", N), ce(P, "photon-dialog-canceled", N), ce(P, "photon-dialog-confirmed", E), P._$owner = fe(), A(z, () => s()?.treatment?.value?.name, se), ce(ue, "photon-dialog-alt", () => {
      p(!1), v(!0);
    }), ce(ue, "photon-dialog-canceled", () => {
      p(!1);
    }), ce(ue, "photon-dialog-confirmed", () => {
      p(!1), h(!0), v(!0);
    }), ue._$owner = fe(), A(q, b(xy, {
      closeTitle: "Lose unsaved prescriptions?",
      closeBody: "You will not be able to recover unsaved prescriptions.",
      onClosed: () => {
        C(), m.clearSelectedPatient();
      },
      checkShouldWarn: () => Eae(s),
      title: "New prescription",
      titleIconName: "prescription",
      get footer() {
        return L(() => !!$())() ? null : L(() => !!e.enableOrder)() ? b(st, {
          class: "w-full xs:w-fit",
          size: "lg",
          get loading() {
            return g();
          },
          onClick: M,
          children: "Send order"
        }) : [b(st, {
          class: "w-full xs:w-fit",
          size: "lg",
          get loading() {
            return L(() => !!g())() && c();
          },
          onClick: M,
          children: "Save and create order"
        }), b(st, {
          class: "w-full xs:w-fit",
          size: "lg",
          variant: "secondary",
          get loading() {
            return L(() => !!g())() && !c();
          },
          onClick: V,
          children: "Save prescriptions"
        })];
      },
      get form() {
        return (() => {
          var D = Sae(), R = D.firstChild;
          return ce(R, "photon-clinical-alert-cancel", (Q) => {
            Q.stopPropagation(), v(!1);
          }), ce(R, "photon-signature-attestation-canceled", () => {
            C(), m.clearSelectedPatient();
          }), ce(R, "photon-signature-attestation-agreed", () => {
            w(!1);
          }), ce(R, "photon-order-combine-error", (Q) => {
            Q.stopPropagation(), v(!1);
          }), ce(R, "photon-order-error", (Q) => {
            Q.stopPropagation(), v(!1);
          }), ce(R, "photon-prescriptions-created", (Q) => {
            Q.stopPropagation(), e.enableOrder || k(c(), Q.detail.prescriptions.map((Z) => Z.id), s()?.patient?.value?.id);
          }), ce(R, "photon-form-validate", (Q) => {
            i(Q.detail.canSubmit), l(Q.detail.form);
          }), R.setTriggerSubmit = v, R._$owner = fe(), J((Q) => {
            var Z = e.hideTemplates, F = g(), oe = e.patientId, pe = e.templateIds, ee = e.prescriptionIds, re = e.weight, Ie = e.weightUnit, Pe = e.externalOrderId, at = e.additionalNotes, Xe = e.enableMedHistory, ft = e.enableMedHistoryLinks, bt = e.enableMedHistoryRefillButton, le = e.enableOrder, Y = e.enableLocalPickup, ve = e.enableSendToPatient, xe = e.enableCombineAndDuplicate, Qe = e.enableDeliveryPharmacies, Fe = e.enableCoverageCheck, He = e.pharmacyId, Ge = e.mailOrderIds, Gt = g(), Ze = e?.toastBuffer || 0;
            return Z !== Q.e && (R.hideTemplates = Q.e = Z), F !== Q.t && (R.loading = Q.t = F), oe !== Q.a && (R.patientId = Q.a = oe), pe !== Q.o && (R.templateIds = Q.o = pe), ee !== Q.i && (R.prescriptionIds = Q.i = ee), re !== Q.n && (R.weight = Q.n = re), Ie !== Q.s && (R.weightUnit = Q.s = Ie), Pe !== Q.h && (R.externalOrderId = Q.h = Pe), at !== Q.r && (R.additionalNotes = Q.r = at), Xe !== Q.d && (R.enableMedHistory = Q.d = Xe), ft !== Q.l && (R.enableMedHistoryLinks = Q.l = ft), bt !== Q.u && (R.enableMedHistoryRefillButton = Q.u = bt), le !== Q.c && (R.enableOrder = Q.c = le), Y !== Q.w && (R.enableLocalPickup = Q.w = Y), ve !== Q.m && (R.enableSendToPatient = Q.m = ve), xe !== Q.f && (R.enableCombineAndDuplicate = Q.f = xe), Qe !== Q.y && (R.enableDeliveryPharmacies = Q.y = Qe), Fe !== Q.g && (R.enableCoverageCheck = Q.g = Fe), He !== Q.p && (R.pharmacyId = Q.p = He), Ge !== Q.b && (R.mailOrderIds = Q.b = Ge), Gt !== Q.T && (R.triggerSubmit = Q.T = Gt), Ze !== Q.A && (R.toastBuffer = Q.A = Ze), Q;
          }, {
            e: void 0,
            t: void 0,
            a: void 0,
            o: void 0,
            i: void 0,
            n: void 0,
            s: void 0,
            h: void 0,
            r: void 0,
            d: void 0,
            l: void 0,
            u: void 0,
            c: void 0,
            w: void 0,
            m: void 0,
            f: void 0,
            y: void 0,
            g: void 0,
            p: void 0,
            b: void 0,
            T: void 0,
            A: void 0
          }), D;
        })();
      }
    }), null), J((D) => {
      var R = d(), Q = f();
      return R !== D.e && (P.open = D.e = R), Q !== D.t && (ue.open = D.t = Q), D;
    }, {
      e: void 0,
      t: void 0
    }), q;
  })();
};
Tt("photon-multirx-form-wrapper", {
  hideTemplates: !1,
  patientId: void 0,
  pharmacyId: void 0,
  templateIds: void 0,
  prescriptionIds: void 0,
  weight: void 0,
  weightUnit: "lbs",
  additionalNotes: void 0,
  enableLocalPickup: !1,
  enableSendToPatient: !1,
  enableDeliveryPharmacies: !0,
  enableMedHistory: !1,
  enableMedHistoryLinks: !1,
  enableMedHistoryRefillButton: !1,
  enableCombineAndDuplicate: !1,
  enableCoverageCheck: !1,
  mailOrderIds: void 0,
  enableOrder: !1,
  toastBuffer: 0,
  externalOrderId: void 0
}, Tae);
